(function() {
  'use strict';

  angular
    .module('website', [
      'adaptiveTemplating',
      'afkl.lazyImage',
      'angular-google-analytics',
      'config',
      'duScroll',
      'me-lazyload',
      'ng-token-auth',
      'ngAnimate',
      'ngNotify',
      'ngResource',
      'ngStorage',
      'ui.bootstrap',
      'ui.router',
      'uiGmapgoogle-maps',
    ])
    .filter('trustedUrl', ['$sce', function($sce) {
      return function(url) {
        return $sce.trustAsResourceUrl(url);
      };
    }]);

})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('toolbarCart', toolbarCart)
    .controller('ToolbarController', ToolbarController);

  /* @ngInject */
  function toolbarCart(env) {
    var directive = {
      controller: ToolbarController,
      controllerAs: 'vm',
      restrict: 'E',
      templateUrl: 'app/components/toolbar-cart/{mobile}/toolbar-cart.html'
    };
    return directive;
  }

  /* @ngInject */
  function ToolbarController($auth, $state, cart, env) {
    var vm = this;
    vm.menuText = env.ENVIRONMENT == 'mxniusushi' ? 'Menú' : 'Carta';
    vm.isLoggedIn = false;
    vm.latestOrders = latestOrders;

    activate();

    ////////////////

    function activate() {
      $auth.validateUser()
      .then(function(resp) {
        vm.isLoggedIn = true;
      })
      .catch(function(err) {
        vm.isLoggedIn = false;
      })
    }

    function latestOrders() {
      if (vm.isLoggedIn) {
        $state.go('menu.category', { 'categoryName': 'latestOrders' });
      } else {
        var stateName = env.ENVIRONMENT == 'mxniusushi' ? 'signin' : 'passwordless';
        $state.go(stateName, { redirectTo: 'menu.category', redirectParams: { 'categoryName': 'latestOrders' } });
      }
    }

    Object.defineProperty(this, 'count', {
      get: function() {
        return cart.count;
      }
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('stopEvent', stopEvent);

  /* @ngInject */
  function stopEvent() {
    var directive = {
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element, attr) {
      element.on(attr.stopEvent, function (e) {
        e.stopPropagation();
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('skeletonScreen', skeletonScreen)
    .controller('SkeletonController', SkeletonController);

  /* @ngInject */
  function skeletonScreen() {
    // Usage:
    // <skeleton-screen template="template-name"><skeleton-screen/>
    // Creates:
    // adds a skeleton screen with a template name
    var directive = {
      bindToController: true,
      controller: SkeletonController,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      bindings: {
        template  : '@'
      },
      templateUrl: function($element, $attrs) {
        var templates = {
          'banner-home' :'app/components/skeleton-screen/{mobile}{desktop}/banner-home.html',
          'checkout-delivery-details' :'app/components/skeleton-screen/{mobile}{desktop}/checkout-delivery-details.html',
          'checkout-items-details' :'app/components/skeleton-screen/{mobile}{desktop}/checkout-items-details.html',
          'favorites-home' :'app/components/skeleton-screen/{mobile}{desktop}/favorites-home.html',
          'menu-card' :'app/components/skeleton-screen/{mobile}{desktop}/menu-card.html',
          'menu-categories':'app/components/skeleton-screen/{mobile}{desktop}/menu-categories.html',
          'menu-home' :'app/components/skeleton-screen/{mobile}{desktop}/menu-home.html',
          'more-info-home' :'app/components/skeleton-screen/{mobile}{desktop}/more-info-home.html',
          'promotions-home':'app/components/skeleton-screen/{mobile}{desktop}/promotions-home.html',
          'tracking-address':'app/components/skeleton-screen/{mobile}{desktop}/tracking-address.html',
          'tracking-products':'app/components/skeleton-screen/{mobile}{desktop}/tracking-products.html',
          'tracking-status':'app/components/skeleton-screen/{mobile}{desktop}/tracking-status.html',
          'tracking-description':'app/components/skeleton-screen/mobile/tracking-description.html',
          'tracking-map':'app/components/skeleton-screen/mobile/tracking-map.html',
          'tracking-need-help':'app/components/skeleton-screen/mobile/tracking-need-help.html'
        }
        return templates[$attrs.template];
      }
    };
    return directive;

    function link(scope, element, attrs) {
    }
  }

  /* @ngInject */
  function SkeletonController () {
    var vm = this;
    vm.getNumber = getNumber;

    function getNumber(start, end, step) {
      var range = [];
      for(var i = start; i <= end; i += step) {
        range.push(i);
      }

      return range;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('string', string);

  /* @ngInject */
  function string() {
    var service = this;
    service.clearText = clearText;
    service.transliterateText = transliterateText;
    service.transliterateOption = transliterateOption;
    service.isWrapping = isWrapping;
    service.emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z.]{2,5}$/;

    function clearText(text) {
      var cleanText = text ? text.toUpperCase() : '';
      cleanText = cleanText.replace(new RegExp(/\s/g), '');
      return cleanText;
    }

    function transliterateText(text) {
      var cleanText = text;
      cleanText = cleanText.replace(new RegExp(/[ÄÁ]/g), "A");
      cleanText = cleanText.replace(new RegExp(/[ËÉ]/g), "E");
      cleanText = cleanText.replace(new RegExp(/[ÏÍ]/g), "I");
      cleanText = cleanText.replace(new RegExp(/[ÖÓ]/g), "O");
      cleanText = cleanText.replace(new RegExp(/[ÜÚ]/g), "U");
      return cleanText;
    }

    function transliterateOption(text) {
      var cleanText = text;
      cleanText = cleanText.replace(new RegExp(/\bCON\b/g), "");
      cleanText = cleanText.replace(new RegExp(/\bSI\b/g), "");
      cleanText = cleanText.replace(new RegExp(/\bEN\b/g), "");
      return cleanText;
    }

    function isWrapping(query) {
      var wrappedRegex  = new RegExp(/\bENVUELTO\b/);
      var wrappingRegex = new RegExp(/\bENVOLTURA\b/);
      var coveredRegex  = new RegExp(/\bCUBIERTO\b/);
      if(!query.match(wrappedRegex) && !query.match(wrappingRegex) && !query.match(coveredRegex)) {
        return false;
      }
      return true;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('restaurant', restaurant);

  /* @ngInject */
  function restaurant() {
    var service = this;
    service.sortArrayRestaurants = sortArrayRestaurants;

    function sortArrayRestaurants(x, y){
      return x.name.localeCompare(y.name);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('productCarousel', productCarousel)
    .controller('ProductCarouselController', ProductCarouselController);

  /* @ngInject */
  function productCarousel() {
    // Usage:
    //  <product-carousel><product-carousel/>
    // Creates:
    //
    var directive = {
      bindToController: true,
      controller: ProductCarouselController,
      controllerAs: 'vm',
      restrict: 'E',
      templateUrl: 'app/components/product-carousel/{mobile}{desktop}/product-carousel.html'
    };
    return directive;
  }

  /* @ngInject */
  function ProductCarouselController (_, analytics, api, cart, $log, $rootScope, $uibModal) {
    var vm          = this;
    vm.cart         = cart;
    vm.products     = [];
    vm.prev         = prev;
    vm.next         = next;
    vm.addToCart    = addToCart;
    vm.viewSeleable = viewSeleable;

    activate();

    ////////////////

    function activate() {
      getProducts();
    }

    function getProducts() {
      return api.menuCategories.all().then(function () {
        api.products.homeWeb()
        .then(function(response) {
          _.each(response, function(product) {
            product.type          = 'products';
            product.is_additional = false;
            vm.products.push(product);
          });

          return vm.products;
        })
        .catch(function(err) {
          $log.error(JSON.stringify(err));
        });
      })
      .then(function() {
        $rootScope.$broadcast('product-carousel:load');
      });
    }

    function next() {
      changeActiveImage(false, true);
    }

    function prev() {
      changeActiveImage(true, false);
    }

    function changeActiveImage(toLeft, toRight) {
      var container = document.getElementById('product-carousel-content');
      if (!container) return;

      var scrollAmount = 305;
      container.scrollBy({
        left: toRight ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    }

    function addToCart(seleable) {
      var modifiable, options, quantity;
      if (seleable.type === 'products') {
        modifiable = !_.isEmpty(seleable.modifier_groups);
        options    = (seleable.modifier_groups && seleable.modifier_groups.length > 0) ? false : {};
        if (options) {
          quantity = seleable.quantity || 1;
          cart.addWithEffect(seleable.id, seleable.name, quantity, options, seleable.type, seleable.total_extra_price, modifiable);
          analytics.addToCart(seleable, seleable.total_extra_price);

          return $rootScope.$broadcast('cart:added');
        }
      }

      viewSeleable(seleable);
    }

    function viewSeleable(seleable) {
      var modifiable    = (seleable.modifier_groups && seleable.modifier_groups.length > 0);
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'product modal-type-' + seleable.type + ' modal-modifiable-' + modifiable,
        controller: 'SeleableController as seleable',
        templateUrl: 'app/seleable/{mobile}{desktop}/seleable.html',
        resolve: {
          seleable: function() {
            return seleable;
          },
          category: function() {
            return false;
          },
          makeSelection: function() {
            return false;
          },
          myFavorites: function() {
            return false;
          },
          categories: function() {
            return [];
          }
        }
      });

      return modalInstance.result
      .then(function() {
        analytics.addToCart(seleable, seleable.total_extra_price);
        $rootScope.$broadcast('cart:added');
      })
      .catch(function() {
        console.warn('El modal fue cerrado sin completar una acción.');
      });
    }
  }
})();

(function(){/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/
var aa=this||self;function k(a,b){a=a.split(".");var c=aa;a[0]in c||"undefined"==typeof c.execScript||c.execScript("var "+a[0]);for(var d;a.length&&(d=a.shift());)a.length||void 0===b?c[d]&&c[d]!==Object.prototype[d]?c=c[d]:c=c[d]={}:c[d]=b}function m(a,b){function c(){}c.prototype=b.prototype;a.$=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.fa=function(d,f,e){for(var g=Array(arguments.length-2),h=2;h<arguments.length;h++)g[h-2]=arguments[h];return b.prototype[f].apply(d,g)}};function ba(a){var b=[];var c=0;for(var d in a)b[c++]=a[d];return b};function ca(a,b){this.g=a;this.m=!!b.o;this.i=b.h;this.v=b.type;this.u=!1;switch(this.i){case da:case ea:case fa:case ha:case ia:case ja:case ka:this.u=!0}this.l=b.defaultValue}var ka=1,ja=2,da=3,ea=4,fa=6,ha=16,ia=18;function la(a,b){this.i=a;this.g={};for(a=0;a<b.length;a++){var c=b[a];this.g[c.g]=c}}function ma(a){a=ba(a.g);a.sort(function(b,c){return b.g-c.g});return a};function n(){this.g={};this.l=this.j().g;this.i=this.m=null}n.prototype.has=function(a){return null!=this.g[a.g]};n.prototype.get=function(a,b){return p(this,a.g,b)};n.prototype.set=function(a,b){q(this,a.g,b)};n.prototype.add=function(a,b){r(this,a.g,b)};
function na(a,b){for(var c=ma(a.j()),d=0;d<c.length;d++){var f=c[d],e=f.g;if(null!=b.g[e]){a.i&&delete a.i[f.g];var g=11==f.i||10==f.i;if(f.m){f=t(b,e);for(var h=0;h<f.length;h++)r(a,e,g?f[h].clone():f[h])}else f=u(b,e),g?(g=u(a,e))?na(g,f):q(a,e,f.clone()):q(a,e,f)}}}n.prototype.clone=function(){var a=new this.constructor;a!=this&&(a.g={},a.i&&(a.i={}),na(a,this));return a};
function u(a,b){var c=a.g[b];if(null==c)return null;if(a.m){if(!(b in a.i)){var d=a.m,f=a.l[b];if(null!=c)if(f.m){for(var e=[],g=0;g<c.length;g++)e[g]=d.i(f,c[g]);c=e}else c=d.i(f,c);return a.i[b]=c}return a.i[b]}return c}function p(a,b,c){var d=u(a,b);return a.l[b].m?d[c||0]:d}function v(a,b){if(null!=a.g[b])a=p(a,b);else a:{a=a.l[b];if(void 0===a.l)if(b=a.v,b===Boolean)a.l=!1;else if(b===Number)a.l=0;else if(b===String)a.l=a.u?"0":"";else{a=new b;break a}a=a.l}return a}
function t(a,b){return u(a,b)||[]}function w(a,b){return a.l[b].m?null!=a.g[b]?a.g[b].length:0:null!=a.g[b]?1:0}function q(a,b,c){a.g[b]=c;a.i&&(a.i[b]=c)}function r(a,b,c){a.g[b]||(a.g[b]=[]);a.g[b].push(c);a.i&&delete a.i[b]}function x(a,b){var c=[],d;for(d in b)0!=d&&c.push(new ca(d,b[d]));return new la(a,c)};function y(){}y.prototype.g=function(a){new a.i;throw Error("Unimplemented");};y.prototype.i=function(a,b){if(11==a.i||10==a.i)return b instanceof n?b:this.g(a.v.prototype.j(),b);if(14==a.i)return"string"===typeof b&&oa.test(b)&&(a=Number(b),0<a)?a:b;if(!a.u)return b;a=a.v;if(a===String){if("number"===typeof b)return String(b)}else if(a===Number&&"string"===typeof b&&("Infinity"===b||"-Infinity"===b||"NaN"===b||oa.test(b)))return Number(b);return b};var oa=/^-?[0-9]+$/;function z(){}m(z,y);z.prototype.g=function(a,b){a=new a.i;a.m=this;a.g=b;a.i={};return a};function B(){}m(B,z);B.prototype.i=function(a,b){return 8==a.i?!!b:y.prototype.i.apply(this,arguments)};B.prototype.g=function(a,b){return B.$.g.call(this,a,b)};function C(a,b){null!=a&&this.g.apply(this,arguments)}C.prototype.i="";C.prototype.set=function(a){this.i=""+a};C.prototype.g=function(a,b,c){this.i+=String(a);if(null!=b)for(var d=1;d<arguments.length;d++)this.i+=arguments[d];return this};C.prototype.toString=function(){return this.i};/*

 Protocol Buffer 2 Copyright 2008 Google Inc.
 All other code copyright its respective owners.
 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function D(){n.call(this)}m(D,n);var pa=null;function E(){n.call(this)}m(E,n);var qa=null;function F(){n.call(this)}m(F,n);var ra=null;
D.prototype.j=function(){var a=pa;a||(pa=a=x(D,{0:{name:"NumberFormat",s:"i18n.phonenumbers.NumberFormat"},1:{name:"pattern",required:!0,h:9,type:String},2:{name:"format",required:!0,h:9,type:String},3:{name:"leading_digits_pattern",o:!0,h:9,type:String},4:{name:"national_prefix_formatting_rule",h:9,type:String},6:{name:"national_prefix_optional_when_formatting",h:8,defaultValue:!1,type:Boolean},5:{name:"domestic_carrier_code_formatting_rule",h:9,type:String}}));return a};D.j=D.prototype.j;
E.prototype.j=function(){var a=qa;a||(qa=a=x(E,{0:{name:"PhoneNumberDesc",s:"i18n.phonenumbers.PhoneNumberDesc"},2:{name:"national_number_pattern",h:9,type:String},9:{name:"possible_length",o:!0,h:5,type:Number},10:{name:"possible_length_local_only",o:!0,h:5,type:Number},6:{name:"example_number",h:9,type:String}}));return a};E.j=E.prototype.j;
F.prototype.j=function(){var a=ra;a||(ra=a=x(F,{0:{name:"PhoneMetadata",s:"i18n.phonenumbers.PhoneMetadata"},1:{name:"general_desc",h:11,type:E},2:{name:"fixed_line",h:11,type:E},3:{name:"mobile",h:11,type:E},4:{name:"toll_free",h:11,type:E},5:{name:"premium_rate",h:11,type:E},6:{name:"shared_cost",h:11,type:E},7:{name:"personal_number",h:11,type:E},8:{name:"voip",h:11,type:E},21:{name:"pager",h:11,type:E},25:{name:"uan",h:11,type:E},27:{name:"emergency",h:11,type:E},28:{name:"voicemail",h:11,type:E},
29:{name:"short_code",h:11,type:E},30:{name:"standard_rate",h:11,type:E},31:{name:"carrier_specific",h:11,type:E},33:{name:"sms_services",h:11,type:E},24:{name:"no_international_dialling",h:11,type:E},9:{name:"id",required:!0,h:9,type:String},10:{name:"country_code",h:5,type:Number},11:{name:"international_prefix",h:9,type:String},17:{name:"preferred_international_prefix",h:9,type:String},12:{name:"national_prefix",h:9,type:String},13:{name:"preferred_extn_prefix",h:9,type:String},15:{name:"national_prefix_for_parsing",
h:9,type:String},16:{name:"national_prefix_transform_rule",h:9,type:String},18:{name:"same_mobile_and_fixed_line_pattern",h:8,defaultValue:!1,type:Boolean},19:{name:"number_format",o:!0,h:11,type:D},20:{name:"intl_number_format",o:!0,h:11,type:D},22:{name:"main_country_for_code",h:8,defaultValue:!1,type:Boolean},23:{name:"leading_digits",h:9,type:String}}));return a};F.j=F.prototype.j;function H(){n.call(this)}m(H,n);var sa=null,ta={ea:0,da:1,ca:5,ba:10,aa:20};
H.prototype.j=function(){var a=sa;a||(sa=a=x(H,{0:{name:"PhoneNumber",s:"i18n.phonenumbers.PhoneNumber"},1:{name:"country_code",required:!0,h:5,type:Number},2:{name:"national_number",required:!0,h:4,type:Number},3:{name:"extension",h:9,type:String},4:{name:"italian_leading_zero",h:8,type:Boolean},8:{name:"number_of_leading_zeros",h:5,defaultValue:1,type:Number},5:{name:"raw_input",h:9,type:String},6:{name:"country_code_source",h:14,defaultValue:0,type:ta},7:{name:"preferred_domestic_carrier_code",
h:9,type:String}}));return a};H.ctor=H;H.ctor.j=H.prototype.j;/*

 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
var I={1:"US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),7:["RU","KZ"],20:["EG"],27:["ZA"],30:["GR"],31:["NL"],32:["BE"],33:["FR"],34:["ES"],36:["HU"],39:["IT","VA"],40:["RO"],41:["CH"],43:["AT"],44:["GB","GG","IM","JE"],45:["DK"],46:["SE"],47:["NO","SJ"],48:["PL"],49:["DE"],51:["PE"],52:["MX"],53:["CU"],54:["AR"],55:["BR"],56:["CL"],57:["CO"],58:["VE"],60:["MY"],61:["AU","CC","CX"],62:["ID"],63:["PH"],64:["NZ"],65:["SG"],66:["TH"],81:["JP"],82:["KR"],84:["VN"],
86:["CN"],90:["TR"],91:["IN"],92:["PK"],93:["AF"],94:["LK"],95:["MM"],98:["IR"],211:["SS"],212:["MA","EH"],213:["DZ"],216:["TN"],218:["LY"],220:["GM"],221:["SN"],222:["MR"],223:["ML"],224:["GN"],225:["CI"],226:["BF"],227:["NE"],228:["TG"],229:["BJ"],230:["MU"],231:["LR"],232:["SL"],233:["GH"],234:["NG"],235:["TD"],236:["CF"],237:["CM"],238:["CV"],239:["ST"],240:["GQ"],241:["GA"],242:["CG"],243:["CD"],244:["AO"],245:["GW"],246:["IO"],247:["AC"],248:["SC"],249:["SD"],250:["RW"],251:["ET"],252:["SO"],
253:["DJ"],254:["KE"],255:["TZ"],256:["UG"],257:["BI"],258:["MZ"],260:["ZM"],261:["MG"],262:["RE","YT"],263:["ZW"],264:["NA"],265:["MW"],266:["LS"],267:["BW"],268:["SZ"],269:["KM"],290:["SH","TA"],291:["ER"],297:["AW"],298:["FO"],299:["GL"],350:["GI"],351:["PT"],352:["LU"],353:["IE"],354:["IS"],355:["AL"],356:["MT"],357:["CY"],358:["FI","AX"],359:["BG"],370:["LT"],371:["LV"],372:["EE"],373:["MD"],374:["AM"],375:["BY"],376:["AD"],377:["MC"],378:["SM"],380:["UA"],381:["RS"],382:["ME"],383:["XK"],385:["HR"],
386:["SI"],387:["BA"],389:["MK"],420:["CZ"],421:["SK"],423:["LI"],500:["FK"],501:["BZ"],502:["GT"],503:["SV"],504:["HN"],505:["NI"],506:["CR"],507:["PA"],508:["PM"],509:["HT"],590:["GP","BL","MF"],591:["BO"],592:["GY"],593:["EC"],594:["GF"],595:["PY"],596:["MQ"],597:["SR"],598:["UY"],599:["CW","BQ"],670:["TL"],672:["NF"],673:["BN"],674:["NR"],675:["PG"],676:["TO"],677:["SB"],678:["VU"],679:["FJ"],680:["PW"],681:["WF"],682:["CK"],683:["NU"],685:["WS"],686:["KI"],687:["NC"],688:["TV"],689:["PF"],690:["TK"],
691:["FM"],692:["MH"],800:["001"],808:["001"],850:["KP"],852:["HK"],853:["MO"],855:["KH"],856:["LA"],870:["001"],878:["001"],880:["BD"],881:["001"],882:["001"],883:["001"],886:["TW"],888:["001"],960:["MV"],961:["LB"],962:["JO"],963:["SY"],964:["IQ"],965:["KW"],966:["SA"],967:["YE"],968:["OM"],970:["PS"],971:["AE"],972:["IL"],973:["BH"],974:["QA"],975:["BT"],976:["MN"],977:["NP"],979:["001"],992:["TJ"],993:["TM"],994:["AZ"],995:["GE"],996:["KG"],998:["UZ"]},ua={AC:[,[,,"(?:[01589]\\d|[46])\\d{4}",
,,,,,,[5,6]],[,,"6[2-467]\\d{3}",,,,"62889",,,[5]],[,,"4\\d{4}",,,,"40123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AC",247,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:0[1-9]|[1589]\\d)\\d{4}",,,,"542011",,,[6]],,,[,,,,,,,,,[-1]]],AD:[,[,,"(?:1|6\\d)\\d{7}|[135-9]\\d{5}",,,,,,,[6,8,9]],[,,"[78]\\d{5}",,,,"712345",,,[6]],[,,"690\\d{6}|[356]\\d{5}",,,,"312345",,,[6,9]],[,,"180[02]\\d{4}",,,,"18001234",,,[8]],[,,"[19]\\d{5}",,,,"912345",,,[6]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AD",376,"00",,,,,,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],[,"(\\d{4})(\\d{4})","$1 $2",["1"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],,[,,,,,,,,,[-1]],,,[,,"1800\\d{4}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AE:[,[,,"(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",,,,,,,[5,6,7,8,9,10,11,12]],[,,"[2-4679][2-8]\\d{6}",,,,"22345678",,,[8],[7]],[,,"5[024-68]\\d{7}",,,,"501234567",,,[9]],[,,"400\\d{6}|800\\d{2,9}",,,,"800123456"],
[,,"900[02]\\d{5}",,,,"900234567",,,[9]],[,,"700[05]\\d{5}",,,,"700012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AE",971,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],[,"(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"600[25]\\d{5}",,,,"600212345",,,[9]],,,[,,,,,,,,,[-1]]],AF:[,[,,"[2-7]\\d{8}",,,,,,,[9],[7]],[,,"(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
,,,"234567890",,,,[7]],[,,"7\\d{8}",,,,"701234567",,,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AF",93,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[1-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AG:[,[,,"(?:268|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",,,,"2684601234",
,,,[7]],[,,"268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}",,,,"2684641234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,"26848[01]\\d{4}",,,,"2684801234",,,,[7]],
"AG",1,"011","1",,,"([457]\\d{6})$|1","268$1",,,,,[,,"26840[69]\\d{4}",,,,"2684061234",,,,[7]],,"268",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AI:[,[,,"(?:264|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"264(?:292|4(?:6[12]|9[78]))\\d{4}",,,,"2644612345",,,,[7]],[,,"264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",,,,"2642351234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"AI",1,"011","1",,,"([2457]\\d{6})$|1","264$1",,,,,[,,"264724\\d{4}",,,,"2647241234",,,,[7]],,"264",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AL:[,[,,"(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",,,,,,,[6,7,8,9],[5]],[,,"4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",,,,"22345678",,,[8],[5,6,7]],[,,"6(?:[78][2-9]|9\\d)\\d{6}",,,,"672123456",,,[9]],[,,"800\\d{4}",,,,"8001234",,,[7]],[,,"900[1-9]\\d\\d",
,,,"900123",,,[6]],[,,"808[1-9]\\d\\d",,,,"808123",,,[6]],[,,"700[2-9]\\d{4}",,,,"70021234",,,[8]],[,,,,,,,,,[-1]],"AL",355,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],[,"(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AM:[,[,,"(?:[1-489]\\d|55|60|77)\\d{6}",
,,,,,,[8],[5,6]],[,,"(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",,,,"10123456",,,,[5,6]],[,,"(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",,,,"77123456"],[,,"800\\d{5}",,,,"80012345"],[,,"90[016]\\d{5}",,,,"90012345"],[,,"80[1-4]\\d{5}",,,,"80112345"],[,,,,,,,,,[-1]],[,,"60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}",,,,"60271234"],"AM",374,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],[,"(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],
"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AO:[,[,,"[29]\\d{8}",,,,,,,[9]],[,,"2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",,,,"222123456"],[,,"9[1-59]\\d{7}",,,,"923123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AO",244,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]]],AR:[,[,,"(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",,,,,,,[10,11],[6,7,8]],[,,"3888[013-9]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
,,,"1123456789",,,[10],[6,7,8]],[,,"93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
,,,"91123456789",,,,[6,7,8]],[,,"800\\d{7,8}",,,,"8001234567"],[,,"60[04579]\\d{7}",,,,"6001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AR",54,"00","0",,,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
"9$1",,,[[,"(\\d{3})","$1",["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]],[,"(\\d{2})(\\d{4})","$1-$2",["[1-9]"]],[,"(\\d{3})(\\d{4})","$1-$2",["[2-9]"]],[,"(\\d{4})(\\d{4})","$1-$2",["[1-8]"]],[,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",,1],[,"(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1"],[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1"]],[[,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",,1],[,"(\\d)(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"]],
[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3-$4",["91"]],[,"(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3-$4",["9"]]],[,,,,,,,,,[-1]],,,[,,"810\\d{7}",,,,,,,[10]],[,,"810\\d{7}",,,,"8101234567",,,[10]],,,[,,,,,,,,,[-1]]],AS:[,[,,"(?:[58]\\d\\d|684|900)\\d{7}",,,,,,,[10],[7]],[,,"6846(?:22|33|44|55|77|88|9[19])\\d{4}",,,,"6846221234",,,,[7]],[,,"684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}",,,,"6847331234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"AS",1,"011","1",,,"([267]\\d{6})$|1","684$1",,,,,[,,,,,,,,,[-1]],,"684",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AT:[,[,,"1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
,,,,,,[4,5,6,7,8,9,10,11,12,13],[3]],[,,"1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}",,,,"1234567890",,,,[3]],[,,"6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",,,,"664123456",,,[7,8,9,10,11,12,13]],[,,"800\\d{6,10}",
,,,"800123456",,,[9,10,11,12,13]],[,,"(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}",,,,"900123456",,,[9,10,11,12,13]],[,,"8(?:10|2[018])\\d{6,10}|828\\d{5}",,,,"810123456",,,[8,9,10,11,12,13]],[,,,,,,,,,[-1]],[,,"5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",,,,"780123456",,,[5,6,7,8,9,10,11,12,13]],"AT",43,"00","0",,,"0",,,,[[,"(\\d{4})","$1",["14"]],[,"(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],[,"(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],
[,"(\\d{6})","$1",["[18]"]],[,"(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],[,"(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],[[,"(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],[,"(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],[,"(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
"0$1"],[,"(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AU:[,[,,"1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",,,,,,,[5,6,7,8,9,10,12]],[,,"(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
,,,"212345678",,,[9],[8]],[,,"4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",,,,"1300123456",,,[6,8,10,12]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"AU",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,
"(183[12])|0",,"0011",,[[,"(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["13"]],[,"(\\d{3})(\\d{3})","$1 $2",["19"]],[,"(\\d{3})(\\d{4})","$1 $2",["180","1802"]],[,"(\\d{4})(\\d{3,4})","$1 $2",["19"]],[,"(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)","$CC ($1)"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]],[,"(\\d{4})(\\d{4})(\\d{4})",
"$1 $2 $3",["130"]]],[[,"(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)","$CC ($1)"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],[,,"163\\d{2,6}",,,,"1631234",,,[5,6,7,8,9]],1,,[,,"1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}",,,,,,,[6,7,8,10,12]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AW:[,[,,"(?:[25-79]\\d\\d|800)\\d{4}",
,,,,,,[7]],[,,"5(?:2\\d|8[1-9])\\d{4}",,,,"5212345"],[,,"(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",,,,"5601234"],[,,"800\\d{4}",,,,"8001234"],[,,"900\\d{4}",,,,"9001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:28\\d|501)\\d{4}",,,,"5011234"],"AW",297,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AX:[,[,,"2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
,,,,,,[5,6,7,8,9,10,11,12]],[,,"18[1-8]\\d{3,6}",,,,"181234567",,,[6,7,8,9]],[,,"4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",,,,"412345678",,,[6,7,8,9,10]],[,,"800\\d{4,6}",,,,"800123456",,,[7,8,9]],[,,"[67]00\\d{5,6}",,,,"600123456",,,[8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AX",358,"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","0",,,"0",,"00",,,,[,,,,,,,,,[-1]],,"18",[,,,,,,,,,[-1]],[,,"20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
,,,"10112345"],,,[,,,,,,,,,[-1]]],AZ:[,[,,"365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",,,,,,,[9],[7]],[,,"(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}",,,,"123123456",,,,[7]],[,,"36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}",,,,"401234567"],[,,"88\\d{7}",,,,"881234567"],[,,"900200\\d{3}",,,,"900200123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AZ",994,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[1-9]"]],[,
"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["[13-9]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BA:[,[,,"6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",,,,,,,[8,9],[6]],[,,"(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",,,,"30212345",,,[8],[6]],[,,"6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",,,,"61123456"],[,,"8[08]\\d{6}",,,,"80123456",,,[8]],[,,"9[0246]\\d{6}",,,,"90123456",,,[8]],[,,"8[12]\\d{6}",,,,"82123456",,,[8]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BA",387,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})","$1-$2",["[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]],[,,"703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",,,,"70341234",,,[8]],,,[,,,,,,,,,[-1]]],BB:[,[,,"(?:246|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}",,,,"2464123456",,,,[7]],[,,"246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}",,,,"2462501234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
,,,"8002123456"],[,,"(?:246976|900[2-9]\\d\\d)\\d{4}",,,,"9002123456",,,,[7]],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,"24631\\d{5}",,,,"2463101234",,,,[7]],"BB",1,"011","1",,,"([2-9]\\d{6})$|1","246$1",,,,,[,,,,,,,,,[-1]],,"246",[,,,,,,,,,[-1]],[,,"246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
,,,"2464301234",,,,[7]],,,[,,,,,,,,,[-1]]],BD:[,[,,"[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",,,,,,,[6,7,8,9,10]],[,,"(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:222|[45]\\d)\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
,,,"27111234"],[,,"(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",,,,"1812345678",,,[10]],[,,"80[03]\\d{7}",,,,"8001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}",,,,"9604123456",,,[10]],"BD",880,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],[,"(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
"0$1"],[,"(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|22"],"0$1"],[,"(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BE:[,[,,"4\\d{8}|[1-9]\\d{7}",,,,,,,[8,9]],[,,"80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",,,,"12345678",,,[8]],[,,"4[5-9]\\d{7}",,,,"470123456",,,[9]],[,,"800[1-9]\\d{4}",,,,"80012345",,,[8]],[,,"(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}",,,,"90012345",,,[8]],[,,"7879\\d{4}",
,,,"78791234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BE",32,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}",,,,"78102345",,,[8]],,,[,,,,,,,,,[-1]]],BF:[,[,,"[025-7]\\d{7}",
,,,,,,[8]],[,,"2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}",,,,"20491234"],[,,"(?:0[1-35-7]|5[0-8]|[67]\\d)\\d{6}",,,,"70123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BF",226,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BG:[,[,,"00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",,,,,,,[6,7,8,9,12],[4,5]],
[,,"2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",,,,"2123456",,,[6,7,8],[4,5]],[,,"(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",,,,"43012345",,,[8,9]],[,,"(?:00800\\d\\d|800)\\d{5}",,,,"80012345",,,[8,12]],[,,"90\\d{6}",,,,"90123456",,,[8]],[,,"700\\d{5}",,,,"70012345",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BG",359,"00","0",,,"0",,,,[[,"(\\d{6})","$1",["1"]],[,"(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",
["43[1-6]|70[1-9]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],[[,"(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],
"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BH:[,[,,"[136-9]\\d{7}",,,,,,,[8]],[,,"(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
,,,"17001234"],[,,"(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}",,,,"36001234"],[,,"8[02369]\\d{6}",,,,"80123456"],[,,"(?:87|9[0-8])\\d{6}",,,,"90123456"],[,,"84\\d{6}",,,,"84123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BH",973,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[13679]|8[02-4679]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BI:[,[,,"(?:[267]\\d|31)\\d{6}",,,,,,,[8]],[,,"(?:22|31)\\d{6}",,,,"22201234"],[,,"(?:29|[67][125-9])\\d{6}",
,,,"79561234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BI",257,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BJ:[,[,,"[24-689]\\d{7}",,,,,,,[8]],[,,"2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}",,,,"20211234"],[,,"(?:4[0-6]|[56]\\d|9[013-9])\\d{6}",,,,"90011234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"857[58]\\d{4}",,,,"85751234"],"BJ",
229,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"81\\d{6}",,,,"81123456"],,,[,,,,,,,,,[-1]]],BL:[,[,,"590\\d{6}|(?:69|80|9\\d)\\d{7}",,,,,,,[9]],[,,"590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}",,,,"590271234"],[,,"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:(?:395|76[018])\\d|475[0-5])\\d{4}",,,,"976012345"],"BL",590,"00","0",,,"0",
,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BM:[,[,,"(?:441|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",,,,"4414123456",,,,[7]],[,,"441(?:[2378]\\d|5[0-39]|92)\\d{5}",,,,"4413701234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"BM",1,"011","1",,,"([2-9]\\d{6})$|1","441$1",,,,,[,,,,,,,,,[-1]],,"441",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BN:[,[,,"[2-578]\\d{6}",,,,,,,[7]],[,,"22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}",,,,"2345678"],[,,"(?:22[89]|[78]\\d\\d)\\d{4}",,,,"7123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[34]\\d{5}",,,,"5345678"],"BN",673,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BO:[,[,,"(?:[2-467]\\d\\d|8001)\\d{5}",,,,,,,[8,9],[7]],[,,"(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",,,,"22123456",,,[8],[7]],[,,"[67]\\d{7}",,,,"71234567",,,[8]],[,,"8001[07]\\d{4}",,,,"800171234",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BO",591,"00(?:1\\d)?","0",
,,"0(1\\d)?",,,,[[,"(\\d)(\\d{7})","$1 $2",["[23]|4[46]"],,"0$CC $1"],[,"(\\d{8})","$1",["[67]"],,"0$CC $1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"],,"0$CC $1"]],,[,,,,,,,,,[-1]],,,[,,"8001[07]\\d{4}",,,,,,,[9]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BQ:[,[,,"(?:[34]1|7\\d)\\d{5}",,,,,,,[7]],[,,"(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}",,,,"7151234"],[,,"(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}",,,,"3181234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BQ",599,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"[347]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BR:[,[,,"(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",,,,,,,[8,9,10,11]],[,,"(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",,,,"1123456789",,,[10],[8]],[,,"(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",,,,"11961234567",,,[10,11],[8,9]],[,,"800\\d{6,7}",,,,"800123456",,,
[9,10]],[,,"300\\d{6}|[59]00\\d{6,7}",,,,"300123456",,,[9,10]],[,,"(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}",,,,"40041234",,,[8,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BR",55,"00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","0",,,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2",,,[[,"(\\d{3,6})","$1",["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]],[,"(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],[,"(\\d{4})(\\d{4})","$1-$2",
["[2-57]","[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]],[,"(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],[,"(\\d{5})(\\d{4})","$1-$2",["9"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)","0 $CC ($1)"],[,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)","0 $CC ($1)"]],[[,"(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],[,"(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],
"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)","0 $CC ($1)"],[,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)","0 $CC ($1)"]],[,,,,,,,,,[-1]],,,[,,"30(?:0\\d{5,7}|3\\d{7})|40(?:0\\d|20)\\d{4}|800\\d{6,7}",,,,,,,[8,9,10]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BS:[,[,,"(?:242|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
,,,"2423456789",,,,[7]],[,,"242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}",,,,"2423591234",,,,[7]],[,,"242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456",,,,[7]],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"BS",1,"011","1",,,"([3-8]\\d{6})$|1","242$1",,,,,[,,,,,,,,,[-1]],,"242",[,,,,,,,,,[-1]],[,,"242225\\d{4}",,,,"2422250123"],,,[,,,,,,,,,[-1]]],BT:[,[,,"[17]\\d{7}|[2-8]\\d{6}",,,,,,,[7,8],[6]],[,,"(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",,,,"2345678",,,[7],[6]],[,,"(?:1[67]|77)\\d{6}",,,,"17123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BT",975,"00",,,,,,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[2-7]"]],[,"(\\d)(\\d{3})(\\d{3})",
"$1 $2 $3",["[2-68]|7[246]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]],[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BW:[,[,,"(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",,,,,,,[7,8,10]],[,,"(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}",
,,,"2401234",,,[7]],[,,"(?:321|7[1-8]\\d)\\d{5}",,,,"71123456",,,[8]],[,,"(?:0800|800\\d)\\d{6}",,,,"0800012345",,,[10]],[,,"90\\d{5}",,,,"9012345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"79(?:1(?:[01]\\d|2[0-8])|2[0-7]\\d)\\d{3}",,,,"79101234",,,[8]],"BW",267,"00",,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["90"]],[,"(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-9]"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]],
,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BY:[,[,,"(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",,,,,,,[6,7,8,9,10,11],[5]],[,,"(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",,,,"152450911",,,[9],[5,6,7]],[,,"(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",,,,"294911911",
,,[9]],[,,"800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",,,,"8011234567"],[,,"(?:810|902)\\d{7}",,,,"9021234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"249\\d{6}",,,,"249123456",,,[9]],"BY",375,"810","8",,,"0|80?",,"8~10",,[[,"(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],[,"(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],[,"(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
"8 0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,"800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BZ:[,[,,"(?:0800\\d|[2-8])\\d{6}",,,,,,,[7,11]],[,,"(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",,,,"2221234",,,[7]],[,,"6[0-35-7]\\d{5}",
,,,"6221234",,,[7]],[,,"0800\\d{7}",,,,"08001234123",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BZ",501,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],[,"(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CA:[,[,,"(?:[2-8]\\d|90)\\d{8}|3\\d{6}",,,,,,,[7,10]],[,,"(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
,,,"5062345678",,,[10],[7]],[,,"(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",,,,"5062345678",,,[10],[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456",,,[10]],[,,"900[2-9]\\d{6}",,,,"9002123456",,,[10]],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
,,,"5002345678",,,[10]],[,,"600[2-9]\\d{6}",,,,"6002012345",,,[10]],"CA",1,"011","1",,,"1",,,1,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"310\\d{4}",,,,"3101234",,,[7]],,,[,,,,,,,,,[-1]]],CC:[,[,,"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",,,,,,,[6,7,8,9,10,12]],[,,"8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",,,,"891621234",,,[9],[8]],[,,"4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",,,,"1300123456",,,[6,8,10,12]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"CC",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,"([59]\\d{7})$|0","8$1","0011",,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CD:[,[,,"[189]\\d{8}|[1-68]\\d{6}",,,,,,
,[7,9]],[,,"12\\d{7}|[1-6]\\d{6}",,,,"1234567"],[,,"88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}",,,,"991234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CD",243,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],[,"(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CF:[,[,,
"(?:[27]\\d{3}|8776)\\d{4}",,,,,,,[8]],[,,"2[12]\\d{6}",,,,"21612345"],[,,"7[024-7]\\d{6}",,,,"70012345"],[,,,,,,,,,[-1]],[,,"8776\\d{4}",,,,"87761234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CF",236,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CG:[,[,,"222\\d{6}|(?:0\\d|80)\\d{7}",,,,,,,[9]],[,,"222[1-589]\\d{5}",,,,"222123456"],[,,"026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
,,,"061234567"],[,,,,,,,,,[-1]],[,,"80[0-2]\\d{6}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CG",242,"00",,,,,,,,[[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CH:[,[,,"8\\d{11}|[2-9]\\d{8}",,,,,,,[9,12]],[,,"(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",,,,"212345678",,,[9]],[,,"7[35-9]\\d{7}",,,,"781234567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],
[,,"90[016]\\d{6}",,,,"900123456",,,[9]],[,,"84[0248]\\d{6}",,,,"840123456",,,[9]],[,,"878\\d{6}",,,,"878123456",,,[9]],[,,,,,,,,,[-1]],"CH",41,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],,[,,"74[0248]\\d{6}",,,,"740123456",,,[9]],,,[,,,,,,,,,[-1]],[,,"5[18]\\d{7}",,,,"581234567",,,[9]],,,[,,"860\\d{9}",,,,"860123456789",
,,[12]]],CI:[,[,,"[02]\\d{9}",,,,,,,[10]],[,,"2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}",,,,"2123456789"],[,,"0[157]\\d{8}",,,,"0123456789"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CI",225,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CK:[,[,,"[2-578]\\d{4}",,,,,,
,[5]],[,,"(?:2\\d|3[13-7]|4[1-5])\\d{3}",,,,"21234"],[,,"[578]\\d{4}",,,,"71234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CK",682,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CL:[,[,,"12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",,,,,,,[9,10,11]],[,,"2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
,,,"221234567",,,[9]],[,,"2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",,,,"221234567",,,[9]],[,,"(?:123|8)00\\d{6}",,,,"800123456",,,[9,11]],[,,,,,,,,,[-1]],[,,
"600\\d{7,8}",,,,"6001234567",,,[10,11]],[,,,,,,,,,[-1]],[,,"44\\d{7}",,,,"441234567",,,[9]],"CL",56,"(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",,,,,,,1,[[,"(\\d{4})","$1",["1(?:[03-589]|21)|[29]0|78"]],[,"(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],
"($1)"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]],[[,"(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],[,"(\\d{3})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["60|8"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]],[,,,,,,,,,[-1]],,,[,,"600\\d{7,8}",,,,,,,[10,11]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CM:[,[,,"[26]\\d{8}|88\\d{6,7}",,,,,,,[8,9]],[,,"2(?:22|33)\\d{6}",,,,"222123456",,,[9]],[,,"(?:24[23]|6[25-9]\\d)\\d{6}",,,,"671234567",,,[9]],[,,"88\\d{6,7}",,,,"88012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CM",237,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["88"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CN:[,[,,"1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",,,,,,,[7,8,9,10,11,12],[5,6]],[,,"(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
,,,"1012345678",,,[7,8,9,10,11],[5,6]],[,,"1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",,,,"13123456789",,,[11]],[,,"(?:(?:10|21)8|8)00\\d{7}",,,,"8001234567",,,[10,12]],[,,"16[08]\\d{5}",,,,"16812345",,,[8]],[,,"10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
,,,"4001234567",,,[7,8,9,10,11],[5,6]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CN",86,"00|1(?:[12]\\d|79)\\d\\d00","0",,,"(1(?:[12]\\d|79)\\d\\d)|0",,"00",,[[,"(\\d{5,6})","$1",["10|96"]],[,"(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","10(?:10|9[56])|2[0-57-9](?:100|9[56])"],"0$1","$CC $1"],[,"(\\d{3})(\\d{4})","$1 $2",["[1-9]","1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])","1(?:0(?:[0-8]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])|6)|[3-9]"]],
[,"(\\d{4})(\\d{4})","$1 $2",["16[08]"]],[,"(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
"85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],
"0$1","$CC $1"],[,"(\\d{4})(\\d{4})","$1 $2",["[1-9]","1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]","1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
"1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"]],
[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{7,8})",
"$1 $2",["9"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"],,"$CC $1"],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",,1]],[[,"(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","10(?:10|9[56])|2[0-57-9](?:100|9[56])"],"0$1","$CC $1"],[,"(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
"(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
"85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1","$CC $1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],
"0$1","$CC $1",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{7,8})","$1 $2",["9"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"],,"$CC $1"],
[,"(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",,1]],[,,,,,,,,,[-1]],,,[,,"(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}",,,,,,,[10,11,12]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CO:[,[,,"(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",,,,,,,[10,11],[7]],[,,"601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60(?:[124-7][2-9]|8[1-9])\\d{6}",,,,"6012345678",,,[10],[7]],[,,"333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",
,,,"3211234567",,,[10]],[,,"1800\\d{7}",,,,"18001234567",,,[11]],[,,"19(?:0[01]|4[78])\\d{7}",,,,"19001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CO",57,"00(?:4(?:[14]4|56)|[579])","0",,,"0([3579]|4(?:[14]4|56))?",,,,[[,"(\\d{3})(\\d{7})","$1 $2",["6"],"($1)","0$CC $1"],[,"(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"],,"0$CC $1"],[,"(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1"]],[[,"(\\d{3})(\\d{7})","$1 $2",["6"],"($1)","0$CC $1"],[,"(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"],,
"0$CC $1"],[,"(\\d)(\\d{3})(\\d{7})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CR:[,[,,"(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",,,,,,,[8,10]],[,,"210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",,,,"22123456",,,[8]],[,,"(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",,,,"83123456",,,[8]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"90[059]\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:210[0-6]|4\\d{3}|5100)\\d{4}",
,,,"40001234",,,[8]],"CR",506,"00",,,,"(19(?:0[0-2468]|1[09]|20|66|77|99))",,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CU:[,[,,"[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",,,,,,,[6,7,8,10],[4,5]],[,,"(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",,,,"71234567",,,,[4,5]],[,,"(?:5\\d|63)\\d{6}",
,,,"51234567",,,[8]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,,,,,,,,[-1]],[,,"807\\d{7}",,,,"8071234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CU",53,"119","0",,,"0",,,,[[,"(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],[,"(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],[,"(\\d)(\\d{7})","$1 $2",["[56]"],"0$1"],[,"(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CV:[,[,,"(?:[2-59]\\d\\d|800)\\d{4}",,,,,,,[7]],[,,"2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
,,,"2211234"],[,,"(?:36|5[1-389]|9\\d)\\d{5}",,,,"9911234"],[,,"800\\d{4}",,,,"8001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:3[3-5]|4[356])\\d{5}",,,,"3401234"],"CV",238,"0",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CW:[,[,,"(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",,,,,,,[7,8]],[,,"9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
,,,"94351234"],[,,"953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",,,,"95181234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"60[0-2]\\d{4}",,,,"6001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CW",599,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[3467]"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],,[,,"955\\d{5}",,,,"95581234",,,[8]],1,"[69]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CX:[,[,,"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",,,,,,,[6,7,8,9,10,12]],[,,"8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
,,,"891641234",,,[9],[8]],[,,"4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",,,,"1300123456",,,[6,8,10,12]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"CX",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,
"([59]\\d{7})$|0","8$1","0011",,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CY:[,[,,"(?:[279]\\d|[58]0)\\d{6}",,,,,,,[8]],[,,"2[2-6]\\d{6}",,,,"22345678"],[,,"9(?:10|[4-79]\\d)\\d{5}",,,,"96123456"],[,,"800\\d{5}",,,,"80001234"],[,,"90[09]\\d{5}",,,,"90012345"],[,,"80[1-9]\\d{5}",,,,"80112345"],[,,"700\\d{5}",,,,"70012345"],[,,,,,,,,,[-1]],"CY",357,"00",,,,,,,,[[,"(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:50|77)\\d{6}",,,,"77123456"],
,,[,,,,,,,,,[-1]]],CZ:[,[,,"(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",,,,,,,[9,10,11,12]],[,,"(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",,,,"212345678",,,[9]],[,,"(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}",,,,"601123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"9(?:0[05689]|76)\\d{6}",,,,"900123456",,,[9]],[,,"8[134]\\d{7}",,,,"811234567",,,[9]],[,,"70[01]\\d{6}",,,,"700123456",,,[9]],[,,"9[17]0\\d{6}",,,,"910123456",,,[9]],"CZ",420,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],
[,"(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"9(?:5\\d|7[2-4])\\d{6}",,,,"972123456",,,[9]],,,[,,"9(?:3\\d{9}|6\\d{7,10})",,,,"93123456789"]],DE:[,[,,"[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
,,,,,,[4,5,6,7,8,9,10,11,12,13,14,15],[2,3]],[,,"32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
,,,"30123456",,,[5,6,7,8,9,10,11,12,13,14,15],[2,3,4]],[,,"15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}",,,,"15123456789",,,[10,11]],[,,"800\\d{7,12}",,,,"8001234567890",,,[10,11,12,13,14,15]],[,,"(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",,,,"9001234567",,,[10,11]],[,,"180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",,,,"18012345",,,[7,8,9,10,11,12,13,14]],[,,"700\\d{8}",,,,"70012345678",,,[11]],[,,,,,,,,,[-1]],"DE",49,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],[,"(\\d{3})(\\d{3,12})",
"$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],[,"(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],[,"(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],[,"(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],[,"(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],[,"(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],[,"(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],[,"(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],[,"(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],
[,"(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],[,"(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],[,"(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],,[,,"16(?:4\\d{1,10}|[89]\\d{1,11})",,,,"16412345",,,[4,5,6,7,8,9,10,11,12,13,14]],,,[,,,,,,,,,[-1]],[,,"18(?:1\\d{5,11}|[2-9]\\d{8})",,,,"18500123456",,,[8,9,10,11,12,13,14]],,,[,,"1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
,,,"177991234567",,,[12,13]]],DJ:[,[,,"(?:2\\d|77)\\d{6}",,,,,,,[8]],[,,"2(?:1[2-5]|7[45])\\d{5}",,,,"21360003"],[,,"77\\d{6}",,,,"77831001"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"DJ",253,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DK:[,[,,"[2-9]\\d{7}",,,,,,,[8]],[,,"(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",,,,"32123456"],[,,"(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",
,,,"32123456"],[,,"80\\d{6}",,,,"80123456"],[,,"90\\d{6}",,,,"90123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"DK",45,"00",,,,,,,1,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DM:[,[,,"(?:[58]\\d\\d|767|900)\\d{7}",,,,,,,[10],[7]],[,,"767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",,,,"7674201234",,,,[7]],[,,"767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",,,,"7672251234",,,,[7]],
[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"DM",1,"011","1",,,"([2-7]\\d{6})$|1","767$1",,,,,[,,,,,,,,,[-1]],,"767",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
DO:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",,,,"8092345678",,,,[7]],[,,"8[024]9[2-9]\\d{6}",,,,"8092345678",,,,[7]],[,,"8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",
,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"DO",1,"011","1",,,"1",,,,,,[,,,,,,,,,[-1]],,"8001|8[024]9",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DZ:[,[,,"(?:[1-4]|[5-79]\\d|80)\\d{7}",,,,,,,[8,9]],
[,,"9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}",,,,"12345678"],[,,"(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",,,,"551234567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"80[3-689]1\\d{5}",,,,"808123456",,,[9]],[,,"80[12]1\\d{5}",,,,"801123456",,,[9]],[,,,,,,,,,[-1]],[,,"98[23]\\d{6}",,,,"983123456",,,[9]],"DZ",213,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],
[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EC:[,[,,"1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",,,,,,,[8,9,10,11],[7]],[,,"[2-7][2-7]\\d{6}",,,,"22123456",,,[8],[7]],[,,"964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",,,,"991234567",,,[9]],[,,"1800\\d{7}|1[78]00\\d{6}",,,,"18001234567",,,[10,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[2-7]890\\d{4}",,,,"28901234",,,[8]],"EC",593,"00","0",,,
"0",,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-7]"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],[[,"(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-7]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EE:[,[,,"8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",,,,,,,[7,8,10]],[,,"(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
,,,"3212345",,,[7]],[,,"(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",,,,"51234567",,,[7,8]],[,,"800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",,,,"80012345"],[,,"(?:40\\d\\d|900)\\d{4}",,,,"9001234",,,[7,8]],[,,,,,,,,,[-1]],[,,"70[0-2]\\d{5}",,,,"70012345",
,,[8]],[,,,,,,,,,[-1]],"EE",372,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],[,"(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,"800[2-9]\\d{3}",,,,,,,[7]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EG:[,[,,"[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
,,,,,,[8,9,10],[6,7]],[,,"13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",,,,"234567890",,,[8,9],[6,7]],[,,"1[0-25]\\d{8}",,,,"1001234567",,,[10]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"EG",20,"00","0",,,"0",,,,[[,"(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],[,"(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],
"0$1"],[,"(\\d{2})(\\d{8})","$1 $2",["1"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EH:[,[,,"[5-8]\\d{8}",,,,,,,[9]],[,,"528[89]\\d{5}",,,,"528812345"],[,,"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}",,,,"650123456"],[,,"80[0-7]\\d{6}",,,,"801234567"],[,,"89\\d{7}",,,,"891234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",,,,"592401234"],"EH",212,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,"528[89]",[,,,,,,
,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ER:[,[,,"[178]\\d{6}",,,,,,,[7],[6]],[,,"(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}",,,,"8370362",,,,[6]],[,,"(?:17[1-3]|7\\d\\d)\\d{4}",,,,"7123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ER",291,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ES:[,[,,"[5-9]\\d{8}",,,,,,,[9]],[,,"96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
,,,"810123456"],[,,"(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}",,,,"612345678"],[,,"[89]00\\d{6}",,,,"800123456"],[,,"80[367]\\d{6}",,,,"803123456"],[,,"90[12]\\d{6}",,,,"901123456"],[,,"70\\d{7}",,,,"701234567"],[,,,,,,,,,[-1]],"ES",34,"00",,,,,,,,[[,"(\\d{4})","$1",["905"]],[,"(\\d{6})","$1",["[79]9"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],
[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"51\\d{7}",,,,"511234567"],,,[,,,,,,,,,[-1]]],ET:[,[,,"(?:11|[2-579]\\d)\\d{7}",,,,,,,[9],[7]],[,,"11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
,,,"111112345",,,,[7]],[,,"700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}",,,,"911234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ET",251,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FI:[,[,,"[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",,,,,,,[5,6,7,8,9,10,11,12]],[,,"(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}",
,,,"131234567",,,[5,6,7,8,9]],[,,"4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",,,,"412345678",,,[6,7,8,9,10]],[,,"800\\d{4,6}",,,,"800123456",,,[7,8,9]],[,,"[67]00\\d{5,6}",,,,"600123456",,,[8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FI",358,"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","0",,,"0",,"00",,[[,"(\\d{5})","$1",["75[12]"],"0$1"],[,"(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],[,"(\\d{6})","$1",["11"]],[,"(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],
"0$1"],[,"(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],[,"(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],[[,"(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],[,"(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],[,"(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],[,"(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],[,,,,,,,,,[-1]],1,"1[03-79]|[2-9]",[,,"20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"],
[,,"20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",,,,"10112345"],,,[,,,,,,,,,[-1]]],FJ:[,[,,"45\\d{5}|(?:0800\\d|[235-9])\\d{6}",,,,,,,[7,11]],[,,"603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",,,,"3212345",,,[7]],[,,"(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",,,,"7012345",,,[7]],[,,"0800\\d{7}",,,,"08001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FJ",679,"0(?:0|52)",,,,,
,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FK:[,[,,"[2-7]\\d{4}",,,,,,,[5]],[,,"[2-47]\\d{4}",,,,"31234"],[,,"[56]\\d{4}",,,,"51234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FK",500,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FM:[,[,,"(?:[39]\\d\\d|820)\\d{4}",,,,,,,[7]],[,,"31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
,,,"3201234"],[,,"31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",,,,"3501234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FM",691,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[389]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FO:[,[,,"[2-9]\\d{5}",,,,,,,[6]],[,,"(?:20|[34]\\d|8[19])\\d{4}",,,,"201234"],[,,"(?:[27][1-9]|5\\d|9[16])\\d{4}",,,,"211234"],[,,"80[257-9]\\d{3}",,,,"802123"],[,,"90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
,,,"901123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:6[0-36]|88)\\d{4}",,,,"601234"],"FO",298,"00",,,,"(10(?:01|[12]0|88))",,,,[[,"(\\d{6})","$1",["[2-9]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FR:[,[,,"[1-9]\\d{8}",,,,,,,[9]],[,,"59[1-9]\\d{6}|(?:[1-3]\\d|4[1-9]|5[0-8])\\d{7}",,,,"123456789"],[,,"(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}",,,,"612345678"],[,,"80[0-5]\\d{6}",,,,"801234567"],[,,"836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
,,,"891123456"],[,,"8(?:1[01]|2[0156]|4[02]|84)\\d{6}",,,,"884012345"],[,,,,,,,,,[-1]],[,,"9\\d{8}",,,,"912345678"],"FR",33,"00","0",,,"0",,,,[[,"(\\d{4})","$1",["10"]],[,"(\\d{3})(\\d{3})","$1 $2",["1"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],[,,,,,,,,
,[-1]],,,[,,,,,,,,,[-1]],[,,"80[6-9]\\d{6}",,,,"806123456"],,,[,,,,,,,,,[-1]]],GA:[,[,,"(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",,,,,,,[7,8]],[,,"[01]1\\d{6}",,,,"01441234",,,[8]],[,,"(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",,,,"06031234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GA",241,"00",,,,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1",,,[[,"(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["0"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GB:[,[,,"[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",,,,,,,[7,9,10],[4,5,6,8]],[,,"(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
,,,"1212345678",,,[9,10],[4,5,6,7,8]],[,,"7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",,,,"7400123456",,,[10]],[,,"80[08]\\d{7}|800\\d{6}|8001111",,,,"8001234567"],[,,"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",,,,"9012345678",,,[7,10]],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,"56\\d{8}",,,,"5612345678",
,,[10]],"GB",44,"00","0"," x",,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],[,"(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],[,"(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])",
"[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],[,"(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],,[,,"76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",,,,"7640123456",,,[10]],1,,[,,,,,,,,,[-1]],[,,"(?:3[0347]|55)\\d{8}",,,,"5512345678",,,[10]],,,[,,,,,,,,,[-1]]],GD:[,[,,"(?:473|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
,,,"4732691234",,,,[7]],[,,"473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}",,,,"4734031234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],
"GD",1,"011","1",,,"([2-9]\\d{6})$|1","473$1",,,,,[,,,,,,,,,[-1]],,"473",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GE:[,[,,"(?:[3-57]\\d\\d|800)\\d{6}",,,,,,,[9],[6,7]],[,,"(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",,,,"322123456",,,,[6,7]],[,,"5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:00(?:0\\d|11|22|33|44|5[05]|77|88|99)|1(?:1(?:00|[124]\\d|3[01])|4\\d\\d)|(?:44|68)\\d\\d|5(?:[0157-9]\\d\\d|200)|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|58[89]|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:070|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}",
,,,"555123456"],[,,"800\\d{6}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"70[67]\\d{6}",,,,"706123456"],"GE",995,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"70[67]\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GF:[,[,,"[56]94\\d{6}|(?:80|9\\d)\\d{7}",
,,,,,,[9]],[,,"594(?:[02-49]\\d|1[0-4]|5[6-9]|6[0-3]|80)\\d{4}",,,,"594101234"],[,,"694(?:[0-249]\\d|3[0-8])\\d{4}",,,,"694201234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}",,,,"976012345"],"GF",594,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[56]|9[47]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,
,,,,[-1]]],GG:[,[,,"(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",,,,,,,[7,9,10],[6]],[,,"1481[25-9]\\d{5}",,,,"1481256789",,,[10],[6]],[,,"7(?:(?:781|839)\\d|911[17])\\d{5}",,,,"7781123456",,,[10]],[,,"80[08]\\d{7}|800\\d{6}|8001111",,,,"8001234567"],[,,"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",,,,"9012345678",,,[7,10]],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,"56\\d{8}",,,,"5612345678",,,[10]],"GG",44,"00","0",,,"([25-9]\\d{5})$|0","1481$1",,,,,[,,"76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
,,,"7640123456",,,[10]],,,[,,,,,,,,,[-1]],[,,"(?:3[0347]|55)\\d{8}",,,,"5512345678",,,[10]],,,[,,,,,,,,,[-1]]],GH:[,[,,"(?:[235]\\d{3}|800)\\d{5}",,,,,,,[8,9],[7]],[,,"3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",,,,"302345678",,,[9],[7]],[,,"(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",,,,"231234567",,,[9]],[,,"800\\d{5}",,,,"80012345",
,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GH",233,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[237]|8[0-2]"]],[,"(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],[[,"(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"800\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GI:[,[,,"(?:[25]\\d|60)\\d{6}",,,,,,,[8]],[,,"2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
,,,"20012345"],[,,"5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}",,,,"57123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GI",350,"00",,,,,,,,[[,"(\\d{3})(\\d{5})","$1 $2",["2"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GL:[,[,,"(?:19|[2-689]\\d|70)\\d{4}",,,,,,,[6]],[,,"(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}",,,,"321000"],[,,"[245]\\d{5}",,,,"221234"],[,,"80\\d{4}",,,,"801234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],[,,"3[89]\\d{4}",,,,"381234"],"GL",299,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GM:[,[,,"[2-9]\\d{6}",,,,,,,[7]],[,,"(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}",,,,"5661234"],[,,"(?:[23679]\\d|5[0-489])\\d{5}",,,,"3012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GM",220,"00",
,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GN:[,[,,"722\\d{6}|(?:3|6\\d)\\d{7}",,,,,,,[8,9]],[,,"3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",,,,"30241234",,,[8]],[,,"6[0-356]\\d{7}",,,,"601123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"722\\d{6}",,,,"722123456",,,[9]],"GN",224,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[67]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GP:[,[,,"590\\d{6}|(?:69|80|9\\d)\\d{7}",,,,,,,[9]],[,,"590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}",,,,"590201234"],[,,"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:(?:395|76[018])\\d|475[0-5])\\d{4}",,,,"976012345"],"GP",590,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[569]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GQ:[,[,,"222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",,,,,,,[9]],[,,"33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}",,,,"333091234"],[,,"(?:222|55\\d)\\d{6}",,,,"222123456"],[,,"80\\d[1-9]\\d{5}",,,,"800123456"],[,,"90\\d[1-9]\\d{5}",,,,"900123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GQ",240,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})",
"$1 $2 $3",["[235]"]],[,"(\\d{3})(\\d{6})","$1 $2",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GR:[,[,,"5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",,,,,,,[10,11,12]],[,,"2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
,,,"2123456789",,,[10]],[,,"68[57-9]\\d{7}|(?:69|94)\\d{8}",,,,"6912345678",,,[10]],[,,"800\\d{7,9}",,,,"8001234567"],[,,"90[19]\\d{7}",,,,"9091234567",,,[10]],[,,"8(?:0[16]|12|[27]5|50)\\d{7}",,,,"8011234567",,,[10]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,,,,,,,,[-1]],"GR",30,"00",,,,,,,,[[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],[,"(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],[,"(\\d{3})(\\d{3,4})(\\d{5})",
"$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"5005000\\d{3}",,,,"5005000123",,,[10]],,,[,,,,,,,,,[-1]]],GT:[,[,,"80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",,,,,,,[8,11]],[,,"[267][2-9]\\d{6}",,,,"22456789",,,[8]],[,,"(?:[3-5]\\d\\d|80[0-4])\\d{5}",,,,"51234567",,,[8]],[,,"18[01]\\d{8}",,,,"18001112222",,,[11]],[,,"19\\d{9}",,,,"19001112222",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GT",502,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2-8]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",
["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GU:[,[,,"(?:[58]\\d\\d|671|900)\\d{7}",,,,,,,[10],[7]],[,,"671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",,,,"6713001234",,,,[7]],[,,"671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
,,,"6713001234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"GU",1,"011","1",,,"([2-9]\\d{6})$|1","671$1",,1,,,[,,,,,,,,,[-1]],,"671",[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],,,[,,,,,,,,,[-1]]],GW:[,[,,"[49]\\d{8}|4\\d{6}",,,,,,,[7,9]],[,,"443\\d{6}",,,,"443201234",,,[9]],[,,"9(?:5\\d|6[569]|77)\\d{6}",,,,"955012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"40\\d{5}",,,,"4012345",,,[7]],"GW",245,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["40"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GY:[,[,,"(?:[2-8]\\d{3}|9008)\\d{3}",,,,,,,[7]],[,,"(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
,,,"2201234"],[,,"(?:510|6\\d\\d|7(?:0\\d|1[0-8]|25|49))\\d{4}",,,,"6091234"],[,,"(?:289|8(?:00|6[28]|88|99))\\d{4}",,,,"2891234"],[,,"9008\\d{3}",,,,"9008123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"515\\d{4}",,,,"5151234"],"GY",592,"001",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HK:[,[,,"8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",,,,,,,[5,6,7,8,9,11]],[,,"(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[59]\\d|6[01]))|58(?:0[1-9]|1[2-9]))\\d{4}",
,,,"21234567",,,[8]],[,,"(?:4(?:44[5-9]|6(?:1[0-7]|4[0-57-9]|6[0-4]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-6]|8[0-4])|848[0-25-9]|9(?:29[013-9]|59[0-4]|899))\\d{4}|(?:4(?:4[015]|6[02357-9])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",,,,"51234567",,,[8]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"900(?:[0-24-9]\\d{7}|3\\d{1,4})",,,,"90012345678",,,[5,6,7,8,11]],[,,,,,,,,,[-1]],[,,"8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",
,,,"81123456",,,[8]],[,,,,,,,,,[-1]],"HK",852,"00(?:30|5[09]|[126-9]?)",,,,,,"00",,[[,"(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],,[,,"7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
,,,"71123456",,,[8]],,,[,,,,,,,,,[-1]],[,,"30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",,,,"30161234",,,[8]],,,[,,,,,,,,,[-1]]],HN:[,[,,"8\\d{10}|[237-9]\\d{7}",,,,,,,[8,11]],[,,"2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",,,,"22123456",
,,[8]],[,,"[37-9]\\d{7}",,,,"91234567",,,[8]],[,,"8002\\d{7}",,,,"80021234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"HN",504,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1-$2",["[237-9]"]],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["8"]]],[[,"(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]],[,,,,,,,,,[-1]],,,[,,"8002\\d{7}",,,,,,,[11]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HR:[,[,,"(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",,,,,,,[6,7,8,9]],[,,"1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
,,,"12345678",,,[8,9],[6,7]],[,,"9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|77|9[5-7])))\\d{4}|98\\d{6}",,,,"921234567",,,[8,9]],[,,"80\\d{5,7}",,,,"800123456",,,[7,8,9]],[,,"6[01459]\\d{6}|6[01]\\d{4,5}",,,,"611234",,,[6,7,8]],[,,,,,,,,,[-1]],[,,"7[45]\\d{6}",,,,"74123456",,,[8]],[,,,,,,,,,[-1]],"HR",385,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],[,"(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"62\\d{6,7}|72\\d{6}",,,,"62123456",,,[8,9]],,,[,,,,,,,,,[-1]]],HT:[,[,,"(?:[2-489]\\d|55)\\d{6}",,,,,,,[8]],[,,"2(?:2\\d|5[1-5]|81|9[149])\\d{5}",,,,"22453300"],[,,"(?:[34]\\d|55)\\d{6}",,,,"34101234"],[,,"8\\d{7}",,,,"80012345"],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",,,,"98901234"],"HT",509,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-589]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HU:[,[,,"[235-7]\\d{8}|[1-9]\\d{7}",,,,,,,[8,9],[6,7]],[,,"(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",,,,"12345678",,,[8],[6,7]],[,,"(?:[257]0|3[01])\\d{7}",,,,"201234567",,,[9]],[,,"(?:[48]0\\d|680[29])\\d{5}",,,,"80123456"],
[,,"9[01]\\d{6}",,,,"90123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"21\\d{7}",,,,"211234567",,,[9]],"HU",36,"00","06",,,"06",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],,[,,,,,,,,,[-1]],,,[,,"(?:[48]0\\d|680[29])\\d{5}"],[,,"38\\d{7}",,,,"381234567",,,[9]],,,[,,,,,,,,,[-1]]],ID:[,[,,"(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
,,,,,,[7,8,9,10,11,12,13],[5,6]],[,,"2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",,,,"218350123",
,,[7,8,9,10,11],[5,6]],[,,"8[1-35-9]\\d{7,10}",,,,"812345678",,,[9,10,11,12]],[,,"00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}",,,,"8001234567",,,[8,9,10,11,12,13]],[,,"809\\d{7}",,,,"8091234567",,,[10]],[,,"804\\d{7}",,,,"8041234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ID",62,"00[89]","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],[,"(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],[,"(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],[,"(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],
"(0$1)"],[,"(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],[,"(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],[,"(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["001"]],[,"(\\d{2})(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3 $4",["0"]]],[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],[,"(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],
"(0$1)"],[,"(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],[,"(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],[,"(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],[,"(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],[,"(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"001803\\d{6,7}|(?:007803\\d|8071)\\d{6}",,,,,,,[10,12,13]],[,,"(?:1500|8071\\d{3})\\d{3}",,,,
"8071123456",,,[7,10]],,,[,,,,,,,,,[-1]]],IE:[,[,,"(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",,,,,,,[7,8,9,10],[5,6]],[,,"(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}",,,,"2212345",,,,[5,6]],[,,"8(?:22|[35-9]\\d)\\d{6}",,,,"850123456",,,[9]],[,,"1800\\d{6}",,,,"1800123456",,,[10]],[,,"15(?:1[2-8]|[2-8]0|9[089])\\d{6}",,,,"1520123456",,,[10]],[,,"18[59]0\\d{6}",,,,"1850123456",
,,[10]],[,,"700\\d{6}",,,,"700123456",,,[9]],[,,"76\\d{7}",,,,"761234567",,,[9]],"IE",353,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],[,"(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],[,"(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",
["[78]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],[,"(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"18[59]0\\d{6}",,,,,,,[10]],[,,"818\\d{6}",,,,"818123456",,,[9]],,,[,,"88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}",,,,"8551234567",,,[10]]],IL:[,[,,"1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",,,,,,,[7,8,9,10,11,12]],[,,"153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
,,,"21234567",,,[8,11,12],[7]],[,,"55410\\d{4}|5(?:(?:[02][02-9]|[149][2-9]|[36]\\d|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",,,,"502345678",,,[9]],[,,"1(?:255|80[019]\\d{3})\\d{3}",,,,"1800123456",,,[7,10]],[,,"1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}",,,,"1919123456",,,[8,10]],[,,"1700\\d{6}",,,,"1700123456",,,[10]],[,,,,,,,,,[-1]],[,,"7(?:38(?:0\\d|5[09]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",,,,"771234567",
,,[9]],"IL",972,"0(?:0|1[2-9])","0",,,"0",,,,[[,"(\\d{4})(\\d{3})","$1-$2",["125"]],[,"(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],[,"(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],[,"(\\d{4})(\\d{6})","$1-$2",["159"]],[,"(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],[,"(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],,[,,,,,,,,,[-1]],,,[,,"1700\\d{6}",,,,,,,[10]],[,
,"1599\\d{6}",,,,"1599123456",,,[10]],,,[,,"151\\d{8,9}",,,,"15112340000",,,[11,12]]],IM:[,[,,"1624\\d{6}|(?:[3578]\\d|90)\\d{8}",,,,,,,[10],[6]],[,,"1624(?:230|[5-8]\\d\\d)\\d{3}",,,,"1624756789",,,,[6]],[,,"76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}",,,,"7924123456"],[,,"808162\\d{4}",,,,"8081624567"],[,,"8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}",,,,"9016247890"],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678"],[,,"56\\d{8}",,,,"5612345678"],"IM",44,"00","0",,,"([25-8]\\d{5})$|0",
"1624$1",,,,,[,,,,,,,,,[-1]],,"74576|(?:16|7[56])24",[,,,,,,,,,[-1]],[,,"3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}",,,,"5512345678"],,,[,,,,,,,,,[-1]]],IN:[,[,,"(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",,,,,,,[8,9,10,11,12,13],[6,7]],[,,"2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
,,,"7410410123",,,[10],[6,7,8]],[,,"(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
,,,"8123456789",,,[10]],[,,"000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))",,,,"1800123456"],[,,"186[12]\\d{9}",,,,"1861123456789",,,[13]],[,,"1860\\d{7}",,,,"18603451234",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IN",91,"00","0",,,"0",,,,[[,"(\\d{7})","$1",["575"]],[,"(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],,,1],[,"(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",
["140"],,,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],
"0$1",,1],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",,1],[,"(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",,1],[,"(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],,,1],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
"$1 $2 $3 $4",["0"]],[,"(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],,,1]],[[,"(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],,,1],[,"(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],,,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],
"0$1",,1],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",,1],[,"(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",,1],[,"(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],,,1],[,"(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
"$1 $2 $3 $4",["18"],,,1]],[,,,,,,,,,[-1]],,,[,,"1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"],[,,"140\\d{7}",,,,"1409305260",,,[10]],,,[,,,,,,,,,[-1]]],IO:[,[,,"3\\d{6}",,,,,,,[7]],[,,"37\\d{5}",,,,"3709100"],[,,"38\\d{5}",,,,"3801234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IO",246,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["3"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],IQ:[,[,,"(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
,,,,,,[8,9,10],[6,7]],[,,"1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",,,,"12345678",,,[8,9],[6,7]],[,,"7[3-9]\\d{8}",,,,"7912345678",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IQ",964,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],IR:[,
[,,"[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",,,,,,,[4,5,6,7,10],[8]],[,,"(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}",,,,"2123456789",,,[6,7,10],[4,5,8]],[,,"9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}",,,,"9123456789",,,[10]],[,,,,,,,,,[-1]],[,,,,,,
,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IR",98,"00","0",,,"0",,,,[[,"(\\d{4,5})","$1",["96"],"0$1"],[,"(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",,,,,,,[4,5,10]],[,,"96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
,,,"9601",,,[4,5]],,,[,,,,,,,,,[-1]]],IS:[,[,,"(?:38\\d|[4-9])\\d{6}",,,,,,,[7,9]],[,,"(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",,,,"4101234",,,[7]],[,,"(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}",,,,"6111234"],[,,"80[0-8]\\d{4}",,,,"8001234",,,[7]],[,,"90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
,,,"9001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"49[0-24-79]\\d{4}",,,,"4921234",,,[7]],"IS",354,"00|1(?:0(?:01|[12]0)|100)",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"809\\d{4}",,,,"8091234",,,[7]],,,[,,"(?:689|8(?:7[18]|80)|95[48])\\d{4}",,,,"6891234",,,[7]]],IT:[,[,,"0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",,,,,,,[6,7,8,9,10,11,12]],[,,"0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
,,,"0212345678",,,[6,7,8,9,10,11]],[,,"3[1-9]\\d{8}|3[2-9]\\d{7}",,,,"3123456789",,,[9,10]],[,,"80(?:0\\d{3}|3)\\d{3}",,,,"800123456",,,[6,9]],[,,"(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",,,,"899123456",,,[6,8,9,10]],[,,"84(?:[08]\\d{3}|[17])\\d{3}",,,,"848123456",,,[6,9]],[,,"1(?:78\\d|99)\\d{6}",,,,"1781234567",,,[9,10]],[,,"55\\d{8}",,,,"5512345678",,,[10]],"IT",39,"00",,,,,,,,[[,"(\\d{4,5})","$1",["1(?:0|9[246])","1(?:0|9(?:2[2-9]|[46]))"]],
[,"(\\d{6})","$1",["1(?:1|92)"]],[,"(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],[,"(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],[,"(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],[,"(\\d{4})(\\d{4})","$1 $2",["894"]],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]"]],[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],[,
"(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],[[,"(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],[,"(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],[,"(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],[,"(\\d{4})(\\d{4})","$1 $2",["894"]],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],[,"(\\d{3})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["1(?:44|[679])|[378]"]],[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],[,"(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],[,,,,,,,,,[-1]],1,,[,,"848\\d{6}",,,,,,,[9]],[,,,,,,,,,[-1]],,,[,,"3[2-8]\\d{9,10}",,,,"33101234501",,,[11,12]]],JE:[,[,,"1534\\d{6}|(?:[3578]\\d|90)\\d{8}",,,,,,,[10],[6]],[,,"1534[0-24-8]\\d{5}",,,,"1534456789",,,,[6]],[,,"7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}",
,,,"7797712345"],[,,"80(?:07(?:35|81)|8901)\\d{4}",,,,"8007354567"],[,,"(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",,,,"9018105678"],[,,,,,,,,,[-1]],[,,"701511\\d{4}",,,,"7015115678"],[,,"56\\d{8}",,,,"5612345678"],"JE",44,"00","0",,,"([0-24-8]\\d{5})$|0","1534$1",,,,,[,,"76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",,,,"7640123456"],,,[,,,,,,,,,[-1]],[,,"(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
,,,"5512345678"],,,[,,,,,,,,,[-1]]],JM:[,[,,"(?:[58]\\d\\d|658|900)\\d{7}",,,,,,,[10],[7]],[,,"8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}",,,,"8765230123",,,,[7]],[,,"(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
,,,"8762101234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"JM",1,"011","1",,,"1",,,,,,[,,,,,,,,,[-1]],,"658|876",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,
,,,,[-1]]],JO:[,[,,"(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",,,,,,,[8,9]],[,,"87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
,,,"62001234",,,[8]],[,,"7(?:[78][0-25-9]|9\\d)\\d{6}",,,,"790123456",,,[9]],[,,"80\\d{6}",,,,"80012345",,,[8]],[,,"9\\d{7}",,,,"90012345",,,[8]],[,,"85\\d{6}",,,,"85012345",,,[8]],[,,"70\\d{7}",,,,"700123456",,,[9]],[,,,,,,,,,[-1]],"JO",962,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],[,"(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],,[,,"74(?:66|77)\\d{5}",,,,"746612345",
,,[9]],,,[,,,,,,,,,[-1]],[,,"8(?:10|8\\d)\\d{5}",,,,"88101234",,,[8]],,,[,,,,,,,,,[-1]]],JP:[,[,,"00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",,,,,,,[8,9,10,11,12,13,14,15,16,17]],[,,"(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",,,,"312345678",,,[9]],[,,"[7-9]0[1-9]\\d{7}",
,,,"9012345678",,,[10]],[,,"00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}",,,,"120123456"],[,,"990\\d{6}",,,,"990123456",,,[9]],[,,,,,,,,,[-1]],[,,"60\\d{7}",,,,"601234567",,,[9]],[,,"50[1-9]\\d{7}",,,,"5012345678",,,[10]],"JP",81,"010","0",,,"(000[259]\\d{6})$|(?:(?:003768)0?)|0","$1",,,[[,"(\\d{4})(\\d{4})","$1-$2",["007","0077","00777","00777[01]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],[,"(\\d{4})(\\d)(\\d{4})",
"$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],
"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],
"0$1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],[,"(\\d{4})(\\d{2})(\\d{3,4})","$1-$2-$3",["007","0077"]],[,"(\\d{4})(\\d{2})(\\d{4})","$1-$2-$3",["008"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{4})(\\d{4,5})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{5})(\\d{5,6})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{6})(\\d{6,7})","$1-$2-$3",
["0"]]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],[,"(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],
"0$1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],[,,"20\\d{8}",,,,"2012345678",,,[10]],,,[,,"00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"],[,,"570\\d{6}",,,,"570123456",,,[9]],,,[,,,,,,,,,[-1]]],KE:[,[,,"(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",,,,,,,[7,8,9,10]],[,,"(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
,,,"202012345",,,[7,8,9]],[,,"(?:1(?:0[0-6]|1[0-5]|2[014]|30)|7\\d\\d)\\d{6}",,,,"712123456",,,[9]],[,,"800[2-8]\\d{5,6}",,,,"800223456",,,[9,10]],[,,"900[02-9]\\d{5}",,,,"900223456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KE",254,"000","0",,,"0",,,,[[,"(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KG:[,[,,"8\\d{9}|[235-9]\\d{8}",
,,,,,,[9,10],[5,6]],[,,"312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",,,,"312123456",,,[9],[5,6]],[,,"312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",,,,"700123456",,,[9]],[,,"800\\d{6,7}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KG",996,"00","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],[,"(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KH:[,[,,"1\\d{9}|[1-9]\\d{7,8}",,,,,,,[8,9,10],[6,7]],[,,"23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
,,,"23756789",,,[8,9],[6,7]],[,,"(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",,,,"91234567",,,[8,9]],[,,"1800(?:1\\d|2[019])\\d{4}",,,,"1800123456",,,[10]],[,,"1900(?:1\\d|2[09])\\d{4}",,,,"1900123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KH",855,"00[14-9]","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],
,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KI:[,[,,"(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",,,,,,,[5,8]],[,,"(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}",,,,"31234"],[,,"(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
,,,"72001234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"30(?:0[01]\\d\\d|12(?:11|20))\\d\\d",,,,"30010000",,,[8]],"KI",686,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KM:[,[,,"[3478]\\d{6}",,,,,,,[7],[4]],[,,"7[4-7]\\d{5}",,,,"7712345",,,,[4]],[,,"[34]\\d{6}",,,,"3212345"],[,,,,,,,,,[-1]],[,,"8\\d{6}",,,,"8001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KM",269,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",
["[3478]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KN:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}",,,,"8692361234",,,,[7]],[,,"869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}",,,,"8697652917",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"KN",1,"011","1",,,"([2-7]\\d{6})$|1","869$1",,,,,[,,,,,,,,,[-1]],,"869",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KP:[,[,,"85\\d{6}|(?:19\\d|[2-7])\\d{7}",,,,,,,[8,10],[6,7]],[,,"(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}",,,,"21234567",,,,[6,7]],[,,"19[1-3]\\d{7}",,,,"1921234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KP",850,"00|99","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],
"0$1"],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KR:[,[,,"00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",,,,,,,[5,6,8,9,10,11,12,13,14],[3,4,7]],[,,"(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",,,,"22123456",,,[5,6,8,9,10],
[3,4,7]],[,,"1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",,,,"1020000000",,,[9,10]],[,,"00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}",,,,"801234567",,,[9,11,12,13,14]],[,,"60[2-9]\\d{6}",,,,"602345678",,,[9]],[,,,,,,,,,[-1]],[,,"50\\d{8,9}",,,,"5012345678",,,[10,11]],[,,"70\\d{8}",,,,"7012345678",,,[10]],"KR",82,"00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","0",,,"0(8(?:[1-46-8]|5\\d\\d))?",,,,[[,"(\\d{5})","$1",["1[016-9]1","1[016-9]11","1[016-9]114"],
"0$1"],[,"(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1","0$CC-$1"],[,"(\\d{4})(\\d{4})","$1-$2",["1"]],[,"(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1","0$CC-$1"],[,"(\\d{5})(\\d{3})(\\d{3})","$1 $2 $3",["003","0030"]],[,"(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1",
"0$CC-$1"],[,"(\\d{5})(\\d{3,4})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{5})(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["0"]]],[[,"(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1","0$CC-$1"],[,"(\\d{4})(\\d{4})","$1-$2",["1"]],[,"(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1","0$CC-$1"],
[,"(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1","0$CC-$1"]],[,,"15\\d{7,8}",,,,"1523456789",,,[9,10]],,,[,,"00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})",,,,,,,[11,12,13,14]],[,,"1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[168]|88)|8(?:00|33|55|77|99))\\d{4}",,,,"15441234",,,[8]],,,[,,,,,,,,,[-1]]],KW:[,[,,"18\\d{5}|(?:[2569]\\d|41)\\d{6}",,,,,,,[7,8]],[,,"2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",,,,"22345678",,,[8]],[,,"(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
,,,"50012345",,,[8]],[,,"18\\d{5}",,,,"1801234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KW",965,"00",,,,,,,,[[,"(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],[,"(\\d{3})(\\d{5})","$1 $2",["[245]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KY:[,[,,"(?:345|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}",,,,"3452221234",
,,,[7]],[,,"345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}",,,,"3453231234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"(?:345976|900[2-9]\\d\\d)\\d{4}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"KY",1,"011","1",,,"([2-9]\\d{6})$|1","345$1",,,,,[,,"345849\\d{4}",,,,"3458491234"],,"345",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KZ:[,[,,"(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",,,,,,,[10,14],[5,6,7]],[,,"(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
,,,"7123456789",,,[10],[5,6,7]],[,,"7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",,,,"7710009998",,,[10]],[,,"8(?:00|108\\d{3})\\d{7}",,,,"8001234567"],[,,"809\\d{7}",,,,"8091234567",,,[10]],[,,,,,,,,,[-1]],[,,"808\\d{7}",,,,"8081234567",,,[10]],[,,"751\\d{7}",,,,"7511234567",,,[10]],"KZ",7,"810","8",,,"8",,"8~10",,,,[,,,,,,,,,[-1]],,"33|7",[,,"751\\d{7}",,,,,,,[10]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LA:[,[,,"[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",,,,,,,[8,9,10],[6]],[,,"(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
,,,"21212862",,,[8],[6]],[,,"(?:20(?:[2359]\\d|7[6-8]|88)|302\\d)\\d{6}",,,,"2023123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LA",856,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"30[013-9]\\d{6}",,,,"301234567",,,[9]],,,[,,,,,,
,,,[-1]]],LB:[,[,,"[27-9]\\d{7}|[13-9]\\d{6}",,,,,,,[7,8]],[,,"7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}",,,,"1123456"],[,,"793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}",,,,"71123456"],[,,,,,,,,,[-1]],[,,"9[01]\\d{6}",,,,"90123456",,,[8]],[,,"80\\d{6}",,,,"80123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LB",961,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LC:[,[,,"(?:[58]\\d\\d|758|900)\\d{7}",,,,,,,[10],[7]],[,,"758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}",,,,"7584305678",,,,[7]],[,,"758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}",,,,"7582845678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],
[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"LC",1,"011","1",,,"([2-8]\\d{6})$|1","758$1",,,,,[,,,,,,,,,[-1]],,"758",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LI:[,[,,"[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",,,,,,,[7,9]],[,,"(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
,,,"2345678",,,[7]],[,,"(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}",,,,"660234567"],[,,"8002[28]\\d\\d|80(?:05\\d|9)\\d{4}",,,,"8002222"],[,,"90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",,,,"9002222",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LI",423,"00","0",,,"(1001)|0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],[,"(\\d{2})(\\d{3})(\\d{4})",
"$1 $2 $3",["69"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"870(?:28|87)\\d\\d",,,,"8702812",,,[7]],,,[,,"697(?:42|56|[78]\\d)\\d{4}",,,,"697861234",,,[9]]],LK:[,[,,"[1-9]\\d{8}",,,,,,,[9],[7]],[,,"(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",,,,"112345678",,,,[7]],[,,"7(?:[0-25-8]\\d|4[0-4])\\d{6}",,,,"712345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],[,,,,,,,,,[-1]],"LK",94,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"1973\\d{5}",,,,"197312345"],,,[,,,,,,,,,[-1]]],LR:[,[,,"(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",,,,,,,[7,8,9]],[,,"2\\d{7}",,,,"21234567",,,[8]],[,,"(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}",,,,"770123456",,,[7,9]],[,,,,,,,,,[-1]],[,,"332(?:02|[34]\\d)\\d{4}",,,,"332021234",
,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LR",231,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23578]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LS:[,[,,"(?:[256]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"2\\d{7}",,,,"22123456"],[,,"[56]\\d{7}",,,,"50123456"],[,,"800[256]\\d{4}",,,,"80021234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,
,,[-1]],[,,,,,,,,,[-1]],"LS",266,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2568]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LT:[,[,,"(?:[3469]\\d|52|[78]0)\\d{6}",,,,,,,[8]],[,,"(?:3[1478]|4[124-6]|52)\\d{6}",,,,"31234567"],[,,"6\\d{7}",,,,"61234567"],[,,"80[02]\\d{5}",,,,"80012345"],[,,"9(?:0[0239]|10)\\d{5}",,,,"90012345"],[,,"808\\d{5}",,,,"80812345"],[,,"70[05]\\d{5}",,,,"70012345"],[,,"[89]01\\d{5}",,,,"80123456"],"LT",370,"00","8",,,"[08]",,,,[[,"(\\d)(\\d{3})(\\d{4})",
"$1 $2 $3",["52[0-7]"],"(8-$1)",,1],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",,1],[,"(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",,1],[,"(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",,1]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"70[67]\\d{5}",,,,"70712345"],,,[,,,,,,,,,[-1]]],LU:[,[,,"35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",,,,,,,[4,5,6,7,8,9,10,11]],[,,"(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
,,,"27123456"],[,,"6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",,,,"628123456",,,[9]],[,,"800\\d{5}",,,,"80012345",,,[8]],[,,"90[015]\\d{5}",,,,"90012345",,,[8]],[,,"801\\d{5}",,,,"80112345",,,[8]],[,,,,,,,,,[-1]],[,,"20(?:1\\d{5}|[2-689]\\d{1,7})",,,,"20201234",,,[4,5,6,7,8,9,10]],"LU",352,"00",,,,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",,,,[[,"(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"],,"$CC $1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",
["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LV:[,[,,"(?:[268]\\d|90)\\d{6}",,,,,,,[8]],[,,"6\\d{7}",,,,"63123456"],[,,"23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}",,,,"21234567"],[,,"80\\d{6}",,,,"80123456"],[,,"90\\d{6}",,,,"90123456"],[,,"81\\d{6}",,,,"81123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LV",371,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",
["[269]|8[01]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LY:[,[,,"[2-9]\\d{8}",,,,,,,[9],[7]],[,,"(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",,,,"212345678",,,,[7]],[,,"9[1-6]\\d{7}",,,,"912345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LY",218,"00","0",
,,"0",,,,[[,"(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MA:[,[,,"[5-8]\\d{8}",,,,,,,[9]],[,,"5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}",,,,"520123456"],[,,"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}",,,,"650123456"],[,,"80[0-7]\\d{6}",,,,"801234567"],[,,"89\\d{7}",,,,"891234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
,,,"592401234"],"MA",212,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],[,"(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"],"0$1"],[,"(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],[,"(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],,[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MC:[,[,,"(?:[3489]|6\\d)\\d{7}",,,,,,,[8,9]],[,,"(?:870|9[2-47-9]\\d)\\d{5}",,,,"99123456",,,[8]],[,,
"4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}",,,,"612345678"],[,,"(?:800|90\\d)\\d{5}",,,,"90123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MC",377,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["87"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[389]"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"8[07]0\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MD:[,[,,"(?:[235-7]\\d|[89]0)\\d{6}",,,,,,,[8]],[,,"(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}",,,,"22212345"],[,,"562\\d{5}|(?:6\\d|7[16-9])\\d{6}",,,,"62112345"],[,,"800\\d{5}",,,,"80012345"],[,,"90[056]\\d{5}",,,,"90012345"],[,,"808\\d{5}",,,,"80812345"],[,,,,,,,,,[-1]],[,,"3[08]\\d{6}",,,,"30123456"],"MD",373,"00",
"0",,,"0",,,,[[,"(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"803\\d{5}",,,,"80312345"],,,[,,,,,,,,,[-1]]],ME:[,[,,"(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",,,,,,,[8,9],[6]],[,,"(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",,,,"30234567",,,[8],[6]],[,,"6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",,,,"67622901",,,[8]],
[,,"80(?:[0-2578]|9\\d)\\d{5}",,,,"80080002"],[,,"9(?:4[1568]|5[178])\\d{5}",,,,"94515151",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"78[1-49]\\d{5}",,,,"78108780",,,[8]],"ME",382,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"77[1-9]\\d{5}",,,,"77273012",,,[8]],,,[,,,,,,,,,[-1]]],MF:[,[,,"590\\d{6}|(?:69|80|9\\d)\\d{7}",,,,,,,[9]],[,,"590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}",,,,"590271234"],[,,"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",
,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:(?:395|76[018])\\d|475[0-5])\\d{4}",,,,"976012345"],"MF",590,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MG:[,[,,"[23]\\d{8}",,,,,,,[9],[7]],[,,"2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}",,,,"202123456",,,,[7]],[,,"3[2-47-9]\\d{7}",,,,"321234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"22\\d{7}",
,,,"221234567"],"MG",261,"00","0",,,"([24-9]\\d{6})$|0","20$1",,,[[,"(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MH:[,[,,"329\\d{4}|(?:[256]\\d|45)\\d{5}",,,,,,,[7]],[,,"(?:247|45[78]|528|625)\\d{4}",,,,"2471234"],[,,"(?:(?:23|54)5|329|45[356])\\d{4}",,,,"2351234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"635\\d{4}",,,,"6351234"],"MH",692,"011","1",,,"1",,,,[[,"(\\d{3})(\\d{4})","$1-$2",
["[2-6]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MK:[,[,,"[2-578]\\d{7}",,,,,,,[8],[6,7]],[,,"(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}",,,,"22012345",,,,[6,7]],[,,"7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|6[01]|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",,,,"72345678"],
[,,"800\\d{5}",,,,"80012345"],[,,"5\\d{7}",,,,"50012345"],[,,"8(?:0[1-9]|[1-9]\\d)\\d{5}",,,,"80123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MK",389,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],[,"(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ML:[,[,,"[24-9]\\d{7}",,,,,,,[8]],[,,"2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",
,,,"20212345"],[,,"2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}",,,,"65012345"],[,,"80\\d{6}",,,,"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ML",223,"00",,,,,,,,[[,"(\\d{4})","$1",["67[057-9]|74[045]","67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]],[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]],[,,,,,,,,,[-1]],,,[,,"80\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MM:[,
[,,"1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",,,,,,,[6,7,8,9,10],[5]],[,,"(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:(?:3\\d|8[01459])\\d|4[67]0)))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
,,,"1234567",,,[6,7,8,9],[5]],[,,"(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",,,,"92123456",,,[7,8,9,10]],[,,"80080(?:0[1-9]|2\\d)\\d{3}",,,,"8008001234",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"1333\\d{4}|[12]468\\d{4}",,,,"13331234",,,[8]],"MM",95,"00","0",,,"0",,,,[[,"(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{3})",
"$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],[,"(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],[,"(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],,[,,,
,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MN:[,[,,"[12]\\d{7,9}|[5-9]\\d{7}",,,,,,,[8,9,10],[4,5,6]],[,,"[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}",,,,"53123456",,,,[4,5,6]],[,,"(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}",,,,"88123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}",,,,"75123456",
,,[8]],"MN",976,"001","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],[,"(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],[,"(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],[,"(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],[,"(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MO:[,[,,"0800\\d{3}|(?:28|[68]\\d)\\d{6}",,,,,,,[7,8]],[,,"(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
,,,"28212345",,,[8]],[,,"6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",,,,"66123456",,,[8]],[,,"0800\\d{3}",,,,"0800501",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MO",853,"00",,,,,,,,[[,"(\\d{4})(\\d{3})","$1 $2",["0"]],[,"(\\d{4})(\\d{4})","$1 $2",["[268]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MP:[,[,,"[58]\\d{9}|(?:67|90)0\\d{7}",,,,,,,[10],[7]],[,,"670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
,,,"6702345678",,,,[7]],[,,"670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",,,,"6702345678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"MP",1,"011","1",,,"([2-9]\\d{6})$|1","670$1",,1,,,[,,,,,,,,,[-1]],,"670",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MQ:[,[,,"596\\d{6}|(?:69|80|9\\d)\\d{7}",,,,,,,[9]],[,,"596(?:[03-7]\\d|10|2[7-9]|8[0-39]|9[04-9])\\d{4}",,,,"596301234"],[,,"69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}",,,,"696201234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:397[0-2]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}",,,,"976612345"],"MQ",596,
"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MR:[,[,,"(?:[2-4]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"(?:25[08]|35\\d|45[1-7])\\d{5}",,,,"35123456"],[,,"[2-4][0-46-9]\\d{6}",,,,"22123456"],[,,"800\\d{5}",,,,"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MR",222,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[2-48]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MS:[,[,,"(?:[58]\\d\\d|664|900)\\d{7}",,,,,,,[10],[7]],[,,"6644(?:1[0-3]|91)\\d{4}",,,,"6644912345",,,,[7]],[,,"664(?:3(?:49|9[1-6])|49[2-6])\\d{4}",,,,"6644923456",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"MS",1,"011","1",,,"([34]\\d{6})$|1","664$1",,,,,[,,,,,,,,,[-1]],,"664",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MT:[,[,,"3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}",,,,"21001234"],[,,"(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",,,,"96961234"],[,,"800(?:02|[3467]\\d)\\d{3}",,,,"80071234"],[,,"5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",,,,
"50037123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"3550\\d{4}",,,,"35501234"],"MT",356,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]],,[,,"7117\\d{4}",,,,"71171234"],,,[,,,,,,,,,[-1]],[,,"501\\d{5}",,,,"50112345"],,,[,,,,,,,,,[-1]]],MU:[,[,,"(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",,,,,,,[7,8,10]],[,,"(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",,,,"54480123",,,[7,8]],[,,"5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-3]|3[013]))\\d{5}",
,,,"52512345",,,[8]],[,,"802\\d{7}|80[0-2]\\d{4}",,,,"8001234",,,[7,10]],[,,"30\\d{5}",,,,"3012345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"3(?:20|9\\d)\\d{4}",,,,"3201234",,,[7]],"MU",230,"0(?:0|[24-7]0|3[03])",,,,,,"020",,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],[,"(\\d{4})(\\d{4})","$1 $2",["[57]"]],[,"(\\d{5})(\\d{5})","$1 $2",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MV:[,[,,"(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",,,,,,,[7,10]],[,,"(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
,,,"6701234",,,[7]],[,,"(?:46[46]|[79]\\d\\d)\\d{4}",,,,"7712345",,,[7]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MV",960,"0(?:0|19)",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1-$2",["[34679]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"4(?:0[01]|50)\\d{4}",,,,"4001234",,,[7]],,,[,,,,,,,,,[-1]]],MW:[,[,,"(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",,,,,,,[7,9]],[,,"(?:1[2-9]|2[12]\\d\\d)\\d{5}",
,,,"1234567"],[,,"111\\d{6}|(?:31|77|[89][89])\\d{7}",,,,"991234567",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MW",265,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MX:[,[,,"1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
,,,,,,[10,11],[7,8]],[,,"657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",,,,"2001234567",,,[10],[7,8]],
[,,"657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",
,,,"12221234567",,,,[7,8]],[,,"8(?:00|88)\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,"300\\d{7}",,,,"3001234567",,,[10]],[,,"500\\d{7}",,,,"5001234567",,,[10]],[,,,,,,,,,[-1]],"MX",52,"0[09]","01",,,"0(?:[12]|4[45])|1",,"00",,[[,"(\\d{5})","$1",["53"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],,,1],[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],,,1],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})",
"$2 $3 $4",["1"],,,1]],[[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],,,1],[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],,,1],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],,,1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MY:[,[,,"1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",,,,,,,[8,9,10],[6,7]],[,,"(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
,,,"323856789",,,[8,9],[6,7]],[,,"1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",,,,"123456789",,,[9,10]],[,,"1[378]00\\d{6}",,,,"1300123456",,,[10]],[,,"1600\\d{6}",,,,"1600123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
,,,"1546012345",,,[10]],"MY",60,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MZ:[,[,,"(?:2|8\\d)\\d{7}",,,,,,,[8,9]],[,,"2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",,,,"21123456",,,[8]],[,,"8[2-79]\\d{7}",,,,"821234567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MZ",258,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NA:[,[,,"[68]\\d{7,8}",
,,,,,,[8,9]],[,,"64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",,,,"61221234"],[,,"(?:60|8[1245])\\d{7}",,,,"811234567",,,[9]],[,,"80\\d{7}",,,,"800123456",,,[9]],[,,"8701\\d{5}",,,,"870123456",
,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"8(?:3\\d\\d|86)\\d{5}",,,,"88612345"],"NA",264,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NC:[,[,,"(?:050|[2-57-9]\\d\\d)\\d{3}",,,,,,,[6]],[,,"(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",,,,"201234"],[,
,"(?:5[0-4]|[79]\\d|8[0-79])\\d{4}",,,,"751234"],[,,"050\\d{3}",,,,"050012"],[,,"36\\d{4}",,,,"366711"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NC",687,"00",,,,,,,,[[,"(\\d{3})","$1",["5[6-8]"]],[,"(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]],[[,"(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NE:[,[,,"[027-9]\\d{7}",,,,,,,[8]],[,,"2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
,,,"20201234"],[,,"(?:23|7[047]|[89]\\d)\\d{6}",,,,"93123456"],[,,"08\\d{6}",,,,"08123456"],[,,"09\\d{6}",,,,"09123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NE",227,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[047]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NF:[,[,,"[13]\\d{5}",,,,,,,[6],[5]],[,,"(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}",,,,"106609",,,,[5]],[,,"(?:14|3[58])\\d{4}",
,,,"381234",,,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NF",672,"00",,,,"([0-258]\\d{4})$","3$1",,,[[,"(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],[,"(\\d)(\\d{5})","$1 $2",["[13]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NG:[,[,,"(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",,,,,,,[7,8,10,11,12,13,14],[5,6]],[,,"(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}",
,,,"18040123",,,[7,8],[5,6]],[,,"(?:702[0-24-9]|819[01])\\d{6}|(?:70[13-689]|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-356]))\\d{7}",,,,"8021234567",,,[10]],[,,"800\\d{7,11}",,,,"80017591759",,,[10,11,12,13,14]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NG",234,"009","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["[7-9]"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],[,"(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"700\\d{7,11}",,,,"7001234567",,,[10,11,12,13,14]],,,[,,,,,,,,,[-1]]],NI:[,[,,"(?:1800|[25-8]\\d{3})\\d{4}",,,,,,,[8]],[,,"2\\d{7}",,,,"21234567"],[,,"(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",,,,"81234567"],[,,"1800\\d{4}",,,,"18001234"],[,,,,,,,,,[-1]],[,,,,,,,,,
[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NI",505,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NL:[,[,,"(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",,,,,,,[5,6,7,8,9,10,11]],[,,"(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
,,,"101234567",,,[9]],[,,"(?:6[1-58]|970\\d)\\d{7}",,,,"612345678",,,[9,11]],[,,"800\\d{4,7}",,,,"8001234",,,[7,8,9,10]],[,,"90[069]\\d{4,7}",,,,"9061234",,,[7,8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:85|91)\\d{7}",,,,"851234567",,,[9]],"NL",31,"00","0",,,"0",,,,[[,"(\\d{4})","$1",["1[238]|[34]"]],[,"(\\d{2})(\\d{3,4})","$1 $2",["14"]],[,"(\\d{6})","$1",["1"]],[,"(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],[,"(\\d)(\\d{8})","$1 $2",["6"],"0$1"],[,
"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],[[,"(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],[,"(\\d)(\\d{8})","$1 $2",["6"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{5})",
"$1 $2 $3",["9"],"0$1"]],[,,"66\\d{7}",,,,"662345678",,,[9]],,,[,,"140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d",,,,,,,[5,6]],[,,"140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",,,,"14020",,,[5,6,9]],,,[,,,,,,,,,[-1]]],NO:[,[,,"(?:0|[2-9]\\d{3})\\d{4}",,,,,,,[5,8]],[,,"(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",,,,"21234567",,,[8]],[,,"(?:4[015-8]|9\\d)\\d{6}",
,,,"40612345",,,[8]],[,,"80[01]\\d{5}",,,,"80012345",,,[8]],[,,"82[09]\\d{5}",,,,"82012345",,,[8]],[,,"810(?:0[0-6]|[2-8]\\d)\\d{3}",,,,"81021234",,,[8]],[,,"880\\d{5}",,,,"88012345",,,[8]],[,,"85[0-5]\\d{5}",,,,"85012345",,,[8]],"NO",47,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]"]]],,[,,,,,,,,,[-1]],1,"[02-689]|7[0-8]",[,,,,,,,,,[-1]],[,,"(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",,,,"02000"],,,[,,"81[23]\\d{5}",,
,,"81212345",,,[8]]],NP:[,[,,"(?:1\\d|9)\\d{9}|[1-9]\\d{7}",,,,,,,[8,10,11],[6,7]],[,,"(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",,,,"14567890",,,[8],[6,7]],[,,"9(?:6[0-3]|7[024-6]|8[0-24-68])\\d{7}",,,,"9841234567",,,[10]],[,,"1(?:66001|800\\d\\d)\\d{5}",,,,"16600101234",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NP",977,"00","0",,,"0",,,,[[,"(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],[,"(\\d{2})(\\d{6})",
"$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],[,"(\\d{3})(\\d{7})","$1-$2",["9"]],[,"(\\d{4})(\\d{2})(\\d{5})","$1-$2-$3",["1"]]],[[,"(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],[,"(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],[,"(\\d{3})(\\d{7})","$1-$2",["9"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NR:[,[,,"(?:444|(?:55|8\\d)\\d|666)\\d{4}",,,,,,,[7]],[,,"444\\d{4}",,,,"4441234"],[,,"(?:55[3-9]|666|8\\d\\d)\\d{4}",,,,"5551234"],[,,,,,,
,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NR",674,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NU:[,[,,"(?:[4-7]|888\\d)\\d{3}",,,,,,,[4,7]],[,,"[47]\\d{3}",,,,"7012",,,[4]],[,,"(?:[56]|888[1-9])\\d{3}",,,,"8884012"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NU",683,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NZ:[,[,,"[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",,,,,,,[5,6,7,8,9,10]],[,,"24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",,,,"32345678",,,[8],[7]],[,,"2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",,,,"211234567",,,[8,9,10]],[,,"508\\d{6,7}|80\\d{6,8}",,,,"800123456",,,[8,9,10]],[,,"(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",,,,"900123456",,,[7,8,9,10]],[,,,,,,,,,[-1]],[,,"70\\d{7}",
,,,"701234567",,,[9]],[,,,,,,,,,[-1]],"NZ",64,"0(?:0|161)","0",,,"0",,"00",,[[,"(\\d{2})(\\d{3,8})","$1 $2",["8[1-79]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|8|90","50(?:[0367]|88)|8|90"],"0$1"],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[589]"],"0$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7"],"0$1"]],
,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}",,,,"83012378"],,,[,,,,,,,,,[-1]]],OM:[,[,,"(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",,,,,,,[7,8,9]],[,,"2[1-6]\\d{6}",,,,"23123456",,,[8]],[,,"1505\\d{4}|(?:7(?:[1289]\\d|6[89]|7[0-5])|9(?:0[1-9]|[1-9]\\d))\\d{5}",,,,"92123456",,,[8]],[,,"8007\\d{4,5}|(?:500|800[05])\\d{4}",,,,"80071234"],[,,"900\\d{5}",,,,"90012345",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"OM",968,"00",,,,,,,
,[[,"(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],[,"(\\d{2})(\\d{6})","$1 $2",["2"]],[,"(\\d{4})(\\d{4})","$1 $2",["[179]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PA:[,[,,"(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",,,,,,,[7,8,10,11]],[,,"(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
,,,"2001234",,,[7]],[,,"(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",,,,"61234567",,,[7,8]],[,,"800\\d{4,5}|(?:00800|800\\d)\\d{6}",,,,"8001234"],[,,"(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",,,,"8601234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PA",507,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],[,"(\\d{4})(\\d{4})","$1-$2",["[68]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PE:[,[,,"(?:[14-8]|9\\d)\\d{7}",
,,,,,,[8,9],[6,7]],[,,"(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",,,,"11234567",,,[8],[6,7]],[,,"9\\d{8}",,,,"912345678",,,[9]],[,,"800\\d{5}",,,,"80012345",,,[8]],[,,"805\\d{5}",,,,"80512345",,,[8]],[,,"801\\d{5}",,,,"80112345",,,[8]],[,,"80[24]\\d{5}",,,,"80212345",,,[8]],[,,,,,,,,,[-1]],"PE",51,"00|19(?:1[124]|77|90)00","0"," Anexo ",,"0",,"00",,[[,"(\\d{3})(\\d{5})","$1 $2",["80"],
"(0$1)"],[,"(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PF:[,[,,"4\\d{5}(?:\\d{2})?|8\\d{7,8}",,,,,,,[6,8,9]],[,,"4(?:0[4-689]|9[4-68])\\d{5}",,,,"40412345",,,[8]],[,,"8[7-9]\\d{6}",,,,"87123456",,,[8]],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"499\\d{5}",,,,"49901234",,,[8]],"PF",689,"00",
,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]],,[,,,,,,,,,[-1]],,,[,,"44\\d{4}",,,,,,,[6]],[,,"44\\d{4}",,,,"440123",,,[6]],,,[,,,,,,,,,[-1]]],PG:[,[,,"(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",,,,,,,[7,8]],[,,"(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",,,,"3123456",,,[7]],[,,"(?:7\\d|8[128])\\d{6}",,,,"70123456",,,[8]],[,,"180\\d{4}",,,
,"1801234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"2(?:0[0-57]|7[568])\\d{4}",,,,"2751234",,,[7]],"PG",675,"00|140[1-3]",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],[,"(\\d{4})(\\d{4})","$1 $2",["[78]"]]],,[,,"27[01]\\d{4}",,,,"2700123",,,[7]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PH:[,[,,"(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",,,,,,,[6,8,9,10,11,12,13],[4,5,7]],[,,"(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
,,,"232345678",,,[6,8,9,10],[4,5,7]],[,,"(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",,,,"9051234567",,,[10]],[,,"1800\\d{7,9}",,,,"180012345678",,,[11,12,13]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PH",63,"00","0",,,"0",,,,[[,"(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],[,"(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
"(0$1)"],[,"(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PK:[,[,,"122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
,,,,,,[8,9,10,11,12],[5,6,7]],[,,"(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",,,,"2123456789",,,[9,10],[5,6,7,8]],[,,"3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}",,,,"3012345678",,,[10]],[,,"800\\d{5}(?:\\d{3})?",,,,"80012345",,,[8,11]],[,,"900\\d{5}",,,,"90012345",,,[8]],[,,,,,,,,,[-1]],[,,"122\\d{6}",
,,,"122044444",,,[9]],[,,,,,,,,,[-1]],"PK",92,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],[,"(\\d{4})(\\d{5})","$1 $2",["1"]],[,"(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
"(0$1)"],[,"(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],[,"(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],[,"(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
,,,"21111825888",,,[11,12]],,,[,,,,,,,,,[-1]]],PL:[,[,,"(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",,,,,,,[6,7,8,9,10]],[,,"47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",,,,"123456789",,,[7,9]],[,,"21(?:1(?:[145]\\d|3[1-5])|2\\d\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",,,,"512345678",,,[9]],[,,"800\\d{6,7}",,,,"800123456",,,[9,10]],[,,"70[01346-8]\\d{6}",,,,"701234567",,,[9]],[,,"801\\d{6}",
,,,"801234567",,,[9]],[,,,,,,,,,[-1]],[,,"39\\d{7}",,,,"391234567",,,[9]],"PL",48,"00",,,,,,,,[[,"(\\d{5})","$1",["19"]],[,"(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],
[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]],,[,,"64\\d{4,7}",,,,"641234567",,,[6,7,8,9]],,,[,,,,,,,,,[-1]],[,,"804\\d{6}",,,,"804123456",,,[9]],,,[,,,,,,,,,[-1]]],PM:[,[,,"[45]\\d{5}|(?:708|80\\d)\\d{6}",,,,,,,[6,9]],[,,"(?:4[1-35-7]|5[01])\\d{4}",,,,"430123",,,[6]],[,,"(?:4[02-4]|5[056]|708[45][0-5])\\d{4}",,,,"551234"],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],"PM",508,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PR:[,[,,"(?:[589]\\d\\d|787)\\d{7}",,,,,,,[10],[7]],[,,"(?:787|939)[2-9]\\d{6}",,,,"7872345678",,,,[7]],[,,"(?:787|939)[2-9]\\d{6}",,,,"7872345678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",
,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"PR",1,"011","1",,,"1",,,1,,,[,,,,,,,,,[-1]],,"787|939",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PS:[,[,,"[2489]2\\d{6}|(?:1\\d|5)\\d{8}",,,,,,,[8,9,10],[7]],[,,"(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
,,,"22234567",,,[8],[7]],[,,"5[69]\\d{7}",,,,"599123456",,,[9]],[,,"1800\\d{6}",,,,"1800123456",,,[10]],[,,,,,,,,,[-1]],[,,"1700\\d{6}",,,,"1700123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PS",970,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PT:[,[,,"1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",,,,,,,[9]],
[,,"2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}",,,,"212345678"],[,,"6(?:[06]92(?:30|9\\d)|[35]92(?:3[03]|9\\d))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",,,,"912345678"],[,,"80[02]\\d{6}",,,,"800123456"],[,,"(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",,,,"760123456"],[,,"80(?:8\\d|9[1579])\\d{5}",,,,"808123456"],[,,"884[0-4689]\\d{5}",,,,"884123456"],[,,"30\\d{7}",,,,"301234567"],"PT",351,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",
["2[12]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]],,[,,"6222\\d{5}",,,,"622212345"],,,[,,,,,,,,,[-1]],[,,"70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}",,,,"707123456"],,,[,,"600\\d{6}|6[06]9233\\d{3}",,,,"600110000"]],PW:[,[,,"(?:[24-8]\\d\\d|345|900)\\d{4}",,,,,,,[7]],[,,"(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",,,,"2771234"],[,,"(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}",,,,"6201234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,
,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PW",680,"01[12]",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PY:[,[,,"59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",,,,,,,[6,7,8,9,10,11],[5]],[,,"(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
,,,"212345678",,,[7,8,9],[5,6]],[,,"9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}",,,,"961456789",,,[9]],[,,"9800\\d{5,7}",,,,"98000123456",,,[9,10,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"8700[0-4]\\d{4}",,,,"870012345",,,[9]],"PY",595,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],[,"(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],[,"(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],[,"(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-6])"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"[2-9]0\\d{4,7}",,,,"201234567",,,[6,7,8,9]],,,[,,,,,,,,,[-1]]],QA:[,[,,"800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",,,,,,,[7,8,9,11]],[,,"4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
,,,"44123456",,,[8]],[,,"[35-7]\\d{7}",,,,"33123456",,,[8]],[,,"800\\d{4}|(?:0080[01]|800)\\d{6}",,,,"8001234",,,[7,9,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"QA",974,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["2[16]|8"]],[,"(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]],,[,,"2[16]\\d{5}",,,,"2123456",,,[7]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RE:[,[,,"(?:26|[689]\\d)\\d{7}",,,,,,,[9]],[,,"26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}",,,,"262161234"],[,,"69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}",
,,,"692123456"],[,,"80\\d{7}",,,,"801234567"],[,,"89[1-37-9]\\d{6}",,,,"891123456"],[,,"8(?:1[019]|2[0156]|84|90)\\d{6}",,,,"810123456"],[,,,,,,,,,[-1]],[,,"9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}",,,,"939901234"],"RE",262,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],,[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RO:[,[,,"(?:[2378]\\d|62|90)\\d{7}|[23]\\d{5}",,,,,,,[6,9]],[,,"[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
,,,"211234567"],[,,"7020\\d{5}|(?:62\\d|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}",,,,"712034567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"90[0136]\\d{6}",,,,"900123456",,,[9]],[,,"801\\d{6}",,,,"801123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RO",40,"00","0"," int ",,"0",,,,[[,"(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],[,"(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",
["[236-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:37\\d|80[578])\\d{6}",,,,"372123456",,,[9]],,,[,,,,,,,,,[-1]]],RS:[,[,,"38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",,,,,,,[6,7,8,9,10,11,12],[4,5]],[,,"(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",,,,"10234567",,,[7,8,9,10,11,12],[4,5,6]],[,,"6(?:[0-689]|7\\d)\\d{6,7}",,,,"601234567",,,[8,9,10]],[,,"800\\d{3,9}",,,,"80012345"],
[,,"(?:78\\d|90[0169])\\d{3,7}",,,,"90012345",,,[6,7,8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RS",381,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],[,"(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"7[06]\\d{4,10}",,,,"700123456"],,,[,,,,,,,,,[-1]]],RU:[,[,,"8\\d{13}|[347-9]\\d{9}",,,,,,,[10,14],[7]],[,,"(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
,,,"3011234567",,,[10],[7]],[,,"9\\d{9}",,,,"9123456789",,,[10]],[,,"8(?:0[04]|108\\d{3})\\d{7}",,,,"8001234567"],[,,"80[39]\\d{7}",,,,"8091234567",,,[10]],[,,,,,,,,,[-1]],[,,"808\\d{7}",,,,"8081234567",,,[10]],[,,,,,,,,,[-1]],"RU",7,"810","8",,,"8",,"8~10",,[[,"(\\d{3})(\\d{2})(\\d{2})","$1-$2-$3",["[0-79]"]],[,"(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],
"8 ($1)",,1],[,"(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],
"8 ($1)",,1],[,"(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],[[,"(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",,1],[,"(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",,1],[,"(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],[,,,,,,,,,[-1]],1,"3[04-689]|[489]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RW:[,[,,"(?:06|[27]\\d\\d|[89]00)\\d{6}",,,,,,,[8,9]],[,,"(?:06|2[23568]\\d)\\d{6}",,,,"250123456"],[,,"7[237-9]\\d{7}",,,,"720123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,
,"900\\d{6}",,,,"900123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RW",250,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SA:[,[,,"92\\d{7}|(?:[15]|8\\d)\\d{8}",,,,,,,[9,10],[7]],[,,"1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",,,,"112345678",,,[9],[7]],[,,"579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
,,,"512345678",,,[9]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"925\\d{6}",,,,"925012345",,,[9]],[,,"920\\d{6}",,,,"920012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SA",966,"00","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["9"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"811\\d{7}",,,,"8110123456",
,,[10]],,,[,,,,,,,,,[-1]]],SB:[,[,,"(?:[1-6]|[7-9]\\d\\d)\\d{4}",,,,,,,[5,7]],[,,"(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",,,,"40123",,,[5]],[,,"48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",,,,"7421234"],[,,"1[38]\\d{3}",,,,"18123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[12]\\d{3}",,,,"51123",,,[5]],"SB",677,"0[01]",,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],,[,,,,,,,,,[-1]],,,
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SC:[,[,,"800\\d{4}|(?:[249]\\d|64)\\d{5}",,,,,,,[7]],[,,"4[2-46]\\d{5}",,,,"4217123"],[,,"2[125-8]\\d{5}",,,,"2510123"],[,,"800[08]\\d{3}",,,,"8000000"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"971\\d{4}|(?:64|95)\\d{5}",,,,"6412345"],"SC",248,"010|0[0-2]",,,,,,"00",,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SD:[,[,,"[19]\\d{8}",,,,,,,[9]],[,,"1(?:5\\d|8[35-7])\\d{6}",
,,,"153123456"],[,,"(?:1[0-2]|9[0-3569])\\d{7}",,,,"911231234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SD",249,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SE:[,[,,"(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",,,,,,,[6,7,8,9,10,12]],[,,"(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
,,,"8123456",,,[7,8,9]],[,,"7[02369]\\d{7}",,,,"701234567",,,[9]],[,,"20\\d{4,7}",,,,"20123456",,,[6,7,8,9]],[,,"649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}",,,,"9001234567",,,[7,8,9,10]],[,,"77[0-7]\\d{6}",,,,"771234567",,,[9]],[,,"75[1-8]\\d{6}",,,,"751234567",,,[9]],[,,,,,,,,,[-1]],"SE",46,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1"],[,"(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
"0$1"],[,"(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1"],[,"(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1"],[,"(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1"],[,"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})",
"$1-$2 $3 $4",["8"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1"]],[[,"(\\d{2})(\\d{2,3})(\\d{2})","$1 $2 $3",["20"]],[,"(\\d{3})(\\d{4})","$1 $2",["9(?:00|39|44|9)"]],[,"(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]],[,"(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["8"]],[,"(\\d{3})(\\d{2,3})(\\d{2})","$1 $2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]],[,"(\\d{3})(\\d{2,3})(\\d{3})","$1 $2 $3",["9(?:00|39|44)"]],[,"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["10|7"]],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["8"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["9"]],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]]],[,,"74[02-9]\\d{6}",,,,"740123456",,,[9]],,,[,,,,,,,,,[-1]],[,,"10[1-8]\\d{6}",,,,"102345678",,,[9]],,,[,,"(?:25[245]|67[3-68])\\d{9}",,,,"254123456789",,,[12]]],SG:[,[,,"(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",,,,,,,[8,10,11]],[,,"662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
,,,"61234567",,,[8]],[,,"8(?:08[013]|95[0-2])\\d{4}|(?:8(?:0[1-7]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}",,,,"81234567",,,[8]],[,,"(?:18|8)00\\d{7}",,,,"18001234567",,,[10,11]],[,,"1900\\d{7}",,,,"19001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:3[12]\\d|666)\\d{5}",,,,"31234567",,,[8]],"SG",65,"0[0-3]\\d",,,,,,,,[[,"(\\d{4,5})","$1",["1[013-9]|77","1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]],[,"(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-8]|[1-9])"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],[,
"(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],[[,"(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-8]|[1-9])"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],[,"(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"7000\\d{7}",,,,"70001234567",,,[11]],,,[,,,,,,,,,[-1]]],SH:[,[,,"(?:[256]\\d|8)\\d{3}",,,,,,,[4,5]],[,,"2(?:[0-57-9]\\d|6[4-9])\\d\\d",,,,"22158"],[,,"[56]\\d{4}",,,,"51234",
,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"262\\d\\d",,,,"26212",,,[5]],"SH",290,"00",,,,,,,,,,[,,,,,,,,,[-1]],1,"[256]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SI:[,[,,"[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",,,,,,,[5,6,7,8]],[,,"(?:[1-357][2-8]|4[24-8])\\d{6}",,,,"12345678",,,[8],[7]],[,,"65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",,,,"31234567",,,[8]],[,,"80\\d{4,6}",,,,"80123456",,,[6,7,8]],[,,"89[1-3]\\d{2,5}|90\\d{4,6}",,,,"90123456"],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",,,,"59012345",,,[8]],"SI",386,"00|10(?:22|66|88|99)","0",,,"0",,"00",,[[,"(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],[,"(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
SJ:[,[,,"0\\d{4}|(?:[489]\\d|79)\\d{6}",,,,,,,[5,8]],[,,"79\\d{6}",,,,"79123456",,,[8]],[,,"(?:4[015-8]|9\\d)\\d{6}",,,,"41234567",,,[8]],[,,"80[01]\\d{5}",,,,"80012345",,,[8]],[,,"82[09]\\d{5}",,,,"82012345",,,[8]],[,,"810(?:0[0-6]|[2-8]\\d)\\d{3}",,,,"81021234",,,[8]],[,,"880\\d{5}",,,,"88012345",,,[8]],[,,"85[0-5]\\d{5}",,,,"85012345",,,[8]],"SJ",47,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"79",[,,,,,,,,,[-1]],[,,"(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",,,,"02000"],,,[,,"81[23]\\d{5}",,,,"81212345",
,,[8]]],SK:[,[,,"[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",,,,,,,[6,7,9]],[,,"(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d",,,,"221234567"],[,,"909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",,,,"912123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"9(?:00|[78]\\d)\\d{6}",,,,"900123456",,,[9]],[,,"8[5-9]\\d{7}",,,,"850123456",,,[9]],[,,,,,,,,,[-1]],[,,"6(?:02|5[0-4]|9[0-6])\\d{6}",,,,"690123456",,,[9]],"SK",421,
"00","0",,,"0",,,,[[,"(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],[,"(\\d{4})(\\d{3})","$1 $2",["909","9090"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],[[,"(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1",
"[3-5][1-8]1[67]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],[,,"9090\\d{3}",,,,"9090123",,,[7]],,,[,,"9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}",,,,,,,[7,9]],[,,"96\\d{7}",,,,"961234567",,,[9]],,,[,,,,,,,,,[-1]]],SL:[,[,,"(?:[237-9]\\d|66)\\d{6}",,,,,,,[8],[6]],[,,"22[2-4][2-9]\\d{4}",,,,"22221234",,,,[6]],[,,"(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}",
,,,"25123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SL",232,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SM:[,[,,"(?:0549|[5-7]\\d)\\d{6}",,,,,,,[8,10],[6]],[,,"0549(?:8[0157-9]|9\\d)\\d{4}",,,,"0549886377",,,[10],[6]],[,,"6[16]\\d{6}",,,,"66661212",,,[8]],[,,,,,,,,,[-1]],[,,"7[178]\\d{6}",,,,"71123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[158]\\d{6}",
,,,"58001110",,,[8]],"SM",378,"00",,,,"([89]\\d{5})$","0549$1",,,[[,"(\\d{6})","$1",["[89]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],[,"(\\d{4})(\\d{6})","$1 $2",["0"]]],[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],[,"(\\d{4})(\\d{6})","$1 $2",["0"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SN:[,[,,"(?:[378]\\d|93)\\d{7}",,,,,,,[9]],[,,"3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",,,,"301012345"],[,,"7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}",
,,,"701234567"],[,,"800\\d{6}",,,,"800123456"],[,,"88[4689]\\d{6}",,,,"884123456"],[,,"81[02468]\\d{6}",,,,"810123456"],[,,,,,,,,,[-1]],[,,"(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}",,,,"933301234"],"SN",221,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SO:[,[,,"[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",,,,,,,[6,7,8,9]],[,,
"(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",,,,"4012345",,,[6,7]],[,,"(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",,,,"71123456",,,[7,8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SO",252,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{4})","$1 $2",["8[125]"]],[,"(\\d{6})","$1",["[134]"]],[,"(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],[,"(\\d)(\\d{7})","$1 $2",
["(?:2|90)4|[67]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[348]|64|79|90"]],[,"(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[0-35-9]|77|9[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SR:[,[,,"(?:[2-5]|68|[78]\\d)\\d{5}",,,,,,,[6,7]],[,,"(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}",,,,"211234"],[,,"(?:7[124-7]|8[124-9])\\d{5}",,,,"7412345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"56\\d{4}",,,,"561234",,,[6]],"SR",597,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})",
"$1-$2-$3",["56"]],[,"(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],[,"(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SS:[,[,,"[19]\\d{8}",,,,,,,[9]],[,,"1[89]\\d{7}",,,,"181234567"],[,,"(?:12|9[1257-9])\\d{7}",,,,"977123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SS",211,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,
,,,,,,[-1]]],ST:[,[,,"(?:22|9\\d)\\d{5}",,,,,,,[7]],[,,"22\\d{5}",,,,"2221234"],[,,"900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",,,,"9812345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ST",239,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[29]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SV:[,[,,"[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",,,,,,,[7,8,11]],[,,"2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
,,,"21234567",,,[8]],[,,"[67]\\d{7}",,,,"70123456",,,[8]],[,,"800\\d{4}(?:\\d{4})?",,,,"8001234",,,[7,11]],[,,"900\\d{4}(?:\\d{4})?",,,,"9001234",,,[7,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SV",503,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[89]"]],[,"(\\d{4})(\\d{4})","$1 $2",["[267]"]],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SX:[,[,,"7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"7215(?:4[2-8]|8[239]|9[056])\\d{4}",
,,,"7215425678",,,,[7]],[,,"7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}",,,,"7215205678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"SX",1,"011","1",,,"(5\\d{6})$|1",
"721$1",,,,,[,,,,,,,,,[-1]],,"721",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SY:[,[,,"[1-39]\\d{8}|[1-5]\\d{7}",,,,,,,[8,9],[6,7]],[,,"21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}",,,,"112345678",,,,[6,7]],[,,"9[1-689]\\d{7}",,,,"944567890",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SY",963,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],
"0$1",,1]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SZ:[,[,,"0800\\d{4}|(?:[237]\\d|900)\\d{6}",,,,,,,[8,9]],[,,"[23][2-5]\\d{6}",,,,"22171234",,,[8]],[,,"7[6-9]\\d{6}",,,,"76123456",,,[8]],[,,"0800\\d{4}",,,,"08001234",,,[8]],[,,"900\\d{6}",,,,"900012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"70\\d{6}",,,,"70012345",,,[8]],"SZ",268,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[0237]"]],[,"(\\d{5})(\\d{4})","$1 $2",["9"]]],,[,,,,,,,,,[-1]],,,[,,"0800\\d{4}",,,,,,,
[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TA:[,[,,"8\\d{3}",,,,,,,[4]],[,,"8\\d{3}",,,,"8999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TA",290,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"8",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TC:[,[,,"(?:[58]\\d\\d|649|900)\\d{7}",,,,,,,[10],[7]],[,,"649(?:266|712|9(?:4\\d|50))\\d{4}",,,,"6497121234",,,,[7]],[,,"649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",,,,"6492311234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,"649(?:71[01]|966)\\d{4}",,,,"6497101234",,,,[7]],"TC",1,"011","1",,,"([2-479]\\d{6})$|1","649$1",,,,,[,,,,,,,,,[-1]],,"649",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
TD:[,[,,"(?:22|[69]\\d|77)\\d{6}",,,,,,,[8]],[,,"22(?:[37-9]0|5[0-5]|6[89])\\d{4}",,,,"22501234"],[,,"(?:6[0235689]|77|9\\d)\\d{6}",,,,"63012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TD",235,"00|16",,,,,,"00",,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TG:[,[,,"[279]\\d{7}",,,,,,,[8]],[,,"2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",,,,"22212345"],[,,"(?:7[019]|9[0-36-9])\\d{6}",
,,,"90112345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TG",228,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TH:[,[,,"(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",,,,,,,[8,9,10,13]],[,,"(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",,,,"21234567",,,[8]],[,,"671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",,,,"812345678",,,[9]],[,,"(?:001800\\d|1800)\\d{6}",,,
,"1800123456",,,[10,13]],[,,"1900\\d{6}",,,,"1900123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"6[08]\\d{7}",,,,"601234567",,,[9]],"TH",66,"00[1-9]","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TJ:[,[,,"[0-57-9]\\d{8}",,,,,,,[9],[3,5,6,7]],[,,"(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
,,,"372123456",,,,[3,5,6,7]],[,,"(?:4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:0[0-57-9]|1[017]|2[02]|[34]0|5[05]|7[0178]|8[078]|9\\d)\\d{7}",,,,"917123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TJ",992,"810",,,,,,"8~10",,[[,"(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["44[02-479]|[34]7"]],[,"(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],,[,,,,,,,,,[-1]],,,
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TK:[,[,,"[2-47]\\d{3,6}",,,,,,,[4,5,6,7]],[,,"(?:2[2-4]|[34]\\d)\\d{2,5}",,,,"3101"],[,,"7[2-4]\\d{2,5}",,,,"7290"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TK",690,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TL:[,[,,"7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",,,,,,,[7,8]],[,,"(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",,,,"2112345",,,[7]],[,,"7[2-8]\\d{6}",,,,"77212345",,,[8]],[,,"80\\d{5}",
,,,"8012345",,,[7]],[,,"90\\d{5}",,,,"9012345",,,[7]],[,,,,,,,,,[-1]],[,,"70\\d{5}",,,,"7012345",,,[7]],[,,,,,,,,,[-1]],"TL",670,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],[,"(\\d{4})(\\d{4})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TM:[,[,,"[1-6]\\d{7}",,,,,,,[8]],[,,"(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",,,,"12345678"],[,,"6\\d{7}",,,,"66123456"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TM",993,"810","8",,,"8",,"8~10",,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],[,"(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],[,"(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TN:[,[,,"[2-57-9]\\d{7}",,,,,,,[8]],[,,"81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}",,,,"30010123"],[,,"3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
,,,"20123456"],[,,"8010\\d{4}",,,,"80101234"],[,,"88\\d{6}",,,,"88123456"],[,,"8[12]10\\d{4}",,,,"81101234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TN",216,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TO:[,[,,"(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",,,,,,,[5,7]],[,,"(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",,,,"20123",,,[5]],[,,"(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
,,,"7715123",,,[7]],[,,"0800\\d{3}",,,,"0800222",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"55[0-37-9]\\d{4}",,,,"5510123",,,[7]],"TO",676,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],[,"(\\d{4})(\\d{3})","$1 $2",["0"]],[,"(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TR:[,[,,"4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",,,,,,,[7,10,12,13]],[,,"(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
,,,"2123456789",,,[10]],[,,"561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",,,,"5012345678",,,[10]],[,,"8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",,,,"8001234567",,,[10,12,13]],[,,"(?:8[89]8|900)\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,"592(?:21[12]|461)\\d{4}",,,,"5922121234",,,[10]],[,,"850\\d{7}",,,,"8500123456",,,[10]],"TR",90,"00","0",,,"0",,,,[[,"(\\d{3})(\\d)(\\d{3})","$1 $2 $3",["444"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",,1],
[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|61[06])","5(?:[0-59]|61[06]1)"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",,1],[,"(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",,1]],[[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|61[06])","5(?:[0-59]|61[06]1)"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["[24][1-8]|3[1-9]"],"(0$1)",,1],[,"(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",,1]],[,,"512\\d{7}",,,,"5123456789",,,[10]],,,[,,"(?:444|811\\d{3})\\d{4}",,,,,,,[7,10]],[,,"444\\d{4}",,,,"4441444",,,[7]],,,[,,,,,,,,,[-1]]],TT:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",,,,"8682211234",,,,[7]],[,,"868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
,,,"8682911234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"TT",1,"011","1",,,"([2-46-8]\\d{6})$|1","868$1",,,,,[,,,,,,,,,[-1]],,"868",[,,,,,,,,,[-1]],[,,
,,,,,,,[-1]],,,[,,"868619\\d{4}",,,,"8686191234",,,,[7]]],TV:[,[,,"(?:2|7\\d\\d|90)\\d{4}",,,,,,,[5,6,7]],[,,"2[02-9]\\d{3}",,,,"20123",,,[5]],[,,"(?:7[01]\\d|90)\\d{4}",,,,"901234",,,[6,7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TV",688,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1 $2",["2"]],[,"(\\d{2})(\\d{4})","$1 $2",["90"]],[,"(\\d{2})(\\d{5})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TW:[,[,,"[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
,,,,,,[7,8,9,10,11]],[,,"(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
,,,"221234567",,,[8,9]],[,,"(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",,,,"912345678",,,[9]],[,,"80[0-79]\\d{6}|800\\d{5}",,,,"800123456",,,[8,9]],[,,"20(?:[013-9]\\d\\d|2)\\d{4}",,,,"203123456",,,[7,9]],[,,,,,,,,,[-1]],[,,"99\\d{7}",,,,"990123456",,,[9]],[,,"7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",,,,"7012345678",,,[10,11]],"TW",886,"0(?:0[25-79]|19)","0","#",,"0",,,,[[,"(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],[,"(\\d)(\\d{3,4})(\\d{4})",
"$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"50[0-46-9]\\d{6}",,,,"500123456",,,[9]],,,[,,,,,,,,,[-1]]],TZ:[,[,,"(?:[25-8]\\d|41|90)\\d{7}",,,,,,,[9]],[,,"2[2-8]\\d{7}",,,,"222345678"],[,,"77[2-9]\\d{6}|(?:6[125-9]|7[13-689])\\d{7}",,,,"621234567"],[,,"80[08]\\d{6}",,,,"800123456"],[,,"90\\d{7}",
,,,"900123456"],[,,"8(?:40|6[01])\\d{6}",,,,"840123456"],[,,,,,,,,,[-1]],[,,"41\\d{7}",,,,"412345678"],"TZ",255,"00[056]","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["5"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"(?:8(?:[04]0|6[01])|90\\d)\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UA:[,[,,"[89]\\d{9}|[3-9]\\d{8}",,,,,,,[9,10],[5,6,7]],[,,"(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
,,,"311234567",,,[9],[5,6,7]],[,,"(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}",,,,"501234567",,,[9]],[,,"800[1-8]\\d{5,6}",,,,"800123456"],[,,"900[239]\\d{5,6}",,,,"900212345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"89[1-579]\\d{6}",,,,"891234567",,,[9]],"UA",380,"00","0",,,"0",,"0~0",,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],[,"(\\d{4})(\\d{5})","$1 $2",
["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UG:[,[,,"800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",,,,,,,[9],[5,6,7]],[,,"20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
,,,"312345678",,,,[5,6,7]],[,,"726[01]\\d{5}|7(?:[015-8]\\d|20|36|4[0-4]|9[89])\\d{6}",,,,"712345678"],[,,"800[1-3]\\d{5}",,,,"800123456"],[,,"90[1-3]\\d{6}",,,,"901123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UG",256,"00[057]","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],US:[,[,,"[2-9]\\d{9}|3\\d{6}",
,,,,,,[10],[7]],[,,"(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
,,,"2015550123",,,,[7]],[,,"(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
,,,"2015550123",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"US",1,"011","1",,,"1",,,1,[[,"(\\d{3})(\\d{4})","$1-$2",["310"],,,1],[,"(\\d{3})(\\d{4})","$1-$2",
["[24-9]|3(?:[02-9]|1[1-9])"]],[,"(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],,,1]],[[,"(\\d{3})(\\d{4})","$1-$2",["310"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[2-9]"]]],[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UY:[,[,,"0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",,,,,,,[6,7,8,9,10,11,12,13]],[,,"(?:1(?:770|9(?:20|87))|(?:2\\d|4[2-7])\\d\\d)\\d{4}",,,,"21231234",,,[8],[7]],[,,"9[1-9]\\d{6}",,,,"94231234",,,[8]],[,,"0004\\d{2,9}|(?:405|80[05])\\d{4}",,
,,"8001234"],[,,"90[0-8]\\d{4}",,,,"9001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UY",598,"0(?:0|1[3-9]\\d)","0"," int. ",,"0",,"00",,[[,"(\\d{3})(\\d{3,4})","$1 $2",["0"]],[,"(\\d{3})(\\d{4})","$1 $2",["[49]0|8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{4})","$1 $2",["[124]"]],[,"(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3 $4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,
,,,,,[-1]]],UZ:[,[,,"(?:20|33|[5-79]\\d|88)\\d{7}",,,,,,,[9]],[,,"(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}",,,,"669050123"],[,,"(?:(?:[25]0|33|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
,,,"912345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UZ",998,"810","8",,,"8",,"8~10",,[[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-9]"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VA:[,[,,"0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",,,,,,,[6,7,8,9,10,11,12]],[,,"06698\\d{1,6}",,,,"0669812345",,,[6,7,8,9,10,11]],[,,"3[1-9]\\d{8}|3[2-9]\\d{7}",,,,"3123456789",,,[9,10]],[,,"80(?:0\\d{3}|3)\\d{3}",
,,,"800123456",,,[6,9]],[,,"(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",,,,"899123456",,,[6,8,9,10]],[,,"84(?:[08]\\d{3}|[17])\\d{3}",,,,"848123456",,,[6,9]],[,,"1(?:78\\d|99)\\d{6}",,,,"1781234567",,,[9,10]],[,,"55\\d{8}",,,,"5512345678",,,[10]],"VA",39,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"06698",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"3[2-8]\\d{9,10}",,,,"33101234501",,,[11,12]]],VC:[,[,,"(?:[58]\\d\\d|784|900)\\d{7}",,,,,,,[10],[7]],
[,,"784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}",,,,"7842661234",,,,[7]],[,,"784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}",,,,"7844301234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,"78451[0-2]\\d{4}",,,,"7845101234",,,,[7]],"VC",1,"011","1",,,"([2-7]\\d{6})$|1","784$1",,,,,[,,,,,,,,,[-1]],,"784",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VE:[,[,,"[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",,,,,,,[10],[7]],[,,"(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}",,,,"2121234567",,,,[7]],[,,"4(?:1[24-8]|2[46])\\d{7}",,,,"4121234567"],[,,"800\\d{7}",,,,"8001234567"],[,,"90[01]\\d{7}",,,,"9001234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
"VE",58,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1","$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"501\\d{7}",,,,"5010123456",,,,[7]],,,[,,,,,,,,,[-1]]],VG:[,[,,"(?:284|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}",,,,"2842291234",,,,[7]],[,,"284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}",,,,"2843001234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",
,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"VG",1,"011","1",,,"([2-578]\\d{6})$|1","284$1",,,,,[,,,,,,,,,[-1]],,"284",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VI:[,[,,"[58]\\d{9}|(?:34|90)0\\d{7}",,,,,,,[10],[7]],[,,"340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
,,,"3406421234",,,,[7]],[,,"340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",,,,"3406421234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"VI",1,"011","1",,,"([2-9]\\d{6})$|1","340$1",,1,,,[,,,,,,,,,[-1]],,"340",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VN:[,[,,"[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",,,,,,,[7,8,9,10]],[,,"2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}",,,,"2101234567",,,[10]],[,,"(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",,,,"912345678",,,[9]],[,,"1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
,,,"1800123456",,,[8,9,10]],[,,"1900\\d{4,6}",,,,"1900123456",,,[8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"672\\d{6}",,,,"672012345",,,[9]],"VN",84,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[17]99"],"0$1",,1],[,"(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",,1],[,"(\\d{3})(\\d{4,5})","$1 $2",["69"],"0$1",,1],[,"(\\d{4})(\\d{4,6})","$1 $2",["1"],,,1],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["6"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[357-9]"],"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})",
"$1 $2 $3",["2[48]"],"0$1",,1],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",,1]],[[,"(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",,1],[,"(\\d{4})(\\d{4,6})","$1 $2",["1"],,,1],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["6"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[357-9]"],"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",,1],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",,1]],[,,,,,,,,,[-1]],,,[,,"[17]99\\d{4}|69\\d{5,6}",,,,,,,[7,8]],[,,"(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
,,,"1992000",,,[7,8]],,,[,,,,,,,,,[-1]]],VU:[,[,,"[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",,,,,,,[5,7]],[,,"(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",,,,"22123",,,[5]],[,,"(?:[58]\\d|7[013-7])\\d{5}",,,,"5912345",,,[7]],[,,"81[18]\\d\\d",,,,"81123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:0[1-9]|1[01])\\d{4}",,,,"9010123",,,[7]],"VU",678,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:3[03]|900\\d)\\d{3}",,,,"30123"],,
,[,,,,,,,,,[-1]]],WF:[,[,,"(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",,,,,,,[6,9]],[,,"72\\d{4}",,,,"721234",,,[6]],[,,"(?:72|8[23])\\d{4}",,,,"821234",,,[6]],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"WF",681,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"[48]0\\d{4}",,,,"401234",,,[6]]],WS:[,[,,"(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
,,,,,,[5,6,7,10]],[,,"6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",,,,"22123",,,[5,6]],[,,"(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",,,,"7212345",,,[7,10]],[,,"800\\d{3}",,,,"800123",,,[6]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"WS",685,"0",,,,,,,,[[,"(\\d{5})","$1",["[2-5]|6[1-9]"]],[,"(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],[,"(\\d{2})(\\d{5})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],XK:[,[,,"[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",,,,,,,[8,
9]],[,,"(?:2[89]|39)0\\d{6}|[23][89]\\d{6}",,,,"28012345"],[,,"4[3-9]\\d{6}",,,,"43201234",,,[8]],[,,"800\\d{5}",,,,"80001234",,,[8]],[,,"900\\d{5}",,,,"90001234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"XK",383,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],YE:[,[,,"(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
,,,,,,[7,8,9],[6]],[,,"78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",,,,"1234567",,,[7,8],[6]],[,,"7[01378]\\d{7}",,,,"712345678",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"YE",967,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7(?:[24-6]|8[0-7])"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],YT:[,[,,"(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
,,,,,,[9]],[,,"269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}",,,,"269601234"],[,,"639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}",,,,"639012345"],[,,"80\\d{7}",,,,"801234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:(?:39|47)8[01]|769\\d)\\d{4}",,,,"939801234"],"YT",262,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ZA:[,[,,"[1-79]\\d{8}|8\\d{4,9}",,,,,,,[5,6,7,8,9,10]],[,,"(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
,,,"101234567",,,[9]],[,,"(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",,,,"711234567",,,[5,6,7,8,9]],[,,"80\\d{7}",,,,"801234567",,,[9]],[,,"(?:86[2-9]|9[0-2]\\d)\\d{6}",,,,"862345678",,,[9]],[,,"860\\d{6}",,,,"860123456",,,[9]],[,,,,,,,,,[-1]],[,,"87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
,,,"871234567",,,[9]],"ZA",27,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"861\\d{6,7}",,,,"861123456",,,[9,10]],,,[,,,,,,,,,[-1]]],ZM:[,[,,"800\\d{6}|(?:21|63|[79]\\d)\\d{7}",,,,,,,[9],[6]],[,,"21[1-8]\\d{6}",,,,
"211234567",,,,[6]],[,,"(?:7[5-79]|9[5-8])\\d{7}",,,,"955123456"],[,,"800\\d{6}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"63\\d{7}",,,,"630123456"],"ZM",260,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[1-9]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,
,,,,,,,,[-1]]],ZW:[,[,,"2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",,,,,,,[5,6,7,8,9,10],[3,4]],[,,"(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
,,,"1312345",,,,[3,4]],[,,"7(?:[178]\\d|3[1-9])\\d{6}",,,,"712345678",,,[9]],[,,"80(?:[01]\\d|20|8[0-8])\\d{3}",,,,"8001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",,,,"8686123456",,,[10]],"ZW",263,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],[,"(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],
[,"(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],[,"(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],[,"(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],800:[,[,,"(?:00|[1-9]\\d)\\d{6}",,,,,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:00|[1-9]\\d)\\d{6}",,,,"12345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",800,,,,,,,,1,[[,"(\\d{4})(\\d{4})","$1 $2",["\\d"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]]],808:[,[,,"[1-9]\\d{7}",,,,,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[1-9]\\d{7}",,,,"12345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",808,,,,,,,,1,[[,"(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],870:[,[,,"7\\d{11}|[35-7]\\d{8}",,,,,,,[9,12]],[,,,,,,,,,[-1]],[,,"(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}",,,,"301234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,
,,,,,,[-1]],"001",870,,,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],878:[,[,,"10\\d{10}",,,,,,,[12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"10\\d{10}",,,,"101234567890"],"001",878,,,,,,,,1,[[,"(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],881:[,[,,"6\\d{9}|[0-36-9]\\d{8}",,,,,,,[9,10]],
[,,,,,,,,,[-1]],[,,"6\\d{9}|[0-36-9]\\d{8}",,,,"612345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",881,,,,,,,,,[[,"(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-37-9]"]],[,"(\\d)(\\d{3})(\\d{5,6})","$1 $2 $3",["6"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],882:[,[,,"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",,,,,,,[7,8,9,10,11,12]],[,,,,,,,,,[-1]],[,,"342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
,,,"3421234",,,[7,8,9,10,12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}",,,,"390123456789"],"001",882,,,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["16|342"]],[,"(\\d{2})(\\d{6})","$1 $2",["49"]],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1[36]|9"]],[,"(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],[,"(\\d{2})(\\d{3,4})(\\d{4})",
"$1 $2 $3",["16"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|23|3(?:[15]|4[57])|4|51"]],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],[,"(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-35]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"348[57]\\d{7}",,,,"34851234567",,,[11]]],883:[,[,,"(?:[1-4]\\d|51)\\d{6,10}",,,,,,,[8,9,10,11,12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
,,,"510012345"],"001",883,,,,,,,,1,[[,"(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3",["[14]|2[24-689]|3[02-689]|51[24-9]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["21"]],[,"(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[235]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],888:[,[,,"\\d{11}",,,,,,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,
,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",888,,,,,,,,1,[[,"(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"\\d{11}",,,,"12345678901"],,,[,,,,,,,,,[-1]]],979:[,[,,"[1359]\\d{8}",,,,,,,[9],[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[1359]\\d{8}",,,,"123456789",,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",979,,,,,,,,1,[[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]]};/*

 Copyright (C) 2010 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function J(){this.g={}}J.i=void 0;J.g=function(){return J.i?J.i:J.i=new J};
var va={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","\uff10":"0","\uff11":"1","\uff12":"2","\uff13":"3","\uff14":"4","\uff15":"5","\uff16":"6","\uff17":"7","\uff18":"8","\uff19":"9","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u06f0":"0","\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9"},wa={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",
7:"7",8:"8",9:"9","\uff10":"0","\uff11":"1","\uff12":"2","\uff13":"3","\uff14":"4","\uff15":"5","\uff16":"6","\uff17":"7","\uff18":"8","\uff19":"9","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u06f0":"0","\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9",A:"2",B:"2",C:"2",D:"3",E:"3",F:"3",G:"4",H:"4",I:"4",J:"5",K:"5",L:"5",M:"6",N:"6",O:"6",P:"7",
Q:"7",R:"7",S:"7",T:"8",U:"8",V:"8",W:"9",X:"9",Y:"9",Z:"9"},K=RegExp("^[+\uff0b]+"),xa=RegExp("([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9])"),ya=RegExp("[+\uff0b0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]"),za=/[\\\/] *x/,Aa=RegExp("[^0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9A-Za-z#]+$"),Ba=/(?:.*?[A-Za-z]){3}.*/,Ca=RegExp("^\\+([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]|[\\-\\.\\(\\)]?)*[0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]|[\\-\\.\\(\\)]?)*$"),
Da=RegExp("^([A-Za-z0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]+((\\-)*[A-Za-z0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9])*\\.)*[A-Za-z]+((\\-)*[A-Za-z0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9])*\\.?$");function L(a){return"([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,"+a+"})"}
function Ea(){return";ext="+L("20")+"|[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|\u0434\u043e\u0431|anexo)[:\\.\uff0e]?[ \u00a0\\t,-]*"+(L("20")+"#?|[ \u00a0\\t,]*(?:[x\uff58#\uff03~\uff5e]|int|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*")+(L("9")+"#?|[- ]+")+(L("6")+"#|[ \u00a0\\t]*(?:,{2}|;)[:\\.\uff0e]?[ \u00a0\\t,-]*")+(L("15")+"#?|[ \u00a0\\t]*(?:,)+[:\\.\uff0e]?[ \u00a0\\t,-]*")+(L("9")+"#?")}
var Fa=new RegExp("(?:"+Ea()+")$","i"),Ga=new RegExp("^[0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{2}$|^[+\uff0b]*(?:[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e*]*[0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]){3,}[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e*A-Za-z0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]*(?:"+Ea()+")?$","i"),Ha=/(\$\d)/;
function Ia(a){return 2>a.length?!1:M(Ga,a)}function Ja(a){return M(Ba,a)?N(a,wa):N(a,va)}function Ka(a){var b=Ja(a.toString());a.i="";a.g(b)}function La(a){return null!=a&&(1!=w(a,9)||-1!=t(a,9)[0])}function N(a,b){for(var c=new C,d,f=a.length,e=0;e<f;++e)d=a.charAt(e),d=b[d.toUpperCase()],null!=d&&c.g(d);return c.toString()}function O(a){return null!=a&&isNaN(a)&&a.toUpperCase()in ua}
function Ma(a,b,c){if(0==p(b,2)&&null!=b.g[5]){var d=v(b,5);if(0<d.length)return d}d=v(b,1);var f=P(b);if(0==c)return Na(d,0,f,"");if(!(d in I))return f;a=Q(a,d,R(d));b=null!=b.g[3]&&0!=p(b,3).length?3==c?";ext="+p(b,3):null!=a.g[13]?p(a,13)+v(b,3):" ext. "+v(b,3):"";a:{a=0==t(a,20).length||2==c?t(a,19):t(a,20);for(var e,g=a.length,h=0;h<g;++h){e=a[h];var l=w(e,3);if(0==l||0==f.search(p(e,3,l-1)))if(l=new RegExp(p(e,1)),M(l,f)){a=e;break a}}a=null}null!=a&&(g=a,a=v(g,2),e=new RegExp(p(g,1)),v(g,5),
g=v(g,4),f=2==c&&null!=g&&0<g.length?f.replace(e,a.replace(Ha,g)):f.replace(e,a),3==c&&(f=f.replace(RegExp("^[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e]+"),""),f=f.replace(RegExp("[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e]+","g"),"-")));return Na(d,c,f,b)}function Q(a,b,c){return"001"==c?S(a,""+b):S(a,c)}
function P(a){if(null==a.g[2])return"";var b=""+p(a,2);return null!=a.g[4]&&p(a,4)&&0<v(a,8)?Array(v(a,8)+1).join("0")+b:b}function Na(a,b,c,d){switch(b){case 0:return"+"+a+c+d;case 1:return"+"+a+" "+c+d;case 3:return"tel:+"+a+"-"+c+d;default:return c+d}}
function T(a,b){switch(b){case 4:return p(a,5);case 3:return p(a,4);case 1:return p(a,3);case 0:case 2:return p(a,2);case 5:return p(a,6);case 6:return p(a,8);case 7:return p(a,7);case 8:return p(a,21);case 9:return p(a,25);case 10:return p(a,28);default:return p(a,1)}}function U(a,b){return V(a,p(b,1))?V(a,p(b,5))?4:V(a,p(b,4))?3:V(a,p(b,6))?5:V(a,p(b,8))?6:V(a,p(b,7))?7:V(a,p(b,21))?8:V(a,p(b,25))?9:V(a,p(b,28))?10:V(a,p(b,2))?p(b,18)||V(a,p(b,3))?2:0:!p(b,18)&&V(a,p(b,3))?1:-1:-1}
function S(a,b){if(null==b)return null;b=b.toUpperCase();var c=a.g[b];if(null==c){c=ua[b];if(null==c)return null;c=(new B).g(F.j(),c);a.g[b]=c}return c}function V(a,b){var c=a.length;return 0<w(b,9)&&-1==t(b,9).indexOf(c)?!1:M(v(b,2),a)}
function Oa(a,b){if(null==b)return null;var c=v(b,1);c=I[c];if(null==c)a=null;else if(1==c.length)a=c[0];else a:{b=P(b);for(var d,f=c.length,e=0;e<f;e++){d=c[e];var g=S(a,d);if(null!=g.g[23]){if(0==b.search(p(g,23))){a=d;break a}}else if(-1!=U(b,g)){a=d;break a}}a=null}return a}function R(a){a=I[a];return null==a?"ZZ":a[0]}
function W(a,b,c,d){var f=T(c,d),e=0==w(f,9)?t(p(c,1),9):t(f,9);f=t(f,10);if(2==d)if(La(T(c,0)))a=T(c,1),La(a)&&(e=e.concat(0==w(a,9)?t(p(c,1),9):t(a,9)),e.sort(),0==f.length?f=t(a,10):(f=f.concat(t(a,10)),f.sort()));else return W(a,b,c,1);if(-1==e[0])return 5;b=b.length;if(-1<f.indexOf(b))return 4;c=e[0];return c==b?0:c>b?2:e[e.length-1]<b?3:-1<e.indexOf(b,1)?0:5}function X(a,b){var c=P(b);b=v(b,1);if(!(b in I))return 1;b=Q(a,b,R(b));return W(a,c,b,-1)}
function Pa(a,b,c,d,f,e){if(0==b.length)return 0;b=new C(b);var g;null!=c&&(g=p(c,11));null==g&&(g="NonMatch");var h=b.toString();if(0==h.length)g=20;else if(K.test(h))h=h.replace(K,""),b.i="",b.g(Ja(h)),g=1;else{h=new RegExp(g);Ka(b);g=b.toString();if(0==g.search(h)){h=g.match(h)[0].length;var l=g.substring(h).match(xa);l&&null!=l[1]&&0<l[1].length&&"0"==N(l[1],va)?g=!1:(b.i="",b.g(g.substring(h)),g=!0)}else g=!1;g=g?5:20}f&&q(e,6,g);if(20!=g){if(2>=b.i.length)throw Error("Phone number too short after IDD");
a:{a=b.toString();if(0!=a.length&&"0"!=a.charAt(0))for(f=a.length,b=1;3>=b&&b<=f;++b)if(c=parseInt(a.substring(0,b),10),c in I){d.g(a.substring(b));d=c;break a}d=0}if(0!=d)return q(e,1,d),d;throw Error("Invalid country calling code");}if(null!=c&&(g=v(c,10),h=""+g,l=b.toString(),0==l.lastIndexOf(h,0)&&(h=new C(l.substring(h.length)),l=p(c,1),l=new RegExp(v(l,2)),Qa(h,c,null),h=h.toString(),!M(l,b.toString())&&M(l,h)||3==W(a,b.toString(),c,-1))))return d.g(h),f&&q(e,6,10),q(e,1,g),g;q(e,1,0);return 0}
function Qa(a,b,c){var d=a.toString(),f=d.length,e=p(b,15);if(0!=f&&null!=e&&0!=e.length){var g=new RegExp("^(?:"+e+")");if(f=g.exec(d)){e=new RegExp(v(p(b,1),2));var h=M(e,d),l=f.length-1;b=p(b,16);if(null==b||0==b.length||null==f[l]||0==f[l].length){if(!h||M(e,d.substring(f[0].length)))null!=c&&0<l&&null!=f[l]&&c.g(f[1]),a.set(d.substring(f[0].length))}else if(d=d.replace(g,b),!h||M(e,d))null!=c&&0<l&&c.g(f[1]),a.set(d)}}}
function Z(a,b,c){if(!O(c)&&0<b.length&&"+"!=b.charAt(0))throw Error("Invalid country calling code");return Ra(a,b,c,!0)}
function Ra(a,b,c,d){if(null==b)throw Error("The string supplied did not seem to be a phone number");if(250<b.length)throw Error("The string supplied is too long to be a phone number");var f=new C;var e=b.indexOf(";phone-context=");if(-1===e)e=null;else if(e+=15,e>=b.length)e="";else{var g=b.indexOf(";",e);e=-1!==g?b.substring(e,g):b.substring(e)}var h=e;null==h?g=!0:0===h.length?g=!1:(g=Ca.exec(h),h=Da.exec(h),g=null!==g||null!==h);if(!g)throw Error("The string supplied did not seem to be a phone number");
null!=e?("+"===e.charAt(0)&&f.g(e),e=b.indexOf("tel:"),f.g(b.substring(0<=e?e+4:0,b.indexOf(";phone-context=")))):(e=f.g,g=b||"",h=g.search(ya),0<=h?(g=g.substring(h),g=g.replace(Aa,""),h=g.search(za),0<=h&&(g=g.substring(0,h))):g="",e.call(f,g));e=f.toString();g=e.indexOf(";isub=");0<g&&(f.i="",f.g(e.substring(0,g)));if(!Ia(f.toString()))throw Error("The string supplied did not seem to be a phone number");e=f.toString();if(!(O(c)||null!=e&&0<e.length&&K.test(e)))throw Error("Invalid country calling code");
e=new H;d&&q(e,5,b);a:{b=f.toString();g=b.search(Fa);if(0<=g&&Ia(b.substring(0,g))){h=b.match(Fa);for(var l=h.length,A=1;A<l;++A)if(null!=h[A]&&0<h[A].length){f.i="";f.g(b.substring(0,g));b=h[A];break a}}b=""}0<b.length&&q(e,3,b);g=S(a,c);b=new C;h=0;l=f.toString();try{h=Pa(a,l,g,b,d,e)}catch(G){if("Invalid country calling code"==G.message&&K.test(l)){if(l=l.replace(K,""),h=Pa(a,l,g,b,d,e),0==h)throw G;}else throw G;}0!=h?(f=R(h),f!=c&&(g=Q(a,h,f))):(Ka(f),b.g(f.toString()),null!=c?(h=v(g,10),q(e,
1,h)):d&&(delete e.g[6],e.i&&delete e.i[6]));if(2>b.i.length)throw Error("The string supplied is too short to be a phone number");null!=g&&(c=new C,f=new C(b.toString()),Qa(f,g,c),a=W(a,f.toString(),g,-1),2!=a&&4!=a&&5!=a&&(b=f,d&&0<c.toString().length&&q(e,7,c.toString())));d=b.toString();a=d.length;if(2>a)throw Error("The string supplied is too short to be a phone number");if(17<a)throw Error("The string supplied is too long to be a phone number");if(1<d.length&&"0"==d.charAt(0)){q(e,4,!0);for(a=
1;a<d.length-1&&"0"==d.charAt(a);)a++;1!=a&&q(e,8,a)}q(e,2,parseInt(d,10));return e}function M(a,b){return(a="string"==typeof a?b.match("^(?:"+a+")$"):b.match(a))&&a[0].length==b.length?!0:!1};k("intlTelInputUtils",{});k("intlTelInputUtils.formatNumber",function(a,b,c){try{var f=J.g(),e=Z(f,a,b);var d=X(f,e);return 0==d||4==d?Ma(f,e,"undefined"===typeof c?0:c):a}catch(f){return a}});k("intlTelInputUtils.getExampleNumber",function(a,b,c){try{var h=J.g();a:{var d=h;if(O(a)){var f=T(S(d,a),c);try{if(null!=f.g[6]){var e=p(f,6);var g=Ra(d,e,a,!1);break a}}catch(l){}}g=null}return Ma(h,g,b?2:1)}catch(h){return""}});k("intlTelInputUtils.getExtension",function(a,b){try{return p(Z(J.g(),a,b),3)}catch(c){return""}});
k("intlTelInputUtils.getNumberType",function(a,b){try{var h=J.g();var c=Z(h,a,b);a=h;var d=Oa(a,c),f=Q(a,v(c,1),d);if(null==f)var e=-1;else{var g=P(c);e=U(g,f)}return e}catch(h){return-99}});
k("intlTelInputUtils.getValidationError",function(a,b){try{var c=J.g(),d=Z(c,a,b);return X(c,d)}catch(c){return"Invalid country calling code"===c.message?1:"Phone number too short after IDD"===c.message||"The string supplied is too short to be a phone number"===c.message?2:"The string supplied is too long to be a phone number"===c.message?3:-99}});
k("intlTelInputUtils.isValidNumber",function(a,b){try{var Y=J.g();var c=Z(Y,a,b);a=Y;var d=Oa(a,c);var f=v(c,1),e=Q(a,f,d),g;if(!(g=null==e)){var h;if(h="001"!=d){var l=S(a,d);if(null==l)throw Error("Invalid region code: "+d);var A=v(l,10);h=f!=A}g=h}if(g)var G=!1;else{var Sa=P(c);G=-1!=U(Sa,e)}return G}catch(Y){return!1}});k("intlTelInputUtils.isPossibleNumber",function(a,b){try{var c=J.g(),d=Z(c,a,b);return 0===X(c,d)}catch(c){return!1}});
k("intlTelInputUtils.numberFormat",{E164:0,INTERNATIONAL:1,NATIONAL:2,RFC3966:3});k("intlTelInputUtils.numberType",{FIXED_LINE:0,MOBILE:1,FIXED_LINE_OR_MOBILE:2,TOLL_FREE:3,PREMIUM_RATE:4,SHARED_COST:5,VOIP:6,PERSONAL_NUMBER:7,PAGER:8,UAN:9,VOICEMAIL:10,UNKNOWN:-1});k("intlTelInputUtils.validationError",{IS_POSSIBLE:0,INVALID_COUNTRY_CODE:1,TOO_SHORT:2,TOO_LONG:3,IS_POSSIBLE_LOCAL_ONLY:4,INVALID_LENGTH:5});})();

(function() {
  'use strict';

  angular
    .module('website')
    .filter('phone', phone);

  /* @ngInject */
  function phone(env) {
    var filter = function(input) {
      var regex;
      var phone = ('' + input).replace(/[\s\uFEFF\xA0]+/g, '');
      if (phone.length == 12) regex = /(\+\d{3})(\d{4})(\d{4})/;
      if (phone.length == 13) regex = /(\+\d{2})(\d{2})(\d{4})(\d{4})/;
      var result = phone.match(regex);

      if (result && result.length == 4) return result[1] + ' ' + result[2] + ' ' + result[3];
      if (result && result.length == 5) return result[1] + ' ' + result[2] + ' ' + result[3] + ' ' + result[4];
      return '';
    };
    return filter;
  }
})();

// https://intl-tel-input.com/
(function() {
  'use strict';

  angular
  .module('website')
  .directive('phoneSelect', phoneSelect)
  .controller('PhoneSelectController', PhoneSelectController);

  /* @ngInject */
  function phoneSelect() {
    // Usage:
    //  <phone-select></phone-select>
    // Creates:
    //  adds a phone number select of all countries
    var directive = {
      bindToController: {
        number: '=',
        btnSubmitId: '@',
        model: '@',
        object: '@',
        formName: '@',
        invalidPhone: '@',
        disabled: '@'
      },
      controller: PhoneSelectController,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: 'app/components/phone/{mobile}{desktop}/phone-select.html'
    };
    return directive;
    function link(scope, element, attrs) {
    }
  }

  /* @ngInject */
  function PhoneSelectController (env, $scope, $rootScope) {
    var vm = this;
    vm.value = '';
    vm.selectedCountryPlaceholder = '';

    activate();

    function activate() {
      var input = document.querySelector('#phone');

      window.intlTelInput(input, {
        utilsScript: 'utils.js',
        separateDialCode: true,
        useFullscreenPopup: false,
        initialCountry: env.PHONE_INITIAL_COUNTRY,
        preferredCountries: env.PHONE_PREFERRED_COUNTRIES,
        customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
          vm.selectedCountryPlaceholder = selectedCountryPlaceholder;
          return 'ejemplo ' + selectedCountryPlaceholder;
        }
      });

      if (vm.disabled === 'true') {
        input.setAttribute('disabled', 'disabled');
      }

      addScrollBarClass();

      var iti = window.intlTelInputGlobals.getInstance(input);
      if (vm.number) iti.setNumber(vm.number);

      var button = document.querySelector('#' + vm.btnSubmitId);
      var phoneErrorMessage = document.querySelector('#phone-error-message');
      checkBtnSubmit(input, button, iti, phoneErrorMessage, true, false);

      input.addEventListener('input', function() {
        savePhone(iti.getNumber());
        checkBtnSubmit(input, button, iti, phoneErrorMessage, false, false);
      });

      input.addEventListener('blur', function() {
        checkBtnSubmit(input, button, iti, phoneErrorMessage, false, true);
      });

      input.addEventListener('countrychange', function() {
        savePhone(iti.getNumber());
        checkBtnSubmit(input, button, iti, phoneErrorMessage, false, false);
      });
    }

    function addScrollBarClass() {
      var countryList = document.querySelector('ul.iti__country-list');
      if (countryList) countryList.classList.add('scroll-bar');
    }

    function checkBtnSubmit(input, btn, instance, phoneErrorMessage, firstCarge, clickOut) {
      if ((firstCarge && input.value == '') ||
          (firstCarge && instance.isValidNumber())) {
        phoneErrorMessage.classList.add('hide');
        setTimeout(function() { btn.disabled = input.value == ''; }, '300');
        vm.invalidPhone = input.value == '';
        return input.value == '';
      }

      if (input.value.length == 1) {
        setTimeout(function() { phoneErrorMessage.classList.add('hide'); }, '100');
        btn.disabled = true;
        vm.invalidPhone = true;
        $scope[vm.formName][input.name].$setTouched(true);
        return true;
      }

      if (input.value == '' || !instance.isValidNumber()) {
        var formInput = $scope[vm.formName][input.name];
        if (formInput && clickOut && formInput.$touched) phoneErrorMessage.classList.remove('hide');
        btn.disabled = true;
        vm.invalidPhone = true;
        return true;
      }

      phoneErrorMessage.classList.add('hide');
      if ($scope[vm.formName].$valid) {
        btn.disabled = false;
        vm.invalidPhone = false;
        return false;
      }

      btn.disabled = true;
      vm.invalidPhone = true;
      return true;
    }

    function savePhone(fullNumber) {
      $scope[vm.object]['phones'] = [fullNumber];
      $scope[vm.formName]['phones-0'].$viewValue = [fullNumber];
      vm.value = [fullNumber];
    }
  }
})();

/*
 * International Telephone Input v18.3.3
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */

!function(a){"object"==typeof module&&module.exports?module.exports=a():window.intlTelInput=a()}(function(a){"use strict";return function(){function b(a){for(var b=1;b<arguments.length;b++){var d=null!=arguments[b]?Object(arguments[b]):{},e=Object.keys(d);"function"==typeof Object.getOwnPropertySymbols&&e.push.apply(e,Object.getOwnPropertySymbols(d).filter(function(a){return Object.getOwnPropertyDescriptor(d,a).enumerable})),e.forEach(function(b){c(a,b,d[b])})}return a}function c(a,b,c){return b=g(b),b in a?Object.defineProperty(a,b,{value:c,enumerable:!0,configurable:!0,writable:!0}):a[b]=c,a}function d(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function e(a,b){for(var c=0;c<b.length;c++){var d=b[c];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,g(d.key),d)}}function f(a,b,c){return b&&e(a.prototype,b),c&&e(a,c),Object.defineProperty(a,"prototype",{writable:!1}),a}function g(a){var b=h(a,"string");return"symbol"==typeof b?b:String(b)}function h(b,c){if("object"!=typeof b||null===b)return b;var d=b[Symbol.toPrimitive];if(d!==a){var e=d.call(b,c||"default");if("object"!=typeof e)return e;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===c?String:Number)(b)}for(var i=[["Afghanistan","af","93"],["Albania","al","355"],["Algeria","dz","213"],["American Samoa","as","1",5,["684"]],["Andorra","ad","376"],["Angola","ao","244"],["Anguilla","ai","1",6,["264"]],["Antigua & Barbuda","ag","1",7,["268"]],["Argentina","ar","54"],["Armenia","am","374"],["Aruba","aw","297"],["Ascension Island","ac","247"],["Australia","au","61",0],["Austria","at","43"],["Azerbaijan","az","994"],["Bahamas","bs","1",8,["242"]],["Bahrain","bh","973"],["Bangladesh","bd","880"],["Barbados","bb","1",9,["246"]],["Belarus","by","375"],["Belgium","be","32"],["Belize","bz","501"],["Benin","bj","229"],["Bermuda","bm","1",10,["441"]],["Bhutan","bt","975"],["Bolivia","bo","591"],["Bosnia & Herzegovina","ba","387"],["Botswana","bw","267"],["Brazil","br","55"],["British Indian Ocean Territory","io","246"],["British Virgin Islands","vg","1",11,["284"]],["Brunei","bn","673"],["Bulgaria","bg","359"],["Burkina Faso","bf","226"],["Burundi","bi","257"],["Cambodia","kh","855"],["Cameroon","cm","237"],["Canada","ca","1",1,["204","226","236","249","250","263","289","306","343","354","365","367","368","382","387","403","416","418","428","431","437","438","450","584","468","474","506","514","519","548","579","581","584","587","604","613","639","647","672","683","705","709","742","753","778","780","782","807","819","825","867","873","902","905"]],["Cape Verde","cv","238"],["Caribbean Netherlands","bq","599",1,["3","4","7"]],["Cayman Islands","ky","1",12,["345"]],["Central African Republic","cf","236"],["Chad","td","235"],["Chile","cl","56"],["China","cn","86"],["Christmas Island","cx","61",2,["89164"]],["Cocos (Keeling) Islands","cc","61",1,["89162"]],["Colombia","co","57"],["Comoros","km","269"],["Congo - Brazzaville","cg","242"],["Congo - Kinshasa","cd","243"],["Cook Islands","ck","682"],["Costa Rica","cr","506"],["Côte d’Ivoire","ci","225"],["Croatia","hr","385"],["Cuba","cu","53"],["Curaçao","cw","599",0],["Cyprus","cy","357"],["Czech Republic","cz","420"],["Denmark","dk","45"],["Djibouti","dj","253"],["Dominica","dm","1",13,["767"]],["Dominican Republic","do","1",2,["809","829","849"]],["Ecuador","ec","593"],["Egypt","eg","20"],["El Salvador","sv","503"],["Equatorial Guinea","gq","240"],["Eritrea","er","291"],["Estonia","ee","372"],["Eswatini","sz","268"],["Ethiopia","et","251"],["Falkland Islands","fk","500"],["Faroe Islands","fo","298"],["Fiji","fj","679"],["Finland","fi","358",0],["France","fr","33"],["French Guiana","gf","594"],["French Polynesia","pf","689"],["Gabon","ga","241"],["Gambia","gm","220"],["Georgia","ge","995"],["Germany","de","49"],["Ghana","gh","233"],["Gibraltar","gi","350"],["Greece","gr","30"],["Greenland","gl","299"],["Grenada","gd","1",14,["473"]],["Guadeloupe","gp","590",0],["Guam","gu","1",15,["671"]],["Guatemala","gt","502"],["Guernsey","gg","44",1,["1481","7781","7839","7911"]],["Guinea","gn","224"],["Guinea-Bissau","gw","245"],["Guyana","gy","592"],["Haiti","ht","509"],["Honduras","hn","504"],["Hong Kong","hk","852"],["Hungary","hu","36"],["Iceland","is","354"],["India","in","91"],["Indonesia","id","62"],["Iran","ir","98"],["Iraq","iq","964"],["Ireland","ie","353"],["Isle of Man","im","44",2,["1624","74576","7524","7924","7624"]],["Israel","il","972"],["Italy","it","39",0],["Jamaica","jm","1",4,["876","658"]],["Japan","jp","81"],["Jersey","je","44",3,["1534","7509","7700","7797","7829","7937"]],["Jordan","jo","962"],["Kazakhstan","kz","7",1,["33","7"]],["Kenya","ke","254"],["Kiribati","ki","686"],["Kosovo","xk","383"],["Kuwait","kw","965"],["Kyrgyzstan","kg","996"],["Laos","la","856"],["Latvia","lv","371"],["Lebanon","lb","961"],["Lesotho","ls","266"],["Liberia","lr","231"],["Libya","ly","218"],["Liechtenstein","li","423"],["Lithuania","lt","370"],["Luxembourg","lu","352"],["Macau","mo","853"],["Madagascar","mg","261"],["Malawi","mw","265"],["Malaysia","my","60"],["Maldives","mv","960"],["Mali","ml","223"],["Malta","mt","356"],["Marshall Islands","mh","692"],["Martinique","mq","596"],["Mauritania","mr","222"],["Mauritius","mu","230"],["Mayotte","yt","262",1,["269","639"]],["Mexico","mx","52"],["Micronesia","fm","691"],["Moldova","md","373"],["Monaco","mc","377"],["Mongolia","mn","976"],["Montenegro","me","382"],["Montserrat","ms","1",16,["664"]],["Morocco","ma","212",0],["Mozambique","mz","258"],["Myanmar (Burma)","mm","95"],["Namibia","na","264"],["Nauru","nr","674"],["Nepal","np","977"],["Netherlands","nl","31"],["New Caledonia","nc","687"],["New Zealand","nz","64"],["Nicaragua","ni","505"],["Niger","ne","227"],["Nigeria","ng","234"],["Niue","nu","683"],["Norfolk Island","nf","672"],["North Korea","kp","850"],["North Macedonia","mk","389"],["Northern Mariana Islands","mp","1",17,["670"]],["Norway","no","47",0],["Oman","om","968"],["Pakistan","pk","92"],["Palau","pw","680"],["Palestine","ps","970"],["Panama","pa","507"],["Papua New Guinea","pg","675"],["Paraguay","py","595"],["Peru","pe","51"],["Philippines","ph","63"],["Poland","pl","48"],["Portugal","pt","351"],["Puerto Rico","pr","1",3,["787","939"]],["Qatar","qa","974"],["Réunion","re","262",0],["Romania","ro","40"],["Russia","ru","7",0],["Rwanda","rw","250"],["Samoa","ws","685"],["San Marino","sm","378"],["São Tomé & Príncipe","st","239"],["Saudi Arabia","sa","966"],["Senegal","sn","221"],["Serbia","rs","381"],["Seychelles","sc","248"],["Sierra Leone","sl","232"],["Singapore","sg","65"],["Sint Maarten","sx","1",21,["721"]],["Slovakia","sk","421"],["Slovenia","si","386"],["Solomon Islands","sb","677"],["Somalia","so","252"],["South Africa","za","27"],["South Korea","kr","82"],["South Sudan","ss","211"],["Spain","es","34"],["Sri Lanka","lk","94"],["St Barthélemy","bl","590",1],["St Helena","sh","290"],["St Kitts & Nevis","kn","1",18,["869"]],["St Lucia","lc","1",19,["758"]],["St Martin","mf","590",2],["St Pierre & Miquelon","pm","508"],["St Vincent & Grenadines","vc","1",20,["784"]],["Sudan","sd","249"],["Suriname","sr","597"],["Svalbard & Jan Mayen","sj","47",1,["79"]],["Sweden","se","46"],["Switzerland","ch","41"],["Syria","sy","963"],["Taiwan","tw","886"],["Tajikistan","tj","992"],["Tanzania","tz","255"],["Thailand","th","66"],["Timor-Leste","tl","670"],["Togo","tg","228"],["Tokelau","tk","690"],["Tonga","to","676"],["Trinidad & Tobago","tt","1",22,["868"]],["Tunisia","tn","216"],["Turkey","tr","90"],["Turkmenistan","tm","993"],["Turks & Caicos Islands","tc","1",23,["649"]],["Tuvalu","tv","688"],["Uganda","ug","256"],["Ukraine","ua","380"],["United Arab Emirates","ae","971"],["United Kingdom","gb","44",0],["United States","us","1",0],["Uruguay","uy","598"],["US Virgin Islands","vi","1",24,["340"]],["Uzbekistan","uz","998"],["Vanuatu","vu","678"],["Vatican City","va","39",1,["06698"]],["Venezuela","ve","58"],["Vietnam","vn","84"],["Wallis & Futuna","wf","681"],["Western Sahara","eh","212",1,["5288","5289"]],["Yemen","ye","967"],["Zambia","zm","260"],["Zimbabwe","zw","263"],["Åland Islands","ax","358",1,["18"]]],j=0;j<i.length;j++){var k=i[j];i[j]={name:k[0],iso2:k[1],dialCode:k[2],priority:k[3]||0,areaCodes:k[4]||null}}var l={getInstance:function(a){var b=a.getAttribute("data-intl-tel-input-id");return window.intlTelInputGlobals.instances[b]},instances:{},documentReady:function(){return"complete"===document.readyState}};"object"==typeof window&&(window.intlTelInputGlobals=l);var m=0,n={allowDropdown:!0,autoInsertDialCode:!1,autoPlaceholder:"polite",customContainer:"",customPlaceholder:null,dropdownContainer:null,excludeCountries:[],formatOnDisplay:!0,geoIpLookup:null,hiddenInput:"",initialCountry:"",localizedCountries:null,nationalMode:!0,onlyCountries:[],placeholderNumberType:"MOBILE",preferredCountries:["us","gb"],separateDialCode:!1,showFlags:!0,useFullscreenPopup:/Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)||window.innerWidth<=500,utilsScript:""},o=["800","822","833","844","855","866","877","880","881","882","883","884","885","886","887","888","889"],p=function(a,b){for(var c=Object.keys(a),d=0;d<c.length;d++)b(c[d],a[c[d]])},q=function(a){p(window.intlTelInputGlobals.instances,function(b){window.intlTelInputGlobals.instances[b][a]()})},r=function(){function c(a,b){var e=this;d(this,c),this.id=m++,this.a=a,this.b=null,this.c=null;var f=b||{};this.d={},p(n,function(a,b){e.d[a]=f.hasOwnProperty(a)?f[a]:b}),this.e=Boolean(a.getAttribute("placeholder"))}return f(c,[{key:"_init",value:function(){var a=this;this.d.nationalMode&&(this.d.autoInsertDialCode=!1),this.d.separateDialCode&&(this.d.autoInsertDialCode=!1);var b=this.d.allowDropdown&&!this.d.separateDialCode;if(!this.d.showFlags&&b&&(this.d.showFlags=!0),this.d.useFullscreenPopup&&(document.body.classList.add("iti-fullscreen-popup"),this.d.dropdownContainer||(this.d.dropdownContainer=document.body)),this.isRTL=!!this.a.closest("[dir=rtl]"),"undefined"!=typeof Promise){var c=new Promise(function(b,c){a.h=b,a.i=c}),d=new Promise(function(b,c){a.i0=b,a.i1=c});this.promise=Promise.all([c,d])}else this.h=this.i=function(){},this.i0=this.i1=function(){};this.s={},this._b(),this._f(),this._h(),this._i(),this._i3()}},{key:"_b",value:function(){this._d(),this._d2(),this._e(),this.d.localizedCountries&&this._d0(),(this.d.onlyCountries.length||this.d.localizedCountries)&&this.p.sort(this._d1)}},{key:"_c",value:function(b,c,d){c.length>this.countryCodeMaxLen&&(this.countryCodeMaxLen=c.length),this.q.hasOwnProperty(c)||(this.q[c]=[]);for(var e=0;e<this.q[c].length;e++)if(this.q[c][e]===b)return;var f=d!==a?d:this.q[c].length;this.q[c][f]=b}},{key:"_d",value:function(){if(this.d.onlyCountries.length){var a=this.d.onlyCountries.map(function(a){return a.toLowerCase()});this.p=i.filter(function(b){return a.indexOf(b.iso2)>-1})}else if(this.d.excludeCountries.length){var b=this.d.excludeCountries.map(function(a){return a.toLowerCase()});this.p=i.filter(function(a){return-1===b.indexOf(a.iso2)})}else this.p=i}},{key:"_d0",value:function(){for(var a=0;a<this.p.length;a++){var b=this.p[a].iso2.toLowerCase();this.d.localizedCountries.hasOwnProperty(b)&&(this.p[a].name=this.d.localizedCountries[b])}}},{key:"_d1",value:function(a,b){return a.name<b.name?-1:a.name>b.name?1:0}},{key:"_d2",value:function(){this.countryCodeMaxLen=0,this.dialCodes={},this.q={};for(var a=0;a<this.p.length;a++){var b=this.p[a];this.dialCodes[b.dialCode]||(this.dialCodes[b.dialCode]=!0),this._c(b.iso2,b.dialCode,b.priority)}for(var c=0;c<this.p.length;c++){var d=this.p[c];if(d.areaCodes)for(var e=this.q[d.dialCode][0],f=0;f<d.areaCodes.length;f++){for(var g=d.areaCodes[f],h=1;h<g.length;h++){var i=d.dialCode+g.substr(0,h);this._c(e,i),this._c(d.iso2,i)}this._c(d.iso2,d.dialCode+g)}}}},{key:"_e",value:function(){this.preferredCountries=[];for(var a=0;a<this.d.preferredCountries.length;a++){var b=this.d.preferredCountries[a].toLowerCase(),c=this._y(b,!1,!0);c&&this.preferredCountries.push(c)}}},{key:"_e2",value:function(a,b,c){var d=document.createElement(a);return b&&p(b,function(a,b){return d.setAttribute(a,b)}),c&&c.appendChild(d),d}},{key:"_f",value:function(){this.a.hasAttribute("autocomplete")||this.a.form&&this.a.form.hasAttribute("autocomplete")||this.a.setAttribute("autocomplete","off");var a=this.d,c=a.allowDropdown,d=a.separateDialCode,e=a.showFlags,f=a.customContainer,g=a.hiddenInput,h=a.dropdownContainer,i="iti";c&&(i+=" iti--allow-dropdown"),d&&(i+=" iti--separate-dial-code"),e&&(i+=" iti--show-flags"),f&&(i+=" ".concat(f));var j=this._e2("div",{"class":i});this.a.parentNode.insertBefore(j,this.a);var k=c||e||d;if(k&&(this.k=this._e2("div",{"class":"iti__flag-container"},j)),j.appendChild(this.a),k&&(this.selectedFlag=this._e2("div",b({"class":"iti__selected-flag"},c&&{role:"combobox","aria-haspopup":"listbox","aria-controls":"iti-".concat(this.id,"__country-listbox"),"aria-expanded":"false","aria-label":"Telephone country code"}),this.k)),e&&(this.l=this._e2("div",{"class":"iti__flag"},this.selectedFlag)),this.selectedFlag&&this.a.disabled&&this.selectedFlag.setAttribute("aria-disabled","true"),d&&(this.t=this._e2("div",{"class":"iti__selected-dial-code"},this.selectedFlag)),c&&(this.a.disabled||this.selectedFlag.setAttribute("tabindex","0"),this.u=this._e2("div",{"class":"iti__arrow"},this.selectedFlag),this.m=this._e2("ul",{"class":"iti__country-list iti__hide",id:"iti-".concat(this.id,"__country-listbox"),role:"listbox","aria-label":"List of countries"}),this.preferredCountries.length&&(this._g(this.preferredCountries,"iti__preferred",!0),this._e2("li",{"class":"iti__divider","aria-hidden":"true"},this.m)),this._g(this.p,"iti__standard"),h?(this.dropdown=this._e2("div",{"class":"iti iti--container"}),this.dropdown.appendChild(this.m)):this.k.appendChild(this.m)),g){var l=g,m=this.a.getAttribute("name");if(m){var n=m.lastIndexOf("[");-1!==n&&(l="".concat(m.substr(0,n),"[").concat(l,"]"))}this.hiddenInput=this._e2("input",{type:"hidden",name:l}),j.appendChild(this.hiddenInput)}}},{key:"_g",value:function(a,b,c){for(var d="",e=0;e<a.length;e++){var f=a[e],g=c?"-preferred":"";d+="<li class='iti__country ".concat(b,"' tabIndex='-1' id='iti-").concat(this.id,"__item-").concat(f.iso2).concat(g,"' role='option' data-dial-code='").concat(f.dialCode,"' data-country-code='").concat(f.iso2,"' aria-selected='false'>"),this.d.showFlags&&(d+="<div class='iti__flag-box'><div class='iti__flag iti__".concat(f.iso2,"'></div></div>")),d+="<span class='iti__country-name'>".concat(f.name,"</span>"),d+="<span class='iti__dial-code'>+".concat(f.dialCode,"</span>"),d+="</li>"}this.m.insertAdjacentHTML("beforeend",d)}},{key:"_h",value:function(){var a=this.a.getAttribute("value"),b=this.a.value,c=a&&"+"===a.charAt(0)&&(!b||"+"!==b.charAt(0)),d=c?a:b,e=this._5(d),f=this._w(d),g=this.d,h=g.initialCountry,i=g.autoInsertDialCode;e&&!f?this._v(d):"auto"!==h&&(h?this._z(h.toLowerCase()):e&&f?this._z("us"):(this.j=this.preferredCountries.length?this.preferredCountries[0].iso2:this.p[0].iso2,d||this._z(this.j)),!d&&i&&(this.a.value="+".concat(this.s.dialCode))),d&&this._u(d)}},{key:"_i",value:function(){this._j(),this.d.autoInsertDialCode&&this._l(),this.d.allowDropdown&&this._i2(),this.hiddenInput&&this._i0()}},{key:"_i0",value:function(){var a=this;this._a14=function(){a.hiddenInput.value=a.getNumber()},this.a.form&&this.a.form.addEventListener("submit",this._a14)}},{key:"_i1",value:function(){for(var a=this.a;a&&"LABEL"!==a.tagName;)a=a.parentNode;return a}},{key:"_i2",value:function(){var a=this;this._a9=function(b){a.m.classList.contains("iti__hide")?a.a.focus():b.preventDefault()};var b=this._i1();b&&b.addEventListener("click",this._a9),this._a10=function(){!a.m.classList.contains("iti__hide")||a.a.disabled||a.a.readOnly||a._n()},this.selectedFlag.addEventListener("click",this._a10),this._a11=function(b){a.m.classList.contains("iti__hide")&&-1!==["ArrowUp","Up","ArrowDown","Down"," ","Enter"].indexOf(b.key)&&(b.preventDefault(),b.stopPropagation(),a._n()),"Tab"===b.key&&a._2()},this.k.addEventListener("keydown",this._a11)}},{key:"_i3",value:function(){var a=this;this.d.utilsScript&&!window.intlTelInputUtils?window.intlTelInputGlobals.documentReady()?window.intlTelInputGlobals.loadUtils(this.d.utilsScript):window.addEventListener("load",function(){window.intlTelInputGlobals.loadUtils(a.d.utilsScript)}):this.i0(),"auto"===this.d.initialCountry?this._i4():this.h()}},{key:"_i4",value:function(){window.intlTelInputGlobals.autoCountry?this.handleAutoCountry():window.intlTelInputGlobals.startedLoadingAutoCountry||(window.intlTelInputGlobals.startedLoadingAutoCountry=!0,"function"==typeof this.d.geoIpLookup&&this.d.geoIpLookup(function(a){window.intlTelInputGlobals.autoCountry=a.toLowerCase(),setTimeout(function(){return q("handleAutoCountry")})},function(){return q("rejectAutoCountryPromise")}))}},{key:"_j",value:function(){var a=this;this._a12=function(){a._v(a.a.value)&&a._m2CountryChange()},this.a.addEventListener("keyup",this._a12),this._a13=function(){setTimeout(a._a12)},this.a.addEventListener("cut",this._a13),this.a.addEventListener("paste",this._a13)}},{key:"_j2",value:function(a){var b=this.a.getAttribute("maxlength");return b&&a.length>b?a.substr(0,b):a}},{key:"_l",value:function(){var a=this;this._a8=function(){a._l2()},this.a.form&&this.a.form.addEventListener("submit",this._a8),this.a.addEventListener("blur",this._a8)}},{key:"_l2",value:function(){if("+"===this.a.value.charAt(0)){var a=this._m(this.a.value);a&&this.s.dialCode!==a||(this.a.value="")}}},{key:"_m",value:function(a){return a.replace(/\D/g,"")}},{key:"_m2",value:function(a){var b=document.createEvent("Event");b.initEvent(a,!0,!0),this.a.dispatchEvent(b)}},{key:"_n",value:function(){this.m.classList.remove("iti__hide"),this.selectedFlag.setAttribute("aria-expanded","true"),this._o(),this.b&&(this._x(this.b,!1),this._3(this.b,!0)),this._p(),this.u.classList.add("iti__arrow--up"),this._m2("open:countrydropdown")}},{key:"_n2",value:function(a,b,c){c&&!a.classList.contains(b)?a.classList.add(b):!c&&a.classList.contains(b)&&a.classList.remove(b)}},{key:"_o",value:function(){var a=this;if(this.d.dropdownContainer&&this.d.dropdownContainer.appendChild(this.dropdown),!this.d.useFullscreenPopup){var b=this.a.getBoundingClientRect(),c=window.pageYOffset||document.documentElement.scrollTop,d=b.top+c,e=this.m.offsetHeight,f=d+this.a.offsetHeight+e<c+window.innerHeight,g=d-e>c;if(this._n2(this.m,"iti__country-list--dropup",!f&&g),this.d.dropdownContainer){var h=!f&&g?0:this.a.offsetHeight;this.dropdown.style.top="".concat(d+h,"px"),this.dropdown.style.left="".concat(b.left+document.body.scrollLeft,"px"),this._a4=function(){return a._2()},window.addEventListener("scroll",this._a4)}}}},{key:"_o2",value:function(a){for(var b=a;b&&b!==this.m&&!b.classList.contains("iti__country");)b=b.parentNode;return b===this.m?null:b}},{key:"_p",value:function(){var a=this;this._a0=function(b){var c=a._o2(b.target);c&&a._x(c,!1)},this.m.addEventListener("mouseover",this._a0),this._a1=function(b){var c=a._o2(b.target);c&&a._1(c)},this.m.addEventListener("click",this._a1);var b=!0;this._a2=function(){b||a._2(),b=!1},document.documentElement.addEventListener("click",this._a2);var c="",d=null;this._a3=function(b){b.preventDefault(),"ArrowUp"===b.key||"Up"===b.key||"ArrowDown"===b.key||"Down"===b.key?a._q(b.key):"Enter"===b.key?a._r():"Escape"===b.key?a._2():/^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(b.key)&&(d&&clearTimeout(d),c+=b.key.toLowerCase(),a._s(c),d=setTimeout(function(){c=""},1e3))},document.addEventListener("keydown",this._a3)}},{key:"_q",value:function(a){var b="ArrowUp"===a||"Up"===a?this.c.previousElementSibling:this.c.nextElementSibling;b&&(b.classList.contains("iti__divider")&&(b="ArrowUp"===a||"Up"===a?b.previousElementSibling:b.nextElementSibling),this._x(b,!0))}},{key:"_r",value:function(){this.c&&this._1(this.c)}},{key:"_s",value:function(a){for(var b=0;b<this.p.length;b++)if(this._t(this.p[b].name,a)){var c=this.m.querySelector("#iti-".concat(this.id,"__item-").concat(this.p[b].iso2));this._x(c,!1),this._3(c,!0);break}}},{key:"_t",value:function(a,b){return a.substr(0,b.length).toLowerCase()===b}},{key:"_u",value:function(a){var b=a;if(this.d.formatOnDisplay&&window.intlTelInputUtils&&this.s){var c=this.d.nationalMode||"+"!==b.charAt(0)&&!this.d.separateDialCode,d=intlTelInputUtils.numberFormat,e=d.NATIONAL,f=d.INTERNATIONAL,g=c?e:f;b=intlTelInputUtils.formatNumber(b,this.s.iso2,g)}b=this._7(b),this.a.value=b}},{key:"_v",value:function(a){var b=a,c=this.s.dialCode,d="1"===c;b&&d&&"+"!==b.charAt(0)&&("1"!==b.charAt(0)&&(b="1".concat(b)),b="+".concat(b)),this.d.separateDialCode&&c&&"+"!==b.charAt(0)&&(b="+".concat(c).concat(b));var e=this._5(b,!0),f=this._m(b),g=null;if(e){var h=this.q[this._m(e)],i=-1!==h.indexOf(this.s.iso2)&&f.length<=e.length-1;if(!("1"===c&&this._w(f))&&!i)for(var j=0;j<h.length;j++)if(h[j]){g=h[j];break}}else"+"===b.charAt(0)&&f.length?g="":b&&"+"!==b||(g=this.j);return null!==g&&this._z(g)}},{key:"_w",value:function(a){var b=this._m(a);if("1"===b.charAt(0)){var c=b.substr(1,3);return-1!==o.indexOf(c)}return!1}},{key:"_x",value:function(a,b){var c=this.c;c&&c.classList.remove("iti__highlight"),this.c=a,this.c.classList.add("iti__highlight"),this.selectedFlag.setAttribute("aria-activedescendant",a.getAttribute("id")),b&&this.c.focus()}},{key:"_y",value:function(a,b,c){for(var d=b?i:this.p,e=0;e<d.length;e++)if(d[e].iso2===a)return d[e];if(c)return null;throw new Error("No country data for '".concat(a,"'"))}},{key:"_z",value:function(a){var b=this.d,c=b.allowDropdown,d=b.separateDialCode,e=b.showFlags,f=this.s.iso2?this.s:{};if(this.s=a?this._y(a,!1,!1):{},this.s.iso2&&(this.j=this.s.iso2),e&&this.l.setAttribute("class","iti__flag iti__".concat(a)),this._setSelectedCountryFlagTitleAttribute(a,d),d){var g=this.s.dialCode?"+".concat(this.s.dialCode):"";this.t.innerHTML=g;var h=this.selectedFlag.offsetWidth||this._z2();this.isRTL?this.a.style.paddingRight="".concat(h+6,"px"):this.a.style.paddingLeft="".concat(h+6,"px")}if(this._0(),c){var i=this.b;if(i&&(i.classList.remove("iti__active"),i.setAttribute("aria-selected","false")),a){var j=this.m.querySelector("#iti-".concat(this.id,"__item-").concat(a,"-preferred"))||this.m.querySelector("#iti-".concat(this.id,"__item-").concat(a));j.setAttribute("aria-selected","true"),j.classList.add("iti__active"),this.b=j}}return f.iso2!==a}},{key:"_setSelectedCountryFlagTitleAttribute",value:function(a,b){if(this.selectedFlag){var c;c=a&&!b?"".concat(this.s.name,": +").concat(this.s.dialCode):a?this.s.name:"Unknown",this.selectedFlag.setAttribute("title",c)}}},{key:"_z2",value:function(){var a=this.a.parentNode.cloneNode();a.style.visibility="hidden",document.body.appendChild(a);var b=this.k.cloneNode();a.appendChild(b);var c=this.selectedFlag.cloneNode(!0);b.appendChild(c);var d=c.offsetWidth;return a.parentNode.removeChild(a),d}},{key:"_0",value:function(){var a="aggressive"===this.d.autoPlaceholder||!this.e&&"polite"===this.d.autoPlaceholder;if(window.intlTelInputUtils&&a){var b=intlTelInputUtils.numberType[this.d.placeholderNumberType],c=this.s.iso2?intlTelInputUtils.getExampleNumber(this.s.iso2,this.d.nationalMode,b):"";c=this._7(c),"function"==typeof this.d.customPlaceholder&&(c=this.d.customPlaceholder(c,this.s)),this.a.setAttribute("placeholder",c)}}},{key:"_1",value:function(a){var b=this._z(a.getAttribute("data-country-code"));this._2(),this._4(a.getAttribute("data-dial-code")),this.a.focus();var c=this.a.value.length;this.a.setSelectionRange(c,c),b&&this._m2CountryChange()}},{key:"_2",value:function(){this.m.classList.add("iti__hide"),this.selectedFlag.setAttribute("aria-expanded","false"),this.selectedFlag.removeAttribute("aria-activedescendant"),this.u.classList.remove("iti__arrow--up"),document.removeEventListener("keydown",this._a3),document.documentElement.removeEventListener("click",this._a2),this.m.removeEventListener("mouseover",this._a0),this.m.removeEventListener("click",this._a1),this.d.dropdownContainer&&(this.d.useFullscreenPopup||window.removeEventListener("scroll",this._a4),this.dropdown.parentNode&&this.dropdown.parentNode.removeChild(this.dropdown)),this._m2("close:countrydropdown")}},{key:"_3",value:function(a,b){var c=this.m,d=window.pageYOffset||document.documentElement.scrollTop,e=c.offsetHeight,f=c.getBoundingClientRect().top+d,g=f+e,h=a.offsetHeight,i=a.getBoundingClientRect().top+d,j=i+h,k=i-f+c.scrollTop,l=e/2-h/2;if(i<f)b&&(k-=l),c.scrollTop=k;else if(j>g){b&&(k+=l);var m=e-h;c.scrollTop=k-m}}},{key:"_4",value:function(a){var b,c=this.a.value,d="+".concat(a);if("+"===c.charAt(0)){var e=this._5(c);b=e?c.replace(e,d):d,this.a.value=b}else this.d.autoInsertDialCode&&(b=c?d+c:d,this.a.value=b)}},{key:"_5",value:function(a,b){var c="";if("+"===a.charAt(0))for(var d="",e=0;e<a.length;e++){var f=a.charAt(e);if(!isNaN(parseInt(f,10))){if(d+=f,b)this.q[d]&&(c=a.substr(0,e+1));else if(this.dialCodes[d]){c=a.substr(0,e+1);break}if(d.length===this.countryCodeMaxLen)break}}return c}},{key:"_6",value:function(){var a=this.a.value.trim(),b=this.s.dialCode,c=this._m(a);return(this.d.separateDialCode&&"+"!==a.charAt(0)&&b&&c?"+".concat(b):"")+a}},{key:"_7",value:function(a){var b=a;if(this.d.separateDialCode){var c=this._5(b);if(c){c="+".concat(this.s.dialCode);var d=" "===b[c.length]||"-"===b[c.length]?c.length+1:c.length;b=b.substr(d)}}return this._j2(b)}},{key:"_m2CountryChange",value:function(){this._m2("countrychange")}},{key:"handleAutoCountry",value:function(){"auto"===this.d.initialCountry&&(this.j=window.intlTelInputGlobals.autoCountry,this.a.value||this.setCountry(this.j),this.h())}},{key:"handleUtils",value:function(){window.intlTelInputUtils&&(this.a.value&&this._u(this.a.value),this._0()),this.i0()}},{key:"destroy",value:function(){var a=this.a.form;if(this.d.allowDropdown){this._2(),this.selectedFlag.removeEventListener("click",this._a10),this.k.removeEventListener("keydown",this._a11);var b=this._i1();b&&b.removeEventListener("click",this._a9)}this.hiddenInput&&a&&a.removeEventListener("submit",this._a14),this.d.autoInsertDialCode&&(a&&a.removeEventListener("submit",this._a8),this.a.removeEventListener("blur",this._a8)),this.a.removeEventListener("keyup",this._a12),this.a.removeEventListener("cut",this._a13),this.a.removeEventListener("paste",this._a13),this.a.removeAttribute("data-intl-tel-input-id");var c=this.a.parentNode;c.parentNode.insertBefore(this.a,c),c.parentNode.removeChild(c),delete window.intlTelInputGlobals.instances[this.id]}},{key:"getExtension",value:function(){return window.intlTelInputUtils?intlTelInputUtils.getExtension(this._6(),this.s.iso2):""}},{key:"getNumber",value:function(a){if(window.intlTelInputUtils){var b=this.s.iso2;return intlTelInputUtils.formatNumber(this._6(),b,a)}return""}},{key:"getNumberType",value:function(){
return window.intlTelInputUtils?intlTelInputUtils.getNumberType(this._6(),this.s.iso2):-99}},{key:"getSelectedCountryData",value:function(){return this.s}},{key:"getValidationError",value:function(){if(window.intlTelInputUtils){var a=this.s.iso2;return intlTelInputUtils.getValidationError(this._6(),a)}return-99}},{key:"isValidNumber",value:function(){var a=this._6().trim();return window.intlTelInputUtils?intlTelInputUtils.isValidNumber(a,this.s.iso2):null}},{key:"isPossibleNumber",value:function(){var a=this._6().trim();return window.intlTelInputUtils?intlTelInputUtils.isPossibleNumber(a,this.s.iso2):null}},{key:"setCountry",value:function(a){var b=a.toLowerCase();this.s.iso2!==b&&(this._z(b),this._4(this.s.dialCode),this._m2CountryChange())}},{key:"setNumber",value:function(a){var b=this._v(a);this._u(a),b&&this._m2CountryChange()}},{key:"setPlaceholderNumberType",value:function(a){this.d.placeholderNumberType=a,this._0()}}]),c}();l.getCountryData=function(){return i};var s=function(a,b,c){var d=document.createElement("script");d.onload=function(){q("handleUtils"),b&&b()},d.onerror=function(){q("rejectUtilsScriptPromise"),c&&c()},d.className="iti-load-utils",d.async=!0,d.src=a,document.body.appendChild(d)};return l.loadUtils=function(a){if(!window.intlTelInputUtils&&!window.intlTelInputGlobals.startedLoadingUtilsScript){if(window.intlTelInputGlobals.startedLoadingUtilsScript=!0,"undefined"!=typeof Promise)return new Promise(function(b,c){return s(a,b,c)});s(a)}return null},l.defaults=n,l.version="18.3.3",function(a,b){var c=new r(a,b);return c._init(),a.setAttribute("data-intl-tel-input-id",c.id),window.intlTelInputGlobals.instances[c.id]=c,c}}()});

(function() {
  'use strict';

  angular
    .module('website')
    .directive('productBadge', productBadge);

  /* @ngInject */
  function productBadge() {
    // Usage:
    //  <product-badge badge="badge-name-to-use"><product-badge/>
    // Creates:
    //  adds a product badge to use in product card
    var directive = {
      restrict: 'E',
      scope: {
        badge: '@',
        seleable: '=',
        modal: '=',
      },
      templateUrl: function($element, $attrs) {
        var badges = {
          'highlight-text' :'app/components/product-badge/{mobile}{desktop}/highlight-text.html',
        };
        return badges[$attrs.badge];
      },
      compile: function ($element, $attrs) {
        return function link(scope, element) {
          element.addClass('product-component-container');

          var product = scope.seleable ? scope.seleable : scope.item.seleable;
          scope.badgeText = product.highlighted_text;
        }
      }
    };
    return directive;
  }
})();

(function () {
  "use strict";

  angular.module("website").service("PaymentNormalizer", PaymentNormalizer);

  /* @ngInject */
  function PaymentNormalizer() {
    var service = this;

    service.normalize = normalize;

    function normalize(paymentMethods) {
      var normalized = {};
      var order = [];

      if (!paymentMethods) {
        return { paymentTypes: normalized, order: order };
      }

      var metaKeys = [
        "priority",
        "active",
        "online",
        "allow_schedule",
        "allowSchedule",
        "tip",
        "name",
        "code",
      ];

      function parseBoolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") return value.toLowerCase() === "true";
        return undefined;
      }

      function sanitizeType(type) {
        if (type == null) return null;
        return ("" + type)
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]/g, "");
      }

      function resolveType(entry) {
        if (!entry) return null;

        var byCode = sanitizeType(entry.code);
        if (byCode) return byCode;

        var byType = sanitizeType(entry.type);
        if (byType) return byType;

        if (entry.name && !entry.code && !entry.type) {
          var byName = sanitizeType(entry.name);
          if (byName) return byName;
        }

        var dynamicKey = Object.keys(entry).find(function (key) {
          return metaKeys.indexOf(key) === -1 && entry[key];
        });

        return sanitizeType(dynamicKey);
      }

      function applyEntryConfig(type, entry) {
        if (!type || !entry) return;

        var target = normalized[type] || {};

        var online = parseBoolean(entry.online);
        if (typeof online === "boolean") target.online = online;

        var tip = parseBoolean(entry.tip);
        if (typeof tip === "boolean") target.tip = tip;

        var allowSchedule = parseBoolean(entry.allow_schedule);
        if (typeof allowSchedule === "undefined") {
          allowSchedule = parseBoolean(entry.allowSchedule);
        }
        if (typeof allowSchedule === "boolean") {
          target.allowSchedule = allowSchedule;
        }

        normalized[type] = target;
      }

      function pushOrder(type, priority) {
        if (!type) return;
        order.push({
          type: type,
          priority: typeof priority === "number" ? priority : order.length + 1,
        });
      }

      if (angular.isArray(paymentMethods)) {
        paymentMethods.forEach(function (entry) {
          if (!entry || entry.active === false) return;

          var type = resolveType(entry);
          if (!type) return;

          applyEntryConfig(type, entry);
          pushOrder(type, entry.priority);
        });
      } else if (typeof paymentMethods === "object") {
        Object.keys(paymentMethods).forEach(function (key) {
          var entry = paymentMethods[key];
          var type = sanitizeType(key);

          applyEntryConfig(type, entry);
          pushOrder(type, entry && entry.priority);
        });
      }

      order.sort(function (a, b) {
        return a.priority - b.priority;
      });

      if (normalized.webpayplus && !normalized.webpay) {
        normalized.webpay = angular.copy(normalized.webpayplus);
      }

      return {
        paymentTypes: normalized,
        order: order,
      };
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('onSlideChange', onSlideChange);

  /* @ngInject */
  function onSlideChange($parse) {
    // Usage:
    // for angular ui bootstrap carousel
    // Creates:
    //
    var directive = {
      link: link,
      require: 'carousel',
      restrict: 'A'
    };
    return directive;

    function link(scope, element, attrs, carouselController) {
      var fn = $parse(attrs.onSlideChange);
      var origSelect = carouselController.select;
      carouselController.select = function(nextSlide, direction, nextIndex) {
        if (nextSlide !== this.currentSlide) {
          nextIndex = this.getCurrentIndex();
          nextIndex += direction === 'next' ? 1 : -1;
          fn(scope, {
            nextSlide: nextSlide,
            direction: direction,
            nextIndex: nextIndex
          });
        }
        return origSelect.apply(this, arguments);
      };
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('website')
    .directive('noticeBarCart', noticeBarCart);

  /* @ngInject */
  function noticeBarCart(env) {
    var directive = {
      bindToController: true,
      controller: Controller,
      controllerAs: 'noticeBarCart',
      restrict: 'E',
      templateUrl: 'app/components/notice-bar-cart/{mobile}{desktop}/notice-bar-cart.html'
    };
    return directive;
  }

  /* @ngInject */
  function Controller(api, html, $document, $rootScope, $scope, env) {
    var vm                  = this;
    var noticeBarKey        = 'noticeBarShown';
    var today               = new Date().toISOString().split('T')[0];

    vm.appleUrl             =  env.APP_IOS_STORE_LINK;
    vm.androidUrl           =  env.APP_ANDROID_STORE_URL;
    $scope.noticeBarMobile  = false;
    $scope.noticeBarDesktop = false;
    $scope.noticeBarLogo    = false;
    $scope.noticeBarIcon    = false;
    $scope.noticeBarTitle   = '';
    $scope.noticeBarBody    = '';
    $scope.noticeBarLink    = '';
    $scope.niuLogoApp       = 'assets/images/niu-logo-app.webp';
    $scope.goToLink         = goToLink;
    $scope.downloadAppUrl   = downloadAppUrl;
    $scope.noticeBarClose   = noticeBarClose;
    activate();

    ////////////////

    function activate() {
      var lastShownDate = localStorage.getItem(noticeBarKey);
      if (lastShownDate !== today) {
        getNoticeBar();
      }
    }

    function getNoticeBar() {
      api.prefs.all().then(function() {
        var noticeBar = api.prefs.get('notice_bar');
        if (noticeBar) {
          $scope.noticeBarMobile = noticeBar.mobile ? noticeBar.mobile.toLowerCase() === 'true' : false;
          $scope.noticeBarDesktop = noticeBar.desktop ? noticeBar.desktop.toLowerCase() === 'true' : false;
          $scope.noticeBarLogo = noticeBar.logo ? noticeBar.logo.toLowerCase() === 'true' : false;
          $scope.noticeBarIcon = noticeBar.icon ? noticeBar.icon.toLowerCase() === 'true' : false;
          $scope.noticeBarTitle = noticeBar.title ? noticeBar.title : '';
          $scope.noticeBarBody = noticeBar.body ? noticeBar.body : '';
          $scope.noticeBarLink = noticeBar.link ? noticeBar.link : '';
          validateDeviceType();
        }
      });
    }

    function validateDeviceType() {
      if ($rootScope.deviceType == 'mobile' && $scope.noticeBarMobile) activateNoticeBar();
      if ($rootScope.deviceType == 'desktop' && $scope.noticeBarDesktop) activateNoticeBar();
    }

    function activateNoticeBar() {
      var navbar = $document[0].getElementById('navbar');
      html.addClass(navbar, 'notice-bar');
      var body = $document[0].getElementById('body');
      html.addClass(body, 'notice-bar');
    }

    function goToLink() {
      if (!!$scope.noticeBarLink) document.location.href = $scope.noticeBarLink;
    }

    function downloadAppUrl() {
      if (/Android/i.test(navigator.userAgent)) return vm.androidUrl;
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) return vm.appleUrl;
      return '';
    }

    function noticeBarClose() {
      var noticeBar = $document[0].getElementById('notice-bar');
      html.addClass(noticeBar, 'hidden');
      var navbar = $document[0].getElementById('navbar');
      html.removeClass(navbar, 'notice-bar');
      var body = $document[0].getElementById('body');
      html.removeClass(body, 'notice-bar');

      localStorage.setItem(noticeBarKey, today);
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("website")
    .controller("LocationMethodController", LocationMethodController);

  LocationMethodController.$inject = [
    "api",
    "$uibModalInstance",
    "$uibModal",
    "currentAddress",
  ];

  /* @ngInject */
  function LocationMethodController(
    api,
    $uibModalInstance,
    currentAddress
  ) {
    var vm = this;
    vm.method = "delivery";
    vm.address = null;
    vm.restaurants = [];
    vm.selectedRestaurant = null;
    vm.googleMapsUrl = googleMapsUrl;
    vm.addresses = [];
    vm.isAddressOpen = false;
    vm.toggleAddressList = toggleAddressList;
    vm.selectAddress = selectAddress;
    vm.confirm = confirm;
    vm.close = close;
    vm.selectMethod = selectMethod;
    vm.selectRestaurant = selectRestaurant;
    vm.openAddAddressModal = openAddAddressModal;

    activate();

    function activate() {
      loadAddress();
    }

    function confirm() {
      if (vm.method === "delivery") {
        if (!vm.selectedAddress) return;
        $uibModalInstance.close({
          method: "delivery",
          address: vm.selectedAddress,
        });
      }
      if (vm.method === "pickup") {
        if (!vm.selectedRestaurant) return;
        $uibModalInstance.close({
          method: "pickup",
          restaurant: vm.selectedRestaurant,
        });
      }
    }
    function openAddAddressModal() {
      $uibModalInstance.close({
        action: "add-address",
      });
    }

    function loadAddress() {
      api.addresses.all().then(function (addresses) {
        if (!addresses || !addresses.length) return;
        vm.addresses = addresses;
        var found = null;
        if (currentAddress && currentAddress.id) {
          for (var i = 0; i < addresses.length; i++) {
            if (addresses[i].id === currentAddress.id) {
              found = addresses[i];
              break;
            }
          }
        }
        vm.selectedAddress = found || addresses[0];
        vm.address = vm.selectedAddress;
      });
    }

    function toggleAddressList() {
      vm.isAddressOpen = !vm.isAddressOpen;
    }

    function selectAddress(address) {
      vm.selectedAddress = address;
      vm.address = address;
      vm.isAddressOpen = false;
    }

    function loadRestaurants() {
      if (!vm.address || !vm.address.id) return;
      api.restaurants
        .byCustomerAddress(vm.address.id)
        .then(function (restaurants) {
          vm.restaurants = (restaurants || []).sort(function (a, b) {
            return Number(Boolean(b.selected)) - Number(Boolean(a.selected));
          });

          vm.selectedRestaurant = null;
          for (var i = 0; i < vm.restaurants.length; i++) {
            if (vm.restaurants[i].selected) {
              vm.selectedRestaurant = vm.restaurants[i];
              break;
            }
          }
        });
    }

    function selectMethod(method) {
      vm.method = method;

      if (method === "pickup") {
        loadRestaurants();
      }
    }

    function selectRestaurant(restaurant) {
      vm.selectedRestaurant = restaurant;
    }

    function close() {
      $uibModalInstance.dismiss();
    }
  }

  function googleMapsUrl(restaurant) {
    if (!restaurant || !restaurant.address) return "#";

    return (
      "https://www.google.com/maps/search/?api=1&query=" +
      encodeURIComponent(restaurant.address)
    );
  }
})();

(function() {
  'use strict';
  angular.module("ngLocale", [], ["$provide", function($provide) {
    var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
    $provide.value("$locale", {
      "DATETIME_FORMATS": {
        "AMPMS": [
          "a. m.",
          "p. m."
        ],
        "DAY": [
          "domingo",
          "lunes",
          "martes",
          "mi\u00e9rcoles",
          "jueves",
          "viernes",
          "s\u00e1bado"
        ],
        "ERANAMES": [
          "antes de Cristo",
          "despu\u00e9s de Cristo"
        ],
        "ERAS": [
          "a. C.",
          "d. C."
        ],
        "FIRSTDAYOFWEEK": 0,
        "MONTH": [
          "enero",
          "febrero",
          "marzo",
          "abril",
          "mayo",
          "junio",
          "julio",
          "agosto",
          "septiembre",
          "octubre",
          "noviembre",
          "diciembre"
        ],
        "SHORTDAY": [
          "dom.",
          "lun.",
          "mar.",
          "mi\u00e9.",
          "jue.",
          "vie.",
          "s\u00e1b."
        ],
        "SHORTMONTH": [
          "ene.",
          "feb.",
          "mar.",
          "abr.",
          "may.",
          "jun.",
          "jul.",
          "ago.",
          "sept.",
          "oct.",
          "nov.",
          "dic."
        ],
        "WEEKENDRANGE": [
          5,
          6
        ],
        "fullDate": "EEEE, d 'de' MMMM 'de' y",
        "longDate": "d 'de' MMMM 'de' y",
        "medium": "dd-MM-y h:mm:ss a",
        "mediumDate": "dd-MM-y",
        "mediumTime": "h:mm:ss a",
        "short": "dd-MM-yy h:mm a",
        "shortDate": "dd-MM-yy",
        "shortTime": "h:mm a"
      },
      "NUMBER_FORMATS": {
        "CURRENCY_SYM": "$",
        "DECIMAL_SEP": ",",
        "GROUP_SEP": ".",
        "PATTERNS": [
          {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 3,
            "minFrac": 0,
            "minInt": 1,
            "negPre": "-",
            "negSuf": "",
            "posPre": "",
            "posSuf": ""
          },
          {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 2,
            "minFrac": 2,
            "minInt": 1,
            "negPre": "\u00a4-",
            "negSuf": "",
            "posPre": "\u00a4",
            "posSuf": ""
          }
        ]
      },
      "id": "es-cl",
      "pluralCat": function(n) {  if (n === 1) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
    });
  }]);
})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('loader', loader)
    .controller('LoaderController', LoaderController);

  /* @ngInject */
  function loader() {
    // Usage:
    //  <loader template="template-name" size="loader-size"><loader/>
    //  Can be: small or large. Small is by default
    // Creates:
    //  A loader component
    var directive = {
      bindToController: true,
      controller: LoaderController,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      bindings: {
        template  : '@'
      },
      templateUrl: function($element, $attrs) {
        var templates = {
            'ellipsis' :'app/components/loader/{mobile}{desktop}/ellipsis.html',
            'ring':'app/components/loader/{mobile}{desktop}/ring.html',
        }
        return templates[$attrs.template];
      }
    };
    return directive;

    function link(scope, element, attrs) {
    }
  }

  /* @ngInject */
  function LoaderController ($attrs) {
    var vm = this;
    vm.size = $attrs.size || 'small'
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('inputForm', inputForm);

  /* @ngInject */
  function inputForm(string) {
    var service = this;
    service.validateInput = validateInput;
    service.checkBtnSubmit = checkBtnSubmit;
    service.isValidEmail = isValidEmail;

    function validateInput(form, inputId, btnSubmitId) {
      var input  = document.querySelector('#' + inputId);
      var button = document.querySelector('#' + btnSubmitId);
      var inputErrorMessage = document.querySelector('#' + inputId + '-error-message');
      checkBtnSubmit(form, input, button, inputErrorMessage, true, false);

      input.addEventListener('input', function() {
        checkBtnSubmit(form, input, button, inputErrorMessage, false, false);
      });

      input.addEventListener('change', function() {
        checkBtnSubmit(form, input, button, inputErrorMessage, false, false);
      });

      input.addEventListener('blur', function() {
        checkBtnSubmit(form, input, button, inputErrorMessage, false, true);
      });
    }

    function checkBtnSubmit(form, input, btn, inputErrorMessage, firstCarge, clickOut) {
      if (firstCarge) {
        inputErrorMessage.classList.add('hide');
        setTimeout(function() { btn.disabled = input.value == ''; }, '600');
        return input.value == '';
      }

      if (input.value.length == 1) {
        setTimeout(function() { inputErrorMessage.classList.add('hide'); }, '100');
        btn.disabled = true;
        form[input.name].$setTouched(true);
        return true;
      }

      if (input.value == '' || (input.type == 'email' && !service.isValidEmail(input))) {
        var formInput = form[input.name];
        if (formInput && clickOut && formInput.$touched) inputErrorMessage.classList.remove('hide');
        btn.disabled = true;
        return true;
      }

      inputErrorMessage.classList.add('hide');
      if (form.$valid) {
        btn.disabled = false;
        return false;
      }

      btn.disabled = true;
      return true;
    }

    function isValidEmail(input) {
      return string.emailRegex.test(input.value);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('html', html);

  /* @ngInject */
  function html($document) {
    var service = this;
    service.addClass = addClass;
    service.removeClass = removeClass;
    service.removeAllClass = removeAllClass;
    service.modifyStyle = modifyStyle;
    service.querySelector = querySelector;
    service.querySelectorAll = querySelectorAll;
    service.addInnerHTML = addInnerHTML;
    service.createElement = createElement;

    function addClass(element, value) {
      if (!!element) element.classList.add(value);
    }

    function removeClass(element, value) {
      if (!!element) element.classList.remove(value);
    }

    function removeAllClass(element) {
      if (!!element) element.classList.value = '';
    }

    function modifyStyle(element, property, value) {
      if (!!element) element[0].style[property] = value;
    }

    function querySelector(id) {
      return angular.element($document[0].querySelector(id));
    }

    function querySelectorAll(values) {
      return angular.element($document[0].querySelectorAll(values));
    }

    /** @function
    * @name addInnerHTML
    * @param {string} id - Container ID.
    * @param {string} html - HTML String.
    * @description Add HTML code to container from string.
    */
    function addInnerHTML(id, html) {
      $document[0].getElementById(id).innerHTML = html;
    }

    /** @function
    * @name createElement
    * @param {string} element - HTML element.
    * @description Method to create the HTML element.
    */
    function createElement(element) {
      $document[0].createElement(element);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('kushki', kushki);

  /* @ngInject */
  function kushki(api, env, hero, ngNotify, $document, $localStorage, $log, $rootScope, $templateCache, $uibModal) {
    var service = this;
    service.isDisabled = false;
    service.inProgress = false;
    service.kushkiForm = {};
    service.filterExpiryMonth = filterExpiryMonth;
    service.filterExpiryYear = filterExpiryYear;
    service.openModalInscriptionKushkiCard = openModalInscriptionKushkiCard;
    service.closeModalKushki = closeModalKushki;
    service.kushkiSubscribeCard = kushkiSubscribeCard;
    service.kushkiDeleteSubscribedCard = kushkiDeleteSubscribedCard;
    service.kushkiGenerateCharge = kushkiGenerateCharge;

    var kushkiInstance = new Kushki({
      merchantId: env.KUSHKI_MERCHANT_ID,
      inTestEnvironment: env.KUSHKI_IN_TEST_ENVIRONMENT
    });

    function transformerYear(expiryYear) {
      var year = parseInt(expiryYear, 10);
      if (isNaN(year)) return year;
      return year + 2000;
    }

    function filterExpiryMonth($event) {
      var month        = $event.target.value;
      var year         = angular.element($document[0].getElementById('expiryYear')).val();
      var currentMonth = new Date().getMonth() + 1;
      var currentYear  = new Date().getFullYear();
      month            = parseInt(month, 10);
      year             = transformerYear(year);
      if (month < 0 || month > 12) return service.isDisabled = true;
      if (year == '') return service.isDisabled = true;
      if (year > currentYear || (year == currentYear && month >= currentMonth)) return service.isDisabled = false;
      return service.isDisabled = true;
    };

    function filterExpiryYear($event) {
      var year         = $event.target.value;
      var month        = angular.element($document[0].getElementById('expiryMonth')).val();
      var currentYear  = new Date().getFullYear();
      var currentMonth = new Date().getMonth() + 1;
      year             = transformerYear(year);
      month            = parseInt(month, 10);
      if (year < currentYear || year > currentYear + 10) return service.isDisabled = true;
      if (month == '') return service.isDisabled = true;
      if (year > currentYear || (year == currentYear && month >= currentMonth)) return service.isDisabled = false;
      return service.isDisabled = true;
    };

    function openModalInscriptionKushkiCard() {
      service.kushkiForm = {};
      service.isDisabled = false;
      service.inProgress = false;
      $rootScope.modalInstance = $uibModal.open({
        animation: true,
        size: 'kushki-form',
        keyboard: false,
        backdrop: 'static',
        controller: 'kushkiController as kushki',
        templateUrl: 'app/kushki/{mobile}{desktop}/modal-kushki.html',
        resolve: {
          kushkiSubscribeModal: function() {
            return '';
          }
        }
      });
      $rootScope.openModal = true;
    }

    function closeModalKushki() {
      service.kushkiForm = {};
      service.isDisabled = false;
      service.inProgress = false;
      $rootScope.modalInstance.close();
      $rootScope.openModal = false;
    }

    function kushkiSubscribeCard() {
      service.isDisabled = true;
      service.inProgress = true;
      kushkiInstance.requestSubscriptionToken({
        currency: env.CURRENCY,
        card: {
          name: service.kushkiForm.name,
          number: service.kushkiForm.number,
          cvc: service.kushkiForm.cvv,
          expiryMonth: service.kushkiForm.expiryMonth,
          expiryYear: service.kushkiForm.expiryYear
        },
      }, function(response) {
        if (!response.code) {
          api.payment_gateway.subscribe_card({
            token: response.token,
            gateway_name: 'kushki'
          })
          .then(function(response) {
            var msg = 'Tarjeta de crédito inscrita con éxito.';
            ngNotify.set(msg, 'info');
            hero.setAnalyticsClass('perm-success-saving-kushki-card');
            service.closeModalKushki();
            $rootScope.$broadcast('kushki:subscribe-card');
          })
          .catch(function(err) {
            var msg = errorTextMessage(err);
            ngNotify.set(msg, 'error');
            hero.setAnalyticsClass('perm-error-saving-kushki-card');
            $log.error(msg);
            service.isDisabled = false;
            service.inProgress = false;
          });
        } else {
          var msg = 'Error: ' + response.message;
          ngNotify.set(msg, 'error');
          hero.setAnalyticsClass('perm-error-saving-kushki-card');
          $log.error(msg);
          service.isDisabled = false;
          service.inProgress = false;
        }
      });
    }

    function errorTextMessage(err) {
      if (!!err.data.errors && !!err.data.errors.kushki) {
        var msg = 'Error: ' + err.data.errors.kushki[0].split(': ')[1];
      } else {
        var msg = 'Error: ' + err.data.message.split(': ')[1];
      }
      return msg;
    }

    function kushkiDeleteSubscribedCard(card, $event) {
      var templateUrl = 'app/webpay/confirmation.modal.html';
      var template = $templateCache.get(templateUrl);
      var modalConfig = {
        animation: true,
        keyboard: false,
        backdrop: 'static',
        controller: 'WebpayCardConfirmationModalController',
        controllerAs: 'confirmation',
        windowClass: 'deactivateCardModal'
      };
      if (template) {
        modalConfig.template = template;
      } else {
        modalConfig.templateUrl = templateUrl;
      }
      var modalInstance = $uibModal.open(modalConfig);

      modalInstance.result.then(function(confirmed) {
        if (confirmed) {
          return api.payment_gateway.delete_subscribed_card(
            { id: card.id },
            { token: card.token, gateway_name: 'kushki' }
          )
          .then(function(response) {
            var msg = 'Tarjeta de crédito eliminada con éxito.';
            ngNotify.set(msg, 'info');
            hero.setAnalyticsClass('perm-success-deactivate-kushki-card');
            $rootScope.$broadcast('kushki:delete-card');
          })
          .catch(function() {
            var msg = 'Hubo un problema eliminando tu tarjeta. Intenta más tarde.';
            ngNotify.set(msg, 'error');
            hero.setAnalyticsClass('perm-error-deactivate-kushki-card');
            $log.error(msg);
          });
        }
      }, function(err) {
        console.error(err);
      });
    }

    function kushkiGenerateCharge(options) {
      return new Promise(function(resolve, reject) {
        var subscriptionId = options.subscriptionId;
        var orderId = options.orderId;
        var cardId = options.cardId;
        kushkiInstance.requestDeviceToken({
          subscriptionId: subscriptionId
        }, function(response) {
          if(response.token) {
            api.payment_gateway.generate_charge_oneclick(
              { payment_card_id: cardId },
              { payment_attempt:  {
                  token: response.token,
                  order_id: orderId,
                  gateway_name: 'kushki',
                  subscription_id: subscriptionId
                }}
            ).then(function() {
              var msg = 'Pago realizado con éxito.';
              ngNotify.set(msg, 'info');
              hero.setAnalyticsClass('perm-success-generate-charge-kushki');
              delete $localStorage.currentCustomerCoupon;
              resolve();
            })
            .catch(function(err) {
              var msg = 'Hubo un problema al pagar com tu tarjeta. Intenta más tarde.';
              ngNotify.set(msg, 'error');
              hero.setAnalyticsClass('perm-error-generate-charge-kushki');
              console.error(err);
              reject(err);
            });
          } else {
            var msg = 'Error: ' + response.message;
            ngNotify.set(msg, 'error');
            hero.setAnalyticsClass('perm-error-generate-charge-kushki');
            $log.error(msg);
            reject(msg);
          }
        });
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('hero', hero);

  /* @ngInject */
  function hero($document, html) {
    var service = this;
    service.setAnalyticsClass = setAnalyticsClass;

    function setAnalyticsClass(value, duration) {
      duration = (duration !== undefined) ? duration : 4000;
      var element = $document[0].getElementById('analytics-class');
      html.removeAllClass(element);
      html.addClass(element, value);
      setTimeout(function() { html.removeAllClass(element) }, duration);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('headerCheckout', headerCheckout)
    .controller('HeaderCheckoutController', HeaderCheckoutController);

  /* @ngInject */
  function headerCheckout(env) {
    var directive = {
      bindToController: true,
      controller: HeaderCheckoutController,
      controllerAs: 'vm',
      restrict: 'E',
      templateUrl: 'app/components/header-checkout/{mobile}{desktop}/header-checkout.html'
    };
    return directive;
  }

  /* @ngInject */
  function HeaderCheckoutController(env, $localStorage, $rootScope) {
    var vm = this;
    vm.how = null;
    vm.redirectTo = 'menu';
    $rootScope.envConstants = env;

    activate();

    ////////////////

    $rootScope.$on('checkout:how', function(ev, checkoutHow) {
      vm.how = checkoutHow == 'pickup' ? 'Retiro' : 'Despacho';
    });

    function activate() {
      if (!!$localStorage.how) {
        vm.how = $localStorage.how == 'pickup' ? 'Retiro' : 'Despacho';
      } else {
        vm.how = 'Despacho';
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('gmapIframe', gmapIframe);

  /* @ngInject */
  function gmapIframe() {
    var directive = {
      bindToController: true,
      controller: Controller,
      controllerAs: 'gmap',
      restrict: 'E',
      templateUrl: 'app/components/gmap-iframe/gmap-iframe.html'
    };
    return directive;
  }

  /* @ngInject */
  function Controller(env, $rootScope) {
    var vm = this;
    vm.lonLat = {};
    vm.lonLat.latitude = -33.4059632;
    vm.lonLat.longitude = -70.5608473;
    vm.mapLonLat = angular.copy(vm.lonLat);
    vm.mapOptions = {};
    vm.mapOptions.draggable = true;
    vm.mapOptions.mapTypeControl = false;
    vm.mapOptions.scrollwheel = false;
    vm.mapOptions.streetViewControl = false;
    vm.mapControl = false;
    vm.markerEvents = {
      dragend: function(marker) {
        var position = marker.getPosition();
        var lonLat = {
          longitude: position.lng(),
          latitude: position.lat()
        };
        vm.lonLat.longitude = lonLat.longitude;
        vm.lonLat.latitude = lonLat.latitude;
        vm.mapLonLat.longitude = lonLat.longitude;
        vm.mapLonLat.latitude = lonLat.latitude;
        $rootScope.$broadcast('address:marker-moved', lonLat);
      }
    };

    activate();

    ////////////////

    $rootScope.$on('address:gmap', function(event, lonLat, mapControl) {
      vm.mapControl          = (mapControl !== undefined) ? mapControl : false;
      vm.lonLat.longitude    = lonLat.longitude;
      vm.lonLat.latitude     = lonLat.latitude;
      vm.mapLonLat.longitude = lonLat.longitude;
      vm.mapLonLat.latitude  = lonLat.latitude;
    });

    function activate() {
      var width = 44, height = 58;

      vm.markerOptions = {
        draggable: true,
        icon: {
          url: '/assets/images/address_icon_' + env.ENVIRONMENT + '.svg',
          scaledSize: { width: width, height: height },
          anchor: { x: Math.round(width / 2), y: height }
        }
      };
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('headerCart', headerCart)
    .controller('HeaderController', HeaderController);

  /* @ngInject */
  function headerCart(env) {
    // Usage:
    //  <header-cart/>
    // Creates:
    //  adds a header with a cart counter
    var directive = {
      bindToController: true,
      controller: HeaderController,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: 'app/components/header-cart/{mobile}{desktop}/header-cart.html'
    };
    return directive;

    function link(scope, element, attrs) {
      scope.backState = attrs.backState;
    }
  }

  /* @ngInject */
  function HeaderController (api, cart, customer, $uibModal, $rootScope, $state, $timeout, env, $localStorage) {
    var vm = this;
    vm.customer = customer.get();
    vm.href = $state.href;
    vm.currentState = $state.current.name;
    vm.redirectTo = vm.currentState.includes('menu') ? env.NEW_HOME ? 'home' : 'main' : 'menu';
    vm.logoutModal = logoutModal;
    vm.includeStr = includeStr;
    vm.viewMenu = viewMenu;
    vm.stateIncludes = stateIncludes;
    vm.categories = [];
    vm.menuCategories = [];
    vm.openModalLocation = openModalLocation;
    vm.menuText = env.ENVIRONMENT == 'mxniusushi' ? 'Menú' : 'Carta';
    vm.restaurantText = env.ENVIRONMENT == 'mxniusushi' ? 'Sucursales' : 'Locales';
    vm.restaurantGroup = '';
    vm.stateName = '';
    $rootScope.openModal = false;
    $rootScope.envConstants = env;
    vm.openAddressMethodModal = openAddressMethodModal;
    vm.newHome = env.NEW_HOME;
    vm.primaryAddress = null;
    api.addresses.all()
    .then(function (addresses) {
      if (!addresses || !addresses.length) return;

      var hasPickupSelected = $localStorage.how === 'pickup';
      var selectedAddress = null;

      if (!hasPickupSelected && $localStorage.selectedLocationId) {
        selectedAddress = _.find(addresses, function (address) {
          return address.id === $localStorage.selectedLocationId;
        });
      }

      vm.primaryAddress = selectedAddress || addresses[0];
      if (!vm.primaryAddress) return;

      api.addresses.setCurrent(vm.primaryAddress);

      if (!hasPickupSelected) {
        $localStorage.how = $localStorage.how || 'delivery';
        $localStorage.selectedLocationId = vm.primaryAddress.id;
      }
    });

    activate();
    getCurrentRestaurantGroup();
    getRestaurantGroups();

    function activate() {
      vm.stateName = env.ENVIRONMENT == 'mxniusushi' ? 'signin' : 'passwordless';
      return api.menuCategories.all()
      .then(function(response) {
        vm.menuCategories = response;
      })
      .catch(function(err) {
        console.log(JSON.stringify(err));
      })
      .then(function() {
        getCategories();
      });
    }

    function getRestaurantGroups() {
      return api.restaurantGroups.all()
    }

    function getCurrentRestaurantGroup() {
      if (env.ALLOW_PRICE_LISTS != 'true') return;
      vm.restaurantGroup = api.getCurrentLocation();
      if (vm.restaurantGroup) {
        if (vm.restaurantGroup.open_modal) {
          vm.restaurantGroup.open_modal = false;
          return openModalLocation();
        } else {
          return vm.restaurantGroup;
        }
      } else {
        if($rootScope.deviceType == 'mobile') return;
        return getHeaderCurrentLocation();
      }
    }

    function getHeaderCurrentLocation(){
      return api.getPromiseCurrentLocation()
      .then(function(response) {
        vm.restaurantGroup = response.restaurant_group;
      });
    }

    Object.defineProperty(this, 'count', {
      get: function() {
        return cart.count;
      }
    });

    function Category(name) {
      this.name = name;
      this.isExpanded = false;
      this.seleables = [];
      this.isFavorites = false;
    }

    function getCategories() {
      vm.categories = _.map(vm.menuCategories, function(category) {
        var id  = '#' + _.kebabCase(category.name);
        return { id: id, name: category.name };
      });
      var favorites = { id: '#mis-favoritos', name: 'Mis Favoritos' }
      var latestOrders = { id: '#latest-orders', name: 'Mis pedidos anteriores' }
      vm.categories.unshift(latestOrders);
      vm.categories.unshift(favorites);
    }

    function openModalLocation() {
      var modalInstance = $uibModal.open({
        animation: true,
        // size: 'product modal-type-' + 'products' + ' modal-modifiable-' + 'false',
        size: 'location',
        controller: 'LocationController as location',
        templateUrl: 'app/location/{mobile}{desktop}/location.html',
        resolve: {
          selectedLocation: function() {
            return '';
          }
        }
      });

      return modalInstance.result.finally(function() {
        vm.restaurantGroup.open_modal = false;
      });
    }

    function openAddressMethodModal($event) {
      if ($event) $event.stopPropagation();

      var modal = $uibModal.open({
        animation: true,
        backdrop: true,
        windowClass: 'locationMethodModal',
        controller: 'LocationMethodController',
        controllerAs: 'vm',
        templateUrl: 'app/components/location-method/{mobile}{desktop}/location-method.modal.html',
        resolve: {
          currentAddress: function () {
            return vm.primaryAddress;
          }
        }
      });

      modal.result.then(function (result) {
        if (!result) return;

        if (result.action === 'add-address') {
          $timeout(function () {
            openNewAddressModal();
          }, 0);
          return;
        }

        if (result.method === 'delivery') {
          vm.primaryAddress = result.address;
          api.addresses.setCurrent(result.address);
          $localStorage.how = 'delivery';
          $localStorage.selectedLocationId = result.address.id;
          $localStorage.pickupSelectedFromModal = false;
        }
        if (result.method === 'pickup') {
          $localStorage.selectedLocationId = result.restaurant.id;
          $localStorage.pickupSelectedFromModal = true;
          $localStorage.how = 'pickup';
        }
      });
    }

    function openNewAddressModal() {
      var modal = $uibModal.open({
        animation: true,
        backdrop: 'static',
        controller: 'AddressController',
        controllerAs: 'address',
        windowClass: 'newAddressModal',
        templateUrl: 'app/address/{mobile}{desktop}/address.modal.html',
        resolve: {
          fromLogin: function () {
            return false; 
          }
        }
      });

      modal.result.then(function (newAddress) {
        if (!newAddress) return;
        vm.primaryAddress = newAddress;
        api.addresses.setCurrent(newAddress);
        $localStorage.how = 'delivery';
        $localStorage.selectedLocationId = newAddress.id;
        $rootScope.$broadcast('checkout:how', 'delivery');
        $rootScope.$broadcast('location:changed', newAddress);
      });
    }

    function stateIncludes() {
      return ['menu', 'menu.category'].includes($state.current.name);
    }

    var modalInstance;

    function logoutModal() {
      if (modalInstance) {
        modalInstance.close();
        $rootScope.openModal = false;
        modalInstance = null;
        return;
      }

      modalInstance = $uibModal.open({
        size: 'logout',
        controller: 'ProfileController as profile',
        templateUrl: 'app/profile/desktop/logout.html'
      });

      var onLogin = $rootScope.$on('auth:logout-success', function() {
        modalInstance.close();
        $rootScope.openModal = false;
        onLogin();
      });

      return modalInstance;
    }

    function includeStr(str, args) {
      var regex = new RegExp(args.join('|'), 'gi');
      var resp = regex.test(str);
      return resp;
    }

    function viewMenu() {
      $rootScope.modalInstance = $uibModal.open({
        animation: false,
        size: 'modal-menu',
        controller: 'MenuController as menu',
        templateUrl: 'app/menu/{mobile}/menu.modal.html',
      });
      $rootScope.openModal = true;
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('website')
    .directive('goTo', goTo)
    .controller('GoToController', GoToController);
  /* @ngInject */
  function goTo() {
    // Usage:
    //  <go-to arrow-direction="left or right"
    //    redirect-to="name-by-routes"
    //    class="class-for-element-a">
    //  <go-to/>
    // Creates:
    //  adds a go to with a arrow direction, redirect to and class
    var directive = {
      bindToController: true,
      controller: GoToController,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: 'app/components/go-to/{mobile}{desktop}/go-to.html'
    };
    return directive;
    function link(scope, element, attrs) {
    }
  }
  /* @ngInject */
  function GoToController ($attrs) {
    var vm = this;
    vm.arrowClass = arrowClass();
    vm.redirectTo = $attrs.redirectTo ? $attrs.redirectTo : 'menu';
    vm.parentClass = parentClass($attrs.class);
    vm.textGoTo = textGoTo(vm.redirectTo);

    function arrowClass() {
      var arrowDirection = $attrs.arrowDirection;
      if(arrowDirection == 'left') return 'icon-chevron-left';
      if(arrowDirection == 'right') return 'icon-chevron-right';

      return '';
    }

    function textGoTo(key) {
      var texts = {
        'menu': 'Seguir comprando'
        // Add new redirect key
      }

      return texts[key] ? texts[key] : 'Volver';
    }

    function parentClass(initialClass) {
      return initialClass ? initialClass : 'go-to';
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('footerHome', footerHome);

  /* @ngInject */
  function footerHome(env) {
    // Usage:
    //  <footer-home/>
    // Creates:
    //  adds a footer
    var directive = {
      bindToController: true,
      controller: Controller,
      controllerAs: 'footerHome',
      restrict: 'E',
      templateUrl: 'app/components/footer-home/{mobile}{desktop}/footer-home.html'
    };
    return directive;
  }

  /* @ngInject */
  function Controller (env, $state) {
    var vm                = this;
    vm.localeTos          = '';
    vm.companyName        = env.COMPANY_NAME;
    vm.restaurantSchedule = env.MAIN_RESTAURANT_SCH_1;
    vm.facebookUrl        = env.FACEBOOK_URL;
    vm.instagramUrl       = env.INSTAGRAM_URL;
    vm.tiktokUrl          = env.TIKTOK_URL;
    vm.logoFooter         = env.LOGO_FOOTER_URL;
    vm.hasGenerateReceipt = env.MY_RECEIPT;
    vm.fixedFooter        = fixedFooter;

    activate();

    ////////////////

    function activate() {
      if (env.LOCALE == 'es-cl') {
        vm.localeTos = 'POLITICAS DE PRIVACIDAD';
      }
      if (env.LOCALE == 'es-mx') {
        vm.localeTos = 'AVISO DE PRIVACIDAD';
      }
    }

    function fixedFooter() {
      var resp = $state.includes('main');
      return resp;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('footerCart', footerCart);

  /* @ngInject */
  function footerCart(env) {
    // Usage:
    //  <footer-cart/>
    // Creates:
    //  adds a footer
    var directive = {
      bindToController: true,
      controller: Controller,
      controllerAs: 'footerCart',
      restrict: 'E',
      templateUrl: 'app/components/footer-cart/{mobile}{desktop}/footer-cart.html'
    };
    return directive;
  }

  /* @ngInject */
  function Controller ($state, env) {
    var vm                = this;
    vm.localeTos          = '';
    vm.hasGenerateReceipt = env.MY_RECEIPT;
    vm.fixedFooter        = fixedFooter;

    activate();

    ////////////////

    function activate() {
      localeTos();
    }

    function fixedFooter() {
      var resp = $state.includes('main');
      return resp;
    }

    function localeTos() {
      if (env.LOCALE == 'es-cl') {
        vm.localeTos = 'POLITICAS DE PRIVACIDAD';
      }
      if (env.LOCALE == 'es-mx') {
        vm.localeTos = 'AVISO DE PRIVACIDAD';
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('dateTime', dateTime);

  /* @ngInject */
  function dateTime() {
    var service = this;
    service.setFullDate = setFullDate;
    service.currentDate = currentDate;
    service.timeRem = timeRem;
    service.daysRem = daysRem;
    service.hoursRem = hoursRem;
    service.minRem = minRem;
    service.secRem = secRem;
    service.addMinutes = addMinutes;
    service.removeMinutes = removeMinutes;
    service.addDays = addDays;
    service.checkIfTimeIsInRange = checkIfTimeIsInRange;

    function setFullDate(moreDays, hours, minutes, seconds, milliseconds) {
      var date = new Date();
      date.setDate(date.getDate() + moreDays);
      date.setHours(hours);
      date.setMinutes(minutes);
      date.setSeconds(seconds);
      date.setMilliseconds(milliseconds);
      return date;
    }

    /** @function
    * @name currentDate
    * @param {object} now - Date object containing the current date and time.
    * @param {object} schedule - Date object containing the schedule date and time.
    * @returns {object} Date object containing the time zone date and time.
    */
    function currentDate(now, schedule) {
      var nowYears = now.getFullYear();
      var nowMonth = now.getMonth();
      var nowDays  = now.getDate();
      var date     = new Date(schedule);
      var dateZone = date.getTimezoneOffset();
      var dateMin  = date.getMinutes()
      date.setFullYear(nowYears);
      date.setMonth(nowMonth);
      date.setDate(nowDays);
      date.setMinutes(dateMin + dateZone);

      return date;
    }

    /** @function
    * @name timeRem
    * @param {object} date - Date object.
    * @param {object} now - Date object containing the current date and time.
    * @returns {number} Time remaining.
    */
    function timeRem(date, now) {
      var timeRem = date - now;
      return timeRem;
    }

    /** @function
    * @name daysRem
    * @param {number} timeRem - Time remaining.
    * @returns {number} Days remaining.
    */
    function daysRem(timeRem) {
      var daysRem = Math.floor(timeRem / (1000 * 60 * 60 * 24));
      return daysRem;
    }

    /** @function
    * @name hoursRem
    * @param {number} timeRem - Time remaining.
    * @returns {number} Hours remaining.
    */
    function hoursRem(timeRem) {
      var hoursRem = Math.floor((timeRem % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      return hoursRem;
    }

    /** @function
    * @name minRem
    * @param {number} timeRem - Time remaining.
    * @returns {number} Minutes remaining.
    */
    function minRem(timeRem) {
      var minRem = Math.floor((timeRem % (1000 * 60 * 60)) / (1000 * 60));
      return minRem;
    }

    /** @function
    * @name secRem
    * @param {number} timeRem - Time remaining.
    * @returns {number} Seconds remaining.
    */
    function secRem(timeRem) {
      var secRem = Math.floor((timeRem % (1000 * 60)) / 1000);
      return secRem;
    }

    function addMinutes(date, minutes) {
      return new Date(date.getTime() + minutes * 60000);
    }

    function removeMinutes(date, minutes) {
      return new Date(date.getTime() - minutes * 60000);
    }

    function addDays(date, days) {
      var newdate = new Date(date);
      newdate.setDate(newdate.getDate() + days);
      return newdate;
    }

    function checkIfTimeIsInRange(date, startDate, endDate) {
      var dateHours = date.getHours();
      var dateMinutes = date.getMinutes();
      var startDateHours = startDate.getHours();
      var endDateHours = endDate.getHours();
      var endDateMinutes = endDate.getMinutes();
      var startDateMinutes = startDate.getMinutes();
      if (startDateHours < dateHours && dateHours < endDateHours) {
        return true;
      } else if (startDateHours == dateHours) {
        if (dateHours == endDateHours) {
          return (startDateMinutes <= dateMinutes && dateMinutes <= endDateMinutes)
        } else {
          return (startDateMinutes <= dateMinutes)
        }
      } else if (dateHours == endDateHours) {
        return dateMinutes <= endDateMinutes
      } else {
        return false
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('cartproduct', cartproduct);

  /* @ngInject */
  function cartproduct(_, api, cart, $localStorage, $rootScope, $uibModal) {
    this.addToCart = addToCart;
    this.viewSeleable = viewSeleable;
    this.addCouponProduct = addCouponProduct;


    function addToCart(seleable, category, repeatingOrder) {
      var options, quantity, type, modifiable;
      // is it a product?
      if (seleable.type === 'products') {
        options = defaultOptions(seleable, repeatingOrder);
        modifiable = !_.isEmpty(seleable.modifier_groups);
        if (options) {
          quantity = seleable.quantity || 1;
          type = seleable.type;
          cart.addWithEffect(seleable.id, seleable.name, quantity, options, type, seleable.total_extra_price, modifiable);
          $rootScope.$broadcast('coupon:apply');
          return $rootScope.$broadcast('cart:added');
        }
      } else {
        // is it a promotion?
        if (seleable.type === 'promotions') {
          var haveNoOptions = true; // have no options to choose

          if (seleable.repeat_order) {
            quantity = seleable.quantity || 1;
            type = seleable.type;
            var totalExtraPrice = seleable.total_extra_price;

            var options = {};
            _.each(seleable.promotion_product_groups, function(promotionProductGroup) {
              options[promotionProductGroup.id] = {};

              _.each(promotionProductGroup.products, function(prod) {
                options[promotionProductGroup.id][prod.id] = prod;
                options[promotionProductGroup.id][prod.id].extraPrice = prod.price;
              });
            });
            cart.addWithEffect(seleable.id, seleable.name, quantity, options, type, totalExtraPrice);
            $rootScope.$broadcast('coupon:apply');
            return $rootScope.$broadcast('cart:added');
          }
        }
      }
      
      // open modal asking to select options
      viewSeleable(seleable, category, true);
    }

    function defaultOptions(product, repeatingOrder) {
      if (product.modifier_groups.length > 0 && !repeatingOrder) return false;
      if (product.modifier_groups.length > 0 && repeatingOrder) {
        var optionsTaken = {};
        _.each(product.options, function(opts, key) {
          optionsTaken[key] = JSON.parse(opts);
        });
        return optionsTaken;
      } else { 
        var haveNoOptions = true; // have no options to choose

        var optionsNames = [],
          optionsTaken = product.options || {};
        _.each(product.product_options, function(opts, key) {
          if (opts.length > 1) {
            optionsNames.push(key);
          } else {
            optionsTaken[key] = opts[0];
          }
        });
        var optionsTakenNames = _.keys(optionsTaken);

        // check if options are already taken
        haveNoOptions = _.intersection(optionsNames, optionsTakenNames).length === optionsNames.length;
        if (haveNoOptions) return optionsTaken;
      }
    }

    function viewSeleable(seleable, category, makeSelection, myFavorites) {
      var modifiable = (seleable.modifier_groups && seleable.modifier_groups.length > 0);
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'product modal-type-' + seleable.type + ' modal-modifiable-' + modifiable,
        controller: 'SeleableController as seleable',
        templateUrl: 'app/seleable/{mobile}{desktop}/seleable.html',
        resolve: {
          makeSelection: function() {
            return makeSelection;
          },
          category: function() {
            return category;
          },
          seleable: function() {
            return seleable;
          },
          myFavorites: function() {
            return myFavorites;
          },
          categories: function() {
            return [];
          }
        }
      });

      $rootScope.$broadcast('coupon:apply');

      return modalInstance.result
      .then(function() {
        $rootScope.$broadcast('cart:added');
      })
      .catch(function() {
        console.warn('El modal fue cerrado sin completar una acción.');
      })
      .finally(function() {
        activate();
      });
    }

    function addCouponProduct() {
      var currentCoupon = $localStorage.currentCustomerCoupon;
      if (!currentCoupon.coupon.coupon_type.includes('products', 'products_free')) return;

      _.each(currentCoupon.products_enabled, function(itemId) {
        var couponProduct = api.products.get(itemId);

        var items = cart.products(true);
        var productAdded = _.find(items, function(item) {
          return couponProduct.id == item.id;
        });

        if (productAdded) {
          $rootScope.$broadcast('coupon:apply');
          return;
        }

        addToCart(couponProduct, null);
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('event', event);

  /* @ngInject */
  function event(_, env, $http) {
    var service = this;
    service.getEventData = getEventData;

    function getEventData(eventSelected) {
      var enviroment = env.ENVIRONMENT.replace('-', '');
      return $http.get('app/components/event/' + enviroment + '-event-config.json')
      .then(function(response) {
        var eventJson = response.data;
        if (!eventSelected) return eventJson[enviroment];
        var eventData = _.find(eventJson[enviroment], function(data) {
          return data.code == eventSelected;
        });
        return eventData;
      })
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('customer', customer);

  /* @ngInject */
  function customer(env) {
    this.get = get;
    this.set = set;
    this.showAllBrands = showAllBrands;

    ////////////////

    var currentCustomer = null;

    function get() {
      return currentCustomer;
    }

    function set(newCustomer) {
      currentCustomer = newCustomer;
      return currentCustomer;
    }

    function showAllBrands() {
      return env.ENVIRONMENT !== 'mxniusushi';
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('coupon', coupon);

  /* @ngInject */
  function coupon(api, cart, cartproduct, env, hero, ngNotify, $localStorage, $log, $rootScope, $templateCache, $uibModal) {
    var service = this;
    service.coupons = [];
    service.code = null;
    service.currentCustomerCouponId = $localStorage.currentCustomerCoupon ? $localStorage.currentCustomerCoupon.id : null;

    service.couponsLoad = couponsLoad;
    service.couponsGet = couponsGet;
    service.refreshCoupons = refreshCoupons;
    service.activateCoupon = activateCoupon;
    service.deactivateCoupon = deactivateCoupon;
    service.removeCurrentCoupon = removeCurrentCoupon;
    service.applyCoupon = applyCoupon;
    service.calculateCouponValue = calculateCouponValue;
    service.newCouponModal = newCouponModal;

    activate();

    ////////////////

    function activate() {
      api.coupons.all()
      .then(function(coupons) {
        service.coupons = coupons;
        if ($localStorage.currentCustomerCoupon) {
          var availableCoupon = _.filter(service.coupons, {
            id: $localStorage.currentCustomerCoupon.id
          });
          // Deactivate if no longer available.
          if (availableCoupon.length == 0) delete $localStorage.currentCustomerCoupon;
        }
        $rootScope.$broadcast('coupon:load');
      })
      .catch(onError);
    }

    function couponsLoad() {
      api.coupons.all()
      .then(function(coupons) {
        service.coupons = coupons;
        $rootScope.$broadcast('coupon:load');
      })
      .catch(onError);
    }

    function couponsGet() {
      return service.coupons;
    }

    function refreshCoupons(coupons) {
      service.coupons = coupons;
    }

    function activateCoupon(currentCustomerCouponId) {
      $localStorage.currentCustomerCoupon = _.find(service.coupons, function(customerCoupon) {
        return currentCustomerCouponId == customerCoupon.id;
      });
      return $rootScope.$broadcast('coupon:load');
    }

    function deactivateCoupon(currentCoupon) {
      var templateUrl = 'app/coupon/deactivate-coupon.modal.html';
      var template = $templateCache.get(templateUrl);
      var modalConfig = {
        animation: true,
        backdrop: 'static',
        controller: 'CouponController',
        controllerAs: 'coupon',
        windowClass: 'deactivateCouponModal',
        resolve: {
          currentCoupon: function () {
            return currentCoupon;
          }
        }
      };
      if (template) {
        modalConfig.template = template;
      } else {
        modalConfig.templateUrl = templateUrl;
      }

      var modalInstance = $uibModal.open(modalConfig);
      modalInstance.result.then(function(confirmed) {
        if (confirmed) {
          var msg = 'Cupón eliminado con éxito';
          ngNotify.set(msg, 'info');
          return service.removeCurrentCoupon();
        }
      }, function (e) {
        console.error(e);
      });
    }

    function removeCurrentCoupon() {
      delete $localStorage.currentCustomerCoupon;
      service.couponsLoad();
      api.menuCategories.all(true);
    }

    function applyCoupon(isMobile) {
      var dataCoupon = {
        code: service.code,
        address_id: cart.isDelivery ? $localStorage.selectedLocationId : null,
        restaurant_id: cart.isDelivery ? null : $localStorage.selectedLocationId,
        scheduled_datetime: $localStorage.scheduledOrderDateTime,
        subtotal: cart.subTotalNoDiscount()
      };
      return api.coupons.apply(dataCoupon)
      .then(function(data) {
        if (data.error) {
          ngNotify.set('Cupón inválido.', 'error');
          hero.setAnalyticsClass('perm-error-coupon-invalid');
          $rootScope.$broadcast('coupon:apply');
          return false;
        } else {
          service.coupons = data.coupon_customers;
          var currentCoupon = _.find(service.coupons, function(coupon) {
            return service.code.toLowerCase() == coupon.coupon.code.toLowerCase();
          });
          service.refreshCoupons(service.coupons);
          service.currentCustomerCouponId = currentCoupon.id;
          service.activateCoupon(service.currentCustomerCouponId);

          if (currentCoupon.coupon.coupon_type.includes('products')) {
            api.menuCategories.all(true).then(function() {
              api.products.all().then(function () {
                Promise.all([cartproduct.addCouponProduct()])
                .then(function() {
                  notificationAppliedCoupon(currentCoupon);
                });
              });
            });
          } else {
            notificationAppliedCoupon(currentCoupon);
          }
        }
        $rootScope.$broadcast('coupon:apply');
        return true;
      })
      .catch(function(data) {
        // $log.error(data);
        var message = _.get(data, 'data.message',
          'Hubo un problema aplicando el cupón. Intenta más tarde'
        );
        ngNotify.set(message, 'error');
        hero.setAnalyticsClass('perm-error-applying-coupon');
        return false;
      });
    }

    function notificationAppliedCoupon(currentCustomerCoupon) {
      var msgApplied = '¡Cupón aplicado!';
      var msgAdded = 'Cupón agregado correctamente pero tu compra aún no cumple los requisitos mínimos para poder ser aplicado';
      var msgVariants = 'Cupón agregado correctamente pero tu compra tiene variantes que debes elegir primero para poder aplicar el cupón';
      var msg = couldBeApplied(currentCustomerCoupon) ? msgApplied : msgAdded;
      // Validates products with variants to display a specific message instead of a generic one.
      // if ((currentCustomerCoupon.coupon.coupon_type === 'products' || currentCustomerCoupon.coupon.coupon_type === 'products_free') && msg === msgAdded) {
      //   msg = msgVariants;
      // }
      ngNotify.set(msg);
      hero.setAnalyticsClass('perm-success-applying-coupon');
    }

    function couldBeApplied(currentCustomerCoupon) {
      return service.calculateCouponValue(currentCustomerCoupon) !== 0;
    }

    function calculateCouponValue(customerCoupon) {
      var coupon = customerCoupon.coupon;
      if (!customerCoupon || !customerCoupon.active) return 0;

      // If don't comply with minimum purchase, does not apply.
      var total = cart.discountable() ? cart.subTotal() : cart.subTotalNoDiscount();
      if (total < coupon.min_amount) return 0;

      if (coupon.coupon_type == 'products' || coupon.coupon_type == 'products_free') {
        var couponDiscount = cart.calculateCouponProduct(customerCoupon);
        // If don't comply with minimum purchase, does not apply.
        if (total - couponDiscount < coupon.min_amount) return 0;
        return couponDiscount;
      }

      if (coupon.coupon_type == 'percentage') return Math.round(cart.totalDiscount() * coupon.value/100);
      if (coupon.coupon_type == 'fixed_amount') return parseInt(coupon.value);
    }

    function newCouponModal() {
      var templateUrl = 'app/coupon/coupon.modal.html';
      var template = $templateCache.get(templateUrl);
      var modalConfig = {
        animation: true,
        controller: 'CouponController',
        controllerAs: 'coupon'
      };
      if (template) {
        modalConfig.template = template;
      } else {
        modalConfig.templateUrl = templateUrl;
      }
      var modalInstance = $uibModal.open(modalConfig);
    }

    function onError(err) {
      $log.error(JSON.stringify(err));
      ngNotify.set('Error en la conexión. Intenta más tarde.', 'error');
      hero.setAnalyticsClass('perm-server-error-notify');
    }
  }
})();

angular.module("config", [])

.constant("env", {
	"ENVIRONMENT": "niusushi",
	"URL": "www.niusushi.cl",
	"BASE_URL": "https://niusushi.cl",
	"API_URL": "https://api.niusushi.cl/api/v1/",
	"CENTRAL_SERVER_URL": "https://posserver.niusushi.cl/api/v1/",
	"CENTRAL_SERVER_API_KEY": "f9b366ba38522fuihrauiljof938uhyg2uu019289fh9oijwf2h3f9ojawiefj9244d1e0a87bd6a474cd3ad1bbca5f9e2218ea2a19a473dbde299cb673efdf0b17f3dd26e9a353ee9225ec1b472debe913a8ea87fgbon29fqo8wijfalhf",
	"FAQ": "true",
	"FRANCHISES": "true",
	"ALLOW_PRICE_LISTS": "true",
	"WARNING_PRICE": 70000,
	"DELIVERY": 1500,
	"SEARCH": "true",
	"BANNER": "true",
	"PROMOQR_ON": true,
	"EVENTS": false,
	"NEW_HOME": false,
	"MY_RECEIPT": false,
	"SHOW_TOTAL_ON_BUTTON": true,
	"DEFAULT_DISCOUNT": "0.0",
	"DEFAULT_DISCOUNT_1": "0.0",
	"DEFAULT_DISCOUNT_2": "0.0",
	"MAIN_RESTAURANT_ADDRESS_1": "Av. La Dehesa 1201, Lo Barnechea",
	"MAIN_RESTAURANT_ADDRESS_2": "",
	"MAIN_RESTAURANT_SCH_1": "Lun-Sáb 12:00-17:00 y 18:00-23:30 | Lun-Dom 12:00 a 23:30 (Restaurantes seleccionados).",
	"MAIN_RESTAURANT_PHONE": "+56 2 2247 9001",
	"NG_TOKEN_AUTH_URL": "https://api.niusushi.cl",
	"COMPANY_NAME": "Niu Sushi",
	"LOGO_HEADER_URL": "assets/images/niusushi/niusushi-logo-header.svg",
	"LOGO_FOOTER_URL": "assets/images/desktop/niufoods-logo-footer.svg",
	"LOGO_HEADER_MOBILE_URL": "assets/images/niusushi/niusushi-logo.png",
	"COMPANY_EMAIL": "niusushi@niusushi.cl",
	"ROUTE_TITLE": "Niu Sushi",
	"TITLE_DESCRIPTION": "La cadena de sushi más grande de Chile",
	"FOOD_TYPE": "sushi",
	"COMPANY_FOOD": "Sushi",
	"API_DNS_PREFETCH_URL": "https://api.niusushi.cl/",
	"ASSETS_DNS_PREFETCH_URL": "https://assets.niusushi.cl/",
	"FAVICON_URL": "favicon-niusushi.ico",
	"DISCOUNT_URL": "",
	"BANNER_EVENT_URL": "assets/images/niusushi/banner-event.jpg",
	"RESTAURANT_ICON_ACTIVE_URL": "assets/images/desktop/titled-icon-active_niusushi.png",
	"RESTAURANT_ICON_INACTIVE_URL": "assets/images/desktop/titled-icon_niusushi.png",
	"RESTAURANT_MENU_DESKTOP": "assets/images/niusushi/cartatragos-desktop-A-june.webp",
	"RESTAURANT_MENU_DESKTOP_2": "",
	"RESTAURANT_MENU_MOBILE": "assets/images/niusushi/cartatragos-mobile-june.webp",
	"BEERS_MENU_DESKTOP": "assets/images/niusushi/cartacerveza-desktop-june.webp",
	"BEERS_MENU_MOBILE": "assets/images/niusushi/cartacerveza-mobile-june.webp",
	"BAR_MENU_DESKTOP": "assets/images/niusushi/cartatragos-desktop-A-june.webp",
	"BAR_MENU_MOBILE": "assets/images/niusushi/cartatragos-mobile-june.webp",
	"KIDS_MENU_DESKTOP": "",
	"KIDS_MENU_MOBILE": "",
	"GOOGLE_MAPS_API_KEY": "AIzaSyDGna4m27F80zM-NJmdLqTmHA5Fyj4zgHA",
	"GOOGLE_SITE_VERIFICATION": "-jMvslXAzcrYxQ_r3HwmHt_JPK2qiJyOCUgPhnbXTOI",
	"GOOGLE_TAG_MANAGER_ID": "GTM-NDKLDX6",
	"GOOGLE_ANALYTICS_TRACKING_NUM": "UA-20324301-1",
	"GOOGLE_CONVERSION_ID": "",
	"GOOGLE_CONVERSION_LABEL": "",
	"COUNTRY": "CL",
	"CURRENCY": "CLP",
	"LOCALE": "es-cl",
	"KUSHKI_MERCHANT_ID": "b8f771c5cccd491fbdb0511da95d428b",
	"KUSHKI_IN_TEST_ENVIRONMENT": false,
	"FACEBOOK_PIXEL_ID": "5583138815035220",
	"FACEBOOK_DOMAIN_ID": "dvr91ccbfhm43pviys1ftp94ft90d8",
	"FACEBOOK_URL": "https://www.facebook.com/niusushi/",
	"INSTAGRAM_URL": "https://www.instagram.com/niusushi/",
	"TIKTOK_URL": "https://www.tiktok.com/@niusushicl",
	"APP_IOS_STORE_LINK": "https://apps.apple.com/cl/app/niu-foods/id6446782707",
	"APP_ANDROID_STORE_URL": "https://play.google.com/store/apps/details?id=com.niufoods.niufoodsapp",
	"TAG_PLACEHOLDER_SEARCH": "Ej: Con pollo, sin salmón, etc.",
	"MENU_PLACEHOLDER_SEARCH": "Busca tu roll",
	"NOTICE_BAR": "¿Y si eliminamos el home?",
	"ROOT_DESCRIPTION": "Santiago, Viña del Mar, Concón, Machalí, Talca, Antofagasta, La Serena, Concepción y Temuco. Próximamente en más Regiones",
	"KEYWORDS": "comida, sushi, delivery, santiago, las condes, lo barnechea, barato, domicilio, restaurant",
	"FOOTER_DESCRIPTION": "En Niu Sushi tenemos el mejor sushi de Chile.",
	"FOOTER_DELIVERY_DESCRIPTION": "Tenemos despacho a domicilio, consumo en local y retiro",
	"DELIVERY_COMMUNES": "Las condes, Vitacura, Providencia, La reina y Ñuñoa.",
	"PHONE_INITIAL_COUNTRY": "cl",
	"PHONE_PREFERRED_COUNTRIES": [
		"cl"
	],
	"AMIPASS_LOCAL_ID": "909",
	"AMIPASS_ESTABLISHMENT_ID": "10289",
	"PLUXEE_MERCHANT_ID": 1338,
	"TIPS": [
		{
			"id": 1,
			"amount": 0,
			"formattedAmount": "$0",
			"default": false
		},
		{
			"id": 2,
			"amount": 1250,
			"formattedAmount": "$1.250",
			"default": true
		},
		{
			"id": 3,
			"amount": 2500,
			"formattedAmount": "$2.500",
			"default": false
		},
		{
			"id": 4,
			"amount": 4000,
			"formattedAmount": "$4.000",
			"default": false
		}
	],
	"INDEX_LD_JSON": [
		{
			"@context": "http://schema.org/",
			"@type": "Product",
			"name": "Sugerencias",
			"image": "",
			"description": "¿No sabes qué pedir? ¡Nosotros te ayudamos!",
			"mpn": "925872",
			"brand": {
				"@type": "Thing",
				"name": "Sushi"
			},
			"aggregateRating": {
				"@type": "AggregateRating",
				"ratingValue": "5.0",
				"reviewCount": "89"
			}
		},
		{
			"@context": "http://schema.org/",
			"@type": "Product",
			"name": "Para Empezar",
			"image": "",
			"description": "Para Empezar",
			"mpn": "925872",
			"brand": {
				"@type": "Thing",
				"name": "Sushi"
			},
			"aggregateRating": {
				"@type": "AggregateRating",
				"ratingValue": "5.0",
				"reviewCount": "92"
			}
		},
		{
			"@context": "http://schema.org/",
			"@type": "Product",
			"name": "Principal",
			"image": "",
			"description": "Plato Principal",
			"mpn": "925872",
			"brand": {
				"@type": "Thing",
				"name": "Sushi"
			},
			"aggregateRating": {
				"@type": "AggregateRating",
				"ratingValue": "5.0",
				"reviewCount": "98"
			}
		},
		{
			"@context": "http://schema.org/",
			"@type": "Product",
			"name": "Principal",
			"image": "",
			"description": "Para Acompañar",
			"mpn": "925872",
			"brand": {
				"@type": "Thing",
				"name": "Sushi"
			},
			"aggregateRating": {
				"@type": "AggregateRating",
				"ratingValue": "5.0",
				"reviewCount": "98"
			}
		}
	]
})

;
(function() {
  'use strict';

  angular
    .module('website')
    .directive('carousel', carousel)
    .controller('CarouselController', CarouselController);

  /* @ngInject */
  function carousel(env) {
    // Usage:
    //  <carousel><carousel/>
    // Creates:
    //
    var directive = {
      bindToController: true,
      controller: CarouselController,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: 'app/components/carousel/{mobile}{desktop}/carousel.html'
    };
    return directive;

    function link(scope, element, attrs) {
    }
  }

  /* @ngInject */
  function CarouselController (api, env, $log, $rootScope, $scope, $state) {
    var vm          = this;
    vm.currentState = $state.current.name;
    vm.newHome      = env.NEW_HOME;
    vm.next         = next;
    vm.prev         = prev;
    vm.dot          = dot;
    vm.goToUrl      = goToUrl;
    vm.rootScope    = $rootScope;

    $scope.$on('$destroy', function() {
      clearInterval($rootScope.carouselInterval);
      $rootScope.carouselInterval = null;
    });

    activate();

    function activate() {
      getImages();
    }

    function defaultImage() {
      var imageUrl = '/assets/images/' + env.ENVIRONMENT;
      imageUrl += '/' + env.ENVIRONMENT + '-' + vm.rootScope.deviceType + '-pattern.png';
      var imageData = {
        image: imageUrl,
        active_class: 'active',
        redirect: '/carta',
        alt: 'Imagen principal'
      };
      vm.images = [imageData];
      vm.totalImages = 1;
      return vm.images;
    }

    function getImages() {
      var isMobile = vm.rootScope.deviceType == 'mobile';
      // TODO: Change when the carousel is busy with more types
      //    of images and another service should be called
      return api.settings.banner('banner', isMobile)
      .then(function(images) {
        var imagesData = [];
        images.forEach(function(images, index) {
          var redirect_url = images.redirect_url.includes('http') ? images.redirect_url : 'https://' + images.redirect_url;
          imagesData.push({
            image: isMobile ? images.mobile_image : images.desktop_image,
            active_class: index === 0 ? 'active' : '',
            redirect: redirect_url,
            index: index,
            alt: images.name
          })
        });

        vm.images = imagesData;
        vm.totalImages = imagesData.length;

        if (vm.images.length === 0) return defaultImage();
        return imagesData;
      })
      .then(function() {
        if (vm.totalImages > 1) cycleInterval();
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
        defaultImage();
      });
    }

    function cycleInterval() {
      if ($rootScope.carouselInterval === null || $rootScope.carouselInterval === 'undefined') {
        $rootScope.carouselInterval = setInterval(vm.next, 5000);
      } else {
        clearInterval($rootScope.carouselInterval);
        $rootScope.carouselInterval = null;
      }
    }

    function next() {
      changeActiveImage(false, true);
    }

    function prev() {
      changeActiveImage(true, false);
    }

    function changeActiveImage(isPrev, isNext) {
      var currentImage = activeImage();
      var indexCurrentImage = !!currentImage ? (+currentImage.dataset.index) : 0;
      var indexNextImage = null;
      if(isPrev) indexNextImage = indexCurrentImage === 0 ? vm.totalImages - 1 : indexCurrentImage - 1;
      if(isNext) indexNextImage = indexCurrentImage === vm.totalImages - 1 ? 0 : indexCurrentImage + 1;

      deactivateActiveImage();
      activateImage(indexNextImage);
      indicator(indexCurrentImage, indexNextImage);
      cycleInterval();
    }

    function indicator(previousIndex, currentIndex) {
      var previousDot = getElement('.dot-container button[data-index="' + (+previousIndex) + '"]');
      var currentDot = getElement('.dot-container button[data-index="' + (+currentIndex) + '"]');
      if (!!previousDot) previousDot.classList.remove('active');
      if (!!currentDot) currentDot.classList.add('active');
    }

    function dot(e) {
      var indexSelected = e.target.dataset.index;
      var previousIndexDot = getElement('.dot-container button.active').dataset.index;
      indicator(previousIndexDot, indexSelected);
      deactivateActiveImage();
      activateImage(indexSelected);
    }

    function deactivateActiveImage() {
      var currentImage = activeImage();
      if (!!currentImage) currentImage.classList.remove('active');
      return currentImage;
    }

    function activeImage() {
      return getElement('.carousel-image.active');
    }

    function activateImage(index) {
      var nextImage = getElement('.carousel-image[data-index="' + (+index) + '"]');
      if (!!nextImage) nextImage.classList.add('active');
      return nextImage;
    }

    function getElement(query) {
      return document.querySelector(query);
    }

    function goToUrl(url) {
      document.location.href = url;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('cart', cart);

  /* @ngInject */
  function cart(_, api, env, hero, ngNotify, $localStorage, $q) {
    var service = this;
    service.count = 0;
    service.isDelivery = false;
    service.deliveryCost = env.DELIVERY;
    service.calculatedProducts = {};
    service.calculatedProducts.set = calculatedProductsSet;
    service.additionalProduct = {};
    service.additionalProduct.set = additionalProductSet;
    service.additionalProduct.get = additionalProductGet;

    service.save = save;
    service.setSeleableProperty = setSeleableProperty;
    service.moveCart = moveCart;
    service.addWithEffect = addWithEffect;
    service.add = add;
    service.get = get;
    service.remove = remove;
    service.removeAll = removeAll;
    service.total = total;
    service.subTotal = subTotal;
    service.subTotalNoDiscount = subTotalNoDiscount;
    service.totalDiscount = totalDiscount;
    service.discount = discount;
    service.setDiscount = setDiscount;
    service.setDefaultDiscount = setDefaultDiscount;
    service.discountable = discountable;
    service.getSeleable = getSeleable;
    service.getPrice = getPrice;
    service.discountPrice = discountPrice;
    service.price = price;
    service.parseIntl = parseIntl;
    service.discountPriceIntl = discountPriceIntl;
    service.priceIntl = priceIntl;
    service.extraPriceIntl = extraPriceIntl;
    service.seleablePriceIntl = seleablePriceIntl;
    service.showCoupon = showCoupon;
    service.freeShipping = freeShipping;
    service.products = products;
    service.additionalItems = additionalItems;
    service.itemsCount = itemsCount;
    service.findKushkiCard = findKushkiCard;
    service.findTbkCard = findTbkCard;
    service.cardTypeName = cardTypeName;
    service.showDiscountPercentage = showDiscountPercentage;
    service.calculateCouponProduct = calculateCouponProduct;
    service.priceValue = priceValue;

    var items = {
      products: {},
      promotions: {},
      additionalProducts: {}
    };

    activate();

    ////////////////

    function activate() {
      $q.all([api.additionalProducts.all(), api.products.all(), api.promotions.all()])
      .then(function() {
        // load items from LS
        if ($localStorage.cartServiceItems) items = $localStorage.cartServiceItems;
        if (!(items.products || items.promotions)) throw 'LS cart is not valid';
        service.count = 0;
        _.each(items, function(seleableItems, type) {
          var setSeleablePropertyCurried = _.curry(setSeleableProperty)(_, type);
          // add 'seleable' property to every item
          _.each(seleableItems, function(itemList) {
            _.each(itemList, setSeleablePropertyCurried);
          });
          // count
          service.count += _.map(seleableItems, function(itemList, id) {
            if (type === 'products' && service.price(id, true, type) === 0) return 0;
            return service.get(id, null, type);
          }).reduce(_.add, 0);
        });
        service.save();
      }).catch(function() {
        items = $localStorage.cartServiceItems = {
          products: {},
          promotions: {},
          additionalProducts: {}
        };
        service.count = 0;
      });
    }

    function calculatedProductsSet(prod) {
      var oldValue = service.get(prod.id);
      var newValue = additionalProductsCalculate(prod);

      if (oldValue < newValue) {
        service.add(prod.id, newValue - oldValue);
      } else if (newValue < oldValue) {
        service.remove(prod.id, oldValue - newValue);
      }

      return newValue;
    }

    function additionalProductsCalculate(additionalProduct) {
      var totalNumber = 0;
      _.each(items, function(seleableItems) {
        _.each(seleableItems, function(itemList) {
          _.each(itemList, function(item) {
            // is it a product?
            var seleable = item.seleable;
            if (seleable.is_additional) return;

            if (seleable.type === 'products') {
              totalNumber += calculateAdditionalByProduct(seleable, item.quantity, additionalProduct);
            } else {
              // is it a promotions?
              if (seleable.type === 'promotions') {
                _.each(seleable.promotion_product_groups, function(promotion_group) {
                  _.each(promotion_group.products, function(product) {
                    if (!item.options[promotion_group.id][product.id].selected) return;
                    totalNumber += calculateAdditionalByProduct(product, item.quantity, additionalProduct);
                  });
                });
              }
            }
          });
        });
      });

      var minValue = totalNumber > 0 ? 1 : 0;
      return Math.max(minValue, Math.round(totalNumber));
    }

    function calculateAdditionalByProduct(product, quantity, additionalProduct) {
      var totalNumber = 0;
      var firstCategory = product.menu_categories ? product.menu_categories[0] : '';

      if (additionalProduct.m_categories.length > 0) {
        if (product.menu_categories.length > 1) firstCategory = getMainMenuCategory(product, additionalProduct);
        totalNumber = calculateByAdditionalCategory(quantity, additionalProduct, firstCategory, totalNumber);
      } else {
        totalNumber = quantity * additionalProduct.quantity;
      }

      return totalNumber;
    }

    function getMainMenuCategory(product, additionalProduct) {
      var majorCategory = additionalProduct.m_categories.reduce(function(prev, current) {
        return (prev.quantity > current.quantity ) ? prev : current;
      });

      var firstCategory = _.find(product.menu_categories, function(menuCat) {
        return majorCategory.name === menuCat;
      });

      return firstCategory ? firstCategory : product.menu_categories ? product.menu_categories[0] : '';
    }

    function calculateByAdditionalCategory(quantity, additionalProduct, firstCategory, totalNumber) {
      var additionalCategory = _.find(additionalProduct.m_categories, function(additionalCat) {
        return firstCategory === additionalCat.name;
      });

      if (additionalCategory) {
        totalNumber = quantity * additionalCategory.quantity;
      } else {
        totalNumber = additionalProduct.quantity > 0 ? quantity * additionalProduct.quantity : totalNumber;
      }

      return totalNumber;
    }

    function additionalProductSet(item) {
      var product = api.additionalProducts.get({ name: item.name });
      var oldValue = service.get(product.id),
          newValue;

      if (item.option_on && oldValue === 0) {
        newValue = service.add(product.id, parseInt(product.quantity));
      } else if (!item.option_on && oldValue > 0) {
        newValue = service.remove(product.id, parseInt(product.quantity));
      } else {
        newValue = oldValue;
      }

      return newValue > 0;
    }

    function additionalProductGet(item) {
      var selectedProduct = api.additionalProducts.get({ name: item.name });
      return service.get(selectedProduct.id) > 0;
    }

    function save() {
      var MS_PER_HOUR = 1000 * 60 * 60,
        now = Date.now();

      _.each(items, function(seleableItems, type) {
        _.each(seleableItems, function(itemList, id) {
          _.remove(itemList, function(item) {
            if (!item.seleable) {
              service.count -= item.quantity;
              return true;
            }
            if (item.modifiable == true && _.isEmpty(item.options)) {
              service.count -= item.quantity;
              logItemWithoutModifiers(item, items);
              return true;
            }
            var updatedAt = item.updatedAt || item.addedAt;
            if ((now - updatedAt) / MS_PER_HOUR > 2) {
              if (type !== 'products' || service.price(id, true, type) !== 0) {
                service.count -= item.quantity;
              }
              return true;
            }
          });
        });
      });

      $localStorage.cartServiceItems = items;
    }

    function logItemWithoutModifiers(itemWithoutModifiers, cartItems) {
      ngNotify.set('Tuvimos un problema agregando el producto, intenta nuevamente o contáctanos', 'error');
      hero.setAnalyticsClass('perm-error-product-without-modifiers');

      var allItems = Object.values(cartItems.products).reduce(function(acc, items) {
        return acc.concat(items);
      }, []);
      var mappedItems = allItems.map(function(item) {
        return { item: { seleable: item.seleable } };
      });
      var payload = { items: mappedItems };
      var logGroup = "PRODUCTOS-SIN-MODIFICADORES-" + env.ENVIRONMENT.toUpperCase();
      var streamName = itemWithoutModifiers.seleable.name.replace(/ /g, "-").toLowerCase() + "__" + itemWithoutModifiers.id;

      // TODO: Moves to independent service
      var data = {
        'cloud_watch_log': {
          'payload': payload,
          'group_name': logGroup,
          'stream_name': streamName
        }
      };
      api.setEventLogs(data);
    }

    function setSeleableProperty(item, type) {
      if (item.seleable) return;
      Object.defineProperty(item, 'seleable', {
        get: function() {
          var result = api[type].get(item.id) || api.additionalProducts.get(item.id);
          if (!result) return item.type === 'promotions' ? false : delete items[item.type][item.id];
          return result;
        }
      });
    }

    function calculateSeleableQuantity (seleable, quantity) {
      return seleable.normal_price > 0 || seleable.additional_type === 'calculated' ? quantity : 0;
    }

    function moveCart() {
      var cart = document.querySelector('a.navbar-cart');
      if (cart) {
        cart.classList.add(cart, 'shake');
        setTimeout(function() {
          cart.classList.remove(cart, 'shake');
        }, 1000);
      } else {
        console.warn('El elemento navbar-cart no está disponible en el DOM.');
      }
    }

    function addWithEffect(id, name, quantity, options, type, extraPrice, modifiable) {
      add(id, quantity, options, type, extraPrice, modifiable);
      moveCart();
    }

    function add(id, quantity, options, type, extraPrice, modifiable) {
      quantity = quantity ? quantity : 1;
      options = options ? options : {};
      type = type ? type : 'products';
      extraPrice = extraPrice ? extraPrice : 0;

      var itemList = items[type][id] || [];
      var item, i;
      for (i = 0; i < itemList.length; i++) {
        if (_.eq(itemList[i].options, options)) {
          item = itemList[i];
          break;
        }
      }

      if (item) {
        item.quantity += calculateSeleableQuantity(item.seleable, quantity);
        item.updatedAt = Date.now();
      } else {
        item = {
          id: id,
          quantity: quantity,
          options: options,
          type: type,
          extraPrice: extraPrice,
          modifiable: modifiable,
          addedAt: Date.now(),
          updatedAt: Date.now()
        };
        setSeleableProperty(item, type);

        if (!items[type][id]) items[type][id] = [];
        items[type][id].push(item);
      }

      service.save();

      if (!(type === 'products' && service.price(id, true, type) === 0)) {
        service.count += quantity;
      }

      return service.get(id, options, type);
    }

    function get(id, options, type) {
      type = type ? type : 'products';

      var itemList = (items[type][id] || []);
      if (options) {
        var item = _.find(itemList, {options: options});
        return item ? parseInt(item.quantity) : 0;
      }

      return itemList.map(function(item) {
        return item.quantity;
      }).reduce(_.add, 0);
    }

    function remove(id, quantity, options, type) {
      quantity = quantity ? quantity : 1;
      options = options ? options : {};
      type = type ? type : 'products';

      var itemList = items[type][id] || [];
      var item, i;
      for (i = 0; i < itemList.length; i++) {
        if (_.eq(itemList[i].options, options)) {
          item = itemList[i];
          break;
        }
      }

      if (!item) return;

      quantity = Math.min(quantity, item.quantity);

      if (item.seleable.normal_price > 0) {
        item.quantity -= quantity;
      } else {
        item.quantity = 0;
      }

      item.updatedAt = Date.now;
      if (!(type === 'products' && service.price(id, true, type) === 0)) service.count -= quantity;

      if (item.quantity === 0) {
        itemList.splice(i, 1);
        if (itemList.length) {
          items[type][id] = itemList;
        } else {
          delete items[type][id];
        }
      }
      save();
    }

    function removeAll() {
      _.each(items, function (types, type) {
        _.each(types, function (itemList, id) {
          _.each(itemList, function (item) {
            service.count -= item.quantity;
          });
          delete items[type][id];
        });
      });

      save();
    }

    var genericTotal = function(applyDiscount, delivery) {
      var prices = [],
        quantities = [];

      _.each(items, function(seleableItems, type) {
        _.each(seleableItems, function(itemList, id) {
          itemList.forEach(function(item) {
            prices.push(service.price(id, applyDiscount, type, item.extraPrice));
            quantities.push(item.quantity);
          });
        });
      });

      return prices.map(function(price, i) {
        return price * quantities[i];
      }).reduce(_.add, (delivery && service.isDelivery) ? service.deliveryCost : 0);
    };

    function subTotalNoDiscount() {
      return genericTotal(false, false);
    }

    function total() {
      return genericTotal(false, true);
    }

    function subTotal() {
      return genericTotal(true, false);
    }

    function totalDiscount(extraDiscount) {
      extraDiscount = extraDiscount ? extraDiscount : 0;
      var totalAmount = genericTotal(true, false) - extraDiscount;
      return (totalAmount > 0 ? totalAmount : 0);
    }

    /** @var {number} currentDiscount - Stores the current discount value initialized from the environment configuration. */
    var currentDiscount = parseFloat(env.DEFAULT_DISCOUNT);

    /** @function
    * @name discount
    * @returns {number} Returns the current discount value.
    * @description Retrieves the current discount value.
    */
    function discount() {
      return currentDiscount;
    }

    /** @function
    * @name setDiscount
    * @param {number} newDiscount - The new discount value to be set.
    * @returns {number} Returns the updated discount value.
    * @description Updates the current discount value and returns it.
    */
    function setDiscount(newDiscount) {
      currentDiscount = newDiscount;
      return currentDiscount;
    }

    /** @function
    * @name setDefaultDiscount
    * @description Sets the default discount value from the environment configuration.
    */
    function setDefaultDiscount() {
      setDiscount(parseFloat(env.DEFAULT_DISCOUNT));
    }

    /** @function
    * @name discountable
    * @returns {boolean} Returns true if the default discount is greater than 0, otherwise false.
    */
    function discountable() {
      return parseFloat(env.DEFAULT_DISCOUNT) > 0;
    }

    /** @function
    * @name getSeleable
    * @param {number} id - The ID of the item.
    * @param {string} type - The type of the item (default is 'products').
    * @returns {object|null} Returns the selected item from the API or null if not found.
    */
    function getSeleable(id, type) {
      type = type ? type : 'products';
      var seleable = api[type].get(id);
      return seleable;
    }

    /** @function
    * @name getPrice
    * @param {boolean} applyDiscount - Whether to apply the discount.
    * @param {boolean} seleableDiscount - Indicates if the item has a discount.
    * @param {number} seleablePrice - The base price of the item.
    * @param {number} extraPrice - Additional price to be added.
    * @returns {number} Returns the final price after applying the discount if applicable.
    */
    function getPrice(applyDiscount, seleableDiscount, seleablePrice, extraPrice) {
      var p = seleablePrice + extraPrice;
      if (applyDiscount && seleableDiscount) p *= (1 - service.discount());
      return Math.round(p);
    }

    /** @function
    * @name discountPrice
    * @param {number} id - The ID of the item.
    * @param {string} type - The type of the item (default is 'products').
    * @param {number} extraPrice - Additional price to be added (default is 0).
    * @returns {number} Returns the discounted price if applicable, otherwise the normal price.
    */
    function discountPrice(id, type, extraPrice) {
      var seleable = service.getSeleable(id, type);
      if (!seleable) return 0;

      return service.getPrice(false, seleable.discount, seleable.normal_price, extraPrice ? extraPrice : 0);
    }

    /** @function
    * @name price
    * @param {number} id - The ID of the item.
    * @param {boolean} applyDiscount - Whether to apply the discount.
    * @param {string} type - The type of the item (default is 'products').
    * @param {number} extraPrice - Additional price to be added (default is 0).
    * @returns {number} Returns the final price, considering any applicable discount and the lowest price available.
    */
    function price(id, applyDiscount, type, extraPrice) {
      var seleable = service.getSeleable(id, type);
      if (!seleable) return 0;

      var seleablePrice = seleable.discount || seleable.special_price <= 0 || seleable.normal_price <= seleable.special_price
        ? seleable.normal_price
        : seleable.special_price;
      return service.getPrice(applyDiscount, seleable.discount, seleablePrice, extraPrice ? extraPrice : 0);
    }

    /** @function
    * @name parseIntl
    * @param {number} price.
    * @returns {string} Return price formatted according to the language and formatting options of this Intl.NumberFormat object.
    */
    function parseIntl(price) {
      var resp = new Intl.NumberFormat('es-' + env.COUNTRY, { style: 'currency', currency: env.CURRENCY }).format(price);
      return resp;
    }

    /** @function
    * @name discountPriceIntl
    * @param {number} itemId - The ID of the item.
    * @param {string} itemType - The type of the item (default is 'products').
    * @param {number} extraPrice - Additional price to be added.
    * @returns {string} Returns the final price formatted according to the user's locale.
    */
    function discountPriceIntl(itemId, itemType, extraPrice) {
      var resp = service.discountPrice(itemId, itemType, extraPrice);
      var respIntl = service.parseIntl(resp);
      return respIntl;
    }

    /** @function
    * @name priceIntl
    * @param {number} itemId - The ID of the item.
    * @param {boolean} applyDiscount - Whether to apply the discount.
    * @param {string} itemType - The type of the item (default is 'products').
    * @param {number} extraPrice - Additional price to be added.
    * @returns {string} Returns the final price formatted according to the user's locale.
    */
    function priceIntl(itemId, applyDiscount, itemType, extraPrice) {
      var resp = service.price(itemId, applyDiscount, itemType, extraPrice);
      var respIntl = service.parseIntl(resp);
      return respIntl;
    }

    /** @function
    * @name extraPriceIntl
    * @param {number} extraPrice - Additional price to be added (default is 0).
    * @param {boolean} applyDiscount - Whether to apply the discount.
    * @returns {string} Return extra price with the discount applied or not and formatted according to Intl.NumberFormat object.
    */
    function extraPriceIntl(extraPrice, applyDiscount) {
      if (applyDiscount && service.discountable()) extraPrice *= (1 - service.discount());
      extraPrice = Math.round(extraPrice);
      return service.parseIntl(extraPrice);
    }

    /** @function
    * @name seleablePriceIntl
    * @param {object} seleable - The item object containing price and discount information.
    * @param {number} extraPrice - Additional price to be added (default is 0).
    * @returns {string} Returns the item's final price formatted according to the user's locale.
    * @description Determines the correct price for the item, applies the discount if applicable, and formats it using international currency formatting.
    */
    function seleablePriceIntl(seleable, extraPrice) {
      var seleablePrice = seleable.discount || seleable.special_price <= 0 || seleable.normal_price <= seleable.special_price
        ? seleable.normal_price
        : seleable.special_price;
      var price = service.getPrice(true, seleable.discount, seleablePrice, extraPrice ? extraPrice : 0);
      return service.parseIntl(price);
    }

    function showCoupon(coupon) {
      if (coupon.coupon_type == 'fixed_amount') {
        var caption = service.parseIntl(coupon.value) + ' dcto';
        if (coupon.min_amount > 0) caption += '. Min compra: ' + service.parseIntl(coupon.min_amount);
        return caption;
      }
      return coupon.caption;
    }

    function freeShipping() {
      return parseInt(service.deliveryCost) === 0;
    }

    // TODO: rename to seleables()
    function products(includeAll) {
      var allProducts = [];
      _.each(items, function(seleableItems, type) {
        _.each(seleableItems, function(itemList, id) {
          var costZero = type === 'products' &&
            service.price(id, true, type) === 0;
          if (!includeAll && costZero) return;
          _.each(itemList, function(item) {
            allProducts.push(item);
          });
        });
      });

      return allProducts.sort(function(item1, item2) {
        return item1.addedAt > item2.addedAt;
      });
    }

    function additionalItems() {
      var allProducts = [];

      function getAdditionalItemPriority(itemName) {
        var normalizedName = (itemName || '')
          .toString()
          .trim()
          .toLowerCase();
        if (normalizedName.indexOf('soya') >= 0) {
          return 0;
        }
        if (normalizedName.indexOf('palito') >= 0) {
          return 1;
        }
        return Number.MAX_SAFE_INTEGER;
      }

      _.each(items, function(seleableItems, type) {
        _.each(seleableItems, function(itemList, id) {
          var costZero = type === 'products' &&
            service.price(id, true, type) === 0;

          if (!costZero) return;

          _.each(itemList, function(item) {
            allProducts.push({
              id: item.id,
              name: item.seleable.name,
              quantity: item.quantity,
              addedAt: item.addedAt,
              position: item.seleable.additional_type === 'calculated' ? 0 : 1
            });
          });
        });
      });

      return allProducts.sort(function(item1, item2) {
        if (item1.position !== item2.position) {
          return item1.position - item2.position;
        }
        var item1Priority = getAdditionalItemPriority(item1.name);
        var item2Priority = getAdditionalItemPriority(item2.name);
        if (item1Priority !== item2Priority) {
          return item1Priority - item2Priority;
        }
        if (item1.addedAt !== item2.addedAt) {
          return item1.addedAt - item2.addedAt;
        }
        return item1.name.localeCompare(item2.name);
      });
    }

    function itemsCount() {
      return service.count;
    }

    function findKushkiCard(kushkiCards, creditCard) {
      return _.find(kushkiCards, function(kushkiCard) {
        return creditCard == kushkiCard.token;
      });
    }

    function findTbkCard(tbkCards, creditCard) {
      return _.find(tbkCards, function(tbkCard) {
        return creditCard == tbkCard.id;
      });
    }

    function cardTypeName(cardType) {
      return cardType ? cardType.toUpperCase() : '';
    }

    function showDiscountPercentage() {
      return env.ENVIRONMENT !== 'mxniusushi';
    }

    function calculateCouponProduct(customerCoupon) {
      var couponProductDiscount = 0;
      var cartItems = service.products();
      var cartCouponProducts = _.filter(cartItems, function(item) {
        return customerCoupon.products_enabled.includes(item.id);
      });

      _.each(cartCouponProducts, function(item) {
        var price = service.priceValue(item, true, false);
        couponProductDiscount += price;
      });

      return couponProductDiscount;
    }

    function priceValue(seleable, applyDiscount, isIntl) {
      var resp = service.price(seleable.id, applyDiscount, seleable.type);
      if (!isIntl) return resp;
      var respIntl = service.parseIntl(resp);
      return respIntl;
    }
  }
})();


(function() {
  'use strict';

  angular
  .module('website')
  .service('api', api);

  /* @ngInject */
  function api($resource, env, _, $localStorage, $location, $log) {
    var service = this;
    this.addresses = {};
    this.addresses.all = addressesAll;
    this.addresses.save = addressesSave;
    this.addresses.setCurrent = setCurrentAddress;
    this.addresses.getCurrent = getCurrentAddress;
    this.addresses.validate = addressesValidate;
    this.addresses.resendCode = addressesResendCode;
    this.additionalProducts = {};
    this.additionalProducts.all = additionalProductsAll;
    this.additionalProducts.get = additionalProductsGet;
    this.comunes = {};
    this.comunes.all = comunesAll;
    this.comunes.hasRestaurants = comuneshasRestaurants;
    this.feedbacks = {};
    this.feedbacks.byFiltersInApi = feedbacksbyFiltersInApi;
    this.feedbacks.byFiltersInCentralServer = feedbacksbyFiltersInCentralServer;
    this.feedbacks.save = saveFeedback;
    this.prefs = {};
    this.prefs.all = prefsAll;
    this.prefs.get = prefsGet;
    this.prefs.set = prefsSet;
    this.menuCategories = {};
    this.menuCategories.all = menuCategoriesAll;
    this.menuCategories.get = menuCategoriesGet;
    this.menuCategories.homeWeb = menuCategoriesHomeWeb;
    this.menuCategories.checkMenuItem = checkMenuItem;
    this.products = {};
    this.products.all = productsAll;
    this.products.get = productsGet;
    this.products.homeWeb = productsHomeWeb;
    this.products.like = productsLike;
    this.products.reset = productsReset;
    this.products.setPreference = setPrefsForProduct;
    this.promotions = {};
    this.promotions.all = promotionsAll;
    this.promotions.get = promotionsGet;
    this.promotions.setPreference = promotionsSetPreference;
    this.orders = {};
    this.orders.get = ordersGet;
    this.orders.privateOrders = privateOrdersGet;
    this.orders.save = ordersSave;
    this.orders.status = ordersStatus;
    this.orders.saveEvent = eventSave;
    this.orders.validateSchedule = validateSchedule;
    this.orders.checkCart = ordersCheckCart;
    this.restaurants = {};
    this.restaurants.all = restaurantsAll;
    this.restaurants.allActives = restaurantsAllActives;
    this.restaurants.get = restaurantsGet;
    this.restaurants.timesAverage = timesAverage;
    this.restaurants.polygonsRestaurants = polygonsRestaurants;
    this.restaurants.externalPolygon = externalPolygon;
    this.restaurants.availablesSchedules = availablesSchedules;
    this.restaurants.availablesHours = availablesHours;
    this.receipts = {}
    this.receipts.get = receiptsGet;
    this.receiptsTpb = {}
    this.receiptsTpb.check = receiptsTpbCheck;
    this.receiptsTpb.update = receiptsTpbUpdate;
    this.receiptsTpb.tax_regimes = receiptsTpbTaxRegimes;
    this.receiptsTpb.cfdi_uses = receiptsTpbCfdiUses;
    this.settings = {};
    this.settings.banner = settingsBanner;
    this.myFavorites = {}
    this.myFavorites.get = myFavoritesGet;
    this.tbkuser = {};
    this.tbkuser.all = tbkuserAll;
    this.webpay = {};
    this.webpay.authorize = webpayAuthorize;
    this.webpay.deactivate = deactivateTbkUser;
    this.paymentIntents = {};
    this.paymentIntents.create = paymentIntentsCreate;
    this.paymentIntents.status = paymentIntentsStatus;

    this.payment_gateway = {};
    this.payment_gateway.get_payment_cards = getPaymentCards;
    this.payment_gateway.subscribe_card = subscribeCard;
    this.payment_gateway.generate_charge_oneclick = generateChargeOneclick;
    this.payment_gateway.generate_charge_by_payment_portal = generateChargePaymentPortal;
    this.payment_gateway.generate_charge_by_amipass = generateChargeByAmipass;
    this.payment_gateway.confirm_payment = confirmPayment;
    this.payment_gateway.delete_subscribed_card = deleteSubscribedCard;

    this.coupons = {};
    this.coupons.all = customerCouponsAll;
    this.coupons.apply = applyCoupon;

    this.franchises_forms = {};
    this.franchises_forms.save = franchisesFormsSave;

    this.client_contact = {};
    this.client_contact.save = clientContactFormSave;
    this.client_contact.reasonsAll = reasonsAll;
    this.setRestaurantGroup = setRestaurantGroup;
    this.setCustomerRestaurantGroupParam = setCustomerRestaurantGroupParam;
    this.restaurantGroups = {};
    this.restaurantGroups.all = restaurantGroupsAll;
    this.getCurrentLocation = getCurrentLocation;
    this.getRestaurantHours = getRestaurantHours;
    this.getLocation = getLocation;
    this.refreshLocation = refreshLocation;
    this.checkCartItems = checkCartItems;
    this.getCustomerRestaurantGroup = getCustomerRestaurantGroup;
    this.setLocalRestaurantGroup = setLocalRestaurantGroup;
    this.getPromiseCurrentLocation = getPromiseCurrentLocation;
    this.setRestaurantGroupParamFailed = setRestaurantGroupParamFailed;

    this.imageable = {};
    this.imageable.getImage = getImageUrl;

    this.setLogEntry = setLogEntry;
    this.setEventLogs = setEventLogs;

    ////////////////

    var specialProducts = {};
    var restaurantGroup = {};
    var cords = null;
    var currentAddress = null;

    // ----- Start Restaurant Group declaration ------
    var restaurantGroupsPromise;
    var customerRestaurantGroupPromise;
    var setRestaurantGroupPromise;
    var restaurantGroupParam = null;
    var restaurantGroupParamFailed = false;

    checkRestaurantGroupIdParam();

    if (isMobile()) {
      getLocationMobile();
    } else {
      checkPermissionsStatus();
    }

    function setRestaurantGroupParamFailed(value) {
      return restaurantGroupParamFailed = value;
    }

    function checkRestaurantGroupIdParam() {
      restaurantGroupParam = $location.search().restaurant_group_id;
    }

    function setCurrentAddress(address) {
      currentAddress = address;
    }

    function getCurrentAddress() {
      return currentAddress;
    }

    var RestaurantGroup = $resource(env.API_URL, {}, {
      query: {
        method: 'GET',
        isArray: false,
        url: env.API_URL + 'restaurant_groups'
      },
      restaurant_hours: {
        method: 'GET',
        isArray: false,
        url: env.API_URL + 'restaurant_groups/restaurant_hours'
      },
      check_items: {
        method: 'POST',
        isArray: false,
        url: env.API_URL + 'restaurant_groups/:id/check_items'
      },
      set: {
        method: 'GET',
        isArray: false,
        url: env.API_URL + 'restaurant_groups/search_restaurant_group'
      },
      set_restaurant_group: {
        method: 'POST',
        isArray: false,
        url: env.API_URL + 'restaurant_groups/set_restaurant_group'
      },
    });

    function restaurantGroupsAll(force) {
      if (env.ALLOW_PRICE_LISTS === 'false') return null;

      if (force || !restaurantGroupsPromise) {
        restaurantGroupsPromise = RestaurantGroup.query({}).$promise;
      }

      return restaurantGroupsPromise
    }

    function getLocation() {
      if (env.ALLOW_PRICE_LISTS === 'false') return setLocalRestaurantGroup(null);

      if ($localStorage.restaurantGroup) {
        return restaurantGroup = { restaurant_group_id: $localStorage.restaurantGroup.id };
      }

      return navigator.permissions.query({ name: 'geolocation' }).then(function(result) {
        if (result.state === 'prompt') {
          navigatorGeolocationPrompt();
        } else if (result.state === 'granted' || result.state === 'denied') {
          if (restaurantGroupParam) return;
          navigatorGeolocation();
        }
      });
    }

    function getLocationMobile() {
      if (env.ALLOW_PRICE_LISTS === 'false') return setLocalRestaurantGroup(null);

      if(restaurantGroupParam && !$localStorage.restaurantGroup) {
        return navigatorGeolocationRestGroupId();
      } else if (!$localStorage.restaurantGroup) {
        return navigatorGeolocation();
      }

      if ($localStorage.restaurantGroup) {
        return restaurantGroup = { restaurant_group_id: $localStorage.restaurantGroup.id };
      }

      navigatorGeolocation();
    }

    function refreshLocation() {
      if (env.ALLOW_PRICE_LISTS === 'false') return setLocalRestaurantGroup(null);

      navigatorGeolocation();

      if(isMobile()) return;

      return navigator.permissions.query({ name: 'geolocation' }).then(function(result) {
        if (result.state === 'prompt') {
          setPosition();
        }
      });
    }

    function checkPermissionsStatus() {
      if (env.ALLOW_PRICE_LISTS === 'false') return setLocalRestaurantGroup(null);

      getLocation();

      if ($localStorage.restaurantGroup) {
        restaurantGroup = { restaurant_group_id: $localStorage.restaurantGroup.id };
      } else {
        restaurantGroup = null;
      }

      return navigator.permissions.query({ name: 'geolocation' }).then(function(result) {
        if (restaurantGroupParam) return;

        if (result.state === 'prompt') {
          if (restaurantGroup) return navigatorGeolocationPrompt();
          return setDefaultRestaurantGroup();
        }
      });
    }

    function isMobile() {
      var isMobile = window.matchMedia('(max-width: 820px)').matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      var parser = new UAParser();
      var result = parser.getResult();
      if (result) {
        var name = result.browser.name;
      }
      var isSafari = name.toLowerCase().includes('safari');
      return isMobile || isSafari;
    }

    function navigatorGeolocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition, errorCallback);
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    }

    function navigatorGeolocationRestGroupId() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(successPosition, errorPosition);
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    }

    function navigatorGeolocationPrompt() {
      if (restaurantGroupParam) return;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition, notShowPosition);
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    }

    function setDefaultRestaurantGroup() {
      if (!setRestaurantGroupPromise) {
        setRestaurantGroupPromise = RestaurantGroup.set().$promise;
      }

      return setRestaurantGroupPromise.then(function(response) {
        var rest_group = response.restaurant_group;
        rest_group.open_modal = false;

        if (rest_group) {
          restaurantGroup = { restaurant_group_id: rest_group.id }
          $localStorage.restaurantGroup = rest_group;
        } else {
          restaurantGroup = null;
          $localStorage.restaurantGroup = null;
        }

        menuCategoriesAll(true).then(function() {
          productsAll()
          promotionsAll();
        });
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
      });
    }

    function showPosition(position) {
      cords = { longitude: position.coords.longitude, latitude: position.coords.latitude };
      setPosition(cords)
    }

    function errorCallback(error) {
      setPosition()
    };

    function notShowPosition(error) {
      return;
    };

    function successPosition(position) {
      if(restaurantGroupParamFailed) {
        cords = { longitude: position.coords.longitude, latitude: position.coords.latitude };
        return setPosition(cords);
      }

      return;
    }

    function errorPosition(error) {
      if(restaurantGroupParamFailed) {
        return setPosition();
      }

      return;
    }

    function setPosition(cords) {
      setRestaurantGroupPromise = RestaurantGroup.set(cords).$promise;
      return setRestaurantGroupPromise.then(function(response) {
        $localStorage.restaurantGroup = response.restaurant_group;

        if (response.restaurant_group) {
          window.location.reload();
        } else {
          restaurantGroup = null;
        }
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
      });
    }

    function setLocalRestaurantGroup(restGroup) {
      $localStorage.restaurantGroup = restGroup;

      if (restGroup) {
        restaurantGroup = { restaurant_group_id: restGroup.id }
      } else {
        restaurantGroup = null;
      }
    }

    function getCustomerRestaurantGroup(force) {
      if (force || !customerRestaurantGroupPromise) {
        // customerRestaurantGroupPromise = RestaurantGroup.get_restaurant_group().$promise;
        customerRestaurantGroupPromise = RestaurantGroup.set().$promise;
      }

      return customerRestaurantGroupPromise;
    }

    function getCurrentLocation() {
      if (env.ALLOW_PRICE_LISTS === 'false') return null;
      return $localStorage.restaurantGroup || null;
    }

    function getRestaurantHours(restaurantGroupId) {
      if (restaurantGroupId) {
        return RestaurantGroup.restaurant_hours({ id: restaurantGroupId }).$promise;
      }

      return RestaurantGroup.restaurant_hours().$promise;
    }

    function getPromiseCurrentLocation() {
      if (env.ALLOW_PRICE_LISTS === 'false') return null;

      if (!setRestaurantGroupPromise) {
        setRestaurantGroupPromise = RestaurantGroup.set().$promise;
      }

      return setRestaurantGroupPromise
    }

    function setRestaurantGroup(rest_group, options) {
      return setCustomerRestaurantGroup(rest_group, options);
      // TODO: BUscar camino para obtener customer, ya que customer.get() no funciona acá
      // if (customer.get()) {
      //   setCustomerRestaurantGroup(rest_group)
      // } else {
      //   $localStorage.restaurantGroup = rest_group;
      //   window.location.reload();
      // }
    }

    function setCustomerRestaurantGroup(rest_group, options) {
      options = options || {};
      var setCustomerRestGroupPromise = RestaurantGroup.set_restaurant_group({ restaurant_group_id: rest_group.id }).$promise;
      return setCustomerRestGroupPromise.then(function(response) {
        var newRestaurantGroup = response.restaurant_group || rest_group;
        $localStorage.restaurantGroup = newRestaurantGroup;
        restaurantGroup = { restaurant_group_id: newRestaurantGroup.id };

        if (!options.skipReload) {
          window.location.reload();
        }

        return newRestaurantGroup;
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
      });
    }

    function setCustomerRestaurantGroupParam(restGroupId) {
      if (!setRestaurantGroupPromise) {
        setRestaurantGroupPromise = RestaurantGroup.set_restaurant_group({ restaurant_group_id: restGroupId }).$promise;
      }

      return setRestaurantGroupPromise
    }

    function checkCartItems(restaurantGroup, cartItems) {
      var formattedCartItems = {
        items: cartItems.map(function(item) { return item.id })
      };

      return RestaurantGroup.check_items({ id: restaurantGroup.id}, formattedCartItems).$promise;
    }
    // ----- End Restaurant Group declaration ------

    // ----- Start Settings declaration ------
    var Settings = $resource(env.API_URL + 'gallery_images', {}, {
      banner: {
        method: 'GET',
        url: env.API_URL + 'gallery_images/banner'
      }
    });

    var settingsBanner = {};
    var settingsBannerPromise;
    function settingsBanner(galleryType, isMobile) {
      if (!settingsBannerPromise || !settingsBanner || !settingsBanner[galleryType]) {
        settingsBannerPromise = Settings.banner({ gallery_type: galleryType, mobile: isMobile }).$promise;
      }

      return settingsBannerPromise
      .then(function(response) {
        if (_.isEmpty(settingsBanner) || _.isEmpty(settingsBanner[galleryType])) {
          settingsBanner[galleryType] = response.gallery_images;
        }
        return settingsBanner[galleryType];
      });
    }
    // ----- End Settings declaration ------

    // ----- Start My Favorites declaration ------
    var myFavoritesPromise;

    var Favorites = $resource(env.API_URL + 'favorites', {}, {
      query: {
        method: 'GET',
        isArray: false
      }
    });

    function myFavoritesGet(force) {
      if (force || !myFavoritesPromise) {
        myFavoritesPromise = Favorites.query(restaurantGroup).$promise;

      }

      return myFavoritesPromise;
    }
    // ----- End My Favorites declaration ------

    // ----- Start Additional Products declaration ------
    var additionalProductsPromise;
    var additionalProducts = {};

    var AdditionalProducts = $resource(env.API_URL + 'additional_products', {}, {
      query: {
        method: 'GET',
        isArray: true,
        transformResponse: function(data) {
          return angular.fromJson(data).products;
        }
      }
    });

    function additionalProductsGet(product) {
      var result;

      if (_.isString(product)) {
        result = _.find(specialProducts, function(prod){
          return product == prod.id;
        });
      } else
        if (_.isObject(product) && product.name) {
          result = _.find(specialProducts, function(prod){
            return product.name == prod.name;
          });
        }

      return result;
    }

    function additionalProductsAll(force) {
      if (force) {
        additionalProducts = null;
      }
      if (!additionalProductsPromise) {
        additionalProductsPromise = AdditionalProducts.query(restaurantGroup).$promise;
      }

      return additionalProductsPromise.then(function(additionalProductsList) {
        specialProducts = additionalProductsList;
        if (force || _.isEmpty(additionalProducts)) {
          additionalProductsList.forEach(function(p) {
            p.type = 'products';
            p.quantity = p.quantity;
            p.is_additional = true;
            additionalProducts[p.id] = p;
          });
        }

        return additionalProductsList;
      });
    }
    // ----- End Additional Products declaration declaration ------

    var Prefs = $resource(env.API_URL + 'preferences', {}, {
      query: {
        method: 'GET',
        isArray: false
      },
      set: {
        method: 'POST',
        isArray: false
      }
    });
    var prefs = {};
    var prefsPromise;
    function prefsAll(force) {
      if (force) {
        prefsPromise = null;
      }
      if (!prefsPromise) {
        prefsPromise = Prefs.query(restaurantGroup).$promise;
      }
      return prefsPromise.then(function(prefsObject) {
        _.extend(prefs, prefsObject);
        return prefsObject;
      });
    }
    function prefsGet(attr) {
      if (Object.keys(prefs).length === 0) {
        throw 'Must call "api.prefs.all()" before calling ' +
          '"api.prefs.get(:attr)", with attr: "' + attr +'".';
      }
      return prefs[attr];
    }
    function prefsSet() {
      var postData = {},
        valid = true;
        switch (arguments.length) {
          case 1:
            postData = arguments[0];
            break;
          case 2:
            var attr = arguments[0],
              value = arguments[1];
              postData[attr] = value;
              break;
            default:
              valid = false;
        }
        if (valid) {
          return Prefs.set(postData).$promise;
        } else {
          throw 'Must call "api.prefs.set(attr:string, value)" or ' +
            '"api.prefs.set(attrs:Object)".';
        }
    }

    var MenuCategory = $resource(env.API_URL + 'menu_categories/:id', {}, {
      query: {
        method: 'GET',
        isArray: true,
        url: env.API_URL + 'menu_categories?module=website',
        transformResponse: function(data) {
          return angular.fromJson(data).menu_categories;
        }
      },
      set: {
        method: 'POST',
        url: env.API_URL + 'menu_categories/:id',
      },
      check_item: {
        method: 'POST',
        url: env.API_URL + 'menu_categories/check_menu_item',
      },
      home_web: {
        method: 'GET',
        url: env.API_URL + 'menu_categories/home_web',
      }
    });
    var menuCategories = {};
    var menuCategoriesPromise;
    var menuCategoriesHome = {};
    var menuCategoriesHomePromise;

    function checkMenuItem(cartItems, restaurantGroupId) {
      var formattedItems = {
        restaurant_group_id: restaurantGroupId,
        items: cartItems.map(function(item) {
          return { id: item.id, type: item.type }
        })
      }

      var checkItemPromise = MenuCategory.check_item(formattedItems).$promise;
      return checkItemPromise;
    }

    function menuCategoriesHomeWeb() {
      if (!menuCategoriesHomePromise) {
        menuCategoriesHomePromise = MenuCategory.home_web(restaurantGroup).$promise;
      }
      return menuCategoriesHomePromise
      .then(function(response) {
        if (_.isEmpty(menuCategoriesHome)) {
          menuCategoriesHome = response.menu_categories;
        }
        return menuCategoriesHome;
      });
    }

    function menuCategoriesAll(force) {
      if (force) {
        menuCategoriesPromise = null;
      }
      if (!menuCategoriesPromise) {
        menuCategoriesPromise = MenuCategory.query(restaurantGroup).$promise;
      }
      return menuCategoriesPromise
      .then(function(menuCategoriesList) {
        if (force || _.isEmpty(menuCategories)) {
          menuCategoriesList.forEach(function(p) {
            p.type = 'menu_categories';
            menuCategories[p.id] = p;
          });
        }
        return menuCategoriesList;
      });
    }
    function menuCategoriesGet(menuCategory) {
      if (Object.keys(menuCategories).length === 0) {
        throw 'Must call "api.menuCategories.all()" before calling ' +
          '"api.menuCategories.get(:id)", with id: "' + menuCategory +'".';
      } else
        if (_.isString(menuCategory)) {
          return menuCategories[menuCategory];
        }
    }

    var Product = $resource(env.API_URL + 'products/:id', {}, {
      query: {
        method: 'GET',
        isArray: true,
        url: env.API_URL + 'products?module=website',
        transformResponse: function(data) {
          return angular.fromJson(data).products;
        }
      },
      set: {
        method: 'POST',
        url: env.API_URL + 'products/:id',
      },
      home_web: {
        method: 'GET',
        url: env.API_URL + 'products/home_web',
      }
    });
    var products = {};
    var productsPromise;
    var productsHome = {};
    var productsHomePromise;
    function setPrefsForProduct(product, preference) {
      // force to reload products
      productsPromise = null;
      var postData = {
        preference: preference
      };
      return Product.set({id: product.id}, postData).$promise;
    }

    function productsAll(force) {
      return service.menuCategories.all(force)
        .then(function() {
          _.each(menuCategories, function(mc) {
            _.each(mc.products, function(p) {
              p.type = 'products';
              p.is_additional = false;
              products[p.id] = p;
            });
        });
      });
    }
    function productsGet(product) {
      if (Object.keys(products).length === 0) {
        throw 'Must call "api.products.all()" before calling ' +
          '"api.products.get(:id)", with id: "' + product +'".';
      } else
        if (_.isString(product)) {
          return products[product];
        } else
          if (_.isObject(product) && product.name) {
            return specialProducts[product.name];
          }
    }

    function productsHomeWeb() {
      if (!productsHomePromise) {
        productsHomePromise = Product.home_web().$promise;
      }
      return productsHomePromise
      .then(function(response) {
        if (_.isEmpty(productsHome)) {
          productsHome = response.products;
        }
        return productsHome;
      });
    }

    function productsLike(product) {
      return setPrefsForProduct(product, 1);
    }
    function productsReset(product) {
      return setPrefsForProduct(product, 0);
    }


    var Promotion = $resource(env.API_URL + 'promotions/:id', {}, {
      query: {
        method: 'GET',
        isArray: true,
        transformResponse: function(data) {
          return angular.fromJson(data).promotions;
        }
      },
      set: {
        method: 'POST',
        url: env.API_URL + 'promotions/:id',
      }
    });
    var promotions = {};
    var promotionsPromise;
    var promotionsList = [];
    function promotionsAll(force) {
      return service.menuCategories.all() // add force
        .then(function() {
          _.each(menuCategories, function(mc) {
            _.each(mc.promotions, function(p) {
              p.type = 'promotions';
              p.is_additional = false;
              promotions[p.id] = p;
            });
        });
      });
      // if (force || !promotionsPromise) {
      //   promotionsPromise = Promotion.query({}).$promise;
      // }
      // return promotionsPromise
      // .then(function(promotionsList) {
      //   if (force || _.isEmpty(promotions)) {
      //     _.each(promotionsList, function(p) {
      //       p.type = 'promotions';
      //       promotions[p.id] = p;
      //     });
      //   }
      //   return promotionsList;
      // });
    }
    function promotionsGet(promotionId) {
      if (Object.keys(promotions).length === 0) return $log.error('No promotions'); // Entra en este if si promotions no tiene categoria.
      if (!promotions[promotionId]) return $log.error('promotionId: ' + promotionId + ' not found');
      return promotions[promotionId];
    }
    function promotionsSetPreference(promotion, preference) {
      // force to reload promotions
      promotionsPromise = null;
      var postData = {
        preference: preference
      };
      return Promotion.set({id: promotion.id}, postData).$promise;
    }

    var Restaurants = $resource(env.API_URL + 'restaurants', {}, {
      query: {
        method: 'GET',
        isArray: true,
        transformResponse: function(data) {
          return angular.fromJson(data).restaurants;
        }
      },
      allActives: {
        method: 'GET',
        url: env.API_URL + 'restaurants/actives',
        isArray: true,
        transformResponse: function(data) {
          return angular.fromJson(data).restaurants;
        }
      },
      timesAverage: {
        method: 'GET',
        url: env.API_URL + 'restaurants/times_average'
      },
      externalPolygon: {
        method: 'GET',
        isArray: true,
        url: env.API_URL + 'restaurants/external_polygon'
      },
      polygonsRestaurants: {
        method: 'GET',
        isArray: true,
        url: env.API_URL + 'restaurants/polygons'
      },
      availablesSchedules: {
        method: 'GET',
        isArray: true,
        url: env.API_URL + 'restaurants/:id/availables_schedules',
        transformResponse: function(data) { return angular.fromJson(data).availables_schedules }
      },
      availablesHours: {
        method: 'GET',
        isArray: true,
        url: env.API_URL + 'restaurants/:id/availables_hours',
        transformResponse: function(data) { return angular.fromJson(data).availables_hours }
      }
    });

    var restaurants = {};
    var restaurantsPromise;
    function restaurantsAll(force, sortLatestOrders) {
      force = (force !== undefined) ? force : false;
      sortLatestOrders = (sortLatestOrders !== undefined) ? sortLatestOrders : false;
      if (force || !restaurantsPromise) {
        restaurantsPromise = Restaurants.query({ sort_latest_orders: sortLatestOrders }).$promise;
      }
      return restaurantsPromise
      .then(function(restaurantsList) {
        if (_.isEmpty(restaurants)) {
          _.each(restaurantsList, function(r) {
            restaurants[r.id] = r;
          });
        }
        return restaurantsList;
      });
    }
    this.restaurants.byCustomerAddress = restaurantsByCustomerAddress;

    function restaurantsByCustomerAddress(customerAddressId) {
      return Restaurants.query({
        customer_address_id: customerAddressId,
      }).$promise;
    }

    function restaurantsAllActives() {
      restaurantsPromise = Restaurants.allActives().$promise;
      return restaurantsPromise
      .then(function(restaurantsList) {
        if (_.isEmpty(restaurants)) {
          _.each(restaurantsList, function(r) {
            restaurants[r.id] = r;
          });
        }
        return restaurantsList;
      });
    }

    function restaurantsGet(id) {
      return restaurants[id];
    }

    var timesAveragePromise;
    function timesAverage() {
      if (!timesAveragePromise) {
        timesAveragePromise = Restaurants.timesAverage().$promise;
      }
      return timesAveragePromise
      .then(function(times) {
        return times;
      });
    }

    function polygonsRestaurants() {
      return Restaurants.polygonsRestaurants().$promise;
    }

    function externalPolygon() {
      return Restaurants.externalPolygon().$promise;
    }

    function availablesSchedules(restaurantId, parameters, requester) {
      return Restaurants.availablesSchedules(
        {
          id: restaurantId,
          number_of_days: parameters.numberOfDays,
          start_minutes_after_open_today: parameters.startMinutesAfterOpenToday,
          start_minutes_after_open: parameters.startMinutesAfterOpen,
          ends_minutes_after_open: parameters.endsMinutesAfterOpen,
          minutes_interval: parameters.minutesInterval,
          requester: requester
        }
      ).$promise;
    }

    function availablesHours(restaurantId, date, startMinutesAfterOpenToday,
                             startMinutesAfterOpen, endsMinutesAfterOpen, minutesInterval) {
      return Restaurants.availablesHours(
        {
          id: restaurantId,
          date: date,
          start_minutes_after_open_today: startMinutesAfterOpenToday,
          start_minutes_after_open: startMinutesAfterOpen,
          ends_minutes_after_open: endsMinutesAfterOpen,
          minutes_interval: minutesInterval
        }
      ).$promise;
    }

    var Addresses = $resource(env.API_URL + 'addresses/:id', {}, {
      query: {
        method: 'GET',
        isArray: true,
        transformResponse: function(data) {
          return angular.fromJson(data).addresses.map(function(a) {
            a.address = a.street_name + ' #' + a.street_number;
            if (a.specific_number) {
              a.address += ' ' + a.specific_number;
            }
            a.address +=  ', ' + a.comune_name;
            return a;
          });
        }
      },
      update: { method:'PUT' },
      validate: {
        method: 'POST',
        isArray: false,
        url: env.API_URL + 'validations/resource',
      },
      resendCode: {
        method: 'POST',
        isArray: false,
        url: env.API_URL + 'validations/new_token',
      }
    });
    function addressesAll() {
      return Addresses.query({}).$promise;
    }
    function addressesSave(address) {
      var id = address.id;
      if (id) {
        return Addresses.update({id: id}, address).$promise;
      } else {
        var a = new Addresses(address);
        return a.$save();
      }
    }

    function addressesValidate(payload) {
      return Addresses.validate(payload).$promise;
    }

    function addressesResendCode(payload) {
      return Addresses.resendCode(payload).$promise;
    }

    var Orders = $resource(env.API_URL + 'orders/:id', {}, {
      get: {
        method: 'GET',
        transformResponse: function(data) {
          return angular.fromJson(data).order;
        }
      },
      privateOrders: {
        method: 'GET',
        isArray: false,
        url: env.API_URL + 'orders/:id?private_order=true',
        transformResponse: function(data) {
          return angular.fromJson(data).order;
        }
      },
      status: {
        method: 'GET',
        isArray: false,
        url: env.API_URL + 'orders/:order_id/order_trackings/status',
        transformResponse: function(data) {
          return angular.fromJson(data);
        }
      },
      update: { method: 'PUT' },
      saveEvent: {
        method: 'POST',
        url: env.API_URL + 'orders/event'
      },
      validateSchedule: { method: 'POST',
        url: env.API_URL + 'orders/validate_schedule'
       },
      checkCart: {
        method: 'POST',
        url: env.API_URL + 'orders/check_cart'
      }
    });
    function ordersGet(order) {
      return Orders.get({ id: order }).$promise;
    }
    function privateOrdersGet(order) {
      return Orders.privateOrders({ id: order }).$promise;
    }
    function ordersSave(order) {
      var id = order.id;
      if (id) {
        return Orders.update({id: id}, order).$promise;
      } else {
        var o = new Orders(order);
        return o.$save();
      }
    }
    function ordersStatus(orderId) {
      return Orders.status({ order_id: orderId }).$promise;
    }
    function eventSave(order){
      return Orders.saveEvent(order).$promise;
    }
    function validateSchedule(order) {
      return Orders.validateSchedule(order).$promise;
    }
    function ordersCheckCart(order) {
      return Orders.checkCart({}, { order: order }).$promise;
    }

    var Comunes = $resource(env.API_URL, {}, {
      all: {
        method: 'GET',
        isArray: true,
        url: env.API_URL + 'comunes',
        transformResponse: function(data) {
          return angular.fromJson(data).comunes;
        }
      },
      restaurants: {
        method: 'GET',
        isArray: true,
        url: env.API_URL + 'comunes/restaurants_comunes',
        transformResponse: function(data) {
          return angular.fromJson(data).comunes;
        }
      }
    });

    function comunesAll() {
      return Comunes.all({}).$promise;
    }

    function comuneshasRestaurants() {
      return Comunes.restaurants({}).$promise;
    }

    // Start Feedbacks
    var Feedbacks = $resource(env.API_URL + 'feedbacks', {}, {
      byFiltersInApi: {
        method: 'GET',
        url: env.API_URL + 'feedbacks/by_filters',
        transformResponse: function(data) { return angular.fromJson(data); }
      },
      byFiltersInCentralServer: {
        method: 'GET',
        url: env.CENTRAL_SERVER_URL + 'feedbacks/by_filters',
        headers: { 'POSAPIKEY': env.CENTRAL_SERVER_API_KEY },
        transformResponse: function(data) { return angular.fromJson(data); }
      },
      save: {
        method: 'POST',
        url: env.CENTRAL_SERVER_URL + 'feedbacks',
        headers: { 'POSAPIKEY': env.CENTRAL_SERVER_API_KEY }
      }
    });

    function feedbacksbyFiltersInApi(filters) {
      return Feedbacks.byFiltersInApi(filters).$promise;
    }

    function feedbacksbyFiltersInCentralServer(filters) {
      return Feedbacks.byFiltersInCentralServer(filters).$promise;
    }

    function saveFeedback(form_params, details_params) {
      var formattedFeedback = {};
      _.each(form_params, function(value, key) {
        if (value === 'yes' || value === 'no') {
          value = value === 'yes';
        }
        formattedFeedback[_.snakeCase(key)] = value;
      });
      var feedback_params = { 'feedback': $.extend({}, formattedFeedback, details_params) };
      return Feedbacks.save(feedback_params).$promise;
    }
    //End Feedbacks

    var TbkUser = $resource(env.API_URL + 'tbkuser/:customer_id', {}, {
      all: {
        method: 'GET',
        isArray: true,
        transformResponse: function(data) {
          return angular.fromJson(data);
        }
      }
    });

    function tbkuserAll(customer_id) {
      return TbkUser.all({ customer_id: customer_id }).$promise;
    }

    var Webpay = $resource(env.API_URL + 'webpays/authorize_transaction', {}, {
      authorize: {
        method: 'POST'
      },
      deactivate: {
        method: 'POST',
        url: env.API_URL + 'webpays/remove_inscription'
      }
    });
    function webpayAuthorize(params) {
      return Webpay.authorize(params).$promise;
    }
    function deactivateTbkUser(params) {
      return Webpay.deactivate(params).$promise;
    }


    var paymentGateways = $resource(env.API_URL + 'payment_card', {}, {
      subscribe_card: {
        method: 'POST'
      },
      get_payment_cards: {
        method: 'GET'
      },
      generate_charge_oneclick: {
        method: 'POST',
        url: env.API_URL + 'payment_card/:payment_card_id/payment_attempt'
      },
      generate_charge_by_payment_portal: {
        method: 'POST',
        url: env.API_URL + 'payment_attempt'
      },
      delete_subscribed_card: {
        method: 'DELETE',
        url: env.API_URL + 'payment_card/:id'
      },
      confirm_payment: {
        method: 'POST',
        url: env.API_URL + 'payment_attempt/confirm_payment'
      },
      generate_charge_by_amipass: {
        method: 'POST',
        url: env.API_URL + 'payment_intents',
        isArray: false,
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }
    });

    function getPaymentCards(params) {
      return paymentGateways.get_payment_cards(params).$promise;
    }

    function subscribeCard(params) {
      return paymentGateways.subscribe_card(params).$promise;
    }

    function generateChargeOneclick(payment_card_id, params) {
      params.payment_attempt.transaction_type = 'oneclick';
      return paymentGateways.generate_charge_oneclick(payment_card_id, params).$promise;
    }

    function generateChargeByAmipass(params) {
      return paymentGateways.generate_charge_by_amipass(params).$promise;
    }

    function generateChargePaymentPortal(params) {
      params.payment_attempt.transaction_type = 'payment_portal';
      return paymentGateways.generate_charge_by_payment_portal(params).$promise;
    }

    function deleteSubscribedCard(id, params) {
      return paymentGateways.delete_subscribed_card(id, params).$promise;
    }

    function confirmPayment(params) {
      return paymentGateways.confirm_payment(params).$promise;
    }

    // Coupons
    var Coupons = $resource(env.API_URL, {}, {
      get: {
        method: 'GET',
        isArray: true,
        url: env.API_URL + 'coupons/coupon_customers',
        transformResponse: function(data) {
          if (data)
            return angular.fromJson(data).coupon_customers;
           else
             return [];
        }
      },
      apply: {
        method: 'POST',
        url: env.API_URL + 'coupons/apply'
      }
    });
    function customerCouponsAll() {
      return Coupons.get({}).$promise;
    }
    function applyCoupon(coupon) {
    return Coupons.apply({
      code: coupon.code,
      subtotal: coupon.subtotal
    }).$promise;
  }

    // Receipts
    var Receipts = $resource(env.API_URL + 'receipts', {}, {
      get: {
        method: 'GET',
        responseType: "arraybuffer",
        transformResponse: function(response, headersGetter) {
          return { data : response, headers: headersGetter()};
        }
      }
    });
    function receiptsGet(data) {
      return Receipts.get(data).$promise;
    }

    // Third Party Billing Receipts
    var ReceiptsTpb = $resource(env.API_URL + 'receipts', {}, {
      check: {
        method: 'GET',
        url: env.API_URL + 'receipts/check',
      },
      update: {
        method: 'PUT',
        url: env.API_URL + 'receipts/generate_receipt_mx',
      },
      tax_regimes: {
        method: 'GET',
        url: env.API_URL + 'receipts/tax_regimes',
      },
      cfdi_uses: {
        method: 'GET',
        url: env.API_URL + 'receipts/cfdi_uses',
      }
    });

    function receiptsTpbCheck(data) {
      return ReceiptsTpb.check(data).$promise;
    }

    function receiptsTpbUpdate(data) {
      return ReceiptsTpb.update(data).$promise;
    }

    function receiptsTpbTaxRegimes() {
      return ReceiptsTpb.tax_regimes().$promise;
    }

    function receiptsTpbCfdiUses() {
      return ReceiptsTpb.cfdi_uses().$promise;
    }

    //Franchises Forms
    var franchisesForms = $resource(env.API_URL, {}, {
      save_form: {
        method: 'POST',
        url: env.API_URL + 'franchises_forms'
      }
    });
    function franchisesFormsSave(form) {
      return franchisesForms.save_form(form).$promise;
    }

    // Client contact form
    var ClientContactForm = $resource(env.API_URL, {}, {
      save_form: {
        method: 'POST',
        url: env.API_URL + 'contact_clients'
      },
      get_reasons: {
        method: 'GET',
        url: env.API_URL + 'contact_clients/reasons'
      }
    });
    function clientContactFormSave(form){
      return ClientContactForm.save_form(form).$promise;
    }

    // Reasons
    var reasonsPromise;

    function reasonsAll(force) {
      if (force || !reasonsPromise) {
        reasonsPromise = ClientContactForm.get_reasons().$promise;
      }
      return reasonsPromise
      .then(function(response) {
        return response.reasons;
      });
    }

    // Log Entries
    var LogEntry = $resource(env.API_URL, {}, {
      create: {
        method: 'POST',
        url: env.API_URL + 'event_log_entries'
      }
    });
    function setLogEntry(logEntry) {
      var application = { application: 'china-delivery' }
      var fullLogEntry = $.extend({}, application, logEntry)
      return LogEntry.create(fullLogEntry).$promise;
    }

    // Event logs
    var EventLogs = $resource(env.API_URL, {}, {
      create: {
        method: 'POST',
        url: env.API_URL + 'event_logs'
      }
    });
    
    function setEventLogs(logEntry) {
      var fullLogEntry = angular.extend(logEntry)
      return EventLogs.create(fullLogEntry).$promise;
    }

    var PaymentIntents = $resource(env.API_URL + 'payment_intents/:id', {}, {
      create: {
        method: 'POST',
        url: env.API_URL + 'payment_intents'
      },
      status: {
        method: 'GET',
        url: env.API_URL + 'payment_intents/:id'
      }
    });

    function paymentIntentsCreate(payload) {
      return PaymentIntents.create(payload).$promise;
    }

    function paymentIntentsStatus(params) {
      return PaymentIntents.status(params).$promise;
    }

    // ----- Start Imageable ------
    var Image = $resource(env.API_URL + 'images', {}, {
      get_url: {
        method: 'GET',
        url: env.API_URL + 'images/url'
      }
    });

    function getImageUrl(imageableType, imageableId, deviceType, imageType) {
      return Image.get_url({
        imageable_type: imageableType,
        imageable_id: imageableId,
        image_type: imageType,
        device_type: deviceType
      }).$promise;
    };
    // ----- End Imageable ------
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('analytics', analytics);

  /* @ngInject */
  function analytics(_, cart, env, $auth) {
    var service = this;
    service.addToCart = addToCart;
    service.beginCheckout = beginCheckout;
    service.userNavigation = userNavigation;
    service.scriptType = 'text/javascript';
    service.userNavigationScriptId = 'analytics-user-navigation-script';

    /** @function
    * @name addToCart
    * @param {Object} seleable - Product object used to build the Analytics item payload.
    * @param {number} additionalPrice - Extra price added to the selected product.
    * @description Track a product added to the cart and push its ecommerce payload to the dataLayer.
    */
    function addToCart(seleable, additionalPrice) {
      var price = cart.price(seleable.id, true, seleable.type, additionalPrice);
      var structure = addToCartEventStructure(price, seleable);

      return appendSeleableAnalytics(structure);
    }

    /** @function
    * @name addToCartEventStructure
    * @param {number} price - Final product price sent to Analytics.
    * @param {Object} seleable - Product object selected by the customer.
    * @returns {Object} Ecommerce payload for the add-to-cart event.
    * @description Build the Analytics event structure for a single product added to the cart.
    */
    function addToCartEventStructure(price, seleable) {
      return {
        'event': 'add_to_cart',
        'ecommerce': {
          currency: env.CURRENCY,
          value: price,
          items: [
            {
              item_id: seleable.id,
              item_name: seleable.name,
              price: price,
              quantity: 1
            }
          ]
        }
      };
    }

    /** @function
    * @name beginCheckout
    * @param {Object} cart - Cart service instance used to read products and calculate prices.
    * @param {string} event - Analytics event name to push into the dataLayer.
    * @description Build the ecommerce payload from the current cart and push the checkout event to the dataLayer.
    */
    function beginCheckout(cart, event) {
      var productsArray = cart.products().map(function(product) {
        var price = cart.price(product.seleable.id, true, product.seleable.type);
        return beginCheckoutProductDetails(price, product);
      });

      var totalPrice = productsArray.reduce(function(total, product) { return total + product.price * product.quantity; }, 0);
      var structure  = beginCheckoutEventStructure(event, totalPrice, productsArray);

      return appendSeleableAnalytics(structure);
    }

    /** @function
    * @name beginCheckoutProductDetails
    * @param {number} price - Final unit price for the cart product.
    * @param {Object} product - Cart product wrapper with seleable and quantity data.
    * @returns {Object} Analytics item payload for a checkout product.
    * @description Normalize a cart product into the item structure expected by the ecommerce payload.
    */
    function beginCheckoutProductDetails(price, product) {
      return {
        item_id: product.seleable.id,
        item_name: product.seleable.name,
        price: price,
        quantity: product.quantity
      };
    }

    /** @function
    * @name beginCheckoutEventStructure
    * @param {string} event - Checkout-related event name to be pushed to Analytics.
    * @param {number} totalPrice - Total order value computed from cart products.
    * @param {Array<Object>} productsArray - Normalized Analytics items included in the checkout event.
    * @returns {Object} Ecommerce payload for the checkout event.
    * @description Build the Analytics structure for checkout and payment step events.
    */
    function beginCheckoutEventStructure(event, totalPrice, productsArray) {
      return {
        'event': event,
        'ecommerce': {
          currency: env.CURRENCY,
          value: totalPrice,
          items: productsArray
        }
      };
    }

    /** @function
    * @name appendSeleableAnalytics
    * @param {Object} structure - Analytics payload pushed into the dataLayer.
    * @returns {void}
    * @description Create a script tag that resets the ecommerce object and pushes the provided Analytics payload.
    */
    function appendSeleableAnalytics(structure) {
      var script  = document.createElement('script');
      script.type = service.scriptType;
      script.innerHTML = buildDataLayerScriptContent(structure);
      document.head.insertBefore(script, document.head.firstElementChild);
    }

    /** @function
    * @name userNavigation
    * @returns {void}
    * @description Remove duplicated user tracking scripts and keep a single dataLayer payload with the authenticated user identifier.
    */
    function userNavigation() {
      var customer = $auth.user;
      removeLegacyUserNavigationScripts();

      if (_.isEmpty(customer) || _.isEmpty(customer.id)) {
        removeUserNavigationScript();
        return;
      }

      appendUserEventAnalytics(customer.id);
    }

    /** @function
    * @name removeUserNavigationScript
    * @returns {void}
    * @description Remove the current user navigation Analytics script from the DOM when there is no authenticated user.
    */
    function removeUserNavigationScript() {
      var script = document.getElementById(service.userNavigationScriptId);
      if (script && script.parentNode) script.parentNode.removeChild(script);
    }

    /** @function
    * @name removeLegacyUserNavigationScripts
    * @returns {void}
    * @description Remove previously injected user navigation Analytics scripts so only the managed script remains.
    */
    function removeLegacyUserNavigationScripts() {
      var scripts = document.head.querySelectorAll('script[type="' + service.scriptType + '"]');

      scripts.forEach(function(script) {
        if (script.id === service.userNavigationScriptId) return;
        if (isLegacyUserNavigationScript(script)) script.parentNode.removeChild(script);
      });
    }

    /** @function
    * @name appendUserEventAnalytics
    * @param {(string|number)} customerId - Authenticated customer identifier sent to Analytics.
    * @returns {void}
    * @description Create or reuse the managed user navigation script and update it with the current user event payload.
    */
    function appendUserEventAnalytics(customerId) {
      var script = userNavigationScript();
      var structure = userEventStructure(customerId);
      script.innerHTML = buildDataLayerScriptContent(structure);
    }

    /** @function
    * @name userEventStructure
    * @param {(string|number)} customerId - Authenticated customer identifier sent to Analytics.
    * @returns {Object} Analytics payload for the authenticated user event.
    * @description Build the dataLayer structure used to identify the current authenticated user.
    */
    function userEventStructure(customerId) {
      return {
        'event': 'user_ready',
        'user_id': customerId
      };
    }

    /** @function
    * @name userNavigationScript
    * @returns {HTMLScriptElement} Managed script element used for user navigation Analytics events.
    * @description Retrieve the current user navigation script or create it when it does not exist.
    */
    function userNavigationScript() {
      var script = document.getElementById(service.userNavigationScriptId);

      if (script) return script;

      script = document.createElement('script');
      script.type = service.scriptType;
      script.id = service.userNavigationScriptId;
      document.head.insertBefore(script, document.head.firstElementChild);

      return script;
    }

    /** @function
    * @name buildDataLayerScriptContent
    * @param {Object} structure - Analytics payload to serialize into the script body.
    * @returns {string} JavaScript snippet that resets ecommerce data and pushes the provided payload.
    * @description Generate the inline script content inserted into the DOM for Analytics tracking.
    */
    function buildDataLayerScriptContent(structure) {
      return 'dataLayer.push({ ecommerce: null }); \n' +
        'dataLayer.push(' + JSON.stringify(structure) + ');';
    }

    /** @function
    * @name isLegacyUserNavigationScript
    * @param {HTMLScriptElement} script - Script node evaluated as a potential legacy Analytics tag.
    * @returns {boolean} Whether the script matches a previously injected user navigation payload.
    * @description Detect legacy user navigation scripts so they can be removed before writing the managed script.
    */
    function isLegacyUserNavigationScript(script) {
      return !!script.innerHTML && script.innerHTML.indexOf('dataLayer.push({ event: "user_ready", user_id: ') !== -1;
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('website')
  .controller('WebpayCardConfirmationModalController', WebpayCardConfirmationModalController);

  /* @ngInject */
  function WebpayCardConfirmationModalController($uibModalInstance) {
    var vm = this;
    vm.answer = answer;

    function answer(answer){
      $uibModalInstance.close(answer);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('TrackingController', TrackingController);

  /* @ngInject */
  function TrackingController(_, api, cart, env, hero, ngNotify, $log, $state, $stateParams) {
    var vm             = this;
    vm.isLoadingItems  = true;
    vm.address         = null;
    vm.customer        = null;
    vm.mapLonLat       = null;
    vm.order           = null;
    vm.orderItems      = null;
    vm.additionalItems = null;
    vm.currentStatus   = null;
    vm.ordersStatus    = null;
    vm.trackingUrl     = null;
    vm.paymentMethod   = null;
    vm.creditCard      = null;
    vm.currentTime     = null;
    vm.promisedTime    = null;
    vm.restaurant      = null;
    vm.orderTypeName   = null;
    vm.orderTypeIcon   = null;
    vm.subtotalAmount  = 0;
    vm.discountAmount  = 0;
    vm.couponAmount    = 0;
    vm.deliveryAmount  = 0;
    vm.tipAmount       = 0;
    vm.totalAmount     = 0;
    vm.hasTracking     = false;
    vm.hasNoName       = true;
    vm.items           = [];
    vm.iconCooking     = 'icon-cooking-' + env.ENVIRONMENT.toLowerCase();
    vm.environment     = env.ENVIRONMENT;
    vm.franchise       = env.COMPANY_NAME;
    vm.icon            = env.RESTAURANT_ICON_ACTIVE_URL;

    vm.setOrderName          = setOrderName;
    vm.trackingStepActive    = trackingStepActive;
    vm.trackingStatusActive  = trackingStatusActive;
    vm.finishedStatus        = finishedStatus;
    vm.showOptions           = showOptions;
    vm.showAdditionalProduct = showAdditionalProduct;
    vm.showStatusImg         = showStatusImg;

    vm.cart = cart;

    getTracking();

    ////////////////

    function getTracking() {
      return api.prefs.all()
      .then(function() {
        var tracking = api.prefs.get('tracking');
        vm.hasTracking = tracking.value == 'true';
        activate();
      });
    }

    function activate() {
      if (!vm.hasTracking) $state.go('main');
      return api.orders.privateOrders($stateParams.orderId)
      .then(function(order) {
        vm.order = order;
        vm.customer = order.customer ? order.customer :  {};
        vm.customerName = vm.customer.name.split(' ')[0];
        vm.customerLastName = vm.customer.name.split(' ')[1];
        vm.restaurant = order.restaurant ? order.restaurant : {};
        vm.hasNoName = !order.name;
      })
      .catch(function(err) {
        $log.error(err);
        if (err.status === 404) {
          ngNotify.set('El pedido al que haces referencia no es válido. Verifica que el link sea correcto', 'error');
          hero.setAnalyticsClass('perm-error-tracking-invalid');
          return $state.go('main', {}, { location: 'replace' });
        }
      })
      .then(function() {
        setPaymentDetails();
      })
      .then(function() {
        setOrderAddress();
      })
      .then(function() {
        setProducts();
      })
      .then(function() {
        setOrderProducts();
      })
      .then(function() {
        setAdditionalProducts();
      })
      .then(function() {
        setOrderPaymentMethod();
      })
      .then(function() {
        setOrderPromisedTime();
      })
      .then(function() {
        appendMetaPixel();
        appendOrderAnalytics();
      })
      .then(function() {
        setOrdersStatus();
        var interval = setInterval(function() {
          setOrdersStatus(interval);
        }, 10000);
      })
      .then(function() {
        vm.isLoadingItems = false;
      });
    }

    function setPaymentDetails() {
      var paymentDetails = vm.order.payment_details;
      if (paymentDetails) {
        vm.subtotalAmount = paymentDetails.subtotal_amount;
        vm.discountAmount = paymentDetails.discount_amount;
        vm.couponAmount   = paymentDetails.coupon_amount;
        vm.deliveryAmount = paymentDetails.delivery_amount;
        vm.tipAmount      = paymentDetails.tip_amount;
        vm.totalAmount    = paymentDetails.total_amount;
      } else {
        vm.subtotalAmount = vm.order.total;
        vm.deliveryAmount = vm.order.delivery_cost;
        vm.tipAmount      = vm.order.tip_amount;
        vm.totalAmount    = vm.order.total_to_pay;
      }
    }

    function setOrderAddress() {
      var orderType = vm.order.order_type.name ? vm.order.order_type.name.toLowerCase() : '';
      if (orderType == 'delivery') {
        vm.orderTypeName = 'Despacho';
        vm.orderTypeIcon = 'icon-delivered';
        vm.mapLonLat = vm.order.address.lonlat;
        var specificNumber = vm.order.address.specific_number ? ', ' + vm.order.address.specific_number : '';
        vm.address = vm.order.address.street_name + ' ' + vm.order.address.street_number + specificNumber + ', ' + vm.order.address.comune_name;
        vm.currentTime = vm.order.restaurant.current_delivery_time;
      }
      if (orderType == 'retiro') {
        vm.orderTypeName = 'Retiro';
        vm.orderTypeIcon = 'icon-ready-on-the-way';
        vm.mapLonLat = vm.order.restaurant.lonlat;
        vm.address = vm.order.restaurant.address + ', ' + vm.order.restaurant.comune_name;
        vm.currentTime = vm.order.restaurant.current_pickup_time;
      }
    }

    function setProducts() {
      if (vm.order.order_products) {
        var products = _.map(vm.order.order_products, function(product) {
          return product.product;
        }).filter(function (product) {
          return product.normal_price > 0;
        });
        if (products.length > 0) vm.items.push.apply(vm.items, products);
      }
      if (vm.order.order_promotions) {
        var promotions = _.map(vm.order.order_promotions, function(promotion) {
          return promotion.promotion;
        }).filter(function (promotion) {
          return promotion.normal_price > 0;
        });
        if (promotions.length > 0) vm.items.push.apply(vm.items, promotions);
      }
    }

    function setOrderProducts() {
      vm.orderItems = [];
      if (vm.order.order_products) {
        var orderProducts = _.filter(vm.order.order_products, function(product) {
          return product.product.normal_price > 0;
        });
        orderProducts = _.each(orderProducts, function(product) {
          product.item_type = 'product';
        });
        if (orderProducts.length > 0) vm.orderItems.push.apply(vm.orderItems, orderProducts);
      }
      if (vm.order.order_promotions) {
        var orderPromotions = _.filter(vm.order.order_promotions, function(promotion) {
          return promotion.promotion.normal_price > 0;
        });
        orderPromotions = _.each(orderPromotions, function(promotion) {
          promotion.item_type = 'promotion';
        });
        if (orderPromotions.length > 0) vm.orderItems.push.apply(vm.orderItems, orderPromotions);
      }
    }

    function setAdditionalProducts() {
      vm.additionalItems = [];
      if (vm.order.order_products) {
        var additionalProducts = _.filter(vm.order.order_products, function(product) {
          return product.product.normal_price == 0 && product.product.special_price == 0;
        });
        _.each(additionalProducts, function(product) {
          vm.additionalItems.push({
            id: product.id,
            name: product.product.name,
            quantity: product.quantity
          });
        });
      }
    }

    function setOrderPaymentMethod() {
      var method = vm.order.payment_method || "Efectivo";
      var lastDigits = null;

      if (vm.order.webpay_payment && vm.order.webpay_payment.last_four_card_digits) {
        lastDigits = vm.order.webpay_payment.last_four_card_digits;
      }
      if (!lastDigits && vm.order.transaction_data && vm.order.transaction_data.card_last_digits) {
        lastDigits = vm.order.transaction_data.card_last_digits;
      }
      vm.paymentMethod = lastDigits ? method + " - " + lastDigits : method;
    }

    function setOrderPromisedTime() {
      if (!vm.order.promised_time) return;

      var date = new Date(Date.parse(vm.order.promised_time));
      var now = new Date();

      var sameDay =
        date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth() &&
        date.getDate() === now.getDate();

      var locale = "es-" + env.COUNTRY;

      var time = new Intl.DateTimeFormat(locale, {
        hourCycle: "h23",
        hour: "2-digit",
        minute: "2-digit",
      }).format(date);

      if (sameDay) {
        vm.promisedTime = time;
        return;
      }

      var weekday = new Intl.DateTimeFormat(locale, { weekday: "long" }).format(
        date
      );
      var day = new Intl.DateTimeFormat(locale, { day: "2-digit" }).format(
        date
      );
      var month = new Intl.DateTimeFormat(locale, { month: "long" }).format(
        date
      );

      weekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);

      vm.promisedTime = weekday + " " + day + " de " + month + ", " + time;
    }

    function setOrdersStatus(interval) {
      api.orders.status($stateParams.orderId)
      .then(function(response) {
        vm.trackingUrl    = response.tracking_url ? response.tracking_url + "&only_show_map=1" : null;
        var orderType     = response.order_type;
        var statuses      = _.sortBy(response.statuses, 'position'),
            currentStatus = response.current_status;
        vm.currentStatus  = response.current_status;
        vm.ordersStatus   = _.each(statuses, function(status) {
          status.statusIcon    = status.status ? _.kebabCase('icon-' + status.status) : '';
          status.currentStatus = status.status == currentStatus;

          if (status.status == 'confirmed') status.name = 'Recibido';
          if (status.status == 'cooking') {
            status.name = 'Preparación';
            status.statusIcon = status.status ? _.kebabCase('icon-' + status.status + '-' + vm.environment) : '';
            status.statusImg = 'assets/images/icons/' + vm.environment + '/icon-cooking-active.svg';
          }
          if (orderType == 'Delivery') {
            if (status.status == 'ready_on_the_way') status.name = 'En camino';
            if (status.status == 'delivered') status.name = 'Entregado';
          } else {
            if (status.status == 'ready_on_the_way') {
              status.statusIcon = status.status ? _.kebabCase('icon-delivered') : '';
              status.name = 'Retirar';
            };
          }

          if (!!interval) {
            if (status.status == 'delivered' && status.currentStatus ||
                status.status == 'finished' && status.currentStatus) clearInterval(interval);
          }
        });
      })
      .catch(function(err) {
        $log.error(err);
        ngNotify.set('Error de conexión. Reintenta más tarde', 'error');
        hero.setAnalyticsClass('perm-server-error-notify');
        if (!!interval) clearInterval(interval);
      });
    }

    function setOrderName() {
      api.orders.save(vm.order)
      .then(function() {
        vm.hasNoName = false;
        ngNotify.set('Tu pedido ha quedado nombrado exitosamente.', 'info');
        hero.setAnalyticsClass('perm-success-set-order-name');
      }, function(err) {
        $log.error(err);
        ngNotify.set('Hubo un problema al nombrar tu pedido. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-error-set-order-name');
      })
      .then(function() {
        // loading the latest orders should update the name of the order
        api.prefs.all(true);
      });
    }

    function trackingStepActive(index) {
      if (index == 0) {
        if (vm.ordersStatus[1].currentStatus) return true;
        if (vm.ordersStatus[2].currentStatus) return true;
      }
      if (index == 1) {
        if (vm.ordersStatus[2].currentStatus) return true;
      }
      return false;
    }

    function trackingStatusActive(index) {
      if (finishedStatus(vm.currentStatus)) return true;
      if (vm.ordersStatus[index].currentStatus) return true;
      if (index == 0) {
        if (vm.ordersStatus[1].currentStatus) return true;
        if (vm.ordersStatus[2].currentStatus) return true;
      }
      if (index == 1) {
        if (vm.ordersStatus[2].currentStatus) return true;
      }
      return false;
    }

    function finishedStatus(currentStatus) {
      return currentStatus == 'delivered' || currentStatus == 'finished';
    }

    function showOptions(item) {
      var options = item.product_options ? item.product_options : {};
      if (item.item_type == "promotion") {
        var promotionProductGroups = item.promotion.promotion_product_groups;
        return _.map(promotionProductGroups, function(promotionProductGroup) {
          var products = promotionProductGroup.products;
          var selections = _.map(products, function(product, productIndex) {
            if (!options[promotionProductGroup.id] ||
                !options[promotionProductGroup.id][product.id] ||
                !options[promotionProductGroup.id][product.id].selected) return;
            var name = product.name,
              productOptions = _.extend({}, (options[productIndex] || {}), product.extras);
            if (!_.isEmpty(productOptions)) {
              name += ' (' + _.values(productOptions).join(', ') + ')';
            }
            return name;
          }).filter(function (el) {
            return el != undefined;
          });
          if (promotionProductGroup.items_limit > 0) {
            return promotionProductGroup.name + " " + selections.join(', ');
          } else {
            return selections.join(', ');
          }
        });
      }
      if (item.product && item.product.modifier_groups.length > 0) {
        var productGroups = item.product.modifier_groups;
        return _.map(productGroups, function(productGroup) {
          if (!options[productGroup.id]) return;
          var groupName = productGroup.name,
            groupCategories = productGroup.modifier_group_categories;
          var selections = _.map(groupCategories, function(groupCategory) {
            var groupVariants = groupCategory.modifier_group_variants;
            return _.map(groupVariants, function(groupVariant) {
              var variantId = groupVariant.variant.id,
                variantName = groupVariant.variant.name;
              var productOptions= options[productGroup.id].replace(/=>/gi, ":");
              productOptions= JSON.parse(productOptions);
              return _.map(productOptions, function(productGroupOption) {
                var productId = Object.keys(productGroupOption)[0],
                  variantQuantity = productGroupOption[productId].quantity;
                if (productId !== variantId) return;
                return variantName + (variantQuantity > 1 ? " (x" + variantQuantity + ")" : "");
              }).filter(function (el) {
                return el != undefined;
              });
            }).filter(function (el) {
              return el.length;
            });
          })
          return groupName + " " + selections.join(',').split(',').join(', ');
        });
      }
    }

    function showAdditionalProduct(item) {
      if (vm.additionalItems.length == 1) return item.quantity + ' ' + item.name;

      var penultimateItem = getPositionItem(item, -2);
      var lastItem = getPositionItem(item, -1);

      if (lastItem) {
        return 'y ' + item.quantity + ' ' + item.name + '.';
      } else if (penultimateItem) {
        return item.quantity + ' ' + item.name;
      } else {
        return item.quantity + ' ' + item.name + ', ';
      }
    }

    function getPositionItem(item, position) {
      return item.id === vm.additionalItems[vm.additionalItems.length - Math.abs(position)].id;
    }

    function showStatusImg(status) {
      if (status.status == 'cooking' && status.currentStatus) {
        return (env.ENVIRONMENT == 'niusushi' || env.ENVIRONMENT == 'mxniusushi');
      }
      return false;
    }

    function appendMetaPixel() {
      var script  = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML += 'fbq("init", "' + env.FACEBOOK_PIXEL_ID + '", ' + JSON.stringify(visitorData()) + ');';
      document.head.insertBefore(script, document.head.firstElementChild);
    }

    function visitorData() {
      return {
        'em': vm.customer.email,
        'fn': vm.customer.name,
        'ph': vm.customer.phones[0]
      }
    }

    function appendOrderAnalytics() {
      var script  = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = 'dataLayer.push({ ecommerce: null }); \n';
      script.innerHTML += 'dataLayer.push(' + JSON.stringify(analysisStructure()) + ');';
      document.head.insertBefore(script, document.head.firstElementChild);
    }

    function analysisStructure() {
      return {
        'event': 'purchase',
        'ecommerce': {
          'purchase': {
            'actionField': {
              'currency': env.CURRENCY,
              'id': vm.order.id,
              'revenue': vm.totalAmount,
              'shipping': vm.deliveryAmount,
              'em': vm.customer.email,
              'fn': vm.customer.name,
              'ph': vm.customer.phones[0],
              'userId': vm.customer.id
            },
            'products': vm.items
          }
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('website')
  .controller('TosController', TosController);

  /* @ngInject */
  function TosController(env, $rootScope) {
    var vm = this;
    vm.companyUrl = env.URL;
    vm.country = env.COUNTRY;
    vm.companyName = env.COMPANY_NAME;
    vm.companyEmail = env.COMPANY_EMAIL;
    vm.templateUrl = templateUrl;

    function templateUrl() {
      var country = vm.country.toLowerCase();
      return "app/tos/" + $rootScope.deviceType + "/tos-" + country + ".html";
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('RestaurantsController', RestaurantsController);

  /* @ngInject */
  function RestaurantsController(_, api, env, hero, ngNotify, $document, $log, $scope, $timeout) {
    var vm = this;
    vm.mapOptions = {};
    vm.mapOptions.mapTypeControl = false;
    vm.mapOptions.scrollwheel = false;
    vm.mapOptions.streetViewControl = false;
    vm.mapOptions.zoom = env.ENVIRONMENT === 'mxniusushi' ? 13 : 11;
    vm.selected = null;
    vm.localeCommune = '';
    vm.localeCommunes = '';
    vm.comunes = [];
    vm.polygons = [];
    vm.restaurants = [];
    vm.restaurantsAll = [];
    vm.kebabCase = _.kebabCase;

    vm.activate = activate;
    vm.onMarkerClick = onMarkerClick;
    vm.onSlideChange = onSlideChange;
    vm.googleMapsUrl = googleMapsUrl;

    vm.envConstants = env;

    activate();
    getComunes();
    getPolygon();

    ////////////////
    $scope.update = function () {
      if ($scope.restaurantComune) {
        vm.restaurants = _.filter(vm.restaurantsAll, {
          comune_id: $scope.restaurantComune.id
        });
        vm.selected = vm.restaurants[0];
        onSlideChange(0, 0, 0);
      } else {
        vm.restaurants = vm.restaurantsAll;
      }
    }

    function activate() {
      return api.restaurants.allActives()
      .then(function(restaurants) {
        vm.restaurants = restaurants;
        _.each(vm.restaurants, function(restaurant) {
          restaurant.icon = vm.envConstants.RESTAURANT_ICON_INACTIVE_URL;
        });
        vm.restaurantsAll = restaurants;
        var restaurantGroup = api.getCurrentLocation();
        vm.selected = getRestaurantSelected(restaurantGroup);
        onMarkerClick('', '', vm.selected);
        localeRestaurants();
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
        ngNotify.set('Error en la conexión. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-server-error-notify');
      });
    }

    function getRestaurantSelected(restaurantGroup) {
      if (restaurantGroup) return _.find(vm.restaurants, { restaurant_group_id: restaurantGroup.id }) || vm.restaurants[0];
      return vm.restaurants[0];
    }

    function getComunes() {
      return api.comunes.hasRestaurants()
      .then(function(comunes) {
        vm.comunes = comunes;
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
        ngNotify.set('Error en la conexión. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-server-error-notify');
      });
    }

    function getPolygon() {
      return api.restaurants.externalPolygon()
      .then(function(polygons){
        vm.polygons = polygons;
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
        ngNotify.set('Error en la conexión. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-server-error-notify');
      });
    }

    function onMarkerClick(marker, eventName, restaurant) {
      onSlideChange(0, 0, _.findIndex(vm.restaurants, restaurant));

      var id = _.kebabCase(restaurant.name);
      $timeout(function() {
        var parent = angular.element($document[0].getElementById('restaurants-list')),
        polygon = angular.element($document[0].getElementById(id));
        if (polygon.length == 0) return;
        return parent.animate({
          scrollTop: polygon[0].offsetTop - parent[0].offsetTop
        }, 'slow');
      }, 700);
    }

    function onSlideChange(nextSlide, direction, nextIndex) {
      if (0 <= nextIndex && nextIndex < vm.restaurants.length) {
        vm.selected.icon = vm.envConstants.RESTAURANT_ICON_INACTIVE_URL;
        vm.selected = vm.restaurants[nextIndex];
        vm.selected.icon = vm.envConstants.RESTAURANT_ICON_ACTIVE_URL;
      }
    }

    function localeRestaurants() {
      if (env.LOCALE == 'es-cl') {
        vm.localeCommune = 'comuna';
        vm.localeCommunes = 'comunas';
      }
      if (env.LOCALE == 'es-mx') {
        vm.localeCommune = 'alcaldía';
        vm.localeCommunes = 'alcaldías';
      }
    }

    function googleMapsUrl(restaurant) {
      if (restaurant.google_place_id) return 'https://www.google.com/maps/search/?api=1&query=' + env.URL + '&query_place_id=' + restaurant.google_place_id;
      return 'https://www.google.com/maps/search/?api=1&query=' + restaurant.lonlat[1] + ',' + restaurant.lonlat[0];
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('SeleableController', SeleableController);

  /* @ngInject */
  function SeleableController(analytics, api, cart, customer, makeSelection, seleable, category, categories, myFavorites, _, $uibModalInstance, $timeout, $filter, $state, env, html) {
    var vm = this;
    vm.addedUpselling = false;
    vm.cart = cart;
    vm.addToCart = addToCart;
    vm.cancel = cancel;
    vm.carouselInterval = 6000;
    vm.category = category;
    vm.changeSeleable = changeSeleable;
    vm.currentIndex = 0;
    vm.currentState = $state.current.name;
    vm.customer = customer.get();
    vm.getUpselling = null;
    vm.images = [];
    vm.makeSelection = makeSelection;
    vm.onSelectionChange = onSelectionChange;
    vm.price = price;
    vm.calculateTotals = calculateTotals;
    vm.product = null;
    vm.productSelections = {};
    vm.promotion = null;
    vm.promotionSelections = [];
    vm.toggleLike = toggleLike;
    vm.currentImage = {};
    vm.selectedPromotionProducts = {}
    vm.selectedProductVariants = {}
    vm.shouldDisableGroup = shouldDisableGroup;
    vm.shouldDisableElem = shouldDisableElem;
    vm.additionalPrice = 0;
    vm.calculateAdditionalPrice = calculateAdditionalPrice;
    vm.submiteable = false;
    vm.hasExtraPriceDiscount = false;
    vm.hasServingsSeleable = false;

    vm.modifyVariant = modifyVariant;
    vm.modifyRadioVariant = modifyRadioVariant;
    vm.addHeartFull = addHeartFull;
    vm.addHeartEmpty = addHeartEmpty;
    vm.productQuantity = 1;
    vm.addOne = addOne;
    vm.removeOne = removeOne;
    vm.html = html;
    vm.showTotalOnButton = env.SHOW_TOTAL_ON_BUTTON;

    getExtraPriceDiscount();
    activate();
    getServingsSeleable();
    ////////////////

    function activate() {
      vm.images[0] = {
        src: seleable.image.medium,
        lazy: seleable.image.medium,
        large: seleable.image.large
      };
      vm.currentImage = vm.images[0];

      var promotionProductGroups = seleable.promotion_product_groups;
      vm.submiteable = seleable.repeat_order || false;
      if (promotionProductGroups) {
        // it is a promotion
        vm.promotion = seleable;
        _.each(promotionProductGroups, function(promotionProductGroup) {
          promotionProductGroup.amountChecked = 0;
          promotionProductGroup.shouldDisable = false;
          vm.selectedPromotionProducts[promotionProductGroup.id] = 
          {
            name: promotionProductGroup.name, amountChecked: 0, 
            free_items_quantity: promotionProductGroup.free_items_quantity, 
            extra_price_per_item: promotionProductGroup.extra_price_per_item, 
            items_limit: promotionProductGroup.items_limit
          }
          var products = promotionProductGroup.products;
          _.each(products, function(prod, index) {
            // The option will be JUST TEXT in the modal:
            //   free_items_quantity == 1 and items_limit == 0
            // The option will be RADIO BUTTON in the modal:
            //  free_items_quantity == 1 and items_limit == 1 and extra_price_per_item == 0
            // The option will be CHECKBOX in the modal:
            //  free_items_quantity >= 1 and items_limit >= 1 and extra_price_per_item >= 0
            var selected = (promotionProductGroup.free_items_quantity == 1 && promotionProductGroup.items_limit == 0) ? true
                         : (promotionProductGroup.free_items_quantity == 1 && promotionProductGroup.items_limit == 1 && promotionProductGroup.extra_price_per_item == 0 && index == 0) ? true
                         : false;
            vm.selectedPromotionProducts[promotionProductGroup.id][prod.id] = 
            {
              selected: selected || false,
              extra: prod.extra || false, 
              name: prod.name, 
              extraPrice: prod.price
            }
            if (selected) {
              shouldDisableGroup(promotionProductGroup, prod);
            } else if (!promotionProductGroup.shouldDisable) {
              vm.submiteable = false;
            }
            var product = api.products.get(prod.id);
            if (product) {
              vm.images.push({
                src: product.image.medium,
                lazy: product.image.medium,
                large: product.image.large,
                text: product.name
              });
            }
          });
        });
        if (seleable.repeat_order){
          calculateAdditionalPrice();
        }
      } else {
        vm.product = seleable;
        vm.pref = vm.product.preference;

        var modifierGroups = seleable.modifier_groups;
        if (modifierGroups) {
          _.each(modifierGroups, function(modifierGroup) {
              modifierGroup.amountChecked = 0;
              modifierGroup.shouldDisable = false;
              vm.selectedProductVariants[modifierGroup.id] = 
              {
                name: modifierGroup.name, amountChecked: 0, 
                free_items_quantity: modifierGroup.free_quantity, 
                extra_price_per_item: modifierGroup.extra_price, 
                max_permitted_per_option: modifierGroup.max_permitted_per_option,
                min_selection: modifierGroup.min_selection,
                max_selection: modifierGroup.max_selection,
                variants: {}
              }
              var modifierGroupCategories = modifierGroup.modifier_group_categories;
              _.each(modifierGroupCategories, function(modifierGroupCategory) {
                var modifierGroupVariant = modifierGroupCategory.modifier_group_variants;
                _.each(modifierGroupVariant, function(modifierGroupVariant, mgvIndex) {
                  var prod = modifierGroupVariant.variant;
                  // The option will be JUST TEXT in the modal:
                  //   min_selection == 0 and max_selection == 1 and max_permitted_per_option == 0
                  // The option will be RADIO BUTTON in the modal:
                  //   min_selection == 1 and max_selection == 1 and max_permitted_per_option == 1
                  // The option will be BUTTON QUANTITY in the modal:
                  //   min_selection != 1 or max_selection != 1 or max_permitted_per_option != 1
                  prod.selected = (modifierGroup.min_selection == 0 && modifierGroup.max_selection == 1 && modifierGroup.max_permitted_per_option == 0) ? true : prod.selected || false;
                  vm.selectedProductVariants[modifierGroup.id].variants[prod.id] = 
                  {
                    selected: prod.selected || false, 
                    extra: prod.extra || false, 
                    name: prod.name, 
                    extraPrice: modifierGroupVariant.extra_price,
                    quantity: 0
                  }
                  if (modifierGroup.min_selection == 0) shouldDisableModifierGroup(vm.selectedProductVariants[modifierGroup.id]);
                  if (modifierGroup.min_selection == 0 && modifierGroup.max_selection == 1 && modifierGroup.max_permitted_per_option == 0) {
                    vm.selectedProductVariants[modifierGroup.id].variants[prod.id].quantity += 1;
                    vm.selectedProductVariants[modifierGroup.id].amountChecked += 1;
                    shouldDisableModifierGroup(vm.selectedProductVariants[modifierGroup.id]);
                  }
                  if (modifierGroup.max_selection == 1 && modifierGroup.max_permitted_per_option == 1) {
                    if (modifierGroup.min_selection == 0) modifyVariant(modifierGroup.id, prod.id);
                    if (modifierGroup.min_selection == 1 && mgvIndex == 0) modifyRadioVariant(modifierGroup.id, prod.id);
                  } else {
                    if (modifierGroup.min_selection != 0) {
                      vm.submiteable = false;
                    }
                  }
                });
              });
          });
          if (seleable.repeat_order){
            calculateAdditionalPrice();
          }
        }

        vm.product.modifier_groups = _.each(vm.product.modifier_groups, function(modifierGroup) {
          modifierGroup.isExpanded = true;
        })
      }

      vm.pref = seleable.preference || 0;
    }

    function getExtraPriceDiscount() {
      return api.prefs.all()
      .then(function() {
        var extraPriceDiscount = api.prefs.get('extra_price_discount');
        vm.hasExtraPriceDiscount = extraPriceDiscount.value == 'true';
      });
    }

    function getServingsSeleable() {
      return api.prefs.all()
      .then(function() {
        var servingsSeleable = api.prefs.get('servings_seleable');
        vm.hasServingsSeleable = servingsSeleable.value == 'true';
      });
    }

    function setNextProduct(products) {
      vm.product = _.find(products, function(product, i) {
        if (!_.isEmpty(product.product_options) && !vm.promotionSelections[i]) {
          var multiple = false;
          var options = Object.keys(product.product_options);
          vm.promotionSelections[i] = {};
          options.forEach(function(option, index){
            if (product.product_options[option].length > 1){
              multiple = true;
            } else if (product.product_options[option].length == 1) {
              vm.promotionSelections[i][option] = product.product_options[option][0]
            }
          });
          if (multiple) {
            vm.currentIndex = i;
            return true;
          }
        }
        return false;
      });
      if(vm.product) { vm.pref = vm.product.preference; }
      vm.currentImage = vm.images[0]; //vm.currentIndex + 1];
    }

    function addToCart(quantity) {
      if (vm.promotion) {
        vm.makeSelection = true;

        if (!vm.product) {
          cart.addWithEffect(seleable.id, seleable.name, quantity, vm.selectedPromotionProducts, seleable.type, vm.additionalPrice);
          analytics.addToCart(seleable, vm.additionalPrice);
          $uibModalInstance.close();
          return true;
        }
      }

      var productOptions = vm.product.product_options;
      if (productOptions) {
        vm.reminder = _.findKey(productOptions, function (options, name) {
          if (!vm.productSelections[name]) {
            return name;
          }
        });
      }

      if (vm.reminder) {
        vm.reminder = vm.reminder.toLowerCase();
        return false;
      }

      var modifiable = !_.isEmpty(vm.selectedProductVariants);

      var selectedOptions;
      if (modifiable) {
        selectedOptions = {};
        Object.entries(vm.selectedProductVariants).map(function (modifier) {
          selectedOptions[modifier[0]] = [];
          _.each(Object.entries(modifier[1].variants), function (variant) {
            if (variant[1].quantity > 0) {
              var v = {};
              v[variant[0]] = { quantity: variant[1].quantity, name: variant[1].name };
              selectedOptions[modifier[0]].push(v);
            }
          });
        });
      } else {
        selectedOptions = vm.productSelections;
      }

      cart.addWithEffect(seleable.id, seleable.name, quantity, selectedOptions, seleable.type, vm.additionalPrice, modifiable);

      if (vm.addedUpselling) {
        cart.addWithEffect(seleable.upselling, seleable.name, quantity, {}, seleable.upselling.type);
      }

      analytics.addToCart(seleable, vm.additionalPrice);
      $uibModalInstance.close();

      return true;
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function changeSeleable(direction) {
      var seleablesList = vm.category.seleables;
      var index = _.findIndex(seleablesList, seleable);
      index += direction === 'next' ? 1 : -1;
      if (0 <= index && index < seleablesList.length) {
        seleable = seleablesList[index];
        activate();
      }
    }

    function toggleLike() {
      var setPreference = vm.product ? api.products.setPreference : api.promotions.setPreference;

      var product = vm.product || seleable;
      var newPref = vm.pref ? 0 : 1;

      var updateLike = setPreference(product, newPref);
      vm.pref = newPref
      updateLike.then(function() {
        seleable.preference = newPref;

        api.myFavorites.get(true).then(function(response) {
          myFavorites[0].seleables = response.favorites
        })

        if (category.name.toLowerCase() === 'mis favoritos'){
          _.each(categories, function(cat){
            _.each(cat.seleables, function(sel){
              if(seleable.id === sel.id) sel.preference = newPref;
            });
          });
        }
      });
    }

    function price(seleable, applyDiscount) {
      return cart.price(seleable.id, applyDiscount, seleable.type, vm.additionalPrice);
    }

    function calculateTotals(seleable, applyDiscount, productQuantity) {
      var subTotal = cart.price(seleable.id, applyDiscount, seleable.type, vm.additionalPrice);
      var total = subTotal * productQuantity;
      var respIntl = cart.parseIntl(total);
      return respIntl;
    }

    function calculateAdditionalPrice(){
      vm.additionalPrice = 0
      _.each(vm.selectedPromotionProducts, function(promotionProductGroup){
        if (promotionProductGroup.amountChecked > promotionProductGroup.free_items_quantity){
          var extraItems = promotionProductGroup.amountChecked - promotionProductGroup.free_items_quantity;
          vm.additionalPrice += promotionProductGroup.extra_price_per_item * extraItems;
        }
        var extraItemPrices = 0
        _.each(promotionProductGroup, function(product){
          if (!product || !product.selected)
            return;
          extraItemPrices += product.extraPrice
        });
        vm.additionalPrice += extraItemPrices;
      });
    }

    function onSelectionChange() {
      if (!vm.makeSelection) {
        return;
      }
      $timeout(addToCart, 40);
    }

    function shouldDisableGroup(promotionProductGroup, product) {
      _.each(vm.selectedPromotionProducts[promotionProductGroup.id], function(promotionProduct, index) {
        if (!promotionProduct || !promotionProduct.name) return;
        // The option will be JUST TEXT in the modal:
        //   free_items_quantity == 1 and items_limit == 0
        // The option will be RADIO BUTTON in the modal:
        //  free_items_quantity == 1 and items_limit == 1 and extra_price_per_item == 0
        // The option will be CHECKBOX in the modal:
        //  free_items_quantity >= 1 and items_limit >= 1 and extra_price_per_item >= 0
        if (promotionProductGroup.free_items_quantity == 1 && promotionProductGroup.items_limit == 0 ||
            promotionProductGroup.free_items_quantity == 1 && promotionProductGroup.items_limit == 1 &&
            promotionProductGroup.extra_price_per_item == 0) {
          promotionProduct.selected = (index == product.id) ? true : false;
        }
      });
      var selectedProduct = vm.selectedPromotionProducts[promotionProductGroup.id][product.id];
      if (selectedProduct && selectedProduct.selected) {
        promotionProductGroup.amountChecked++;
        vm.selectedPromotionProducts[promotionProductGroup.id].amountChecked++;
      } else {
        promotionProductGroup.amountChecked--;
        vm.selectedPromotionProducts[promotionProductGroup.id].amountChecked--;
        selectedProduct.extra = false;
      }
      var extraCounter = 0;
      _.each(vm.selectedPromotionProducts[promotionProductGroup.id], function(product, index) {
        if (!product || !product.selected) return;
        product.extra = false;
        extraCounter++;
        if (extraCounter > promotionProductGroup.free_items_quantity) {
          product.extra = true;
        }
      });
      promotionProductGroup.shouldDisable = (promotionProductGroup.items_limit && promotionProductGroup.amountChecked >= promotionProductGroup.items_limit);
      calculateAdditionalPrice();
      updateSubmiteable();
    }

    function shouldDisableElem(promotionProductGroup, product){
      var shouldDisable = false;
      var selectedGroup = vm.selectedPromotionProducts[promotionProductGroup.id];

      if (selectedGroup && (!selectedGroup[product.id] || selectedGroup[product.id] && selectedGroup[product.id].selected !== true) ){
        shouldDisable = promotionProductGroup.shouldDisable;
      }
      return shouldDisable;
    }

    function updateSubmiteable(){
      vm.submiteable = true;
      _.each(vm.selectedPromotionProducts, function(selectedPromotionProduct) {
        vm.submiteable = vm.submiteable && (selectedPromotionProduct.amountChecked > 0)
      });
    }

    function modifyVariant(modifierGroupId, prodId, operation){
      var modifierGroup = vm.selectedProductVariants[modifierGroupId]
      var variant = modifierGroup.variants[prodId]
      if (!variant.quantity) variant.quantity = 0;
      if (operation == "add" && variant.quantity < modifierGroup.max_permitted_per_option && modifierGroup.amountChecked < modifierGroup.max_selection) {
        variant.quantity += 1;
        modifierGroup.amountChecked += 1;
      } else if (operation == "substract" && variant.quantity > 0) {
        variant.quantity -= 1;
        modifierGroup.amountChecked -= 1;
      }
      shouldDisableModifierGroup(modifierGroup);
    }

    function modifyRadioVariant(modifierGroupId, prodId){
      var modifierGroup = vm.selectedProductVariants[modifierGroupId]
      _.each(modifierGroup.variants, function(variant) {variant.quantity = 0});
      var variant = modifierGroup.variants[prodId]
      variant.quantity = 1;
      modifierGroup.amountChecked = 1;
      shouldDisableModifierGroup(modifierGroup);
    }

    function shouldDisableModifierGroup(modifierGroup){
      modifierGroup.shouldDisable = (modifierGroup.max_selection && modifierGroup.amountChecked >= modifierGroup.max_selection);
      calculateAdditionalPriceModifiableProduct();
      updateSubmiteableModifiableProduct();
    }

    function updateSubmiteableModifiableProduct(){
      vm.submiteable = true;
      _.each(vm.selectedProductVariants, function(selectedProductVariant) {
        //Skip validation if extra
        if (selectedProductVariant.min_selection == 0) return;
        if (selectedProductVariant.extra_price_per_item > 0 && selectedProductVariant.free_items_quantity == 0) return;
        var selectedVariantsCount = Object.entries(selectedProductVariant.variants).map(function(item){
          return item[1].quantity;
        }).reduce(_.add, 0);
        if (Object.keys(selectedProductVariant.variants).length === 0 && selectedProductVariant.max_selection > 0) {
          selectedProductVariant.amountChecked = 1;
        }
        vm.submiteable = vm.submiteable && selectedProductVariant.amountChecked > 0 && selectedVariantsCount >= selectedProductVariant.min_selection
      });
    }

    function calculateAdditionalPriceModifiableProduct(){
      vm.additionalPrice = 0
      _.each(vm.selectedProductVariants, function(selectedProductVariant){
        if (selectedProductVariant.amountChecked > selectedProductVariant.free_items_quantity){
          var extraItems = selectedProductVariant.amountChecked - selectedProductVariant.free_items_quantity;
          vm.additionalPrice += selectedProductVariant.extra_price_per_item * extraItems;
        }
        var extraItemPrices = 0
        _.each(selectedProductVariant.variants, function(variant){
          if (variant.quantity == 0)
            return;
          extraItemPrices += variant.extraPrice * variant.quantity
        });
        vm.additionalPrice += extraItemPrices;
      });
    }

    function selectDefaultModifierOptions(){
      var options = angular.element('.default-selected-option');
      _.each(options, function(option) {
        angular.element(option).trigger('click');
      });
    }

    function addHeartFull(event) {
      event.target.src = 'assets/images/favorite-heart.svg';
    }

    function addHeartEmpty(event) {
      event.target.src = 'assets/images/favorite-heart-empty.svg';
    }

    function addOne() {
      vm.productQuantity += 1;
    }

    function removeOne() {
      vm.productQuantity -= 1;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('RestaurantMenuController', RestaurantMenuController);

  /* @ngInject */
  function RestaurantMenuController(api, $rootScope, $state, $log) {
    var vm = this;
    vm.imageUrl = null;
    vm.deviceType = $rootScope.deviceType;
    vm.menuType = $state.params.menuType;
    // TODO: The condition by default can be removed after coordination with the
    //   marketing area for the printing of QR codes.
    //   The condition should also be removed on the web front
    vm.imageableType = $state.params.type || 'RestaurantGroup';
    vm.id = $state.params.id;

    activate();
    ////////////////

    function activate() {
      getImageUrl();
    }

    function getImageUrl() {
      return api.imageable.getImage(vm.imageableType, vm.id, vm.deviceType, vm.menuType)
      .then(function(response) {
        vm.imageUrl = response['image_url'];
      })
      .catch(function(err) {
        ngNotify.set('Hubo un problema al intentar acceder al menú', 'error');
        $state.go('main');
        $log.error(JSON.stringify(err));
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('ReceiptController', ReceiptController);

  /* @ngInject */
  function ReceiptController(_, api, env, hero, restaurant, $log, ngNotify, $state, $stateParams, $window) {
    var vm = this;
    vm.inProgress = false;
    vm.checkTicketSuccess = false;
    vm.restaurants = null;
    vm.clientType = null;
    vm.errorMessage = null;
    vm.ticketForm = {};
    vm.checkTicketForm = {};
    vm.receiptForm = {}; //{restaurant_identifier: "24", amount: 14800, fiscal_number: 2815};
    vm.taxRegimeItems = [];
    vm.filteredTaxRegimes = [];
    vm.filteredCfdiUses = [];
    vm.patternDate = /(\d{2})\-(\d{2})\-(\d{4})/;

    vm.activate = activate;
    vm.requestDte = requestDte;
    vm.checkTicket = checkTicket;
    vm.requestTicket = requestTicket;
    vm.onChangeTaxRegimeType = onChangeTaxRegimeType;
    vm.downloadFile = downloadFile;

    vm.backState = $stateParams.backState;
    vm.filePdfBase64 = $stateParams.filePdfBase64 || null;
    vm.fileXmlBase64 = $stateParams.fileXmlBase64 || null;
    vm.bussinessName = $stateParams.bussinessName || null;

    activate();

    ////////////////

    function activate() {
      setCheckTicketForm();
      activateMyReceiptData()
      return api.restaurants.all()
      .then(function(restaurants) {
        var items = restaurants.sort(restaurant.sortArrayRestaurants);
        vm.restaurants = items;
      });
    }

    function activateMyReceiptData() {
      if (!env.MY_RECEIPT) return;

      getTaxRegimeItems();
      getCfdiUseItems();
    }

    function setCheckTicketForm() {
      vm.checkTicketForm.restaurant_identifier = $stateParams.rid ? $stateParams.rid : '';
      vm.checkTicketForm.fiscal_number = $stateParams.fiscal_n ? parseInt($stateParams.fiscal_n) : '';
      vm.checkTicketForm.emission_date = $stateParams.date ? new Date($stateParams.date.replace(vm.patternDate, '$2-$1-$3')) : '';
      // TODO: Parse float amount: parseFloat($stateParams.amount)
      vm.checkTicketForm.amount = $stateParams.amount ? $stateParams.amount : '';
    }

    function requestDte() {
      var form = vm.receiptForm;
      api.receipts.get(form)
      .then(function(resp) {
        var data = resp.data;
        var respType = resp.headers["content-type"];
        if (respType == "application/json") {
          ngNotify.set('Documento no encontrado. Intenta más tarde.', 'error');
          hero.setAnalyticsClass('perm-error-request-receipt');
        } else {
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          $window.open(fileURL);
          ngNotify.set('Documento encontrado.', 'info');
          hero.setAnalyticsClass('perm-success-request-receipt');
        }
      })
      .catch(function(resp) {
        $log.error(JSON.stringify(resp));
        ngNotify.set('Hubo un problema en la conexión. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-server-error-notify');
      });
    }

    function checkTicket() {
      vm.inProgress = true;
      var form = vm.checkTicketForm;
      api.receiptsTpb.check(form)
      .then(function(resp) {
        vm.inProgress = false;
        vm.filePdfBase64 = resp.file_pdf_base64;
        vm.fileXmlBase64 = resp.file_xml_base64;
        vm.bussinessName = resp.bussiness_name;

        if (vm.filePdfBase64 && vm.fileXmlBase64) {
          goToSuccess();
        } else {
          vm.checkTicketSuccess = true;
        }
        ngNotify.set('Ticket encontrado.', 'info');
        hero.setAnalyticsClass('perm-success-check-ticket');
      })
      .catch(function(resp) {
        vm.inProgress = false;
        $log.error(JSON.stringify(resp));
        if (resp.status === 404) {
          ngNotify.set('No se encontró ticket con los datos ingresados.', 'error');
          hero.setAnalyticsClass('perm-error-check-ticket');
          return;
        }
        ngNotify.set('Hubo un problema en la conexión. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-server-error-notify');
      });
    }

    function requestTicket() {
      vm.inProgress = true;
      var form = vm.ticketForm;
      form.fiscal_number = vm.checkTicketForm.fiscal_number;
      form.restaurant_identifier = vm.checkTicketForm.restaurant_identifier;
      if (!validateRfc(form.bussiness_identification)) return;
      api.receiptsTpb.update(form)
      .then(function(resp) {
        vm.inProgress = false;
        vm.bussinessName = resp.bussiness_name;
        vm.filePdfBase64 = resp.file_pdf_base64;
        vm.fileXmlBase64 = resp.file_xml_base64;

        if (vm.filePdfBase64 && vm.fileXmlBase64) {
          goToSuccess();
          ngNotify.set('Éxito al generar ticket.', 'info');
          hero.setAnalyticsClass('perm-success-generate-receipt');
        }
      })
      .catch(function(resp) {
        vm.inProgress = false;
        $log.error(JSON.stringify(resp));
        if (resp.data && resp.data.message) {
          ngNotify.set(resp.data.message, 'error');
          hero.setAnalyticsClass('perm-error-generate-receipt');
          setErrorMessage(resp.data);
        } else {
          ngNotify.set('Ups hubo un problema. Intenta más tarde.', 'error');
          hero.setAnalyticsClass('perm-server-error-notify');
          vm.errorMessage = null;
        }
      });
    }

    function downloadFile(type) {
      var fileBase64 = type === 'pdf' ? vm.filePdfBase64 : vm.fileXmlBase64
      var binaryData = atob(fileBase64);
      var arrayBuffer = new ArrayBuffer(binaryData.length);
      var uint8Array = new Uint8Array(arrayBuffer);
      for (var i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }

      var file = new Blob([uint8Array], { type: "application/" + type });
      var fileURL = window.URL.createObjectURL(file);
      $window.open(fileURL);
    }

    function validateRfc(rfc) {
      var newRegex = new RegExp(/[A-ZÑ&]{3,4}\d{6}[A-V1-9][A-Z1-9][0-9A]/);
      if (validateLengthRfc(rfc) && rfc.match(newRegex)) return true;

      var errMessage = { code: '', message: 'RFC inválido.' };
      ngNotify.set(errMessage.message, 'error');
      hero.setAnalyticsClass('perm-error-rfc-invalid');
      setErrorMessage({code: '', message: errMessage.message});
      vm.inProgress = false;
      return false;
    }

    function validateLengthRfc(rfc) {
      var lengthValue = rfc.length;
      return lengthValue >= 12 && lengthValue <= 13;
    }

    function setErrorMessage(data) {
      vm.errorMessage = data.code + ' - ' + data.message;
    }

    function goToSuccess() {
      $state.go('receipt-success', { filePdfBase64: vm.filePdfBase64, fileXmlBase64: vm.fileXmlBase64, bussinessName: vm.bussinessName });
    }

    function getTaxRegimeItems() {
      return api.receiptsTpb.tax_regimes()
      .then(function(resp) {
        vm.taxRegimeItems = resp.items;
      })
      .catch(function(resp) {
        $log.error(JSON.stringify(resp));
        ngNotify.set('Hubo un problema en la conexión. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-server-error-notify');
      });
    }

    function getCfdiUseItems() {
      return api.receiptsTpb.cfdi_uses()
      .then(function(resp) {
        vm.cfdiUseItems = resp.items;
      })
      .catch(function(resp) {
        $log.error(JSON.stringify(resp));
        ngNotify.set('Hubo un problema en la conexión. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-server-error-notify');
      });
    }

    function onChangeTaxRegimeType() {
      vm.filteredTaxRegimes = _.filter(vm.taxRegimeItems, function(item) {
        return item[vm.clientType] === true;
      });

      vm.filteredCfdiUses = _.filter(vm.cfdiUseItems, function(item) {
        return item[vm.clientType] === true;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('ProfileController', ProfileController);

  /* @ngInject */
  function ProfileController(_, api, cart, cartproduct, coupon, customer, hero, html, kushki, ngNotify, $auth, $document, $localStorage, $log, $rootScope, $scope, $templateCache, $uibModal, $window) {
    var vm = this;
    vm.info = null;
    vm.genders = ['Masculino', 'Femenino'];
    vm.addresses = [];
    vm.phones = null;
    vm.latestOrders = [];
    vm.tbkUsers = [];
    vm.paymentCards = [];

    vm.saveProfile = saveProfile;
    vm.newAddressModal = newAddressModal;
    vm.deactivateAddress = deactivateAddress;
    vm.deactivateCard = deactivateCard;
    vm.signOut = signOut;

    vm.cart = cart;
    vm.coupon = coupon;
    vm.kushki = kushki;

    activate();

    ////////////////

    $scope.$on('kushki:delete-card', function() {
      getPaymentCards();
    });

    $rootScope.$on('auth:logout-success', function() {
      customer.set(null);
    });

    function activate() {
      var auth = customer.get();
      // pass a Date object
      var date = auth.birthdate;
      if (date && _.isString(date)) {
        date = date.split('-');
        auth.birthdate = new Date();
        auth.birthdate.setYear(date[0]);
        auth.birthdate.setMonth(+date[1] - 1, date[2]);
      }
      vm.info = auth;
      vm.phones = vm.info.phones;

      api.addresses.all()
      .then(function(addresses) {
        vm.addresses = _.sortBy(addresses, 'comune_name');
      })
      .catch(onError);

      api.prefs.all().then(function() {
        var kushki_payment = api.prefs.get('kushki_payment');
        var online_payment = api.prefs.get('online_payment');
        vm.kushkiPayment = kushki_payment ? kushki_payment.value.toLowerCase() === 'true' : false;
        vm.onlinePayment = online_payment ? online_payment.value.toLowerCase() === 'true' : false;
        if (vm.kushkiPayment) getPaymentCards();
        if (vm.onlinePayment) getTbkUser();
      });
    }

    function getPaymentCards() {
      api.payment_gateway.get_payment_cards()
      .then(function(response) {
        vm.paymentCards = response.payment_cards;
      })
      .catch(onError);
    }

    function getTbkUser() {
      api.tbkuser.all(vm.info.id)
      .then(function(tbkUsers) {
        vm.tbkUsers = tbkUsers;
      })
      .catch(onError);
    }

    function saveProfile(profile) {
      vm.info.phones = vm.phones;
      api.prefs.set(profile)
      .then(function() {
        ngNotify.set('¡Guardado!', 'info');
        hero.setAnalyticsClass('perm-success-updating-profile');
      })
      .catch(function() {
        var msg = 'Hubo un problema al actualizar tu perfil. Intenta más tarde.';
        ngNotify.set(msg, 'error');
        hero.setAnalyticsClass('perm-error-updating-profile');
      });
    }

    function newAddressModal(isMobile) {
      var templateUrl = "app/address/desktop/address.modal.html";
      if (isMobile) templateUrl = "app/address/mobile/address.modal.html";
      var modalConfig = {
        animation: true,
        backdrop: "static",
        controller: "AddressController",
        controllerAs: "address",
        windowClass: "newAddressModal",
        resolve: {
          fromLogin: function () {
            return false;
          },
        },
      };
      modalConfig.templateUrl = templateUrl;
      var modalInstance = $uibModal.open(modalConfig);
      modalInstance.result.then(function (newAddress) {
        if (!newAddress) return;
        vm.addresses.unshift(newAddress);
        vm.addresses = _.sortBy(vm.addresses, "comune_name");
      });
    }

    function deactivateAddress(address) {
      var templateUrl = 'app/address/confirmation.modal.html';
      var template = $templateCache.get(templateUrl);
      var modalConfig = {
        animation: true,
        controller: 'AddressConfirmationModalController',
        controllerAs: 'confirmation',
        windowClass: 'deactivateAddressModal',
        resolve: {
          address: function () {
            return address;
          }
        }
      };
      if (template) {
        modalConfig.template = template;
      } else {
        modalConfig.templateUrl = templateUrl;
      }
      var modalInstance = $uibModal.open(modalConfig);

      modalInstance.result.then(function (confirmed) {
        if (confirmed) {
          address.active = false;
          return api.addresses.save(address)
          .then(function(data) {
            api.addresses.all()
            .then(function(addresses) {
              vm.addresses = _.sortBy(addresses, 'comune_name');
            });
            ngNotify.set('Dirección eliminada con éxito.', 'info');
            hero.setAnalyticsClass('perm-success-deactivate-address');
          })
          .catch(function() {
            var msg = 'Hubo un problema eliminando tu dirección. Intenta más tarde.';
            ngNotify.set(msg, 'error');
            hero.setAnalyticsClass('perm-error-deactivate-address');
          });
        }
      }, function (e) {
        console.error(e);
      });
    }

    function deactivateCard(tbkUser, index) {
      var templateUrl = 'app/webpay/confirmation.modal.html';
      var template = $templateCache.get(templateUrl);
      var modalConfig = {
        animation: true,
        keyboard: false,
        backdrop: 'static',
        controller: 'WebpayCardConfirmationModalController',
        controllerAs: 'confirmation',
        windowClass: 'deactivateCardModal'
      };
      if (template) {
        modalConfig.template = template;
      } else {
        modalConfig.templateUrl = templateUrl;
      }
      var modalInstance = $uibModal.open(modalConfig);

      modalInstance.result.then(function (confirmed) {
        if (confirmed) {
          var button = $document[0].getElementById('tbkuser-' + index + '-deactivate-card');
          var loader = $document[0].getElementById('tbkuser-' + index + '-loader');
          html.addClass(button, 'hidden');
          html.removeClass(loader, 'hidden');
          var params = {
            customer_id: vm.info.id,
            tbk_user_id: tbkUser.id
          };
          return api.webpay.deactivate(params)
          .then(function(response) {
            if (response.tbk_user_deactivated) {
              html.addClass(button, 'hidden');
              html.removeClass(loader, 'hidden');
              _.remove(vm.tbkUsers, function(obj) {
                return obj.id == tbkUser.id;
              });
              vm.tbkUser = null;
              ngNotify.set('Tarjeta de crédito eliminada con éxito.', 'info');
              hero.setAnalyticsClass('perm-success-deactivate-credit-card');
            } else {
              html.addClass(loader, 'hidden');
              html.removeClass(button, 'hidden');
              var msg = 'Hubo un problema eliminando tu tarjeta. Intenta más tarde.';
              ngNotify.set(msg, 'error');
              hero.setAnalyticsClass('perm-error-deactivate-credit-card');
            }
          })
          .catch(function() {
            html.addClass(loader, 'hidden');
            html.removeClass(button, 'hidden');
            var msg = 'Hubo un problema eliminando tu tarjeta. Intenta más tarde.';
            ngNotify.set(msg, 'error');
            hero.setAnalyticsClass('perm-error-deactivate-credit-card');
          });
        }
      }, function (e) {
        console.error(e);
      });
    }

    function signOut() {
      $auth.signOut()
      .then(function() {
        var restaurantGroup = $localStorage.restaurantGroup;
        customer.set(null);
        $localStorage.$reset();
        $localStorage.restaurantGroup = restaurantGroup;
        $window.location.href = '/';
      })
      .catch(onError);
    }

    function onError(err) {
      $log.error(JSON.stringify(err));
      ngNotify.set('Error en la conexión. Intenta más tarde.', 'error');
      hero.setAnalyticsClass('perm-server-error-notify');
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("website")
    .controller("PaymentRedirectController", PaymentRedirectController);

  /** @ngInject */
  function PaymentRedirectController($stateParams, $window) {
    var vm = this;

    vm.status = $stateParams.status;
    vm.orderId = $stateParams.order_id;

    vm.isSuccess = vm.status === "success";
    vm.isError = vm.status === "error";

    vm.openApp = function () {
      if (!vm.orderId && !vm.isError) return;

      var deepLink = "niufoods://payments/amipass?status=" + vm.status;

      if (vm.orderId) {
        deepLink += "&order_id=" + vm.orderId;
      }

      $window.location.href = deepLink;
    };
  }
})();

(function() {
  'use strict';

  angular
  .module('website')
  .controller('NgStatusController', NgStatusController);

  /* @ngInject */
  function NgStatusController() {
    var vm = this;
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('OrderController', OrderController);

  /* @ngInject */
  function OrderController(api, auth, cart, customer, env, hero, ngNotify, $auth, $localStorage, $log, $state, $stateParams, $window) {
    var vm = this;
    vm.eta = null;
    vm.order = null;
    vm.restaurant = null;
    vm.hasNoName = true;
    vm.hasTracking = false;
    vm.updatePasswordForm = {};
    vm.deliveryTimeMessage = '';

    vm.setOrderName = setOrderName;
    vm.buildDeliveryTimeMessage = buildDeliveryTimeMessage;

    vm.customer = auth;
    vm.cart = cart;
    vm.storage = $localStorage;
    vm.showAllBrands = customer.showAllBrands;

    activate();

    ////////////////

    if (typeof($window.google_trackConversion) == typeof(Function)) {
      $window.google_trackConversion({
        google_conversion_id : env.GOOGLE_CONVERSION_ID,
        google_conversion_language : "en",
        google_conversion_format : "3",
        google_conversion_color : "ffffff",
        google_conversion_label : env.GOOGLE_CONVERSION_LABEL,
        google_remarketing_only : false
      });
    }

    function activate() {
      vm.order = $stateParams.order;
      if (!vm.order) return $state.go('main', {}, { location: 'replace' });
      vm.hasNoName = !vm.order.name;
      var rawPaymentType = vm.order.payment_type || $localStorage.lastPaymentType || '';
      vm.paymentType = rawPaymentType.charAt(0).toUpperCase() + rawPaymentType.slice(1);
      vm.restaurant = api.restaurants.get(vm.order.restaurant_id);
      vm.deliveryTimeMessage = vm.buildDeliveryTimeMessage();
      getTracking();
      appendMetaPixel();
      appendOrderAnalytics();
    }

    function buildDeliveryTimeMessage() {
      var rangeScheduledOrderArray = $stateParams.rangeScheduledOrder;
      if(vm.order.scheduled && rangeScheduledOrderArray) {
        return 'el ' + vm.order.promised_date_with_format + ' entre ' + rangeScheduledOrderArray[1] + ' y ' + rangeScheduledOrderArray[0];
      } else {
        return 'en unos ' + vm.order.remaining_minutes + ' minutos';
      }
    }

    function getTracking() {
      return api.prefs.all()
      .then(function() {
        var tracking = api.prefs.get('tracking');
        vm.hasTracking = tracking.value == 'true';
      });
    }

    function setOrderName() {
      api.orders.save(vm.order)
      .then(function() {
        vm.hasNoName = false;
        ngNotify.set('Tu pedido ha quedado nombrado exitosamente.', 'info');
        hero.setAnalyticsClass('perm-success-set-order-name');
      }, function(err) {
        $log.error(err);
        ngNotify.set('Hubo un problema al nombrar tu pedido. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-error-set-order-name');
      })
      .then(function() {
        // loading the latest orders should update the name of the order
        api.prefs.all(true);
      });
    }

    function appendOrderAnalytics() {
      var script  = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = 'dataLayer.push({ ecommerce: null }); \n';
      script.innerHTML += 'dataLayer.push(' + JSON.stringify(analysisStructure()) + ');';
      document.head.insertBefore(script, document.head.firstElementChild);
    }

    function analysisStructure() {
      return {
        'event': 'purchase',
        'ecommerce': {
          'purchase': {
            'actionField': {
              'currency': env.CURRENCY,
              'id': vm.order.id,
              'revenue': vm.order.total_to_pay,
              'shipping': (vm.order.total_to_pay - vm.order.total),
              'em': vm.customer.email,
              'fn': vm.customer.name,
              'ph': vm.customer.phones[0],
              'userId': vm.customer.id
            },
            'products': vm.order.products
          }
        }
      }
    }

    function appendMetaPixel() {
      var script  = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML += 'fbq("init", "' + env.FACEBOOK_PIXEL_ID + '", ' + JSON.stringify(visitorData()) + ');';
      document.head.insertBefore(script, document.head.firstElementChild);
    }

    function visitorData() {
      return {
        'em': vm.customer.email,
        'fn': vm.customer.name,
        'ph': vm.customer.phones[0]
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('ProcessPaymentController', ProcessPaymentController);

  /*@ngInject*/
  function ProcessPaymentController(_, api, cart, customer, env,ngNotify, $auth, $location, $localStorage, $state) {
    var vm = this;
    vm.data = {};
    vm.customer = customer
    vm.restaurants = null;
    vm.params = $location.search();
    vm.order = $localStorage.order;

    activate();

    ////////////////

    function activate() {
      if (vm.params.payment_method === "amipass") {
        vm.isAmipass = true;
        vm.paymentMethod = vm.params.payment_method;
        vm.amount = Number(vm.params.amount) || 0;
        vm.isError = vm.params.error === "true";
        return;
      }
      $auth.validateUser().then(function (customer) {
        vm.customer = customer;
        return api.restaurants.all().then(function (restaurants) {
          vm.restaurants = restaurants;
          paymentProcess();
        });
      });
    }

    function paymentProcess() {
      api.payment_gateway.confirm_payment({
        payment_attempt: { trx_params: vm.params, order: vm.order, gateway_name: 'transbank' }
      })
      .then(function(response) {
        vm.data = response.data;
        if (vm.data.success) {
          var restaurantId = vm.data.order.restaurant.id;
          delete $localStorage.currentCustomerCoupon;
          cart.removeAll();
          appendMetaPixel();
          appendOrderAnalytics();
          getTracking(restaurantId);
        } else {
          $state.go('process-payment.fail_new');
        }
      })
      .catch(function(error) {
        console.error("Error durante el proceso de pago:", error);
        var message = (error.data && error.data.message) ? error.data.message : "Lo sentimos, la transacción no fue exitosa. Por favor, intenta nuevamente";
        var isProductError = message.includes("Producto");
        message = message.split(/Producto/).pop().trim();
        if (isProductError) { vm.data.reason = message }

        ngNotify.set(message, 'error');
        vm.data.customer = vm.customer;
        vm.data.isProductError = isProductError;
        $state.go('process-payment.fail_new');
      }).finally(function() {
        delete $localStorage.order;
      });
    }

    function getTracking(restaurantId) {
      return api.prefs.all()
      .then(function() {
        var tracking = api.prefs.get('tracking');
        var restaurant = _.find(vm.restaurants, function(restaurant) {
          return restaurant.id == restaurantId;
        });
        if (tracking.value == 'true' && !!restaurant && restaurant.tracker_active) {
          $state.go('tracking', { 'orderId': vm.data.order.id });
        } else {
          $state.go('process-payment.success_new');
        }
      });
    }

    function appendOrderAnalytics() {
      var script  = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = 'dataLayer.push({ ecommerce: null }); \n';
      script.innerHTML += 'dataLayer.push(' + JSON.stringify(analysisStructure()) + ');';
      document.head.insertBefore(script, document.head.firstElementChild);
    }

    function analysisStructure() {
      return {
        'event': 'purchase',
        'ecommerce': {
          'purchase': {
            'actionField': {
              'currency': env.CURRENCY,
              'id': vm.data.order.id,
              'revenue': vm.data.order.total_to_pay,
              'shipping': (vm.data.order.total_to_pay - vm.data.order.total),
              'em': vm.customer.email,
              'fn': vm.customer.name,
              'ph': vm.customer.phones[0],
              'userId': vm.customer.id
            },
            'products': vm.data.order.products
          }
        }
      }
    }

    function appendMetaPixel() {
      var script  = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML += 'fbq("init", "' + env.FACEBOOK_PIXEL_ID + '", ' + JSON.stringify(visitorData()) + ');';
      document.head.insertBefore(script, document.head.firstElementChild);
    }

    function visitorData() {
      return {
        'em': vm.customer.email,
        'fn': vm.customer.name,
        'ph': vm.customer.phones[0]
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('MenuController', MenuController);

  /* @ngInject */
  function MenuController(_, analytics, api, cart, customer, event, hero, html, ngNotify, string, $document, $filter, $scope, $location, $uibModal, $log, $q, $rootScope, $state, $localStorage, $timeout, $window, env) {
    var vm = this;
    vm.isLoadingCategories = true;
    vm.close = close;
    vm.addToCart = addToCart;
    vm.cart = cart;
    vm.categories = [];
    vm.favoritesAndPurchased = new Category('Mis Favoritos');
    vm.favoritesAndPurchased.isFavorites = true;
    vm.categories.push(vm.favoritesAndPurchased);
    vm.customer = customer.get();
    vm.currentState = $state.current.name;
    vm.promisedTimeFormat = promisedTimeFormat;
    vm.expandCategory = expandCategory;
    vm.href = $state.href;
    vm.kebabCase = _.kebabCase;
    vm.latestOrders = [];
    vm.price = price;
    vm.repeatOrder = repeatOrder;
    vm.selectedCategory = null;
    vm.viewSeleable = viewSeleable;
    vm.expandPastOrders = expandPastOrders;
    vm.expandCartPastOrders = expandCartPastOrders;
    vm.expandMenuPastOrders = expandMenuPastOrders;
    vm.expandMenu = expandMenu;
    vm.originUrl = $state.current.url;
    vm.myPastOrdesExpandend = (vm.originUrl != '/repetir-pedidos') ? false : true;
    vm.isMenuBase = vm.originUrl.includes('/carta');
    vm.isMenuCategory = vm.originUrl.includes('/:categoryName');
    vm.menuExpandend = true;
    vm.myFavorites = [{seleables: []}]
    vm.getMyFavorites = getMyFavorites;
    vm.getCategories = getCategories;
    vm.toggleSwitch = toggleSwitch;
    vm.additionalProducts = [];
    vm.showFreeItems = showFreeItems;
    vm.deprecatedItems = [];
    vm.deprecatedItemsAdded = [];
    vm.counter = 0;
    vm.modal = 'menu';
    vm.menuText = env.ENVIRONMENT == 'mxniusushi' ? 'Menú' : 'Carta';
    vm.restaurantText = env.ENVIRONMENT == 'mxniusushi' ? 'Sucursales' : 'Locales';
    vm.getEventData = event.getEventData;
    vm.myEventsExpandend = (vm.originUrl != '/eventos-y-cumpleanos') ? false : true;
    vm.expandEvents = expandEvents;
    vm.expandCartEvents = expandCartEvents;
    vm.expandMenuEvents = expandMenuEvents;
    vm.viewEvent = viewEvent;
    vm.events = env.EVENTS;
    vm.bannerEvent = env.BANNER_EVENT_URL;
    vm.filteredProducts = [];
    vm.filterExpanded = (vm.originUrl != '/buscador-productos') ? false : true;
    vm.expandFilter = expandFilter;
    vm.viewMenuSearch = viewMenuSearch;
    vm.searchProducts = searchProducts;
    vm.querySeleables = [];
    vm.tagText = '';
    vm.hasTags = false;
    vm.updateTags = updateTags;
    vm.deleteTag = deleteTag;
    vm.cleanTags = cleanTags;
    vm.tagPlaceholder = env.TAG_PLACEHOLDER_SEARCH;
    vm.menuPlaceholderSearch = !!env.MENU_PLACEHOLDER_SEARCH ? env.MENU_PLACEHOLDER_SEARCH : 'Busca aquí';
    vm.includeStr = includeStr;
    vm.currentCategoryState = currentCategoryState;
    vm.menuStateIncludes = menuStateIncludes;
    vm.currentMenuState = currentMenuState;
    vm.currentCartState = currentCartState;
    vm.facebook_url = env.FACEBOOK_URL;
    vm.instagram_url = env.INSTAGRAM_URL;
    vm.tiktok_url = env.TIKTOK_URL;
    vm.search = env.SEARCH;
    vm.faq = env.FAQ;
    vm.toggleLike = toggleLike;
    vm.isEmpty = isEmpty;
    vm.openModalRequiredProduct = openModalRequiredProduct;
    vm.addHeartFull = addHeartFull;
    vm.addHeartEmpty = addHeartEmpty;
    vm.discountable = cart.discountable;
    vm.hasGenerateReceipt = env.MY_RECEIPT;
    vm.hasNoticeBar = false;
    vm.fullSizeImg = env.ENVIRONMENT == 'mxniusushi';
    vm.isEmptyState = isEmptyState;
    vm.emptyTextDescription = emptyTextDescription;
    vm.getEntityLabel = getEntityLabel;
    $localStorage.tags = $localStorage.tags ? $localStorage.tags : {};
    //$window.addEventListener('scroll', sticky);

    $scope.$watch(function() {
      return $localStorage.tags;
    }, function(resp) {
      $scope.tags = resp;
    });

    function close() {
      $rootScope.modalInstance.close();
      $rootScope.openModal = false;
    }

    checkUrlParams()

    function checkUrlParams() {
      var restaurantGroupIdParam = $location.search().restaurant_group_id;

      if(restaurantGroupIdParam) {
        getRestaurantGroupWithParam(restaurantGroupIdParam);
      } else {
        getRestaurantGroup();
      }
    }

    function getRestaurantGroup() {
      if (!customer.get() || env.ALLOW_PRICE_LISTS === 'false') return loadMenu();

      return api.getCustomerRestaurantGroup()
      .then(function(response) {
        api.setLocalRestaurantGroup(response.restaurant_group);
        loadMenu();
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
      });
    };

    function getRestaurantGroupWithParam(restaurantGroupIdParam) {
      if (env.ALLOW_PRICE_LISTS === 'false') return loadMenu();

      return api.setCustomerRestaurantGroupParam(restaurantGroupIdParam)
      .then(function(response) {
        if (!response.restaurant_group) {
          api.setRestaurantGroupParamFailed(true);
          return loadMenu();
        }

        api.setLocalRestaurantGroup(response.restaurant_group);
        $state.go('menu', {}, { reload: true });
        api.products.all(true);
        api.promotions.all(true);
        loadMenu();
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
      });
    };

    function loadMenu() {
      activate()
      .then(function() {
        openModalRequiredProduct();
      });
      searchProducts();
      getMyFavorites();
      getAdditionalProducts();
      getEvent();
    }

    function openModalRequiredProduct() {
      var queryParams = $location.search();
      var seleableType = queryParams.producto ? 'product' : 'promotion';
      var product_id = queryParams.producto || queryParams.promocion;
      if(!product_id) return;

      var categoryName = $location.path().split('/').slice(-1).join();
      categoryName = humanize(categoryName);
      
      var service = seleableType == 'product' ? api.products : api.promotions;
      var seleable = service.get(product_id)
      if (seleable) {
        var category = null;
        _.each(vm.categories, function(cat) {
          if (cat.name.toLowerCase() == categoryName.toLowerCase()) {
            category = cat;
          }
        });
        var seleableCategory = _.isEmpty(category) ? '' : _.kebabCase(category.name);
        viewSeleable(seleable, seleableCategory, true, true);
      } else {
        $log.error(seleableType + ' no encontrado: ' + product_id);
        $state.go('menu.category', {'categoryName': _.kebabCase(categoryName)});
      }
    }

    function getMyFavorites(force) {
      if (!customer.get()) return;

      return api.myFavorites.get(force)
      .then(function(response) {
        vm.myFavorites[0].seleables = response.favorites
        vm.myFavorites[0].name = "Mis Favoritos"
        vm.myFavorites[0].isFavorites = false;
        vm.myFavorites[0].isExpanded = vm.currentState == 'myFavorites' || vm.currentCartState('mis-favoritos');
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
      });
    }

    function getAdditionalProducts(force) {
      return api.additionalProducts.all(force)
        .then(function(response) {
          vm.additionalProducts = response
        })
        .catch(function(err) {
          $log.error(JSON.stringify(err));
        });
    }

    function getEvent() {
      vm.getEventData()
      .then(function(response) {
        vm.eventData = response;
      })
    }

    function getCategories(menu) {
      if (menu.currentState === 'myFavorites') {
        menu.myFavorites[0].isExpanded = true
        return menu.myFavorites
      }
      if (menu.currentState === 'searchMenu' || vm.currentCartState('searchMenu')) {
        if (_.keys($localStorage.tags).length == 0) return {};
        return menu.querySeleables;
      };
      return (menu.currentState.indexOf('menu') != -1) ? menu.categories : menu.latestOrders
    }

    function Category(name) {
      this.name = name;
      this.isExpanded = false;
      this.seleables = [];
      this.isFavorites = false;
    }

    Category.prototype.moreThan = function CategoryMoreThan() {
      if (!this.seleables) {
        return;
      }
      var length = this.seleables.length,
        moreThan = Math.floor((length%10)/5)*5 + Math.floor(length/10)*10;

      moreThan = moreThan ? moreThan : length - 1;
      return moreThan;
    };

    $scope.$on('cart:added', function(args) {
      var order_index = args && args.repeatOrder !== false && args.repeatOrder >= 0 ? args.repeatOrder : -1;
      var repeatedOrder = _.find(vm.latestOrders, function(o){
        return o.index == order_index;
      });
      if(repeatedOrder){
        // var hasWasabi = false;
        // var hasGinger = false;
        // _.each(repeatedOrder.free_items, function(item){
        //   if(item.name == "Wasabi"){ hasWasabi = true; }
        //   if(item.name == "Jengibre"){ hasGinger = true; }
        // });
        // cart.wasabi.set(hasWasabi);
        // cart.ginger.set(hasGinger);
      }
      if(cart.itemsCount() == 1 && !repeatedOrder){
        additionalProductsAddAll();
        // if (api.prefs.get('preferences').length > 0) {
        //   _.each(api.prefs.get('preferences'), function(pref) {
        //     cart.additionalProduct.set(pref);
        //   })
        //   activateAdditionalProducts();
        // } else {
        //   additionalProductsAddAll()
        // }
      } else {
        activateAdditionalProducts();
      }
    });

    function additionalProductsAddAll() {
      api.additionalProducts.all().then (function(products) {
        _.each(products, function(prod) {
          cart.add(prod.id, parseInt(prod.quantity));
        });
        activateAdditionalProducts()
      })
    }

    function activateAdditionalProducts(){
      _.each(vm.additionalProducts, function(item){
        if (!customer.get()) {
          item.option_on = true;
        } else {
          item.option_on = cart.additionalProduct.get(item);
        }
      });
    }

    function activate() {
      return $q.all({
        menuCategories: api.menuCategories.all()
      })
      .then(function(resolved) {
        cart.setDefaultDiscount();
        activateAdditionalProducts();
        var menuCategories = resolved.menuCategories;
        _.each(menuCategories, function(menuCategory) {
          if (menuCategory.active) {
            var newCat = new Category(menuCategory.name);
            // check if it is already added
            var isPresent = false;
            _.each(vm.categories, function(cat) {
              if (cat.name == menuCategory.name) {
                isPresent = true;
              }
            });
            // add to its categories
            if (!isPresent){
              newCat.seleables = menuCategory.products.concat(menuCategory.promotions);
              vm.categories.push(newCat);
            }
            _.each(menuCategory.products, function(product) {
              var potentialDup = _.find(vm.filteredProducts, function(fp) { return fp.id == product.id; });
              if (potentialDup === undefined && product.name != 'Envio') {
                vm.filteredProducts.push(searchableProduct(product));
              }
            });
          }
        });
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
        ngNotify.set('Error en la conexión. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-server-error-notify');
      })
      .then(function() {
        getNoticeBar();
      })
      .then(function() {
        searchProducts();
      })
      .then(function() {
        expandInitialCategory();
      })
      .then(function() {
        activatePrefs();
      })
      .then(function() {
        getMyFavorites();
      })
      .then(function() {
        vm.isLoadingCategories = false;
      })
    }

    function activatePrefs() {
      return $q.all({
        prefs: api.prefs.all()
      })
      .then(function(resolved) {
        vm.latestOrders.length = 0;
        Array.prototype.push.apply(vm.latestOrders,
        _.each(api.prefs.get('latest_orders'), function(o) {
          o.promised_time = new Date(Date.parse(o.promised_time));
          o.seleables = _.filter(o.seleables, function(seleable) {
            return vm.price(seleable) > 0 // && !seleable.deprecated_options;
          });
          o.isExpanded = false;
        }));
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
        ngNotify.set('Error en la conexión. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-server-error-notify');
      })
      .then(function() {
        expandInitialCategory();
      });
    }

    function expandInitialCategory(){
      if ($rootScope.openModal == true) return;
      if ($rootScope.deviceType == 'mobile' && $state.current.name == 'menu') return;
      if ($rootScope.deviceType == 'mobile' && vm.currentCartState('searchMenu')) return vm.filterExpanded = true;
      if ($rootScope.deviceType == 'mobile' && vm.currentCartState('latestOrders')) return expandMenuPastOrders();
      if ($rootScope.deviceType == 'mobile' && vm.currentCartState('events')) return expandMenuEvents();
      var r = $location.path().match(/\/([a-zA-Z0-9\-]+$)/);
      if (!r || !r[1]) {
        return;
      }
      var categoryName = r[1];
      if (!_.any(vm.categories, 'isExpanded', true)) {
        findAndSelectCategory(categoryName);
      }
    }

    function defaultOptions(product, repeatingOrder) {
      if (product.modifier_groups.length > 0 && !repeatingOrder){
              return false;
      } else if (product.modifier_groups.length > 0 && repeatingOrder) {
        var optionsTaken = {}
        _.each(product.options, function(opts, key) {
          optionsTaken[key] = JSON.parse(opts)
        });
        return optionsTaken;
      } // else {
      //   var haveNoOptions = true; // have no options to choose

      //   var optionsNames = [],
      //     optionsTaken = product.options || {};
      //   _.each(product.product_options, function(opts, key) {
      //     if (opts.length > 1) {
      //       optionsNames.push(key);
      //     } else {
      //       optionsTaken[key] = opts[0];
      //     }
      //   });
      //   var optionsTakenNames = _.keys(optionsTaken);

      //   // check if options are already taken
      //   haveNoOptions = _.intersection(optionsNames, optionsTakenNames)
      //     .length === optionsNames.length;

      //   if (haveNoOptions) {
      //     return optionsTaken;
      //   }
      // }

      return {};
    }

    function addToCart(seleable, category, repeatingOrder) {
      var options, quantity, type, modifiable;
      // is it a product?
      if (seleable.type === 'products') {
        options = defaultOptions(seleable, repeatingOrder);
        modifiable = !_.isEmpty(seleable.modifier_groups);
        if (options) {
          quantity = seleable.quantity || 1;
          type = seleable.type;
          cart.addWithEffect(seleable.id, seleable.name, quantity, options, type, seleable.total_extra_price, modifiable);
          analytics.addToCart(seleable, seleable.total_extra_price);

          return $rootScope.$broadcast('cart:added');
        }
      } else
      // is it a promotion?
      if (seleable.type === 'promotions') {
        // Actualmente si es repeat_order hace unos pasos adicionales y le hace skip a abrir el modal
        // Si una promoción esta mal (deprecated_options), reviso si debo abrir o no el modal
        // Si no tiene nada que seleccionar en el modal, se agrega con las opciones actuales de la promo
        if (seleable.repeat_order && !seleable.deprecated_options) {
          quantity = seleable.quantity || 1;
          type = seleable.type;
          var totalExtraPrice = seleable.total_extra_price;

          var options = {};
          _.each(seleable.promotion_product_groups, function(promotionProductGroup) {
            options[promotionProductGroup.id] = {};

            _.each(promotionProductGroup.products, function(prod) {
              options[promotionProductGroup.id][prod.id] = prod;
              options[promotionProductGroup.id][prod.id].extraPrice = prod.price;
            });

          });
          cart.addWithEffect(seleable.id, seleable.name, quantity, options, type, totalExtraPrice);
          analytics.addToCart(seleable, totalExtraPrice);

          return $rootScope.$broadcast('cart:added');
        } else {
          return generatePromotionOptions(seleable, category);
        }
      }

      // open modal asking to select options
      var seleableCategory = _.isEmpty(category) ? '' : _.kebabCase(category.name);
      viewSeleable(seleable, seleableCategory, true, true);
    }

    function generatePromotionOptions(seleable, category) {
      var type = seleable.type;
      var totalExtraPrice = seleable.total_extra_price;

      var options = {};
      var resp = false;
      // Add directly to cart only if all items in promotion do not require user selection
      _.each(seleable.promotion_product_groups, function(promotionProductGroup) {
        if (!(promotionProductGroup.items_limit == 0 && promotionProductGroup.free_items_quantity == 1)) {
          resp = true; return
        };
        options[promotionProductGroup.id] = {};
        options[promotionProductGroup.id].amountChecked = 1;
        options[promotionProductGroup.id].extra_price_per_item = promotionProductGroup.extra_price_per_item;
        options[promotionProductGroup.id].free_items_quantity = promotionProductGroup.free_items_quantity;
        options[promotionProductGroup.id].items_limit = promotionProductGroup.items_limit;
        options[promotionProductGroup.id].name = promotionProductGroup.name;

        _.each(promotionProductGroup.products, function(prod) {
          options[promotionProductGroup.id][prod.id] = {};
          options[promotionProductGroup.id][prod.id].extra = false;
          options[promotionProductGroup.id][prod.id].extraPrice = prod.price;
          options[promotionProductGroup.id][prod.id].name = prod.name;
          options[promotionProductGroup.id][prod.id].selected = true;
        });

      });
      if (resp) {
        var seleableCategory = _.isEmpty(category) ? '' : _.kebabCase(category.name);
        return viewSeleable(seleable, seleableCategory, true, true);
      }
      cart.addWithEffect(seleable.id, seleable.name, 1, options, type, totalExtraPrice);
      analytics.addToCart(seleable, totalExtraPrice);

      return $rootScope.$broadcast('cart:added');
    }

    function repeatOrder(order) {
      var items = getDeprecatedItems(order);
      var notDeprecatedItems = items[0]
      vm.deprecatedItems = items[1]
      vm.counter = 0;
      vm.deprecatedItemsAdded = [];

      if (vm.deprecatedItems.length > 0) {
        viewSeleableDeprecated(vm.deprecatedItems, notDeprecatedItems, '', false, order);
      } else {
        addNotDeprecatedItemToCart(notDeprecatedItems)
        $state.go('checkout', {'orderName': order.name});
      }
    }

    function getDeprecatedItems(order) {
      var deprecatedItems = order.seleables.filter(function (sel) {
        return sel.deprecated_options;
      });
      var notDeprecatedItems = order.seleables.filter(function (sel) {
        return !sel.deprecated_options;
      });

      return [notDeprecatedItems, deprecatedItems];
    }

    function addNotDeprecatedItemToCart(notDeprecatedItems) {
      _.each(notDeprecatedItems, function(seleable) {
        vm.addToCart(seleable, null, true);
      });
    }

    function getNoticeBar() {
      api.prefs.all().then(function() {
        var noticeBar = api.prefs.get('notice_bar');
        var isMobile = $rootScope.deviceType == 'mobile';
        if (isMobile) {
          vm.hasNoticeBar = noticeBar.mobile ? noticeBar.mobile.toLowerCase() === 'true' : false;
        } else {
          vm.hasNoticeBar = noticeBar.desktop ? noticeBar.desktop.toLowerCase() === 'true' : false;
        }
        if (vm.hasNoticeBar) {
          var body = $document[0].getElementById('body');
          html.addClass(body, 'notice-bar'); // Add notice-bar class from body classList
        }
      });
    }

    function getOffset(isMobile) {
      if (isMobile) return (vm.hasNoticeBar) ? 100 : 60;
      return (vm.hasNoticeBar) ? 130 : 90;
    }

    function promisedTimeFormat(promisedTime) {
      if (!promisedTime) return '';
      var options = { weekday: "long", year: "numeric", month: "numeric", day: "numeric" };
      var newPromisedTime = new Intl.DateTimeFormat('es', options).format(promisedTime);
      return newPromisedTime;
    }

    function expandCategory(category, isMobile) {
      var id = _.kebabCase(promisedTimeFormat(category.promised_time) + (category.name || ''));
      var stateName = env.ENVIRONMENT == 'mxniusushi' ? 'signin' : 'passwordless';
      if (!customer.get() && id === 'mis-favoritos') $state.go(stateName, { redirectTo: 'menu.category', redirectParams: { 'categoryName': 'mis-favoritos' } });
      if (category.isExpanded && !category.order_id && !isMobile) return;
      appendStructuredData(category);
      var human_category = id.replace(/[-\s]+/g, ' ')
                    .replace(/^[a-z]/, function(m) { return m.toUpperCase(); });
      var category_desc = human_category + ' | La mejor experiencia en ' + env.FOOD_TYPE +
                        ' pide online.';
      // if(category.promised_time){
      //   id = category.promised_time.getTime();
      // }
      if (vm.currentState.indexOf('menu') === 0) {
        if(!window.location.search){
          $state.go('menu.category', { 'categoryName': id });
        }
        $window.document.title = env.COMPANY_NAME + ' ' +
                                  human_category + ' | La mejor experiencia en ' +
                                  env.FOOD_TYPE + ' pide online. ';
        document.querySelector('meta[name="description"]').setAttribute("content", category_desc);
      }

      category.isExpanded = !category.isExpanded;
      if (category.isExpanded) {
        if (vm.filterExpanded) vm.filterExpanded = false;
        if (vm.selectedCategory) vm.selectedCategory.isExpanded = false;
        if (vm.myEventsExpandend) vm.myEventsExpandend = false;
        if (vm.myPastOrdesExpandend && !category.order_id) vm.myPastOrdesExpandend = false;
        category.limit = category.seleables.length;
        vm.selectedCategory = category;
        if (!!category.order_id && !isMobile) return;
        if (vm.hasNoticeBar) {
          var body = $document[0].getElementById('body');
          html.addClass(body, 'notice-bar'); // Add notice-bar class from body classList
        }

        $timeout(function() {
          var header = angular.element($document[0].getElementById(id));
          if (header.length == 0) return;
          var offset = getOffset(isMobile);
          $document.scrollToElement(header, offset, 400);
          if (isMobile) return;
          var menuRight = angular.element($document[0].getElementById('menu-right'));
          return menuRight[0].scrollTo(0,0);
        }, 700);
      } else {
        vm.selectedCategory = null;
      }
    }

    function expandCartEvents() {
      vm.myEventsExpandend = (vm.myEventsExpandend) ? false : true;
      expandEvents();
    }

    function expandMenuEvents() {
      vm.myEventsExpandend = true;
      expandEvents();
    }

    function expandEvents() {
      if (vm.filterExpanded) vm.filterExpanded = false;
      if (vm.myPastOrdesExpandend && !category.order_id) vm.myPastOrdesExpandend = false;
      if (vm.selectedCategory) vm.selectedCategory.isExpanded = false;
      $state.go('menu.category', { 'categoryName': 'events' });
      $timeout(function() {
        var header = angular.element($document[0].getElementById('menu-events'));
        if (header.length == 0) return;
        return $document.scrollToElement(header, 60, 400);
      }, 700);
    }

    function expandCartPastOrders() {
      vm.myPastOrdesExpandend = (vm.myPastOrdesExpandend) ? false : true;
      expandPastOrders();
    }

    function expandMenuPastOrders() {
      var stateName = env.ENVIRONMENT == 'mxniusushi' ? 'signin' : 'passwordless';
      if (!customer.get()) $state.go(stateName, { redirectTo: 'menu.category', redirectParams: { 'categoryName': 'latestOrders' } });
      vm.myPastOrdesExpandend = true;
      expandPastOrders();
    }

    function expandPastOrders() {
      if (vm.filterExpanded) vm.filterExpanded = false;
      if (vm.myEventsExpandend) vm.myEventsExpandend = false;
      if (vm.selectedCategory) vm.selectedCategory.isExpanded = false;
      $state.go('menu.category', { 'categoryName': 'latestOrders' });
      $timeout(function() {
        var header = angular.element($document[0].getElementById('latest-orders'));
        if (header.length == 0) return;
        return $document.scrollToElement(header, 60, 400);
      }, 700);
    }

    function expandMenu(){
      if(vm.menuExpandend){
        vm.menuExpandend = false;
      } else {
        vm.menuExpandend = true;
      }
    }

    function isEmptyState() {
      if (vm.currentState === 'latestOrders') {
        return vm.latestOrders.length === 0;
      } else if (vm.currentState === 'myFavorites') {
        return vm.myFavorites[0].seleables.length === 0;
      }
      return false;
    }
    
    function getEntityLabel() {
      return vm.currentState === 'latestOrders' ? 'órdenes' : 'favoritos';
    }

    function emptyTextDescription() {
      return vm.currentState === 'latestOrders' ? 'Tu historial de órdenes aparecerán aquí' : 'Presiona el ❤️ en tus productos seleccionados y se guardarán aquí';
    }

    function price(seleable, applyDiscount) {
      return cart.price(seleable.id, applyDiscount, seleable.type);
    }

    function viewSeleableDeprecated(items, notDeprecatedItems, category, makeSelection, order) {
      if (items.length === vm.deprecatedItemsAdded.length) {
        addNotDeprecatedItemToCart(notDeprecatedItems)
        $state.go('checkout', {'orderName': order.name});
        return;
      }

      var modifiable = (items[vm.counter].modifier_groups && items[vm.counter].modifier_groups.length > 0)
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'product modal-type-' + items[vm.counter].type + ' modal-modifiable-' + modifiable,
        controller: 'SeleableController as seleable',
        templateUrl: 'app/seleable/{mobile}{desktop}/seleable.html',
        resolve: {
          makeSelection: function() {
            return makeSelection;
          },
          category: function() {
            return category;
          },
          seleable: function() {
            return items[vm.counter];
          },
          myFavorites: function() {
            return vm.myFavorites;
          },
          categories: function() {
            return vm.categories
          }
        }
      });

      return modalInstance.result.then(function() {
        vm.counter = vm.counter + 1;
        vm.deprecatedItemsAdded.push(items[vm.counter])
        viewSeleableDeprecated(vm.deprecatedItems, notDeprecatedItems, '', false, order)
        return $rootScope.$broadcast('cart:added');
      });
    }

    function viewEvent(eventSelected) {
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'product',
        controller: 'EventController as event',
        templateUrl: 'app/event/{mobile}{desktop}/event.html',
        resolve: {
          eventSelected: function() {
            return eventSelected;
          }
        }
      });

      return modalInstance.result.then(function() {
        $state.go('eventCheckout', {'eventSelected': eventSelected});
      });
    }

    function viewSeleable(seleable, category, makeSelection, hasCategoryName) {
      var offset = $window.scrollY;
      var modifiable = (seleable.modifier_groups && seleable.modifier_groups.length > 0);
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'product modal-type-' + seleable.type + ' modal-modifiable-' + modifiable,
        controller: 'SeleableController as seleable',
        templateUrl: 'app/seleable/{mobile}{desktop}/seleable.html',
        resolve: {
          makeSelection: function() {
            return makeSelection;
          },
          category: function() {
            return category;
          },
          seleable: function() {
            return seleable;
          },
          myFavorites: function() {
            return vm.myFavorites;
          },
          categories: function() {
            return vm.categories
          }
        }
      });

      if (!window.location.search) {
        var keyName = seleable.type == 'promotions' ? '?promocion=' : '?producto=';
        history.pushState({page: 1}, "title 1", $location.absUrl() + keyName + seleable.id);
      }

      modalInstance.result.finally(function() {
        if (hasCategoryName) {
          $state.go('menu.category', {'categoryName': category});
        } else {
          $state.go(category, {});
        }
        $timeout(function() {
          $window.scrollBy(0, offset);
        }, 300);
      });

      appendSeleableAnalytics(seleable);

      return modalInstance.result.then(function() {
        return $rootScope.$broadcast('cart:added');
      });
    }

    function appendSeleableAnalytics(seleable) {
      var script  = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = 'dataLayer.push({ ecommerce: null }); \n';
      script.innerHTML += 'dataLayer.push(' + JSON.stringify(analyticsStructure(seleable)) + ');';
      document.head.insertBefore(script, document.head.firstElementChild);
    }

    function analyticsStructure(seleable) {
      return {
        'event': 'view_item',
        'ecommerce': {
          items: [{
            item_name: seleable.name,
            item_id: seleable.id,
            price: vm.price(seleable, true),
            quantity: 1
          }]
        }
      }
    }

    function findAndSelectCategory(categoryName) {
      var category = _.find(vm.categories, function(c) {
        return _.kebabCase(c.name) === categoryName;
      });
      if (!category) {
        var seleableCategories = vm.categories.filter(function (el) {
          return el.seleables.length > 0;
        });
        category = seleableCategories[0];
      }
      if (category) {
        var isMobile = $rootScope.deviceType == 'mobile';
        expandCategory(category, isMobile);
        return category;
      }
      return category;
    }

    function addElementsToItsCategory(newCat, categoryElements, productsDict){
      var favoritesAndPurchased = vm.favoritesAndPurchased
      _.each(productsDict, function(product) {
        if (categoryElements.filter(function(e){return e.id == [product.id]}).length == 0)
          return;
        if (product.active) {
          var element = productsDict[product.id];
          newCat.seleables.push(element);
          if (('preference' in element && element.preference > 0)  || ('counter' in element && element.counter)) {
            favoritesAndPurchased.seleables.push(element);
          }
          if (element && element.normal_price === 0) {
            return;
          }
        }
      });
    }

    function appendStructuredData(category){
      var structured_data = [];
      _.each(category["seleables"], function(seleable) {
        var product_sd = {
          "@context": "http://schema.org/",
          "@type": "Product",
          "name": seleable["name"],
          "image": seleable["image"]["medium"],
          "description": seleable["description"],
          "brand": {
            "@type": "Thing",
            "name": env.COMPANY_NAME
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "5.0",
            "reviewCount": "89"
          },
          "offers": {
            "@type": "Offer",
            "priceCurrency": "CLP",
            "price": price(seleable,true),
            "priceValidUntil": "2020-11-05",
            "itemCondition": "http://schema.org/UsedCondition",
            "availability": "http://schema.org/InStock",
            "seller": {
              "@type": "Organization",
              "name": env.COMPANY_NAME
            }
          }
        };
        structured_data.push(product_sd);
      });

      var s = document.createElement("script");
      s.type = "application/ld+json";
      s.innerHTML = "";
      s.innerHTML = JSON.stringify(structured_data);
      $(".structured_data").empty();
      $(".structured_data").append(s);
    }

    function toggleSwitch(itemId){
      var item = api.additionalProducts.get(itemId);
      cart.additionalProduct.set(item);
    }

    function showFreeItems(){
      var items = vm.additionalProducts.map(function(item){
        return item.additional_type;
      });

      var unitaryExist = items.includes('unitary');
      return cart.count && unitaryExist
    }

    function expandFilter() {
      if (vm.selectedCategory) vm.selectedCategory.isExpanded = false;
      if (vm.myPastOrdesExpandend) vm.myPastOrdesExpandend = false;
      if (vm.myEventsExpandend) vm.myEventsExpandend = false;
      if (vm.filterExpanded) return vm.filterExpanded = false;
      vm.filterExpanded = !vm.filterExpanded;
      if ($rootScope.deviceType == 'mobile') {
        $state.go('menu.category', { 'categoryName': 'searchMenu' }, { reload: true });
      } else {
        $state.go('searchMenu', {}, { reload: true });
      }
      $timeout(function() {
        angular.element($document[0].getElementById('input-tag-filter')).focus();
        var header = angular.element($document[0].getElementById('filter-category'));
        if (header.length == 0) return;
        return $document.scrollToElement(header, 60, 400);
      }, 700);
    }

    function viewMenuSearch() {
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'menu-search',
        controller: 'MenuController as menu',
        templateUrl: 'app/menu/{desktop}/menu_search.modal.html',
      });
    }

    function updateTags(e) {
      if (e.key === 'Tab' || e.key === 'Enter' || e.key === ',') {
        e.preventDefault();
        if (vm.tagText.length < 3) {
          vm.tagText = '';
        } else {
          var tagKey = vm.tagText.toUpperCase();
          tagKey = string.transliterateText(tagKey);
          tagKey = string.transliterateOption(tagKey);
          $localStorage.tags[tagKey] = vm.tagText;
          vm.tagText = '';
          vm.tagPlaceholder = '';
          vm.hasTags = true;
          if ($rootScope.deviceType == 'mobile') {
            $state.go('menu.category', { 'categoryName': 'searchMenu' }, { reload: true });
          } else {
            $state.go('searchMenu', {}, { reload: true });
          }
          $timeout(function() {
            return angular.element($document[0].getElementById('input-tag-filter')).focus();
          }, 100);
        }
      } else if (e.key === 'Backspace' && vm.tagText.length < 1) {
        deleteTag(_.last(_.keys($localStorage.tags)));
      }
    }

    function searchProducts() {
      var out = _.filter(vm.filteredProducts, function(product) {
        var matchesAll = true;
        var productName = product.searchableName;
        var productDescription = product.searchableDescription;
        var productOptions = product.searchableOptions;
        _.each($localStorage.tags, function(tagValue, tagKey) {
          var withoutRegex = new RegExp(/\bSIN\b/);
          var minusRegex = new RegExp(/\bMENOS\b/);
          var notRegex = new RegExp(/\bNO\b/);
          var wrapped = string.isWrapping(tagKey);
          if (tagKey.match(withoutRegex)) {
            tagKey = tagKey.replace(withoutRegex, '');
            tagKey = tagKey.replace(new RegExp(/\s/), '');
            var productNameIncludes  = !productName.includes(tagKey);
            var productDescrIncludes = !productDescription.includes(tagKey);
            matchesAll = matchesAll && (productNameIncludes && productDescrIncludes);
          } else if (tagKey.match(notRegex)) {
            tagKey = tagKey.replace(notRegex, '');
            tagKey = tagKey.replace(new RegExp(/\s/), '');
            var productNameIncludes  = !productName.includes(tagKey);
            var productDescrIncludes = !productDescription.includes(tagKey);
            matchesAll = matchesAll && (productNameIncludes && productDescrIncludes);
          } else if (tagKey.match(minusRegex)) {
            tagKey = tagKey.replace(minusRegex, '');
            tagKey = tagKey.replace(new RegExp(/\s/), '');
            var productNameIncludes  = !productName.includes(tagKey);
            var productDescrIncludes = !productDescription.includes(tagKey);
            matchesAll = matchesAll && (productNameIncludes && productDescrIncludes);
          } else {
            tagKey = string.clearText(tagKey);
            tagKey = string.transliterateText(tagKey);
            var productNameIncludes  = productName.includes(tagKey);
            var productDescrIncludes = productDescription.includes(tagKey);
            var productOptionsIncludes = productOptions.includes(tagKey);
            matchesAll = matchesAll && (productNameIncludes || productDescrIncludes || productOptionsIncludes);
          }
        });
        return matchesAll
      });
      vm.querySeleables = out;
    }

    function toggleLike(type, preferenceId, product) {
      var setPreference = type.toLowerCase() === 'products' ?
                            api.products.setPreference :
                            api.promotions.setPreference;

      var newPref = preferenceId === 0 ? 1 : 0;
      product.preference = newPref;

      var updateLike = setPreference(product, newPref);

      updateLike.then(function() {
        api.myFavorites.get(true).then(function(response) {
          vm.myFavorites[0].seleables = response.favorites;
        })
      });

      if (vm.currentState === 'myFavorites'){
        _.each(vm.categories, function(cat){
          _.each(cat.seleables, function(sel){
            if(product.id === sel.id) sel.preference = newPref;
          });
        });
      }
    }

    function searchableProduct(product) {
      var productName = string.clearText(product.name);
      productName = string.transliterateText(productName);
      var productDescription = product.description ? product.description.toUpperCase() : '';
      productDescription = string.transliterateText(productDescription);
      var productOptions = '';
      var productOptionsArray = product.product_options ? product.product_options : [];
      _.mapValues(productOptionsArray, function(optionValues) {
        _.each(optionValues, function(optionValue) {
          var optionText = optionValue.toUpperCase();
          optionText = string.transliterateText(optionText);
          _.each(optionText.split(' '), function(optionKey) {
            var optionRegex = new RegExp('\\b' + _.escapeRegExp(optionKey) + '\\b');
            if (productDescription.match(optionRegex)) {
              productDescription = productDescription.replace(optionRegex, '');
            }
            productOptions += optionKey;
          });
        });
      });
      product.searchableName = productName;
      product.searchableDescription = productDescription;
      product.searchableOptions = productOptions;
      return product;
    }

    function deleteTag(key) {
      $localStorage.tags = _.omit($localStorage.tags, key);
      if (_.keys($localStorage.tags).length == 0) {
        cleanTags();
      }
      if ($rootScope.deviceType == 'mobile') {
        $state.go('menu.category', { 'categoryName': 'searchMenu' }, { reload: true });
      } else {
        $state.go('searchMenu', {}, { reload: true });
      }
      $timeout(function() {
        return angular.element($document[0].getElementById('input-tag-filter')).focus();
      }, 100);
    }

    function cleanTags() {
      $localStorage.tags = {};
      vm.querySeleables = [];
      vm.tagPlaceholder = env.TAG_PLACEHOLDER_SEARCH;
      vm.hasTags = false;
      $timeout(function() {
        return angular.element($document[0].getElementById('input-tag-filter')).focus();
      }, 100);
    }

    function includeStr(str, args) {
      var regex = new RegExp(args.join('|'), 'gi');
      var resp = regex.test(str);
      return resp;
    }

    function currentCategoryState(category) {
      var resp = (category == vm.selectedCategory &&
                  vm.currentState != 'events' &&
                  vm.currentState != 'latestOrders' &&
                  vm.currentState != 'searchMenu');
      return resp;
    }

    function menuStateIncludes() {
      return ['menu', 'menu.category'].includes($state.current.name);
    }

    function currentMenuState(state) {
      var resp = $state.includes(state)
      return resp;
    }

    function currentCartState(category) {
      var resp = $state.includes('menu.category', { categoryName: category })
      return resp;
    }

    function sticky() {
      var isMobile = $rootScope.deviceType == 'mobile';
      if (!menuStateIncludes() || !isMobile) return;
      var navbarBrand = html.querySelector('#navbar-brand'),
      navbarCategory  = html.querySelector('#navbar-category'),
      //navbar          = html.querySelector('#navbar'),
      //noticeBar       = html.querySelector('#notice-bar'),
      //panelAcordeon   = html.querySelector('#panel-acordeon'),
      //toolbar         = html.querySelector('#toolbar'),
      //footer          = html.querySelector('#footer'),
      mainNavLinks    = html.querySelectorAll('nav.navbar div.navbar-category a');
      //pageHeight      = $window.innerHeight + $window.pageYOffset,
      //footerTop       = footer[0].offsetTop + 90;
      if ($window.pageYOffset >= 48) {
        //html.modifyStyle(navbar, 'top', '0px');
        html.modifyStyle(navbarBrand, 'display', 'none');
        html.modifyStyle(navbarCategory, 'display', 'flex');
        //html.modifyStyle(noticeBar, 'display', 'none');
      } else {
        //html.modifyStyle(navbar, 'top', '30px');
        html.modifyStyle(navbarBrand, 'display', 'flex');
        html.modifyStyle(navbarCategory, 'display', 'none');
        //html.modifyStyle(noticeBar, 'display', 'flex');
      }
      _.each(mainNavLinks, function(link) {
        var section    = html.querySelector(link.hash);
        if (section.length == 0) return;
        var sectionTop = section[0].offsetTop,
        sectionHeight  = section[0].offsetTop + section[0].offsetHeight;
        if (sectionTop <= $window.pageYOffset && sectionHeight > $window.pageYOffset) {
          html.addClass(link, 'active');
        } else {
          html.removeClass(link, 'active');
        }
      });
      // if (pageHeight >= footerTop) {
      //   toolbar.addClass('sticky');
      //   html.modifyStyle(panelAcordeon, 'padding-bottom', '0px');
      // } else {
      //   toolbar.removeClass('sticky');
      //   html.modifyStyle(panelAcordeon, 'padding-bottom', '80px');
      // }
    };

    function addHeartFull(event) {
      event.target.src = 'assets/images/favorite-heart.svg';
    }

    function addHeartEmpty(event) {
      event.target.src = 'assets/images/favorite-heart-empty.svg';
    }

    function isEmpty(obj) {
      return _.isEmpty(obj);
    }

    function humanize(text) {
      return text
      .replace(/^[\s_]+|[\s_]+$/g, '')
      .replace(/[_\s]+/g, ' ')
      .replace(/\-/g, ' ')
      .replace(/^[a-z]/, function(m) { return m.toUpperCase(); });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('kushkiController', kushkiController);

  /* @ngInject */
  function kushkiController(kushki) {
    var vm = this;
    vm.kushki = kushki;
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($state, api, customer, $log, $rootScope, env, $uibModal, $scope) {
    var vm = this;
    vm.openModalLocation = openModalLocation;
    vm.customer = customer.get();
    vm.rootScope = $rootScope;
    vm.customerChanged = customerChanged;
    vm.firstButton = { state: "menu.category({categoryName: 'niu-collection'})" };
    vm.href = $state.href;
    vm.isOpen = false;
    vm.isOpenChanged = isOpenChanged;
    vm.secondButton = {};
    vm.timesAverage = {};
    vm.state = $state;
    vm.envConstants = env;
    vm.boxDescription = {};
    vm.restaurantGroup = '';

    activate();
    getTimesAverage();
    getCurrentRestaurantGroup();
    getRestaurantGroups();

    function getRestaurantGroups() {
      return api.restaurantGroups.all()
    }

    function getCurrentRestaurantGroup() {
      return vm.restaurantGroup = api.getCurrentLocation();
    }

    function openModalLocation() {
      return $uibModal.open({
        animation: true,
        // size: 'product modal-type-' + 'products' + ' modal-modifiable-' + 'false',
        controller: 'LocationController as location',
        templateUrl: 'app/location/{mobile}{desktop}/location.html',
        resolve: {
          selectedLocation: function() {
            return '';
          }
        }
      });
    }

    function activate() {
      vm.ready = api.prefs.all().then(function() {
        vm.greeting = api.prefs.get('greeting');
        var noticeBar = api.prefs.get('notice_bar');
        if (noticeBar) {
          $scope.noticeBarDesktop = noticeBar.desktop ? noticeBar.desktop.toLowerCase() === 'true' : false;
        }
      });

      customerChanged();
      isOpenChanged(true);
    }

    function getTimesAverage(){
      return api.restaurants.timesAverage()
      .then(function(times) {
        vm.timesAverage = times;
      });
    }

    function isOpenChanged(newIsOpen) {
      vm.isOpen = newIsOpen;
      var button = vm.firstButton;

      if (newIsOpen) {
        button.title = 'Nuevo pedido';
        button.body = 'Ve a la carta y haz tu pedido';
      } else {
        button.title = 'Realiza un Pedido Anticipado';
        button.body = 'Elige la hora y olvídate de cocinar';
      }
    }

    function customerChanged() {
      var button = vm.secondButton;

      if (vm.customer) {
        button.title = 'Repetir un Pedido';
        button.body = 'Repite un pedido completo o parte de ellos';
        button.state = 'latestOrders';
      } else {
        button.title = 'Estoy registrado';
        button.body = 'Customiza la carta, repite pedidos y más';
        button.state = 'passwordless';
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('LocationController', LocationController);

  /* @ngInject */
  function LocationController(api, cart, _, $uibModal, selectedLocation, $log) {
    var vm = this;
    vm.location = {} ;
    vm.setRestaurantGroup = setRestaurantGroup;
    vm.confirmWarningModal = confirmWarningModal;
    vm.restaurantGroups = [];
    vm.locationPrefs = {};

    getRestaurantGroups();

    function getRestaurantGroups(force) {
      return api.restaurantGroups.all(force)
      .then(function(response) {
        vm.restaurantGroups = response.restaurant_groups;
        setCurrentLocation();
        setLocationPrefs();
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
      });
    }

    function setCurrentLocation () {
      var currentLocation = api.getCurrentLocation();
      if(!currentLocation) return;

      vm.location = _.find(vm.restaurantGroups, function(rest_group){
        return currentLocation.id == rest_group.id;
      });
    }

    function setLocationPrefs() {
      vm.locationPrefs = _.find(vm.restaurantGroups, function(rest_group){
        return selectedLocation.id == rest_group.id;
      });
    }
  
    function setRestaurantGroup() {
      var items = cart.products();

      if (!items.length) {
        return api.setRestaurantGroup(vm.location);
      }

      return api.checkCartItems(vm.location, items)
      .then(function(response) {
        if(response.cart_items.length > 0) {
          modalWarningCartItems(vm.location)
        } else {
          api.setRestaurantGroup(vm.location);
        }
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
      });
    }

    function modalWarningCartItems(rest_group) {
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'location-warning',
        controller: 'LocationController as location',
        templateUrl: 'app/location/{mobile}{desktop}/cart-warning-modal.html',
        resolve: {
          selectedLocation: function() {
            return rest_group;
          }
        }
      });

      modalInstance.result.then(function (confirmed) {
        if(confirmed) api.setRestaurantGroup(rest_group);
      })
    }

    function confirmWarningModal() {
      api.setRestaurantGroup(selectedLocation);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController(_, api, env, $rootScope, $scope) {
    var vm             = this;
    vm.restaurantGroup = '';
    vm.restaurantImage = '';
    vm.isLoadingItems  = true;
    vm.products        = [];
    vm.banners         = [];
    vm.menuCategories  = [];
    vm.kebabCase       = _.kebabCase;
    vm.rootScope       = $rootScope;
    vm.goToUrl         = goToUrl;

    activate();
    getBannersHome();
    getProductsHome();
    getMenuCategoriesHome();

    ////////////////

    $scope.$on('product-carousel:load', function () {
      vm.isLoadingItems = false;
    });

    function activate() {
      vm.restaurantImage = 'assets/images/' + env.ENVIRONMENT + '/sucursales.png';
      api.prefs.all().then(function() {
        var noticeBar = api.prefs.get('notice_bar');
        if (noticeBar) {
          $scope.noticeBarDesktop = noticeBar.desktop ? noticeBar.desktop.toLowerCase() === 'true' : false;
        }
      });
    }

    function getBannersHome() {
      var isMobile = vm.rootScope.deviceType == 'mobile';
      return api.settings.banner('new_home', isMobile)
      .then(function(banners) {
        banners.forEach(function(banner, index) {
          var redirect_url = banner.redirect_url.includes('http') ? banner.redirect_url : 'https://' + banner.redirect_url;
          vm.banners.push({
            image: isMobile ? banner.mobile_image : banner.desktop_image,
            redirect: redirect_url,
            index: index,
            alt: banner.name
          })
        });

        return vm.banners;
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
      });
    }

    function getProductsHome() {
      return api.products.homeWeb()
      .then(function(response) {
        vm.products = response;
      });
    }

    function getMenuCategoriesHome() {
      return api.menuCategories.homeWeb()
      .then(function(response) {
        vm.menuCategories = response;
      });
    }

    function goToUrl(url) {
      document.location.href = url;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('FranchisesController', FranchisesController);

  /* @ngInject */
  function FranchisesController(_, api, env, hero, ngNotify, $location, $log, $state, $stateParams) {
    var vm = this;
    vm.restaurants = {};
    vm.isExpanded = false;
    vm.isDisabled = false;
    vm.companyName = env.COMPANY_NAME;
    vm.companyFood = env.COMPANY_FOOD;
    vm.environment = env.ENVIRONMENT;
    vm.form = $stateParams.form || {};
    vm.submitForm = submitForm;
    vm.locationPath = $location.path();

    activate();

    ////////////////

    function activate() {
      vm.form.subject = "Solicitud de Franquicia";
      vm.form.form_type = "franchises";
    }

    function submitForm() {
      vm.isDisabled = true;
      vm.form.phone = vm.phones[0];
      var form = vm.form;
      api.franchises_forms.save(form)
      .then(function() {
        ngNotify.set('Muchas Gracias, te contactaremos a la brevedad.', 'info');
        hero.setAnalyticsClass('perm-success-sending-franchises');
        $state.go('main');
      })
      .catch(function(resp) {
        $log.error(JSON.stringify(resp));
        ngNotify.set('Hubo un problema con tu solicitud de franquicia. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-error-sending-franchises');
        vm.isDisabled = false;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('FaqController', FaqController);

  /* @ngInject */
  function FaqController(env, $http) {
    var vm = this;
    vm.questions = [];

    activate();

    function activate() {
      vm.questions = [];
      $http.get('app/faq/faq.json').then(function(response) {
        var faqJson = response.data;
        var enviroment = env.ENVIRONMENT.replace('-', '')
        $.each(faqJson[enviroment], function(_index, full_question) {
          if (full_question['CustomAnswer'] == true) {
            $.each(full_question['questions'], function(index, question) {
              if (question['CustomAnswer'] == true) {
                full_question['questions'][index]['q'] = findAndReplace(question['q'])
                full_question['questions'][index]['a'] = findAndReplace(question['a'])
              }
            })
          }
          vm.questions.push(full_question)
        })
      })
    }

    function findAndReplace(phrase) {
      var words = phrase.match(/{(.*?)}/g)
      if (!words) return phrase
      $.each(words, function(_index, word) {
        var value = word.replace('{', '').replace('}', '');
        phrase = phrase.replace('{'+value+'}', env[value]);
      })
      return phrase
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('FeedbackController', FeedbackController);

  /* @ngInject */
  function FeedbackController(_, api, env, hero, ngNotify, $log, $state, $stateParams, $timeout, $auth) {
    var vm = this;

    vm.v1 = 'V1'; // Search by ID of an order
    vm.v2 = 'V2'; // Search by check local uuid(POS) or an order id(API) from restaurant assigned
    vm.v3 = 'V3'; // Search only by check local uuid from restaurant assigned'

    vm.isLoadingView = true;
    vm.isSending = false;
    vm.getFeedbackVersion = getFeedbackVersion();
    vm.detailsParams = buildDetailsParams();
    vm.feedbackForm = {};
    vm.includeTextWatermark = includeTextWatermark;
    vm.evaluationValues = _.range(1, 10 + 1);
    vm.envConstants = env;
    vm.sendFeedback = sendFeedback;
    vm.scrollTo = scrollTo;
    vm.existingFeedback = false;
    vm.existing_error = false;
    vm.specialQuestions = vm.envConstants.COUNTRY == 'MX'
    vm.feedbackChannel = $stateParams.f_c;
    // TODO: create country of origin's centralized verification service

    activate();

    ////////////////

    function activate() {
      feedback_existence();
    }

    // TODO: when enought time has passed, stick to the feedback last version
    function getFeedbackVersion() {
      var saleChannel = $stateParams.s_c;
      var restaurantIdentifier = $stateParams.r_id;
      var id = $stateParams.orderId;

      if(saleChannel == null && restaurantIdentifier == null) { vm.feedbackVersion = vm.v1; return; }
      if(includeTextWatermark(id)) { vm.feedbackVersion = vm.v3; return; }
      vm.feedbackVersion = vm.v2;
    }

    function buildDetailsParams() {
      var saleChannel = $stateParams.s_c;
      var restaurantIdentifier = $stateParams.r_id;
      var id = $stateParams.orderId;

      var version = vm.feedbackVersion;
      if(version === vm.v1) return { order_id: id };

      var baseParams = { sale_channel: saleChannel, restaurant_identifier: restaurantIdentifier };

      if(version === vm.v3) {
        return $.extend({}, { check_local_uuid: id }, baseParams);
      }

      if(version === vm.v2) {
        var orderId = {};
        if ($stateParams.s_c == 'local') orderId = { check_local_uuid: id };
        if ($stateParams.s_c == 'web') orderId = { order_id: id };
        return $.extend({}, orderId, baseParams);
      }
    }

    function includeTextWatermark(id) {
      return id.split('-').length === 6; // The length of a uuid is 5 + 1(text watermark)
    }

    function feedback_existence() {
      var version = vm.feedbackVersion;

      // Check in Central server
      if(version === vm.v3) {
        return api.feedbacks.byFiltersInCentralServer({ filters: vm.detailsParams })
        .then(
          function(response) { if(response.feedbacks.length > 0) { return existingFeedback() }; },
          function(error) { return errorFeedbackExistence(error) }
        )
        .finally(function(){
          console.info('Promise returned in check of API');
          vm.isLoadingView = vm.existingFeedback && vm.existing_error;
        })
      }

      // Check in the API and Central server
      if(version === vm.v1  || version === vm.v2) {
        return api.feedbacks.byFiltersInApi({ filters: vm.detailsParams })
        .then(
          function(response) {
            if(response.feedbacks.length > 0) {
              vm.existingFeedback = true;
              return existingFeedback();
            };
          },
          function(error) { return errorFeedbackExistence(error) }
        )
        .finally(function(){
          console.info('Promise returned in check of API');
          if(vm.existingFeedback) { return; };
          if(vm.existing_error) { return; };

          return api.feedbacks.byFiltersInCentralServer({ filters: vm.detailsParams })
          .then(
            function(response) { if(response.feedbacks.length > 0) { return existingFeedback() }; },
            function(error) { return errorFeedbackExistence(error) }
          )
          .finally(function(){
            console.info('Promise returned in check of Central Server');
            vm.isLoadingView = vm.existingFeedback && vm.existing_error;
          })
        })
      }
    }

    function existingFeedback() {
      var msg = 'El feedback de este pedido ya lo habías registrado. Te invitamos a seguir disfrutando de nuestros productos.';
      ngNotify.set(msg, 'error-feedback-invalid');
      $state.go('main', {}, { location: 'replace' });
    }

    function errorFeedbackExistence(error) {
      $log.error(JSON.stringify(error));
      var msg = 'El pedido al que haces referencia no es válido. Verifica que el link sea correcto.';
      ngNotify.set(msg, 'error-feedback-invalid');
      $state.go('main', {}, { location: 'replace' });
    }

    function sendFeedback() {
      vm.isSending = true;
      var form = vm.feedbackForm;
      if (vm.feedbackChannel) { form['incoming_channel'] = vm.feedbackChannel; }
      var storedUser = localStorage.getItem('auth_headers');
      if (storedUser) {
        var uid = JSON.parse(storedUser).uid;
        form = $.extend({}, form, { 'sender_email': uid })
      }
      api.feedbacks.save(form, vm.detailsParams)
      .then(function(response) {
        if (form.recommendToFriend > 8 && response.google_place_id) {
          var orderData = { clientName: response.client_name, googlePlaceId: response.google_place_id };
          $state.go('external-feedback', { order: orderData });
        } else {
          ngNotify.set('Gracias por tu feedback.', 'info');
          hero.setAnalyticsClass('perm-success-sending-feedback');
          $state.go('main');
        }
        vm.isSending = false;
      })
      .catch(function(response) {
        $log.error(JSON.stringify(response));
        ngNotify.set('Hubo un problema al enviar feedback. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-error-sending-feedback');
        vm.isSending = false;
      });
    }

    function scrollTo(id) {
      return $timeout(function() {
        var question = angular.element('#' + id);
        var parent = question.parent();
        return parent.scrollToElementAnimated(question, 0, vm.envConstants.DELIVERY);
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('ExternalFeedbackController', ExternalFeedbackController)

  /* @ngInject */
  function ExternalFeedbackController(api, $state, $timeout, $log, $sce, $stateParams, _, $rootScope, $templateCache, $localStorage, env) {
    var vm = this;
    vm.activate = activate;
    vm.backState = $stateParams.backState;
    vm.comment = '';
    vm.close = close;
    vm.googleAddress = null;
    vm.envConstants = env;

    activate();

    function activate() {
      vm.order = $stateParams.order;
      if (!vm.order) {
        return $state.go('main', {}, { location: 'replace' });
      }
      vm.googleAddress = "https://search.google.com/local/writereview?placeid=" + vm.order.googlePlaceId;
    }

    function close(){
      $state.go('main', {
        reload: true,
        inherit: false
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('EventSuccessController', EventSuccessController);

  /* @ngInject */
  function EventSuccessController(customer, $stateParams) {
    var vm = this;
    vm.customer = {};

    activate();

    function activate() {
      vm.customer.name = $stateParams.name;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('EventController', EventController);

  /* @ngInject */
  function EventController(cart, event, eventSelected, $uibModalInstance) {
    var vm = this;
    vm.eventSelected = eventSelected;
    vm.getEventData = event.getEventData;
    vm.eventData = {};
    vm.cancel = cancel;
    vm.addEventRequest = addEventRequest;
    vm.descriptionProducts = descriptionProducts;
    vm.additionalItems = [];
    vm.showAdditionalItem = showAdditionalItem;

    activate();

    function activate() {
      getEvent();
      additionalItems();
    }

    function getEvent() {
      vm.getEventData(vm.eventSelected)
      .then(function(response) {
        vm.eventData = response;
      })
    }

    function additionalItems() {
      vm.additionalItems = cart.additionalItems();
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function addEventRequest() {
      $uibModalInstance.close();
    }

    function descriptionProducts(leftRight) {
      if (!vm.eventData.description) return;
      var descrProd = [];
      var descrSize = vm.eventData.description.length;
      var descrHalf = Math.ceil(descrSize / 2);
      if (leftRight == 'left') {
        for(var i = 0; i < descrHalf; i++) {
          descrProd.push(vm.eventData.description[i]);
        }
      }
      if (leftRight == 'right') {
        for(var i = descrHalf; i < descrSize; i++) {
          descrProd.push(vm.eventData.description[i]);
        }
      }
      return descrProd;
    }

    function showAdditionalItem(item) {
      if(vm.additionalItems.length == 1) {
        return item.name;
      }

      var penultimateItem = getPositionItem(item, -2);
      var lastItem = getPositionItem(item, -1);

      if (lastItem) {
        return 'y ' + item.name;
      } else if (penultimateItem){
        return item.name;
      } else {
        return item.name + ', ';
      }
    }

    function getPositionItem(item, position) {
      return item.id === vm.additionalItems[vm.additionalItems.length - Math.abs(position)].id;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('EventCheckoutController', EventCheckoutController);

  /* @ngInject */
  function EventCheckoutController(_, api, customer, dateTime, event, inputForm, $scope, $state, $stateParams, $window) {
    var vm = this;
    vm.sendOrder = sendOrder;
    vm.getEventData = event.getEventData;
    vm.eventSelected = $stateParams.eventSelected;
    vm.eventData = {};
    vm.customer = {};
    vm.phones = [];
    vm.customerComments = '';
    vm.info = null;
    vm.communes = null;
    vm.date = null;
    vm.minDate = null;
    vm.maxDate = null;
    vm.hiddenInput = null;
    vm.inProgress = false;
    vm.invalidPhone = true;
    vm.sendEmailTxt = 'Enviar';

    activate();

    function activate() {
      getCommunes();
      getEvent();
      getPhones();
      getTomorrowDate();
      validateForm();
    }

    function getCommunes() {
      return api.comunes.all()
      .then(function(communes) {
        vm.communes = communes;
      });
    }

    function getEvent() {
      vm.getEventData(vm.eventSelected)
      .then(function(response) {
        vm.eventData = response;
      })
    }

    function getPhones() {
      vm.customer = customer.get() || {};
      if (_.isEmpty(vm.customer)) return vm.phones = [];
      vm.phones = vm.customer.phones;
      getAddressesData();
    }

    function getAddressesData() {
      return api.addresses.all()
      .then(function(addresses) {
        vm.customer.address = addressFormat(addresses[0]);
        var comuneId = addresses[0].comune_id;
        vm.customer.commune = _.find(vm.communes, function(commune) { return commune.id == comuneId; });
      });
    }

    function addressFormat(addresses) {
      var streetName = addresses.street_name;
      var streetNumber = addresses.street_number;
      var specificNumber = addresses.specific_number;
      return specificNumber ? streetName + ' #' + streetNumber + ', ' + specificNumber : streetName + ' #' + streetNumber;
    }

    function getTomorrowDate() {
      var tomorrow = dateTime.setFullDate(1, 12, 0, 0, 0);
      var oneMonth = dateTime.setFullDate(31, 12, 0, 0, 0);
      vm.date = { day: tomorrow, time: tomorrow };
      vm.minDate = { day: tomorrow, time: tomorrow };
      vm.maxDate = { day: oneMonth, time: oneMonth };
    }

    function validateForm() {
      setTimeout(function() {
        inputForm.validateInput($scope.form, 'name', 'submit-event-form');
        inputForm.validateInput($scope.form, 'email', 'submit-event-form');
        inputForm.validateInput($scope.form, 'address', 'submit-event-form');
        inputForm.validateInput($scope.form, 'commune', 'submit-event-form');
      }, '100');
    }

    function sendOrder() {
      vm.inProgress = true;
      vm.sendEmailTxt = 'Enviando...';
      vm.customer.commune = vm.customer.commune.name;
      var order = { 
        customer: vm.customer,
        phone: vm.phones[0],
        message: vm.customerComments,
        product: vm.eventData.name,
        date: vm.date,
        hidden_input: vm.hiddenInput
      };
      api.orders.saveEvent(order)
      .then(function(info) {
        vm.inProgress = false;
        vm.sendEmailTxt = 'Enviar Email';
        $state.go('eventSuccess', { name: vm.customer.name } );
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('CustomerSessionController', CustomerSessionController);

  /* @ngInject */
  function CustomerSessionController(_, api, cart, customer, env, hero, html, ngNotify, $auth, $document, $localStorage, $location, $log, $rootScope, $state, $stateParams, $timeout, $uibModal, $window) {
    var vm                  = this;
    vm.error                = '';
    vm.errorModal           = '';
    vm.resendCodeCount      = 0;
    vm.codeTimer            = 60;
    vm.codeCountdownInterval = null;
    vm.isEmailSent          = false;
    vm.isPasswordSaved      = false;
    vm.isSendingForm        = false;
    vm.submitButtonDisabled = false;
    vm.resendCodeDisabled   = false;
    vm.loginForm            = {};
    vm.updatePasswordForm   = {};
    vm.resetForm            = { email: $stateParams.email };
    vm.registrationForm     = { phone: { prefix: '+56 9 ', number: '' } };
    vm.phoneRegex           = /^[1-9](\s*\d){7}$/;
    vm.login                = login;
    vm.register             = register;
    vm.resendCode           = resendCode;
    vm.startCodeCountdown   = startCodeCountdown;
    vm.facebookAuth         = facebookAuth;
    vm.resetPassword        = resetPassword;
    vm.togglePassword       = togglePassword;
    vm.updatePassword       = updatePassword;
    vm.showAllBrands        = customer.showAllBrands;
    vm.envConstants         = env;
    vm.niusushiUrl          = env.ENVIRONMENT == 'mxniusushi' ? 'https://niusushi.mx/' : 'https://niusushi.cl/';
    vm.DEFAULT_DISCOUNT     = (parseFloat(env.DEFAULT_DISCOUNT)*100);

    $localStorage.resendCode = 0;

    vm.isLoggedIn = function() {
      return $auth.userIsAuthenticated();
    };

    vm.fixCss = function(event, isFocused) {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(userAgent)) {
        if (isFocused){
          $('.login-regist-form').height(screen.height-80);
          $('.bienvenidos').height(screen.height-80);
          $('.login-regist-form').css({position: 'absolute'});
        } else {
          $('.login-regist-form').height($(window).height());
          $('.bienvenidos').height($(window).height());
          $('.login-regist-form').css({position: ''});
        }
      }
      if (navigator.userAgent.match('CriOS')) {
        if (isFocused) {
          $(event.target).parents().addClass('keyboard-fix');
        } else {
          $(event.target).parents().removeClass('keyboard-fix');
        }
      }
    };

    $window.addEventListener('keydown', function (event) {
      var modals = $document[0].querySelectorAll('div.modal-login, div.modal-signin');
      if (modals.length > 0 && event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    }, true);

    activate();

    ////////////////

    function activate() {
      $rootScope.$on('auth:login-success', loginSuccess);
      $rootScope.$on('auth:oauth-registration', oauthRegistration);
      $rootScope.$on('auth:password-reset-request-success', loginSuccess);

      $rootScope.$on('auth:password-reset-request-error', onErrorModal);
      $rootScope.$on('auth:registration-email-error', onErrorModal);
      $rootScope.$on('auth:login-error', onErrorModal);
    }

    function togglePassword(passEl) {
      passEl = passEl ? passEl : angular.element('input[name=password]');
      if (passEl.attr('type') === 'password') {
        passEl.attr('type','text');
        $timeout(function() {
          passEl.attr('type','password');
        }, 3000);
      } else {
        passEl.attr('type','password');
      }
    }

    function resetPassword(loginData) {
      vm.isSendingForm = true;

      $auth.requestPasswordReset(loginData)
      .then(function() {
        vm.isEmailSent = true;
      })
      .then(function() {
        vm.isSendingForm = false;
      });
    }

    function updatePassword(passwordData) {
      vm.isSendingForm = true;

      if (vm.isLoggedIn) {
        passwordData.password_confirmation = passwordData.password;
      }

      var queryParams = $location.search();
      var resetPasswordToken = queryParams.reset_password_token;
      if (resetPasswordToken) {
        passwordData.reset_password_token = resetPasswordToken;
      }

      $auth.updatePassword(passwordData)
      .then(function () {
        vm.isPasswordSaved = true;
      })
      .then(function () {
        vm.isSendingForm = false;
      })
      .catch(function (resp) {
        vm.error = resp.data.errors.full_messages.join('. ') || resp.statusText;
      });
    }

    function register() {
      disabledSubmitButton();
      vm.registrationForm.phones = vm.phones[0];

      if (!vm.registrationForm.password) {
        var password = vm.registrationForm.phones;
        vm.registrationForm.password = password;
      }
      vm.registrationForm.password_confirmation = vm.registrationForm.password;
      if (!vm.registrationForm.confirm_token) {
        $auth.submitRegistration(vm.registrationForm)
        .then(function() {
          // SKIPPED DUE TO EMAIL CONFIRMATION RAISES CATCH
        }).catch(function() {
          if ($rootScope.deviceType === 'mobile') {
            $localStorage.isNewCustomer = vm.registrationForm.email;
          }
          if (!!vm.requiresVerificationCode) {
            vm.registrationForm.confirm_token = true;
          }
          vm.registrationForm.password = null;
          activeSubmitButton();
        });
      } else {
        login({
          email: vm.registrationForm.email,
          password: vm.registrationForm.password,
          confirm_token: vm.registrationForm.confirm_token,
        }, true);
      }
    }

    function login(loginData, isNewCustomer) {
      disabledSubmitButton();
      $auth.submitLogin(loginData)
      .then(function(userData) {
        if (userData.orders_count > 0) {
          var redirectTo = $rootScope.deviceType === 'mobile' ? 'menu.category' : 'latestOrders',
          redirectParams = $rootScope.deviceType === 'mobile' ? { 'categoryName': 'latestOrders' } : {};
        } else {
          var redirectTo = 'menu',
          redirectParams = {};
        }
        if (['cart.products', 'cart.whenhowwhere', 'checkout'].includes($state.current.name) || cart.count > 0) {
          redirectTo = 'checkout';
          redirectParams = {};
        }

        return api.addresses.all().then(function(addresses) {
          if (!addresses || !addresses.length) {
            $localStorage.pendingPostLoginRedirect = {
              state: redirectTo,
              params: redirectParams,
              reload: !!isNewCustomer
            };
            return;
          }
          if (isNewCustomer) return loadMenuAndRedirect(true, redirectTo, redirectParams);
          if (env.ALLOW_PRICE_LISTS === 'true') {
            checkRestaurantGroupCartItems(userData, redirectTo, redirectParams);
            $state.go(redirectTo, redirectParams);
          } else {
            loadMenuAndRedirect(false, redirectTo, redirectParams);
          }
        });
      }).catch(function(reason) {
        if (reason.requires_verification_code || vm.requiresVerificationCode) {
          activateCodeFlow(vm.loginForm);
        }
        activeSubmitButton();
      });
    }

    function activateCodeFlow(form) {
      if (!form.confirm_token) {
        form.confirm_token = true;
      }
      $timeout(function() {
        disabledResendCode();
        startCodeCountdown();
      });
    }

    function disabledSubmitButton() {
      var submitButtonClick = $document[0].getElementById('submit-button-click');
      vm.submitButtonDisabled = true;
      submitButtonClick.setAttribute('disabled', 'disabled');
    }

    function activeSubmitButton() {
      var submitButtonClick = $document[0].getElementById('submit-button-click');
      vm.submitButtonDisabled = false;
      submitButtonClick.removeAttribute('disabled');
    }

    function resendCode(email) {
      if (vm.resendCodeDisabled == true) return;
      $localStorage.resendCode += 1;
      vm.resendCodeCount = $localStorage.resendCode;
      var payload = { confirm_password: vm.loginForm.confirm_password, email: email }
      disabledResendCode();
      showResendCodeClick();
      startCodeCountdown();
      login(payload);
    }

    function startCodeCountdown() {
      if (vm.codeCountdownInterval) {
        clearInterval(vm.codeCountdownInterval);
      }
      vm.codeTimer = 60;
      vm.codeCountdownInterval = setInterval(function() {
        $timeout(function() {
          vm.codeTimer--;
          if (vm.codeTimer <= 0) {
            clearInterval(vm.codeCountdownInterval);
            vm.codeCountdownInterval = null;
            vm.codeTimer = 0;
          }
        });
      }, 1000);
    }

    function disabledResendCode() {
      setDisabledResendCode();
      setTimeout(function() {
        activeResendCode();
      }, 60000);
    }

    function setDisabledResendCode() {
      var resendCodeClick = $document[0].getElementById('resend-code-click');
      vm.resendCodeDisabled = true;
      if (resendCodeClick) resendCodeClick.setAttribute('disabled', 'disabled');
    }

    function activeResendCode() {
      var resendCodeClick = $document[0].getElementById('resend-code-click');
      vm.resendCodeDisabled = false;
      if (resendCodeClick) resendCodeClick.removeAttribute('disabled');
    }

    function showResendCodeClick() {
      var resendCodeClick = $document[0].getElementById('resend-code-click');
      html.removeClass(resendCodeClick, 'hidden');
    }

    function loadMenuAndRedirect(reload, redirectTo, redirectParams) {
      api.products.all(true);
      api.promotions.all(true);
      api.prefs.all(true);

      if (reload) {
        $state.go(redirectTo, redirectParams, { reload: true });
      } else {
        $state.go(redirectTo, redirectParams);
      }
    }

    function checkRestaurantGroupCartItems(userData, redirectTo, redirectParams) {
      var items = cart.products();
      var currentRestGroup = api.getCurrentLocation();

      if (!items.length || !userData.franchise_preference[env.ENVIRONMENT]) {
        return loadMenuAndPrefs(redirectTo, redirectParams);
      }

      var restGroup = { id: userData.franchise_preference[env.ENVIRONMENT].restaurant_group_id };
      if (restGroup.id === currentRestGroup.id) {
        return loadMenuAndRedirect(false, redirectTo, redirectParams);
      }

      return api.checkCartItems(restGroup, items)
      .then(function(response) {
        if (response.cart_items.length > 0) {
          modalWarning(restGroup, 'cart-warning-modal.html');
        } else if (restGroup.id !== currentRestGroup.id && ($rootScope.current.name == 'checkout' || $rootScope.current.name == 'cart.whenhowwhere')) {
          modalWarning(restGroup, 'login-warning-modal.html', 'modal-warning-login');
        } else {
          loadMenuAndPrefs(redirectTo, redirectParams);
        }
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
      });
    }

    function modalWarning(rest_group, modalName, windowClassName) {
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'location-warning',
        controller: 'LocationController as location',
        templateUrl: 'app/location/{mobile}{desktop}/' + modalName,
        windowClass: windowClassName,
        resolve: {
          selectedLocation: function() {
            return rest_group;
          }
        }
      });

      modalInstance.result.then(function (confirmed) {
        if (confirmed) {
          api.setRestaurantGroup(rest_group);
        } else {
          api.setRestaurantGroup(api.getCurrentLocation());
        }
      }, function (e) {
        api.setRestaurantGroup(api.getCurrentLocation());
      });
    }

    function loadMenuAndPrefs(redirectTo, redirectParams, items) {
      return api.refreshLocation();
    }

    function facebookAuth() {
      $auth.authenticate('facebook')
      .then(function() {
        $log.log('success!', arguments);
      }).catch(function() {
        $log.error('so bad :(', arguments);
      });
    }

    function loginSuccess(ev, loggedCustomer) {
      vm.resendCodeCount = 0;
      $localStorage.resendCode = 0;
      customer.set(loggedCustomer);
    }

    function oauthRegistration(ev, user) {
      vm.resendCodeCount = 0;
      $localStorage.resendCode = 0;
      $log.log('new user registered through oauth:', user);
    }

    function onErrorModal(ev, reason) {
      getDataError(reason);
      vm.isSendingForm = false;
      vm.errorModal = vm.error;
    }

    function onError(ev, reason) {
      getDataError(reason);
      vm.isSendingForm = false;
      ngNotify.set(vm.error, 'error');
      hero.setAnalyticsClass('perm-server-error-notify');
    }

    function getDataError(reason) {
      if (_.isArray(reason.errors)) {
        vm.error = reason.errors.join(', ');
      } else if (_.isObject(reason.errors)) {
        vm.error = reason.errors.full_messages.join(', ');
      }
      vm.data = reason.data;
      vm.requiresVerificationCode = reason.requires_verification_code;
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('website')
  .controller('CreditCardModalController', CreditCardModalController);

  /* @ngInject */
  function CreditCardModalController(_, api, cart, userCard, env, kushki, $auth, $uibModalInstance) {
    var vm = this;
    vm.cart = cart;
    vm.kushki = kushki;
    vm.userCard = userCard;
    vm.customer = null;
    vm.creditCard = null;
    vm.kushkiPayment = false;
    vm.onlinePayment = false;
    vm.paymentCards = null;
    vm.tbkUsers = null;
    vm.inscriptionUrl = env.API_URL + 'webpays/init_inscription';
    vm.selectCreditCard = selectCreditCard;
    vm.initInscriptionUrl = initInscriptionUrl;
    vm.goToInscriptionbWebpay = goToInscriptionbWebpay;

    activate();

    ////////////////

    function activate() {
      api.prefs.all().then(function() {
        var kushki_payment = api.prefs.get('kushki_payment');
        var online_payment = api.prefs.get('online_payment');
        vm.kushkiPayment = kushki_payment ? kushki_payment.value.toLowerCase() === 'true' : false;
        vm.onlinePayment = online_payment ? online_payment.value.toLowerCase() === 'true' : false;
        if (vm.kushkiPayment) getPaymentCards();
        if (vm.onlinePayment) getTbkUser();
      });
    }

    function getPaymentCards() {
      api.payment_gateway.get_payment_cards()
      .then(function(response) {
        vm.paymentCards = response.payment_cards;
        vm.creditCard = vm.userCard;
      })
      .catch(function(err) {
        console.error(err);
      });
    }

    function getTbkUser() {
      if (!_.isEmpty($auth.user)) {
        vm.customer = $auth.user;
        api.tbkuser.all(vm.customer.id)
        .then(function(response) {
          vm.tbkUsers = response;
          vm.creditCard = vm.userCard;
        })
        .catch(function(err) {
          console.error(err);
        });
      }
    }

    function selectCreditCard() {
      $uibModalInstance.close(vm.creditCard);
    }

    function initInscriptionUrl() {
      var params = vm.customer ? '?customer_id=' + vm.customer.id : '';
      vm.inscriptionUrl = env.API_URL + 'webpays/init_inscription' + params;
    }

    function goToInscriptionbWebpay() {
      document.location.href = vm.inscriptionUrl;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('website')
    .controller('CheckoutController', CheckoutController)
    .controller('UIModalController', UIModalController);

  /* @ngInject */
  function UIModalController($uibModalInstance, product) {
    var vm = this;
    vm.product = product;
    vm.removeProductModal = removeProductModal;

    function removeProductModal(remove) {
      $uibModalInstance.close(remove);
    }
  }

  /* @ngInject */
  function CheckoutController(_, analytics, api, cart, cartproduct, coupon, dateTime, env, hero, html, kushki, ngNotify, PaymentNormalizer, $auth, $document, $filter, $locale, $localStorage, $log, $q, $rootScope, $scope, $state, $stateParams, $templateCache, $timeout, $uibModal, $interval) {
    var vm = this;

    // Fixed Texts
    vm.deliveryText = 'delivery';
    vm.now = 'now';
    vm.nowTextByDefault = 'Cuanto antes';
    vm.pickupText = 'pickup';
    vm.scheduled = 'scheduled';
    vm.scheduledTextByDefault = 'Programa tu pedido';
    vm.restaurantText = env.ENVIRONMENT == 'mxniusushi' ? 'Sucursales' : 'Locales';
    vm.closedRestaurant = env.ENVIRONMENT == 'mxniusushi' ? 'Sucursales cerradas' : 'Locales cerrados';

    // Dynamic values
    vm.mapOptions = {};
    vm.mapOptions.mapTypeControl = false;
    vm.mapOptions.scrollwheel = false;
    vm.mapOptions.streetViewControl = false;
    vm.mapOptions.draggable = true;
    vm.isClosed = true;
    vm.showNewAddressBtn = false;
    vm.contentLoaded = false;
    vm.onlinePaymentOn = false;
    vm.openDetails = true;
    vm.hasPickup = false;
    vm.kushki = kushki;
    vm.kushkiPayment = false;
    vm.kushkiPaymentOn = false;
    vm.paymentCards = [];
    vm.kushkiCard = null;
    vm.selectedCardToken = null;
    vm.kushkiCardDraft = null;
    vm.selectedCardId = null;
    vm.hasDelivery = false;
    vm.inProgress = false;
    vm.skeletonShow = true;
    vm.isOpenPickup = false;
    vm.onlinePayment = false;
    vm.amipassPayment = false;
    vm.pluxeePayment = false;
    vm.webpayplusPayment = false;
    vm.paymentType = false;
    vm.paymentTypeModal = false;
    vm.processingWebPayment = false;
    vm.pluxeeMerchantId = null;
    vm.pluxeeStatusReadNotified = false;
    vm.pluxeeStatusRequestInFlight = false;
    vm.pluxeeQrImage = null;
    vm.pluxeeCode = null;
    vm.pluxeePaymentIntent = null;
    vm.initInscriptionButton = false;
    vm.otherTip = false;
    vm.couponLabelDisabled = false;
    vm.localePickup = '';
    vm.localeDelivery = '';
    vm.customer = null;
    vm.tbkUser = null;
    vm.tbkUsers = null;
    vm.creditCard = $localStorage.selectedCreditCard || null;
    vm.showCardDropdown = false;
    vm.selectedLocation = null;
    vm.selectedLocationId = null;
    vm.commerceCode = null;
    vm.webpayplusCommerceCode = null;
    vm.tipModal = null;
    vm.items = [];
    vm.additionalItems = [];
    vm.addressLocations = [];
    vm.pickupRestaurants = [];
    vm.selectedTip = {};
    vm.DEFAULT_DISCOUNT_1 = (parseFloat(env.DEFAULT_DISCOUNT_1) * 100);
    vm.DEFAULT_DISCOUNT_2 = (parseFloat(env.DEFAULT_DISCOUNT_2) * 100);
    vm.currentCoupon = $localStorage.currentCustomerCoupon;
    vm.subtotalAmount = 0;
    vm.productDiscountAmount = 0;
    vm.currentCouponValue = 0;
    vm.deliveryAmount = 0;
    vm.tipAmount = 0;
    vm.totalPay = 0;
    vm.loadingTotals = false;
    var _checkCartSeq = 0;
    var _checkCartDebounce = null;
    var _orderCompleted = false;
    $scope.$on('$destroy', function() {
      if (_checkCartDebounce) $timeout.cancel(_checkCartDebounce);
    });
    vm.scheduledOrder = $localStorage.scheduledOrder ? $localStorage.scheduledOrder : vm.now;
    vm.scheduledOrderModal = $localStorage.scheduledOrder ? $localStorage.scheduledOrder : vm.now;
    vm.paymentTypes = {};
    vm.paymentOrder = [];
    vm.scheduleOrderConf = {}
    vm.scheduleOrderPref = false;
    vm.selectedDateTime = null;
    vm.selectedLocationIsClosed = false;
    vm.selectedLocationAllowsScheduling = false;
    vm.scheduledOrderDateTimeLabel = $localStorage.scheduledOrderDateTimeLabel ? $localStorage.scheduledOrderDateTimeLabel : null;
    vm.how = $localStorage.how ? $localStorage.how : vm.deliveryText;
    vm.howModal = $localStorage.how ? $localStorage.how : vm.deliveryText;
    vm.discountable = cart.discountable;
    vm.environment = env.ENVIRONMENT;
    vm.country = env.COUNTRY || 'CL';
    vm.tips = env.TIPS;
    vm.inscriptionUrl = env.API_URL + 'webpays/init_inscription';
    vm.pluxeePollPromise = null;
    vm.pluxeePollEndsAt = null;
    vm.pendingPluxeeOrderInfo = null;
    vm.paymentConfig = buildPaymentConfig();
    vm.sendOrder = sendOrder;
    vm.price = price;
    vm.handlePickupDelivery = handlePickupDelivery;
    vm.handlePickupDeliveryModal = handlePickupDeliveryModal;
    vm.showTips = showTips;
    vm.addOne = addOne;
    vm.removeOne = removeOne;
    vm.removeAll = removeAll;
    vm.removeProduct = removeProduct;
    vm.productCount = productCount;
    vm.selectLocation = selectLocation;
    vm.selectQuestion = selectQuestion;
    vm.initInscriptionUrl = initInscriptionUrl;
    vm.goToInscriptionbWebpay = goToInscriptionbWebpay;
    vm.openKushkiInscription = openKushkiInscription;
    vm.sendToPaymentPortal = sendToPaymentPortal;
    vm.updatedDiscount = updatedDiscount;
    vm.validateState = validateState;
    vm.toggleSwitch = toggleSwitch;
    vm.showAdditionalItem = showAdditionalItem;
    vm.showOptions = showOptions;
    vm.checkedTip = checkedTip;
    vm.selectTip = selectTip;
    vm.showDetails = showDetails;
    vm.hideLocationModal = hideLocationModal;
    vm.showLocationModal = showLocationModal;
    vm.changeLocationElement = changeLocationElement;
    vm.closeModal = closeModal;
    vm.blockTip = blockTip;
    vm.updateSkeleton = updateSkeleton;
    vm.selectCreditCard = selectCreditCard;
    vm.selectPaymentType = selectPaymentType;
    vm.paymentTypeIsCash = paymentTypeIsCash;
    vm.toggleCardDropdown = toggleCardDropdown;
    vm.confirmSelectedCard = confirmSelectedCard;
    vm.handlePaymentMethodSelection = handlePaymentMethodSelection;
    vm.selectLocationModal = selectLocationModal;
    vm.selectCreditCardModal = selectCreditCardModal;
    vm.selectCouponModal = selectCouponModal;
    vm.selectTipModal = selectTipModal;
    vm.openModalLocation = openModalLocation;
    vm.newAddressSidebarModal = newAddressSidebarModal;
    vm.deliveryPickupModal = deliveryPickupModal;
    vm.paymentMethodModal = paymentMethodModal;
    vm.customerCouponsModal = customerCouponsModal;
    vm.handleCouponApplication = handleCouponApplication;
    vm.couponDescription = couponDescription;
    vm.checkoutTipsModal = checkoutTipsModal;
    vm.buildScheduledDayOptions = buildScheduledDayOptions;
    vm.updateStateScheduledOrder = updateStateScheduledOrder;
    vm.checkPaymentTypeAllowedScheduledOrder = checkPaymentTypeAllowedScheduledOrder;
    vm.canBeActivatedScheduledOrder = canBeActivatedScheduledOrder;
    vm.getLocationRestaurantId = getLocationRestaurantId;
    vm.scheduledOrderActivated = scheduledOrderActivated;
    vm.scheduledOrderDataIsComplete = scheduledOrderDataIsComplete;
    vm.selectedLocationIsOpen = selectedLocationIsOpen;
    vm.restaurantAllowsScheduling = restaurantAllowsScheduling;
    vm.toggleScheduleOrderOptions = toggleScheduleOrderOptions;
    vm.showCouponSection = showCouponSection;
    vm.validateDiscount = validateDiscount;
    vm.validateTip = validateTip;
    vm.cancelPluxeeQr = cancelPluxeeQr;
    vm.startPluxeePolling = startPluxeePolling;
    vm.stopPluxeePolling = stopPluxeePolling;
    vm.cart = cart;
    vm.coupon = coupon;
    vm.envConstants = env;
    vm.scrollToPluxeeQr = scrollToPluxeeQr;

    getAdditionalProducts();
    function getAdditionalProducts(force) {
      return api.additionalProducts.all(force)
        .then(function (response) {
          vm.additionalProducts = response;
        })
        .catch(function (err) {
          $log.error(JSON.stringify(err));
        });
    }

    getPrefsAll();
    function getPrefsAll() {
      return $q.all([setGeneralPreferences(), setGlobalAvailablePaymentsVisibility()])
        .then(function () {
          buildPaymentsFromPrefs();
          activate();
        })
        .catch(function (err) {
          $log.error(JSON.stringify(err));
        });
    }

    if (!vm.discountable()) {
      vm.paymentDiscount = "0"
    }

    function mapPaymentTypeForOrder(paymentType) {
      if (!paymentType) return null;
      return paymentType;
    }

    function buildPaymentConfig() {
      var cashDescription = vm.country === 'MX'
        ? 'Pago contra entrega - Efectivo, tarjeta de débito y crédito'
        : 'Efectivo, tarjeta de débito y crédito (RedCompra) - Presencial';

      return {
        webpayplus: {
          icon: "assets/images/transbank/webpayplus.svg",
          label: "WebpayPlus",
          discount: vm.DEFAULT_DISCOUNT_1,
        },
        amipass: {
          icon: "assets/images/amipass/amipass_logo.png",
          label: "Amipass",
          discount: vm.DEFAULT_DISCOUNT_2,
        },
        kushki: {
          icon: "assets/images/kushki/kushki_logo.svg",
          label: "Tarjeta",
          discount: vm.DEFAULT_DISCOUNT_1
        },
        pluxee: {
          icon: "assets/images/pluxee/pluxee_logo.png",
          label: "Pluxee",
          discount: vm.DEFAULT_DISCOUNT_2,
        },
        cash: {
          icon: "assets/images/payments/cash.svg",
          label: "Cash",
          description: cashDescription,
          discount: vm.DEFAULT_DISCOUNT_1,
        },
      };
    }

    vm.getCardLogo = function (cardType) {
      if (!cardType) return null;
      if (cardType === 'VISA' ||
          cardType === 'MASTERCARD' ||
          cardType === 'AMERICANEXPRESS' ||
          cardType === 'PREPAGO') {
        switch (cardType) {
          case 'VISA':
          case 'PREPAGO':
            return 'assets/images/payment-card/visa.svg';
          case 'MASTERCARD':
            return 'assets/images/payment-card/mastercard.svg';
          case 'AMERICANEXPRESS':
            return 'assets/images/payment-card/amex.svg';
          default:
            return null;
        }
      }
      var type = vm.cart.cardTypeName(cardType);
      switch (type) {
        case 'VISA':
        case 'PREPAGO':
          return 'assets/images/payment-card/visa.svg';
        case 'MASTERCARD':
          return 'assets/images/payment-card/mastercard.svg';
        case 'AMERICANEXPRESS':
          return 'assets/images/payment-card/amex.svg';
        case 'REDCOMPRA':
          return 'assets/images/transbank/redcompra_logo.png';
        default:
          return null;
      }
    };

    function buildPaymentsFromPrefs() {
      var payments = api.prefs.get('payment_methods');
      var result = PaymentNormalizer.normalize(payments);
      vm.paymentTypes = result.paymentTypes;
      vm.paymentOrder = result.order;
    }
    Object.defineProperty(vm, 'count', {
      get: function () {
        return cart.count;
      }
    });

    ////////////////

    $rootScope.$on('location:changed', function (event, location) {
      locationChanged(location);
      updateDataScheduledorder();
    });

    $scope.$on('cart:added', function () {
      vm.items = cart.products();
      calculateTotals();
      vm.additionalItems = cart.additionalItems();
    });

    $scope.$on('path:changed', function () {
      vm.how = $localStorage.how ? $localStorage.how : vm.deliveryText;
      $localStorage.how = vm.how;
      delete $localStorage.modalInstance;
      localeWhenHowHere();
      handleShowPriceWarningModal();
      cart.setDefaultDiscount();
      calculateTotals();
      analytics.beginCheckout(cart, 'begin_checkout');
      updateDataScheduledorder();
    });

    $scope.$on('coupon:load', function () {
      vm.currentCoupon = $localStorage.currentCustomerCoupon;
      calculateTotals();
    });

    $scope.$on('coupon:apply', function () {
      if ($localStorage.modalInstance == 'customerCouponsModal') {
        closeModal();
      }
    });

    $rootScope.$on('auth:login-success', function (ev, loggedCustomer) {
      vm.customer = loggedCustomer;
      if (!_.isEmpty(loggedCustomer)) {
        getTbkUser(loggedCustomer.id).then(function (tbk_users) {
          vm.tbkUsers = tbk_users;
          var storedCardId = $localStorage.selectedCreditCard;
          var storedCard = storedCardId ? cart.findTbkCard(vm.tbkUsers, storedCardId) : null;
          vm.tbkUser = storedCard || vm.tbkUsers[0];
          vm.selectCreditCard(vm.tbkUser ? vm.tbkUser.id : null);
          if (vm.tbkUser) {
            setCardPaymentMethod();
          };
        });
      }
    });

    $rootScope.$on('kushki:subscribe-card', function () {
      getPaymentCards().then(function () {
        onlinePaymentEnabled();
        vm.paymentType = 'kushki';
        vm.paymentTypeModal = 'kushki';
        calculateTotals();
      });
    });

    $rootScope.$on('checkout:how', function (ev, checkoutHow) {
      vm.how = checkoutHow;
      $localStorage.how = vm.how;
    });

    function closeModal() {
      calculateTotals();
      vm.additionalItems = cart.additionalItems();
      $rootScope.modalInstance.close(true);
      $localStorage.modalInstance = null;
    }

    function selectLocationModal(how, location) {
      if (how == vm.pickupText) {
        $localStorage.pickupSelectedFromModal = true;
      }
      var response = { how: how, location: location };
      $rootScope.modalInstance.close(response);
      $localStorage.modalInstance = null;
    }

    function selectCreditCardModal(paymentType, creditCard) {
      var response = { paymentType: paymentType, creditCard: creditCard };
      $rootScope.modalInstance.close(response);
      $localStorage.modalInstance = null;
    }

    function selectCouponModal(customerCoupon) {
      $rootScope.modalInstance.close(customerCoupon);
      vm.items = cart.products();
      vm.additionalItems = cart.additionalItems();
      calculateTotals();
      $localStorage.modalInstance = null;
    }

    function selectTipModal(tipModal) {
      $rootScope.modalInstance.close(tipModal);
      $localStorage.modalInstance = null;
    }

    function openModalLocation() {
      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        size: 'modal-location-checkout',
        windowClass: 'modal-location-checkout',
        controller: 'LocationController as location',
        templateUrl: 'app/location/{mobile}{desktop}/modal-location-cart.html',
        resolve: {
          selectedLocation: function () {
            return '';
          }
        }
      });

      return modalInstance;
    }

    function newAddressSidebarModal() {
      $localStorage.modalInstance = 'newAddressSidebarModal';
      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        controller: 'AddressController',
        controllerAs: 'address',
        windowClass: 'newAddressSidebarModal',
        templateUrl: 'app/address/{mobile}{desktop}/address-sidebar.modal.html',
        resolve: {
          fromLogin: function () {
            return false;
          }
        }
      });

      modalInstance.result.then(function (newAddress) {
        $localStorage.modalInstance = null;
        if (!newAddress) return false;
        $rootScope.$broadcast('checkout:how', vm.deliveryText);
        vm.addressLocations.unshift(newAddress);
        vm.selectedLocation = validateAddress(vm.addressLocations[0], vm.selectedLocation, true);
        $rootScope.$broadcast('location:changed', vm.selectedLocation);
        selectLocation();
        selectQuestion(vm.selectedLocation);
        onlinePaymentEnabled();
        if (!!vm.tbkUser && vm.onlinePaymentOn) {
          vm.paymentType = setDefaultPaymentType();
          setDefaultTip();
        }
        addDelivery(true);
        if (vm.selectedLocation.assigned_restaurant ) {
          vm.selectedLocationIsClosed = !vm.selectedLocation.assigned_restaurant_is_open;
          vm.selectedLocationAllowsScheduling = vm.selectedLocation.assigned_restaurant.allows_scheduling;
        }
        calculateTotals();
      }, function (e) {
        console.error(e);
      });
    }

    function deliveryPickupModal() {
      $localStorage.how = vm.how;
      $localStorage.modalInstance = 'deliveryPickupModal';
      $rootScope.modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        controller: 'CheckoutController',
        controllerAs: 'checkout',
        windowClass: 'deliveryPickupModal',
        templateUrl: 'app/checkout/{mobile}{desktop}/delivery-pickup.modal.html',
      });

      $rootScope.modalInstance.result.then(function (response) {
        if (response == true) return true;
        $rootScope.$broadcast('checkout:how', response.how);
        if (response.how == vm.deliveryText) {
          vm.selectedLocation = validateAddress(response.location, vm.selectedLocation, true);
          addDelivery(true);
        }
        if (response.how == vm.pickupText) {
          vm.selectedLocation = validateRestaurant(response.location, vm.selectedLocation, true);
          addDelivery(false);
        }
        $rootScope.$broadcast('location:changed', vm.selectedLocation);
        selectLocation();
        selectQuestion(vm.selectedLocation);
        onlinePaymentEnabled();
        if (!!vm.tbkUser && vm.onlinePaymentOn){
          vm.paymentType = setDefaultPaymentType();
          setDefaultTip();
        }
        calculateTotals();
      }, function (e) {
        console.error(e);
      });
    }

    function paymentMethodModal() {
      $localStorage.modalInstance = "paymentMethodModal";

      vm.tbkUser = cart.findTbkCard(vm.tbkUsers, vm.creditCard);
      analytics.beginCheckout(cart, 'add_payment_info');

      $rootScope.modalInstance = $uibModal.open({
        animation: true,
        backdrop: "static",
        controller: "CheckoutController",
        controllerAs: "checkout",
        windowClass: "paymentMethodModal",
        templateUrl: "app/checkout/{mobile}{desktop}/payment-method.modal.html",
      });

      $rootScope.modalInstance.result.then(
        function (response) {
          if (response === true) {
            if (vm.creditCard) {
              vm.tbkUser = cart.findTbkCard(vm.tbkUsers, vm.creditCard);
            }
            return;
          }
          vm.paymentType = response.paymentType;
          if (vm.onlinePayment) {
            vm.selectCreditCard(response.creditCard);
            vm.tbkUser = cart.findTbkCard(vm.tbkUsers, response.creditCard);
            if (vm.tbkUser) setDefaultTip();
          }
          onlinePaymentEnabled();
          calculateTotals();
        },
        function (e) {
          console.error(e);
        }
      );
    }

    function customerCouponsModal() {
      $localStorage.modalInstance = 'customerCouponsModal';
      $rootScope.modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        controller: 'CheckoutController',
        controllerAs: 'checkout',
        windowClass: 'customerCouponsModal',
        templateUrl: 'app/checkout/{mobile}{desktop}/customer-coupons.modal.html',
      });

      $rootScope.modalInstance.result.then(function (customerCoupon) {
        if (customerCoupon == true) return true;
        coupon.activateCoupon(customerCoupon);
        coupon.couponsLoad();
      }, function (e) {
        console.error(e);
      });
    }

    function handleCouponApplication(couponInput) {
      vm.couponLabelDisabled = true;
      coupon.code = couponInput;
      coupon.applyCoupon().then(function(success) {
        if (!success) {
          vm.couponLabelDisabled = false;
        }
      }).catch(function(error) {
        vm.couponLabelDisabled = false;
      });
    }

    function couponDescription(coupon) {
      switch (coupon.coupon_type) {
        case 'products':
          return coupon.product_name || coupon.code;
        case 'products_free':
          return coupon.product_name || coupon.code;
        case 'percentage':
          return coupon.value + '%';
        case 'fixed_amount':
          return cart.parseIntl(coupon.value);
        default:
          return coupon.value;
      }
    }

    function checkoutTipsModal() {
      $localStorage.modalInstance = 'checkoutTipsModal';
      $rootScope.modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        controller: 'CheckoutController',
        controllerAs: 'checkout',
        windowClass: 'checkoutTipsModal',
        templateUrl: 'app/checkout/{mobile}{desktop}/checkout-tips.modal.html',
      });

      $rootScope.modalInstance.result.then(function (tipModal) {
        if (tipModal == true) return true;
        var tip = { "id": 5, "amount": tipModal, "formattedAmount": cart.parseIntl(tipModal), "default": false };
        vm.otherTip = true;
        var tipButton = $document[0].getElementById('other-tip');
        html.addClass(tipButton, 'active');
        selectTip(tip);
      }, function (e) {
        console.error(e);
      });
    }

    function removeProduct(product) {
      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        controller: 'UIModalController',
        controllerAs: 'confirmation',
        windowClass: 'removeProductModal',
        templateUrl: 'app/checkout/{mobile}{desktop}/remove-product.modal.html',
        resolve: {
          product: function () {
            return product;
          }
        }
      });

      modalInstance.result.then(function (confirmed) {
        if (confirmed) {
          removeCouponProduct(product);
          removeOne(product);
          returnToMenu();
        }
      }, function (e) {
        console.error(e);
      });
    }

    function removeCouponProduct(product) {
      var currentCoupon = vm.currentCoupon;
      if (!currentCoupon || !currentCoupon.coupon.coupon_type.includes('products')) {
        return;
      }
      var cartCouponProducts = _.filter(vm.items, function (item) {
        return currentCoupon.products_enabled.includes(item.id);
      });
      if (cartCouponProducts.length > 0 && currentCoupon.products_enabled.includes(product.id)) {
        _.remove(vm.items, function (item) {
          return item.id === product.id;
        });
        if (cartCouponProducts.length === 1) {
          delete $localStorage.currentCustomerCoupon;
          vm.currentCoupon = null;
        }
      }
      vm.items = cart.products();
      calculateTotals();
    }

    vm.getSelectedCardLabel = function () {
      if (vm.country === "MX" && vm.selectedCardToken) {
        var card = _.find(vm.paymentCards, function (c) {
          return c.token === vm.selectedCardToken;
        });
        return card ? "**** " + card.card_last_four : "Selecciona una tarjeta";
      }
      if (vm.tbkUser) {
        return "**** " + vm.tbkUser.last_4_card_digits;
      }
      return "Selecciona una tarjeta";
    };

    vm.selectKushkiCardDraft = function (card) {
      vm.kushkiCardDraft = card;
    };

    vm.confirmSelectedKushkiCard = function () {
      var cardToUse = vm.kushkiCardDraft || vm.kushkiCard;
      if (!cardToUse) return;
      vm.kushkiCard = cardToUse;
      vm.selectedCardToken = cardToUse.token;
      vm.selectedCardId = cardToUse.id;
      vm.paymentType = 'kushki';
      vm.paymentTypeModal = 'kushki';
      vm.showCardDropdown = false;
      vm.kushkiCardDraft = null;
      vm.selectCreditCardModal('kushki', vm.selectedCardToken);
    };

    function returnToMenu() {
      if (vm.items.length > 0) return;

      ngNotify.set('Tu carro se encuentra vacío.', { type: 'warning', duration: 1000 });
      hero.setAnalyticsClass('perm-warning-empty-cart', 1000);
      validateState();
    }

    function blockTip() {
      vm.otherTip = false;
      var tipButton = $document[0].getElementById('other-tip');
      if (tipButton) html.removeClass(tipButton, 'active');
    }

    function selectCreditCard(creditCard) {
      vm.creditCard = creditCard;
      if (creditCard) {
        $localStorage.selectedCreditCard = creditCard;
      } else {
        delete $localStorage.selectedCreditCard;
      }
    }

    function selectPaymentType(paymentType) {
      vm.paymentTypeModal = paymentType;
    }

    function paymentTypeIsCash(paymentType) {
      return paymentType === 'cash';
    }

    function toggleCardDropdown() {
      if (vm.country === 'MX') {
        if (!vm.paymentCards || vm.paymentCards.length <= 1) return;
      } else {
        if (!vm.tbkUsers || vm.tbkUsers.length <= 1) return;
      }
      vm.showCardDropdown = !vm.showCardDropdown;
    }

    function confirmSelectedCard() {
      if (!vm.creditCard) return;
      var selectedTbkUser = cart.findTbkCard(vm.tbkUsers, vm.creditCard);
      if (!selectedTbkUser) return;
      vm.tbkUser = selectedTbkUser;
      vm.selectCreditCard(vm.creditCard);
      vm.paymentType = "oneclick";
      vm.paymentTypeModal = "oneclick";
      vm.showCardDropdown = false;
      vm.selectCreditCardModal("oneclick", vm.creditCard);
    }

    function handlePaymentMethodSelection(payment) {
      if (payment.type === 'kushki') {
        vm.selectCreditCard(null);
      }
      vm.paymentTypeModal = payment.type;
      vm.updatedDiscount(getPaymentDiscount(payment.type, payment.discount));
      vm.selectCreditCardModal(payment.type, null);
    }

    function getPaymentDiscount(paymentType, fallbackDiscount) {
      var config = vm.paymentConfig && vm.paymentConfig[paymentType];
      if (config && typeof config.discount !== 'undefined') {
        return config.discount;
      }
      if (fallbackDiscount === vm.DEFAULT_DISCOUNT_1 ||
        fallbackDiscount === vm.DEFAULT_DISCOUNT_2 ||
        fallbackDiscount === 0) {
        return fallbackDiscount;
      }
      return 0;
    }

    function handleShowPriceWarningModal() {
      if (env.WARNING_PRICE === 0) return;

      if (vm.totalDiscount > env.WARNING_PRICE) {
        priceWarningModal();
      }
    }

    function priceWarningModal() {
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'full',
        templateUrl: 'app/cart/{mobile}{desktop}/price-warning.modal.html',
        controller: function ($scope, $uibModalInstance) {
          $scope.parseIntl = cart.parseIntl;
          $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
          };
        }
      });
      return modalInstance;
    }

    function setGlobalAvailablePaymentsVisibility() {
      return api.prefs.all().then(function () {
        var online_payment = api.prefs.get('online_payment');
        var amipass_payment = api.prefs.get('amipass_payment');
        var webpayplus_payment = api.prefs.get('webpayplus_payment');
        var pluxee_payment = api.prefs.get('pluxee_payment');
        var kushki_payment = api.prefs.get('kushki_payment');
        vm.onlinePayment = online_payment ? online_payment.value.toLowerCase() === 'true' : false;
        vm.pluxeePayment = pluxee_payment ? pluxee_payment.value.toLowerCase() === 'true' : false;
        vm.amipassPayment = amipass_payment ? amipass_payment.value.toLowerCase() === 'true' : false;
        vm.webpayplusPayment = webpayplus_payment ? webpayplus_payment.value.toLowerCase() === 'true' : false;
        vm.kushkiPayment = kushki_payment ? kushki_payment.value.toLowerCase() === 'true' : false;
      })
      .then(function () {
        return true;
      });
    }

    function setGeneralPreferences() {
      return api.prefs.all().then(function () {
        var scheduleOrder = api.prefs.get('schedule_order');
        if (!scheduleOrder) return;
        vm.scheduleOrderPref =
          scheduleOrder.activated &&
          scheduleOrder.activated.toLowerCase() === 'true';
        vm.scheduleOrderConf = scheduleOrder.web || {};
        if (scheduleOrder.payment_methods) {
          var result = PaymentNormalizer.normalize(scheduleOrder.payment_methods);
          vm.paymentTypes = result.paymentTypes;
          vm.paymentOrder = result.order;
        }
      });
    }

    function activate() {
      delete $localStorage.order;
      return $q.all([api.products.all(), api.promotions.all()])
        .then(function () {
          activateAdditionalProducts();
          vm.items = cart.products();
          validateState({ items: vm.items });
          calculateTotals();
          if (!$localStorage.modalInstance) handleShowPriceWarningModal();
          vm.additionalItems = cart.additionalItems();
          if ($stateParams.status == 'fail') {
            var msg = 'Hubo un error inscribiendo tu tarjeta. Por favor inténtalo nuevamente.';
            ngNotify.set(msg, 'error');
            hero.setAnalyticsClass('perm-error-saving-credit-card');
          }
          return $auth.validateUser();
        })
        .catch(function (info) {
          if (info.reason !== 'unauthorized') {
            $log.error(info);
            ngNotify.set('Error de conexión. Reintenta más tarde.', 'error');
            hero.setAnalyticsClass('perm-server-error-notify');
          }
        })
        .then(function (customer) {
          vm.customer = customer;
          getOpenRestaurants();
          if (!_.isEmpty($auth.user)) {
            getCustomerAddresses().then(function (addresses) {
              setPreviousState();
            });
            getPaymentCards();
            coupon.couponsLoad();
          }
        })
        .then(function () {
          localeWhenHowHere();
        })
        .then(function () {
          vm.contentLoaded = true;
          updateSkeleton(false);
        });
    }

    function activateAdditionalProducts() {
      _.each(vm.additionalProducts, function (item) {
        item.option_on = cart.additionalProduct.get(item);
      });
    }

    function validateState(items) {
      var tmpItems = items ? items : { items: vm.items };
      var env = tmpItems ? tmpItems : {};
      var stateName = $rootScope.current.name;
      var isInCartState = stateName.indexOf('checkout') >= 0;
      if (!isInCartState) return;
      if (env.items) {
        if (env.items.length === 0) {
          $state.go('menu', {}, { location: 'replace' });
          ngNotify.set('Tu carro se encuentra vacío.', { type: 'warning', duration: 1000 });
          hero.setAnalyticsClass('perm-warning-empty-cart', 1000);
          return false;
        } else {
          return handleCheckMenuItem(env.items);
        }
      }
      if (vm.isClosed) {
        $state.go('menu', {}, { location: 'replace' });
        ngNotify.set(vm.closedRestaurant, { type: 'warning', duration: 1000 });
        return false;
      }
    }

    function handleCheckMenuItem(cartItems) {
      var restaurantGroupId = $localStorage.restaurantGroup ? $localStorage.restaurantGroup.id : null;
      return api.menuCategories.checkMenuItem(cartItems, restaurantGroupId)
        .then(function (response) {
          if (response.items_not_found.length === 0) return true;

          _.each(response.items_not_found, function (item) {
            var element = _.find(cartItems, function (cartItem) {
              return item == cartItem.id;
            });
            removeAll(element);
          });

          api.products.all(true);
          api.promotions.all();

          var message = 'Unos de los productos que elegiste ya no se encuentra disponible. Hemos actualizado tu carro.'
          ngNotify.set(message, 'error');
          hero.setAnalyticsClass('perm-error-product-not-available');
          $state.go('checkout', {}, { reload: true });
          return false;
        });
    }

    function addOne(item) {
      cart.add(item.id, 1, item.options, item.seleable.type);
      calculateTotals();
      vm.additionalItems = cart.additionalItems();
    }

    function remove(item, count) {
      var id = item.id,
        options = item.options;
      cart.remove(id, count, options, item.seleable.type);

      if (vm.items.length) {
        calculateTotals();
      } else {
        $state.go('menu', {}, { location: 'replace' });
      }

      if (productCount(item, options) === 0) {
        vm.items = cart.products();
        vm.additionalItems = cart.additionalItems();
      }
    }

    function removeOne(item) {
      remove(item, 1);
      calculateTotals();
      vm.additionalItems = cart.additionalItems();
    }

    function removeAll(item) {
      remove(item, productCount(item));
      calculateTotals();
      vm.additionalItems = cart.additionalItems();
    }

    function productCount(item) {
      return cart.get(item.id, item.options, item.seleable.type);
    }

    function syncCalculatedAdditionalProducts() {
      if (!vm.additionalProducts || !vm.additionalProducts.length) return;
      _.each(vm.additionalProducts, function (prod) {
        if (prod.additional_type === 'calculated') {
          cart.calculatedProducts.set(prod);
        }
      });
    }

    function calculateTotals() {
      if (_orderCompleted) return;
      syncCalculatedAdditionalProducts();
      vm.items = cart.products();
      vm.additionalItems = cart.additionalItems();
      if (!vm.customer || !vm.selectedLocationId) return;
      _scheduleCheckCart();
    }

    function _scheduleCheckCart() {
      if (_checkCartDebounce) $timeout.cancel(_checkCartDebounce);
      vm.loadingTotals = true;
      _checkCartDebounce = $timeout(function() {
        var seq = ++_checkCartSeq;
        api.orders.checkCart(order())
          .then(function(details) {
            if (seq !== _checkCartSeq) return;
            _applyCartDetails(details.payment_details);
          })
          .catch(function(error) {
            if (seq !== _checkCartSeq) return;
            var message = error.data && error.data.error ? error.data.error[0] : 'Error al calcular el total';
            if (error.data && error.data.details && error.data.details.payment_details) {
              _applyCartDetails(error.data.details.payment_details);
            }
            if (scheduledOrderActivated()) return;
            ngNotify.set(message, 'error');
          })
          .finally(function() {
            if (seq === _checkCartSeq) vm.loadingTotals = false;
          });
      }, 350);
    }

    function _applyCartDetails(pd) {
      vm.subtotalAmount = pd.subtotal_amount;
      vm.productDiscountAmount = pd.discount_amount;
      vm.currentCouponValue = pd.coupon_amount;
      vm.deliveryAmount = pd.delivery_amount;
      vm.tipAmount = pd.tip_amount;
      vm.totalPay = pd.total_amount;
    }

    function locationChanged(location) {
      vm.selectedLocation = location;
      if (vm.selectedLocation) {
        if (vm.selectedLocationIsOpen()) {
          if (['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance) ||
            (vm.scheduledOrderDateTimeLabel || $localStorage.scheduledOrderDateTimeLabel)) {
            $localStorage.scheduledOrder = vm.scheduledOrder;
            vm.scheduledOrderModal = vm.scheduledOrder;
          } else {
            vm.scheduledOrder = vm.now;
          }
        } else {
          if (['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance)) {
            $localStorage.scheduledOrder = vm.scheduledOrder;
            vm.scheduledOrderModal = vm.scheduledOrder;
          } else {
            vm.scheduledOrder = vm.scheduled;
          }
          vm.updateStateScheduledOrder(true, vm.scheduledTextByDefault);
          vm.buildScheduledDayOptions();
        }
        if (vm.selectedLocation.assigned_restaurant ) {
          vm.selectedLocationIsClosed = !vm.selectedLocation.assigned_restaurant_is_open;
          vm.selectedLocationAllowsScheduling = vm.selectedLocation.assigned_restaurant.allows_scheduling;
        } else {
          vm.selectedLocationIsClosed = !vm.selectedLocation.is_open;
          vm.selectedLocationAllowsScheduling = vm.selectedLocation.allows_scheduling;
        }
        vm.selectedLocationId = vm.selectedLocation.id;
        $localStorage.selectedLocationId = vm.selectedLocationId;
        ensureSelectedPaymentTypeAllowedByRestaurant();
      }
    }

    function getCustomerAddresses() {
      if (vm.how == vm.deliveryText) addDelivery(true);
      vm.showNewAddressBtn = false;
      vm.addressLocations.length = 0;
      vm.selectedLocationId = null;

      return api.addresses.all()
        .then(function (addresses) {
          var firstAddresses = addresses.splice(0, 3);
          addresses = _.sortBy(addresses, 'comune_name');
          addresses = addresses.sort(function (a, b) {
            return Number(b.assigned_restaurant_is_open) - Number(a.assigned_restaurant_is_open);
          });
          addresses = addresses.sort(function (a, b) {
            return Number(b.assigned_restaurant_group_is_correct) - Number(a.assigned_restaurant_group_is_correct);
          });
          vm.addressLocations = firstAddresses.concat(addresses);
          if (vm.how == vm.deliveryText) {
            var currentAddress = api.addresses.getCurrent();
            if (currentAddress) {
              vm.selectedLocation =
                _.find(vm.addressLocations, function (address) {
                  return address.id === currentAddress.id;
                }) || null;
            } else if (
              vm.addressLocations.length > 0 &&
              vm.customer.orders_count > 0
            ) {
              findSelectedAddress(vm.addressLocations, vm.scheduleOrderPref);
            } else {
              vm.selectedLocation = null;
            }
            locationChanged(vm.selectedLocation);
            selectLocation();
            selectQuestion(vm.selectedLocation);
            onlinePaymentEnabled();
            if (!!vm.tbkUser && vm.onlinePaymentOn) {
              vm.paymentType = setDefaultPaymentType();
              if ($localStorage.modalInstance == 'paymentMethodModal') {
                vm.paymentTypeModal = vm.paymentType;
              }
              if (['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance)) {
                vm.scheduledOrderModal = vm.scheduledOrder;
              }
              setDefaultTip();
            }
          }
          return addresses;
        })
        .then(function () {
          vm.showNewAddressBtn = true;
        });
    }

    function addDelivery(isDelivery) {
      cart.isDelivery = isDelivery;
      calculateTotals();
    }

    function setDefaultPaymentType(clear_payment) {
      var isMX = vm.country === 'MX';
      var hasKushki = vm.kushkiPaymentOn && vm.paymentCards.length > 0;
      var hasOneclick = !isMX && !!vm.tbkUser && vm.onlinePaymentOn;
      if (isMX) {
        if (hasKushki) return "kushki";
      } else {
        if (hasOneclick) return "oneclick";
      }
      if (clear_payment) return null;
    }

    function selectLocation() {
      vm.paymentType = setDefaultPaymentType(true);
      if ($localStorage.modalInstance == 'paymentMethodModal') {
        vm.paymentTypeModal = vm.paymentType;
      }
      if (['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance)) {
        vm.scheduledOrderModal = vm.scheduledOrder;
      }
      if (vm.creditCard) {
        vm.tbkUser = cart.findTbkCard(vm.tbkUsers, vm.creditCard);
      } else if (!vm.tbkUser && vm.tbkUsers && vm.tbkUsers.length) {
        vm.tbkUser = vm.tbkUsers[0];
        vm.selectCreditCard(vm.tbkUser.id);
      }
      if (vm.tbkUser) setCardPaymentMethod();
      setInscriptionButton();
      calculateTotals();
    }

    function setCardPaymentMethod() {
      vm.paymentType = setDefaultPaymentType();
      if ($localStorage.modalInstance == 'paymentMethodModal') {
        vm.paymentTypeModal = vm.paymentType;
      }
      if (['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance)) {
        vm.scheduledOrderModal = vm.scheduledOrder;
      }
      setDefaultTip();
    }

    function setDefaultTip() {
      vm.selectedTip = {};
      blockTip();

      if (!canUseTips()) {
        return;
      }

      var defaultTip = $filter("filter")(vm.tips, { default: true }, true)[0];
      if (defaultTip) {
        vm.selectedTip = defaultTip;
      }
    }

    function onlinePaymentEnabled() {
      vm.onlinePaymentOn = vm.onlinePayment && !!vm.selectedLocation;
      vm.kushkiPaymentOn = vm.kushkiPayment && vm.paymentCards.length > 0;
    }

    function getCommerceCode() {
      var commerceCode = null;
      var webpayplusCommerceCode = null;
      if (vm.selectedLocation.assigned_restaurant) {
        commerceCode = vm.selectedLocation.assigned_restaurant.commerce_code;
        webpayplusCommerceCode = vm.selectedLocation.assigned_restaurant.webpayplus_commerce_code;
      } else {
        commerceCode = vm.selectedLocation.commerce_code;
        webpayplusCommerceCode = vm.selectedLocation.webpayplus_commerce_code;
      }
      vm.commerceCode = commerceCode;
      vm.webpayplusCommerceCode = webpayplusCommerceCode;
      return commerceCode !== null && commerceCode !== '';
    }

    function selectQuestion(location) {
      if (location) {
        vm.selectedLocation = location;
        locationChanged(vm.selectedLocation);
        onlinePaymentEnabled();
        vm.InitInscriptionSubmitButton = initInscriptionUrl();
      }
    }

    function initInscriptionUrl() {
      $localStorage.how = vm.how;
      $localStorage.selectedLocationId = vm.selectedLocationId;

      var restaurant_id = currentRestaurantID();
      var customer_id = vm.customer ? vm.customer.id : '';
      var params = "?restaurant_id=" + restaurant_id + "&customer_id=" + customer_id;
      vm.inscriptionUrl = env.API_URL + 'webpays/init_inscription' + params;
    }

    function goToInscriptionbWebpay() {
      Promise.all([validateState()])
        .then(function (result) {
          if (result[0] !== false) document.location.href = vm.inscriptionUrl;
        });
    }

    function openKushkiInscription() {
      kushki.openModalInscriptionKushkiCard();
    }

    function sendToPaymentPortal() {
      if (vm.paymentType === "kushki") {
        return sendOrder();
      }
      if (vm.paymentType === 'webpayplus' || vm.paymentType === 'oneclick') {
        getCommerceCode();
      }
      if (vm.scheduledOrderDateTime != null) {
        api.orders
          .validateSchedule(order())
          .then(function () {
            proceedToPayment();
          })
          .catch(function (error) {
            ngNotify.set(error.data.message, "error");
          });
      } else {
        proceedToPayment();
      }

      function proceedToPayment() {
        vm.inProgress = true;
        var couponId = $localStorage.currentCustomerCoupon
          ? $localStorage.currentCustomerCoupon.coupon.id
          : null;
        var couponCustomerId = $localStorage.currentCustomerCoupon
          ? $localStorage.currentCustomerCoupon.id
          : null;
        var addressId = cart.isDelivery ? vm.selectedLocationId : null;
        var restaurantId = cart.isDelivery ? null : vm.selectedLocationId;
        $localStorage.order = order();
        api.payment_gateway
          .generate_charge_by_payment_portal({
            payment_attempt: {
              gateway_name: "transbank",
              commerce_code: vm.webpayplusCommerceCode,
              amount_cents: vm.totalPay,
              coupon_id: couponId,
              customer_id: vm.customer.id,
              coupon_customer_id: couponCustomerId,
              address_id: addressId,
              restaurant_id: restaurantId,
              scheduled_datetime: vm.scheduledOrderDateTime,
            },
            order: $localStorage.order,
          })
          .then(function (data) {
            window.location.href = data.url;
          })
          .catch(function (error) {
            ngNotify.set(error.data.message, "error");
          })
          .finally(function () {
            vm.inProgress = false;
          });
      }
    }

    function currentRestaurantID() {
      var restaurant_id = '';
      if (cart.isDelivery) {
        var selectedAddress = _.find(vm.addressLocations, function (address) {
          return vm.selectedLocationId == address.id;
        });
        if (selectedAddress) restaurant_id = selectedAddress.assigned_restaurant.id;
      } else {
        restaurant_id = vm.selectedLocationId;
      }
      return restaurant_id;
    }

    function setPreviousState() {
      if (!_.isEmpty($auth.user)) {
        getTbkUser($auth.user["id"]).then(function (tbk_users) {
          vm.tbkUsers = tbk_users;
          var storedCardId = $localStorage.selectedCreditCard;
          var storedCard = storedCardId ? cart.findTbkCard(vm.tbkUsers, storedCardId) : null;
          vm.tbkUser = storedCard || vm.tbkUsers[0];
          vm.selectCreditCard(vm.tbkUser ? vm.tbkUser.id : null);
          if (vm.tbkUser) setCardPaymentMethod();
          if ($localStorage.how) {
            vm.how = $localStorage.how;
            if ($localStorage.selectedLocationId && (vm.how == vm.deliveryText || hasPersistedPickupSelection())) {
              vm.selectedLocationId = $localStorage.selectedLocationId;
              if (vm.how == vm.deliveryText) {
                cart.isDelivery = true;
                if (vm.addressLocations.length > 0) {
                  if (vm.customer.orders_count > 0 || ['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance)) {
                    var includeClosed = vm.scheduleOrderPref;
                    if (['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance)) { includeClosed = true; }
                    findSelectedAddress(vm.addressLocations, includeClosed);
                  } else {
                    vm.selectedLocation = null;
                  }
                } else {
                  vm.selectedLocation = null;
                }
                addDelivery(true);
              }
              if (vm.how == vm.pickupText) {
                cart.isDelivery = false;
                if (vm.pickupRestaurants.length > 0) {
                  if (vm.customer.orders_count > 0 || ['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance)) {
                    var includeClosed = vm.scheduleOrderPref;
                    if (['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance)) { includeClosed = true; }
                    findSelectedRestaurant(vm.pickupRestaurants, includeClosed);
                  } else {
                    vm.selectedLocation = null;
                  }
                } else {
                  vm.selectedLocation = null;
                }
                addDelivery(false);
              }
              locationChanged(vm.selectedLocation);
              selectLocation();
              selectQuestion(vm.selectedLocation);
              onlinePaymentEnabled();
              if (!!vm.tbkUser && vm.onlinePaymentOn) {
                vm.paymentType = setDefaultPaymentType();
                if ($localStorage.modalInstance == 'paymentMethodModal') {
                  vm.paymentTypeModal = vm.paymentType;
                }
                if (['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance)) {
                  vm.scheduledOrderModal = vm.scheduledOrder;
                }
                setDefaultTip();
              }
              calculateTotals();
            }
          }
          setInscriptionButton();
        });
      }
    }

    function getTbkUser(customer_id) {
      return api.tbkuser.all(customer_id)
        .then(function (tbk_user) {
          return tbk_user;
        });
    }

    function getPaymentCards() {
      return api.payment_gateway
        .get_payment_cards()
        .then(function (response) {
          vm.paymentCards = response.payment_cards || [];
          if (vm.country === 'MX') {
            if (vm.paymentCards.length > 0) {
              vm.kushkiCard = vm.paymentCards[0];
              vm.selectedCardToken = vm.kushkiCard.token;
              vm.selectedCardId = vm.kushkiCard.id;
              if (!vm.paymentType) {
                vm.paymentType = 'kushki';
              }
            } else {
              vm.kushkiCard = null;
              vm.selectedCardToken = null;
              vm.selectedCardId = null;
              vm.paymentType = null;
            }
          } else {
            vm.kushkiCard = null;
            vm.selectedCardToken = null;
            vm.selectedCardId = null;
          }
        })
        .catch(function (err) {
          console.error(err);
        });
    }

    function hasDeliveryPickup(firstRestaurants, restaurants, howType) {
      if (vm.scheduleOrderPref) return true;

      var filters = { is_open: true }
      if (howType === vm.deliveryText) { $.extend({}, { is_delivery: true }, filters); }
      if (howType === vm.pickupText) { $.extend({}, { is_pickup: true }, filters); }
      var openRestaurants = firstRestaurants.concat(restaurants);
      var deliveryPickupCount = _.filter(openRestaurants, filters).length;

      return deliveryPickupCount > 0;
    }

    function getOpenRestaurants() {
      if (vm.how == vm.pickupText) addDelivery(false);
      vm.showNewAddressBtn = false;
      vm.pickupRestaurants = [];
      var customerAddress = api.addresses.getCurrent();
      var restaurantsPromise;
      if (
        vm.how === vm.pickupText &&
        customerAddress &&
        customerAddress.id
      ) {
        restaurantsPromise = api.restaurants.byCustomerAddress(customerAddress.id);
      } else {
        restaurantsPromise = api.restaurants.all(true, true);
      }
      return restaurantsPromise
        .then(function (restaurants) {
          var correctGroupRestaurants = _.filter(restaurants, { restaurant_group_is_correct: true });
          var firstRestaurants = correctGroupRestaurants.slice(0, 3);
          var remainingCorrectRestaurants = correctGroupRestaurants.slice(3);
          var incorrectGroupRestaurants = _.filter(restaurants, { restaurant_group_is_correct: false });
          restaurants = _.sortBy(restaurants, 'comune_name');
          restaurants = restaurants.sort(function (a, b) {
            return Number(b.is_open) - Number(a.is_open);
          });
          restaurants = restaurants.sort(function (a, b) {
            return Number(b.restaurant_group_is_correct) - Number(a.restaurant_group_is_correct);
          });
          var openRestaurants = firstRestaurants.concat(remainingCorrectRestaurants).concat(incorrectGroupRestaurants);
          vm.pickupRestaurants = _.filter(openRestaurants, { is_pickup: true });
          vm.hasPickup = hasDeliveryPickup(firstRestaurants, restaurants, vm.pickupText);
          vm.hasDelivery = hasDeliveryPickup(firstRestaurants, restaurants, vm.deliveryText);
          vm.isClosed = openRestaurants.length === 0;
          vm.isOpenPickup = true;
          if (vm.how == vm.pickupText) {
            if (vm.pickupRestaurants.length > 0 && vm.customer.orders_count > 0) {
              findSelectedRestaurant(vm.pickupRestaurants, vm.scheduleOrderPref);
            } else {
              vm.selectedLocation = null;
            }
            locationChanged(vm.selectedLocation);
            selectLocation();
            selectQuestion(vm.selectedLocation);
            onlinePaymentEnabled();
            if (!!vm.tbkUser && vm.onlinePaymentOn) {
              vm.paymentType = setDefaultPaymentType();
              if ($localStorage.modalInstance == 'paymentMethodModal') {
                vm.paymentTypeModal = vm.paymentType;
              }
              if (['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance)) {
                vm.scheduledOrderModal = vm.scheduledOrder;
              }
              setDefaultTip();
            }
          }
          return restaurants;
        })
        .then(function () {
          vm.showNewAddressBtn = true;
        });
    }

    function price(item, applyDiscount) {
      return cart.price(item.id, applyDiscount, item.seleable.type, item.extraPrice);
    }

    function handlePickupDelivery(type) {
      vm.selectedLocation = null;
      vm.selectedLocationId = null;
      $localStorage.scheduledOrder = vm.now;
      if (type == vm.pickupText) {
        delete $localStorage.selectedLocationId;
        $localStorage.pickupSelectedFromModal = false;
      }

      $rootScope.$broadcast('checkout:how', type);
      getSelectedLocation();
      cart.setDefaultDiscount();

      $timeout(function () {
        updateSkeleton(false);
      }, 800);
    }

    function handlePickupDeliveryModal(type) {
      vm.selectedLocation = null;
      vm.selectedLocationId = null;
      $localStorage.scheduledOrder = vm.now;
      if (type == vm.pickupText) {
        delete $localStorage.selectedLocationId;
        $localStorage.pickupSelectedFromModal = false;
      }
      vm.how = type;
    }

    function getSelectedLocation() {
      if (vm.how == vm.deliveryText) {
        addDelivery(true);
        if (vm.addressLocations.length > 0) {
          vm.selectedLocation = validateAddress(vm.addressLocations[0], null, true);
        } else {
          vm.selectedLocation = null;
        }
      }
      if (vm.how == vm.pickupText) {
        addDelivery(false);
        if (vm.pickupRestaurants.length > 0 && vm.customer.orders_count > 0) {
          var findRestaurantLocations = _.find(vm.pickupRestaurants, isPreselectedPickupRestaurant);
          vm.selectedLocation = !!findRestaurantLocations ? validateRestaurant(findRestaurantLocations, null, true) : null;
        } else {
          vm.selectedLocation = null;
        }
      }
      $rootScope.$broadcast('location:changed', vm.selectedLocation);
      selectLocation();
      selectQuestion(vm.selectedLocation);
      onlinePaymentEnabled();
      if (!!vm.tbkUser && vm.onlinePaymentOn) {
        vm.paymentType = setDefaultPaymentType();
        if ($localStorage.modalInstance == 'paymentMethodModal') {
          vm.paymentTypeModal = vm.paymentType;
        }
        if (['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance)) {
          vm.scheduledOrderModal = vm.scheduledOrder;
        }
        setDefaultTip();
      }
    }

    function validateAddress(location, elseResponse, includeClosed) {
      var isValid = false;

      if (includeClosed) {
        isValid = location.assigned_restaurant_group_is_correct;
      } else {
        isValid = location.assigned_restaurant_is_open && location.assigned_restaurant_group_is_correct;
      }

      return isValid ? location : elseResponse;
    }

    function validateRestaurant(location, elseResponse, includeClosed) {
      var isValid = false;

      if (includeClosed) {
        isValid = location.restaurant_group_is_correct;
      } else {
        isValid = location.is_open && location.restaurant_group_is_correct;
      }

      return isValid ? location : elseResponse;
    }

    function updatedDiscount(discount) {
      if (discount !== vm.DEFAULT_DISCOUNT_1 && discount !== vm.DEFAULT_DISCOUNT_2 && discount !== 0) {
        throw new Error('Descuento no válido: ' + discount);
      }
      setDefaultTip();
      cart.setDiscount(discount / 100);
      calculateTotals();
      setInscriptionButton();
    }

    function setInscriptionButton() {
      vm.initInscriptionButton = false;

      if (vm.paymentType == "webpay" && !!vm.tbkUser && vm.onlinePaymentOn) {
        vm.initInscriptionButton = false;
      }
      if (vm.paymentType == 'webpay' && !vm.tbkUser && vm.onlinePaymentOn) {
        vm.initInscriptionButton = true;
      }
    }

    function paymentTypeSupportsTips(paymentType) {
      if (!paymentType) {
        return false;
      }
      if (vm.paymentType === 'kushki') {
        return true;
      }
      var config = vm.paymentTypes && vm.paymentTypes[paymentType];
      if (!config || typeof config.tip === 'undefined') {
        return true;
      }

      return config.tip;
    }

    function canUseTips() {
      if (vm.how !== vm.deliveryText || !cart.isDelivery) {
        return false;
      }

      if (!paymentTypeSupportsTips(vm.paymentType)) {
        return false;
      }

      if (vm.paymentType === 'oneclick') {
        return !!vm.tbkUser && vm.onlinePaymentOn;
      }

      if (vm.paymentType === 'webpayplus') {
        return vm.onlinePaymentOn;
      }

      return true;
    }

    function showTips() {
      return canUseTips();
    }

    function toggleSwitch(itemId) {
      var item = api.additionalProducts.get(itemId)
      cart.additionalProduct.set(item);
      calculateTotals();
      vm.additionalItems = cart.additionalItems();
    }

    function showAdditionalItem(item) {
      if (vm.additionalItems.length == 1) return item.quantity + ' ' + item.name;

      var penultimateItem = getPositionItem(item, -2);
      var lastItem = getPositionItem(item, -1);

      if (lastItem) {
        return 'y ' + item.quantity + ' ' + item.name;
      } else if (penultimateItem) {
        return item.quantity + ' ' + item.name;
      } else {
        return item.quantity + ' ' + item.name + ', ';
      }
    }

    function getPositionItem(item, position) {
      return item.id === vm.additionalItems[vm.additionalItems.length - Math.abs(position)].id;
    }

    function order() {
      syncCalculatedAdditionalProducts();
      var order = {
        order_products: [],
        order_promotions: [],
        additional_products: [],
        discount: cart.discount() * 100,
        delivery_cost: vm.deliveryAmount
      };

      _.each(cart.products(true), function (item) {
        var orderItem = {};
        orderItem.quantity = item.quantity;

        if (item.seleable.type === 'products') {
          orderItem.modifiable = item.modifiable;
          orderItem.product_id = item.id;
          orderItem.product_options = item.options;

          if (item.seleable.additional_type) {
            order.additional_products.push(orderItem);
          }

          order.order_products.push(orderItem);
        } else if (item.seleable.type === 'promotions') {
          orderItem.promotion_id = item.id;
          orderItem.order_products = [];
          orderItem.promotion_product_groups = [];
          var promoProductGroups = item.seleable.promotion_product_groups;
          _.each(promoProductGroups, function (promoProductGroup, promoProductGroupIndex) {
            var products = promoProductGroup.products;
            var promotionProducts = [];
            orderItem.promotion_product_groups[promoProductGroupIndex] = { id: promoProductGroup.id };
            _.each(products, function (product, productIndex) {
              if (!item.options[promoProductGroup.id][product.id].selected) return;
              var orderProduct = {};
              orderProduct.product_id = product.id;
              orderProduct.product_options = item.options[productIndex];
              promotionProducts.push(orderProduct);
            });
            orderItem.promotion_product_groups[promoProductGroupIndex].promotion_products = promotionProducts;
          });
          order.order_promotions.push(orderItem);
        }
      });

      order.customer = {
        id: vm.customer.id
      };
      if (cart.isDelivery) {
        order.order_type = 'Delivery';
        order.address_id = vm.selectedLocationId;
        order.restaurant_id = null;
      } else {
        order.order_type = 'Retiro';
        order.restaurant_id = vm.selectedLocationId;
        order.address_id = null;
      }
      if (vm.paymentType === "kushki") {
        order.payment_type = "Kushki";
        order.subcription_card_token = vm.selectedCardToken;
      }
      if (vm.paymentType === "oneclick" && vm.tbkUser) {
        order.payment_type = mapPaymentTypeForOrder(vm.paymentType);
        order.tbk_user_id = vm.tbkUser.id;
      } else if (vm.paymentType) {
        order.payment_type = mapPaymentTypeForOrder(vm.paymentType);
      }
      if (cart.isDelivery && canUseTips() && vm.selectedTip.amount) {
        order.tip_amount = vm.selectedTip.amount;
      }
      order.coupon_id = $localStorage.currentCustomerCoupon ? $localStorage.currentCustomerCoupon.coupon.id : null;
      order.coupon_customer_id = $localStorage.currentCustomerCoupon ? $localStorage.currentCustomerCoupon.id : null;
      order.scheduled_datetime = vm.scheduledOrderDateTime;

      return order;
    }

    function sendOrder() {
      if (vm.scheduledOrderDateTime != null) {
        api.orders.validateSchedule(order())
          .then(function () {
            proceedToPayment();
          })
          .catch(function (error) {
            ngNotify.set(error.data.message, 'error');
          });
      } else {
        proceedToPayment();
      }

      function proceedToPayment() {
      vm.inProgress = true;
      api.orders.save(order())
        .then(function (info) {
          if (vm.paymentType == 'webpay') {
            vm.processingWebPayment = true;
            return authorizePayment(info);
          }
          if (vm.paymentType === "oneclick") {
            vm.processingWebPayment = true;
            return authorizePayment(info);
          }
          else if (vm.paymentType === "kushki") {
            return kushki.kushkiGenerateCharge({
              cardId: vm.selectedCardId,
              subscriptionId: vm.selectedCardToken,
              orderId: info.id
            }).then(function () {
              if (vm.currentCoupon) coupon.removeCurrentCoupon();
              goToSuccess(info);
            });
          }
          else if (vm.paymentType === 'pluxee') {
            vm.pendingPluxeeOrderInfo = info;
            vm.processingWebPayment = true;
            return createPluxeePaymentIntent(info);
          } else if (vm.paymentType === 'webpayplus') {
            return;
          } else if (vm.paymentType === "amipass") {
            return processAmipassPayment(info);
          } else {
            if (vm.currentCoupon) coupon.removeCurrentCoupon();
            goToSuccess(info);
          }
          return info;
        }, function (info) {
          $log.error(info);
          var message = _.get(info, 'data.message', _.get(info, 'data.error', 'Hubo un error. Carga de nuevo la página e inténtalo nuevamente.'));
          var code = message.split(':')[0];
          message = message.split(':')[1];
          var status = _.get(info, 'data.status');
          if (code.includes('410')) {
            message = 'Unos de los productos que elegiste ya no se encuentra disponible. Hemos actualizado tu carro.';
            ngNotify.set(message, 'error');
            hero.setAnalyticsClass('perm-error-product-not-available');
            return $state.go('checkout', {}, { reload: true });
          }
          if (code.includes('420')) return showCouponError(message);
          if (status === 430) {
            ngNotify.set(message, 'error');
            return;
          }
          ngNotify.set(message, 'error');
          hero.setAnalyticsClass('perm-server-error-notify');
          return info;
        })
        .finally(function (info) {
          vm.inProgress = false;
          api.prefs.all(true);
          return info;
        });
      }
    }

    function processAmipassPayment(info) {
      vm.inProgress = true;
      var amount = Number(vm.totalPay);
      var paymentIntentPayload = {
        payment_method: "amipass",
        amount: amount,
        order_id: info.id,
        metadata: {
          email: vm.customer && vm.customer.email ? vm.customer.email : "",
          order_id: info.id,
        },
      };

      return api.payment_gateway
        .generate_charge_by_amipass(paymentIntentPayload)
        .then(function (response) {
          var data = response.data;
          var url = data.url;
          if (url) {
            window.location.href = url;
          } else {
            ngNotify.set("No se recibió URL de pago Amipass", "error");
          }
          return response;
        })
        .catch(function (error) {
          ngNotify.set(error.data.error, "error");
          return $q.reject(error);
        })
        .finally(function () {
          vm.inProgress = false;
        });
    }

    function createPluxeePaymentIntent(info) {
      vm.pluxeePaymentIntent = null;
      vm.pluxeeQrImage = null;
      vm.pluxeeCode = null;

      var paymentIntentPayload = {
        payment_method: 'pluxee',
        amount: info['total_to_pay'],
        merchant_id: '1338',
        order_id: info['id']
      };
      vm.pluxeeStatusReadNotified = false;
      vm.pluxeeMerchantId = paymentIntentPayload.merchant_id;

      if (paymentIntentPayload.amount == null || paymentIntentPayload.order_id == null) {
        vm.processingWebPayment = false;
        ngNotify.set('No pudimos preparar el pago Pluxee. Intenta nuevamente.', 'error');
        return $q.reject(paymentIntentPayload);
      }

      return api.paymentIntents.create(paymentIntentPayload)
        .then(function (response) {
          vm.pluxeePaymentIntent = response.data || {};
          vm.pluxeePollEndsAt = Date.now() + (2 * 60 * 1000); // 2 minutes
          var qrCodeString = _.get(response, 'data.qr_code');
          if (!qrCodeString) {
            vm.processingWebPayment = false;
            ngNotify.set('No pudimos generar el código QR de Pluxee. Intenta nuevamente.', 'error');
            return $q.reject(response);
          }
          return buildQrCodeImage(qrCodeString)
            .then(function (qrImage) {
              vm.pluxeeQrImage = qrImage;
              vm.pluxeeCode = _.get(response, 'data.num_code');
              vm.processingWebPayment = false;
              startPluxeePolling();
              scrollToPluxeeQr();
              return response;
            })
            .catch(function (qrError) {
              vm.processingWebPayment = false;
              ngNotify.set('No pudimos construir el QR de Pluxee. Intenta nuevamente.', 'error');
              return $q.reject(qrError);
            });
        })
        .catch(function (error) {
          vm.processingWebPayment = false;
          var message = _.get(error, 'data.message',
            'Hubo un problema generando el pago Pluxee. Intenta nuevamente.'
          );
          ngNotify.set(message, 'error');
          hero.setAnalyticsClass('perm-error-processing-payment');
          return $q.reject(error);
        });
    }

    function cancelPluxeeQr() {
      vm.pluxeePaymentIntent = null;
      vm.pluxeeQrImage = null;
      vm.pluxeeCode = null;
      vm.pluxeeMerchantId = null;
      vm.pluxeeStatusReadNotified = false;
      vm.pluxeeStatusRequestInFlight = false;
      stopPluxeePolling();
      vm.processingWebPayment = false;
    }

    var qrLibPromise = null;

    function scrollToPluxeeQr() {
      // Scroll to the QR amount section so the user sees the QR immediately
      $timeout(function () {
        var el = $document[0].querySelector('.pluxee-qr-amount');
        if (!el) return;
        if (typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          el.focus();
        }
      }, 0, false);
    }

    function startPluxeePolling() {
      stopPluxeePolling();
      var orderId = _.get(vm, 'pendingPluxeeOrderInfo.id') ||
        _.get(vm, 'pendingPluxeeOrderInfo.order_id');
      var merchantId = vm.pluxeeMerchantId || _.get(vm, 'pluxeePaymentIntent.merchant_id');
      var paymentMethod = 'pluxee';
      if (!orderId || !merchantId) return;

      vm.pluxeePollPromise = $interval(function () {
        if (vm.pluxeePollEndsAt && Date.now() > vm.pluxeePollEndsAt) {
          console.log("pool: "+ vm.pluxeePollEndsAt + ", current: "+ Date.now())
          stopPluxeePolling();
          vm.processingWebPayment = false;
          ngNotify.set('No pudimos confirmar el pago Pluxee a tiempo. Intenta nuevamente.', 'error');
          return;
        }
        if (vm.pluxeeStatusRequestInFlight) {
          return;
        }
        vm.pluxeeStatusRequestInFlight = true;
        api.paymentIntents.status({
          id: orderId,
          payment_method: paymentMethod,
          merchant_id: merchantId
        })
          .then(function (statusResponse) {
            var status = _.get(statusResponse, 'data.status') || _.get(statusResponse, 'status');
            var statusLabel = (_.get(statusResponse, 'data.status_label') || '').toLowerCase();
            console.log("Status: " + status + "Label: " + statusLabel)
            console.log(statusResponse)
            if (!status) return;
            var statusCode = ('' + status).toUpperCase();

            var normalized = (function () {
              var codeMap = { 'A': 'approved', 'R': 'read', 'C': 'canceled', 'D': 'denied' };
              if (codeMap[statusCode]) return codeMap[statusCode];
              var labelMap = { approved: 'approved', read: 'read', canceled: 'canceled', denied: 'denied' };
              return labelMap[statusLabel];
            })();

            if (normalized === 'approved') {
              stopPluxeePolling();
              if (vm.currentCoupon) coupon.removeCurrentCoupon();
              var pluxeeOrderId = _.get(vm, 'pendingPluxeeOrderInfo.id') || _.get(vm, 'pendingPluxeeOrderInfo.order_id');
              return api.orders.get(pluxeeOrderId).then(function (order) {
                goToSuccess(order);
              }).catch(function () {
                goToSuccess(vm.pendingPluxeeOrderInfo || {});
              });
            }

            if (normalized === 'read') {
              if (!vm.pluxeeStatusReadNotified) {
                vm.pluxeeStatusReadNotified = true;
                ngNotify.set('Estamos esperando la aprobación en tu app Pluxee.', 'info');
              }
              return;
            }

            if (normalized === 'canceled' || normalized === 'denied') {
              stopPluxeePolling();
              vm.processingWebPayment = false;
              var label = statusLabel || normalized || 'cancelado';
              var errorDetail = _.get(statusResponse, 'data.error') || _.get(statusResponse, 'error');
              var message = 'El pago Pluxee fue ' + label + '. Puedes intentar nuevamente.';
              if (errorDetail) {
                message = 'El pago Pluxee fue ' + label + '. ' + errorDetail;
              }
              ngNotify.set(message, 'error');
              cancelPluxeeQr();
            }
          })
          .catch(function (err) {
            // Si la API responde con error (422 u otro), detenemos y avisamos
            var msg = 'Ocurrió un problema al procesar el pago Pluxee. ';
            msg += _.get(err, 'data.data.message') || _.get(err, 'data.data.error') ||  'Intente nuevamente mas tarde.'
            stopPluxeePolling();
            vm.processingWebPayment = false;
            ngNotify.set(msg, 'error');
            cancelPluxeeQr();
          })
          .finally(function () {
            vm.pluxeeStatusRequestInFlight = false;
          });
      }, 3000, 0, false);
    }

    function stopPluxeePolling() {
      if (vm.pluxeePollPromise) {
        $interval.cancel(vm.pluxeePollPromise);
        vm.pluxeePollPromise = null;
      }
      vm.pluxeePollEndsAt = null;
    }

    function loadQrLib() {
      if (window.qrcode) return $q.when(window.qrcode);
      if (qrLibPromise) return qrLibPromise;

      var deferred = $q.defer();
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/qrcode-generator@1.4.4/qrcode.min.js';
      script.onload = function () {
        if (window.qrcode) {
          deferred.resolve(window.qrcode);
        } else {
          deferred.reject(new Error('QR library did not initialize'));
        }
      };
      script.onerror = function () {
        deferred.reject(new Error('QR library failed to load'));
      };
      document.head.appendChild(script);

      qrLibPromise = deferred.promise;
      return qrLibPromise;
    }

    function buildQrCodeImage(qrCode) {
      if (!qrCode) return $q.reject(new Error('QR data missing'));

      return loadQrLib().then(function (qrcode) {
        var qr = qrcode(0, 'H');
        qr.addData(qrCode);
        qr.make();
        return qr.createDataURL(6, 0);
      });
    }

    function authorizePayment(info) {
      var params = {
        order_id: info["id"],
        total_amount: vm.totalPay,
        restaurant_id: info["restaurant_id"],
        tbk_user_id: info["tbk_user_id"],
        customer_id: vm.customer.id
      };

      return api.webpay.authorize(params)
        .then(function (response) {
          vm.processingWebPayment = false;
          if (response["payment_status"]) {
            info = _.extend(info, { webpayment: response.webpayment });
            delete $localStorage.currentCustomerCoupon;
            var msg = 'Tu pago se realizó con éxito.';
            ngNotify.set(msg, 'info');
            hero.setAnalyticsClass('perm-success-processing-payment');
            goToSuccess(info);
          } else {
            $log.error(info);
            var message = _.get(info, 'data.message',
              'Hubo un problema procesando tu pago. Intenta nuevamente.'
            );
            var msg = 'Hubo un problema procesando tu pago. Intenta nuevamente.';
            ngNotify.set(msg, 'error');
            hero.setAnalyticsClass('perm-error-processing-payment');
          }
          return info;
        });
    }

    function goToSuccess(info) {
      _orderCompleted = true;
      if (_checkCartDebounce) $timeout.cancel(_checkCartDebounce);
      vm.loadingTotals = false;
      if (!cart.isDelivery) {
        delete $localStorage.selectedLocationId;
        $localStorage.pickupSelectedFromModal = false;
      }
      $localStorage.lastPaymentType = vm.paymentType;
      vm.items.forEach(removeAll);
      getTracking(info);
    }

    function buildRangeScheduledOrder() {
      if (!scheduledOrderActivated()) return [];

      var rangeScheduledOrderInitialArray = $localStorage.scheduledOrderDateTimeLabel.split(' - ');
      var rangeScheduledOrder = [];
      rangeScheduledOrder.push(rangeScheduledOrderInitialArray[rangeScheduledOrderInitialArray.length - 1]);
      rangeScheduledOrder.push(rangeScheduledOrderInitialArray[rangeScheduledOrderInitialArray.length - 2]);
      return rangeScheduledOrder;
    }

    function getTracking(info) {
      return api.prefs.all()
      .then(function() {
        var tracking = api.prefs.get('tracking');
        var restaurant = _.find(vm.pickupRestaurants, function(restaurant) {
          return restaurant.id == info["restaurant_id"];
        });
        if (tracking.value == 'true' && !!restaurant && restaurant.tracker_active) {
          $state.go('tracking', { 'orderId': info["id"] });
        } else {
          var buildRangeScheduledOrderResp = buildRangeScheduledOrder();
          $state.go('order.success', { order: info, rangeScheduledOrder: buildRangeScheduledOrderResp });
        }
      });
    }

    function updateSkeleton(show) {
      vm.skeletonShow = show;
    }

    function showCouponError(message) {
      var errorMessage = message.split(':')[1];
      ngNotify.set(errorMessage, 'error');
      hero.setAnalyticsClass('perm-server-error-notify');
      delete $localStorage.currentCustomerCoupon;
      vm.currentCoupon = null;
      return $state.go('checkout', {}, { reload: true });
    }

    function showOptions(item) {
      var options = item.options || {};
      if (item.type == "promotions") {
        var promotionProductGroups = item.seleable.promotion_product_groups;
        return _.map(promotionProductGroups, function (promotionProductGroup) {
          var products = promotionProductGroup.products;
          var selections = _.map(products, function (product, productIndex) {
            if (!options[promotionProductGroup.id] ||
              !options[promotionProductGroup.id][product.id] ||
              !options[promotionProductGroup.id][product.id].selected)
              return;
            var name = product.name,
              productOptions = _.extend({}, (options[productIndex] || {}), product.extras);
            if (!_.isEmpty(productOptions)) {
              name += ' (' + _.values(productOptions).join(', ') + ')';
            }
            return name;
          }).filter(function (el) {
            return el != undefined;
          });
          if (promotionProductGroup.items_limit > 0) {
            return promotionProductGroup.name + ": " + selections.join(', ');
          } else {
            return selections.join(', ');
          }
        });
      } else if (item.modifiable) {
        var productGroups = item.seleable.modifier_groups;
        return _.map(productGroups, function (productGroup) {
          if (!options[productGroup.id]) return;
          var groupName = productGroup.name,
            groupCategories = productGroup.modifier_group_categories;
          var selections = _.map(groupCategories, function (groupCategory) {
            var groupVariants = groupCategory.modifier_group_variants;
            return _.map(groupVariants, function (groupVariant) {
              var variantId = groupVariant.variant.id,
                variantName = groupVariant.variant.name;
              return _.map(options[productGroup.id], function (productGroupOption) {
                var productId = Object.keys(productGroupOption)[0],
                  variantQuantity = productGroupOption[productId].quantity;
                if (productId !== variantId) return;
                return variantName + (variantQuantity > 1 ? " (x" + variantQuantity + ")" : "");
              }).filter(function (el) {
                return el != undefined;
              });
            }).filter(function (el) {
              return el.length;
            });
          });
          return groupName + ": " + selections.join(',').split(',').join(', ');
        });
      } else {
        return _.map(_.extend({}, options, item.seleable.extras), function (value, key) {
          return key + ': ' + value;
        });
      }
    }

    function checkedTip(tip) {
      if (tip.default) selectTip(tip);
    }

    function selectTip(tip) {
      vm.selectedTip = tip;
      calculateTotals();
    }

    function showDetails() {
      var itemsDetails = document.querySelector('#checkout-items-details');
      if (itemsDetails.classList.contains('hide')) {
        itemsDetails.classList.remove('hide');
        vm.openDetails = true;
      } else {
        itemsDetails.classList.add('hide');
        vm.openDetails = false;
      }
    }

    function hideLocationModal(where, index, hideAll) {
      var querySelector = '.checkout-delivery-pickup-location';
      if (!hideAll) querySelector += ':not(#checkout-' + where + '-' + index + '-container' + ')';
      changeClassLocation(querySelector, 'hide', 'add');
    }

    function showLocationModal() {
      var querySelector = '.checkout-delivery-pickup-location.hide';
      changeClassLocation(querySelector, 'hide', 'remove');
    }

    function changeLocationElement(where, request) {
      var querySelector = '#checkout-click-change-' + where;
      changeClassLocation(querySelector, 'hide', request);
    }

    function changeClassLocation(querySelector, className, request) {
      var nodeList = document.querySelectorAll(querySelector);
      nodeList.forEach(function (element) {
        if (request === 'add') element.classList.add(className);
        if (request === 'remove') element.classList.remove(className);
      })
    }

    function localeWhenHowHere() {
      if (env.LOCALE == 'es-cl') {
        vm.localePickup = 'Retiro';
        vm.localeDelivery = 'Despacho';
      }
      if (env.LOCALE == 'es-mx') {
        vm.localePickup = 'Pick up';
        vm.localeDelivery = 'Delivery';
      }
    }

    function buildScheduledDayOptions() {
      var assignedRestaurantId = vm.getLocationRestaurantId();
      var bodyParameters = {
        numberOfDays: vm.scheduleOrderConf['number_of_days'],
        startMinutesAfterOpenToday: vm.scheduleOrderConf['start_minutes_after_open_today'],
        startMinutesAfterOpen: vm.scheduleOrderConf['start_minutes_after_open'],
        endsMinutesAfterOpen: vm.scheduleOrderConf['ends_minutes_after_open'],
        minutesInterval: vm.scheduleOrderConf['minutes_interval']
      }
      api.restaurants.availablesSchedules(assignedRestaurantId, bodyParameters, 'select')
        .then(function (availablesDays) {
          vm.scheduledDayOptions = availablesDays;
        })
        .finally(function () {
          vm.scheduledDayOptions = _.map(vm.scheduledDayOptions, function (scheduledDayOption) {
            return $.extend({}, scheduledDayOption, { forSchedule: true });
          })

          if (vm.selectedLocationIsOpen()) {
            vm.scheduledDayOptions.unshift({
              id: vm.nowTextByDefault,
              day: vm.nowTextByDefault,
              forSchedule: false
            });
          }
        })
        .catch(function (err) {
          console.error('err: ', err);
          ngNotify.set('No podemos obtener la información en este momento. Intenta más tarde.', 'error');
        });
    }

    function updateDataScheduledorder() {
      if (!['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance)) {
        // Clear variables
        vm.selectedDateTime = null;
        vm.scheduledOrderDateTime = null;
        $localStorage.scheduledOrderDateTime = vm.scheduledOrderDateTime;
        vm.scheduledDayOptions = [];
        vm.scheduledOrderDateTimeLabel = $localStorage.scheduledOrderDateTimeLabel ? $localStorage.scheduledOrderDateTimeLabel : null;
        delete $localStorage.scheduledOrderDateTimeLabel;
        vm.scheduledOrder = $localStorage.scheduledOrder ? $localStorage.scheduledOrder : vm.now;
        delete $localStorage.scheduledOrder;
      }
    }

    function updateStateScheduledOrder(selectOptionForSchedule, selectOptionDay) {
      vm.scheduledOrder = selectOptionForSchedule ? vm.scheduled : vm.now
      $localStorage.scheduledOrder = vm.scheduledOrder;

      if (selectOptionDay !== vm.nowTextByDefault && selectOptionDay !== vm.scheduledTextByDefault) {
        vm.scheduledOrderDateTimeLabel = selectOptionDay;
        $localStorage.scheduledOrderDateTimeLabel = selectOptionDay;
        buildScheduledTime();
      }
      if (scheduledOrderActivated() && !checkPaymentTypeAllowedScheduledOrder(vm.paymentType)) {
        vm.paymentType = setDefaultPaymentType();
      }

      changeClassLocation('#checkout-scheduled-order-body', 'closed-select', 'add')
      changeClassLocation('#checkout-scheduled-order-body', 'open-select', 'remove')

      changeClassLocation('#select-schedule-order', 'not-visible', 'add')
      changeClassLocation('#select-schedule-order', 'is-visible', 'remove')
    }

    function findSelectedAddress(pickupAddress, includeClosed) {
      var findAddressLocations = _.find(pickupAddress, function (address) {
        if ($localStorage.selectedLocationId) {
          return vm.selectedLocationId == address.id;
        } else {
          return address.selected == true;
        }
      });
      vm.selectedLocation = !!findAddressLocations ? validateAddress(findAddressLocations, null, includeClosed) : null;
    }

    function findSelectedRestaurant(pickupRestaurants, includeClosed) {
      var findRestaurantLocations = _.find(pickupRestaurants, function (restaurant) {
        if (hasPersistedPickupSelection()) {
          return vm.selectedLocationId == restaurant.id;
        } else {
          return isPreselectedPickupRestaurant(restaurant);
        }
      });
      vm.selectedLocation = !!findRestaurantLocations ? validateRestaurant(findRestaurantLocations, null, includeClosed) : null;
    }

    function isPreselectedPickupRestaurant(restaurant) {
      return restaurant.selected == true || restaurant.selected_restaurant == true;
    }

    function hasPersistedPickupSelection() {
      return $localStorage.pickupSelectedFromModal === true && !!$localStorage.selectedLocationId;
    }

    function selectedLocationIsOpen() {
      if (vm.how == vm.pickupText) { return vm.selectedLocation.is_open || false };
      if (vm.how == vm.deliveryText) { return vm.selectedLocation.assigned_restaurant_is_open || false };
    }

    function restaurantAllowsScheduling(restaurant) {
      if (!vm.scheduleOrderPref) { return false; };
      if (!restaurant) return false;

      return restaurant.allows_scheduling || false;
    }

    function canBeActivatedScheduledOrder() {
      if (!vm.scheduleOrderPref) { return false; };

      if (vm.how == vm.pickupText) { return vm.selectedLocation.allows_scheduling || false };
      if (vm.how == vm.deliveryText) { return vm.selectedLocation.assigned_restaurant.allows_scheduling || false };

      return false;
    }

    function scheduledOrderActivated() {
      if (['deliveryPickupModal', 'paymentMethodModal'].includes($localStorage.modalInstance)) {
        return $localStorage.scheduledOrder === vm.scheduled;
      }

      return vm.scheduledOrder === vm.scheduled;
    }

    function buildScheduledTime() {
      if (vm.selectedDateTime === vm.nowTextByDefault || vm.selectedDateTime === vm.scheduledTextByDefault) { return; }

      vm.scheduledOrderDateTime = new Date(vm.selectedDateTime);
      $localStorage.scheduledOrderDateTime = vm.scheduledOrderDateTime;
    }

    function checkPaymentTypeAllowedScheduledOrder(paymentType) {
      if (!isPaymentTypeAllowedByRestaurant(paymentType)) {
        return false;
      }

      if (!scheduledOrderActivated()) {
        return true;
      }
      var config = vm.paymentTypes && vm.paymentTypes[paymentType];
      if (!config) {
        return false;
      }
      if (typeof config.allowSchedule === "boolean") {
        return config.allowSchedule;
      }
      return false;
    }

    function isPaymentTypeAllowedByRestaurant(paymentType) {
      if (paymentType === "amipass") {
        return getSelectedRestaurantPaymentFlag("amipass");
      }
      if (paymentType === "pluxee") {
        return getSelectedRestaurantPaymentFlag("pluxee");
      }
      return true;
    }

    function getSelectedRestaurantData() {
      if (!vm.selectedLocation) {
        return null;
      }
      var restaurant =
        vm.how == vm.deliveryText
          ? vm.selectedLocation.assigned_restaurant
          : vm.selectedLocation;
      if (!restaurant) {
        return null;
      }
      return restaurant;
    }

    function getSelectedRestaurantPaymentFlag(paymentKey) {
      var restaurant = getSelectedRestaurantData();
      if (restaurant && restaurant[paymentKey] === true) {
        return true;
      }
      if (vm.selectedLocation && vm.selectedLocation[paymentKey] === true) {
        return true;
      }
      return false;
    }

    function ensureSelectedPaymentTypeAllowedByRestaurant() {
      if (!vm.paymentType) {
        return;
      }
      if (isPaymentTypeAllowedByRestaurant(vm.paymentType)) {
        return;
      }
      vm.paymentType = setDefaultPaymentType(true);
      if ($localStorage.modalInstance == "paymentMethodModal") {
        vm.paymentTypeModal = vm.paymentType;
      }
    }

    function getLocationRestaurantId() {
      if (vm.how == vm.pickupText) { return vm.selectedLocation.id || null };
      if (vm.how == vm.deliveryText) { return vm.selectedLocation.assigned_restaurant.id || null };
    }

    function scheduledOrderDataIsComplete() {
      if (!scheduledOrderActivated()) return true;
      return vm.scheduledOrderDateTime;
    }

    function toggleScheduleOrderOptions() {
      vm.buildScheduledDayOptions();

      toogleContainerScheduleOrder();
      toogleSelectScheduleOrder();
    }

    function toogleSelectScheduleOrder() {
      var select = document.getElementById('select-schedule-order');
      var classToAddSelect = select.classList.contains('is-visible') ? 'not-visible' : 'is-visible';
      var classToRemoveSelect = select.classList.contains('is-visible') ? 'is-visible' : 'not-visible';
      select.classList.add(classToAddSelect);
      select.classList.remove(classToRemoveSelect);
    }

    function toogleContainerScheduleOrder() {
      var container = document.getElementById('checkout-scheduled-order-body');
      var classToAddContainer = container.classList.contains('closed-select') ? 'open-select' : 'closed-select';
      var classToRemoveContainer = container.classList.contains('closed-select') ? 'closed-select' : 'open-select';
      container.classList.add(classToAddContainer);
      container.classList.remove(classToRemoveContainer);
    }

    function showCouponSection() {
      return vm.environment == 'mxniusushi';
    }

    function validateDiscount() {
      return vm.productDiscountAmount > 0;
    }

    function validateTip() {
      vm.tipModal = vm.tipModal === undefined ? "" : Math.abs(vm.tipModal);
    };


    $scope.$on('$destroy', function () {
      stopPluxeePolling();
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('CouponController', CouponController);

  /* @ngInject */
  function CouponController(coupon, currentCoupon, $uibModalInstance) {
    var vm = this;
    vm.currentCoupon = currentCoupon;

    vm.applyCoupon = applyCoupon;
    vm.removeCoupon = removeCoupon;
    vm.closeModal = closeModal;

    vm.coupon = coupon;

    ////////////////

    function applyCoupon(isMobile) {
      return coupon.applyCoupon(isMobile)
      .then(function(response) {
        if (response) vm.closeModal(response);
      });
    }

    function removeCoupon(response) {
      vm.closeModal(response);
    }

    function closeModal(response) {
      $uibModalInstance.close(response);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('ClientContactController', ClientContactController);

  /* @ngInject */
  function ClientContactController(_, api, customer, env, hero, ngNotify, restaurant, $location, $log, $state, $stateParams) {
    var vm = this;
    vm.customer = customer.get();
    vm.reasons = {};
    vm.origins = {};
    vm.restaurants = {};
    vm.isDisabled = false;
    vm.customForm = $stateParams.form || {};
    vm.locationPath = $location.path();

    vm.submitForm = submitForm;

    vm.envConstants = env;

    activate();
    reasonsAll();
    originsAll();

    ////////////////

    function reasonsAll() {
      return api.client_contact.reasonsAll()
      .then(function(reasons) {
        vm.reasons = reasons;
      });
    }

    function setInfoCustomer(){
      if (!customer.get()) return;

      vm.customForm.email = vm.customer.email;
      vm.customForm.phone = vm.customer.phones[0];
      vm.customForm.first_name = vm.customer.name.split(' ')[0];
      vm.customForm.last_name = vm.customer.name.split(' ')[1];
    }

    function activate() {
      setInfoCustomer();
      vm.customForm.subject = "Contacto recibido";
      vm.customForm.form_type = "contact";
      return api.restaurants.all()
      .then(function(restaurants) {
        var items = restaurants.sort(restaurant.sortArrayRestaurants);
        vm.restaurants = items;
      });
    }

    function submitForm() {
      vm.isDisabled = true;
      var form = vm.customForm;
      api.client_contact.save(form)
      .then(function() {
        $state.go('client-contact-success', { form: form });
        ngNotify.set('Contacto enviado con éxito.', 'info');
        hero.setAnalyticsClass('perm-success-saving-client-contact');
      })
      .catch(function(resp) {
        $log.error(JSON.stringify(resp));
        ngNotify.set('Hubo un problema al enviar el contacto. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-error-saving-client-contact');
        vm.isDisabled = false;
      })
    }

    function originsAll() {
      if (env.ENVIRONMENT == 'niusushi') {
        vm.origins = [env.COMPANY_NAME, 'Pedidos Ya', 'Rappi']
      } else if (env.ENVIRONMENT == 'mxniusushi') {
        vm.origins = [env.COMPANY_NAME, 'Rappi']
      } else {
        vm.origins = [env.COMPANY_NAME, 'Pedidos Ya', 'Uber Eats', 'Rappi']
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("website")
    .controller("AmipassProcessingController", AmipassProcessingController);

  function AmipassProcessingController(
    $stateParams,
    $interval,
    $timeout,
    $state,
    $window,
    api,
    ngNotify,
    env,
    cart,
    coupon,
    $localStorage
  ) {
    var vm = this;

    vm.orderId = $stateParams.order_id;

    if (!vm.orderId) {
      ngNotify.set("No se recibió el identificador de la orden.", "error");
      $state.go("home");
      return;
    }

    var MIN_DISPLAY_TIME = 3000;
    var startTime = Date.now();
    var polling = $interval(checkPaymentStatus, 3000);
    var stateCleared = false;

    function clearCartState() {
      if (stateCleared) return;
      cart.removeAll();
      if ($localStorage.currentCustomerCoupon) {
        coupon.removeCurrentCoupon();
      }
      stateCleared = true;
    }

    function goToSuccess() {
      var elapsed = Date.now() - startTime;

      var go = function () {
        api.orders.get(vm.orderId).then(function (order) {
          $state.go('order.success', { order: order, rangeScheduledOrder: [] });
        }).catch(function () {
          $state.go('process-payment.success_new');
        });
      };

      if (elapsed >= MIN_DISPLAY_TIME) {
        go();
      } else {
        $timeout(go, MIN_DISPLAY_TIME - elapsed);
      }
    }

    function goToError() {
      $interval.cancel(polling);
      $window.location.href = $window.location.origin + "/process-payment/ups";
    }

    function checkPaymentStatus() {
      api.paymentIntents
        .status({
          id: vm.orderId,
          payment_method: "amipass",
          merchant_id: Number(env.AMIPASS_MERCHANT_ID),
        })
        .then(function (response) {
          var data = response && response.data ? response.data : {};
          var status = data.payment_state;
          if (status === "paid") {
            $interval.cancel(polling);
            clearCartState();
            goToSuccess();
            return;
          }
          if (status === "failed" || status === "canceled") {
            goToError();
            return;
          }
        })
        .catch(function (err) {
          console.error("[AMIPASS POLLING ERROR]", err);
        });
    }

    vm.$onDestroy = function () {
      $interval.cancel(polling);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('CartController', CartController)
    .controller('UIModalController', UIModalController);

  /* @ngInject */
  function UIModalController($uibModalInstance, product) {
    var vm = this;
    vm.product = product;
    vm.removeProductModal = removeProductModal;

    function removeProductModal(remove) {
      $uibModalInstance.close(remove);
    }
  }

  /* @ngInject */
  function CartController(_, analytics, api, cart, cartproduct, coupon, dateTime, env, hero, html, kushki, ngNotify, $auth, $document, $filter, $localStorage, $log, $q, $rootScope, $scope, $state, $stateParams, $templateCache, $timeout, $uibModal) {
    var vm = this;
    vm.contentLoaded = false;
    vm.activate = activate;
    vm.addDelivery = addDelivery;
    vm.addOne = addOne;
    vm.calculateTotals = calculateTotals;
    vm.creditCards = [
      {name: 'Mastercard LANPASS', endsWith: '9876'},
      {name: 'Visa Movistar', endsWith: '1234'}
    ];
    vm.customer = null;
    vm.getCustomerAddresses = getCustomerAddresses;
    vm.newAddressModal = newAddressModal;
    vm.deactivateAddress = deactivateAddress;
    vm.deactivateCard = deactivateCard;
    vm.getOpenRestaurants = getOpenRestaurants;
    vm.normalTotal = normalTotal;
    vm.onlinePaymentOn = false;
    vm.kushkiPaymentOn = false;
    vm.checkedTip = checkedTip;
    vm.selectTip = selectTip;
    vm.timesAverage = {};
    vm.showTips = showTips;
    vm.hasPickup = false;
    vm.hasDelivery = false;
    vm.isClosed = true;
    vm.inProgress = false;
    vm.items = [];
    vm.additionalItems = [];
    vm.locations = [];
    vm.addressLocations = [];
    vm.pickupRestaurants = [];
    vm.price = price;
    vm.productCount = productCount;
    vm.removeAll = removeAll;
    vm.removeOne = removeOne;
    vm.removeProduct = removeProduct;
    vm.selectedLocation = null;
    vm.selectedLocationId = null;
    vm.selectQuestion = selectQuestion;
    vm.sendOrder = sendOrder;
    vm.sendToPaymentPortal = sendToPaymentPortal;
    vm.showOptions = showOptions;
    vm.updatedDiscount = updatedDiscount;
    vm.discountable = cart.discountable;
    vm.when = 'now';
    vm.isOpenPickup = false;
    vm.upsellingProducts = [];
    vm.addToCart = cartproduct.addToCart;
    vm.viewSeleable = cartproduct.viewSeleable;
    vm.toggleSwitch = toggleSwitch;
    vm.showAdditionalItem = showAdditionalItem;
    vm.addressEnabled = addressEnabled;
    vm.showCouponArea = showCouponArea;
    vm.coupons = [];
    vm.returnToMenu = returnToMenu;
    vm.initInscriptionUrl = initInscriptionUrl;
    vm.openModalLocation = openModalLocation;
    vm.openModalCreditCard = openModalCreditCard;
    vm.validateState = validateState;
    vm.handlePickupDelivery = handlePickupDelivery;
    vm.onlinePayment = false;
    vm.kushkiPayment = false;
    vm.sodexoPayment = false;
    vm.localePickup = '';
    vm.localeDelivery = '';
    vm.DEFAULT_DISCOUNT_1 = (parseFloat(env.DEFAULT_DISCOUNT_1)*100);
    vm.DEFAULT_DISCOUNT_2 = (parseFloat(env.DEFAULT_DISCOUNT_2)*100);
    vm.paymentCards = [];
    vm.getPaymentCards = getPaymentCards;
    vm.selectedCardToken = null;
    vm.selectedCardId = null;
    vm.paymentButtonText = paymentButtonText;
    vm.commerce_code = null;
    vm.webpayplus_commerce_code = null;
    vm.order = {};

    vm.cart = cart;
    vm.cartproduct = cartproduct;
    vm.coupon = coupon;
    vm.envConstants = env;
    vm.kushki = kushki;

    getAdditionalProducts();
    function getAdditionalProducts(force) {
      return api.additionalProducts.all(force)
        .then(function(response) {
          vm.additionalProducts = response;
        })
        .catch(function(err) {
          $log.error(JSON.stringify(err));
        });
    }

    if (!vm.discountable()) {
      vm.paymentDiscount = "0"
    }

    vm.paymentType = false;

    vm.tips = env.TIPS;
    vm.selectedTip = {};

    vm.initInscriptionButton = false;
    vm.inscriptionUrl = env.API_URL + 'webpays/init_inscription';
    vm.paymentInitClick = paymentInitClick;
    vm.goToInscriptionbWebpay = goToInscriptionbWebpay;
    vm.processingWebPayment = false;
    vm.tbkUser = null;
    vm.tbkUsers = null;
    vm.selectLocation = selectLocation;
    vm.hideNewAddress = hideNewAddress;
    vm.showNewAddress = showNewAddress;
    vm.hideWhere = hideWhere;
    vm.showWhere = showWhere;
    vm.changeWhereElement = changeWhereElement;

    vm.newCouponModal = coupon.newCouponModal;
    vm.currentCoupon = $localStorage.currentCustomerCoupon;
    vm.currentCouponId = ($localStorage.currentCustomerCoupon) ? $localStorage.currentCustomerCoupon.id : null;
    vm.currentCouponValue = 0;
    vm.total = 0;
    vm.subTotal = 0;
    vm.totalDiscount = 0;
    vm.subtotalDiscount = 0;
    vm.totalPay = 0;

    Object.defineProperty(vm, 'count', {
      get: function() {
        return cart.count;
      }
    });


    activate(true);

    ////////////////

    $scope.$on('path:changed', function(/*e, path*/) {
      vm.how = '';
      vm.selectedLocationId = null;
      if ($rootScope.current.name == 'cart.whenhowwhere') {
        localeWhenHowHere();
        handleShowPriceWarningModal();
      }

      if ($rootScope.current.name == 'cart.products') {
        cart.setDefaultDiscount();
        vm.calculateTotals();
        if ($rootScope.previousState.name == 'cart.whenhowwhere') getOpenRestaurants();
      }
    });

    $scope.$on('cart:added', function() {
      vm.items = cart.products();
      vm.calculateTotals();
      vm.additionalItems = cart.additionalItems();
    });

    $scope.$on('coupon:load', function() {
      vm.currentCoupon = $localStorage.currentCustomerCoupon;
      vm.calculateTotals();
    });

    $scope.$on('kushki:subscribe-card', function() {
      vm.getPaymentCards();
    });

    $rootScope.$on('auth:login-success', function(ev, loggedCustomer) {
      vm.customer = loggedCustomer;
      if (!_.isEmpty(loggedCustomer)) {
        getTbkUser(loggedCustomer.id).then(function(tbk_users) {
          vm.tbkUsers = tbk_users;
          vm.tbkUser = vm.tbkUsers[0];
          if (vm.tbkUser) {
            setCardPaymentMethod();
          };
        });
        vm.getPaymentCards();
      }
    });

    function handlePickupDelivery(type) {
      vm.selectedLocationId = null;
      cart.setDefaultDiscount();

      if (type === 'pickup') {
        getOpenRestaurants();
      } else {
        getCustomerAddresses();
      }
    }

    function handleShowPriceWarningModal() {
      if (env.WARNING_PRICE === 0) return;

      if ($rootScope.current.name == "cart.whenhowwhere" && vm.totalDiscount > env.WARNING_PRICE) {
        priceWarningModal();
      }
    }

    function openModalLocation() {
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'modal-location-cart',
        windowClass: 'modal-location-cart',
        controller: 'LocationController as location',
        templateUrl: 'app/location/{mobile}{desktop}/modal-location-cart.html',
        resolve: {
          selectedLocation: function() {
            return '';
          }
        }
      });

      return modalInstance;
    }

    function openModalCreditCard(userCard) {
      var modalInstance = $uibModal.open({
        animation: true,
        windowClass: 'modal-credit-card',
        controller: 'CreditCardModalController as creditCard',
        templateUrl: 'app/credit-card/{mobile}{desktop}/select-credit-card.modal.html',
        resolve: {
          userCard: function() {
            return userCard;
          }
        }
      });

      modalInstance.result.then(function (creditCard) {
        if (!creditCard) return false;
        if (vm.kushkiPayment) {
          vm.kushkiCard = cart.findKushkiCard(vm.paymentCards, creditCard);
          vm.selectedCardToken = vm.kushkiCard.token;
          vm.selectedCardId = vm.kushkiCard.id;
        }
        if (vm.onlinePayment) {
          vm.tbkUser = cart.findTbkCard(vm.tbkUsers, creditCard);
          if (vm.tbkUser) setCardPaymentMethod();
        }
      });
    }

    function getTimesAverage() {
      return api.restaurants.timesAverage()
      .then(function(times) {
        vm.timesAverage = times;
      });
    }

    function validateState(items) {
      var tmpItems = items ? items : { items: vm.items };
      var env = tmpItems ? tmpItems : {};
      var stateName = $rootScope.current.name;
      var isInCartState = stateName.indexOf('cart') >= 0;
      if (!isInCartState) return;
      if (env.items) {
        if (env.items.length === 0) {
          $state.go('menu', {}, { location: 'replace' });
          ngNotify.set('Tu carro se encuentra vacío.', { type: 'warning', duration: 1000 });
          hero.setAnalyticsClass('perm-warning-empty-cart', 1000);
          return false;
        } else {
          return handleCheckMenuItem(env.items);
        }
      }
      if (vm.isClosed) {
        $state.go('cart.products', {}, { location: 'replace' });
        return false;
      }
    }

    function handleCheckMenuItem(cartItems) {
      var restaurantGroupId = $localStorage.restaurantGroup ? $localStorage.restaurantGroup.id : null;
      return api.menuCategories.checkMenuItem(cartItems, restaurantGroupId)
      .then(function(response) {
        if (response.items_not_found.length === 0) return true;

        _.each(response.items_not_found, function(item) {
          var element = _.find(cartItems, function(cartItem) {
            return item == cartItem.id;
          });
          removeAll(element);
        });

        api.products.all(true);
        api.promotions.all();

        if ($rootScope.current.name == "cart.whenhowwhere") {
          var message = 'Unos de los productos que elegiste ya no se encuentra disponible. Hemos actualizado tu carro.'
          ngNotify.set(message, 'error');
          hero.setAnalyticsClass('perm-error-product-not-available');
          $state.go('cart.products', {}, { reload: true });
          return false;
        }
        returnToMenu();
        return false;
      });
    }

    function priceWarningModal() {
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'full',
        templateUrl: 'app/cart/{mobile}{desktop}/price-warning.modal.html',
        controller: function ($scope, $uibModalInstance) {
          $scope.parseIntl = cart.parseIntl;
          $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
          };
        }
      })
      return modalInstance;
    }

    function toggleSwitch(itemId){
      var item = api.additionalProducts.get(itemId)
      cart.additionalProduct.set(item);
      vm.calculateTotals();
      vm.additionalItems = cart.additionalItems();
    }

    function activateAdditionalProducts() {
      _.each(vm.additionalProducts, function(item) {
        item.option_on = cart.additionalProduct.get(item);
      });
    }

    function activate() {
      delete $localStorage.order;
      return $q.all([api.products.all(), api.promotions.all()])
      .then(function() {
        activateAdditionalProducts();
        // TODO: use customer preferences
        vm.items = cart.products();
        validateState({ items: vm.items });
        addUpsellingsToCart();
        vm.calculateTotals();
        handleShowPriceWarningModal();
        vm.additionalItems = cart.additionalItems();
        setGlobalAvailablePaymentsVisibility();
        if ($stateParams.status == 'fail') {
          var msg = 'Hubo un error inscribiendo tu tarjeta. Por favor inténtalo nuevamente.';
          ngNotify.set(msg, 'error');
          hero.setAnalyticsClass('perm-error-saving-credit-card');
        }
        return $auth.validateUser();
      })
      .catch(function(info) {
        if (info.reason !== 'unauthorized') {
          $log.error(info);
          ngNotify.set('Error de conexión. Reintenta más tarde.', 'error');
          hero.setAnalyticsClass('perm-server-error-notify');
        }
      })
      .then(function(customer) {
        vm.customer = customer;
        if (!_.isEmpty($auth.user)) {
          if ($rootScope.current.name == 'cart.products' || $rootScope.current.name == "cart.whenhowwhere") {
            vm.getCustomerAddresses().then(function(addresses) {
              setPreviousState();
            })
            vm.addDelivery(false);
            vm.getPaymentCards();
          }
        }
      })
      .then(function() {
        if ($rootScope.current.name == 'cart.products' || $rootScope.current.name == "cart.whenhowwhere") {
          getOpenRestaurants();
        }
      })
      .then(function() {
        if ($rootScope.current.name == "cart.whenhowwhere") {
          localeWhenHowHere();
          return getTimesAverage();
        }
      })
      .then(function() {
        vm.contentLoaded = true;
      });
    }

    function setGlobalAvailablePaymentsVisibility() {
      api.prefs.all().then(function() {
        var online_payment = api.prefs.get('online_payment');
        var kushki_payment = api.prefs.get('kushki_payment');
        var sodexo_payment = api.prefs.get('sodexo_payment');
        var webpayplus_payment = api.prefs.get('webpayplus_payment');
        vm.onlinePayment = online_payment ? online_payment.value.toLowerCase() === 'true' : false;
        vm.kushkiPayment = kushki_payment ? kushki_payment.value.toLowerCase() === 'true' : false;
        vm.sodexoPayment = sodexo_payment ? sodexo_payment.value.toLowerCase() === 'true' : false;
        vm.webpayplusPayment = webpayplus_payment ? webpayplus_payment.value.toLowerCase() === 'true' : false;
      });
    }

    function addUpsellingsToCart() {
      api.menuCategories.all().then(function(allProducts) {
        var itemsArr = [];
        _.each(allProducts, function(category) {
          var prodItems = _.filter(category.products, { is_upselling: true });
          _.each(prodItems, function(prod) { itemsArr.push(prod) }).length > 0;
        });
        vm.upsellingProducts = itemsArr;
      })
      vm.calculateTotals();
      vm.additionalItems = cart.additionalItems();
    }

    function setPreviousState() {
      if (!_.isEmpty($auth.user)) {
        getTbkUser($auth.user["id"]).then(function(tbk_users) {
          vm.tbkUsers = tbk_users;
          vm.tbkUser = vm.tbkUsers[0];
          if (vm.tbkUser) {
            setCardPaymentMethod();
          };
          if ($localStorage.how) {
            vm.how = $localStorage.how;
            if ($localStorage.selectedLocationId) {
              vm.selectedLocationId = $localStorage.selectedLocationId;
              if (vm.how == 'delivery') {
                cart.isDelivery = true;
                vm.selectedLocation = _.find(vm.addressLocations, function(address) {
                  return vm.selectedLocationId == address.id;
                });
                onlinePaymentEnabled()
              } else {
                vm.selectedLocation = _.find(vm.pickupRestaurants, function(restaurant) {
                  return vm.selectedLocationId == restaurant.id;
                });
              }
              vm.selectLocation();
              selectQuestion('cual', '');
              if (!!vm.tbkUser) {
                vm.paymentType = setDefaultPaymentType();
                setDefaultTip();
              }
              vm.calculateTotals();
            }
          }
          setInscriptionButton();
        });
      }
    }

    function addOne(item) {
      cart.addWithEffect(item.id, item.seleable.name, 1, item.options, item.seleable.type);
      syncCalculatedAdditionalProducts();
      vm.calculateTotals();
      vm.additionalItems = cart.additionalItems();
    }

    function remove(item, count) {
      var id = item.id,
        options = item.options;
      cart.remove(id, count, options, item.seleable.type);

      if (vm.items.length) {
        vm.calculateTotals();
      } else {
        $state.go('menu', {}, { location: 'replace' });
      }

      if (productCount(item, options) === 0) {
        vm.items = cart.products();
        vm.additionalItems = cart.additionalItems();
      }
    }

    function removeOne(item) {
      remove(item, 1);
      syncCalculatedAdditionalProducts();
      vm.calculateTotals();
      vm.additionalItems = cart.additionalItems();
    }

    function removeAll(item) {
      remove(item, productCount(item));
      syncCalculatedAdditionalProducts();
      vm.calculateTotals();
      vm.additionalItems = cart.additionalItems();
    }

    function productCount(item) {
      return cart.get(item.id, item.options, item.seleable.type);
    }

    function syncCalculatedAdditionalProducts() {
      _.each(vm.additionalProducts, function(prod) {
        if (prod.additional_type == 'calculated') {
          cart.calculatedProducts.set(prod);
        }
      });
    }

    function calculateTotals() {
      if (!vm.customer || !vm.selectedLocationId) return;
      api.orders.checkCart(order())
        .then(function(details) {
          var pd = details.payment_details;
          vm.subTotal = pd.subtotal_amount;
          vm.total = pd.subtotal_amount;
          vm.totalDiscount = pd.discount_amount;
          vm.subtotalDiscount = pd.discount_amount;
          vm.currentCouponValue = pd.coupon_amount;
          vm.totalPay = pd.total_amount;
        })
        .catch(function(error) {
          var message = error.data && error.data.error ? error.data.error[0] : 'Error al calcular el total';
          ngNotify.set(message, 'error');
        });
    }

    function normalTotal() {
      var calc = vm.total;
      calc -= ((vm.how == 'delivery') ? vm.envConstants.DELIVERY : 0);
      calc -= ((vm.paymentType == 'webpay') ? vm.selectedTip.amount : 0);
      return calc;
    }

    function getTbkUser(customer_id) {
      return api.tbkuser.all(customer_id)
      .then(function(tbk_user) {
        return tbk_user;
      });
    }

    function updateClosedButtonState(button, buttonText, isOpen) {
      if ($rootScope.current.name !== 'cart.products') return;

      var ellipsis = $document[0].getElementById('loading-ellipsis');
      if (!button) var button = $document[0].getElementById('confirmation-order');
      if (!buttonText) var buttonText = $document[0].getElementById('button-text');
      if (isOpen) {
        button.removeAttribute('disabled');
        buttonText.innerHTML = 'Siguiente';
      } else {
        button.setAttribute('disabled', 'disabled');
        buttonText.innerHTML = 'Cerrado';
      }
      ellipsis.classList.add('hide');
      button.classList.remove('hide');
    }

    function hideCountdownContainer(container, button, buttonText, isOpen) {
      container.classList.add('hide');
      container.classList.remove('border-open-restaurant');
      updateClosedButtonState(button, buttonText, isOpen);
    }

    function updateContainerCountdown(container, button, buttonText, display, openMinRem, openSecRem, isOpen) {
      container.classList.remove('hide');
      container.classList.add('border-open-restaurant');
      display.innerHTML = 'Abre en ' + openMinRem + ' minutos ' + openSecRem + ' segundos ';
      updateClosedButtonState(button, buttonText, isOpen);
    }

    function countdown(openTimeRem, container, button, buttonText, display, interval) {
      var openDaysRem  = dateTime.daysRem(openTimeRem);
      var openHoursRem = dateTime.hoursRem(openTimeRem);
      var openMinRem   = dateTime.minRem(openTimeRem);
      var openSecRem   = dateTime.secRem(openTimeRem);
      if (openDaysRem == 0 && openHoursRem == 0) {
        if (openMinRem == 0 && openSecRem == 0) {
          hideCountdownContainer(container, button, buttonText, true);
          clearInterval(interval);
          return;
        }
        openMinRem = (openMinRem < 10) ? "0" + openMinRem : openMinRem;
        openSecRem = (openSecRem < 10) ? "0" + openSecRem : openSecRem;
        updateContainerCountdown(container, button, buttonText, display, openMinRem, openSecRem, false);
      } else {
        hideCountdownContainer(container, button, buttonText, false);
        clearInterval(interval);
        return;
      }
    }

    function scheduleFormat(openSchedule, closedSchedule) {
      if ($rootScope.current.name != 'cart.products') return;

      var container  = $document[0].getElementById('open-restaurant');
      var button     = $document[0].getElementById('confirmation-order');
      var buttonText = $document[0].getElementById('button-text');
      var display    = $document[0].getElementById('countdown');
      if (!container) return;
      var now           = new Date();
      var openDate      = dateTime.currentDate(now, openSchedule);
      var closedDate    = dateTime.currentDate(now, closedSchedule);
      var openTimeRem   = dateTime.timeRem(openDate, now);
      var closedTimeRem = dateTime.timeRem(closedDate, now);

      if ((closedSchedule != null && closedTimeRem > 0) || (openSchedule != null && openTimeRem <= 0)) {
        // Open rigth now
        hideCountdownContainer(container, button, buttonText, true);
        return;
      }
      if (openSchedule == null && closedTimeRem <= 0) {
        // Closed for the rest of the day
        hideCountdownContainer(container, button, buttonText, false);
        return;
      }
      var interval = setInterval(function() {
        openTimeRem -= 1000;
        if ($rootScope.current.name == 'cart.products') {
          countdown(openTimeRem, container, button, buttonText, display, interval);
        } else {
          clearInterval(interval);
        }
      }, 1000);
    }

    function getRestaurantHours() {
      var restaurantGroup = api.getCurrentLocation();
      var restaurantGroupId = restaurantGroup ? restaurantGroup.id : null;
      return api.getRestaurantHours(restaurantGroupId)
      .then(function(response) {
        var restaurantHours = response.restaurant_hours;
        scheduleFormat(restaurantHours.open_restaurant_time, restaurantHours.closed_restaurant_time);
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
      });
    }

    function getOpenRestaurants() {
      vm.addDelivery(false);
      vm.pickupRestaurants = [];
      return api.restaurants.all(true, true)
      .then(function(restaurants) {
        vm.paymentType = setDefaultPaymentType(true);
        vm.selectLocation();
        var openRestaurants = _.filter(restaurants, function(restaurant) {
          return restaurant.is_open && (restaurant.is_pickup || restaurant.is_delivery);
        });
        vm.pickupRestaurants = _.filter(openRestaurants, { is_pickup: true });
        var restaurantGroup = api.getCurrentLocation();
        if (restaurantGroup) {
          openRestaurants = _.filter(openRestaurants, {
            restaurant_group_id: restaurantGroup.id
          });
          vm.pickupRestaurants = _.filter(vm.pickupRestaurants, {
            restaurant_group_id: restaurantGroup.id
          });
        }
        var pickupCount = _.filter(openRestaurants, { is_pickup: true }).length;
        var deliveryCount = _.filter(openRestaurants, { is_delivery: true }).length;
        vm.hasPickup = pickupCount > 0;
        vm.hasDelivery = deliveryCount > 0;
        vm.isClosed = openRestaurants.length === 0;
        vm.isClosed ? getRestaurantHours() : updateClosedButtonState(null, null, !vm.isClosed);
        var nextQuestion = 'where';
        if (vm.pickupRestaurants.length === 1) {
          vm.selectedLocation = vm.pickupRestaurants[0];
          vm.selectedLocationId = vm.pickupRestaurants[0].id;
          if (angular.element($document[0].getElementById('cual')).length) nextQuestion = 'cual';
          vm.selectQuestion(nextQuestion, vm.selectedLocation);
          vm.paymentType = setDefaultPaymentType();
        } else {
          vm.isOpenPickup = true;
          vm.selectedLocationId = null;
          vm.selectQuestion(nextQuestion);
        }
        setDefaultTip();
        return restaurants;
      });
    }

    function getCustomerAddresses() {
      vm.addDelivery(true);
      vm.addressLocations.length = 0;
      vm.selectedLocationId = null;

      return api.addresses.all().then(function(addresses) {
        vm.paymentType = setDefaultPaymentType(true);
        var firstAddresses = addresses.splice(0, 3);
        addresses = _.sortBy(addresses, 'comune_name');
        addresses = addresses.sort(function(a, b) {
          return Number(b.assigned_restaurant_is_open) - Number(a.assigned_restaurant_is_open);
        });
        addresses = addresses.sort(function(a, b) {
          return Number(b.assigned_restaurant_group_is_correct) - Number(a.assigned_restaurant_group_is_correct);
        });
        vm.addressLocations = firstAddresses.concat(addresses);
        vm.addressLocations = _.map(vm.addressLocations, function(restLocation, index) {
          restLocation.selected = index == 0 ? true : false;
          return restLocation;
        });
        vm.selectedLocation = vm.addressLocations[0];
        if (vm.selectedLocation) {
          vm.selectedLocationId = vm.addressLocations[0].assigned_restaurant_is_open ? vm.selectedLocation.id : null;
          vm.changeWhereElement('address', 'remove');
          vm.hideNewAddress();
        }
        vm.selectLocation();
        var nextQuestion = 'where';
        if (addresses.length > 0 && vm.how == 'delivery') {
          nextQuestion = 'cual';
          setDefaultTip();
          onlinePaymentEnabled();
          vm.paymentType = setDefaultPaymentType();
        }
        vm.selectQuestion(nextQuestion, vm.selectedLocation);
        setDefaultTip();
        return addresses;
      })
      .then(function() {
        vm.initInscriptionUrl();
      });
    }

    function selectLocation() {
      vm.paymentType = setDefaultPaymentType();
      vm.tbkUser = vm.tbkUsers ? vm.tbkUsers[0] : vm.tbkUsers;
      if (vm.tbkUser) {
        setCardPaymentMethod();
      };
      setInscriptionButton();
    }

    function hideNewAddress() {
      var querySelector = '#btn-new-address';
      changeClass(querySelector, 'hide', 'add');
    }

    function showNewAddress() {
      var querySelector = '#btn-new-address';
      changeClass(querySelector, 'hide', 'remove');
    }

    function hideWhere(where, index, hideAll) {
      var querySelector = '#where .container-how-box-vertical';
      if (!hideAll) { querySelector += ':not(#container-where-' + where + '-' + index + ')' };
      changeClass(querySelector, 'hide', 'add');
    }

    function showWhere() {
      var querySelector = '#where .container-how-box-vertical.hide';
      changeClass(querySelector, 'hide', 'remove');
    }

    function changeWhereElement(where, request) {
      var querySelector = '#click-change-' + where;
      changeClass(querySelector, 'hide', request);
    }

    function changeClass(querySelector, className, request) {
      var nodeList = document.querySelectorAll(querySelector);
      nodeList.forEach(function(element) {
        if (request === 'add') element.classList.add(className);
        if (request === 'remove') element.classList.remove(className);
      })
    }

    function addressEnabled(location) {
      return location.delivery_restaurant_pickup_time && location.delivery_restaurant_pickup_time > 0;
    }

    function checkedTip(tip) {
      if (tip.default) {
        vm.selectTip(tip);
      }
    }

    function selectTip(tip) {
      vm.selectedTip = tip;
      calculateTotals();
    }

    function onlinePaymentEnabled() {
      if (vm.onlinePayment && vm.selectedLocation) {
        vm.onlinePaymentOn = getCommerceCode();
      } else {
        vm.onlinePaymentOn = false;
      }
      if (vm.kushkiPayment && vm.selectedLocation) {
        vm.kushkiPaymentOn = getCommerceCode();
      } else {
        vm.kushkiPaymentOn = false;
      }
    }

    function getCommerceCode() {
      var commerce_code = null;
      var webpayplus_commerce_code = null;
      if (vm.selectedLocation.assigned_restaurant) {
        commerce_code = vm.selectedLocation.assigned_restaurant.commerce_code;
        webpayplus_commerce_code = vm.selectedLocation.assigned_restaurant.webpayplus_commerce_code;
      } else {
        commerce_code = vm.selectedLocation.commerce_code;
        webpayplus_commerce_code = vm.selectedLocation.webpayplus_commerce_code;
      }
      vm.commerce_code = commerce_code;
      vm.webpayplus_commerce_code = webpayplus_commerce_code;
      return commerce_code !== null && commerce_code !== '';
    }

    function deactivateAddress(address) {
      var templateUrl = 'app/address/confirmation.modal.html';
      var template = $templateCache.get(templateUrl);
      var modalConfig = {
        animation: true,
        controller: 'AddressConfirmationModalController',
        controllerAs: 'confirmation',
        windowClass: 'deactivateAddressModal',
        resolve: {
          address: function () {
            return address;
          }
        }
      };
      if (template) {
        modalConfig.template = template;
      } else {
        modalConfig.templateUrl = templateUrl;
      }
      var modalInstance = $uibModal.open(modalConfig);

      modalInstance.result.then(function (confirmed) {
        if (confirmed) {
          address.active = false;
          return api.addresses.save(address)
          .then(function() {
            ngNotify.set('Dirección eliminada con éxito.', 'info');
            hero.setAnalyticsClass('perm-success-deactivate-address');
            return getCustomerAddresses();
          })
          .catch(function() {
            var msg = 'Hubo un problema eliminando tu dirección. Intenta más tarde.';
            ngNotify.set(msg, 'error');
            hero.setAnalyticsClass('perm-error-deactivate-address');
          });
        }
      }, function (e) {
        console.error(e);
      });
    }

    function deactivateCard(tbkUser, $event) {
      $event.preventDefault();
      vm.paymentType = setDefaultPaymentType();
      var templateUrl = 'app/webpay/confirmation.modal.html';
      var template = $templateCache.get(templateUrl);
      var modalConfig = {
        animation: true,
        keyboard: false,
        backdrop: 'static',
        controller: 'WebpayCardConfirmationModalController',
        controllerAs: 'confirmation',
        windowClass: 'deactivateCardModal'
      };
      if (template) {
        modalConfig.template = template;
      } else {
        modalConfig.templateUrl = templateUrl;
      }
      var modalInstance = $uibModal.open(modalConfig);

      modalInstance.result.then(function (confirmed) {
        if (confirmed) {
          var params = {
            customer_id: vm.customer.id,
            tbk_user_id: tbkUser.id
          };
          return api.webpay.deactivate(params)
          .then(function(response) {
            if (response.tbk_user_deactivated) {
              _.remove(vm.tbkUsers, function(obj) {
                return obj.id == tbkUser.id;
              });
              vm.paymentType = setDefaultPaymentType();
              vm.tbkUser = null;
              ngNotify.set('Tarjeta de crédito eliminada con éxito.', 'info');
              hero.setAnalyticsClass('perm-success-deactivate-credit-card');
            }
            else {
              var msg = 'Hubo un problema eliminando tu tarjeta. Intenta más tarde.';
              ngNotify.set(msg, 'error');
              hero.setAnalyticsClass('perm-error-deactivate-credit-card');
            }
          })
          .catch(function() {
            var msg = 'Hubo un problema eliminando tu tarjeta. Intenta más tarde.';
            ngNotify.set(msg, 'error');
            hero.setAnalyticsClass('perm-error-deactivate-credit-card');
          });
        }
      }, function (e) {
        console.error(e);
      });
    }

    function updatedDiscount(discount) {
      discount = discount;
      if (discount !== vm.DEFAULT_DISCOUNT_1 && discount !== vm.DEFAULT_DISCOUNT_2 && discount !== 0) {
        throw new Error('Descuento no válido: ' + discount);
      }
      setDefaultTip();
      cart.setDiscount(discount/100);
      vm.calculateTotals();
      if (vm.paymentType == 'webpay' || vm.paymentType == 'kushki') {
        selectQuestion('tip');
      }
      setInscriptionButton();
    }

    function setInscriptionButton() {
      vm.initInscriptionButton = false;

      // TODO: Refactorizar
      if ((vm.paymentType == 'webpay' && !!vm.tbkUser) ||
          (vm.paymentType == 'kushki' && vm.paymentCards.length > 0)) {
        vm.initInscriptionButton = false;
      }
      if ((vm.paymentType == 'webpay' && !vm.tbkUser) ||
          (vm.paymentType == 'kushki' && !vm.paymentCards.length > 0)) {
        vm.initInscriptionButton = true;
      }
    }

    function setDefaultTip() {
      vm.selectedTip = {};
      if (((vm.paymentType == 'webpay' && !!vm.tbkUser) ||
          (vm.paymentType == 'kushki' && vm.paymentCards.length > 0)) && cart.isDelivery) {
        vm.selectedTip = $filter('filter')(vm.tips, {default: true}, true)[0];
      }
    }

    function addDelivery(isDelivery) {
      vm.selectedLocation = null;
      cart.isDelivery = isDelivery;
      vm.calculateTotals();
    }

    function paymentInitClick() {
      if (vm.paymentType == 'webpay') goToInscriptionbWebpay();
      if (vm.paymentType == 'kushki') kushki.openModalInscriptionKushkiCard();
    }

    function goToInscriptionbWebpay() {
      Promise.all([validateState()])
      .then(function(result) {
        if(result[0] !== false) document.location.href = vm.inscriptionUrl;
      })
    }

    function initInscriptionUrl() {
      $localStorage.how = vm.how;
      $localStorage.selectedLocationId = vm.selectedLocationId;

      var restaurant_id = currentRestaurantID();
      var customer_id = vm.customer ? vm.customer.id : '';
      var params = "?restaurant_id=" + restaurant_id + "&customer_id=" + customer_id;
      vm.inscriptionUrl = env.API_URL + 'webpays/init_inscription' + params;
    }

    function getPaymentCards() {
      api.payment_gateway.get_payment_cards()
      .then(function(response) {
        vm.paymentCards = response.payment_cards;
        vm.kushkiCard = vm.paymentCards[0];
        vm.selectedCardToken = vm.kushkiCard ? vm.kushkiCard.token : null;
        vm.selectedCardId = vm.kushkiCard ? vm.kushkiCard.id : null;
      })
      .catch(function(err) {
        console.error(err);
      });
    };

    function currentRestaurantID() {
      var restaurant_id = '';
      if (cart.isDelivery) {
        var selectedAddress = _.find(vm.addressLocations, function(address) {
          return vm.selectedLocationId == address.id;
        });
        if (selectedAddress) {
          restaurant_id = selectedAddress.assigned_restaurant.id;
        }
      }
      else {
        restaurant_id = vm.selectedLocationId;
      }
      return restaurant_id;
    }

    function sendToPaymentPortal () {
      api.payment_gateway.generate_charge_by_payment_portal({
        payment_attempt: {
          gateway_name: 'transbank',
          commerce_code: vm.webpayplus_commerce_code,
          amount_cents: vm.totalPay,
        }
      }).then(function(data) {
        $localStorage.order = order();
        window .location.href = data.url;
      });
    }

    function order () {
      var order = {
        order_products: [],
        order_promotions: [],
        additional_products: [],
        discount: cart.discount() * 100
      };

      _.each(cart.products(true), function(item) {
        var orderItem = {};
        orderItem.quantity = item.quantity;

        if (item.seleable.type === 'products') {
          orderItem.modifiable = item.modifiable;
          orderItem.product_id = item.id;
          orderItem.product_options = item.options;

          if (item.seleable.additional_type) {
            order.additional_products.push(orderItem);
          }

          order.order_products.push(orderItem);
        } else if (item.seleable.type === 'promotions') {
          orderItem.promotion_id = item.id;
          orderItem.order_products = [];
          orderItem.promotion_product_groups = [];
          var promoProductGroups = item.seleable.promotion_product_groups;
          _.each(promoProductGroups, function(promoProductGroup, promoProductGroupIndex) {
            var products = promoProductGroup.products;
            var promotionProducts = [];
            orderItem.promotion_product_groups[promoProductGroupIndex] = { id: promoProductGroup.id };
            _.each(products, function(product, productIndex) {
              //Si no está selected, no lo agregamos
              if (!item.options[promoProductGroup.id][product.id].selected) return;
              var orderProduct = {};
              orderProduct.product_id = product.id;
              orderProduct.product_options = item.options[productIndex];
              orderProduct.promotion_product_details = {
                name: product.name,
                promotion_product_id: product.promotion_product_id,
                quantity: product.quantity,
                product_id: product.id
              }
              promotionProducts.push(orderProduct);
            });
            orderItem.promotion_product_groups[promoProductGroupIndex].promotion_products = promotionProducts;
          });
          order.order_promotions.push(orderItem);
        }
      });

      order.customer = {
        id: vm.customer.id
      };

      if (cart.isDelivery) {
        order.order_type = 'Delivery';
        order.address_id = vm.selectedLocationId;
        order.restaurant_id = null;
      } else {
        order.order_type = 'Retiro';
        order.restaurant_id = vm.selectedLocationId;
        order.address_id = null;
      }

      if (vm.paymentType == 'webpay') {
        order.payment_type = 'Oneclick';
        if (!!vm.tbkUser) {
          order.tbk_user_id = vm.tbkUser.id;
          order.tip_amount = vm.selectedTip.amount;
        }
      }

      if (vm.paymentType == 'kushki') {
        order.payment_type = 'Kushki';
        order.subcription_card_token = vm.selectedCardToken;
        order.tip_amount = vm.selectedTip.amount;
      }

      if (vm.paymentType == 'webpayplus' ) {
        order.payment_type = 'Webpayplus';
        order.tip_amount = vm.selectedTip.amount;
      }

      order.coupon_customer_id = $localStorage.currentCustomerCoupon ? $localStorage.currentCustomerCoupon.id : null;

      return order;
    }

    function sendOrder() {
      vm.inProgress = true;
      api.orders.save(order())
      .then(function(info) {
        if (vm.paymentType == 'webpay') {
          vm.processingWebPayment = true;
          return authorizePayment(info);
        }
        else if (vm.paymentType === 'kushki') {
          return kushki.kushkiGenerateCharge({
            cardId: vm.selectedCardId,
            subscriptionId: vm.selectedCardToken,
            orderId: info["id"]
          }).then(function() {
            return goToSuccess(info);
          });
        } else if (vm.paymentType === 'webpayplus') {
          return;
        } else {
          if (vm.currentCoupon) coupon.removeCurrentCoupon();
          goToSuccess(info);
        }
        return info;
      }, function(info) {
        $log.error(info);
        var defaultMessage = 'Hubo un error. Carga de nuevo la página e inténtalo nuevamente.';
        var message = _.get(info, 'data.message',
          defaultMessage
        );

        if (message.includes('410')) {
          var message = 'Unos de los productos que elegiste ya no se encuentra disponible. Hemos actualizado tu carro.';
          ngNotify.set(message, 'error');
          hero.setAnalyticsClass('perm-error-product-not-available');
          return $state.go('cart.products', {}, { reload: true });
        }
        if (message.includes('420')) return showCouponError(message);
        ngNotify.set(message, 'error');
        hero.setAnalyticsClass('perm-server-error-notify');
        return info;
      })
      .finally(function(info) {
        vm.inProgress = false;
        api.prefs.all(true);
        return info;
      });
    }

    function showCouponError(message) {
      var errorMessage = message.split(':')[1];
      ngNotify.set(errorMessage, 'error');
      hero.setAnalyticsClass('perm-server-error-notify');
      delete $localStorage.currentCustomerCoupon;
      vm.currentCoupon = null;
      return $state.go('cart.products', {}, { reload: true });
    }

    function authorizePayment(info) {
      var params = {
        order_id: info["id"],
        total_amount: info["total"],
        restaurant_id: info["restaurant_id"],
        tbk_user_id: info["tbk_user_id"],
        customer_id: vm.customer.id
      };

      return api.webpay.authorize(params)
      .then(function(response) {
        vm.processingWebPayment = false;
        if (response["payment_status"]) {
          info = _.extend(info,{webpayment: response.webpayment});
          delete $localStorage.currentCustomerCoupon;
          var msg = 'Tu pago se realizó con éxito.';
          ngNotify.set(msg, 'info');
          hero.setAnalyticsClass('perm-success-processing-payment');
          goToSuccess(info);
        } else {
          $log.error(info);
          var message = _.get(info, 'data.message',
            'Hubo un problema procesando tu pago. Intenta nuevamente.'
          );
          var msg = 'Hubo un problema procesando tu pago. Intenta nuevamente.';
          ngNotify.set(msg, 'error');
          hero.setAnalyticsClass('perm-error-processing-payment');
        }
        return info;
      });
    }

    function goToSuccess(info) {
      vm.items.forEach(removeAll);
      $state.go('order.success', { order: info });
    }

    function price(item, applyDiscount) {
      return cart.price(item.id, applyDiscount, item.seleable.type, item.extraPrice);
    }

    function showOptions(item) {
      var options = item.options || {};
      if (item.type == "promotions") {
        var promotionProductGroups = item.seleable.promotion_product_groups;
        return _.map(promotionProductGroups, function(promotionProductGroup) {
          var products = promotionProductGroup.products;
          var selections = _.map(products, function(product, productIndex) {
            if (!options[promotionProductGroup.id] ||
                !options[promotionProductGroup.id][product.id] ||
                !options[promotionProductGroup.id][product.id].selected)
              return;
            var name = product.name,
              productOptions = _.extend({}, (options[productIndex] || {}), product.extras);
            if (!_.isEmpty(productOptions)) {
              name += ' (' + _.values(productOptions).join(', ') + ')';
            }
            return name;
          }).filter(function (el) {
            return el != undefined;
          });
          if (promotionProductGroup.items_limit > 0) {
            return promotionProductGroup.name + ": " + selections.join(', ');
          } else {
            return selections.join(', ');
          }
        });
      } else if (item.modifiable) {
        var productGroups = item.seleable.modifier_groups;
        return _.map(productGroups, function(productGroup) {
          if (!options[productGroup.id]) return;
          var groupName = productGroup.name,
            groupCategories = productGroup.modifier_group_categories;
          var selections = _.map(groupCategories, function(groupCategory) {
            var groupVariants = groupCategory.modifier_group_variants;
            return _.map(groupVariants, function(groupVariant) {
              var variantId = groupVariant.variant.id,
                variantName = groupVariant.variant.name;
              return _.map(options[productGroup.id], function(productGroupOption) {
                var productId = Object.keys(productGroupOption)[0],
                  variantQuantity = productGroupOption[productId].quantity;
                if (productId !== variantId) return;
                return variantName + (variantQuantity > 1 ? " (x" + variantQuantity + ")" : "");
              }).filter(function (el) {
                return el != undefined;
              });
            }).filter(function (el) {
              return el.length;
            });
          })
          return groupName + ": " + selections.join(',').split(',').join(', ');
        });
      } else {
        return _.map(_.extend({}, options, item.seleable.extras), function(value, key) {
          return key + ': ' + value;
        });
      }
    }

    function selectQuestion(name, location) {
      if (location) {
        vm.selectedLocation = location;
        onlinePaymentEnabled();
        vm.InitInscriptionSubmitButton = initInscriptionUrl();
      }

      return $timeout(function() {
        var question = angular.element('#' + name);
        if (question.length == 0) return;
        var parent = question.closest(".nn-scroll-ref");
        if (parent.length == 0) {
          parent = question.closest("html");
          return parent.scrollToElementAnimated(question, 0, vm.envConstants.DELIVERY);
        } else {
          return parent.scrollToElementAnimated(question, 0, vm.envConstants.DELIVERY);
        }
      });
    }

    function newAddressModal(isMobile) {
      var templateUrl = 'app/address/desktop/address.modal.html';
      if (isMobile) {
        templateUrl = 'app/address/mobile/address.modal.html';
      }
      var template = $templateCache.get(templateUrl);
      var modalConfig = {
        animation: true,
        backdrop: 'static',
        controller: 'AddressController',
        controllerAs: 'address',
        windowClass: 'newAddressModal',
        resolve: {
          fromLogin: function () {
            return false;
          }
        }
      };
      if (template) {
        modalConfig.template = template;
      } else {
        modalConfig.templateUrl = templateUrl;
      }
      var modalInstance = $uibModal.open(modalConfig);

      modalInstance.result.then(function (newAddress) {
        if (!newAddress) return false;
        vm.addressLocations = _.map(vm.addressLocations, function(restLocation) {
          restLocation.selected = false;
          return restLocation;
        });
        newAddress.selected = true;
        vm.addressLocations.unshift(newAddress);
        vm.selectedLocation = vm.addressLocations[0];
        if (vm.selectedLocation) {
          vm.selectedLocationId = vm.addressLocations[0].assigned_restaurant_is_open ? vm.selectedLocation.id : null;
          vm.changeWhereElement('address', 'remove');
          vm.hideNewAddress();
          vm.hideWhere('address', null, true);
        }
        vm.selectLocation();
        selectQuestion('cual', vm.selectedLocation);
      }, function (e) {
        console.error(e);
      });
    }


    function setCardPaymentMethod() {
      // En la siguiente línea no se encuentra el uso en algún lugar de vm.paymentTypeNames, lo que estuvo provocando errores.
      // TODO: Revisar o borrar
      // vm.paymentTypeNames["webpay"].subtitle = "Tarjeta nro XXXX.XXXX.XXXX." + vm.tbkUser.last_4_card_digits;
      vm.paymentType = setDefaultPaymentType();
      setDefaultTip();
    }

    function showAdditionalItem(item) {
      if (vm.additionalItems.length == 1) return item.quantity + ' ' + item.name;

      var penultimateItem = getPositionItem(item, -2);
      var lastItem = getPositionItem(item, -1);

      if (lastItem) {
        return 'y ' + item.quantity + ' ' + item.name;
      } else if (penultimateItem) {
        return item.quantity + ' ' + item.name;
      } else {
        return item.quantity + ' ' + item.name + ', ';
      }
    }

    function getPositionItem(item, position) {
      return item.id === vm.additionalItems[vm.additionalItems.length - Math.abs(position)].id;
    }

    function showCouponArea() {
      var infoArea = document.querySelector('#info-area'),
        inputsArea = document.querySelector('#inputs-area');
      infoArea.classList.contains('hide') ? infoArea.classList.remove('hide') : infoArea.classList.add('hide');
      inputsArea.classList.contains('hide') ? inputsArea.classList.remove('hide') : inputsArea.classList.add('hide');
    }

    function removeProduct(product) {
      var templateUrl = 'app/cart/{mobile}{desktop}/removeProduct.modal.html';
      var template = $templateCache.get(templateUrl);
      var modalConfig = {
        animation: true,
        controller: 'UIModalController',
        controllerAs: 'confirmation',
        windowClass: 'removeProductModal',
        resolve: {
          product: function () {
            return product;
          }
        }
      };
      if (template) {
        modalConfig.template = template;
      } else {
        modalConfig.templateUrl = templateUrl;
      }
      var modalInstance = $uibModal.open(modalConfig);
      modalInstance.result.then(function (confirmed) {
        if (confirmed) {
          removeCouponProduct(product);
          removeOne(product);
          returnToMenu();
        }
      }, function (e) {
        console.error(e);
      });
    }

    function returnToMenu() {
      if(vm.items.length > 0) return;

      ngNotify.set('Tu carro se encuentra vacío.', { type: 'warning', duration: 1000 });
      hero.setAnalyticsClass('perm-warning-empty-cart', 1000);
      validateState();
    }

    function removeCouponProduct(product) {
      var currentCoupon = vm.currentCoupon;
      if (!currentCoupon || !currentCoupon.coupon.coupon_type.includes('products')) return;

      var cartCouponProducts = _.filter(vm.items, function(item) {
        return currentCoupon.products_enabled.includes(item.id);
      });

      if (cartCouponProducts.length === 1 && currentCoupon.products_enabled.includes(product.id)) {
        delete $localStorage.currentCustomerCoupon;
        vm.currentCoupon = null;
      }
    }

    function showTips() {
      if (vm.how == 'delivery' && !!vm.selectedLocationId) {
        if ((vm.paymentType == 'webpay' && !!vm.tbkUser && vm.onlinePaymentOn) ||
            (vm.paymentType == 'kushki' && vm.paymentCards.length > 0 && vm.kushkiPaymentOn)) return true;
      }
      return false;
    }

    function paymentButtonText() {
      if (vm.paymentType == 'kushki') return 'Kushki';
      if (vm.paymentType == 'webpay') return 'Webpay';
      return '';
    }

    function setDefaultPaymentType(clear_payment) {
      if (clear_payment) return 'efectivo';
      if (vm.kushkiPaymentOn) return 'kushki';
      if (vm.onlinePaymentOn) return 'webpay';
      return 'efectivo';
    }

    function localeWhenHowHere() {
      if (env.LOCALE == 'es-cl') {
        vm.localePickup = 'Retiro';
        vm.localeDelivery = 'Despacho';
      }
      if (env.LOCALE == 'es-mx') {
        vm.localePickup = 'Pick up';
        vm.localeDelivery = 'Delivery';
      }
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('website')
  .controller('AddressConfirmationModalController', AddressConfirmationModalController);

  /* @ngInject */
  function AddressConfirmationModalController($uibModalInstance, address) {
    var vm = this;
    vm.answer = answer;
    vm.address = address;

    function answer(answer){
      $uibModalInstance.close(answer);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('AddressController', AddressController);

  /* @ngInject */
  function AddressController(_, api, env, hero, html, ngNotify, uiGmapGoogleMapApi, $document, $log, $rootScope, $sce, $state, $stateParams, $timeout, $uibModalInstance, fromLogin) {
    var vm = this;
    vm.fromLogin = !!fromLogin;
    vm.modalTitle = "Nueva dirección";
    vm.modalSubtitle = null;
    if (vm.fromLogin) {
    vm.modalTitle = "Antes de continuar, agrega una dirección";
    vm.modalSubtitle =
      "La usaremos para mostrarte locales cercanos y calcular el despacho.";
    }
    vm.activate = activate;
    vm.backState = $stateParams.backState;
    vm.geocode = null;
    vm.latlngBounds = null;
    vm.tokenValidate = null;
    vm.addressValidation = false;
    vm.validationInProgress = false;
    vm.resendCodeDisabled = false;
    vm.codeTimer = 60;
    vm.lonLat = {};
    vm.lonLat.latitude = -33.4059632;
    vm.lonLat.longitude = -70.5608473;
    vm.mapLonLat = angular.copy(vm.lonLat);
    vm.mapOptions = {};
    vm.mapOptions.mapTypeControl = false;
    vm.mapOptions.scrollwheel = false;
    vm.mapOptions.streetViewControl = false;
    vm.mapOptions.draggable = true;
    vm.originalLonLat = {};
    vm.addressAutocomplete = addressAutocomplete;
    vm.getLonLatFromAddress = getLonLatFromAddress;
    vm.handleAutocompleteInputChange = handleAutocompleteInputChange;
    vm.validateAutocompleteInput = validateAutocompleteInput;
    vm.restoreLocation = restoreLocation;
    vm.checkAddress = checkAddress;
    vm.saveAddress = saveAddress;
    vm.validateAddress = validateAddress;
    vm.resendCode = resendCode;
    vm.startCodeCountdown = startCodeCountdown;
    vm.scrollTo = scrollTo;
    vm.step = 0;
    vm.polygons = [];
    vm.polygonFounded = false;
    vm.token = '';
    vm.addressId = '';
    vm.street_number = '';
    vm.street_name = '';
    vm.postal_code = '';
    vm.specific_number = '';
    vm.comment = '';
    vm.comune_name_gmaps = '';
    vm.city_name_gmaps = '';
    vm.place_id_gmaps = '';
    vm.formatted_address_gmaps = '';
    vm.address_components_gmaps = [];
    vm.titleAddress = '';
    vm.fullAddress = '';
    vm.autocompleteInput = '';
    vm.autocompleteInputError = false;
    vm.autocompleteInputErrorMessage = '';
    vm.close = close;
    vm.closeModal = closeModal;
    vm.selectOnMap = selectOnMap;
    vm.tooltip = $sce.trustAsHtml(
      '<h4>Acá se enviará tu pedido</h4>' +
      'Si lo necesitas, arrastra el mapa'
    );
    vm.envConstants = env;
    vm.country = env.COUNTRY || 'CL';
    vm.localeSpecificNumber = '';
    $rootScope.$on('restore-location', vm.restoreLocation);
    $rootScope.$on('address:marker-moved', function(event, lonLat) {
      handleMovedMarker(lonLat);
    });

    activate();
    getPolygon();

    ////////////////

    function activate() {
      localeAddress();
      getLatLngBounds();
      uiGmapGoogleMapApi
      .then(function(maps) {
        vm.geocoder = new maps.Geocoder();
        vm.geocode  = vm.geocoder.geocode.bind(vm.geocoder);
        vm.GeocoderStatus = maps.GeocoderStatus;
        vm.placesService = new maps.places.PlacesService($document[0].createElement('div'));
        vm.PlacesStatus = maps.places.PlacesServiceStatus;
      })
      .catch($log.error);
    }

    function getPolygon() {
      return api.restaurants.polygonsRestaurants()
      .then(function(polygons){
        vm.polygons = polygons;
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
        ngNotify.set('Error en la conexión. Intenta más tarde.', 'error');
        hero.setAnalyticsClass('perm-server-error-notify');
      });
    }

    function getLatLngBounds() {
      api.prefs.all().then(function() {
        vm.latlngBounds = api.prefs.get('latlng_bounds');
        vm.tokenValidate = api.prefs.get('token_validate_address');
      });
    }

    function close() {
      if (vm.fromLogin) {
        $uibModalInstance.close();
        return;
      }
      $state.go('cart.whenhowwhere', { 'choseDelivery': 'true' }, {
        reload: true,
        inherit: false
      });
    }

    function closeModal() {
      $uibModalInstance.close();
    }

    function scrollTo(id) {
      return $timeout(function() {
        var question = angular.element('#' + id);
        var parent = question.parent();
        return parent.scrollToElementAnimated(question, 0, vm.envConstants.DELIVERY);
      });
    }

    function addressAutocomplete() {
      var input = $document[0].getElementById('autocompleteInput');
      var acOptions = getComponentRestrictions();
      var autocomplete = new google.maps.places.Autocomplete(input, acOptions);

      autocomplete.addListener('place_changed', function() {
        var options = { address: input.value, componentRestrictions: { country: vm.country } };
        if (!hasStreetNumber(input.value)) {
          $rootScope.$applyAsync(function() {
            showAutocompleteInputError();
            hideInputsModal();
          });
          return;
        }
        clearAutocompleteInputError();
        getLonLatFromAddress(options);
      });
    }

    function handleAutocompleteInputChange() {
      resetResolvedAddressState();
      clearAutocompleteInputError();
      hideInputsModal();
      scrollTo('map');
    }

    function validateAutocompleteInput() {
      if (!vm.autocompleteInput) {
        clearAutocompleteInputError();
        return;
      }

      if (!hasStreetNumber(vm.autocompleteInput)) {
        resetResolvedAddressState();
        showAutocompleteInputError();
        hideInputsModal();
      }
    }

    function hasStreetNumber(value) {
      return /\d/.test(value || '');
    }

    function showAutocompleteInputError() {
      vm.autocompleteInputError = true;
      vm.autocompleteInputErrorMessage = 'Agrega la numeración';
    }

    function clearAutocompleteInputError() {
      vm.autocompleteInputError = false;
      vm.autocompleteInputErrorMessage = '';
    }

    function getComponentRestrictions() {
      if (!validateLatLngBounds(vm.latlngBounds)) return { componentRestrictions: { country: vm.country } };
      var southWest = new google.maps.LatLng(vm.latlngBounds.south, vm.latlngBounds.west);
      var northEast = new google.maps.LatLng(vm.latlngBounds.north, vm.latlngBounds.east);
      var bounds    = new google.maps.LatLngBounds(southWest, northEast);
      return { componentRestrictions: { country: vm.country }, strictBounds: true, bounds: bounds };
    }

    function validateLatLngBounds(latlngBounds) {
      if (!latlngBounds) return false;
      return (!!latlngBounds.south && !!latlngBounds.west && !!latlngBounds.north && !!latlngBounds.east);
    }

    function getLonLatFromAddress(options) {
      options = buildGeocodeOptions(options);
      vm.geocode(options, function(results, status) {
        $rootScope.$apply(function() {
          handleGeocodeResults(results, status);
        });
      });
    }

    function handleMovedMarker(lonLat) {
      if (!vm.geocode || !lonLat) return;

      vm.geocode({
        location: {
          lat: lonLat.latitude,
          lng: lonLat.longitude
        }
      }, function(results, status) {
        $rootScope.$apply(function() {
          handleGeocodeResults(results, status, lonLat);
        });
      });
    }

    function handleGeocodeResults(results, status, overrideLonLat) {
      if (status !== vm.GeocoderStatus.OK || !results || !results.length) {
        vm.polygonFounded = false;
        $log.error('Geocode was not successful: ' + status);
        return;
      }

      var result = results[0];
      var location = result.geometry.location;
      vm.originalLonLat.latitude = overrideLonLat ? overrideLonLat.latitude : location.lat();
      vm.originalLonLat.longitude = overrideLonLat ? overrideLonLat.longitude : location.lng();
      setAddress(result.address_components);
      vm.autocompleteInput = buildDisplayAddress(result);
      restoreLocation();
      validateLocationInPolygon(vm.originalLonLat);
      addressTexts(result.formatted_address);
      getPlace(result);
    }

    function buildDisplayAddress(result) {
      var addressLine = [vm.street_name, vm.street_number].filter(Boolean).join(' ').trim();
      return result.formatted_address || addressLine || '';
    }

    function buildGeocodeOptions(options) {
      if (_.isObject(options) && !_.isArray(options)) return options;

      var formattedAddressContext = vm.formatted_address_gmaps
        ? vm.formatted_address_gmaps.split(',').slice(1).join(', ').trim()
        : '';
      var autocompleteWithNumber = vm.autocompleteInput
        ? [vm.autocompleteInput, vm.street_number].filter(Boolean).join(' ').trim()
        : '';

      var addressParts = [
        autocompleteWithNumber,
        vm.street_name,
        vm.street_number,
        _.get(vm, 'comune.name'),
        vm.comune_name_gmaps,
        vm.city_name_gmaps,
        formattedAddressContext,
        vm.country
      ].filter(Boolean);

      return {
        address: _.uniq(addressParts).join(', '),
        componentRestrictions: { country: vm.country }
      };
    }

    function validateLocationInPolygon(lonLat) {
      vm.polygonFounded = false;
      if (!lonLat) return;

      var location = new google.maps.LatLng(lonLat.latitude, lonLat.longitude);
      _.each(vm.polygons, function(polygonGroup) {
        polygonGroup.polygons.forEach(function(polygonPath) {
          var polygon = new google.maps.Polygon({ paths: polygonPath });
          var validatePolygon = google.maps.geometry.poly.containsLocation(location, polygon);
          if (!vm.polygonFounded && validatePolygon) vm.polygonFounded = true;
        });
      });
    }

    function getPlace(result) {
      if (result.place_id && vm.placesService) {
        vm.placesService.getDetails({
          placeId: result.place_id,
          fields: [
            'place_id','formatted_address','address_components','geometry',
            'name','types','url','icon','vicinity','utc_offset_minutes',
            'icon_mask_base_uri','icon_background_color'
          ]
        }, function(place, psStatus) {
          if (psStatus === vm.PlacesStatus.OK && place) {
            placeChanged(place);
          } else {
            placeChanged(geocoderResultToPseudoPlace(result));
            $log.error('Places getDetails fallback con GeocoderResult. Status: ' + psStatus);
          }
        });
      } else {
        placeChanged(geocoderResultToPseudoPlace(result));
      }
    }

    function geocoderResultToPseudoPlace(result) {
      return {
        address_components: result.address_components,
        adr_address: null,
        formatted_address: result.formatted_address,
        geometry: {
          location: {
            lat: result.geometry.location.lat(),
            lng: result.geometry.location.lng()
          },
          viewport: result.geometry.viewport
        },
        html_attributions: [],
        icon: null,
        icon_background_color: null,
        icon_mask_base_uri: null,
        name: null,
        place_id: result.place_id,
        reference: null,
        types: result.types || [],
        url: null,
        utc_offset_minutes: null,
        vicinity: null
      }
    }

    function placeChanged(place) {
      if (place.address_components) {
        setAddress(place.address_components);
        vm.autocompleteInput = buildDisplayAddress(place);
      }
      vm.place_id_gmaps           = place.place_id;
      vm.formatted_address_gmaps  = place.formatted_address;
      vm.address_components_gmaps = addressComponents(place);
      showInputsModal();
    }

    function addressComponents(place) {
      return {
        address_components: place.address_components,
        adr_address: place.adr_address,
        formatted_address: place.formatted_address,
        geometry: {
          location: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          },
          viewport: place.geometry.viewport
        },
        html_attributions: place.html_attributions,
        icon: place.icon,
        icon_background_color: place.icon_background_color,
        icon_mask_base_uri: place.icon_mask_base_uri,
        name: place.name,
        place_id: place.place_id,
        reference: place.reference,
        types: place.types,
        url: place.url,
        utc_offset_minutes: place.utc_offset_minutes,
        vicinity: place.vicinity
      }
    }

    function setAddress(address) {
      var previousStreetName = vm.street_name;
      var previousStreetNumber = vm.street_number;
      var foundStreetName = false;
      var foundStreetNumber = false;

      clearInputsModal();
      _.each(address, function(component) {
        if (component.types.includes('street_number')) {
          vm.street_number = component.long_name;
          foundStreetNumber = true;
        }
        if (component.types.includes('route')) {
          vm.street_name = component.long_name;
          foundStreetName = true;
        }
        if (vm.country == 'CL') {
          if (component.types.includes('administrative_area_level_3')) vm.comune_name_gmaps = component.long_name;
          if (component.types.includes('locality')) vm.city_name_gmaps = component.long_name;
        }
        if (vm.country == 'MX') {
          if (component.types.includes('locality')) vm.city_name_gmaps = component.long_name;
          if (component.types.includes('sublocality')) vm.comune_name_gmaps = component.long_name;
        }
        if (component.types.includes('postal_code')) vm.postal_code = component.long_name;
        if (component.types.includes('subpremise')) vm.specific_number = component.long_name;
      });

      if (!foundStreetName && previousStreetName) vm.street_name = previousStreetName;
      if (!foundStreetNumber && previousStreetNumber) vm.street_number = previousStreetNumber;
    }

    function clearInputsModal() {
      vm.token             = '';
      vm.street_number     = '';
      vm.street_name       = '';
      vm.postal_code       = '';
      vm.specific_number   = '';
      vm.comment           = '';
      vm.comune_name_gmaps = '';
      vm.city_name_gmaps   = '';
    }

    function resetResolvedAddressState() {
      clearInputsModal();
      vm.place_id_gmaps = '';
      vm.formatted_address_gmaps = '';
      vm.address_components_gmaps = [];
      vm.titleAddress = '';
      vm.fullAddress = '';
      vm.polygonFounded = false;
      vm.addressValidation = false;
      vm.validationInProgress = false;
    }

    function restoreLocation() {
      vm.lonLat.longitude    = vm.originalLonLat.longitude;
      vm.lonLat.latitude     = vm.originalLonLat.latitude;
      vm.mapLonLat.longitude = vm.originalLonLat.longitude;
      vm.mapLonLat.latitude  = vm.originalLonLat.latitude;
      $rootScope.$broadcast('address:gmap', vm.originalLonLat);
    }

    function addressTexts(formatted_address) {
      // IDs with initials "mkt-" should not be touched.
      var formattedAddress = $document[0].getElementById('mkt-formatted-address');
      var completeAddress = $document[0].getElementById('complete-address');
      html.removeAllClass(formattedAddress);
      if (vm.street_name && !vm.street_number) {
        html.addClass(formattedAddress, 'perm-formatted-address-error');
        vm.titleAddress = 'Dirección incompleta';
        vm.fullAddress = 'Agregar numeración';
        html.removeClass(completeAddress, 'hidden');
        $document[0].getElementById('street-number').focus();
        return;
      }

      if (vm.checkAddress()) {
        // Classes with initials "perm-" should not be touched.
        html.addClass(formattedAddress, 'perm-formatted-address-error');
        vm.titleAddress = 'Entregas no disponibles';
        vm.fullAddress = 'La dirección está fuera del área de entrega';
        html.addClass(completeAddress, 'hidden');
      } else {
        // Classes with initials "perm-" should not be touched.
        html.addClass(formattedAddress, 'perm-formatted-address');
        vm.titleAddress = 'Dirección';
        vm.fullAddress = formatted_address;
        html.addClass(completeAddress, 'hidden');
      }
    }

    function showInputsModal() {
      var address = $document[0].getElementById('address');
      var details = $document[0].getElementById('details');
      var map     = $document[0].getElementById('map');
      var completeAddress = $document[0].getElementById('complete-address');
      clearAutocompleteInputError();
      if (!!address) html.removeClass(address, 'hidden');
      if (!!details) html.removeClass(details, 'hidden');
      if (!!map) html.removeClass(map, 'hidden');
      if (!!completeAddress) html.addClass(completeAddress, 'hidden');
    }

    function hideInputsModal() {
      var address = $document[0].getElementById('address');
      var details = $document[0].getElementById('details');
      var map     = $document[0].getElementById('map');
      var completeAddress = $document[0].getElementById('complete-address');
      if (!!address) html.addClass(address, 'hidden');
      if (!!details) html.addClass(details, 'hidden');
      if (!!map) html.addClass(map, 'hidden');
      if (!!completeAddress) html.addClass(completeAddress, 'hidden');
    }

    function checkAddress() {
      return (!vm.street_name || !vm.street_number || !vm.polygonFounded) ? true : false;
    }

    function saveAddress(isMobile) {
      var address = {
        street_name: vm.street_name,
        street_number: vm.street_number,
        postal_code: vm.postal_code,
        specific_number: vm.specific_number,
        comment: vm.comment,
        lonlat: [vm.lonLat.longitude, vm.lonLat.latitude],
        comune_name_gmaps: vm.comune_name_gmaps,
        city_name_gmaps: vm.city_name_gmaps,
        place_id_gmaps: vm.place_id_gmaps,
        formatted_address_gmaps: vm.formatted_address_gmaps,
        address_components_gmaps: vm.address_components_gmaps
      };
      if (isMobile) {
        address.lonlat = [vm.mapLonLat.longitude, vm.mapLonLat.latitude];
      }
      return api.addresses.save(address)
      .then(function(data) {
        var address = data.address;
        vm.addressId = address.id;
        if (vm.tokenValidate.active == 'true' && address.validated == false) {
          vm.addressValidation = true;
          showValidationInputs();
          scrollBottomPage();
          moveValidationCode();
        } else {
          hero.setAnalyticsClass('perm-success-saving-address');
          thenSaveAddress(data);
        }
      })
      .catch(function(data) {
        hero.setAnalyticsClass('perm-error-saving-address');
        catchSaveAddress(data);
      });
    }

    function showValidationInputs() {
      var validation = $document[0].getElementById('validation');
      var validationCodeInput = $document[0].getElementById('validation-code-input');
      html.removeClass(validation, 'hidden');
      validationCodeInput.focus();
    }

    function scrollBottomPage() {
      var modalAddress = $document[0].querySelector('div.newAddressModal div.modal-dialog');
      $(modalAddress).animate({ scrollTop: modalAddress.scrollHeight }, 1000);
    }

    function moveValidationCode() {
      var validationCodeInput = $document[0].getElementById('validation-code-input');
      html.addClass(validationCodeInput, 'shake');

      setTimeout(function() {
        html.removeClass(validationCodeInput, 'shake');
      }, 2000);
    }

    function thenSaveAddress(data) {
      ngNotify.set('¡Dirección guardada!', 'info');
      if ($uibModalInstance.opened) {
        data = data.address;
        data.address = data.street_name + ' #' + data.street_number;
        if (data.specific_number) {
          data.address += ' ' + data.specific_number;
        }
        data.address +=  ', ' + data.comune_name;
        $uibModalInstance.close(data);
      } else {
        $state.go(vm.backState);
      }
      return data;
    }

    function catchSaveAddress(data) {
      data = data || {};
      var message = _.get(data, 'data.message', '');
      var err = new Error().stack;
      var logData = {
        'service': 'address.controller.js',
        'description': message,
        'payload': _.isEmpty(data) ? { 'data': 'false' } : data,
        meta: { trace: err } };
      api.setLogEntry(logData);
      ngNotify.set(message, 'error');
    }

    function validateAddress() {
      vm.validationInProgress = true;
      var payload = {
        resource: 'Address',
        token: vm.token,
        resource_id: vm.addressId
      }
      setDisabledResendCode();
      return api.addresses.validate(payload)
      .then(function(data) {
        thenSaveAddress(data);
        vm.validationInProgress = false;
        hero.setAnalyticsClass('perm-success-validate-address');
      })
      .catch(function(data) {
        vm.validationInProgress = false;
        catchSaveAddress(data);
        activeResendCode();
        hero.setAnalyticsClass('perm-error-validate-address');
      });
    }

    function resendCode() {
      if (vm.resendCodeDisabled == true) return;
      var payload = {
        resource: 'Address',
        resource_id: vm.addressId
      }
      disabledResendCode();
      showResendCodeClick();
      startCodeCountdown();
      return api.addresses.resendCode(payload)
      .then(function(data) {
        ngNotify.set('Reenvio de token exitoso', 'info');
        hero.setAnalyticsClass('perm-success-resend-code');
      })
      .catch(function(data) {
        hero.setAnalyticsClass('perm-error-resend-code');
        catchSaveAddress(data);
      });
    }

    function startCodeCountdown() {
      vm.codeTimer = 60;

      var countdownInterval = setInterval(function() {
        $timeout(function() {
          vm.codeTimer--;
          if (vm.codeTimer <= 0) {
            clearInterval(countdownInterval);
            vm.codeTimer = 60;
          }
        });
      }, 1000);
    }

    function disabledResendCode() {
      setDisabledResendCode();
      setTimeout(function() {
        activeResendCode();
      }, 60000);
    }

    function setDisabledResendCode() {
      var resendCodeClick = $document[0].getElementById('resend-code-click');
      vm.resendCodeDisabled = true;
      resendCodeClick.setAttribute('disabled', 'disabled');
    }

    function activeResendCode() {
      var resendCodeClick = $document[0].getElementById('resend-code-click');
      vm.resendCodeDisabled = false;
      resendCodeClick.removeAttribute('disabled');
    }

    function showResendCodeClick() {
      var resendCodeClick = $document[0].getElementById('resend-code-click');
      html.removeClass(resendCodeClick, 'hidden');
    }

    function selectOnMap() {
      vm.step = 1;
    }

    function localeAddress() {
      if (env.LOCALE == 'es-cl') {
        vm.localeSpecificNumber = 'N° depto, oficina, etc. (opcional)';
      }
      if (env.LOCALE == 'es-mx') {
        vm.localeSpecificNumber = 'Número interior. (opcional)';
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .run(runBlock);

  /** @ngInject */
  function runBlock(_, analytics, api, env, ngNotify, $auth, $controller, $injector, $location, $localStorage, $log, $rootScope, $state, $timeout, $uibModal, $uibModalStack, $urlRouter) {

    $rootScope.deviceType = _.intersection(['mobile', 'desktop'],
      angular.element(':root').attr('class').split(' '))[0];

    $rootScope.$on('$stateChangeError', $log.error.bind($log));
    $rootScope.$on("auth:login-success", function () {
      analytics.userNavigation();

      if ($localStorage.addressModalShown) return;
      api.addresses
        .all()
        .then(function (addresses) {
          if (addresses && addresses.length > 0) {
            delete $localStorage.addressModalShown;
            if (!$rootScope.selectedAddress) {
              $rootScope.selectedAddress = addresses[0];
            }
            return;
          }
          $localStorage.addressModalShown = true;
          $timeout(function () {
            $uibModalStack.dismissAll();
            var modalInstance = $uibModal.open({
              animation: true,
              backdrop: "static",
              controller: "AddressController",
              controllerAs: "address",
              windowClass: "newAddressModal",
              templateUrl:
                "app/address/{mobile}{desktop}/address-sidebar.modal.html",
              resolve: {
                fromLogin: function () {
                  return true;
                },
              },
            });
            modalInstance.result.then(function () {
              runPendingPostLoginRedirect();
            });
            modalInstance.result.finally(function () {
              delete $localStorage.addressModalShown;
            });
          }, 0);
        })
        .catch(function (err) {
          $log.error("Error loading addresses after login", err);
        });
    });
    $rootScope.$on('auth:password-reset-confirm-success', function() {
      $state.go('newPassword');
    });

    $auth.validateUser()
      .then(function() {
        analytics.userNavigation();
      })
      .catch(function() {});

    var bypass;
    $rootScope.$on('$stateChangeStart', function(e, toState, toParams, fromState, fromParams) {
      var state;
      $rootScope.previousState = { name: fromState.name, params: fromParams };
      $rootScope.current = { name: toState.name, params: toParams };
      delete $localStorage.modalInstance;

      if (bypass) {
        bypass = false;
        return;
      }

      // Remove notice-bar class from body classList
      document.getElementById('body').classList.remove('notice-bar');

      // close all remaining open modals
      if (fromState.name && fromState.name !== toState.name) {
        $uibModalStack.dismissAll();
      }

      // verify if customer is authenticated
      state = toState;
      while (state && state.name !== '' && !state.auth) {
        state = $state.get('^', state);
      }
      if (state && state.auth) {
        e.preventDefault();

        var auth = state.auth;
        $auth.validateUser()
        .then(function() {
          // logged in
          if (!auth.required) {
            var state, params;
            if (toParams.redirectTo) {
              state = toParams.redirectTo;
              params = toParams.redirectParams;
            } else {
              state = auth.redirect;
              params = {};
            }
            $state.transitionTo(state, params, { location: 'replace' });
          } else
          if (!isAdaptive(toState, toParams, e)) {
            bypass = true;
            $state.go(toState, toParams);
          }
        })
        .catch(function() {
          // logged out
          if (auth.required) {
            var params = {
              redirectTo: toState.name,
              redirectParams: toParams
            };
            $state.transitionTo(auth.redirect, params);
          } else
          if (!isAdaptive(toState, toParams, e)) {
            bypass = true;
            $state.go(toState, toParams);
          }
        });
      } else {
        // manage adaptive case
        isAdaptive(toState, toParams, e);
      }
    });
    $rootScope.$on('$locationChangeSuccess', function() {
      $rootScope.$broadcast('hash:changed', $location.hash());
      $rootScope.$broadcast('path:changed', $location.path());
    });

    function runPendingPostLoginRedirect() {
      var pendingRedirect = $localStorage.pendingPostLoginRedirect;
      if (!pendingRedirect || !pendingRedirect.state) return;

      var refreshLocationPromise = null;
      if (env.ALLOW_PRICE_LISTS === 'true') {
        refreshLocationPromise = api.refreshLocation();
      }

      delete $localStorage.pendingPostLoginRedirect;
      var options = pendingRedirect.reload ? { reload: true } : {};

      if (refreshLocationPromise && _.isFunction(refreshLocationPromise.then)) {
        return refreshLocationPromise.finally(function() {
          $state.go(pendingRedirect.state, pendingRedirect.params || {}, options);
        });
      }

      return $state.go(pendingRedirect.state, pendingRedirect.params || {}, options);
    }

    $rootScope.$on('$stateChangeSuccess', function() {
      $timeout(function() {
        analytics.userNavigation();

        var state = $state.current,
          title, description;
        do {
          title = state.title;
          description = state.description;
          state = $state.get('^', state);
        } while (!title && state.name !== '');
        $rootScope.$environment = env.ENVIRONMENT;
        $rootScope.$title = title;
        $rootScope.$description = description;
        $rootScope.$base_url = env.BASE_URL;
        $rootScope.$company_name = env.COMPANY_NAME;
        $rootScope.$company_email = env.COMPANY_EMAIL;
        $rootScope.$api_dns_prefetch_url = env.API_DNS_PREFETCH_URL;
        $rootScope.$assets_dns_prefetch_url = env.ASSETS_DNS_PREFETCH_URL;
        $rootScope.$favicon_url = env.FAVICON_URL;
        $rootScope.$footer_description = env.FOOTER_DESCRIPTION;
        $rootScope.$footer_delivery_description = env.FOOTER_DELIVERY_DESCRIPTION;
        $rootScope.$main_restaurant_address_1 = env.MAIN_RESTAURANT_ADDRESS_1;
        $rootScope.$main_restaurant_address_2 = env.MAIN_RESTAURANT_ADDRESS_2;
        $rootScope.$main_restaurant_phone = env.MAIN_RESTAURANT_PHONE;
        $rootScope.$main_restaurant_sch_1 = env.MAIN_RESTAURANT_SCH_1;
        $rootScope.$logo_url = env.LOGO_URL;
        $rootScope.$polygon_border_color = env.POLYGON_BORDER_COLOR;
        $rootScope.$polygon_fill_color = env.POLYGON_FILL_COLOR;
        $rootScope.$main_location_class = "body-" + $state.$current.name.replace(".", "-");
        $rootScope.$google_tag_manager_id = env.GOOGLE_TAG_MANAGER_ID;
        $rootScope.$google_site_verification = env.GOOGLE_SITE_VERIFICATION;

        var ldJsonString = JSON.stringify(env.INDEX_LD_JSON);
        document.getElementById('ld-json-script-tag').innerHTML = ldJsonString.substring(1, ldJsonString.length -1);
      });
    });

    ngNotify.addTheme('default-theme', 'default-theme');

    ngNotify.config({
      theme: 'default-theme',
      position: 'top',
      duration: 4000,
      type: 'info',
      sticky: false,
      html: false
    });

    ngNotify.addType('info', 'info-notify');
    ngNotify.addType('warning', 'warning-notify');
    ngNotify.addType('error', 'error-notify');

    function isAdaptive(toState, toParams, e) {
      var deviceType = $rootScope.deviceType;

      if (!(toState.adaptive && toState.adaptive[deviceType])) {
        return false;
      }

      e.preventDefault();

      var content = toState.adaptive[deviceType];
      if (content.redirect) {
        var stateAndParams = content.redirect,
          state, params;
        state = stateAndParams.match(/[^\(\)]+/)[0];
        params = stateAndParams.match(/\(.+\)/);
        params = params ? eval(params[0]) : {};
        $state.transitionTo(state, params, { location: 'replace' });
      } else
      if (content.modal) {
        // open modals from everywhere
        // http://blog.dargiel.net/how-to-open-a-modal-from-any-state-using-ui-router/
        var modalInstance = $uibModal.open({
          size: _.kebabCase(toState.name),
          controller: function() {
            return $controller(toState.controller, {
              $stateParams: toParams
            });
          },
          controllerAs: toState.controllerAs,
          templateUrl: toState.templateUrl
        });
        if (content.onCreate) {
          $injector.invoke(content.onCreate, modalInstance);
        }
      }
      return true;
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('website')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, env) {
    var stateName = env.ENVIRONMENT == 'mxniusushi' ? 'signin' : 'passwordless';
    var bannerResolve = function(env, $state, $q) {
      var deferred = $q.defer();
      if (env.BANNER === 'true') {
        deferred.resolve();
      } else {
        deferred.reject();
      }
      return deferred.promise.catch(function () { $state.go('menu'); });
    };
    var authResolve = function($auth, customer, $log) {
      return $auth.validateUser()
      .then(customer.set)
      .catch(function(err) {
        if (err.reason === 'unauthorized') {
          return customer.set(null);
        } else {
          $log.error(err);
        }
      });
    };

    $stateProvider
      .state('ngstatusok', {
        url: '/ngstatusok',
        title: 'Nginx Status OK | ' + env.COMPANY_NAME,
        description: 'Nginx Status OK | ' + env.COMPANY_NAME,
        templateUrl: 'app/ngstatus/ngstatusok.html',
        controller: 'NgStatusController',
        controllerAs: 'ngstatus'
      })
      .state('main', {
        url: '/',
        title: env.COMPANY_NAME + ' | ' + env.TITLE_DESCRIPTION,
        description: env.ROOT_DESCRIPTION,
        templateUrl: 'app/main/{mobile}{desktop}/main.html',
        resolve: { banner: bannerResolve },
        onEnter: function ($state) {
          if (env.NEW_HOME) $state.go('home');
        },
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('home', {
        url: '/home',
        title: env.COMPANY_NAME + ' | ' + env.TITLE_DESCRIPTION,
        description: env.ROOT_DESCRIPTION,
        templateUrl: 'app/home/{mobile}{desktop}/home.html',
        controller: 'HomeController',
        controllerAs: 'home'
      })
      .state('menu', {
        url: '/carta',
        title: 'Carta ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'La mejor calidad de comida ' + env.FOOD_TYPE + ', pide online. ' + env.COMPANY_NAME + ' con despachos a ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/menu/{mobile}{desktop}/menu.html',
        resolve: { auth: authResolve },
        controller: 'MenuController',
        controllerAs: 'menu'
      })
      .state('menu.category', {
        url: '/:categoryName'
      })
      .state('restaurants', {
        url: '/locales',
        title: 'Locales ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Los mejores locales de comida ' + env.FOOD_TYPE + ', pide online. ' + env.COMPANY_NAME + ' con despachos a ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/restaurants/{mobile}{desktop}/restaurants.html',
        controller: 'RestaurantsController',
        controllerAs: 'restaurants'
      })
      .state('faq', {
        url: '/preguntas-frecuentes',
        title: 'FAQ ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/faq/{mobile}{desktop}/faq.html',
        onEnter: function ($state) {
          if (env.FAQ !== 'true') $state.go('main');
        },
        controller: 'FaqController',
        controllerAs: 'faq'
      })
      .state('franchises', {
        url: '/franquicias',
        title: 'Franquicias ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/franchises/{mobile}{desktop}/franchises-form.html',
        onEnter: function ($state) {
          if (env.FRANCHISES !== 'true') $state.go('main');
        },
        controller: 'FranchisesController',
        controllerAs: 'franchises'
      })
      .state('promo', {
        url: '/promoqr',
        title: 'Promo ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'La mejor comida ' + env.FOOD_TYPE + ', pide online. ' + env.COMPANY_NAME + ' con despachos a ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/promos/mobile/promoqr.html',
        adaptive: {
          desktop: { redirect: 'main' }
        },
        onEnter: function ($state) {
          if (!env.PROMOQR_ON) $state.go('main');
        },
      })
      .state('teleton', {
        url: '/teleton',
        title: 'Teletón ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'La mejor comida ' + env.FOOD_TYPE + ', pide online. ' + env.COMPANY_NAME + ' con despachos a ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/promos/mobile/promoqr.html',
        adaptive: {
          desktop: { redirect: 'main' }
        },
        onEnter: function ($state) {
          if (!env.PROMOQR_ON) $state.go('main');
        },
      })
      .state('tos', {
        url: env.COUNTRY == 'MX' ? '/aviso-de-privacidad' : '/terminos-y-condiciones',
        title: 'T y C ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Términos y condiciones de ' + env.COMPANY_NAME + ', a tu casa en ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/tos/{mobile}{desktop}/tos.html',
        controller: 'TosController',
        controllerAs: 'tos'
      })
      .state('latestOrders', {
        auth: {
          required: true,
          redirect: stateName
        },
        url: '/repetir-pedidos',
        title: 'Repite tus pedidos | ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Pide comida ' + env.FOOD_TYPE + ' a tu casa en ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/menu/{mobile}{desktop}/menu.html',
        resolve: { auth: authResolve },
        controller: 'MenuController',
        controllerAs: 'menu'
      })
      .state('myFavorites', {
        auth: {
          required: true,
          redirect: stateName
        },
        url: '/mis-favoritos',
        title: 'Mis favoritos | ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Mis favoritos ' + env.FOOD_TYPE + ' a tu casa en ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/menu/{mobile}{desktop}/menu.html',
        resolve: { auth: authResolve },
        controller: 'MenuController',
        controllerAs: 'menu'
      })
      .state('searchMenu', {
        url: '/buscador-productos',
        title: 'Busca tu producto | ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Busca tu producto ' + env.FOOD_TYPE + ' a tu casa en ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/menu/{mobile}{desktop}/menu.html',
        controller: 'MenuController',
        controllerAs: 'menu'
      })
      .state('events', {
        url: '/eventos-y-cumpleanos',
        title: 'Eventos y Cumpleaños | ' + env.COMPANY_NAME + '| La mejor comida ' + env.FOOD_TYPE + ' de Santiago. ',
        description: 'Eventos y Cumpleaños ' + env.FOOD_TYPE + ' a tu casa en ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/menu/{mobile}{desktop}/menu.html',
        controller: 'MenuController',
        controllerAs: 'menu'
      })
      .state('eventCheckout', {
        url: '/event-checkout/:eventSelected',
        title: 'Eventos y Cumpleaños | ' + env.COMPANY_NAME + '| La mejor comida ' + env.FOOD_TYPE + ' de Santiago. ',
        description: 'Eventos y Cumpleaños ' + env.FOOD_TYPE + ' a tu casa en ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/event/{mobile}{desktop}/event.checkout.html',
        resolve: { auth: authResolve },
        controller: 'EventCheckoutController',
        controllerAs: 'eventCheckout'
      })
      .state('eventSuccess', {
        url: '/event-success?name',
        title: 'Eventos y Cumpleaños | ' + env.COMPANY_NAME + '| La mejor comida ' + env.FOOD_TYPE + ' de Santiago. ',
        description: 'Eventos y Cumpleaños ' + env.FOOD_TYPE + ' a tu casa en ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/event/{mobile}{desktop}/event.success.html',
        resolve: { auth: authResolve },
        controller: 'EventSuccessController',
        controllerAs: 'eventSuccess'
      })
      .state('receipts', {
        url: '/verificar-dte',
        title: 'Verificación DTE ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Validación de Boleta de ' + env.COMPANY_NAME + '| La mejor comida ' + env.FOOD_TYPE + ' a tu casa en ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/receipts/{mobile}{desktop}/search.html',
        controller: 'ReceiptController',
        controllerAs: 'receipt',
        onEnter: function ($state) {
          if (env.MY_RECEIPT) $state.go('menu');
        },
      })
      .state('ticketReceipts', {
        url: '/mifacturacion?rid&fiscal_n&date&amount',
        title: 'Facturar Ticket ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Validación de Boleta de ' + env.COMPANY_NAME + '| La mejor comida ' + env.FOOD_TYPE + ' a tu casa en ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/receipts/{mobile}{desktop}/generate-ticket-receipt.html',
        controller: 'ReceiptController',
        controllerAs: 'receipt',
        onEnter: function ($state) {
          if (!env.MY_RECEIPT) $state.go('menu');
        },
      })
      .state('receipt-success', {
        url: '/exito-facturacion',
        title: 'Facturación exitosa ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/receipts/{mobile}{desktop}/success.html',
        controller: 'ReceiptController',
        controllerAs: 'receipt',
        params: {
          filePdfBase64: null,
          fileXmlBase64: null,
          bussinessName: null
        },
        onEnter: function ($state) {
          if (!env.MY_RECEIPT) $state.go('menu');
        },
      })
      .state('beers-menu', {
        url: '/cartacerveza',
        title: 'Menú Cervezas ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/restaurant-menu/{mobile}{desktop}/beers-menu.html'
      })
      .state('bar-menu', {
        url: '/cartabar',
        title: 'Menú Bar ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/restaurant-menu/{mobile}{desktop}/bar-menu.html'
      })
      .state('restaurant-menu', {
        url: '/menu-restaurant/:menuType?id&type',
        title: 'Menú Restaurant ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/restaurant-menu/{mobile}{desktop}/restaurant-menu.html',
        controller: 'RestaurantMenuController',
        controllerAs: 'restaurantMenu'
      })
      .state('restaurant-menu.category', {
        url: '/:categoryName'
      })
      .state('bar-menu2', {
        url: '/cartabar2',
        title: 'Menú Bar ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/restaurant-menu/{mobile}{desktop}/bar-menu2.html'
      })
      .state('kids-menu', {
        url: '/menukids',
        title: 'Menú Niños ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/restaurant-menu/{mobile}{desktop}/kids-menu.html'
      })
      .state('client-contact', {
        url: '/contacto',
        title: 'Contacto ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/client-contact/{mobile}{desktop}/contact-form.html',
        resolve: { auth: authResolve },
        controller: 'ClientContactController',
        controllerAs: 'custom_form',
      })
      .state('client-contact-success', {
        url: '/exito-contacto',
        title: 'Contacto ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/client-contact/{mobile}{desktop}/success.html',
        controller: 'ClientContactController',
        controllerAs: 'custom_form',
        params: {
          form: null
        },
      })
      .state('register', {
        auth: {
          required: false,
          redirect: 'profile'
        },
        url: '/registro',
        title: 'Registrarse ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Regístrate en ' + env.COMPANY_NAME + ' para probar la mejor comida ' + env.FOOD_TYPE + '.',
        templateUrl: 'app/customer-session/{mobile}{desktop}/register.html',
        controller: 'CustomerSessionController',
        controllerAs: 'customerSession'
      })
      .state('signin', {
        auth: {
          required: false,
          redirect: 'profile'
        },
        adaptive: {
          desktop: {
            modal: true,
            /** @ngInject */
            onCreate: function($rootScope) {
              var modalInstance = this;
              $rootScope.openModal = true;

              var onLogin = $rootScope.$on('auth:login-success', function() {
                modalInstance.close();
                $rootScope.openModal = false;
                onLogin();
              });

              var onRegistration = $rootScope.$on('auth:registration-email-success', function() {
                modalInstance.close();
                $rootScope.openModal = false;
                onRegistration();
              });
            }
          }
        },
        url: '/registrarse?redirectTo',
        resolve: { auth: authResolve },
        params: {
          redirectParams: {}
        },
        title: 'Registrarse ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Regístrate en ' + env.COMPANY_NAME + ' para probar la mejor comida ' + env.FOOD_TYPE + '.',
        templateUrl: 'app/customer-session/{mobile}{desktop}/registration.html',
        controller: 'CustomerSessionController',
        controllerAs: 'customerSession'
      })
      .state('login', {
        auth: {
          required: false,
          redirect: 'profile'
        },
        adaptive: {
          desktop: {
            modal: true,
            /** @ngInject */
            onCreate: function($rootScope) {
              var modalInstance = this;
              var onLogin = $rootScope.$on('auth:login-success', function() {
                modalInstance.close();
                onLogin();
              });
            }
          }
        },
        url: '/login?redirectTo',
        params: {
          redirectParams: {}
        },
        title: 'Inicia Sesión ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Inicia sesión en ' + env.COMPANY_NAME + ' para probar la mejor comida ' + env.FOOD_TYPE + '.',
        templateUrl: 'app/customer-session/{mobile}{desktop}/login.html',
        controller: 'CustomerSessionController',
        controllerAs: 'customerSession'
      })
      .state('passwordless', {
        auth: {
          required: false,
          redirect: 'profile'
        },
        adaptive: {
          desktop: {
            modal: true,
            /** @ngInject */
            onCreate: function($rootScope) {
              var modalInstance = this;
              var onLogin = $rootScope.$on('auth:login-success', function() {
                modalInstance.close();
                onLogin();
              });
            }
          }
        },
        url: '/passwordless?redirectTo',
        params: {
          redirectParams: {}
        },
        title: 'Inicia Sesión ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Inicia sesión en ' + env.COMPANY_NAME + ' para probar la mejor comida ' + env.FOOD_TYPE + '.',
        templateUrl: 'app/customer-session/{mobile}{desktop}/passwordless.html',
        controller: 'CustomerSessionController',
        controllerAs: 'customerSession'
      })
      .state('logout', {
        url: '/logout',
        /** @ngInject */
        onEnter: function($auth, $localStorage, $state, $timeout, customer, $window) {
          $auth.signOut()
          .finally(function() {
            customer.set(null);
            var restaurantGroup = $localStorage.restaurantGroup;
            $localStorage.$reset();
            $localStorage.restaurantGroup = restaurantGroup;
            $window.location.href = '/';
          });
        }
      })
      .state('profile', {
        auth: {
          required: true,
          redirect: stateName
        },
        url: '/perfil',
        title: 'Tu perfil ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Ayudanos a conocerte para atenderte mejor. ' + env.DELIVERY_COMMUNES,
        resolve: { auth: authResolve },
        templateUrl: 'app/profile/{mobile}{desktop}/profile.html',
        controller: 'ProfileController',
        controllerAs: 'profile'
      })
      .state('resetPassword', {
        auth: {
          required: false,
          redirect: 'profile'
        },
        adaptive: {
          desktop: {
            modal: true
          }
        },
        url: '/restaurar-password',
        title: 'Recupera tu contraseña ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Recupera tu contraseña para para poder seguir probando la mejor experiencia en ' + env.FOOD_TYPE + ' pide online.',
        templateUrl: 'app/customer-session/{mobile}{desktop}/reset-password.html',
        controller: 'CustomerSessionController',
        controllerAs: 'customerSession',
        params: {
          email: null
        }
      })
      .state('newPassword', {
        adaptive: {
          desktop: {
            modal: true
          }
        },
        url: '/nueva-password',
        title: 'Nueva contraseña ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Crear nueva contraseña para para poder seguir probando la mejor experiencia en ' + env.FOOD_TYPE + ' pide online.',
        templateUrl: 'app/customer-session/{mobile}{desktop}/new-password.html',
        controller: 'CustomerSessionController',
        controllerAs: 'customerSession'
      })

      .state('address', {
        auth: {
          required: true,
          redirect: stateName
        },
        abstract: true,
        url: '/direccion',
        template: '<ui-view/>',
        resolve: {
          fromLogin: function () {
            return false;
          }
        },
        controller: 'AddressController',
        controllerAs: 'address',
        params: {
          backState: 'profile'
        }
      })
      .state('address.edit', {
        url: '/editar',
        templateUrl: 'app/address/{mobile}{desktop}/address.edit.html'
      })
      .state('address.confirm', {
        url: '/confirmar',
        templateUrl: 'app/address/address.confirm.html',
        adaptive: {
          desktop: { redirect: 'address.edit' }
        }
      })
      /*.state('address.new', {
        url: '/new',
        templateUrl: 'app/address/{mobile}{desktop}/new.html',
        adaptive: {
          desktop: { redirect: 'address.edit' }
        },
        params: {
          backState: 'cart.whenhowwhere'
        }
      })*/
      .state('process-payment', {
        url: '/process-payment',
        template: '<ui-view/>',
        title: 'Procesar pago ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        resolve: { auth: authResolve },
        controller: 'ProcessPaymentController',
        controllerAs: 'payment'
      })
      .state('process-payment.success_new', {
        url: '/order-exito',
        title: 'Orden exitosa ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/payment/{mobile}{desktop}/process-payment.success_new.html',
      })
      .state('process-payment.fail_new', {
        url: '/ups',
        title: 'Orden fallida ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/payment/{mobile}{desktop}/process-payment.fail_new.html'
      })
      .state('amipass-processing', {
        url: '/amipass-processing?order_id',
        auth: { required: false },
        title: 'Procesando pago Amipass ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/amipass/{mobile}{desktop}/amipass-processing.html',
        controller: 'AmipassProcessingController',
        controllerAs: 'amipass'
      })
      .state('payment-redirect', {
        url: '/payments/:paymentMethod/?status&order_id',
        auth: { required: false },
        title: 'Finalizando pago | ' + env.COMPANY_NAME,
        templateUrl: 'app/payment-redirect/{mobile}{desktop}/payment.redirect.html',
        controller: 'PaymentRedirectController',
        controllerAs: 'redirect'
      })
      .state('cart', {
        abstract: true,
        url: '/carro',
        title: 'Carro ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Comida ' + env.FOOD_TYPE + ' para despacho en ' + env.DELIVERY_COMMUNES ,
        template: '<ui-view/>',
        controller: 'CartController',
        controllerAs: 'cart',
        params: {
          choseDelivery: null
        }
      })
      .state('cart.products', {
        url: '/productos',
        title: 'Productos ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'La comida ' + env.FOOD_TYPE + ' más rica en ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/cart/{mobile}{desktop}/cart.products.html'
      })
      .state('cart.whenhowwhere', {
        auth: {
          required: true,
          redirect: stateName
        },
        url: '/donde-como-y-cuando?choseDelivery',
        title: 'Donde quieres tu ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Te llevamos comida ' + env.FOOD_TYPE + ' a tu casa en ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/cart/{mobile}{desktop}/cart.when-how-n-where.html'
      })
      .state('checkout', {
        auth: {
          required: true,
          redirect: stateName
        },
        url: '/checkout',
        title: 'Checkout ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Te llevamos comida ' + env.FOOD_TYPE + ' a tu casa en ' + env.DELIVERY_COMMUNES,
        resolve: { auth: authResolve },
        templateUrl: 'app/checkout/{mobile}{desktop}/checkout.html',
        controller: 'CheckoutController',
        controllerAs: 'checkout'
      })
      .state('order', {
        auth: {
          required: true,
          redirect: stateName
        },
        abstract: true,
        url: '/pedido',
        resolve: { auth: authResolve },
        template: '<ui-view/>',
        controller: 'OrderController',
        controllerAs: 'order',
        params: {
          order: null,
          rangeScheduledOrder: null,
        }
      })
      .state('order.success', {
        url: '/exito',
        title: 'Orden exitosa ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/order/{mobile}{desktop}/order.success.html'
      })
      .state('order.fail', {
        url: '/ups',
        title: 'Orden fallida ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/order/{mobile}{desktop}/order.fail.html'
      })
      .state('tracking', {
        auth: {
          required: true,
          redirect: stateName
        },
        url: '/tracking/:orderId',
        title: 'Estado del pedido ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        templateUrl: 'app/tracking/{mobile}{desktop}/tracking.html',
        resolve: { auth: authResolve },
        controller: 'TrackingController',
        controllerAs: 'tracking'
      })
      .state('feedback', {
        url: '/feedback/:orderId?s_c&r_id&f_c',
        title: 'Feedback ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Ayudanos a mejorar el servicio de comida ' + env.FOOD_TYPE + ' de ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/feedback/{mobile}{desktop}/feedback.html',
        controller: 'FeedbackController',
        controllerAs: 'feedback'
      })
      .state('external-feedback', {
        url: '/external-feedback',
        title: 'Feedback ' + env.COMPANY_NAME + ' | La mejor experiencia en ' + env.FOOD_TYPE + '. Pide online.',
        description: 'Ayudanos a mejorar el servicio de comida ' + env.FOOD_TYPE + ' de ' + env.DELIVERY_COMMUNES,
        templateUrl: 'app/external-feedback/{mobile}{desktop}/external-feedback.html',
        controller: 'ExternalFeedbackController',
        controllerAs: 'externalFeedback',
        params: {
          order: null
        }
      });
    $urlRouterProvider.otherwise('/carta');
  }
})();

/* global moment:false, StackTrace:false, rebound:false, _:false, viewportUnitsBuggyfill:false, viewportUnitsBuggyfillHacks:false */
(function() {
  'use strict';

  angular
    .module('website')
    .constant('_', _)
    .constant('rebound', rebound)
    .constant('StackTrace', StackTrace)
    .constant('viewportUnitsBuggyfill', viewportUnitsBuggyfill)
    .constant('viewportUnitsBuggyfillHacks', viewportUnitsBuggyfillHacks);

})();

(function() {
  'use strict';

  angular
    .module('website')
    .config(config);

  /** @ngInject */
  function config(adaptiveTemplatingProvider, AnalyticsProvider, env, StackTrace, uiGmapGoogleMapApiProvider, viewportUnitsBuggyfill, viewportUnitsBuggyfillHacks, $authProvider, $compileProvider, $locationProvider, $logProvider, $provide, $windowProvider) {
    var window = $windowProvider.$get();

    $locationProvider.html5Mode(true);

    // Enable log
    $logProvider.debugEnabled(true);
    var storageMethod = function(){
      try {
        // try to use localStorage
        window.localStorage.test = 2;
        return 'localStorage';
      } catch (e) {
        // there was an error so...
        alert('Parece ser que estás en modo privado o estás usando una versión antigua de tu navegador. El sitio podría no funcionar correctamente.');
        return 'cookies';
      }
    }

    // Set options third-party lib
    $authProvider.configure({
      apiUrl: env.NG_TOKEN_AUTH_URL,
      passwordResetSuccessUrl: window.location.origin + '/',
      storage: storageMethod(),
      authProviderPaths: {
        facebook: '/auth/facebook'
      }
    });

    $provide.decorator('$uibModalStack', function($delegate) {
      var open = $delegate.open,
        close = $delegate.close,
        dismiss = $delegate.dismiss;

      var onClosed = function() {
        try {
          var body = angular.element('body'),
            scroll = body.css('top').match(/\d+/)[0];

          // body.css({
          //   'position': 'static',
          //   'overflow': 'auto',
          //   'top': 'auto'
          // });

          window.scrollTo(0, scroll);
        }
        catch (e) {}
      };

      $delegate.open = function $uibModalOpen() {
        var body = angular.element('body'),
          scroll = window.scrollY;

        // body.css({
        //   'position': 'fixed',
        //   'overflow': 'hidden',
        //   'top': -scroll+'px',
        //   'left': '0',
        //   'right': '0',
        //   'margin': 'auto'
        // });

        return open.apply($delegate, arguments);
      };

      $delegate.close = function $uibModalClose() {
        onClosed();
        return close.apply($delegate, arguments);
      };
      $delegate.dismiss = function $uibModalDismiss() {
        onClosed();
        return dismiss.apply($delegate, arguments);
      };

      return $delegate;
    });

    $provide.decorator('$exceptionHandler', function($delegate) {
      return function(exception, cause) {
        $delegate(exception, cause);

        StackTrace.fromError(exception)
          .then(function(trace) {
            window.ga('send', 'exception', {
              exDescription: angular.toJson({
                msg: exception.toString(),
                url: window.location.href,
                cause: cause || '',
                trace: trace.slice(0, 6)
              }),
              exFatal: false
            });
          });
      };
    });

    // Loading Google Maps SDK
    uiGmapGoogleMapApiProvider.configure({
      key: env.GOOGLE_MAPS_API_KEY,
      v: '3',
      libraries: 'places,geometry,visualization'
    });

    // Disable spinner

    // Support geo: and tel: protocols
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|geo|tel):/);

    // Use viewport units fix
    viewportUnitsBuggyfill.init({
      force: /iPad|iPhone|iPod/.test(window.navigator.userAgent),
      hacks: viewportUnitsBuggyfillHacks,
      refreshDebounceWait: 250
    });

    // Enable enhanced e-commerce module (ec.js)
    // Universal Analytics only
    AnalyticsProvider
      .useECommerce(true, true);
    // Set Currency 'CLP'. Use ISO currency codes.
    AnalyticsProvider
      .setCurrency(env.CURRENCY);
    // Setting Google Analytics to track pages and exceptions
    AnalyticsProvider
      .setAccount({
        tracker: env.GOOGLE_ANALYTICS_TRACKING_NUM,
        enhancedLinkAttribution: true,
        trackEvent: true
      })
      .setPageEvent('$stateChangeSuccess');

    // Set tests for adaptive templates
    var isMobile = function() {
      var check = false;
      check = window.matchMedia('(max-width: 820px)').matches;
      return check;
    };

    adaptiveTemplatingProvider.addTest('mobile', isMobile());
    adaptiveTemplatingProvider.addTest('desktop', !isMobile());

    angular.element(':root').addClass(isMobile() ? 'mobile' : 'desktop');
    angular.element(':root').addClass(env.ENVIRONMENT);
  }
})();

angular.module("website").run(["$templateCache", function($templateCache) {$templateCache.put("app/address/address.confirm.html","<div class=\"container_site container_checkout\"><div class=\"container-fluid border_head header__app\"><div class=\"contianer\"><a class=\"col-xs-2 retroceder\" ui-sref=\"address.edit\"><i class=\"icon-arrow_ins_right\"></i></a><div class=\"col-xs-10 frace_local\"><p>{{address.envConstants.COMPANY_NAME}}</p></div></div></div><img id=\"marker\" height=\"67\" src=\"/assets/images/address_icon_{{$environment}}.png\" width=\"57\" tooltip-class=\"tooltip-special\" tooltip-html=\"address.tooltip\" tooltip-is-open=\"true\"><ui-gmap-google-map center=\"address.lonLat\" draggable=\"true\" options=\"address.mapOptions\" zoom=\"16\"><ui-gmap-map-control index=\"-1\" position=\"right-bottom\" template=\"app/address/restore/restore.html\"></ui-gmap-map-control></ui-gmap-google-map><button class=\"siguiente\" ng-click=\"address.saveAddress()\"><p>Confirmar dirección</p><i class=\"icon-arrow_ins_left\"></i></button></div>");
$templateCache.put("app/address/confirmation.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"confirmation.answer(false)\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header deactivate-address\" ng-if=\"!(customerSession.isPasswordSaved || customerSession.error)\"><h2>Confirmar</h2></div><div class=\"modal-body\"><div class=\"modal-item deactivate-address\"><p>¿Eliminar dirección \"{{confirmation.address.address}}\"?</p><div class=\"form-checkbox-inline\"><div class=\"form-checkbox\"><input id=\"option-yes\" name=\"si\" type=\"radio\" ng-click=\"confirmation.answer(true)\"> <label for=\"option-yes\" class=\"button-select\"><div class=\"checkbox-label\"><span>Si</span></div></label></div><div class=\"form-checkbox\"><input id=\"option-no\" name=\"no\" type=\"radio\" ng-click=\"confirmation.answer(false)\"> <label for=\"option-no\" class=\"button-select\"><div class=\"checkbox-label\"><span>No</span></div></label></div></div></div></div>");
$templateCache.put("app/coupon/coupon.modal.html","<div class=\"modal-header\"><button type=\"button\" class=\"close close-modal\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"coupon.closeModal()\"><i class=\"icon-x\"></i></button><h2>Ingresar cupón</h2></div><div class=\"modal-body\"><div class=\"item\"><div class=\"row form-group\"><div class=\"col-md-8 col-xs-8\"><input type=\"text\" name=\"coupon\" maxlength=\"50\" autocomplete=\"off\" placeholder=\"Código\" class=\"form-control\" ng-model=\"coupon.coupon.code\" required=\"\"></div><div class=\"col-md-4 col-xs-4\"><button class=\"btn btn-primary btn-block\" style=\"font-size: 15px;\" ng-click=\"coupon.applyCoupon(false)\" ng-disabled=\"!coupon.coupon.code\">Validar</button></div></div></div></div>");
$templateCache.put("app/coupon/deactivate-coupon.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"coupon.removeCoupon(false)\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header deactivate-coupon\"><h2>Confirmar</h2></div><div class=\"modal-body\"><div class=\"modal-item deactivate-coupon\"><p>¿Deseas eliminar este cupón: \"{{coupon.currentCoupon.code}}\"?</p><div class=\"form-checkbox-inline\"><div class=\"form-checkbox\"><input id=\"option-yes\" name=\"si\" type=\"radio\" ng-click=\"coupon.removeCoupon(true)\"> <label for=\"option-yes\" class=\"button-select\"><div class=\"checkbox-label\"><span>Si</span></div></label></div><div class=\"form-checkbox\"><input id=\"option-no\" name=\"no\" type=\"radio\" ng-click=\"coupon.removeCoupon(false)\"> <label for=\"option-no\" class=\"button-select\"><div class=\"checkbox-label\"><span>No</span></div></label></div></div></div></div>");
$templateCache.put("app/ngstatus/ngstatusok.html","<div class=\"ngstatus\"><h1>OK</h1></div>");
$templateCache.put("app/payment-redirect/payment.redirect.html","<div ng-controller=\"PaymentRedirectController as redirect\" class=\"payment-redirect\"><div class=\"card\"><div class=\"icon\" ng-class=\"{ success: redirect.isSuccess, fail: redirect.isFail }\">{{ redirect.isSuccess ? \'✅\' : \'⚠️\' }}</div><h1>{{ redirect.isSuccess ? \'¡Pago confirmado!\' : \'No pudimos confirmar el pago\' }}</h1><p>{{ redirect.isSuccess ? \'En unos segundos volverás a la app.\' : \'Vuelve a la app para revisar el estado de tu pedido.\' }}</p><button ng-click=\"redirect.openApp()\">Volver a la app</button></div></div>");
$templateCache.put("app/webpay/confirmation.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"confirmation.answer(false)\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header deactivate-card\"><h2>Confirmar</h2></div><div class=\"modal-body\"><div class=\"modal-item deactivate-card\"><p>¿Estás seguro que deseas eliminar la tarjeta asociada?</p><div class=\"form-checkbox-inline\"><div class=\"form-checkbox\"><input id=\"option-yes\" name=\"si\" type=\"radio\" ng-click=\"confirmation.answer(true)\"> <label for=\"option-yes\" class=\"button-select\"><div class=\"checkbox-label\"><span>Si</span></div></label></div><div class=\"form-checkbox\"><input id=\"option-no\" name=\"no\" type=\"radio\" ng-click=\"confirmation.answer(false)\"> <label for=\"option-no\" class=\"button-select\"><div class=\"checkbox-label\"><span>No</span></div></label></div></div></div></div>");
$templateCache.put("app/address/desktop/address-sidebar.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"address.closeModal()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><div class=\"modal-header-back\" ng-if=\"!address.fromLogin\"><button class=\"back-button\" data-dismiss=\"modal\" aria-label=\"Back\" ng-click=\"address.closeModal()\"><i class=\"icon-back\"></i></button></div><div class=\"modal-header-title\"><h2>{{ address.modalTitle }}</h2><p class=\"modal-subtitle\" ng-if=\"address.modalSubtitle\">{{ address.modalSubtitle }}</p></div></div><div class=\"modal-body\"><div class=\"modal-item\"><div class=\"modal-group\"><div class=\"modal-element auto-complete-input\" ng-class=\"{\'input-error\': address.autocompleteInputError}\"><input id=\"autocompleteInput\" type=\"text\" name=\"street\" placeholder=\"Ingresa tu dirección\" ng-focus=\"address.addressAutocomplete()\" ng-change=\"address.handleAutocompleteInputChange()\" ng-blur=\"address.validateAutocompleteInput()\" ng-model=\"address.autocompleteInput\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 3000 } }\" required=\"\"> <span class=\"input-error-message\" ng-if=\"address.autocompleteInputError\">{{address.autocompleteInputErrorMessage}}</span></div></div></div><div id=\"address\" class=\"modal-item hidden\"><div class=\"modal-group\"><div id=\"mkt-formatted-address\" class=\"formatted-address\"><div class=\"formatted-address-title\"><i class=\"icon-map-pin\"></i><h5>{{address.titleAddress}}</h5></div><p class=\"address\">{{address.fullAddress}}</p></div></div></div><div id=\"complete-address\" class=\"modal-item hidden\"><div class=\"modal-group\"><h3>Completar dirección</h3></div><div class=\"modal-group\"><div class=\"modal-element street-name\"><input type=\"text\" name=\"street-name\" placeholder=\"Calle\" maxlength=\"50\" ng-model=\"address.street_name\" required=\"\" disabled=\"\"></div><div class=\"modal-element street-number\"><input id=\"street-number\" type=\"number\" name=\"street-number\" placeholder=\"Número\" ng-blur=\"address.street_name && address.getLonLatFromAddress(true)\" ng-model=\"address.street_number\" required=\"\"></div></div></div><div id=\"details\" class=\"modal-item hidden\"><div class=\"modal-group\"><h3>Agregar datos al delivery</h3></div><div class=\"modal-group\"><div class=\"modal-element specific-number\"><input type=\"text\" name=\"specific-number\" placeholder=\"{{address.localeSpecificNumber}}\" maxlength=\"50\" ng-model=\"address.specific_number\"></div><div class=\"modal-element comment\"><input type=\"text\" name=\"comment\" placeholder=\"Agregar nota de delivery. (opcional)\" maxlength=\"50\" ng-model=\"address.comment\"></div></div></div><div id=\"map\" class=\"modal-item hidden\"><gmap-iframe class=\"gmap-iframe\" lon-lat=\"{{address.lonLat}}\" map-lon-lat=\"{{address.mapLonLat}}\" map-options=\"{{address.mapOptions}}\" map-control=\"true\"><gmap-iframe></gmap-iframe></gmap-iframe></div><div id=\"validation\" class=\"modal-item validation-code hidden\"><label class=\"modal-label\">Valida tu dirección ingresando el código enviado a tu correo</label><div class=\"modal-group\"><div class=\"modal-element validation-code\"><input id=\"validation-code-input\" type=\"text\" class=\"validation-code\" name=\"validation-code\" ng-pattern=\"/^[a-zA-Z0-9]+$/\" placeholder=\"Código de validación\" ng-model=\"address.token\"></div></div></div><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-show=\"!address.addressValidation\" ng-click=\"address.saveAddress(false)\" ng-disabled=\"address.checkAddress()\">Guardar dirección</button><div class=\"resend-code\" ng-show=\"address.addressValidation\"><span>{{address.codeTimer}}s</span> <a id=\"resend-code-click\" ng-click=\"address.resendCode()\">Reenviar código <span class=\"icon icon-repeat\"></span></a></div><div class=\"validate-address\"><button class=\"btn submit-button\" ng-show=\"address.addressValidation && !address.validationInProgress\" ng-click=\"address.validateAddress()\">Validar dirección</button><loader template=\"ellipsis\" size=\"x-small\" ng-show=\"address.validationInProgress\"><loader></loader></loader></div></div></div>");
$templateCache.put("app/address/desktop/address.edit.html","<div class=\"container-fluid header\"><div class=\"container\"><div class=\"col-md-4 logo\"><img ui-sref=\"main\" src=\"{{address.envConstants.LOGO_URL}}\" alt=\"{{address.envConstants.COMPANY_NAME}} logo\" height=\"40\"></div></div></div><div class=\"container-fluid container-contenido\"><div class=\"container mis-pedidos\"><div class=\"row\"><div class=\"col-sm-12 col-md-10 col-md-push-1\"><div class=\"header-pedidos\"><p>Nueva dirección</p></div><div class=\"carousel__vertical\"><div class=\"carousel__inner\"><div class=\"item\" id=\"comune\"><h2 class=\"title--pedido\">Comuna</h2><div class=\"seccion__agregar__direccion\"><div class=\"select__niu\"><label><select required=\"\" ng-change=\"!!(address.street_name && address.street_number) ? (address.scrollTo(\'map\') && address.getLonLatFromAddress(true)) : address.scrollTo(\'details\')\" ng-model=\"address.comune\" ng-options=\"comune as comune.name for comune in address.comunes\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona tu comuna</option></select></label></div></div></div><div class=\"item\" id=\"details\" ng-show=\"address.comune\"><h2 class=\"title--pedido\">Ingresa tu dirección</h2><div class=\"seccion__agregar__direccion\"><div class=\"row\"><div class=\"col-md-8\"><input class=\"large\" name=\"street\" placeholder=\"Nombre de tu Calle\" required=\"\" type=\"text\" ng-change=\"address.street_number && address.getLonLatFromAddress(true)\" ng-model=\"address.street_name\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 0 } }\"></div><div class=\"col-md-4\"><input class=\"large\" name=\"number\" placeholder=\"N°\" required=\"\" type=\"text\" ng-change=\"address.street_name && address.scrollTo(\'map\') && address.getLonLatFromAddress(true)\" ng-model=\"address.street_number\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 3000 } }\"></div></div><div class=\"row\"><div class=\"col-md-4\"><input class=\"large\" name=\"specific-number\" placeholder=\"N° Depto, Oficina, etc. (Opcional)\" type=\"text\" ng-model=\"address.specific_number\"></div></div></div></div><div class=\"item\" ng-if=\"address.comune\" id=\"map\"><h2 class=\"title--pedido\">Confirma la ubicación (arrastra el pin si es necesario)</h2><div class=\"seccion__agregar__direccion\"><ui-gmap-google-map center=\"address.mapLonLat\" options=\"address.mapOptions\" pan=\"true\" zoom=\"16\"><ui-gmap-marker coords=\"address.lonLat\" idkey=\"1\" options=\"{draggable: true, icon: \'/assets/images/address_icon_\' + $environment + \'.png\'}\"></ui-gmap-marker><ui-gmap-map-control index=\"-1\" position=\"right-bottom\" template=\"app/address/restore/restore.html\"></ui-gmap-map-control></ui-gmap-google-map></div></div></div></div><div class=\"seccion__progreso\"><div class=\"total__cont\"><button class=\"btn btn--color\" ng-click=\"address.saveAddress()\" ng-disabled=\"!address.street_name || !address.street_number\">Guardar dirección <i class=\"icon-arrow_ins_left\"></i></button></div></div></div></div></div></div>");
$templateCache.put("app/address/desktop/address.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"address.closeModal()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\" ng-if=\"!(customerSession.isPasswordSaved || customerSession.error)\"><h2>Nueva dirección</h2></div><div class=\"modal-body\"><div class=\"modal-item\"><div class=\"modal-group\"><div class=\"modal-element auto-complete-input\" ng-class=\"{\'input-error\': address.autocompleteInputError}\"><input id=\"autocompleteInput\" type=\"text\" name=\"street\" placeholder=\"Ingresa tu dirección\" ng-focus=\"address.addressAutocomplete()\" ng-change=\"address.handleAutocompleteInputChange()\" ng-blur=\"address.validateAutocompleteInput()\" ng-model=\"address.autocompleteInput\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 3000 } }\" required=\"\"> <span class=\"input-error-message\" ng-if=\"address.autocompleteInputError\">{{address.autocompleteInputErrorMessage}}</span></div></div></div><div id=\"address\" class=\"modal-item hidden\"><div class=\"modal-group\"><div id=\"mkt-formatted-address\" class=\"formatted-address\"><div class=\"formatted-address-title\"><i class=\"icon-map-pin\"></i><h5>{{address.titleAddress}}</h5></div><p class=\"address\">{{address.fullAddress}}</p></div></div></div><div id=\"complete-address\" class=\"modal-item hidden\"><div class=\"modal-group\"><h3>Completar dirección</h3></div><div class=\"modal-group\"><div class=\"modal-element street-name\"><input type=\"text\" name=\"street-name\" placeholder=\"Calle\" maxlength=\"50\" ng-model=\"address.street_name\" required=\"\" disabled=\"\"></div><div class=\"modal-element street-number\"><input id=\"street-number\" type=\"number\" name=\"street-number\" placeholder=\"Número\" ng-blur=\"address.street_name && address.getLonLatFromAddress(true)\" ng-model=\"address.street_number\" required=\"\"></div></div></div><div id=\"details\" class=\"modal-item hidden\"><div class=\"modal-group\"><h3>Agregar datos al delivery</h3></div><div class=\"modal-group\"><div class=\"modal-element specific-number\"><input type=\"text\" name=\"specific-number\" placeholder=\"{{address.localeSpecificNumber}}\" maxlength=\"50\" ng-model=\"address.specific_number\"></div><div class=\"modal-element comment\"><input type=\"text\" name=\"comment\" placeholder=\"Agregar nota de delivery. (opcional)\" maxlength=\"50\" ng-model=\"address.comment\"></div></div></div><div id=\"map\" class=\"modal-item hidden\"><gmap-iframe class=\"gmap-iframe\" lon-lat=\"{{address.lonLat}}\" map-lon-lat=\"{{address.mapLonLat}}\" map-options=\"{{address.mapOptions}}\" map-control=\"true\"><gmap-iframe></gmap-iframe></gmap-iframe></div><div id=\"validation\" class=\"modal-item validation-code hidden\"><label class=\"modal-label\">Valida tu dirección ingresando el código enviado a tu correo</label><div class=\"modal-group\"><div class=\"modal-element validation-code\"><input id=\"validation-code-input\" type=\"text\" class=\"validation-code\" name=\"validation-code\" ng-pattern=\"/^[a-zA-Z0-9]+$/\" placeholder=\"Código de validación\" ng-model=\"address.token\"></div></div></div><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-show=\"!address.addressValidation\" ng-click=\"address.saveAddress(false)\" ng-disabled=\"address.checkAddress()\">Guardar dirección</button><div class=\"resend-code\" ng-show=\"address.addressValidation\"><span>{{address.codeTimer}}s</span> <a id=\"resend-code-click\" ng-click=\"address.resendCode()\">Reenviar código <span class=\"icon icon-repeat\"></span></a></div><div class=\"validate-address\"><button class=\"btn submit-button\" ng-show=\"address.addressValidation && !address.validationInProgress\" ng-click=\"address.validateAddress()\">Validar dirección</button><loader template=\"ellipsis\" size=\"x-small\" ng-show=\"address.validationInProgress\"><loader></loader></loader></div></div></div>");
$templateCache.put("app/address/mobile/address-sidebar.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"address.closeModal()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><div class=\"modal-header-back\" ng-if=\"!address.fromLogin\"><button class=\"back-button\" data-dismiss=\"modal\" aria-label=\"Back\" ng-click=\"address.closeModal()\"><i class=\"icon-back\"></i></button></div><div class=\"modal-header-title\"><h2>{{ address.modalTitle }}</h2><p class=\"modal-subtitle\" ng-if=\"address.modalSubtitle\">{{ address.modalSubtitle }}</p></div></div><div class=\"modal-body\"><div class=\"modal-item\"><div class=\"modal-group\"><div class=\"modal-element\" ng-class=\"{\'input-error\': address.autocompleteInputError}\"><input id=\"autocompleteInput\" type=\"text\" name=\"street\" placeholder=\"Ingresa tu dirección\" ng-focus=\"address.addressAutocomplete()\" ng-change=\"address.handleAutocompleteInputChange()\" ng-blur=\"address.validateAutocompleteInput()\" ng-model=\"address.autocompleteInput\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 3000 } }\" required=\"\"> <span class=\"input-error-message\" ng-if=\"address.autocompleteInputError\">{{address.autocompleteInputErrorMessage}}</span></div></div></div><div id=\"address\" class=\"modal-item hidden\"><div class=\"modal-group\"><div id=\"mkt-formatted-address\" class=\"formatted-address\"><div class=\"formatted-address-title\"><i class=\"icon-map-pin\"></i><h5>{{address.titleAddress}}</h5></div><p class=\"address\">{{address.fullAddress}}</p></div></div></div><div id=\"complete-address\" class=\"modal-item hidden\"><div class=\"modal-group\"><h3>Completar dirección</h3></div><div class=\"modal-group\"><div class=\"modal-element\"><input type=\"text\" name=\"street-name\" placeholder=\"Calle\" maxlength=\"50\" ng-model=\"address.street_name\" required=\"\" disabled=\"\"></div><div class=\"modal-element\"><input id=\"street-number\" type=\"number\" name=\"street-number\" placeholder=\"Número\" ng-blur=\"address.street_name && address.getLonLatFromAddress(true)\" ng-model=\"address.street_number\" required=\"\"></div></div></div><div id=\"details\" class=\"modal-item hidden\"><div class=\"modal-group\"><h3>Agregar datos al delivery</h3></div><div class=\"modal-group\"><div class=\"modal-element\"><input type=\"text\" name=\"specific-number\" placeholder=\"{{address.localeSpecificNumber}}\" maxlength=\"50\" ng-model=\"address.specific_number\"></div><div class=\"modal-element\"><input type=\"text\" name=\"comment\" placeholder=\"Agregar nota de delivery. (opcional)\" maxlength=\"50\" ng-model=\"address.comment\"></div></div></div><div id=\"map\" class=\"modal-item hidden\"><gmap-iframe class=\"gmap-iframe\" lon-lat=\"{{address.lonLat}}\" map-lon-lat=\"{{address.mapLonLat}}\" map-options=\"{{address.mapOptions}}\" map-control=\"true\"><gmap-iframe></gmap-iframe></gmap-iframe></div><div id=\"validation\" class=\"modal-item hidden\"><label class=\"modal-label\">Valida tu dirección ingresando el código enviado a tu correo</label><div class=\"modal-group\"><div class=\"modal-element validation-code\"><input id=\"validation-code-input\" type=\"text\" class=\"validation-code\" name=\"validation-code\" ng-pattern=\"/^[a-zA-Z0-9]+$/\" placeholder=\"Código de validación\" ng-model=\"address.token\"></div></div></div><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-show=\"!address.addressValidation\" ng-click=\"address.saveAddress(true)\" ng-disabled=\"address.checkAddress()\">Guardar dirección</button><div class=\"resend-code\" ng-show=\"address.addressValidation\"><span>{{address.codeTimer}}s</span> <a id=\"resend-code-click\" ng-click=\"address.resendCode()\">Reenviar código <span class=\"icon icon-repeat\"></span></a></div><div class=\"validate-address\"><button class=\"btn submit-button\" ng-show=\"address.addressValidation && !address.validationInProgress\" ng-click=\"address.validateAddress()\">Validar dirección</button><loader template=\"ellipsis\" size=\"x-small\" ng-show=\"address.validationInProgress\"><loader></loader></loader></div></div></div>");
$templateCache.put("app/address/mobile/address.edit.html","<div class=\"container_site padding_chek\"><div class=\"container-fluid border_head header__app\"><div class=\"contianer\"><a class=\"col-xs-2 retroceder\" ui-sref=\"{{address.backState}}\"><i class=\"icon-arrow_ins_right\"></i></a><div class=\"col-xs-10 frace_local\"><p>{{address.envConstants.COMPANY_NAME}}</p></div></div></div><div class=\"bienvenidos\"><small>Ingresa tu Dirección</small></div><div class=\"welcome-checkout ending-order login-data\"><div class=\"container_campo_login\"><select class=\"select2 select-direction\" required=\"\" ng-model=\"address.comune\" ng-options=\"comune as comune.name for comune in address.comunes\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona tu comuna</option></select><input class=\"campo_login col-xs-8\" name=\"street\" placeholder=\"Nombre de tu Calle\" required=\"\" type=\"text\" ng-model=\"address.street_name\"> <input class=\"campo_login col-xs-4\" name=\"number\" placeholder=\"N°\" required=\"\" type=\"text\" ng-model=\"address.street_number\"> <input class=\"campo_login\" name=\"specific-number\" placeholder=\"N° Depto, Oficina, etc. (Opcional)\" type=\"text\" ng-model=\"address.specific_number\"></div></div><a class=\"siguiente\" ng-click=\"address.getLonLatFromAddress()\" ng-disabled=\"!(address.comune && address.street_name && address.street_number)\"><p>Guardar Dirección</p></a></div>");
$templateCache.put("app/address/mobile/address.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"address.closeModal()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\" ng-if=\"!(customerSession.isPasswordSaved || customerSession.error)\"><h2>Nueva dirección</h2></div><div class=\"modal-body\"><div class=\"modal-item\"><div class=\"modal-group\"><div class=\"modal-element\" ng-class=\"{\'input-error\': address.autocompleteInputError}\"><input id=\"autocompleteInput\" type=\"text\" name=\"street\" placeholder=\"Ingresa tu dirección\" ng-focus=\"address.addressAutocomplete()\" ng-change=\"address.handleAutocompleteInputChange()\" ng-blur=\"address.validateAutocompleteInput()\" ng-model=\"address.autocompleteInput\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 3000 } }\" required=\"\"> <span class=\"input-error-message\" ng-if=\"address.autocompleteInputError\">{{address.autocompleteInputErrorMessage}}</span></div></div></div><div id=\"address\" class=\"modal-item hidden\"><div class=\"modal-group\"><div id=\"mkt-formatted-address\" class=\"formatted-address\"><div class=\"formatted-address-title\"><i class=\"icon-map-pin\"></i><h5>{{address.titleAddress}}</h5></div><p class=\"address\">{{address.fullAddress}}</p></div></div></div><div id=\"complete-address\" class=\"modal-item hidden\"><div class=\"modal-group\"><h3>Completar dirección</h3></div><div class=\"modal-group\"><div class=\"modal-element\"><input type=\"text\" name=\"street-name\" placeholder=\"Calle\" maxlength=\"50\" ng-model=\"address.street_name\" required=\"\" disabled=\"\"></div><div class=\"modal-element\"><input id=\"street-number\" type=\"number\" name=\"street-number\" placeholder=\"Número\" ng-blur=\"address.street_name && address.getLonLatFromAddress(true)\" ng-model=\"address.street_number\" required=\"\"></div></div></div><div id=\"details\" class=\"modal-item hidden\"><div class=\"modal-group\"><h3>Agregar datos al delivery</h3></div><div class=\"modal-group\"><div class=\"modal-element\"><input type=\"text\" name=\"specific-number\" placeholder=\"{{address.localeSpecificNumber}}\" maxlength=\"50\" ng-model=\"address.specific_number\"></div><div class=\"modal-element\"><input type=\"text\" name=\"comment\" placeholder=\"Agregar nota de delivery. (opcional)\" maxlength=\"50\" ng-model=\"address.comment\"></div></div></div><div id=\"map\" class=\"modal-item hidden\"><gmap-iframe class=\"gmap-iframe\" lon-lat=\"{{address.lonLat}}\" map-lon-lat=\"{{address.mapLonLat}}\" map-options=\"{{address.mapOptions}}\" map-control=\"true\"><gmap-iframe></gmap-iframe></gmap-iframe></div><div id=\"validation\" class=\"modal-item hidden\"><label class=\"modal-label\">Valida tu dirección ingresando el código enviado a tu correo</label><div class=\"modal-group\"><div class=\"modal-element validation-code\"><input id=\"validation-code-input\" type=\"text\" class=\"validation-code\" name=\"validation-code\" ng-pattern=\"/^[a-zA-Z0-9]+$/\" placeholder=\"Código de validación\" ng-model=\"address.token\"></div></div></div><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-show=\"!address.addressValidation\" ng-click=\"address.saveAddress(true)\" ng-disabled=\"address.checkAddress()\">Guardar dirección</button><div class=\"resend-code\" ng-show=\"address.addressValidation\"><span>{{address.codeTimer}}s</span> <a id=\"resend-code-click\" ng-click=\"address.resendCode()\">Reenviar código <span class=\"icon icon-repeat\"></span></a></div><div class=\"validate-address\"><button class=\"btn submit-button\" ng-show=\"address.addressValidation && !address.validationInProgress\" ng-click=\"address.validateAddress()\">Validar dirección</button><loader template=\"ellipsis\" size=\"x-small\" ng-show=\"address.validationInProgress\"><loader></loader></loader></div></div></div>");
$templateCache.put("app/address/mobile/map-modal.html","<div class=\"address-modal\"><div class=\"modal-header\"><button type=\"button\" class=\"close close_modal\" ng-click=\"address.close()\"><span aria-hidden=\"true\">&times;</span></button><h1>Ingresa tu Dirección</h1></div><div class=\"modal-body container-fluid container-contenido modal-address\"><div id=\"map\"><div class=\"seccion__agregar__direccion\"><ui-gmap-google-map center=\"address.mapLonLat\" options=\"address.mapOptions\" pan=\"true\" zoom=\"16\"><ui-gmap-marker coords=\"address.lonLat\" idkey=\"1\" options=\"{draggable: true, icon: \'/assets/images/address_icon_\' + $environment + \'.png\'}\"></ui-gmap-marker><ui-gmap-map-control index=\"-1\" position=\"right-bottom\" template=\"app/address/restore/restore.html\"></ui-gmap-map-control></ui-gmap-google-map></div></div><button class=\"siguiente\" ng-click=\"address.saveAddress()\" ng-disabled=\"!address.street_name || !address.street_number\">Guardar dirección</button></div></div>");
$templateCache.put("app/address/mobile/new.html","<div class=\"container_site no__margin color_fondo__body\"><div class=\"container-fluid header__app\"><div class=\"contianer\"><a class=\"col-xs-3 retroceder\" ng-click=\"address.close()\"><i class=\"icon-arrow_ins_right\"></i></a> <a class=\"col-xs-6\" ui-sref=\"main\"><img src=\"assets/images/logo.png\" alt=\"\" width=\"70\" style=\"margin:0 auto; display:block;\"></a></div></div><div class=\"address-modal\"><h1>Ingresa tu Dirección</h1><div ng-if=\"address.step == 0\"><div class=\"welcome-checkout ending-order login-data\"><div class=\"container_campo_login\"><p>Selecciona tu comuna</p><select required=\"\" ng-change=\"!!(address.street_name && address.street_number) ? (address.getLonLatFromAddress(true)) : address.scrollTo(\'details\')\" ng-model=\"address.comune\" ng-options=\"comune as comune.name for comune in address.comunes\" class=\"select-direction\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona tu comuna</option></select><div class=\"clearfix\"></div><p ng-show=\"address.comune\">Escribe tu dirección</p><div class=\"row\" ng-show=\"address.comune\" id=\"details\"><div class=\"col-md-8\"><input class=\"large\" name=\"street\" placeholder=\"Nombre de tu Calle\" required=\"\" type=\"text\" ng-focus=\"address.fixCss($event, true)\" ng-blur=\"address.fixCss($event, false)\" ng-change=\"address.street_number && address.getLonLatFromAddress(true)\" ng-model=\"address.street_name\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 0 } }\"></div><div class=\"col-md-4\"><input class=\"large\" name=\"number\" placeholder=\"N°\" required=\"\" type=\"text\" ng-focus=\"address.fixCss($event, true)\" ng-blur=\"address.fixCss($event, false)\" ng-change=\"address.street_name && address.getLonLatFromAddress(true)\" ng-model=\"address.street_number\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 3000 } }\"></div><div class=\"col-md-4\"><input class=\"large\" name=\"specific-number\" ng-focus=\"address.fixCss($event, true)\" ng-blur=\"address.fixCss($event, false)\" placeholder=\"N° Depto, Oficina, etc. (Opcional)\" type=\"text\" ng-model=\"address.specific_number\"></div></div></div></div><button class=\"siguiente\" ng-click=\"address.selectOnMap()\" ng-disabled=\"!address.street_name || !address.street_number\">Siguiente</button></div><div ng-if=\"address.step == 1\"><div class=\"map-container login-data\"><p>Confirma la ubicación (arrastra el mapa hasta que el pin esté en la dirección deseada)</p><div id=\"map\"><div class=\"seccion__agregar__direccion\"><ui-gmap-google-map center=\"address.mapLonLat\" options=\"address.mapOptions\" draggable=\"true\" pan=\"true\" zoom=\"16\"><ui-gmap-map-control index=\"-1\" position=\"right-bottom\" template=\"app/address/restore/restore.html\"></ui-gmap-map-control></ui-gmap-google-map><div class=\"marker\"></div></div></div></div><button class=\"siguiente\" ng-click=\"address.saveAddress(true)\" ng-disabled=\"!address.street_name || !address.street_number\">Guardar dirección</button></div></div></div>");
$templateCache.put("app/address/restore/restore.html","<button class=\"btn mobile-size\" ng-click=\"$emit(\'restore-location\')\"><span class=\"icon icon-repeat\"></span><br>Restaurar<br>ubicación</button>");
$templateCache.put("app/amipass/desktop/amipass-processing.html","<header-cart></header-cart><style>\n  .lds-dual-ring {\n    display: inline-block;\n    width: 48px;\n    height: 48px;\n    margin-top: 20px;\n  }\n  .lds-dual-ring:after {\n    content: \" \";\n    display: block;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    border: 6px solid #4CAF50;\n    border-color: #4CAF50 transparent #4CAF50 transparent;\n    animation: lds-dual-ring 1.2s linear infinite;\n  }\n  @keyframes lds-dual-ring {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n</style><div class=\"tracking-container\"><div class=\"tracking-title-container\"><div class=\"tracking-body-container\"><div class=\"tracking-status-container\"><div class=\"tracking-description-container\"><div class=\"order-description-container\"><div class=\"order-description-title\"><h1 class=\"title\">Estamos confirmando tu pago</h1></div><div class=\"order-description-body\" style=\"align-items: center; flex-direction: column;\"><p class=\"processing-text\">En unos segundos te redirigiremos automáticamente al seguimiento de tu pedido.</p><div class=\"lds-dual-ring\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/cart/desktop/cart.products.html","<header-cart></header-cart><div class=\"container-cart\"><div class=\"my-cart\"><div class=\"my-cart-body\"><div class=\"item-heading\"><div class=\"item-container-heading\"><div class=\"item-body-heading\"><h5>Productos</h5></div><div class=\"item-price-heading\"><h5>Precio</h5></div><div class=\"item-controls-heading\"><h5>Cantidad</h5></div></div></div><div class=\"item-added\" ng-repeat=\"item in cart.items | orderBy:\'addedAt\'\"><div class=\"item-info\"><div class=\"item-body\"><div class=\"item-img\"><product-badge badge=\"highlight-text\" seleable=\"seleable\"></product-badge><div class=\"content\"><img ng-src=\"{{item.seleable.image.medium}}\" alt=\"{{item.seleable.name}}\"></div></div><div class=\"item-name\"><div class=\"item-box-name\"><p class=\"product-name\">{{item.seleable.name}}</p></div><div class=\"item-box-name description\" ng-repeat=\"option in cart.showOptions(item) track by $index\" ng-if=\"!!option\"><p class=\"item-description\">-</p><p class=\"item-description\">{{option}}</p></div></div></div><div class=\"item-price\"><div class=\"item-box-price\"><p class=\"total-price\" ng-show=\"cart.price(item, false) != cart.price(item, true)\">{{cart.cart.priceIntl(item.id, false, item.type, item.extraPrice)}}</p><p class=\"discount-price\">{{cart.cart.priceIntl(item.id, true, item.type, item.extraPrice)}}</p></div></div><div class=\"item-controls\"><div class=\"item-box-quantity\"><button class=\"btn-quantity left\" ng-click=\"cart.removeOne(item)\" ng-if=\"cart.productCount(item) > 1\"><i class=\"icon-minus\"></i></button> <button class=\"btn-quantity left\" ng-click=\"cart.removeProduct(item)\" ng-if=\"cart.productCount(item) === 1\"><img class=\"icon-remove\" src=\"assets/images/desktop/borrar.svg\"></button> <input class=\"input-quantity\" type=\"text\" id=\"inputSumador\" ng-value=\"cart.productCount(item)\" name=\"quantity\" disabled=\"\"> <button class=\"btn-quantity right\" ng-click=\"cart.addOne(item)\"><i class=\"icon-plus\"></i></button></div></div></div></div><div class=\"my-cart-shopping\" ng-show=\"cart.count\"><div class=\"container-order\" ng-show=\"cart.count\"><div class=\"container-coupon\"><p class=\"coupon-text\" ng-click=\"cart.showCouponArea()\">¿Tienes un cupón? Ingrésalo aquí</p><div id=\"inputs-area\" class=\"coupon hide\"><div class=\"my-coupon\"><input class=\"input-coupon\" name=\"coupon\" maxlength=\"50\" autocomplete=\"off\" placeholder=\"Cupón de descuento\" required=\"\" type=\"text\" ng-model=\"cart.coupon.code\" ng-disabled=\"!cart.customer\"> <button class=\"btn btn-coupon\" ng-click=\"cart.coupon.applyCoupon(true)\" ng-disabled=\"!cart.coupon.code\">Aplicar</button></div><p id=\"info-area\" class=\"coupon-info hide\" ng-show=\"!cart.customer\"><span>*</span> debes iniciar sesión para ingresar un cupón</p></div></div></div><div class=\"container-price\"><div class=\"subtotal\"><h5>Subtotal</h5><div class=\"subtotal-details\"><h5 class=\"without-discount\" ng-if=\"cart.discountable()\">{{cart.cart.parseIntl(cart.total)}}</h5><h5>{{cart.cart.parseIntl(cart.subtotalDiscount)}}</h5></div></div><div class=\"coupon\" ng-if=\"cart.currentCouponValue > 0\"><h5>Incluye cupón</h5><div class=\"coupon-value\"><h5>- {{cart.cart.showCoupon(cart.currentCoupon.coupon)}}</h5><a ng-click=\"cart.coupon.deactivateCoupon(cart.currentCoupon.coupon)\"><i class=\"icon-x\"></i></a></div></div></div><div class=\"container-price\"><div class=\"total\"><h5>Total</h5><h5>{{cart.cart.parseIntl(cart.totalDiscount)}}</h5></div></div><div id=\"open-restaurant\" class=\"container-open-restaurant hide\"><div class=\"open-restaurant\"><div id=\"countdown\"></div></div></div><div class=\"footer-cart-shopping\"><button ui-sref=\"menu\" class=\"btn btn-cart-shopping modifier-order\">Volver al menú</button> <button id=\"confirmation-order\" ui-sref=\"cart.whenhowwhere\" class=\"btn btn-cart-shopping confirmation-order hide\" ng-click=\"cart.validateState()\" disabled=\"disabled\"><span id=\"button-text\">Cerrado</span></button><loader template=\"ellipsis\"><loader></loader></loader></div></div></div><div class=\"my-cart-body upselling\"><div class=\"item-heading\"><div class=\"item-container-heading\"><div class=\"item-body-heading\"><h5 ng-if=\"cart.upsellingProducts.length > 0\">¿Un último antojo?</h5></div></div></div><div class=\"item-added\" ng-repeat=\"seleable in cart.upsellingProducts\" ng-if=\"cart.upsellingProducts.length > 0\"><div class=\"item-info upselling\"><div class=\"item-body upselling\"><div class=\"item-img\" ng-click=\"cart.viewSeleable(seleable, category)\"><product-badge badge=\"highlight-text\" seleable=\"seleable\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.image.medium}}\" alt=\"{{seleable.name}}\"></div></div><div class=\"item-name\"><div class=\"item-box-name\"><p class=\"product-name\">{{seleable.name}}</p></div><div class=\"item-box-name description\" ng-if=\"seleable.servings\"><p class=\"item-description\">({{seleable.servings}} porciones)</p></div><div class=\"item-box-name price\"><p class=\"total-price\" ng-show=\"cart.cart.priceValue(seleable, false, false) != cart.cart.priceValue(seleable, true, false)\">{{cart.cart.priceValue(seleable, false, true)}}</p><p class=\"discount-price\">{{cart.cart.priceValue(seleable, true, true)}}</p></div></div></div><div class=\"item-controls upselling\"><div class=\"item-box-quantity\" ng-controller=\"MenuController as menu\"><button class=\"btn-quantity upselling\" ng-click=\"menu.addToCart(seleable, category)\"><span>Agregar</span></button></div></div></div></div><div class=\"my-cart-shopping\" ng-show=\"cart.count\"><div class=\"additional-products\" ng-if=\"cart.additionalProducts.length > 0\"><div class=\"additional-items-info\" ng-show=\"cart.additionalItems.length > 0\"><p class=\"item-info\">Incluimos en tu pedido</p></div><div class=\"additional-items\"><div class=\"unitary-product\" ng-repeat=\"item in cart.additionalProducts\" ng-if=\"item.additional_type === \'unitary\'\"><input id=\"option-{{item.id}}\" ng-model=\"item.option_on\" ng-change=\"cart.toggleSwitch(item.id)\" type=\"checkbox\"> <label for=\"option-{{item.id}}\">{{ item.name}}<div class=\"toggle-switch\"></div></label></div></div><div class=\"additional-items-info\" ng-show=\"cart.additionalItems.length > 0\"><div class=\"all-additional-items\"><span ng-repeat=\"item in cart.additionalItems\"><em>{{cart.showAdditionalItem(item)}} &nbsp;</em></span></div></div></div></div></div></div></div>");
$templateCache.put("app/cart/desktop/cart.when-how-n-where.html","<header-cart></header-cart><div class=\"container-checkout\"><div class=\"welcome-checkout\"><h1>Finalicemos tu pedido</h1><div class=\"container-how\" ng-show=\"cart.contentLoaded\"><h5>¿Cómo te lo entregamos?</h5><div class=\"how-box-horizontal\"><input id=\"how-pickup\" name=\"how\" type=\"radio\" value=\"pickup\" ng-model=\"cart.how\" ng-change=\"cart.handlePickupDelivery(\'pickup\')\"> <label class=\"buttonselect pickup\" for=\"how-pickup\"><div class=\"pickup\"><span>{{cart.localePickup}}</span></div></label> <input id=\"how-delivery\" name=\"how\" type=\"radio\" value=\"delivery\" ng-model=\"cart.how\" ng-change=\"cart.handlePickupDelivery(\'delivery\')\"> <label class=\"buttonselect delivery\" for=\"how-delivery\"><div class=\"delivery\"><span>{{cart.localeDelivery}}</span> <small ng-if=\"!cart.cart.freeShipping()\">+ {{cart.cart.parseIntl(envConstants.DELIVERY)}} de envío</small> <small ng-if=\"cart.cart.freeShipping()\">Envío gratis</small></div></label></div></div><div class=\"container-how\" id=\"where\" ng-if=\"cart.how == \'pickup\' && !cart.hasPickup\"><div class=\"where-title\"><h5>Esta opción no está disponible en este momento.</h5></div></div><div class=\"container-how\" id=\"where\" ng-if=\"cart.how == \'pickup\' && cart.hasPickup\"><div class=\"where-title\"><h5>¿Dónde lo quieres?</h5><h6>Tiempo aprox</h6></div><p ng-if=\"!cart.pickupRestaurants.length\" class=\"p-message\">Locales cerrados momentáneamente. Por favor intenta más tarde.</p><div class=\"how-box-vertical\"><div id=\"container-where-restaurant-{{$index}}\" ng-repeat=\"location in cart.pickupRestaurants\" class=\"container-how-box-vertical\" ng-class=\"{\'hide\': ![0,1,2].includes($index)}\"><input type=\"radio\" id=\"where-restaurant-{{$index}}\" name=\"where-restaurant\" ng-value=\"location.id\" ng-model=\"cart.selectedLocationId\" ng-change=\"cart.selectQuestion(\'cual\', location)\" ng-click=\"cart.selectLocation(); cart.hideWhere(\'restaurant\', $index); cart.changeWhereElement(\'restaurant\', \'remove\')\"> <label class=\"buttonselect\" for=\"where-restaurant-{{$index}}\" ng-click=\"cart.selectLocation(); cart.hideWhere(\'restaurant\', $index); cart.changeWhereElement(\'restaurant\', \'remove\')\"><div class=\"location\"><p class=\"location-address\" ng-show=\"location.name\"><span>{{location.name}}</span> <small>{{location.comune_name}}, {{location.address}}</small></p><span class=\"pickup-time\" ng-show=\"location.current_pickup_time && location.current_pickup_time > 0\">{{location.current_pickup_time}} min.</span></div></label></div></div><p id=\"click-change-restaurant\" class=\"change-restaurant\" ng-click=\"cart.showWhere(); cart.changeWhereElement(\'restaurant\', \'add\')\">Cambiar de local</p><p class=\"change-location selected\" ng-if=\"envConstants.ALLOW_PRICE_LISTS === \'true\'\" ng-click=\"cart.openModalLocation()\">¿No encuentras tu local?</p></div><div class=\"container-how\" id=\"where\" ng-if=\"cart.how == \'delivery\' && !cart.hasDelivery\"><div class=\"where-title\"><h5>Las tiendas se encuentran momentáneamente sin delivery.</h5></div></div><div class=\"container-how\" id=\"where\" ng-if=\"cart.how == \'delivery\'\"><div class=\"where-title\"><h5>¿Dónde lo quieres?</h5><h6>Tiempo aprox</h6></div><div class=\"how-box-vertical\"><div id=\"container-where-address-{{$index}}\" ng-repeat=\"location in cart.addressLocations\" class=\"container-how-box-vertical\" ng-class=\"{\'hide\': ![0,1,2].includes($index)}\"><div class=\"separator-line\" ng-if=\"$index == 3\"></div><input type=\"radio\" id=\"where-address-{{$index}}\" name=\"where-address\" ng-value=\"location.id\" ng-model=\"cart.selectedLocationId\" ng-change=\"cart.selectQuestion(\'cual\', location)\" ng-click=\"cart.selectLocation(); cart.hideWhere(\'address\', $index); cart.changeWhereElement(\'address\', \'remove\'); cart.hideNewAddress();\" ng-if=\"location.assigned_restaurant_is_open && location.assigned_restaurant_group_is_correct\"> <input type=\"radio\" id=\"where-address-{{$index}}\" name=\"where-address\" ng-value=\"location.id\" ng-model=\"cart.selectedLocationId\" ng-if=\"!location.assigned_restaurant_is_open || !location.assigned_restaurant_group_is_correct\" disabled=\"\"> <label class=\"buttonselect\" for=\"where-address-{{$index}}\" ng-click=\"cart.selectLocation(); cart.hideWhere(\'address\', $index); cart.changeWhereElement(\'address\', \'remove\'); cart.hideNewAddress();\" ng-if=\"location.assigned_restaurant_is_open && location.assigned_restaurant_group_is_correct\"><div class=\"location\"><span class=\"location-address\" ng-show=\"location.address\">{{location.comune_name}} <span>|</span> <small class=\"location-street\">{{location.street_name}} #{{location.street_number}} <small ng-if=\"location.specific_number\">, {{location.specific_number}}</small></small></span> <span class=\"pickup-time\" ng-show=\"location.delivery_restaurant_pickup_time && location.delivery_restaurant_pickup_time > 0\">{{location.delivery_restaurant_pickup_time}} min.</span></div></label> <label class=\"buttonselect\" for=\"where-address-{{$index}}\" ng-if=\"!location.assigned_restaurant_is_open || !location.assigned_restaurant_group_is_correct\" disabled=\"\"><div class=\"location\"><span class=\"location-address\" ng-show=\"location.address\">{{location.comune_name}} <span>|</span> <small class=\"location-street\">{{location.street_name}} #{{location.street_number}} <small ng-if=\"location.specific_number\">, {{location.specific_number}}</small></small></span><div class=\"disabled-detail\"><span class=\"is-closed\" ng-if=\"!location.assigned_restaurant_is_open && location.assigned_restaurant_group_is_correct\">Local cerrado</span> <span class=\"change-region\" ng-if=\"!location.assigned_restaurant_group_is_correct && envConstants.ALLOW_PRICE_LISTS === \'true\'\" ng-click=\"cart.openModalLocation()\">Cambiar de región</span> <span class=\"no-coverage\" ng-if=\"!location.assigned_restaurant_group_is_correct && envConstants.ALLOW_PRICE_LISTS !== \'true\'\">Sin cobertura</span></div></div></label></div><a id=\"btn-new-address\" class=\"btn btn-direction\" href=\"javascript:void(0)\" ng-click=\"cart.newAddressModal(false)\"><span>Nueva dirección</span></a></div><p id=\"click-change-address\" class=\"change-address hide\" ng-click=\"cart.showWhere(); cart.changeWhereElement(\'address\', \'add\'); cart.showNewAddress();\">Ver mis direcciones</p></div><div class=\"container-how\" ng-show=\"cart.selectedLocationId && cart.how\"><h5>¿Cómo lo pagas?</h5><div class=\"how-box-horizontal payment\"><div class=\"container-how-box-horizontal\" ng-if=\"cart.kushkiPaymentOn && !cart.paymentCards.length > 0 && !cart.discountable()\"><input id=\"init-kushki\" name=\"cual\" type=\"radio\" value=\"kushki\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(0)\"> <label class=\"buttonselect payment\" for=\"init-kushki\"><div class=\"payment credit-card\"><div class=\"box-text\"><span>Pago en línea</span></div><div class=\"box-enter-card\" ng-click=\"cart.kushki.openModalInscriptionKushkiCard()\"><span class=\"enter-card\">Inscribir tarjeta</span></div></div></label></div><div class=\"container-how-box-horizontal\" ng-if=\"cart.kushkiPaymentOn && cart.paymentCards.length > 0 && !cart.discountable()\"><input id=\"{{cart.kushkiCard.token}}\" name=\"cual\" type=\"radio\" value=\"kushki\" ng-model=\"cart.paymentType\" ng-change=\"cart.selectedCardToken = cart.kushkiCard.token; cart.updatedDiscount(0); card.selectedCardId = cart.kushkiCard.id\"> <label class=\"buttonselect payment\" for=\"{{cart.kushkiCard.token}}\"><div class=\"payment credit-card\"><div class=\"box-text\"><span>Pago en línea</span> <span>{{cart.cart.cardTypeName(cart.kushkiCard.payment_brand)}}</span> <small>**** {{cart.kushkiCard.card_last_four}}</small></div><div class=\"box-enter-card\" ng-click=\"cart.openModalCreditCard(cart.kushkiCard.token)\"><span class=\"enter-card\">Otra tarjeta</span></div></div></label></div><div class=\"container-how-box-horizontal\" ng-if=\"cart.onlinePayment && !cart.tbkUser && !cart.discountable() && cart.onlinePaymentOn\"><input id=\"init-webpay\" name=\"cual\" type=\"radio\" value=\"webpay\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(0)\" ng-click=\"cart.initInscriptionUrl()\"> <label class=\"buttonselect payment\" for=\"init-webpay\" ng-click=\"cart.initInscriptionUrl()\"><div class=\"payment credit-card\"><div class=\"box-text\"><img src=\"assets/images/transbank/oneclick.svg\" alt=\"logo\"></div><div class=\"box-enter-card\" ng-click=\"cart.initInscriptionUrl(); cart.goToInscriptionbWebpay()\"><span class=\"enter-card\">Inscribir tarjeta</span></div></div></label></div><div class=\"container-how-box-horizontal\" ng-if=\"cart.onlinePayment && !!cart.tbkUser && !cart.discountable() && cart.onlinePaymentOn\"><input id=\"cual-webpay\" name=\"cual\" type=\"radio\" value=\"webpay\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(0)\"> <label class=\"buttonselect payment\" for=\"cual-webpay\"><div class=\"payment credit-card\"><div class=\"box-text\"><img src=\"assets/images/transbank/oneclick.svg\" alt=\"logo\"> <small>{{cart.cart.cardTypeName(cart.tbkUser.card_type)}} **** {{cart.tbkUser.last_4_card_digits}}</small></div><div class=\"box-enter-card\" ng-click=\"cart.openModalCreditCard(cart.tbkUser.id)\"><span class=\"enter-card\">Otra tarjeta</span></div></div></label></div><div class=\"container-how-box-horizontal\" ng-if=\"!cart.discountable()\"><input id=\"cual-efectivo\" name=\"cual\" type=\"radio\" value=\"efectivo\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(0)\"> <label class=\"buttonselect payment\" for=\"cual-efectivo\"><div class=\"payment\"><span>Contra entrega (efectivo, tarjeta de débito y crédito)</span></div></label></div><div class=\"container-how-box-horizontal\" ng-if=\"cart.kushkiPaymentOn && !cart.paymentCards.length > 0 && cart.discountable()\"><input id=\"init-kushki-discount\" name=\"cual\" type=\"radio\" value=\"kushki\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(cart.DEFAULT_DISCOUNT_1)\"> <label class=\"buttonselect payment\" for=\"init-kushki-discount\"><div class=\"payment credit-card\"><div class=\"box-text\"><span>Pago en línea</span> <small ng-if=\"cart.cart.showDiscountPercentage() && cart.DEFAULT_DISCOUNT_1 > 0\">{{cart.DEFAULT_DISCOUNT_1}}% Dcto.</small></div><div class=\"box-enter-card\" ng-click=\"cart.kushki.openModalInscriptionKushkiCard()\"><span class=\"enter-card\">Inscribir tarjeta</span></div></div></label></div><div class=\"container-how-box-horizontal\" ng-if=\"cart.kushkiPaymentOn && cart.paymentCards.length > 0 && cart.discountable()\"><input id=\"{{cart.kushkiCard.token}}\" name=\"cual\" type=\"radio\" value=\"kushki\" ng-model=\"cart.paymentType\" ng-change=\"cart.selectedCardToken = cart.kushkiCard.token; cart.updatedDiscount(cart.DEFAULT_DISCOUNT_1)\"> <label class=\"buttonselect payment\" for=\"{{cart.kushkiCard.token}}\"><div class=\"payment credit-card\"><div class=\"box-text\"><span>Pago en línea</span> <small>{{cart.cart.cardTypeName(cart.kushkiCard.payment_brand)}} **** {{cart.kushkiCard.card_last_four}}</small></div><div class=\"box-enter-card\" ng-click=\"cart.openModalCreditCard(cart.kushkiCard.token)\"><span class=\"enter-card\">Otra tarjeta</span></div></div></label></div><div class=\"container-how-box-horizontal\" ng-if=\"cart.onlinePayment && !cart.tbkUser && cart.discountable() && cart.onlinePaymentOn\"><input id=\"init-webpay-discount\" name=\"cual\" type=\"radio\" value=\"webpay\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(cart.DEFAULT_DISCOUNT_1)\" ng-click=\"cart.initInscriptionUrl()\"> <label class=\"buttonselect payment\" for=\"init-webpay-discount\" ng-click=\"cart.initInscriptionUrl()\"><div class=\"payment credit-card\"><div class=\"box-text\"><img src=\"assets/images/transbank/oneclick.svg\" alt=\"logo\"> <small ng-if=\"cart.cart.showDiscountPercentage() && cart.DEFAULT_DISCOUNT_1 > 0\">{{cart.DEFAULT_DISCOUNT_1}}% Dcto.</small></div><div class=\"box-enter-card\" ng-click=\"cart.initInscriptionUrl(); cart.goToInscriptionbWebpay()\"><span class=\"enter-card\">Inscribir tarjeta</span></div></div></label></div><div class=\"container-how-box-horizontal\" ng-if=\"cart.onlinePayment && !!cart.tbkUser && cart.discountable() && cart.onlinePaymentOn\"><input id=\"cual-webpay\" name=\"cual\" type=\"radio\" value=\"webpay\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(cart.DEFAULT_DISCOUNT_1)\"> <label class=\"buttonselect payment\" for=\"cual-webpay\"><div class=\"payment credit-card\"><div class=\"box-text\"><img src=\"assets/images/transbank/oneclick.svg\" alt=\"logo\"><div class=\"discount-price\"><small>{{cart.cart.cardTypeName(cart.tbkUser.card_type)}} **** {{cart.tbkUser.last_4_card_digits}}</small> <small>{{cart.DEFAULT_DISCOUNT_1}}% Dcto.</small></div></div><div class=\"box-enter-card\" ng-click=\"cart.openModalCreditCard(cart.tbkUser.id)\"><span class=\"enter-card\">Otra tarjeta</span></div></div></label></div><div class=\"container-how-box-horizontal\" ng-if=\"cart.onlinePayment && cart.onlinePaymentOn && cart.webpayplusPayment && cart.webpayplus_commerce_code\"><input id=\"cual-webpayplus\" name=\"cual\" type=\"radio\" value=\"webpayplus\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(cart.DEFAULT_DISCOUNT_1)\"> <label class=\"buttonselect payment\" for=\"cual-webpayplus\"><div class=\"payment\"><img src=\"assets/images/transbank/webpayplus.svg\" alt=\"logo\"> <small ng-if=\"cart.cart.showDiscountPercentage() && cart.DEFAULT_DISCOUNT_1 > 0\">{{cart.DEFAULT_DISCOUNT_1}}% Dcto.</small></div></label></div><div class=\"container-how-box-horizontal\" ng-if=\"cart.discountable()\"><input id=\"cual-efectivo-descuento\" name=\"cual\" type=\"radio\" value=\"efectivo\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(cart.DEFAULT_DISCOUNT_1)\"> <label class=\"buttonselect payment\" for=\"cual-efectivo-descuento\"><div class=\"payment\"><span>Contra entrega (efectivo, tarjeta de débito y crédito)</span> <small ng-if=\"cart.cart.showDiscountPercentage() && cart.DEFAULT_DISCOUNT_1 > 0\">{{cart.DEFAULT_DISCOUNT_1}}% Dcto.</small></div></label></div><div class=\"container-how-box-horizontal\" ng-if=\"cart.sodexoPayment && cart.discountable()\"><input id=\"cual-tarjeta-descuento\" name=\"cual\" type=\"radio\" value=\"tarjeta\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(cart.DEFAULT_DISCOUNT_2)\"> <label class=\"buttonselect payment\" for=\"cual-tarjeta-descuento\"><div class=\"payment\"><span>Tarjeta Sodexo</span> <small ng-if=\"cart.cart.showDiscountPercentage() && cart.DEFAULT_DISCOUNT_2 > 0\">{{cart.DEFAULT_DISCOUNT_2}}% Dcto. (contra entrega)</small></div></label></div><div class=\"container-how-box-horizontal\" ng-if=\"cart.sodexoPayment && !cart.discountable()\"><input id=\"cual-tarjeta\" name=\"cual\" type=\"radio\" value=\"tarjeta\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(0)\"> <label class=\"buttonselect payment\" for=\"cual-tarjeta\"><div class=\"payment\"><span>Tarjeta Sodexo</span> <small>(contra entrega)</small></div></label></div></div></div><div id=\"tip\" class=\"container-how\" ng-if=\"cart.showTips()\"><h5>¿Agregas propina?</h5><div class=\"how-box-horizontal tip\"><input id=\"tip-{{$index}}\" name=\"tip\" type=\"radio\" ng-init=\"cart.checkedTip(tip)\" ng-value=\"tip.id\" ng-model=\"cart.selectedTip.id\" ng-click=\"cart.selectTip(tip)\" ng-repeat-start=\"tip in cart.tips\"> <label class=\"buttonselect\" for=\"tip-{{$index}}\" ng-click=\"cart.selectTip(tip)\" ng-repeat-end=\"\"><div class=\"tip\"><span ng-show=\"cart.cart.parseIntl(tip.amount)\">{{cart.cart.parseIntl(tip.amount)}}</span></div></label></div></div><div class=\"container-how no-gap\" ng-if=\"cart.selectedLocationId && cart.how && cart.paymentType\"><div class=\"how-box-total\"><div class=\"total\"><h5>Subtotal</h5><h5>{{cart.cart.parseIntl(cart.subTotal)}}</h5></div><div class=\"total\" ng-if=\"cart.how == \'delivery\'\"><h5 class=\"additional\">Delivery</h5><h5 class=\"additional\" ng-if=\"!cart.cart.freeShipping()\">+ {{cart.cart.parseIntl(envConstants.DELIVERY)}}</h5><h5 class=\"additional\" ng-if=\"cart.cart.freeShipping()\">Envío gratis</h5></div><div class=\"total\" ng-if=\"!!cart.selectedTip.id && cart.showTips()\"><h5 class=\"additional\">Propina</h5><h5 class=\"additional\">+ {{cart.cart.parseIntl(cart.selectedTip.amount)}}</h5></div><div class=\"total\" ng-if=\"cart.currentCouponValue > 0\"><h5 class=\"additional\">Incluye cupón</h5><h5 class=\"additional\">- {{cart.cart.showCoupon(cart.currentCoupon.coupon)}} dcto</h5></div></div><div class=\"how-box-total\"><div class=\"total\"><h5>Total</h5><h5>{{cart.cart.parseIntl(cart.totalPay)}}</h5></div></div></div><div class=\"container-how order-confirmation\"><div class=\"how-box-payment\" ng-if=\"cart.selectedLocationId && cart.how && cart.paymentType\"><button class=\"btn btn-payment go-back\" ui-sref=\"cart.products\">Volver al carro</button></div><div class=\"how-box-payment\" ng-if=\"cart.selectedLocationId && cart.how && cart.paymentType && cart.paymentType !== \'webpayplus\'\"><button class=\"btn btn-payment\" ng-click=\"cart.sendOrder()\" ng-show=\"!cart.inProgress\" ng-disabled=\"cart.initInscriptionButton || cart.inProgress || cart.isClosed || !cart.selectedLocationId || !cart.paymentType || cart.processingWebPayment || !cart.how\">Confirmar compra</button><loader template=\"ellipsis\" ng-show=\"cart.inProgress\"><loader></loader></loader></div><div class=\"how-box-payment\" ng-if=\"cart.selectedLocationId && cart.how && cart.paymentType && cart.paymentType === \'webpayplus\'\"><button class=\"btn btn-payment\" ng-click=\"cart.sendToPaymentPortal()\">Ir a pagar<br></button></div></div></div></div>");
$templateCache.put("app/cart/desktop/price-warning.modal.html","<div class=\"price-warning-modal\"><div class=\"modal-header\"><button class=\"close-button\" ng-click=\"$close(false)\"><i class=\"icon-x\"></i></button><h1>¡Atención!</h1></div><div class=\"modal-body\"><p>Recuerda que pedidos mayores a {{parseIntl(envConstants.WARNING_PRICE)}} deben ser pagados previos a que se produzcan.</p><p>Te recomendamos pagar en línea, o contactarte con el local para coordinar el pago.</p><p>Gracias por tu comprensión</p></div><div class=\"modal-footer\"><button ng-click=\"cancel()\">Entendido</button></div></div>");
$templateCache.put("app/cart/desktop/removeProduct.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"confirmation.removeProductModal(false)\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><h2>Confirmar</h2></div><div class=\"modal-body\"><div class=\"modal-item\"><p>¿Deseas eliminar este producto: \"{{confirmation.product.seleable.name}}\"?</p><div class=\"form-checkbox-inline\"><div class=\"form-checkbox\"><input id=\"option-yes\" name=\"si\" type=\"radio\" ng-click=\"confirmation.removeProductModal(true)\"> <label for=\"option-yes\" class=\"button-select\"><div class=\"checkbox-label\"><span>Si</span></div></label></div><div class=\"form-checkbox\"><input id=\"option-no\" name=\"no\" type=\"radio\" ng-click=\"confirmation.removeProductModal(false)\"> <label for=\"option-no\" class=\"button-select\"><div class=\"checkbox-label\"><span>No</span></div></label></div></div></div></div>");
$templateCache.put("app/amipass/mobile/amipass-processing.html","<header-cart></header-cart><style>\n  /* Spinner verde */\n  .amipass-spinner {\n    display: inline-block;\n    width: 48px;\n    height: 48px;\n    margin-top: 25px;\n  }\n\n  .amipass-spinner:after {\n    content: \" \";\n    display: block;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    border: 6px solid #4CAF50;\n    border-color: #4CAF50 transparent #4CAF50 transparent;\n    animation: amipass-ring 1.2s linear infinite;\n  }\n\n  @keyframes amipass-ring {\n    0%   { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n</style><div class=\"tracking-container\"><div class=\"tracking-body-container\" style=\"margin-top: 20px;\"><div class=\"tracking-description-container\"><div class=\"order-description-container\"><div class=\"order-description-body-container\"><div class=\"order-description-title\"><h1>Estamos confirmando tu pago</h1></div><div class=\"order-description-body\" style=\"align-items: center; flex-direction: column;\"><p class=\"processing-text\" style=\"text-align:center; margin-top: 10px;\">En unos segundos te redirigiremos automáticamente al seguimiento de tu pedido.</p><div class=\"amipass-spinner\"></div></div></div></div></div></div></div>");
$templateCache.put("app/client-contact/desktop/contact-form.html","<header-cart></header-cart><div class=\"client-contact\"><div class=\"container-client-contact\"><div class=\"client-contact-form\"><form name=\"form\" ng-submit=\"custom_form.submitForm()\"><div class=\"form-element\"><div class=\"form-element-select\"><select required=\"\" ng-model=\"custom_form.customForm.reason\" ng-options=\"reason.reason as reason.name for reason in custom_form.reasons\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona el motivo</option></select></div></div><div class=\"form-element\"><div class=\"form-element-select\"><select required=\"\" ng-model=\"custom_form.customForm.restaurant\" ng-options=\"restaurant.name as restaurant.name for restaurant in custom_form.restaurants\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Restaurant</option></select></div></div><div class=\"form-element\"><div class=\"form-elements-group\"><input placeholder=\"Nombre\" name=\"first_name\" ng-model=\"custom_form.customForm.first_name\" required=\"\"></div><div class=\"form-elements-group\"><input placeholder=\"Apellido\" name=\"last_name\" ng-model=\"custom_form.customForm.last_name\" required=\"\"></div></div><div class=\"form-element\"><div class=\"form-elements-group\"><phone-select number=\"custom_form.customForm.phone\" btn-submit-id=\"submit-client-contact\" model=\"custom_form.customForm.phone\" object=\"custom_form\" form-name=\"form\" class=\"form-element-phone\"></phone-select></div><div class=\"form-elements-group\"><input placeholder=\"Email con que hiciste la compra\" type=\"email\" name=\"email\" ng-model=\"custom_form.customForm.email\" required=\"\"></div></div><div class=\"form-element\"><div class=\"form-element-select\"><select ng-model=\"custom_form.customForm.origin\" ng-options=\"origin as origin for origin in custom_form.origins\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">Origen del pedido</option></select></div></div><div class=\"form-element\"><textarea type=\"text\" name=\"review\" placeholder=\"Comentario\" ng-model=\"custom_form.customForm.review\">\n          </textarea></div><div class=\"btn-submit-contact\"><button type=\"submit\" id=\"submit-client-contact\" class=\"btn-next\" ng-disabled=\"form.$invalid || custom_form.isDisabled\">Enviar</button></div></form></div></div><footer-cart></footer-cart></div>");
$templateCache.put("app/client-contact/desktop/success.html","<header-cart></header-cart><div class=\"client-contact-success\"><div class=\"client-container-success\"><div class=\"contact-form-success\"><h3>¡Gracias <span class=\"red\">{{custom_form.customForm.first_name}}!</span></h3><p>Hemos recibido tu comentario, te contactaremos pronto</p><img src=\"assets/images/niufoods-dots.png\" alt=\"niufoods\"></div><div class=\"followbox\"><a ui-sref=\"main\"><span class=\"follow\">SEGUIR EXPLORANDO LA WEB</span></a></div></div><footer-cart></footer-cart></div>");
$templateCache.put("app/client-contact/mobile/contact-form.html","<header-cart></header-cart><div class=\"client-contact\"><div class=\"container-client-contact\"><div class=\"client-contact-form\"><form name=\"form\" ng-submit=\"custom_form.submitForm()\"><div class=\"form-element\"><div class=\"form-element-select\"><select required=\"\" ng-model=\"custom_form.customForm.reason\" ng-options=\"reason.reason as reason.name for reason in custom_form.reasons\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona el motivo</option></select></div></div><div class=\"form-element\"><div class=\"form-element-select\"><select required=\"\" ng-model=\"custom_form.customForm.restaurant\" ng-options=\"restaurant.name as restaurant.name for restaurant in custom_form.restaurants\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Restaurant</option></select></div></div><div class=\"form-element\"><div class=\"form-elements-group\"><input placeholder=\"Nombre\" name=\"first_name\" ng-model=\"custom_form.customForm.first_name\" required=\"\"></div></div><div class=\"form-element\"><div class=\"form-elements-group\"><input placeholder=\"Apellido\" name=\"last_name\" ng-model=\"custom_form.customForm.last_name\" required=\"\"></div></div><div class=\"form-element\"><div class=\"form-elements-group\"><phone-select number=\"custom_form.customForm.phone\" btn-submit-id=\"submit-client-contact\" model=\"custom_form.customForm.phone\" object=\"custom_form\" form-name=\"form\" class=\"form-element-phone\"></phone-select></div></div><div class=\"form-element\"><input placeholder=\"Email con que hiciste la compra\" type=\"email\" name=\"email\" ng-model=\"custom_form.customForm.email\" required=\"\"></div><div class=\"form-element\"><div class=\"form-element-select\"><select ng-model=\"custom_form.customForm.origin\" ng-options=\"origin as origin for origin in custom_form.origins\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">Origen del pedido</option></select></div></div><div class=\"form-element\"><textarea type=\"text\" name=\"review\" placeholder=\"Comentario\" ng-model=\"custom_form.customForm.review\">\n          </textarea></div><div class=\"btn-submit-contact\"><button type=\"submit\" id=\"submit-client-contact\" class=\"btn-next\" ng-disabled=\"form.$invalid || custom_form.isDisabled\">Enviar</button></div></form></div></div></div>");
$templateCache.put("app/client-contact/mobile/success.html","<header-cart></header-cart><div class=\"client-contact-success\"><div class=\"contact-form-success\"><h3>¡Gracias <span class=\"red\">{{custom_form.customForm.first_name}}!</span></h3><p>Hemos recibido tu comentario, te contactaremos pronto</p><img src=\"assets/images/niufoods-dots.png\" alt=\"niufoods\"></div><div class=\"followbox\"><a ui-sref=\"main\"><span class=\"follow\">SEGUIR EXPLORANDO LA WEB</span></a></div></div>");
$templateCache.put("app/checkout/desktop/checkout-tips.modal.html","<div class=\"modal-header\"><div class=\"modal-header-title\"><h2>Otro monto</h2></div><div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"checkout.closeModal()\"><i class=\"icon-x\"></i></button></div></div><div class=\"modal-body\"><div class=\"checkout-tips-container\"><div class=\"checkout-tips\"><div class=\"checkout-input-tip\"><input class=\"input-tip\" name=\"tip\" type=\"number\" onkeypress=\"return /[0-9]/i.test(event.key)\" onpaste=\"return false\" placeholder=\"Ingresa un monto\" ng-model=\"checkout.tipModal\" ng-change=\"checkout.validateTip()\" required=\"\"> <button class=\"btn btn-tip\" ng-click=\"checkout.selectTipModal(checkout.tipModal); checkout.closeModal();\">Agregar</button></div></div></div></div>");
$templateCache.put("app/checkout/desktop/checkout.html","<header-checkout></header-checkout><div class=\"checkout\"><div class=\"checkout-container\"><div class=\"checkout-delivery-details\" ng-show=\"checkout.skeletonShow\"><skeleton-screen class=\"full-width\" template=\"checkout-delivery-details\"></skeleton-screen></div><div class=\"checkout-delivery-details\" ng-show=\"!checkout.skeletonShow\"><div class=\"checkout-select-delivery-pickup-container\"><div class=\"checkout-select-delivery-pickup\"><input id=\"how-delivery\" name=\"how-delivery\" type=\"radio\" value=\"delivery\" ng-model=\"checkout.how\" ng-change=\"checkout.updateSkeleton(true); checkout.handlePickupDelivery(checkout.deliveryText)\"> <label class=\"checkout-button-select\" for=\"how-delivery\"><span>{{checkout.localeDelivery}}</span></label> <input id=\"how-pickup\" name=\"how-pickup\" type=\"radio\" value=\"pickup\" ng-model=\"checkout.how\" ng-change=\"checkout.updateSkeleton(true); checkout.handlePickupDelivery(checkout.pickupText)\"> <label class=\"checkout-button-select\" for=\"how-pickup\"><span>{{checkout.localePickup}}</span></label></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.deliveryText && !checkout.hasDelivery\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title\"><h1>Las tiendas se encuentran momentáneamente sin delivery.</h1></div></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.deliveryText && checkout.hasDelivery && !checkout.addressLocations.length > 0\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title\"><h1>Detalles de despacho</h1></div></div><div class=\"checkout-delivery-body\" ng-click=\"checkout.newAddressSidebarModal()\"><div class=\"checkout-delivery-icon\"><i class=\"icon-plus\"></i></div><div class=\"checkout-delivery-addresses\"><div class=\"checkout-delivery\"><p>Agregar una nueva dirección</p></div></div><div class=\"checkout-select-delivery\"><i class=\"icon-chevron-right\"></i></div></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.deliveryText && checkout.hasDelivery && !checkout.selectedLocation && checkout.addressLocations.length > 0\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title\"><h1>Detalles de despacho</h1></div></div><div class=\"checkout-delivery-body\" ng-click=\"checkout.deliveryPickupModal()\"><div class=\"checkout-delivery-icon\"><i class=\"icon-map-pin\"></i></div><div class=\"checkout-delivery-addresses\"><div class=\"checkout-pickup\"><p>Seleccione una dirección</p></div></div><div class=\"checkout-select-delivery\"><i class=\"icon-chevron-right\"></i></div></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.deliveryText && checkout.hasDelivery && !!checkout.selectedLocation\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title\"><h1>Detalles de despacho</h1></div></div><div class=\"checkout-delivery-body\" ng-click=\"checkout.deliveryPickupModal()\"><div class=\"checkout-delivery-icon\"><i class=\"icon-ready-on-the-way\"></i></div><div class=\"checkout-delivery-addresses\"><div class=\"checkout-delivery\"><p class=\"active\">Despacho en: <span>{{checkout.selectedLocation.comune_name}}</span></p><p>{{checkout.selectedLocation.street_name}} #{{checkout.selectedLocation.street_number}} <span ng-if=\"!!checkout.selectedLocation.specific_number\">, {{checkout.selectedLocation.specific_number}}</span></p></div></div><div class=\"checkout-select-delivery\"><i class=\"icon-chevron-right\"></i></div></div><div id=\"checkout-scheduled-order-body\" class=\"checkout-scheduled-order-body closed-select\" ng-if=\"checkout.canBeActivatedScheduledOrder()\" ng-click=\"checkout.toggleScheduleOrderOptions()\"><div class=\"body\"><div class=\"checkout-delivery-icon\"><i class=\"icon-pickup-time\"></i></div><div class=\"checkout-scheduled-order\"><div class=\"checkout-delivery\"><p id=\"{{checkout.now}}\" class=\"active\" ng-if=\"checkout.scheduledOrder === checkout.now\"><span>{{checkout.nowTextByDefault}}</span> <span class=\"pickup-time\">{{checkout.selectedLocation.delivery_restaurant_pickup_time}} min</span></p><p id=\"{{checkout.scheduled}}\" class=\"active\" ng-if=\"checkout.scheduledOrderActivated() && !checkout.scheduledOrderDateTime\"><span>{{checkout.scheduledTextByDefault}}</span> <span class=\"warning\">Solo permite pagos digitales</span></p><p id=\"time-scheduled-order\" class=\"active\" ng-if=\"checkout.scheduledOrderActivated() && checkout.scheduledOrderDateTime\"><span>{{checkout.scheduledOrderDateTimeLabel}}</span> <span class=\"warning\">Solo permite pagos digitales</span></p></div></div><div class=\"checkout-select-delivery-scheduled-order\"><i id=\"icon-chevron-scheduled-order\" class=\"icon-chevron-right\"></i></div></div><div class=\"select\"><div id=\"select-schedule-order\" class=\"select-schedule-order-content scroll-bar not-visible\"><label for=\"option-{{$index}}\" ng-repeat=\"option in checkout.scheduledDayOptions\" ng-click=\"checkout.updateStateScheduledOrder(this.option.forSchedule, this.option.day); $event.stopPropagation()\"><input id=\"option-{{$index}}\" class=\"input-schedule-order\" type=\"radio\" name=\"option-{{$index}}\" value=\"{{option.id}}\" ng-model=\"checkout.selectedDateTime\" attr.data-scheduled=\"{{option.forSchedule}}\"> <span>{{option.day}}</span></label></div></div></div><div class=\"checkout-delivery-maps\" ng-if=\"!!checkout.selectedLocation\"><ui-gmap-google-map center=\"checkout.selectedLocation.lonlat\" options=\"checkout.mapOptions\" pan=\"true\" zoom=\"16\"><ui-gmap-marker coords=\"checkout.selectedLocation.lonlat\" idkey=\"1\" options=\"{draggable: true, icon: \'/assets/images/address_icon_\' + $environment + \'.png\'}\"></ui-gmap-marker></ui-gmap-google-map></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.pickupText && !checkout.hasPickup\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title\"><h1>{{checkout.closedRestaurant}} momentáneamente. Por favor intenta más tarde.</h1></div></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.pickupText && checkout.hasPickup && !checkout.selectedLocation\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title\"><h1>Detalles de retiro</h1></div></div><div class=\"checkout-delivery-body\" ng-click=\"checkout.deliveryPickupModal()\"><div class=\"checkout-delivery-icon\"><i class=\"icon-map-pin\"></i></div><div class=\"checkout-delivery-addresses\"><div class=\"checkout-pickup\"><p>Seleccione un local</p></div></div><div class=\"checkout-select-delivery\"><i class=\"icon-chevron-right\"></i></div></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.pickupText && checkout.hasPickup && !!checkout.selectedLocation\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title\"><h1>Detalles de retiro</h1></div></div><div class=\"checkout-delivery-body\" ng-click=\"checkout.deliveryPickupModal()\"><div class=\"checkout-delivery-icon\"><i class=\"icon-delivered\"></i></div><div class=\"checkout-delivery-addresses\"><div class=\"checkout-pickup\" ng-if=\"!!checkout.selectedLocation\"><p class=\"active\">Retiro en: <span>{{checkout.selectedLocation.name}}</span></p><p>{{checkout.selectedLocation.comune_name}}, {{checkout.selectedLocation.address}}</p></div></div><div class=\"checkout-select-delivery\"><i class=\"icon-chevron-right\"></i></div></div><div id=\"checkout-scheduled-order-body\" class=\"checkout-scheduled-order-body closed-select\" ng-if=\"checkout.canBeActivatedScheduledOrder()\" ng-click=\"checkout.toggleScheduleOrderOptions()\"><div class=\"body\"><div class=\"checkout-delivery-icon\"><i class=\"icon-pickup-time\"></i></div><div class=\"checkout-scheduled-order\"><div class=\"checkout-delivery\"><p id=\"{{checkout.now}}\" class=\"active\" ng-if=\"checkout.scheduledOrder === checkout.now\"><span>{{checkout.nowTextByDefault}}</span> <span class=\"pickup-time\">{{checkout.selectedLocation.current_pickup_time}} min</span></p><p id=\"{{checkout.scheduled}}\" class=\"active\" ng-if=\"checkout.scheduledOrderActivated() && !checkout.scheduledOrderDateTime\"><span>{{checkout.scheduledTextByDefault}}</span> <span class=\"warning\">Solo permite pagos digitales</span></p><p id=\"time-scheduled-order\" class=\"active\" ng-if=\"checkout.scheduledOrderActivated() && checkout.scheduledOrderDateTime\"><span>{{checkout.scheduledOrderDateTimeLabel}}</span> <span class=\"warning\">Solo permite pagos digitales</span></p></div></div><div class=\"checkout-select-delivery-scheduled-order\"><i id=\"icon-chevron-scheduled-order\" class=\"icon-chevron-right\"></i></div></div><div class=\"select\"><div id=\"select-schedule-order\" class=\"select-schedule-order-content scroll-bar not-visible\"><label for=\"option-{{$index}}\" ng-repeat=\"option in checkout.scheduledDayOptions\" ng-click=\"checkout.updateStateScheduledOrder(this.option.forSchedule, this.option.day); $event.stopPropagation()\"><input id=\"option-{{$index}}\" class=\"input-schedule-order\" type=\"radio\" name=\"option-{{$index}}\" value=\"{{option.id}}\" ng-model=\"checkout.selectedDateTime\" attr.data-scheduled=\"{{option.forSchedule}}\"> <span>{{option.day}}</span></label></div></div></div><div class=\"checkout-delivery-maps\" ng-if=\"!!checkout.selectedLocation\"><ui-gmap-google-map center=\"checkout.selectedLocation.lonlat\" options=\"checkout.mapOptions\" pan=\"true\" zoom=\"16\"><ui-gmap-marker coords=\"checkout.selectedLocation.lonlat\" idkey=\"1\" options=\"{draggable: true, icon: \'/assets/images/address_icon_\' + $environment + \'.png\'}\"></ui-gmap-marker></ui-gmap-google-map></div></div><div class=\"checkout-payment-method-container\" ng-if=\"checkout.hasDelivery && !!checkout.selectedLocation\"><div class=\"checkout-payment-method-title\"><div class=\"payment-method-title\"><h1>Método de pago</h1></div></div><div class=\"checkout-payment-method-body\" ng-click=\"checkout.paymentMethodModal()\"><div class=\"checkout-payment-method\"><div class=\"checkout-payment-card\" ng-repeat=\"payment in checkout.availablePayments\" ng-if=\"!checkout.paymentType\"><div class=\"checkout-payment-card-icon\"><img ng-if=\"checkout.paymentConfig[payment.type].icon\" ng-src=\"{{ checkout.paymentConfig[payment.type].icon }}\" alt=\"payment-logo\"> <i ng-if=\"!checkout.paymentConfig[payment.type].icon\" class=\"icon-credit-card\"></i></div><div class=\"checkout-payment-card-text\"><p>{{ checkout.paymentConfig[payment.type].label }}</p><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.paymentConfig[payment.type].discount > 0\">{{ checkout.paymentConfig[payment.type].discount }}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"!checkout.paymentType && !checkout.availablePayments.length\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><div class=\"checkout-payment-card-text\"><p>Selecciona método de pago</p></div></div><div class=\"checkout-payment-card\" ng-if=\"(checkout.paymentType == \'webpay\' && !checkout.onlinePaymentOn) || (checkout.paymentType == \'kushki\' && !checkout.kushkiPaymentOn)\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><div class=\"checkout-payment-card-text\"><img src=\"assets/images/kushki/logo-kushki.svg\" alt=\"logo\"></div></div><div class=\"checkout-payment-card\" ng-if=\"(checkout.paymentType == \'webpay\' && !checkout.tbkUser) || (checkout.paymentType == \'kushki\' && !checkout.paymentCards.length > 0)\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><div class=\"checkout-payment-card-text\"><img src=\"assets/images/transbank/webpayplus.svg\" alt=\"logo\"></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.country === \'MX\' && checkout.paymentType == \'kushki\' && checkout.kushkiPaymentOn && checkout.kushkiCard\"><div class=\"checkout-payment-card-icon\"><img ng-src=\"{{ checkout.getCardLogo(checkout.kushkiCard.payment_brand) }}\" alt=\"card-logo\"></div><div class=\"checkout-payment-card-text\"><p>**** {{ checkout.kushkiCard.card_last_four }} <span>({{ checkout.customer.name }})</span></p><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_1 > 0\">{{ checkout.DEFAULT_DISCOUNT_1 }}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.country !== \'MX\' && checkout.paymentType == \'oneclick\' && checkout.onlinePaymentOn && checkout.tbkUser\"><div class=\"checkout-payment-card-icon\"><img ng-src=\"{{ checkout.getCardLogo(checkout.tbkUser.card_type) }}\" alt=\"card-logo\"></div><div class=\"checkout-payment-card-text\"><p>**** {{ checkout.tbkUser.last_4_card_digits }} <span>({{ checkout.customer.name }})</span></p><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_1 > 0\">{{ checkout.DEFAULT_DISCOUNT_1 }}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'webpayplus\'\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><div class=\"checkout-payment-card-text\"><img src=\"assets/images/transbank/webpayplus.svg\" alt=\"logo\"><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_1 > 0\">{{checkout.DEFAULT_DISCOUNT_1}}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'cash\'\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><div class=\"checkout-payment-card-text\"><p ng-if=\"checkout.country == \'CL\'\">Efectivo, tarjeta de débito y crédito (RedCompra) - Presencial</p><p ng-if=\"checkout.country == \'MX\'\">Pago contra entrega - Efectivo, tarjeta de débito y crédito</p><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_1 > 0\">{{checkout.DEFAULT_DISCOUNT_1}}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'amipass\'\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><div class=\"checkout-payment-card-text\"><img src=\"assets/images/amipass/amipass_logo.png\" alt=\"logo\"><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_2 > 0\">{{checkout.DEFAULT_DISCOUNT_2}}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'pluxee\'\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><div class=\"checkout-payment-card-text\"><img src=\"assets/images/pluxee/pluxee_logo.png\" alt=\"logo\"><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_2 > 0\">{{checkout.DEFAULT_DISCOUNT_2}}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'amipass\'\"><div class=\"checkout-payment-card-text\"><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_2 > 0\">{{checkout.DEFAULT_DISCOUNT_2}}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'pluxee\'\"><div class=\"checkout-payment-card-text\"><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_2 > 0\">{{checkout.DEFAULT_DISCOUNT_2}}% de descuento</p></div></div></div><div class=\"checkout-select-payment-method\"><i class=\"icon-chevron-right\"></i></div></div></div><div class=\"checkout-tips-container\" ng-if=\"checkout.showTips() && checkout.hasDelivery && !!checkout.selectedLocation\"><div class=\"checkout-tips-title\"><div class=\"tips-title\"><h1>Propina al repartidor</h1></div></div><div class=\"checkout-tips-body\"><div class=\"checkout-tip\" ng-repeat=\"tip in checkout.tips\"><input id=\"tip-{{$index}}\" name=\"tip\" type=\"radio\" ng-init=\"checkout.checkedTip(tip)\" ng-value=\"tip.id\" ng-model=\"checkout.selectedTip.id\" ng-click=\"checkout.selectTip(tip); checkout.blockTip();\"> <label class=\"buttonselect\" for=\"tip-{{$index}}\" ng-click=\"checkout.selectTip(tip); checkout.blockTip();\"><div class=\"tip\"><span ng-if=\"checkout.cart.parseIntl(tip.amount)\">{{checkout.cart.parseIntl(tip.amount)}}</span></div></label></div><div class=\"checkout-tip\"><div id=\"other-tip\" class=\"other-tip\" ng-click=\"checkout.checkoutTipsModal()\"><span ng-if=\"!checkout.otherTip\">Otro monto</span> <span ng-if=\"checkout.otherTip\">{{checkout.cart.parseIntl(checkout.selectedTip.amount)}}</span></div></div></div><div class=\"checkout-tips-footer\"><p>El 100% de la propina va a nuestros repartidores! Ten en consideración la distancia a tu destino.</p></div></div><div class=\"checkout-coupon-container\" ng-if=\"checkout.hasDelivery && !!checkout.selectedLocation\"><div class=\"checkout-coupon-body-container\"><div class=\"checkout-coupon-body\" ng-click=\"checkout.customerCouponsModal()\" ng-if=\"!checkout.currentCoupon\"><div class=\"checkout-coupon\"><p>¿Tienes un cupón?</p></div></div></div><div class=\"checkout-coupon-body checkout-coupon-detail\" ng-if=\"!!checkout.currentCoupon\"><div class=\"checkout-coupon\"><div class=\"checkout-coupon-detail\"><span>{{checkout.currentCoupon.coupon.code}}</span> <small ng-if=\"checkout.currentCoupon.coupon.min_amount > 0\">{{checkout.currentCoupon.coupon.caption}}</small></div><div class=\"checkout-coupon-remove\" ng-click=\"checkout.coupon.deactivateCoupon(checkout.currentCoupon.coupon)\"><p>[Eliminar]</p></div></div></div></div></div><div class=\"checkout-items-details\" ng-show=\"checkout.skeletonShow\"><skeleton-screen class=\"full-width\" template=\"checkout-items-details\"></skeleton-screen></div><div class=\"checkout-items-details\" ng-show=\"!checkout.skeletonShow\"><div class=\"checkout-items-container\"><div class=\"checkout-items-title\"><div class=\"items-title\"><h1>Detalles de tu compra</h1></div></div><div class=\"checkout-items-body\"><div class=\"checkout-price-details-container\" ng-class=\"{\'totals-loading\': checkout.loadingTotals}\"><div class=\"checkout-price-details\"><div class=\"price-details\"><p>Subtotal</p><p class=\"price\">{{ checkout.cart.parseIntl(checkout.subtotalAmount) }}</p></div><div class=\"price-details discount\" ng-if=\"checkout.productDiscountAmount > 0\"><p>Descuento</p><p>-{{ checkout.cart.parseIntl(checkout.productDiscountAmount) }}</p></div><div class=\"price-details discount\" ng-if=\"checkout.paymentType == \'tarjeta\' && checkout.discountable() && checkout.validateDiscount()\"><p>Descuento {{checkout.DEFAULT_DISCOUNT_2}}%</p><p>{{checkout.cart.parseIntl(checkout.productDiscountAmount)}}</p></div><div class=\"price-details discount\" ng-if=\"!!checkout.currentCoupon.coupon\"><p>Cupón</p><p>-{{checkout.couponDescription(checkout.currentCoupon.coupon)}}</p></div><div class=\"price-details\" ng-if=\"checkout.how == checkout.deliveryText\"><p>Delivery</p><p ng-if=\"checkout.deliveryAmount > 0\">{{checkout.cart.parseIntl(checkout.deliveryAmount)}}</p><p ng-if=\"checkout.deliveryAmount == 0\">Envío gratis</p></div><div class=\"price-details\" ng-if=\"checkout.showTips() && !!checkout.selectedTip.amount\"><p>Propina</p><p>{{checkout.cart.parseIntl(checkout.selectedTip.amount)}}</p></div></div><div class=\"checkout-total-details\"><div class=\"total-details\"><p>Total</p><p>{{checkout.cart.parseIntl(checkout.totalPay)}}</p></div></div></div><div class=\"checkout-additional-products-container\" ng-if=\"checkout.count\"><div class=\"checkout-additional-products\" ng-if=\"checkout.additionalProducts.length > 0\"><div class=\"checkout-additional-products-title\" ng-if=\"checkout.additionalItems.length > 0\"><h1>Incluimos en tu pedido</h1></div><div class=\"checkout-additional-products-body\"><div class=\"checkout-unitary-product\" ng-repeat=\"item in checkout.additionalProducts\" ng-if=\"item.additional_type === \'unitary\'\"><input id=\"option-{{item.id}}\" ng-model=\"item.option_on\" ng-change=\"checkout.toggleSwitch(item.id)\" type=\"checkbox\"> <label for=\"option-{{item.id}}\">{{ item.name}}<div class=\"checkout-toggle-switch\"></div></label></div></div><div class=\"checkout-additional-products-info\" ng-if=\"checkout.additionalItems.length > 0\"><div class=\"checkout-all-additional-products\"><span ng-repeat=\"item in checkout.additionalItems\"><em>{{checkout.showAdditionalItem(item)}} &nbsp;</em></span></div></div></div></div><div class=\"checkout-items-details-container\"><div class=\"checkout-items-details-title\"><h1>Tu carrito</h1></div><div id=\"checkout-items-details\" class=\"checkout-items-details-body\"><div class=\"checkout-items\" ng-repeat=\"item in checkout.items | orderBy:\'addedAt\'\"><div class=\"checkout-items-info\"><div class=\"checkout-items-name\"><p class=\"item-name\">{{item.seleable.name}}</p></div><div class=\"checkout-items-description\" ng-repeat=\"option in checkout.showOptions(item) track by $index\" ng-if=\"!!option\"><p class=\"item-description\">-</p><p class=\"item-description\">{{option}}</p></div></div><div class=\"checkout-items-quantity\"><div class=\"checkout-item-box-quantity\"><button class=\"btn-quantity left\" ng-click=\"checkout.removeOne(item)\" ng-if=\"checkout.productCount(item) > 1\"><div class=\"btn-quantity-container active\"><i class=\"icon-minus\"></i></div></button> <button class=\"btn-quantity left\" ng-click=\"checkout.removeProduct(item)\" ng-if=\"checkout.productCount(item) === 1\"><div class=\"btn-quantity-container\"><img class=\"icon-remove\" src=\"assets/images/desktop/borrar.svg\"></div></button> <input class=\"input-quantity\" type=\"text\" id=\"inputSumador\" ng-value=\"checkout.productCount(item)\" name=\"quantity\" disabled=\"\"> <button class=\"btn-quantity right\" ng-click=\"checkout.addOne(item)\"><div class=\"btn-quantity-container active\"><i class=\"icon-plus\"></i></div></button></div></div></div></div></div></div><div class=\"pluxee-qr-box\" ng-if=\"checkout.paymentType === \'pluxee\' && checkout.pluxeeQrImage\"><p class=\"pluxee-qr-title\">Escanea tu código Pluxee</p><img class=\"pluxee-qr-image\" ng-src=\"{{checkout.pluxeeQrImage}}\" width=\"300\" alt=\"Código QR Pluxee\"><p class=\"pt-2\">o ingresa este código en tu App: {{checkout.pluxeeCode}}</p><p class=\"pluxee-qr-amount\">Total: {{checkout.cart.parseIntl(checkout.totalPay)}}</p><button class=\"btn cancel-button\" ng-click=\"checkout.cancelPluxeeQr()\" ng-disabled=\"checkout.processingWebPayment\">Cancelar</button></div><div class=\"checkout-items-footer\"><div class=\"items-footer\" ng-if=\"checkout.paymentType !== \'webpayplus\'\"><button class=\"btn btn-payment\" ng-click=\"checkout.sendOrder()\" ng-disabled=\"checkout.isClosed || !checkout.how || !checkout.selectedLocation || !checkout.selectedLocationId || !checkout.paymentType || checkout.initInscriptionButton || checkout.processingWebPayment || !checkout.scheduledOrderDataIsComplete() || checkout.loadingTotals\" ng-show=\"(!checkout.inProgress) && (checkout.paymentType !== \'pluxee\' || !checkout.pluxeeQrImage)\">{{ (checkout.selectedLocationIsClosed && !checkout.selectedLocationAllowsScheduling) ? \'Local Cerrado\' : (checkout.selectedLocationIsClosed && checkout.selectedLocationAllowsScheduling && checkout.scheduledOrderDateTime == null) ? \'Programa tu pedido y elige horario\' : \'Pagar \' + checkout.cart.parseIntl(checkout.totalPay) }}</button><loader template=\"ellipsis\" size=\"x-small\" ng-show=\"checkout.inProgress\"><loader></loader></loader></div><div class=\"items-footer\" ng-if=\"checkout.paymentType === \'webpayplus\'\"><button class=\"btn btn-payment\" ng-click=\"checkout.sendToPaymentPortal()\" ng-disabled=\"checkout.isClosed || !checkout.how || !checkout.selectedLocation || !checkout.selectedLocationId || !checkout.paymentType || !checkout.scheduledOrderDataIsComplete() || checkout.loadingTotals\" ng-show=\"!checkout.inProgress\">{{ (checkout.selectedLocationIsClosed && !checkout.selectedLocationAllowsScheduling) ? \'Local Cerrado\' : (checkout.selectedLocationIsClosed && checkout.selectedLocationAllowsScheduling && checkout.scheduledOrderDateTime == null) ? \'Programa tu pedido y elige horario\' : \'Pagar \' + checkout.cart.parseIntl(checkout.totalPay) }}</button><loader template=\"ellipsis\" size=\"x-small\" ng-show=\"checkout.inProgress\"><loader></loader></loader></div></div></div></div></div></div>");
$templateCache.put("app/checkout/desktop/customer-coupons.modal.html","<div class=\"modal-container\"><div class=\"modal-header\"><div class=\"modal-header-title\"><h2>Mis cupones</h2></div><div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"!checkout.couponLabelDisabled && checkout.closeModal()\"><i class=\"icon-x\"></i></button></div></div><div class=\"modal-body\"><div class=\"checkout-customer-coupon-container\"><div class=\"checkout-customer-coupon\"><div class=\"checkout-input-coupon\"><input class=\"input-coupon\" name=\"coupon\" maxlength=\"50\" autocomplete=\"off\" placeholder=\"Ingresa tu cupón\" required=\"\" type=\"text\" ng-model=\"checkout.coupon.code\"> <button class=\"btn btn-coupon\" ng-click=\"!checkout.couponLabelDisabled && checkout.handleCouponApplication(checkout.coupon.code)\">Aplicar</button></div></div><div class=\"checkout-customer-coupon\" ng-repeat=\"customerCoupon in checkout.coupon.couponsGet()\"><input id=\"coupon-customer-{{$index}}\" name=\"coupon-customer\" type=\"radio\"> <label class=\"buttonselect\" for=\"coupon-customer-{{$index}}\" ng-click=\"!checkout.couponLabelDisabled && checkout.handleCouponApplication(customerCoupon.coupon.code)\"><div class=\"customer-coupon\"><span class=\"customer-coupon-icon\"><i class=\"icon-coupon\"></i></span> <span class=\"customer-coupon-text\"><span>{{customerCoupon.coupon.code}}</span> <small ng-if=\"customerCoupon.coupon.min_amount > 0\">{{customerCoupon.coupon.caption}}</small> <small ng-if=\"customerCoupon.coupon.coupon_type == \'products\' || customerCoupon.coupon.coupon_type == \'products_free\'\">{{customerCoupon.coupon.product_name || customerCoupon.coupon.value}}</small></span> <span class=\"customer-coupon-select\"><i class=\"icon-chevron-right\"></i></span></div></label></div></div></div></div>");
$templateCache.put("app/checkout/desktop/delivery-pickup.modal.html","<div class=\"modal-header\" ng-if=\"checkout.howModal == \'delivery\'\"><div class=\"modal-header-back\"><button class=\"back-button\" data-dismiss=\"modal\" aria-label=\"Back\" ng-click=\"checkout.closeModal()\"><i class=\"icon-back\"></i></button></div><div class=\"modal-header-title\"><h2>Mis direcciones</h2></div></div><div class=\"modal-header\" ng-if=\"checkout.howModal == \'pickup\'\"><div class=\"modal-header-back\"><button class=\"back-button\" data-dismiss=\"modal\" aria-label=\"Back\" ng-click=\"checkout.closeModal()\"><i class=\"icon-back\"></i></button></div><div class=\"modal-header-title\"><h2>{{checkout.restaurantText}}</h2></div></div><div class=\"modal-body\"><div class=\"checkout-select-delivery-pickup-container\"><div class=\"checkout-select-delivery-pickup\"><input id=\"how-delivery-modal\" name=\"how-delivery-modal\" type=\"radio\" value=\"delivery\" ng-model=\"checkout.howModal\" ng-change=\"checkout.handlePickupDeliveryModal(\'delivery\')\"> <label class=\"checkout-button-select\" for=\"how-delivery-modal\"><span>{{checkout.localeDelivery}}</span></label> <input id=\"how-pickup-modal\" name=\"how-pickup-modal\" type=\"radio\" value=\"pickup\" ng-model=\"checkout.howModal\" ng-change=\"checkout.handlePickupDeliveryModal(\'pickup\')\"> <label class=\"checkout-button-select\" for=\"how-pickup-modal\"><span>{{checkout.localePickup}}</span></label></div><div class=\"checkout-pickup-search-container\" ng-if=\"checkout.howModal == \'pickup\'\"><input type=\"text\" class=\"checkout-pickup-search-input\" ng-model=\"checkout.pickupSearchQuery\" placeholder=\"Buscar local\"></div></div><div class=\"checkout-delivery-pickup-container\" ng-if=\"checkout.howModal == \'delivery\' && checkout.addressLocations.length > 0\"><div class=\"checkout-delivery-pickup-title\"><div class=\"delivery-pickup-title\"><h1>Selecciona una de tus direcciones guardadas:</h1></div></div></div><div class=\"checkout-delivery-pickup-container\" ng-if=\"checkout.howModal == \'pickup\'\"><div class=\"checkout-delivery-pickup-title\"><div class=\"delivery-pickup-title\"><h1>Selecciona un local:</h1></div></div></div><div class=\"checkout-delivery-pickup-container\" ng-if=\"checkout.howModal == \'delivery\'\"><div id=\"checkout-delivery-{{$index}}-container\" class=\"checkout-delivery-pickup-location\" ng-repeat=\"address in checkout.addressLocations\" ng-class=\"{\'hide\': ![0,1,2,3,4].includes($index)}\"><input type=\"radio\" id=\"checkout-address-{{$index}}\" name=\"checkout-address\" ng-value=\"address.id\" ng-model=\"checkout.selectedLocationId\" ng-click=\"checkout.selectLocationModal(\'delivery\', address)\" ng-disabled=\"(!address.assigned_restaurant_is_open || !address.assigned_restaurant_group_is_correct) && !checkout.restaurantAllowsScheduling(address.assigned_restaurant)\"> <label class=\"buttonselect\" for=\"checkout-address-{{$index}}\"><div class=\"location\"><div class=\"location-map-pin\"><i class=\"icon-map-pin-fill\"></i></div><div class=\"location-address-detail\" ng-if=\"address.address\"><span>{{address.comune_name}}</span><div class=\"location-street\"><span>{{address.street_name}} #{{address.street_number}}</span> <small ng-if=\"address.specific_number\">, {{address.specific_number}}</small></div></div><div class=\"location-restaurant-detail\" ng-if=\"address.assigned_restaurant_is_open && address.assigned_restaurant_group_is_correct\"><span class=\"location-pickup-time\">{{address.delivery_restaurant_pickup_time}} min.</span></div><div class=\"location-restaurant-detail\" ng-if=\"!address.assigned_restaurant_is_open || !address.assigned_restaurant_group_is_correct\"><span class=\"location-is-closed\" ng-if=\"!address.assigned_restaurant_is_open && address.assigned_restaurant_group_is_correct && checkout.restaurantAllowsScheduling(address.assigned_restaurant)\">Programa tu pedido</span> <span class=\"location-is-closed\" ng-if=\"!address.assigned_restaurant_is_open && address.assigned_restaurant_group_is_correct && !checkout.restaurantAllowsScheduling(address.assigned_restaurant)\">Local cerrado</span> <span class=\"location-change-region\" ng-if=\"!address.assigned_restaurant_group_is_correct && envConstants.ALLOW_PRICE_LISTS === \'true\'\" ng-click=\"checkout.openModalLocation()\">Cambiar de región</span> <span class=\"location-no-coverage\" ng-if=\"!address.assigned_restaurant_group_is_correct && envConstants.ALLOW_PRICE_LISTS !== \'true\'\">Sin cobertura</span></div><div class=\"location-select\"><i class=\"icon-chevron-right\"></i></div></div></label></div><p id=\"checkout-click-change-delivery\" class=\"checkout-change-delivery\" ng-if=\"checkout.addressLocations.length > 5\" ng-click=\"checkout.showLocationModal(); checkout.changeLocationElement(\'delivery\', \'add\');\">Ver mis direcciones</p></div><div class=\"checkout-delivery-pickup-container\" ng-if=\"checkout.howModal == \'pickup\'\"><div id=\"checkout-pickup-{{$index}}-container\" class=\"checkout-delivery-pickup-location\" ng-repeat=\"restaurant in (checkout.pickupRestaurants | filter:checkout.pickupSearchQuery) track by restaurant.id\" ng-class=\"{\'hide\': !checkout.pickupSearchQuery && ![0,1,2,3,4].includes($index)}\"><input type=\"radio\" id=\"checkout-restaurant-{{$index}}\" name=\"checkout-restaurant\" ng-value=\"restaurant.id\" ng-model=\"checkout.selectedLocationId\" ng-disabled=\"(!restaurant.is_open || !restaurant.restaurant_group_is_correct) && !checkout.restaurantAllowsScheduling(restaurant)\"> <label class=\"buttonselect\" for=\"checkout-restaurant-{{$index}}\" ng-click=\"checkout.selectLocationModal(\'pickup\', restaurant)\"><div class=\"location\"><div class=\"location-map-pin\"><i class=\"icon-map-pin-fill\"></i><div class=\"checkout-distance\" ng-if=\"checkout.selectedLocation.distance_from_customer\"><span class=\"distance-value\">{{ restaurant.distance_from_customer.split(\' \')[0] }}</span> <span class=\"distance-unit\">{{ restaurant.distance_from_customer.split(\' \')[1] }}</span></div></div><div class=\"location-address-detail\" ng-if=\"restaurant.address\"><span>{{restaurant.name}}</span><div class=\"location-street\"><span>{{restaurant.comune_name}}, {{restaurant.address}}</span></div></div><div class=\"location-restaurant-detail\" ng-if=\"restaurant.is_open && restaurant.restaurant_group_is_correct\"><span class=\"location-pickup-time\">{{restaurant.current_pickup_time}} min.</span></div><div class=\"location-restaurant-detail\" ng-if=\"!restaurant.is_open || !restaurant.restaurant_group_is_correct\"><span class=\"location-is-closed\" ng-if=\"!restaurant.is_open && restaurant.restaurant_group_is_correct && checkout.restaurantAllowsScheduling(restaurant)\">Programa tu pedido</span> <span class=\"location-is-closed\" ng-if=\"!restaurant.is_open && restaurant.restaurant_group_is_correct && !checkout.restaurantAllowsScheduling(restaurant)\">Local cerrado</span> <span class=\"location-change-region\" ng-if=\"!restaurant.restaurant_group_is_correct && envConstants.ALLOW_PRICE_LISTS === \'true\'\" ng-click=\"checkout.openModalLocation()\">Cambiar de región</span> <span class=\"location-no-coverage\" ng-if=\"!restaurant.restaurant_group_is_correct && envConstants.ALLOW_PRICE_LISTS !== \'true\'\">Sin cobertura</span></div><div class=\"location-select\"><i class=\"icon-chevron-right\"></i></div></div></label></div><p id=\"checkout-click-change-pickup\" class=\"checkout-change-pickup\" ng-if=\"checkout.pickupRestaurants.length > 5 && !checkout.pickupSearchQuery\" ng-click=\"checkout.showLocationModal(); checkout.changeLocationElement(\'pickup\', \'add\')\">Ver más <span>{{checkout.restaurantText}}</span></p><p class=\"checkout-pickup-empty\" ng-if=\"checkout.pickupSearchQuery && checkout.pickupRestaurants.length && !(checkout.pickupRestaurants | filter:checkout.pickupSearchQuery).length\">No encontramos locales con esa búsqueda.</p><p class=\"checkout-change-location selected\" ng-if=\"envConstants.ALLOW_PRICE_LISTS === \'true\'\" ng-click=\"checkout.openModalLocation()\">¿No encuentras tu local?</p></div><div class=\"button-new-address-center\" ng-if=\"checkout.showNewAddressBtn && checkout.howModal == \'delivery\'\"><button class=\"btn new-address-button\" ng-click=\"checkout.closeModal(); checkout.newAddressSidebarModal();\"><i class=\"icon-plus\"></i><p>Agregar una nueva dirección</p></button></div></div>");
$templateCache.put("app/checkout/desktop/payment-method.modal.html","<div class=\"modal-header\"><div class=\"modal-header-back\"><button class=\"back-button\" aria-label=\"Back\" ng-click=\"checkout.closeModal()\"><i class=\"icon-back\"></i></button></div><div class=\"modal-header-title\"><h2>Método de pago</h2></div></div><div class=\"modal-body\"><div class=\"checkout-payment-method-container\" ng-if=\"checkout.onlinePaymentOn && ((checkout.country === \'MX\' && checkout.paymentCards && checkout.paymentCards.length > 0) || (checkout.country !== \'MX\' && checkout.tbkUsers && checkout.tbkUsers.length > 0))\"><div class=\"checkout-payment-method separator-line\"><div class=\"checkout-payment-method-title\"><h1>Selecciona tu tarjeta</h1></div><div class=\"dropdown-card-selector\" ng-class=\"{ open: checkout.showCardDropdown }\"><div class=\"checkout-payment-card\" ng-click=\"( checkout.country === \'MX\' ? checkout.paymentCards.length > 1 : checkout.tbkUsers.length > 1 ) && checkout.toggleCardDropdown()\"><div class=\"payment dropdown-label\"><div class=\"card-option\"><img ng-if=\"checkout.country === \'MX\' && checkout.kushkiCard\" ng-src=\"{{ checkout.getCardLogo(checkout.kushkiCard.payment_brand) }}\" class=\"card-logo\"> <img ng-if=\"checkout.country !== \'MX\' && checkout.tbkUser\" ng-src=\"{{ checkout.getCardLogo(checkout.tbkUser.card_type) }}\" class=\"card-logo\"> <span class=\"card-option-number\">{{ checkout.getSelectedCardLabel() }}</span></div></div><div class=\"payment-arrow\" ng-if=\"(checkout.country === \'MX\' && checkout.paymentCards.length > 1) || (checkout.country !== \'MX\' && checkout.tbkUsers.length > 1)\"><i class=\"icon-chevron-down\" ng-if=\"!checkout.showCardDropdown\"></i> <i class=\"icon-chevron-up\" ng-if=\"checkout.showCardDropdown\"></i></div></div><ul class=\"card-dropdown-panel\" ng-if=\"checkout.showCardDropdown && ((checkout.country === \'MX\' && checkout.paymentCards.length > 1) || (checkout.country !== \'MX\' && checkout.tbkUsers.length > 1))\"><li ng-repeat=\"card in (checkout.country === \'MX\' ? checkout.paymentCards : checkout.tbkUsers)\" ng-click=\"checkout.country === \'MX\' ? checkout.selectKushkiCardDraft(card) : checkout.selectCreditCard(card.id)\" ng-class=\"{ selected: checkout.country === \'MX\' ? checkout.kushkiCardDraft && checkout.kushkiCardDraft.token === card.token : checkout.creditCard === card.id}\"><div class=\"card-option\"><img ng-if=\"checkout.country === \'MX\'\" ng-src=\"{{ checkout.getCardLogo(card.payment_brand) }}\" class=\"card-logo\"> <img ng-if=\"checkout.country !== \'MX\'\" ng-src=\"{{ checkout.getCardLogo(card.card_type) }}\" class=\"card-logo\"> <span class=\"card-option-number\">**** {{ checkout.country === \'MX\' ? card.card_last_four : card.last_4_card_digits }}</span></div></li></ul></div><div class=\"add-new-card-text\" ng-click=\"checkout.closeModal(); checkout.country === \'MX\' ? checkout.openKushkiInscription() : checkout.goToInscriptionbWebpay()\">Inscribir tarjeta</div><div class=\"button-new-address-center\"><button class=\"btn new-address-button\" ng-click=\"checkout.country === \'MX\' ? checkout.confirmSelectedKushkiCard() : checkout.confirmSelectedCard()\"><p>Confirmar tarjeta</p></button></div></div></div><div class=\"checkout-payment-method-container\" ng-if=\"checkout.onlinePaymentOn && ((checkout.country === \'MX\' && (!checkout.paymentCards || checkout.paymentCards.length === 0)) || (checkout.country !== \'MX\' && (!checkout.tbkUsers || checkout.tbkUsers.length === 0)))\"><div class=\"button-new-address-center\"><button class=\"btn new-address-button\" ng-click=\"checkout.closeModal(); checkout.country === \'MX\' ? checkout.openKushkiInscription() : checkout.goToInscriptionbWebpay()\">Inscribir tarjeta</button></div></div><div class=\"checkout-payment-method-container\"><div class=\"checkout-payment-method\" ng-repeat=\"payment in checkout.paymentOrder\" ng-if=\"checkout.checkPaymentTypeAllowedScheduledOrder(payment.type)\"><div class=\"checkout-payment-card\" ng-click=\"checkout.handlePaymentMethodSelection(payment)\" ng-class=\"{ selected: checkout.paymentTypeModal === payment.type }\"><div class=\"payment\" ng-class=\"{ \'payment-only-logo\': !checkout.paymentTypeIsCash(payment.type) }\"><img ng-if=\"!checkout.paymentTypeIsCash(payment.type) && checkout.paymentConfig[payment.type] && checkout.paymentConfig[payment.type].icon\" ng-src=\"{{ checkout.paymentConfig[payment.type].icon }}\" alt=\"{{ checkout.paymentConfig[payment.type].label || payment.type }}\"> <span ng-if=\"checkout.paymentTypeIsCash(payment.type)\">{{ (checkout.paymentConfig[payment.type] && checkout.paymentConfig[payment.type].description) || \'Efectivo, tarjeta de débito y crédito (RedCompra) - Presencial\' }}</span> <small class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && ((checkout.paymentConfig[payment.type] && checkout.paymentConfig[payment.type].discount > 0) || (payment.discount && payment.discount > 0))\">{{ checkout.paymentConfig[payment.type] && checkout.paymentConfig[payment.type].discount > 0 ? checkout.paymentConfig[payment.type].discount : payment.discount }}% de descuento</small></div><div class=\"payment-arrow\"><i class=\"icon-chevron-right\"></i></div></div></div></div></div>");
$templateCache.put("app/checkout/desktop/remove-product.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"confirmation.removeProductModal(false)\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><h2>Confirmar</h2></div><div class=\"modal-body\"><div class=\"modal-item\"><p>¿Deseas eliminar este producto: \"{{confirmation.product.seleable.name}}\"?</p><div class=\"form-checkbox-inline\"><div class=\"form-checkbox\"><input id=\"option-yes\" name=\"si\" type=\"radio\" ng-click=\"confirmation.removeProductModal(true)\"> <label for=\"option-yes\" class=\"button-select\"><div class=\"checkbox-label\"><span>Si</span></div></label></div><div class=\"form-checkbox\"><input id=\"option-no\" name=\"no\" type=\"radio\" ng-click=\"confirmation.removeProductModal(false)\"> <label for=\"option-no\" class=\"button-select\"><div class=\"checkbox-label\"><span>No</span></div></label></div></div></div></div>");
$templateCache.put("app/checkout/mobile/checkout-tips.modal.html","<div class=\"modal-header\"><div class=\"modal-header-back\"><button class=\"back-button\" data-dismiss=\"modal\" aria-label=\"Back\" ng-click=\"checkout.closeModal()\"><i class=\"icon-back\"></i></button></div><div class=\"modal-header-title\"><h2>Otro monto</h2></div></div><div class=\"modal-body\"><div class=\"checkout-tips-container\"><div class=\"checkout-tips\"><div class=\"checkout-input-tip\"><input class=\"input-tip\" name=\"tip\" type=\"number\" onkeypress=\"return /[0-9]/i.test(event.key)\" onpaste=\"return false\" placeholder=\"Ingresa un monto\" ng-model=\"checkout.tipModal\" ng-change=\"checkout.validateTip()\" required=\"\"> <button class=\"btn btn-tip\" ng-click=\"checkout.selectTipModal(checkout.tipModal); checkout.closeModal();\">Agregar</button></div></div></div></div>");
$templateCache.put("app/checkout/mobile/checkout.html","<notice-bar-cart></notice-bar-cart><header-checkout></header-checkout><div class=\"checkout\"><div class=\"checkout-container\"><div class=\"checkout-delivery-details\" ng-show=\"checkout.skeletonShow\"><skeleton-screen class=\"full-width\" template=\"checkout-delivery-details\"></skeleton-screen></div><div class=\"checkout-delivery-details\" ng-show=\"!checkout.skeletonShow\"><div class=\"checkout-select-delivery-pickup-container\"><div class=\"checkout-select-delivery-pickup\"><input id=\"how-delivery\" name=\"how-delivery\" type=\"radio\" value=\"delivery\" ng-model=\"checkout.how\" ng-change=\"checkout.updateSkeleton(true); checkout.handlePickupDelivery(checkout.deliveryText)\"> <label class=\"checkout-button-select\" for=\"how-delivery\"><span>{{checkout.localeDelivery}}</span></label> <input id=\"how-pickup\" name=\"how-pickup\" type=\"radio\" value=\"pickup\" ng-model=\"checkout.how\" ng-change=\"checkout.updateSkeleton(true); checkout.handlePickupDelivery(checkout.pickupText)\"> <label class=\"checkout-button-select\" for=\"how-pickup\"><span>{{checkout.localePickup}}</span></label></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.deliveryText && !checkout.hasDelivery\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title closed-restaurants\"><h1>Las tiendas se encuentran momentáneamente sin delivery.</h1></div></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.deliveryText && checkout.hasDelivery && !checkout.addressLocations.length > 0\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title\"><h1>Detalles de despacho</h1></div></div><div class=\"checkout-delivery-body\" ng-click=\"checkout.newAddressSidebarModal()\"><div class=\"checkout-delivery-icon\"><i class=\"icon-plus\"></i></div><div class=\"checkout-delivery-addresses\"><div class=\"checkout-delivery\"><p>Agregar una nueva dirección</p></div></div><div class=\"checkout-select-delivery\"><i class=\"icon-chevron-right\"></i></div></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.deliveryText && checkout.hasDelivery && !checkout.selectedLocation && checkout.addressLocations.length > 0\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title\"><h1>Detalles de despacho</h1></div></div><div class=\"checkout-delivery-body\" ng-click=\"checkout.deliveryPickupModal()\"><div class=\"checkout-delivery-icon\"><i class=\"icon-map-pin\"></i></div><div class=\"checkout-delivery-addresses\"><div class=\"checkout-pickup\"><p>Seleccione una dirección</p></div></div><div class=\"checkout-select-delivery\"><i class=\"icon-chevron-right\"></i></div></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.deliveryText && checkout.hasDelivery && !!checkout.selectedLocation\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title\"><h1>Detalles de despacho</h1></div></div><div class=\"checkout-delivery-body\" ng-click=\"checkout.deliveryPickupModal()\"><div class=\"checkout-delivery-icon\"><i class=\"icon-ready-on-the-way\"></i></div><div class=\"checkout-delivery-addresses\"><div class=\"checkout-delivery\"><p class=\"active\">Despacho en: <span>{{checkout.selectedLocation.comune_name}}</span></p><p>{{checkout.selectedLocation.street_name}} #{{checkout.selectedLocation.street_number}} <span ng-if=\"!!checkout.selectedLocation.specific_number\">, {{checkout.selectedLocation.specific_number}}</span></p></div></div><div class=\"checkout-select-delivery\"><i class=\"icon-chevron-right\"></i></div></div><div id=\"checkout-scheduled-order-body\" class=\"checkout-scheduled-order-body closed-select\" ng-if=\"checkout.canBeActivatedScheduledOrder()\" ng-click=\"checkout.toggleScheduleOrderOptions()\"><div class=\"body\"><div class=\"checkout-delivery-icon\"><i class=\"icon-pickup-time\"></i></div><div class=\"checkout-scheduled-order\"><div class=\"checkout-delivery\"><p id=\"{{checkout.now}}\" class=\"active\" ng-if=\"checkout.scheduledOrder === checkout.now\"><span>{{checkout.nowTextByDefault}}</span> <span class=\"pickup-time\">{{checkout.selectedLocation.delivery_restaurant_pickup_time}} min</span></p><p id=\"{{checkout.scheduled}}\" class=\"active\" ng-if=\"checkout.scheduledOrderActivated() && !checkout.scheduledOrderDateTime\"><span>{{checkout.scheduledTextByDefault}}</span> <span class=\"warning\">Solo permite pagos digitales</span></p><p id=\"time-scheduled-order\" class=\"active\" ng-if=\"checkout.scheduledOrderActivated() && checkout.scheduledOrderDateTime\"><span>{{checkout.scheduledOrderDateTimeLabel}}</span> <span class=\"warning\">Solo permite pagos digitales</span></p></div></div><div class=\"checkout-select-delivery-scheduled-order\"><i id=\"icon-chevron-scheduled-order\" class=\"icon-chevron-right\"></i></div></div><div class=\"select\"><div id=\"select-schedule-order\" class=\"select-schedule-order-content scroll-bar not-visible\"><label for=\"option-{{$index}}\" ng-repeat=\"option in checkout.scheduledDayOptions\" ng-click=\"checkout.updateStateScheduledOrder(this.option.forSchedule, this.option.day); $event.stopPropagation()\"><input id=\"option-{{$index}}\" class=\"input-schedule-order\" type=\"radio\" name=\"option-{{$index}}\" value=\"{{option.id}}\" ng-model=\"checkout.selectedDateTime\" attr.data-scheduled=\"{{option.forSchedule}}\"> <span>{{option.day}}</span></label></div></div></div><div class=\"checkout-delivery-maps\" ng-if=\"!!checkout.selectedLocation\"><ui-gmap-google-map center=\"checkout.selectedLocation.lonlat\" options=\"checkout.mapOptions\" pan=\"true\" zoom=\"16\"><ui-gmap-marker coords=\"checkout.selectedLocation.lonlat\" idkey=\"1\" options=\"{draggable: true, icon: \'/assets/images/address_icon_\' + $environment + \'.png\'}\"></ui-gmap-marker></ui-gmap-google-map></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.pickupText && !checkout.hasPickup\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title closed-restaurants\"><h1>{{checkout.closedRestaurant}} momentáneamente. Por favor intenta más tarde.</h1></div></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.pickupText && checkout.hasPickup && !checkout.selectedLocation\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title\"><h1>Detalles de retiro</h1></div></div><div class=\"checkout-delivery-body\" ng-click=\"checkout.deliveryPickupModal()\"><div class=\"checkout-delivery-icon\"><i class=\"icon-map-pin\"></i></div><div class=\"checkout-delivery-addresses\"><div class=\"checkout-pickup\"><p>Seleccione un local</p></div></div><div class=\"checkout-select-delivery\"><i class=\"icon-chevron-right\"></i></div></div></div><div class=\"checkout-delivery-container\" ng-if=\"checkout.how == checkout.pickupText && checkout.hasPickup && !!checkout.selectedLocation\"><div class=\"checkout-delivery-title\"><div class=\"delivery-title\"><h1>Detalles de retiro</h1></div></div><div class=\"checkout-delivery-body\" ng-click=\"checkout.deliveryPickupModal()\"><div class=\"checkout-delivery-icon\"><i class=\"icon-delivered\"></i></div><div class=\"checkout-delivery-addresses\"><div class=\"checkout-pickup\" ng-if=\"!!checkout.selectedLocation\"><p class=\"active\">Retiro en: <span>{{checkout.selectedLocation.name}}</span></p><p>{{checkout.selectedLocation.comune_name}}, {{checkout.selectedLocation.address}}</p></div></div><div class=\"checkout-select-delivery\"><i class=\"icon-chevron-right\"></i></div></div><div id=\"checkout-scheduled-order-body\" class=\"checkout-scheduled-order-body closed-select\" ng-if=\"checkout.canBeActivatedScheduledOrder()\" ng-click=\"checkout.toggleScheduleOrderOptions()\"><div class=\"body\"><div class=\"checkout-delivery-icon\"><i class=\"icon-pickup-time\"></i></div><div class=\"checkout-scheduled-order\"><div class=\"checkout-delivery\"><p id=\"{{checkout.now}}\" class=\"active\" ng-if=\"checkout.scheduledOrder === checkout.now\"><span>{{checkout.nowTextByDefault}}</span> <span class=\"pickup-time\">{{checkout.selectedLocation.current_pickup_time}} min</span></p><p id=\"{{checkout.scheduled}}\" class=\"active\" ng-if=\"checkout.scheduledOrderActivated() && !checkout.scheduledOrderDateTime\"><span>{{checkout.scheduledTextByDefault}}</span> <span class=\"warning\">Solo permite pagos digitales</span></p><p id=\"time-scheduled-order\" class=\"active\" ng-if=\"checkout.scheduledOrderActivated() && checkout.scheduledOrderDateTime\"><span>{{checkout.scheduledOrderDateTimeLabel}}</span> <span class=\"warning\">Solo permite pagos digitales</span></p></div></div><div class=\"checkout-select-delivery-scheduled-order\"><i id=\"icon-chevron-scheduled-order\" class=\"icon-chevron-right\"></i></div></div><div class=\"select\"><div id=\"select-schedule-order\" class=\"select-schedule-order-content scroll-bar not-visible\"><label for=\"option-{{$index}}\" ng-repeat=\"option in checkout.scheduledDayOptions\" ng-click=\"checkout.updateStateScheduledOrder(this.option.forSchedule, this.option.day); $event.stopPropagation()\"><input id=\"option-{{$index}}\" class=\"input-schedule-order\" type=\"radio\" name=\"option-{{$index}}\" value=\"{{option.id}}\" ng-model=\"checkout.selectedDateTime\" attr.data-scheduled=\"{{option.forSchedule}}\"> <span>{{option.day}}</span></label></div></div></div><div class=\"checkout-delivery-maps\" ng-if=\"!!checkout.selectedLocation\"><ui-gmap-google-map center=\"checkout.selectedLocation.lonlat\" options=\"checkout.mapOptions\" pan=\"true\" zoom=\"16\"><ui-gmap-marker coords=\"checkout.selectedLocation.lonlat\" idkey=\"1\" options=\"{draggable: true, icon: \'/assets/images/address_icon_\' + $environment + \'.png\'}\"></ui-gmap-marker></ui-gmap-google-map></div></div><div class=\"checkout-payment-method-container\" ng-if=\"checkout.hasPickup && !!checkout.selectedLocation\"><div class=\"checkout-payment-method-title\"><div class=\"payment-method-title\"><h1>Método de pago</h1></div></div><div class=\"checkout-payment-method-body\" ng-click=\"checkout.paymentMethodModal()\"><div class=\"checkout-payment-method\"><div class=\"checkout-payment-card\" ng-if=\"!checkout.paymentType\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><p>Seleccione método de pago</p></div><div class=\"checkout-payment-card\" ng-if=\"(checkout.paymentType == \'webpay\' && !checkout.onlinePaymentOn) || (checkout.paymentType == \'kushki\' && !checkout.kushkiPaymentOn)\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><img src=\"assets/images/kushki/logo-kushki.svg\" alt=\"logo\"></div><div class=\"checkout-payment-card\" ng-if=\"(checkout.paymentType == \'webpay\' && !checkout.tbkUser) || (checkout.paymentType == \'kushki\' && !checkout.paymentCards.length > 0)\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><img src=\"assets/images/transbank/webpayplus.svg\" alt=\"logo\"></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'kushki\' && checkout.kushkiPaymentOn && checkout.kushkiCard\"><div class=\"checkout-payment-card-icon\"><img ng-if=\"checkout.getCardLogo(checkout.kushkiCard.payment_brand)\" ng-src=\"{{ checkout.getCardLogo(checkout.kushkiCard.payment_brand) }}\" alt=\"card-logo\"></div><div class=\"checkout-payment-card-text\"><p>**** {{ checkout.kushkiCard.card_last_four }} <span>({{ checkout.customer.name }})</span></p><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_1 > 0\">{{ checkout.DEFAULT_DISCOUNT_1 }}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'oneclick\' && checkout.onlinePaymentOn && checkout.tbkUser\"><div class=\"checkout-payment-card-icon\"><img ng-if=\"checkout.getCardLogo(checkout.tbkUser.card_type)\" ng-src=\"{{ checkout.getCardLogo(checkout.tbkUser.card_type) }}\" alt=\"card-logo\"></div><div class=\"checkout-payment-card-text\"><p>**** {{ checkout.tbkUser.last_4_card_digits }} <span>({{ checkout.customer.name }})</span></p><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_1 > 0\">{{ checkout.DEFAULT_DISCOUNT_1 }}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'webpayplus\'\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><div class=\"checkout-payment-card-text\"><img src=\"assets/images/transbank/webpayplus.svg\" alt=\"logo\"><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_1 > 0\">{{checkout.DEFAULT_DISCOUNT_1}}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'cash\'\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><div class=\"checkout-payment-card-text\"><p ng-if=\"checkout.country == \'CL\'\">Efectivo, tarjeta de débito y crédito (RedCompra) - Presencial</p><p ng-if=\"checkout.country == \'MX\'\">Pago contra entrega - Efectivo, tarjeta de débito y crédito</p><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_1 > 0\">{{checkout.DEFAULT_DISCOUNT_1}}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'amipass\'\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><div class=\"checkout-payment-card-text\"><img src=\"assets/images/amipass/amipass_logo.png\" alt=\"logo\"><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_2 > 0\">{{checkout.DEFAULT_DISCOUNT_2}}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'pluxee\'\"><div class=\"checkout-payment-card-icon\"><i class=\"icon-credit-card\"></i></div><div class=\"checkout-payment-card-text\"><img src=\"assets/images/pluxee/pluxee_logo.png\" alt=\"logo\"><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_2 > 0\">{{checkout.DEFAULT_DISCOUNT_2}}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'amipass\'\"><div class=\"checkout-payment-card-text\"><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_2 > 0\">{{checkout.DEFAULT_DISCOUNT_2}}% de descuento</p></div></div><div class=\"checkout-payment-card\" ng-if=\"checkout.paymentType == \'pluxee\'\"><div class=\"checkout-payment-card-text\"><p class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && checkout.DEFAULT_DISCOUNT_2 > 0\">{{checkout.DEFAULT_DISCOUNT_2}}% de descuento</p></div></div></div><div class=\"checkout-select-payment-method\"><i class=\"icon-chevron-right\"></i></div></div></div><div class=\"checkout-tips-container\" ng-if=\"checkout.showTips() && checkout.hasPickup && !!checkout.selectedLocation\"><div class=\"checkout-tips-title\"><div class=\"tips-title\"><h1>Propina al repartidor</h1></div></div><div class=\"checkout-tips-body\"><div class=\"checkout-tips-container\"><div class=\"checkout-tip\" ng-repeat=\"tip in checkout.tips\"><input id=\"tip-{{$index}}\" name=\"tip\" type=\"radio\" ng-init=\"checkout.checkedTip(tip)\" ng-value=\"tip.id\" ng-model=\"checkout.selectedTip.id\" ng-click=\"checkout.selectTip(tip); checkout.blockTip();\"> <label class=\"buttonselect\" for=\"tip-{{$index}}\" ng-click=\"checkout.selectTip(tip); checkout.blockTip();\"><div class=\"tip\"><span ng-if=\"checkout.cart.parseIntl(tip.amount)\">{{checkout.cart.parseIntl(tip.amount)}}</span></div></label></div></div><div class=\"checkout-tips-container\"><div class=\"checkout-tip\"><div id=\"other-tip\" class=\"other-tip\" ng-click=\"checkout.checkoutTipsModal()\"><span ng-if=\"!checkout.otherTip\">Otro monto</span> <span ng-if=\"checkout.otherTip\">{{checkout.cart.parseIntl(checkout.selectedTip.amount)}}</span></div></div></div></div><div class=\"checkout-tips-footer\"><p>El 100% de la propina va a nuestros repartidores! Ten en consideración la distancia a tu destino.</p></div></div><div class=\"checkout-coupon-container\" ng-if=\"checkout.hasDelivery && !!checkout.selectedLocation\"><div class=\"checkout-coupon-body-container\"><div class=\"checkout-coupon-body\" ng-click=\"checkout.customerCouponsModal()\" ng-if=\"!checkout.currentCoupon\"><div class=\"checkout-coupon\"><p>¿Tienes un cupón?</p></div></div></div><div class=\"checkout-coupon-body checkout-coupon-detail\" ng-if=\"!!checkout.currentCoupon\"><div class=\"checkout-coupon\"><div class=\"checkout-coupon-detail\"><span>{{checkout.currentCoupon.coupon.code}}</span> <small ng-if=\"checkout.currentCoupon.coupon.min_amount > 0\">{{checkout.currentCoupon.coupon.caption}}</small></div><div class=\"checkout-coupon-remove\" ng-click=\"checkout.coupon.deactivateCoupon(checkout.currentCoupon.coupon)\"><p>[Eliminar]</p></div></div></div></div></div><div class=\"checkout-items-details\" ng-show=\"checkout.skeletonShow\"><skeleton-screen class=\"full-width\" template=\"checkout-items-details\"></skeleton-screen></div><div class=\"checkout-items-details\" ng-show=\"!checkout.skeletonShow\"><div class=\"checkout-items-container\"><div class=\"checkout-items-title\"><div class=\"items-title\"><h1>Resumen</h1></div></div><div class=\"checkout-items-body\"><div class=\"checkout-price-details-container\" ng-class=\"{\'totals-loading\': checkout.loadingTotals}\"><div class=\"checkout-price-details\"><div class=\"price-details\"><p>Subtotal</p><p class=\"price\">{{ checkout.cart.parseIntl(checkout.subtotalAmount) }}</p></div><div class=\"price-details discount\" ng-if=\"checkout.productDiscountAmount > 0\"><p>Descuento</p><p>-{{ checkout.cart.parseIntl(checkout.productDiscountAmount) }}</p></div><div class=\"price-details discount\" ng-if=\"checkout.paymentType == \'tarjeta\' && checkout.discountable() && checkout.validateDiscount()\"><p>Descuento {{checkout.DEFAULT_DISCOUNT_2}}%</p><p>{{checkout.cart.parseIntl(checkout.productDiscountAmount)}}</p></div><div class=\"price-details discount\" ng-if=\"!!checkout.currentCoupon.coupon\"><p>Cupón</p><p>-{{checkout.couponDescription(checkout.currentCoupon.coupon)}}</p></div><div class=\"price-details\" ng-if=\"checkout.how == checkout.deliveryText\"><p>Delivery</p><p ng-if=\"checkout.deliveryAmount > 0\">{{checkout.cart.parseIntl(checkout.deliveryAmount)}}</p><p ng-if=\"checkout.deliveryAmount == 0\">Envío gratis</p></div><div class=\"price-details\" ng-if=\"checkout.showTips() && !!checkout.selectedTip.amount\"><p>Propina</p><p>{{checkout.cart.parseIntl(checkout.selectedTip.amount)}}</p></div></div><div class=\"checkout-total-details\"><div class=\"total-details\"><p>Total</p><p>{{checkout.cart.parseIntl(checkout.totalPay)}}</p></div></div></div><div class=\"checkout-additional-products-container\" ng-if=\"checkout.count\"><div class=\"checkout-additional-products\" ng-if=\"checkout.additionalProducts.length > 0\"><div class=\"checkout-additional-products-title\" ng-if=\"checkout.additionalItems.length > 0\"><h1>Incluimos en tu pedido</h1></div><div class=\"checkout-additional-products-body\"><div class=\"checkout-unitary-product\" ng-repeat=\"item in checkout.additionalProducts\" ng-if=\"item.additional_type === \'unitary\'\"><input id=\"option-{{item.id}}\" ng-model=\"item.option_on\" ng-change=\"checkout.toggleSwitch(item.id)\" type=\"checkbox\"> <label for=\"option-{{item.id}}\">{{ item.name}}<div class=\"checkout-toggle-switch\"></div></label></div></div><div class=\"checkout-additional-products-info\" ng-if=\"checkout.additionalItems.length > 0\"><div class=\"checkout-all-additional-products\"><span ng-repeat=\"item in checkout.additionalItems\"><em>{{checkout.showAdditionalItem(item)}} &nbsp;</em></span></div></div></div></div><div class=\"checkout-items-details-container\"><div class=\"checkout-items-details-title\"><h1>Tu carrito</h1></div><div id=\"checkout-items-details\" class=\"checkout-items-details-body\"><div class=\"checkout-items\" ng-repeat=\"item in checkout.items | orderBy:\'addedAt\'\"><div class=\"checkout-items-info\"><div class=\"checkout-items-name\"><p class=\"item-name\">{{item.seleable.name}}</p></div><div class=\"checkout-items-description\" ng-repeat=\"option in checkout.showOptions(item) track by $index\" ng-if=\"!!option\"><p class=\"item-description\">-</p><p class=\"item-description\">{{option}}</p></div></div><div class=\"checkout-items-quantity\"><div class=\"checkout-item-box-quantity\"><button class=\"btn-quantity left\" ng-click=\"checkout.removeOne(item)\" ng-if=\"checkout.productCount(item) > 1\"><div class=\"btn-quantity-container active\"><i class=\"icon-minus\"></i></div></button> <button class=\"btn-quantity left\" ng-click=\"checkout.removeProduct(item)\" ng-if=\"checkout.productCount(item) === 1\"><div class=\"btn-quantity-container\"><img class=\"icon-remove\" src=\"assets/images/desktop/borrar.svg\"></div></button> <input class=\"input-quantity\" type=\"text\" id=\"inputSumador\" ng-value=\"checkout.productCount(item)\" name=\"quantity\" disabled=\"\"> <button class=\"btn-quantity right\" ng-click=\"checkout.addOne(item)\"><div class=\"btn-quantity-container active\"><i class=\"icon-plus\"></i></div></button></div></div></div></div></div></div></div></div></div><div class=\"checkout-items-footer-container\" ng-show=\"!checkout.skeletonShow\"><div class=\"checkout-items-footer\" ng-if=\"checkout.paymentType !== \'webpayplus\'\"><button class=\"btn checkout-btn-payment\" ng-click=\"checkout.sendOrder()\" ng-disabled=\"checkout.isClosed || !checkout.how || !checkout.selectedLocation || !checkout.selectedLocationId || !checkout.paymentType || checkout.initInscriptionButton || checkout.processingWebPayment || !checkout.scheduledOrderDataIsComplete() || checkout.loadingTotals\" ng-show=\"(!checkout.inProgress) && (checkout.paymentType !== \'pluxee\' || !checkout.pluxeeQrImage)\">{{ (checkout.selectedLocationIsClosed && !checkout.selectedLocationAllowsScheduling) ? \'Local Cerrado\' : (checkout.selectedLocationIsClosed && checkout.selectedLocationAllowsScheduling && checkout.scheduledOrderDateTime == null) ? \'Programa tu pedido y elige horario\' : \'Pagar \' + checkout.cart.parseIntl(checkout.totalPay) }}</button><loader template=\"ellipsis\" size=\"x-small\" ng-show=\"checkout.inProgress\"><loader></loader></loader></div><div class=\"checkout-items-footer\" ng-if=\"checkout.paymentType === \'webpayplus\'\"><button class=\"btn checkout-btn-payment\" ng-click=\"checkout.sendToPaymentPortal()\" ng-disabled=\"checkout.isClosed || !checkout.how || !checkout.selectedLocation || !checkout.selectedLocationId || !checkout.paymentType || !checkout.scheduledOrderDataIsComplete() || checkout.loadingTotals\" ng-show=\"!checkout.inProgress\">{{ (checkout.selectedLocationIsClosed && !checkout.selectedLocationAllowsScheduling) ? \'Local Cerrado\' : (checkout.selectedLocationIsClosed && checkout.selectedLocationAllowsScheduling && checkout.scheduledOrderDateTime == null) ? \'Programa tu pedido y elige horario\' : \'Pagar \' + checkout.cart.parseIntl(checkout.totalPay) }}</button><loader template=\"ellipsis\" size=\"x-small\" ng-show=\"checkout.inProgress\"><loader></loader></loader></div></div><div class=\"pluxee-qr-box\" ng-if=\"checkout.paymentType === \'pluxee\' && checkout.pluxeeQrImage\"><p class=\"pluxee-qr-title\">Escanea tu código Pluxee</p><img class=\"pluxee-qr-image\" ng-src=\"{{checkout.pluxeeQrImage}}\" width=\"300\" alt=\"Código QR Pluxee\"><p class=\"pt-2\">o ingresa este código en tu App: {{checkout.pluxeeCode}}</p><p class=\"pluxee-qr-amount\">Total: {{checkout.cart.parseIntl(checkout.totalPay)}}</p><button class=\"btn cancel-button\" ng-click=\"checkout.cancelPluxeeQr()\" ng-disabled=\"checkout.processingWebPayment\">Cancelar</button></div></div>");
$templateCache.put("app/checkout/mobile/customer-coupons.modal.html","<div class=\"modal-header\"><div class=\"modal-header-back\"><button class=\"back-button\" data-dismiss=\"modal\" aria-label=\"Back\" ng-click=\"!checkout.couponLabelDisabled && checkout.closeModal()\"><i class=\"icon-back\"></i></button></div><div class=\"modal-header-title\"><h2>Mis cupones</h2></div></div><div class=\"modal-body\"><div class=\"checkout-customer-coupon-container\"><div class=\"checkout-customer-coupon\"><div class=\"checkout-input-coupon\"><input class=\"input-coupon\" name=\"coupon\" maxlength=\"50\" autocomplete=\"off\" placeholder=\"Ingresa tu cupón\" required=\"\" type=\"text\" ng-model=\"checkout.coupon.code\"> <button class=\"btn btn-coupon\" ng-click=\"!checkout.couponLabelDisabled && checkout.handleCouponApplication(checkout.coupon.code)\">Aplicar</button></div></div><div class=\"checkout-customer-coupon\" ng-repeat=\"customerCoupon in checkout.coupon.couponsGet()\"><input id=\"coupon-customer-{{$index}}\" name=\"coupon-customer\" type=\"radio\"> <label class=\"buttonselect\" for=\"coupon-customer-{{$index}}\" ng-click=\"!checkout.couponLabelDisabled && checkout.handleCouponApplication(customerCoupon.coupon.code)\"><div class=\"customer-coupon\"><span class=\"customer-coupon-icon\"><i class=\"icon-coupon\"></i></span> <span class=\"customer-coupon-text\"><span>{{customerCoupon.coupon.code}}</span> <small ng-if=\"customerCoupon.coupon.min_amount > 0\">{{customerCoupon.coupon.caption}}</small> <small ng-if=\"customerCoupon.coupon.coupon_type == \'products\' || customerCoupon.coupon.coupon_type == \'products_free\'\">{{customerCoupon.coupon.product_name || customerCoupon.coupon.value}}</small></span> <span class=\"customer-coupon-select\"><i class=\"icon-chevron-right\"></i></span></div></label></div></div></div>");
$templateCache.put("app/checkout/mobile/delivery-pickup.modal.html","<div class=\"modal-header\" ng-if=\"checkout.howModal == \'delivery\'\"><div class=\"modal-header-back\"><button class=\"back-button\" data-dismiss=\"modal\" aria-label=\"Back\" ng-click=\"checkout.closeModal()\"><i class=\"icon-back\"></i></button></div><div class=\"modal-header-title\"><h2>Mis direcciones</h2></div></div><div class=\"modal-header\" ng-if=\"checkout.howModal == \'pickup\'\"><div class=\"modal-header-back\"><button class=\"back-button\" data-dismiss=\"modal\" aria-label=\"Back\" ng-click=\"checkout.closeModal()\"><i class=\"icon-back\"></i></button></div><div class=\"modal-header-title\"><h2>{{checkout.restaurantText}}</h2></div></div><div class=\"modal-body\"><div class=\"checkout-select-delivery-pickup-container\"><div class=\"checkout-select-delivery-pickup\"><input id=\"how-delivery-modal\" name=\"how-delivery-modal\" type=\"radio\" value=\"delivery\" ng-model=\"checkout.howModal\" ng-change=\"checkout.handlePickupDeliveryModal(\'delivery\')\"> <label class=\"checkout-button-select\" for=\"how-delivery-modal\"><span>{{checkout.localeDelivery}}</span></label> <input id=\"how-pickup-modal\" name=\"how-pickup-modal\" type=\"radio\" value=\"pickup\" ng-model=\"checkout.howModal\" ng-change=\"checkout.handlePickupDeliveryModal(\'pickup\')\"> <label class=\"checkout-button-select\" for=\"how-pickup-modal\"><span>{{checkout.localePickup}}</span></label></div><div class=\"checkout-pickup-search-container\" ng-if=\"checkout.howModal == \'pickup\'\"><input type=\"text\" class=\"checkout-pickup-search-input\" ng-model=\"checkout.pickupSearchQuery\" placeholder=\"Buscar local\"></div></div><div class=\"checkout-delivery-pickup-container\" ng-if=\"checkout.howModal == \'delivery\' && checkout.addressLocations.length > 0\"><div class=\"checkout-delivery-pickup-title\"><div class=\"delivery-pickup-title\"><h1>Selecciona una de tus direcciones guardadas:</h1></div></div></div><div class=\"checkout-delivery-pickup-container\" ng-if=\"checkout.howModal == \'pickup\'\"><div class=\"checkout-delivery-pickup-title\"><div class=\"delivery-pickup-title\"><h1>Selecciona un local:</h1></div></div></div><div class=\"checkout-delivery-pickup-container\" ng-if=\"checkout.howModal == \'delivery\'\"><div id=\"checkout-delivery-{{$index}}-container\" class=\"checkout-delivery-pickup-location\" ng-repeat=\"address in checkout.addressLocations\" ng-class=\"{\'hide\': ![0,1,2,3,4].includes($index)}\"><input type=\"radio\" id=\"checkout-address-{{$index}}\" name=\"checkout-address\" ng-value=\"address.id\" ng-model=\"checkout.selectedLocationId\" ng-click=\"checkout.selectLocationModal(\'delivery\', address)\" ng-disabled=\"(!address.assigned_restaurant_is_open || !address.assigned_restaurant_group_is_correct) && !checkout.restaurantAllowsScheduling(address.assigned_restaurant)\"> <label class=\"buttonselect\" for=\"checkout-address-{{$index}}\"><div class=\"location\"><div class=\"location-map-pin\"><i class=\"icon-map-pin-fill\"></i></div><div class=\"location-address-detail\" ng-if=\"address.address\"><span>{{address.comune_name}}</span><div class=\"location-street\"><span>{{address.street_name}} #{{address.street_number}}</span> <small ng-if=\"address.specific_number\">{{address.specific_number}}</small></div></div><div class=\"location-restaurant-detail\" ng-if=\"address.assigned_restaurant_is_open && address.assigned_restaurant_group_is_correct\"><span class=\"location-pickup-time\">{{address.delivery_restaurant_pickup_time}} min.</span></div><div class=\"location-restaurant-detail\" ng-if=\"!address.assigned_restaurant_is_open || !address.assigned_restaurant_group_is_correct\"><span class=\"location-is-closed\" ng-if=\"!address.assigned_restaurant_is_open && address.assigned_restaurant_group_is_correct && checkout.restaurantAllowsScheduling(address.assigned_restaurant)\">Programa tu pedido</span> <span class=\"location-is-closed\" ng-if=\"!address.assigned_restaurant_is_open && address.assigned_restaurant_group_is_correct && !checkout.restaurantAllowsScheduling(address.assigned_restaurant)\">Local cerrado</span> <span class=\"location-change-region\" ng-if=\"!address.assigned_restaurant_group_is_correct && envConstants.ALLOW_PRICE_LISTS === \'true\'\" ng-click=\"checkout.openModalLocation()\">Cambiar de región</span> <span class=\"location-no-coverage\" ng-if=\"!address.assigned_restaurant_group_is_correct && envConstants.ALLOW_PRICE_LISTS !== \'true\'\">Sin cobertura</span></div><div class=\"location-select\"><i class=\"icon-chevron-right\"></i></div></div></label></div><p id=\"checkout-click-change-delivery\" class=\"checkout-change-delivery\" ng-if=\"checkout.addressLocations.length > 5\" ng-click=\"checkout.showLocationModal(); checkout.changeLocationElement(\'delivery\', \'add\');\">Ver mis direcciones</p></div><div class=\"checkout-delivery-pickup-container\" ng-if=\"checkout.howModal == \'pickup\'\"><div id=\"checkout-pickup-{{$index}}-container\" class=\"checkout-delivery-pickup-location\" ng-repeat=\"restaurant in (checkout.pickupRestaurants | filter:checkout.pickupSearchQuery) track by restaurant.id\" ng-class=\"{\'hide\': !checkout.pickupSearchQuery && ![0,1,2,3,4].includes($index)}\"><input type=\"radio\" id=\"checkout-restaurant-{{$index}}\" name=\"checkout-restaurant\" ng-value=\"restaurant.id\" ng-model=\"checkout.selectedLocationId\" ng-disabled=\"(!restaurant.is_open || !restaurant.restaurant_group_is_correct) && !checkout.restaurantAllowsScheduling(restaurant)\"> <label class=\"buttonselect\" for=\"checkout-restaurant-{{$index}}\" ng-click=\"checkout.selectLocationModal(\'pickup\', restaurant)\"><div class=\"location\"><div class=\"location-map-pin\"><i class=\"icon-map-pin-fill\"></i><div class=\"checkout-distance\" ng-if=\"checkout.selectedLocation.distance_from_customer\"><span class=\"distance-value\">{{ restaurant.distance_from_customer.split(\' \')[0] }}</span> <span class=\"distance-unit\">{{ restaurant.distance_from_customer.split(\' \')[1] }}</span></div></div><div class=\"location-address-detail\" ng-if=\"restaurant.address\"><span>{{restaurant.name}}</span><div class=\"location-street\"><span>{{restaurant.comune_name}}, {{restaurant.address}}</span></div></div><div class=\"location-restaurant-detail\" ng-if=\"restaurant.is_open && restaurant.restaurant_group_is_correct\"><span class=\"location-pickup-time\">{{restaurant.current_pickup_time}} min.</span></div><div class=\"location-restaurant-detail\" ng-if=\"!restaurant.is_open || !restaurant.restaurant_group_is_correct\"><span class=\"location-is-closed\" ng-if=\"!restaurant.is_open && restaurant.restaurant_group_is_correct && checkout.restaurantAllowsScheduling(restaurant)\">Programa tu pedido</span> <span class=\"location-is-closed\" ng-if=\"!restaurant.is_open && restaurant.restaurant_group_is_correct && !checkout.restaurantAllowsScheduling(restaurant)\">Local cerrado</span> <span class=\"location-change-region\" ng-if=\"!restaurant.restaurant_group_is_correct && envConstants.ALLOW_PRICE_LISTS === \'true\'\" ng-click=\"checkout.openModalLocation()\">Cambiar de región</span> <span class=\"location-no-coverage\" ng-if=\"!restaurant.restaurant_group_is_correct && envConstants.ALLOW_PRICE_LISTS !== \'true\'\">Sin cobertura</span></div><div class=\"location-select\"><i class=\"icon-chevron-right\"></i></div></div></label></div><p id=\"checkout-click-change-pickup\" class=\"checkout-change-pickup\" ng-if=\"checkout.pickupRestaurants.length > 5 && !checkout.pickupSearchQuery\" ng-click=\"checkout.showLocationModal(); checkout.changeLocationElement(\'pickup\', \'add\')\">Ver más <span>{{checkout.restaurantText}}</span></p><p class=\"checkout-pickup-empty\" ng-if=\"checkout.pickupSearchQuery && checkout.pickupRestaurants.length && !(checkout.pickupRestaurants | filter:checkout.pickupSearchQuery).length\">No encontramos locales con esa búsqueda.</p><p class=\"checkout-change-location selected\" ng-if=\"envConstants.ALLOW_PRICE_LISTS === \'true\'\" ng-click=\"checkout.openModalLocation()\">¿No encuentras tu local?</p></div><div class=\"button-new-address-center\" ng-if=\"checkout.showNewAddressBtn && checkout.howModal == \'delivery\'\"><button class=\"btn new-address-button\" ng-click=\"checkout.closeModal(); checkout.newAddressSidebarModal();\"><i class=\"icon-plus\"></i><p>Agregar una nueva dirección</p></button></div></div>");
$templateCache.put("app/checkout/mobile/payment-method.modal.html","<div class=\"modal-header\"><div class=\"modal-header-back\"><button class=\"back-button\" aria-label=\"Back\" ng-click=\"checkout.closeModal()\"><i class=\"icon-back\"></i></button></div><div class=\"modal-header-title\"><h2>Método de pago</h2></div></div><div class=\"modal-body\"><div class=\"checkout-payment-method-container\" ng-if=\"checkout.onlinePaymentOn && ((checkout.country === \'MX\' && checkout.paymentCards && checkout.paymentCards.length > 0) || (checkout.country !== \'MX\' && checkout.tbkUsers && checkout.tbkUsers.length > 0))\"><div class=\"checkout-payment-method separator-line\"><div class=\"checkout-payment-method-title\"><h1>Selecciona tu tarjeta</h1></div><div class=\"dropdown-card-selector\" ng-class=\"{ open: checkout.showCardDropdown }\"><div class=\"checkout-payment-card\" ng-click=\"(checkout.country === \'MX\' ? checkout.paymentCards.length > 1 : checkout.tbkUsers.length > 1 ) && checkout.toggleCardDropdown()\"><div class=\"payment dropdown-label\"><div class=\"card-option\"><img ng-if=\"checkout.country === \'MX\' && checkout.kushkiCard\" ng-src=\"{{ checkout.getCardLogo(checkout.kushkiCard.payment_brand) }}\" class=\"card-logo\"> <img ng-if=\"checkout.country !== \'MX\' && checkout.tbkUser\" ng-src=\"{{ checkout.getCardLogo(checkout.tbkUser.card_type) }}\" class=\"card-logo\"> <span class=\"card-option-number\">{{ checkout.getSelectedCardLabel() }}</span></div></div><div class=\"payment-arrow\" ng-if=\"(checkout.country === \'MX\' && checkout.paymentCards.length > 1) || (checkout.country !== \'MX\' && checkout.tbkUsers.length > 1)\"><i class=\"icon-chevron-down\" ng-if=\"!checkout.showCardDropdown\"></i> <i class=\"icon-chevron-up\" ng-if=\"checkout.showCardDropdown\"></i></div></div><ul class=\"card-dropdown-panel\" ng-if=\"checkout.showCardDropdown && ((checkout.country === \'MX\' && checkout.paymentCards.length > 1) || (checkout.country !== \'MX\' && checkout.tbkUsers.length > 1))\"><li ng-repeat=\"card in (checkout.country === \'MX\' ? checkout.paymentCards : checkout.tbkUsers)\" ng-click=\"checkout.country === \'MX\' ? checkout.selectKushkiCardDraft(card) : checkout.selectCreditCard(card.id)\" ng-class=\"{ selected: checkout.country === \'MX\' ? checkout.kushkiCardDraft && checkout.kushkiCardDraft.token === card.token : checkout.creditCard === card.id}\"><div class=\"card-option\"><img ng-if=\"checkout.country === \'MX\'\" ng-src=\"{{ checkout.getCardLogo(card.payment_brand) }}\" class=\"card-logo\"> <img ng-if=\"checkout.country !== \'MX\'\" ng-src=\"{{ checkout.getCardLogo(card.card_type) }}\" class=\"card-logo\"> <span class=\"card-option-number\">**** {{ checkout.country === \'MX\' ? card.card_last_four : card.last_4_card_digits }}</span></div></li></ul></div><div class=\"add-new-card-text\" ng-click=\"checkout.closeModal(); checkout.country === \'MX\' ? checkout.openKushkiInscription() : checkout.goToInscriptionbWebpay()\">Inscribir tarjeta</div><div class=\"button-new-address-center\"><button class=\"btn new-address-button\" ng-click=\"checkout.country === \'MX\' ? checkout.confirmSelectedKushkiCard() : checkout.confirmSelectedCard()\"><p>Confirmar tarjeta</p></button></div></div></div><div class=\"checkout-payment-method-container\" ng-if=\"checkout.onlinePaymentOn && ((checkout.country === \'MX\' && (!checkout.paymentCards || checkout.paymentCards.length === 0)) || (checkout.country !== \'MX\' && (!checkout.tbkUsers || checkout.tbkUsers.length === 0)))\"><div class=\"button-new-address-center\"><button class=\"btn new-address-button\" ng-click=\"checkout.closeModal(); checkout.country === \'MX\' ? checkout.openKushkiInscription() : checkout.goToInscriptionbWebpay()\">Inscribir tarjeta</button></div></div><div class=\"checkout-payment-method-container\"><div class=\"checkout-payment-method\" ng-repeat=\"payment in checkout.paymentOrder\" ng-if=\"checkout.checkPaymentTypeAllowedScheduledOrder(payment.type)\"><div class=\"checkout-payment-card\" ng-click=\"checkout.handlePaymentMethodSelection(payment)\" ng-class=\"{ selected: checkout.paymentTypeModal === payment.type }\"><div class=\"payment\" ng-class=\"{ \'payment-only-logo\': !checkout.paymentTypeIsCash(payment.type) }\"><img ng-if=\"!checkout.paymentTypeIsCash(payment.type) && checkout.paymentConfig[payment.type] && checkout.paymentConfig[payment.type].icon\" ng-src=\"{{ checkout.paymentConfig[payment.type].icon }}\" alt=\"{{ checkout.paymentConfig[payment.type].label || payment.type }}\"> <span ng-if=\"checkout.paymentTypeIsCash(payment.type)\">{{ (checkout.paymentConfig[payment.type] && checkout.paymentConfig[payment.type].description) }}</span> <small class=\"discount\" ng-if=\"checkout.cart.showDiscountPercentage() && ((checkout.paymentConfig[payment.type] && checkout.paymentConfig[payment.type].discount > 0) || (payment.discount && payment.discount > 0))\">{{ checkout.paymentConfig[payment.type] && checkout.paymentConfig[payment.type].discount > 0 ? checkout.paymentConfig[payment.type].discount : payment.discount }}% de descuento</small></div><div class=\"payment-arrow\"><i class=\"icon-chevron-right\"></i></div></div></div></div></div>");
$templateCache.put("app/checkout/mobile/remove-product.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"confirmation.removeProductModal(false)\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><h2>Confirmar</h2></div><div class=\"modal-body\"><div class=\"modal-item\"><p>¿Deseas eliminar este producto: \"{{confirmation.product.seleable.name}}\"?</p><div class=\"form-checkbox-inline\"><div class=\"form-checkbox\"><input id=\"option-yes\" name=\"si\" type=\"radio\" ng-click=\"confirmation.removeProductModal(true)\"> <label for=\"option-yes\" class=\"button-select\"><div class=\"checkbox-label\"><span>Si</span></div></label></div><div class=\"form-checkbox\"><input id=\"option-no\" name=\"no\" type=\"radio\" ng-click=\"confirmation.removeProductModal(false)\"> <label for=\"option-no\" class=\"button-select\"><div class=\"checkbox-label\"><span>No</span></div></label></div></div></div></div>");
$templateCache.put("app/cart/mobile/cart.products.html","<header-cart></header-cart><div class=\"container-cart\"><div class=\"my-cart-body\"><h5 class=\"padding-bottom\">Productos</h5><div class=\"item-added\" ng-repeat=\"item in cart.items | orderBy:\'addedAt\'\"><div class=\"item-cart\"><div class=\"item-body\"><div class=\"item-img\"><product-badge badge=\"highlight-text\" seleable=\"seleable\"></product-badge><div class=\"content\"><img ng-src=\"{{item.seleable.image.medium}}\" alt=\"{{item.seleable.name}}\"></div></div><div class=\"item-controls\"><div class=\"item-box-quantity\"><button class=\"btn-quantity left\" ng-click=\"cart.removeOne(item)\" ng-if=\"cart.productCount(item) > 1\"><i class=\"icon-minus\"></i></button> <button class=\"btn-quantity left\" ng-click=\"cart.removeProduct(item)\" ng-if=\"cart.productCount(item) === 1\"><img class=\"icon-remove\" src=\"assets/images/desktop/borrar.svg\"></button> <input class=\"input-quantity\" type=\"text\" id=\"inputSumador\" ng-value=\"cart.productCount(item)\" name=\"quantity\" disabled=\"\"> <button class=\"btn-quantity right\" ng-click=\"cart.addOne(item)\"><i class=\"icon-plus\"></i></button></div></div></div><div class=\"item-info\"><div class=\"item-box-name\"><div class=\"item-name\"><p class=\"product-name\">{{item.seleable.name}}</p></div><div class=\"item-name description\" ng-repeat=\"option in cart.showOptions(item) track by $index\"><p class=\"item-option\">-</p><p class=\"item-option\">{{option}}</p></div><div class=\"item-name price\"><p class=\"total-price\" ng-show=\"cart.price(item, false) != cart.price(item, true)\">{{cart.cart.priceIntl(item.id, false, item.type, item.extraPrice)}}</p><p class=\"discount-price\">{{cart.cart.priceIntl(item.id, true, item.type, item.extraPrice)}}</p></div></div></div></div></div><div class=\"item-added upselling border-none\" ng-if=\"cart.upsellingProducts.length > 0\"><h5>¿Un último antojo?</h5><div class=\"item-added border-none\" ng-repeat=\"seleable in cart.upsellingProducts\"><div class=\"item-cart\"><div class=\"item-body\"><div class=\"item-img\" ng-click=\"cart.viewSeleable(seleable, category)\"><product-badge badge=\"highlight-text\" seleable=\"seleable\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.image.medium}}\" alt=\"{{seleable.name}}\"></div></div><div class=\"item-controls\"><div class=\"item-box-quantity\" ng-controller=\"MenuController as menu\"><button class=\"btn-quantity upselling\" ng-click=\"menu.addToCart(seleable, category)\"><span>Agregar</span></button></div></div></div><div class=\"item-info\"><div class=\"item-box-name\"><div class=\"item-name\"><p class=\"product-name\">{{seleable.name}}</p></div><div class=\"item-name description\" ng-if=\"seleable.servings\"><p class=\"item-option\">({{seleable.servings}} porciones)</p></div><div class=\"item-name price\"><p class=\"total-price\" ng-show=\"cart.cart.priceValue(seleable, false, false) != cart.cart.priceValue(seleable, true, false)\">{{cart.cart.priceValue(seleable, false, true)}}</p><p class=\"discount-price\">{{cart.cart.priceValue(seleable, true, true)}}</p></div></div></div></div></div></div></div><div class=\"my-cart-shopping\" ng-show=\"cart.count\"><div class=\"additional-products\" ng-show=\"cart.additionalItems.length > 0\"><div class=\"additional-items-info\" ng-show=\"cart.additionalItems.length > 0\"><p class=\"item-info\">Incluimos en tu pedido</p></div><div class=\"additional-items\"><div class=\"unitary-product\" ng-repeat=\"item in cart.additionalProducts\" ng-if=\"item.additional_type === \'unitary\'\"><input id=\"option-{{item.id}}\" ng-model=\"item.option_on\" ng-change=\"cart.toggleSwitch(item.id)\" type=\"checkbox\"> <label for=\"option-{{item.id}}\">{{item.name}}<div class=\"toggle-switch\"></div></label></div></div><div class=\"additional-items-info\" ng-show=\"cart.additionalItems.length > 0\"><div class=\"all-additional-items\"><span ng-repeat=\"item in cart.additionalItems\"><em>{{cart.showAdditionalItem(item)}} &nbsp;</em></span></div></div></div><div class=\"container-coupon\"><p class=\"coupon-text\" ng-click=\"cart.showCouponArea()\">¿Tienes un cupón? Ingrésalo aquí</p><div id=\"inputs-area\" class=\"coupon hide\"><input class=\"input-coupon\" name=\"coupon\" maxlength=\"50\" autocomplete=\"off\" placeholder=\"Cupón de descuento\" required=\"\" type=\"text\" ng-model=\"cart.coupon.code\" ng-disabled=\"!cart.customer\"> <button class=\"btn btn-coupon\" ng-click=\"cart.coupon.applyCoupon(true)\" ng-disabled=\"!cart.coupon.code\">Aplicar</button></div><p id=\"info-area\" class=\"coupon-info hide\" ng-show=\"!cart.customer\"><span>*</span> debes iniciar sesión para ingresar un cupón</p></div><div class=\"container-price\"><div class=\"subtotal\"><h5>Subtotal</h5><div class=\"subtotal-details\"><h5 class=\"without-discount\" ng-if=\"cart.discountable()\">{{cart.cart.parseIntl(cart.total)}}</h5><h5>{{cart.cart.parseIntl(cart.subtotalDiscount)}}</h5></div></div><div class=\"coupon\" ng-if=\"cart.currentCouponValue > 0\"><h5>Incluye cupón</h5><div class=\"coupon-value\"><h5>- {{cart.cart.showCoupon(cart.currentCoupon.coupon)}}</h5><a ng-click=\"cart.coupon.deactivateCoupon(cart.currentCoupon.coupon)\"><i class=\"icon-x\"></i></a></div></div></div><div class=\"container-price\"><div class=\"total\"><h5>Total</h5><h5>{{cart.cart.parseIntl(cart.totalDiscount)}}</h5></div></div><div id=\"open-restaurant\" class=\"container-open-restaurant hide\"><div class=\"open-restaurant\"><div id=\"countdown\"></div></div></div><div class=\"footer-cart-shopping\"><button ui-sref=\"menu\" class=\"btn btn-cart-shopping modifier-order\">Volver al menú</button> <button id=\"confirmation-order\" ui-sref=\"cart.whenhowwhere\" class=\"btn btn-cart-shopping confirmation-order hide\" ng-click=\"cart.validateState()\" disabled=\"disabled\"><span id=\"button-text\">Cerrado</span></button><loader template=\"ellipsis\"><loader></loader></loader></div></div></div>");
$templateCache.put("app/cart/mobile/cart.when-how-n-where.html","<header-cart></header-cart><div class=\"container-checkout\"><div class=\"welcome-checkout\"><h1>Finalicemos tu pedido</h1><div class=\"container-how\" ng-show=\"cart.contentLoaded\"><h5>¿Cómo te lo entregamos?</h5><div class=\"how-box-horizontal\"><input id=\"how-pickup\" name=\"how\" type=\"radio\" value=\"pickup\" ng-model=\"cart.how\" ng-change=\"cart.handlePickupDelivery(\'pickup\')\"> <label class=\"buttonselect pickup\" for=\"how-pickup\"><span>{{cart.localePickup}}</span></label> <input id=\"how-delivery\" name=\"how\" type=\"radio\" value=\"delivery\" ng-model=\"cart.how\" ng-change=\"cart.handlePickupDelivery(\'delivery\')\"> <label class=\"buttonselect delivery\" for=\"how-delivery\"><span>{{cart.localeDelivery}}</span> <small ng-if=\"!cart.cart.freeShipping()\">+ {{cart.cart.parseIntl(envConstants.DELIVERY)}} de envío</small> <small ng-if=\"cart.cart.freeShipping()\">Envío gratis</small></label></div></div><div class=\"container-how\" id=\"where\" ng-if=\"cart.how == \'pickup\' && !cart.hasPickup\"><div class=\"where-title\"><h5>Esta opción no está disponible en este momento.</h5></div></div><div class=\"container-how\" id=\"where\" ng-if=\"cart.how == \'pickup\' && cart.hasPickup\"><div class=\"where-title\"><h5>¿Dónde lo quieres?</h5><h6>Tiempo aprox</h6></div><p ng-if=\"!cart.pickupRestaurants.length\" class=\"p-message\">Locales cerrados momentáneamente. Por favor intenta más tarde.</p><div class=\"how-box-vertical\"><div id=\"container-where-restaurant-{{$index}}\" ng-repeat=\"location in cart.pickupRestaurants\" class=\"container-how-box-vertical\" ng-class=\"{\'hide\': ![0,1,2].includes($index)}\"><input type=\"radio\" id=\"where-restaurant-{{$index}}\" name=\"where-restaurant\" ng-value=\"location.id\" ng-model=\"cart.selectedLocationId\" ng-change=\"cart.selectQuestion(\'cual\', location)\" ng-click=\"cart.selectLocation(); cart.hideWhere(\'restaurant\', $index); cart.changeWhereElement(\'restaurant\', \'remove\')\"> <label class=\"buttonselect\" for=\"where-restaurant-{{$index}}\" ng-click=\"cart.selectLocation(); cart.hideWhere(\'restaurant\', $index); cart.changeWhereElement(\'restaurant\', \'remove\')\"><div class=\"location\"><p class=\"location-address\" ng-show=\"location.name\"><span>{{location.name}}</span> <small>{{location.comune_name}}, {{location.address}}</small></p><span class=\"pickup-time\" ng-show=\"location.current_pickup_time && location.current_pickup_time > 0\">{{location.current_pickup_time}} min.</span></div></label></div></div><p id=\"click-change-restaurant\" class=\"change-restaurant\" ng-click=\"cart.showWhere(); cart.changeWhereElement(\'restaurant\', \'add\')\">Cambiar de local</p><p class=\"change-location selected\" ng-if=\"envConstants.ALLOW_PRICE_LISTS === \'true\'\" ng-click=\"cart.openModalLocation()\">¿No encuentras tu local?</p></div><div class=\"container-how\" id=\"where\" ng-if=\"cart.how == \'delivery\' && !cart.hasDelivery\"><div class=\"where-title\"><h5>Las tiendas se encuentran momentáneamente sin delivery.</h5></div></div><div class=\"container-how\" id=\"where\" ng-if=\"cart.how == \'delivery\'\"><div class=\"where-title\"><h5>¿Dónde lo quieres?</h5><h6>Tiempo aprox</h6></div><div class=\"how-box-vertical\"><div id=\"container-where-address-{{$index}}\" ng-repeat=\"location in cart.addressLocations\" class=\"container-how-box-vertical\" ng-class=\"{\'hide\': ![0,1,2].includes($index)}\"><div class=\"separator-line\" ng-if=\"$index == 3\"></div><input type=\"radio\" id=\"where-address-{{$index}}\" name=\"where-address\" ng-value=\"location.id\" ng-model=\"cart.selectedLocationId\" ng-change=\"cart.selectQuestion(\'cual\', location)\" ng-click=\"cart.selectLocation(); cart.hideWhere(\'address\', $index); cart.changeWhereElement(\'address\', \'remove\'); cart.hideNewAddress();\" ng-if=\"location.assigned_restaurant_is_open && location.assigned_restaurant_group_is_correct\"> <input type=\"radio\" id=\"where-address-{{$index}}\" name=\"where-address\" ng-value=\"location.id\" ng-model=\"cart.selectedLocationId\" ng-if=\"!location.assigned_restaurant_is_open || !location.assigned_restaurant_group_is_correct\" disabled=\"\"> <label class=\"buttonselect\" for=\"where-address-{{$index}}\" ng-click=\"cart.selectLocation(); cart.hideWhere(\'address\', $index); cart.changeWhereElement(\'address\', \'remove\'); cart.hideNewAddress();\" ng-if=\"location.assigned_restaurant_is_open && location.assigned_restaurant_group_is_correct\"><div class=\"location\"><div class=\"location-address\" ng-show=\"location.address\"><span>{{location.comune_name}}</span> <small>{{location.street_name}} #{{location.street_number}}</small> <small ng-if=\"location.specific_number\">{{location.specific_number}}</small></div><span class=\"pickup-time\" ng-show=\"location.delivery_restaurant_pickup_time && location.delivery_restaurant_pickup_time > 0\">{{location.delivery_restaurant_pickup_time}} min.</span></div></label> <label class=\"buttonselect\" for=\"where-address-{{$index}}\" ng-if=\"!location.assigned_restaurant_is_open || !location.assigned_restaurant_group_is_correct\" disabled=\"\"><div class=\"location\"><div class=\"location-address\" ng-show=\"location.address\"><span>{{location.comune_name}}</span> <small>{{location.street_name}} #{{location.street_number}}</small> <small ng-if=\"location.specific_number\">{{location.specific_number}}</small></div><div class=\"disabled-detail\"><span class=\"is-closed\" ng-if=\"!location.assigned_restaurant_is_open && location.assigned_restaurant_group_is_correct\">Local cerrado</span> <span class=\"change-region\" ng-if=\"!location.assigned_restaurant_group_is_correct && envConstants.ALLOW_PRICE_LISTS === \'true\'\" ng-click=\"cart.openModalLocation()\">Cambiar de región</span> <span class=\"no-coverage\" ng-if=\"!location.assigned_restaurant_group_is_correct && envConstants.ALLOW_PRICE_LISTS !== \'true\'\">Sin cobertura</span></div></div></label></div><a id=\"btn-new-address\" class=\"btn btn-direction\" href=\"javascript:void(0)\" ng-click=\"cart.newAddressModal(true)\"><span>Nueva dirección</span></a></div><p id=\"click-change-address\" class=\"change-address hide\" ng-click=\"cart.showWhere(); cart.changeWhereElement(\'address\', \'add\'); cart.showNewAddress();\">Ver mis direcciones</p></div><div class=\"container-how\" ng-show=\"cart.selectedLocationId && cart.how\"><h5>¿Cómo lo pagas?</h5><div class=\"how-box-vertical payment\"><div class=\"container-how-box-vertical payment\" ng-if=\"cart.kushkiPaymentOn && !cart.paymentCards.length > 0 && !cart.discountable()\"><input id=\"init-kushki\" name=\"cual\" type=\"radio\" value=\"kushki\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(0)\"> <label class=\"buttonselect payment\" for=\"init-kushki\"><div class=\"payment credit-card\"><div class=\"box-text\"><span>Pago en línea</span></div><div class=\"box-enter-card\" ng-click=\"cart.kushki.openModalInscriptionKushkiCard()\"><span class=\"enter-card\">Inscribir tarjeta</span></div></div></label></div><div class=\"container-how-box-vertical payment\" ng-if=\"cart.kushkiPaymentOn && cart.paymentCards.length > 0 && !cart.discountable()\"><input id=\"{{cart.kushkiCard.token}}\" name=\"cual\" type=\"radio\" value=\"kushki\" ng-model=\"cart.paymentType\" ng-change=\"cart.selectedCardToken = cart.kushkiCard.token; cart.updatedDiscount(0); card.selectedCardId = cart.kushkiCard.id\"> <label class=\"buttonselect payment\" for=\"{{cart.kushkiCard.token}}\"><div class=\"payment credit-card\"><div class=\"box-text\"><span>Pago en línea</span> <span>{{cart.cart.cardTypeName(cart.kushkiCard.payment_brand)}}</span> <small>**** {{cart.kushkiCard.card_last_four}}</small></div><div class=\"box-enter-card\" ng-click=\"cart.openModalCreditCard(cart.kushkiCard.token)\"><span class=\"enter-card\">Otra tarjeta</span></div></div></label></div><div class=\"container-how-box-vertical payment\" ng-if=\"cart.onlinePayment && !cart.tbkUser && !cart.discountable() && cart.onlinePaymentOn\"><input id=\"init-webpay\" name=\"cual\" type=\"radio\" value=\"webpay\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(0)\" ng-click=\"cart.initInscriptionUrl()\"> <label class=\"buttonselect payment\" for=\"init-webpay\" ng-click=\"cart.initInscriptionUrl()\"><div class=\"payment credit-card\"><div class=\"box-text\"><img src=\"assets/images/transbank/oneclick.svg\" alt=\"logo\"></div><div class=\"box-enter-card\" ng-click=\"cart.initInscriptionUrl(); cart.goToInscriptionbWebpay()\"><span class=\"enter-card\">Inscribir tarjeta</span></div></div></label></div><div class=\"container-how-box-vertical payment\" ng-if=\"cart.onlinePayment && !!cart.tbkUser && !cart.discountable() && cart.onlinePaymentOn\"><input id=\"cual-webpay\" name=\"cual\" type=\"radio\" value=\"webpay\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(0)\"> <label class=\"buttonselect payment\" for=\"cual-webpay\"><div class=\"payment credit-card\"><div class=\"box-text\"><img src=\"assets/images/transbank/oneclick.svg\" alt=\"logo\"> <small>{{cart.cart.cardTypeName(cart.tbkUser.card_type)}} **** {{cart.tbkUser.last_4_card_digits}}</small></div><div class=\"box-enter-card\" ng-click=\"cart.openModalCreditCard(cart.tbkUser.id)\"><span class=\"enter-card\">Otra tarjeta</span></div></div></label></div><div class=\"container-how-box-vertical payment\" ng-if=\"cart.kushkiPaymentOn && !cart.paymentCards.length > 0 && cart.discountable()\"><input id=\"init-kushki-discount\" name=\"cual\" type=\"radio\" value=\"kushki\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(cart.DEFAULT_DISCOUNT_1)\"> <label class=\"buttonselect payment\" for=\"init-kushki-discount\"><div class=\"payment credit-card\"><div class=\"box-text\"><span>Pago en línea</span> <small ng-if=\"cart.cart.showDiscountPercentage() && cart.DEFAULT_DISCOUNT_1 > 0\">{{cart.DEFAULT_DISCOUNT_1}}% Dcto.</small></div><div class=\"box-enter-card\" ng-click=\"cart.kushki.openModalInscriptionKushkiCard()\"><span class=\"enter-card\">Inscribir tarjeta</span></div></div></label></div><div class=\"container-how-box-vertical payment\" ng-if=\"cart.kushkiPaymentOn && cart.paymentCards.length > 0 && cart.discountable()\"><input id=\"{{cart.kushkiCard.token}}\" name=\"cual\" type=\"radio\" value=\"kushki\" ng-model=\"cart.paymentType\" ng-change=\"cart.selectedCardToken = cart.kushkiCard.token; cart.updatedDiscount(cart.DEFAULT_DISCOUNT_1)\"> <label class=\"buttonselect payment\" for=\"{{cart.kushkiCard.token}}\"><div class=\"payment credit-card\"><div class=\"box-text\"><span>Pago en línea</span> <span>{{cart.cart.cardTypeName(cart.kushkiCard.payment_brand)}}</span> <small>**** {{cart.kushkiCard.card_last_four}}</small></div><div class=\"box-enter-card\" ng-click=\"cart.openModalCreditCard(cart.kushkiCard.token)\"><span class=\"enter-card\">Otra tarjeta</span></div></div></label></div><div class=\"container-how-box-vertical payment\" ng-if=\"cart.onlinePayment && !cart.tbkUser && cart.discountable() && cart.onlinePaymentOn\"><input id=\"init-webpay-discount\" name=\"cual\" type=\"radio\" value=\"webpay\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(cart.DEFAULT_DISCOUNT_1)\" ng-click=\"cart.initInscriptionUrl()\"> <label class=\"buttonselect payment\" for=\"init-webpay-discount\" ng-click=\"cart.initInscriptionUrl()\"><div class=\"payment credit-card\"><div class=\"box-text\"><img src=\"assets/images/transbank/oneclick.svg\" alt=\"logo\"> <small ng-if=\"cart.cart.showDiscountPercentage() && cart.DEFAULT_DISCOUNT_1 > 0\">{{cart.DEFAULT_DISCOUNT_1}}% Dcto.</small></div><div class=\"box-enter-card\" ng-click=\"cart.initInscriptionUrl(); cart.goToInscriptionbWebpay()\"><span class=\"enter-card\">Inscribir tarjeta</span></div></div></label></div><div class=\"container-how-box-vertical payment\" ng-if=\"cart.onlinePayment && !!cart.tbkUser && cart.discountable() && cart.onlinePaymentOn\"><input id=\"cual-webpay\" name=\"cual\" type=\"radio\" value=\"webpay\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(cart.DEFAULT_DISCOUNT_1)\"> <label class=\"buttonselect payment\" for=\"cual-webpay\"><div class=\"payment credit-card\"><div class=\"box-text\"><img src=\"assets/images/transbank/oneclick.svg\" alt=\"logo\"> <small>{{cart.cart.cardTypeName(cart.tbkUser.card_type)}} **** {{cart.tbkUser.last_4_card_digits}}</small> <small>{{cart.DEFAULT_DISCOUNT_1}}% Dcto.</small></div><div class=\"box-enter-card\" ng-click=\"cart.openModalCreditCard(cart.tbkUser.id)\"><span class=\"enter-card\">Otra tarjeta</span></div></div></label></div><div class=\"container-how-box-vertical payment\" ng-if=\"cart.onlinePayment && cart.onlinePaymentOn && cart.webpayplusPayment && cart.webpayplus_commerce_code\"><input id=\"cual-webpayplus\" name=\"cual\" type=\"radio\" value=\"webpayplus\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(cart.DEFAULT_DISCOUNT_1)\"> <label class=\"buttonselect payment\" for=\"cual-webpayplus\"><div class=\"payment\"><img src=\"assets/images/transbank/webpayplus.svg\" alt=\"logo\"> <small ng-if=\"cart.cart.showDiscountPercentage() && cart.DEFAULT_DISCOUNT_1 > 0\">{{cart.DEFAULT_DISCOUNT_1}}% Dcto.</small></div></label></div><div class=\"container-how-box-vertical payment\" ng-if=\"cart.discountable()\"><input id=\"cual-efectivo-descuento\" name=\"cual\" type=\"radio\" value=\"efectivo\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(cart.DEFAULT_DISCOUNT_1)\"> <label class=\"buttonselect payment\" for=\"cual-efectivo-descuento\"><div class=\"payment\"><span>Contra entrega (efectivo, tarjeta de débito y crédito)</span> <small ng-if=\"cart.cart.showDiscountPercentage() && cart.DEFAULT_DISCOUNT_1 > 0\">{{cart.DEFAULT_DISCOUNT_1}}% Dcto.</small></div></label></div><div class=\"container-how-box-vertical payment\" ng-if=\"cart.sodexoPayment && cart.discountable()\"><input id=\"cual-tarjeta-descuento\" name=\"cual\" type=\"radio\" value=\"tarjeta\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(cart.DEFAULT_DISCOUNT_2)\"> <label class=\"buttonselect payment\" for=\"cual-tarjeta-descuento\"><div class=\"payment\"><span>Tarjeta Sodexo</span> <small ng-if=\"cart.cart.showDiscountPercentage() && cart.DEFAULT_DISCOUNT_2 > 0\">{{cart.DEFAULT_DISCOUNT_2}}% Dcto. (contra entrega)</small></div></label></div><div class=\"container-how-box-vertical payment\" ng-if=\"!cart.discountable()\"><input id=\"cual-efectivo\" name=\"cual\" type=\"radio\" value=\"efectivo\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(0)\"> <label class=\"buttonselect payment\" for=\"cual-efectivo\"><div class=\"payment\"><span>Contra entrega (efectivo, tarjeta de débito y crédito)</span></div></label></div><div class=\"container-how-box-vertical payment\" ng-if=\"cart.sodexoPayment && !cart.discountable()\"><input id=\"cual-tarjeta\" name=\"cual\" type=\"radio\" value=\"tarjeta\" ng-model=\"cart.paymentType\" ng-change=\"cart.updatedDiscount(0)\"> <label class=\"buttonselect payment\" for=\"cual-tarjeta\"><div class=\"payment\"><span>Tarjeta Sodexo</span> <small>(contra entrega)</small></div></label></div></div></div><div id=\"tip\" class=\"container-how\" ng-if=\"cart.showTips()\"><h5>¿Agregas propina?</h5><div class=\"how-box-horizontal tip\"><input id=\"tip-{{$index}}\" name=\"tip\" type=\"radio\" ng-init=\"cart.checkedTip(tip)\" ng-value=\"tip.id\" ng-model=\"cart.selectedTip.id\" ng-click=\"cart.selectTip(tip)\" ng-repeat-start=\"tip in cart.tips\"> <label class=\"buttonselect\" for=\"tip-{{$index}}\" ng-click=\"cart.selectTip(tip)\" ng-repeat-end=\"\"><div class=\"tip\"><span ng-show=\"cart.cart.parseIntl(tip.amount)\">{{cart.cart.parseIntl(tip.amount)}}</span></div></label></div></div><div class=\"container-how no-gap\" ng-if=\"cart.selectedLocationId && cart.how && cart.paymentType\"><div class=\"how-box-total\"><div class=\"total\"><h5>Subtotal</h5><h5>{{cart.cart.parseIntl(cart.subTotal)}}</h5></div><div class=\"total\" ng-if=\"cart.how == \'delivery\'\"><h5 class=\"additional\">Delivery</h5><h5 class=\"additional\" ng-if=\"!cart.cart.freeShipping()\">+ {{cart.cart.parseIntl(envConstants.DELIVERY)}}</h5><h5 class=\"additional\" ng-if=\"cart.cart.freeShipping()\">Envío gratis</h5></div><div class=\"total\" ng-if=\"!!cart.selectedTip.id && cart.showTips()\"><h5 class=\"additional\">Propina</h5><h5 class=\"additional\">+ {{cart.cart.parseIntl(cart.selectedTip.amount)}}</h5></div><div class=\"total\" ng-if=\"cart.currentCouponValue > 0\"><h5 class=\"additional\">Incluye cupón</h5><h5 class=\"additional\">- {{cart.cart.showCoupon(cart.currentCoupon.coupon)}} dcto</h5></div></div><div class=\"how-box-total\"><div class=\"total\"><h5>Total</h5><h5>{{cart.cart.parseIntl(cart.totalPay)}}</h5></div></div></div><div class=\"container-how order-confirmation\"><div class=\"how-box-payment\" ng-if=\"cart.selectedLocationId && cart.how && cart.paymentType\"><button class=\"btn btn-payment go-back\" ui-sref=\"cart.products\">Volver al carro</button></div><div class=\"how-box-payment\" ng-if=\"cart.selectedLocationId && cart.how && cart.paymentType && cart.paymentType !== \'webpayplus\'\"><button class=\"btn btn-payment\" ng-click=\"cart.sendOrder()\" ng-show=\"!cart.inProgress\" ng-disabled=\"cart.initInscriptionButton || cart.inProgress || cart.isClosed || !cart.selectedLocationId || !cart.paymentType || cart.processingWebPayment || !cart.how\">Confirmar compra</button><loader template=\"ellipsis\" ng-show=\"cart.inProgress\"><loader></loader></loader></div><div class=\"how-box-payment\" ng-if=\"cart.selectedLocationId && cart.how && cart.paymentType && cart.paymentType === \'webpayplus\'\"><button class=\"btn btn-payment\" ng-click=\"cart.sendToPaymentPortal()\">Ir a pagar<br></button></div></div></div></div>");
$templateCache.put("app/cart/mobile/price-warning.modal.html","<div class=\"price-warning-modal\"><div class=\"modal-header\"><button class=\"close-button\" ng-click=\"$close(false)\"><i class=\"icon-x\"></i></button><h2>¡Atención!</h2></div><div class=\"modal-body\" stop-event=\"touchend\"><p>Recuerda que pedidos mayores a {{parseIntl(envConstants.WARNING_PRICE)}} deben ser pagados previos a que se produzcan.</p><p>Te recomendamos pagar en línea, o contactarte con el local para coordinar el pago.</p><p>Gracias por tu comprensión</p></div><div class=\"modal-footer\"><button ng-click=\"cancel()\">Entendido</button></div></div>");
$templateCache.put("app/cart/mobile/removeProduct.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"confirmation.removeProductModal(false)\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><h2>Confirmar</h2></div><div class=\"modal-body\"><div class=\"modal-item\"><p>¿Deseas eliminar este producto: \"{{confirmation.product.seleable.name}}\"?</p><div class=\"form-checkbox-inline\"><div class=\"form-checkbox\"><input id=\"option-yes\" name=\"si\" type=\"radio\" ng-click=\"confirmation.removeProductModal(true)\"> <label for=\"option-yes\" class=\"button-select\"><div class=\"checkbox-label\"><span>Si</span></div></label></div><div class=\"form-checkbox\"><input id=\"option-no\" name=\"no\" type=\"radio\" ng-click=\"confirmation.removeProductModal(false)\"> <label for=\"option-no\" class=\"button-select\"><div class=\"checkbox-label\"><span>No</span></div></label></div></div></div></div>");
$templateCache.put("app/components/gmap-iframe/gmap-iframe.html","<label class=\"modal-label\">Confirma la ubicación (arrastra el pin hasta que esté en la dirección deseada)</label><ui-gmap-google-map center=\"gmap.mapLonLat\" options=\"gmap.mapOptions\" pan=\"true\" zoom=\"16\"><ui-gmap-marker coords=\"gmap.lonLat\" idkey=\"1\" events=\"gmap.markerEvents\" options=\"gmap.markerOptions\"></ui-gmap-marker><ui-gmap-map-control ng-if=\"gmap.mapControl\" index=\"-1\" position=\"right-bottom\" template=\"app/address/restore/restore.html\"></ui-gmap-map-control></ui-gmap-google-map>");
$templateCache.put("app/credit-card/desktop/select-credit-card.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><h2>Tus tarjetas guardadas</h2></div><div class=\"modal-body\"><div class=\"modal-credit-cards\"><div class=\"container-credit-cards\" ng-if=\"creditCard.kushkiPayment\"><input id=\"init-kushki\" name=\"kushki\" type=\"radio\" value=\"{{null}}\" ng-model=\"creditCard.creditCard\"> <label class=\"buttonselect\" for=\"init-kushki\"><div class=\"credit-card\"><div class=\"box-text\"><span>Kushki</span></div><div class=\"box-enter-card\" ng-click=\"$close() && creditCard.kushki.openModalInscriptionKushkiCard()\"><span class=\"enter-card\">Inscribir tarjeta</span></div></div></label></div><div class=\"container-credit-cards\" ng-repeat=\"card in creditCard.paymentCards\" ng-if=\"creditCard.kushkiPayment && creditCard.paymentCards.length > 0\"><input id=\"kushki-{{$index}}\" name=\"kushki\" type=\"radio\" value=\"{{card.token}}\" ng-model=\"creditCard.creditCard\"> <label class=\"buttonselect\" for=\"kushki-{{$index}}\"><div class=\"credit-card\"><div class=\"box-text\"><span>Kushki</span> <span>{{creditCard.cart.cardTypeName(card.payment_brand)}}&nbsp; <small>**** {{card.card_last_four}}</small></span></div></div></label></div><div class=\"container-credit-cards\" ng-if=\"creditCard.onlinePayment\"><input id=\"init-webpay\" name=\"tbkuser\" type=\"radio\" value=\"{{null}}\" ng-model=\"creditCard.creditCard\" ng-click=\"creditCard.initInscriptionUrl()\"> <label class=\"buttonselect\" for=\"init-webpay\" ng-click=\"creditCard.initInscriptionUrl()\"><div class=\"credit-card\"><div class=\"box-text\"><span>Webpay</span> <span>OneClick</span></div><div class=\"box-enter-card\" ng-click=\"creditCard.initInscriptionUrl(); creditCard.goToInscriptionbWebpay()\"><span class=\"enter-card\">Inscribir tarjeta</span></div></div></label></div><div class=\"container-credit-cards\" ng-repeat=\"card in creditCard.tbkUsers\" ng-if=\"creditCard.onlinePayment && !!creditCard.tbkUsers\"><input id=\"tbkuser-{{$index}}\" name=\"tbkuser\" type=\"radio\" value=\"{{card.id}}\" ng-model=\"creditCard.creditCard\"> <label class=\"buttonselect\" for=\"tbkuser-{{$index}}\"><div class=\"credit-card\"><div class=\"box-text\"><span>Webpay Oneclick</span> <span>{{creditCard.cart.cardTypeName(card.card_type)}} <small>**** {{card.last_4_card_digits}}</small></span></div></div></label></div><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-click=\"creditCard.selectCreditCard()\" ng-disabled=\"!creditCard.creditCard\">Seleccionar tarjeta</button></div></div></div>");
$templateCache.put("app/credit-card/mobile/select-credit-card.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><h2>Tus tarjetas guardadas</h2></div><div class=\"modal-body\"><div class=\"modal-credit-cards\"><div class=\"container-credit-cards\" ng-if=\"creditCard.kushkiPayment\"><input id=\"init-kushki\" name=\"kushki\" type=\"radio\" value=\"{{null}}\" ng-model=\"creditCard.creditCard\"> <label class=\"buttonselect\" for=\"init-kushki\"><div class=\"credit-card\"><div class=\"box-text\"><span>Kushki</span></div><div class=\"box-enter-card\" ng-click=\"$close() && creditCard.kushki.openModalInscriptionKushkiCard()\"><span class=\"enter-card\">Inscribir tarjeta</span></div></div></label></div><div class=\"container-credit-cards\" ng-repeat=\"card in creditCard.paymentCards\" ng-if=\"creditCard.kushkiPayment && creditCard.paymentCards.length > 0\"><input id=\"kushki-{{$index}}\" name=\"kushki\" type=\"radio\" value=\"{{card.token}}\" ng-model=\"creditCard.creditCard\"> <label class=\"buttonselect\" for=\"kushki-{{$index}}\"><div class=\"credit-card\"><div class=\"box-text\"><span>Kushki</span> <span>{{creditCard.cart.cardTypeName(card.payment_brand)}}&nbsp; <small>**** {{card.card_last_four}}</small></span></div></div></label></div><div class=\"container-credit-cards\" ng-if=\"creditCard.onlinePayment\"><input id=\"init-webpay\" name=\"tbkuser\" type=\"radio\" value=\"{{null}}\" ng-model=\"creditCard.creditCard\" ng-click=\"creditCard.initInscriptionUrl()\"> <label class=\"buttonselect\" for=\"init-webpay\" ng-click=\"creditCard.initInscriptionUrl()\"><div class=\"credit-card\"><div class=\"box-text\"><span>Webpay</span> <span>OneClick</span></div><div class=\"box-enter-card\" ng-click=\"creditCard.initInscriptionUrl(); creditCard.goToInscriptionbWebpay()\"><span class=\"enter-card\">Inscribir tarjeta</span></div></div></label></div><div class=\"container-credit-cards\" ng-repeat=\"card in creditCard.tbkUsers\" ng-if=\"creditCard.onlinePayment && !!creditCard.tbkUsers\"><input id=\"tbkuser-{{$index}}\" name=\"tbkuser\" type=\"radio\" value=\"{{card.id}}\" ng-model=\"creditCard.creditCard\"> <label class=\"buttonselect\" for=\"tbkuser-{{$index}}\"><div class=\"credit-card\"><div class=\"box-text\"><span>Webpay Oneclick</span> <span>{{creditCard.cart.cardTypeName(card.card_type)}} <small>**** {{card.last_4_card_digits}}</small></span></div></div></label></div><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-click=\"creditCard.selectCreditCard()\" ng-disabled=\"!creditCard.creditCard\">Seleccionar tarjeta</button></div></div></div>");
$templateCache.put("app/customer-session/desktop/login.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\" ng-if=\"customerSession.showAllBrands()\"><h2>Si tienes cuenta en una, tienes cuenta en todas</h2><p>Desde ahora, pide en todas las marcas <b class=\"highlight\">NiuFoods</b> con una misma cuenta</p></div><div class=\"modal-header\" ng-if=\"!customerSession.showAllBrands() && customerSession.DEFAULT_DISCOUNT > 0\"><h2 class=\"title-mx\">!Estás a un paso de disfrutar</h2><p class=\"title-mx\">tus pedidos con un {{customerSession.DEFAULT_DISCOUNT}}% de dcto.!</p></div><div class=\"modal-body\"><div class=\"modal-brands\"><div class=\"brands-img\"><a href=\"{{customerSession.niusushiUrl}}\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a ng-if=\"customerSession.showAllBrands()\" href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"modal-form\"><div class=\"login-form\"><form ng-submit=\"customerSession.login(customerSession.loginForm)\"><div class=\"login-group-error\" ng-if=\"!!customerSession.errorModal\"><p class=\"login-error\">{{customerSession.errorModal}}</p></div><input type=\"hidden\" name=\"confirm_password\" ng-model=\"customerSession.loginForm.confirm_password\" ng-init=\"customerSession.loginForm.confirm_password = true\"><div class=\"login-group\"><label class=\"login-label\">Email</label> <input type=\"email\" name=\"email\" placeholder=\"ejemplo@email.com\" ng-model=\"customerSession.loginForm.email\" required=\"\"></div><div class=\"login-group\"><label class=\"login-label\">Contraseña</label> <input type=\"password\" name=\"password\" placeholder=\"********\" ng-model=\"customerSession.loginForm.password\" required=\"\"></div><a class=\"forget\" href=\"javascript:void(0)\" ui-sref=\"resetPassword({email: customerSession.loginForm.email})\">¿Olvidaste tu clave?</a><div class=\"login-passwordless\"><a id=\"login-password-click\" href=\"javascript:void(0)\" ui-sref=\"passwordless\">Ingresar con código</a></div><div class=\"button-submit-center\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\">Iniciar sesión</button></div></form><a href=\"javascript:void(0)\" class=\"register-link\" ui-sref=\"signin\">¿No tienes cuenta? Regístrate</a></div></div></div><div class=\"modal-footer\"><img src=\"assets/success/niu-foods.png\" alt=\"\"></div>");
$templateCache.put("app/customer-session/desktop/new-password.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\" ng-if=\"!(customerSession.isPasswordSaved || customerSession.error)\"><h2>Crear nueva contraseña</h2></div><div class=\"modal-body\"><div class=\"modal-form\" ng-if=\"!(customerSession.isPasswordSaved || customerSession.error)\"><div class=\"login-form\"><form ng-submit=\"customerSession.updatePassword(customerSession.updatePasswordForm)\"><input type=\"password\" placeholder=\"Nueva clave\" ng-model=\"customerSession.updatePasswordForm.password\" name=\"password\" required=\"\"> <input type=\"password\" placeholder=\"Confirmar contraseña\" ng-model=\"customerSession.updatePasswordForm.password_confirmation\" name=\"password_confirmation\" ng-if=\"!customerSession.isLoggedIn()\" required=\"\"><div class=\"button-submit-center\"><button type=\"submit\" class=\"btn submit-button\">Enviar</button></div></form></div></div><div class=\"modal-email-sent\" ng-if=\"customerSession.isPasswordSaved\"><h2>Excelente</h2><p>Tu contraseña ya ha sido actualizada.</p><p>Explora <a ui-sref=\"menu\" ui-sref-opts=\"{location: \'replace\'}\"><span>la carta</span></a> , o revisa <a ui-sref=\"profile\" ui-sref-opts=\"{location: \'replace\', reload: true}\"><span>tu perfil</span></a>.</p></div><div class=\"modal-email-sent\" ng-if=\"customerSession.error\"><h2>Ups</h2><p>{{customerSession.error}}</p><a ng-click=\"customerSession.error = null\" class=\"btn btn-primary-outline btn-block\"><span>Inténtalo nuevamente.</span></a></div></div>");
$templateCache.put("app/customer-session/desktop/passwordless.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\" ng-if=\"customerSession.showAllBrands()\"><h2>Si tienes cuenta en una, tienes cuenta en todas</h2><p>Desde ahora, pide en todas las marcas <b class=\"highlight\">NiuFoods</b> con una misma cuenta</p></div><div class=\"modal-header\" ng-if=\"!customerSession.showAllBrands() && customerSession.DEFAULT_DISCOUNT > 0\"><h2 class=\"title-mx\">!Estás a un paso de disfrutar</h2><p class=\"title-mx\">tus pedidos con un {{customerSession.DEFAULT_DISCOUNT}}% de dcto.!</p></div><div class=\"modal-body\"><div class=\"modal-brands\"><div class=\"brands-img\"><a href=\"{{customerSession.niusushiUrl}}\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a ng-if=\"customerSession.showAllBrands()\" href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"modal-form\"><div class=\"login-form\"><form ng-submit=\"customerSession.login(customerSession.loginForm)\"><div class=\"login-group-error\" ng-if=\"!customerSession.requiresVerificationCode && !!customerSession.errorModal\"><p class=\"login-error\">{{customerSession.errorModal}}</p></div><div class=\"login-group-code\" ng-if=\"!!customerSession.requiresVerificationCode && !!customerSession.data.email\"><span><i class=\"icon-checkmark\"></i></span><p class=\"login-title-code\">¡Solo un paso más!</p><p class=\"login-text-code\">Valida tu cuenta ingresando el código enviado a {{customerSession.data.email}}.</p></div><input type=\"hidden\" name=\"confirm_password\" ng-model=\"customerSession.loginForm.confirm_password\" ng-init=\"customerSession.loginForm.confirm_password = false\"><div class=\"login-group\" ng-if=\"!customerSession.loginForm.confirm_token\"><label class=\"login-label\">Email</label> <input type=\"email\" name=\"email\" placeholder=\"ejemplo@email.com\" ng-model=\"customerSession.loginForm.email\" required=\"\"></div><div class=\"login-group\" ng-if=\"customerSession.loginForm.confirm_token\"><label class=\"login-label\">Código</label> <input type=\"text\" name=\"code\" placeholder=\"XXXXXX\" ng-model=\"customerSession.loginForm.password\" ng-change=\"customerSession.loginForm.password = (customerSession.loginForm.password || \'\').toUpperCase()\" required=\"\"></div><div class=\"button-submit-center\" ng-if=\"!customerSession.loginForm.confirm_token\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\">Iniciar sesión</button></div><div class=\"resend-code\" ng-if=\"customerSession.loginForm.confirm_token\"><span ng-if=\"customerSession.codeTimer > 0\">{{customerSession.codeTimer}}s</span> <a id=\"resend-code-click\" ng-click=\"customerSession.resendCode(customerSession.loginForm.email)\">Reenviar código <span class=\"icon icon-repeat\"></span></a> <a id=\"login-password-click\" class=\"login-password-click\" href=\"javascript:void(0)\" ui-sref=\"login\" ng-if=\"customerSession.resendCodeCount > 0\">Ingresar con contraseña</a></div><div class=\"button-submit-center\" ng-if=\"customerSession.loginForm.confirm_token\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\">Validar código</button></div></form><a href=\"javascript:void(0)\" class=\"register-link\" ui-sref=\"signin\">¿No tienes cuenta? Regístrate</a></div></div></div><div class=\"modal-footer\"><img src=\"assets/success/niu-foods.png\" alt=\"\"></div>");
$templateCache.put("app/customer-session/desktop/register.html","<div class=\"register\"><div class=\"register-header\" ng-if=\"customerSession.showAllBrands()\"><h2>Si tienes cuenta en una, tienes cuenta en todas</h2><p>Desde ahora, pide en todas las marcas <b class=\"highlight\">NiuFoods</b> con una misma cuenta</p></div><div class=\"register-header\" ng-if=\"!customerSession.showAllBrands() && customerSession.DEFAULT_DISCOUNT > 0\"><h2 class=\"title-mx\">¡Estás a un paso de disfrutar</h2><p class=\"title-mx\">tus pedidos con un {{customerSession.DEFAULT_DISCOUNT}}% de dcto.!</p></div><div class=\"register-body\"><div class=\"register-brands\"><div class=\"brands-img\"><a href=\"{{customerSession.niusushiUrl}}\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a ng-if=\"customerSession.showAllBrands()\" href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"container-form\"><div class=\"box-form\"><form name=\"registrationForm\" ng-submit=\"customerSession.register()\"><div class=\"login-group-error\" ng-if=\"!customerSession.requiresVerificationCode && !!customerSession.errorModal\"><p ng-class=\"{\'login-error\': !customerSession.data}\">{{customerSession.errorModal}}</p></div><div class=\"login-group-code\" ng-if=\"!!customerSession.requiresVerificationCode && !!customerSession.data.email\"><span><i class=\"icon-checkmark\"></i></span><p class=\"login-title-code\">¡Solo un paso más!</p><p class=\"login-text-code\">Valida tu cuenta ingresando el código enviado a {{customerSession.data.email}}.</p></div><input type=\"hidden\" name=\"confirm_password\" ng-model=\"customerSession.registrationForm.confirm_password\" ng-init=\"customerSession.registrationForm.confirm_password = false\"><div class=\"login-group\" ng-if=\"!customerSession.registrationForm.confirm_token\"><label class=\"register-label\">Nombre y apellido</label> <input autocomplete=\"name\" type=\"text\" name=\"name\" placeholder=\"Juan Perez\" ng-model=\"customerSession.registrationForm.name\" required=\"\"> <label class=\"register-label\">Email</label> <input type=\"email\" name=\"email\" placeholder=\"ejemplo@email.com\" ng-model=\"customerSession.registrationForm.email\" required=\"\"> <label class=\"register-label\">Teléfono</label><div class=\"container-phone\"><phone-select btn-submit-id=\"submit-button-click\" model=\"customerSession.registrationForm.phone.number\" object=\"customerSession\" form-name=\"registrationForm\" class=\"phone-component\"></phone-select></div><div class=\"button-submit-center\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\" ng-disabled=\"registrationForm.$invalid\">Guardar datos</button></div></div><div class=\"login-group\" ng-if=\"customerSession.registrationForm.confirm_token\"><label class=\"register-label\">Código</label> <input type=\"text\" name=\"code\" placeholder=\"XXXXXX\" ng-model=\"customerSession.registrationForm.password\" required=\"\"><div class=\"resend-code\"><span>{{customerSession.codeTimer}}s</span> <a id=\"resend-code-click\" ng-click=\"customerSession.resendCode(customerSession.registrationForm.email)\">Reenviar código <span class=\"icon icon-repeat\"></span></a></div><div class=\"button-submit-center\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\">Confirmar Cuenta</button></div></div></form><a href=\"javascript:void(0)\" class=\"login-link\" ui-sref=\"passwordless\">¿Ya tienes cuenta? Inicia sesión</a></div></div><div class=\"register-footer\"><img src=\"assets/success/niu-foods.png\" alt=\"\"></div></div></div>");
$templateCache.put("app/customer-session/desktop/registration.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\" ng-if=\"customerSession.showAllBrands()\"><h2>Si tienes cuenta en una, tienes cuenta en todas</h2><p>Desde ahora, pide en todas las marcas <b class=\"highlight\">NiuFoods</b> con una misma cuenta</p></div><div class=\"modal-header\" ng-if=\"!customerSession.showAllBrands() && customerSession.DEFAULT_DISCOUNT > 0\"><h2 class=\"title-mx\">¡Estás a un paso de disfrutar</h2><p class=\"title-mx\">tus pedidos con un {{customerSession.DEFAULT_DISCOUNT}}% de dcto.!</p></div><div class=\"modal-body\"><div class=\"modal-brands\"><div class=\"brands-img\"><a href=\"{{customerSession.niusushiUrl}}\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a ng-if=\"customerSession.showAllBrands()\" href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"modal-form\"><div class=\"login-form\"><form name=\"registrationForm\" ng-submit=\"customerSession.register()\"><div class=\"login-group-error\" ng-if=\"!customerSession.requiresVerificationCode && !!customerSession.errorModal\"><p ng-class=\"{\'login-error\': !customerSession.data}\">{{customerSession.errorModal}}</p></div><div class=\"login-group-code\" ng-if=\"!!customerSession.requiresVerificationCode && !!customerSession.data.email\"><span><i class=\"icon-checkmark\"></i></span><p class=\"login-title-code\">¡Solo un paso más!</p><p class=\"login-text-code\">Valida tu cuenta ingresando el código enviado a {{customerSession.data.email}}.</p></div><input type=\"hidden\" name=\"confirm_password\" ng-model=\"customerSession.registrationForm.confirm_password\" ng-init=\"customerSession.registrationForm.confirm_password = false\"><div class=\"login-group\" ng-if=\"!customerSession.registrationForm.confirm_token\"><label class=\"login-label\">Nombre y apellido</label> <input autocomplete=\"name\" type=\"text\" name=\"name\" placeholder=\"Juan Perez\" ng-model=\"customerSession.registrationForm.name\" required=\"\"> <label class=\"login-label\">Email</label> <input type=\"email\" name=\"email\" placeholder=\"ejemplo@email.com\" ng-model=\"customerSession.registrationForm.email\" required=\"\"> <label class=\"login-label\">Teléfono</label><div class=\"container-phone\"><phone-select btn-submit-id=\"submit-button-click\" model=\"customerSession.registrationForm.phone.number\" object=\"customerSession\" form-name=\"registrationForm\" class=\"phone-component\"></phone-select></div><div class=\"button-submit-center\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\" ng-disabled=\"registrationForm.$invalid\">Guardar datos</button></div></div><div class=\"login-group\" ng-if=\"customerSession.registrationForm.confirm_token\"><label class=\"login-label\">Código</label> <input type=\"text\" name=\"code\" placeholder=\"XXXXXX\" ng-model=\"customerSession.registrationForm.password\" required=\"\"><div class=\"resend-code\"><span>{{customerSession.codeTimer}}s</span> <a id=\"resend-code-click\" ng-click=\"customerSession.resendCode(customerSession.registrationForm.email)\">Reenviar código <span class=\"icon icon-repeat\"></span></a></div><div class=\"button-submit-center\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\">Confirmar Cuenta</button></div></div></form><a href=\"javascript:void(0)\" class=\"login-link\" ui-sref=\"passwordless\">¿Ya tienes cuenta? Inicia sesión</a></div></div></div><div class=\"modal-footer\"><img src=\"assets/success/niu-foods.png\" alt=\"\"></div>");
$templateCache.put("app/customer-session/desktop/reset-password.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\" ng-if=\"!(customerSession.isEmailSent || customerSession.error)\"><h2>Olvidé mi Contraseña</h2></div><div class=\"modal-body\"><div class=\"modal-form\" ng-if=\"!(customerSession.isEmailSent || customerSession.error)\"><div class=\"login-form\"><form ng-submit=\"customerSession.resetPassword(customerSession.resetForm)\"><fieldset ng-disabled=\"customerSession.isSendingForm\"><input type=\"email\" placeholder=\"ejemplo@email.com\" ng-model=\"customerSession.resetForm.email\" name=\"email\" required=\"\"></fieldset><div class=\"button-submit-center\"><button type=\"submit\" class=\"btn submit-button\">Enviar</button></div></form></div></div><div class=\"modal-email-sent\" ng-if=\"customerSession.isEmailSent\"><h2>Excelente</h2><p>Se te ha enviado un email a <span class=\"highlight\">\'{{customerSession.resetForm.email}}\'</span> con instrucciones para restaurar tu contraseña. Te debiese llegar en los próximos minutos. Por mientras, <a ng-click=\"$close()\" ui-sref-opts=\"{location: \'replace\'}\"><span>revisa qué quieres pedir</span></a>.</p></div><div class=\"modal-email-sent\" ng-if=\"customerSession.error\"><h2>Ups</h2><p>{{customerSession.error}}</p><a ng-click=\"customerSession.error = null\" class=\"btn btn-primary-outline btn-block\"><span>Inténtalo nuevamente.</span></a></div></div>");
$templateCache.put("app/external-feedback/mobile/external-feedback.html","<nav class=\"navbar navbar-default\"><div class=\"navbar-brand\"><a ui-sref=\"main\"><img src=\"{{externalFeedback.envConstants.LOGO_HEADER_URL}}\" alt=\"{{externalFeedback.envConstants.COMPANY_NAME}} logo\"></a></div></nav><div class=\"feedback\"><div class=\"feedback-container\"><div class=\"feedback-container-title\"><h2 class=\"feedback-title\">¡{{externalFeedback.order.clientName.split(\' \')[0]}}, muchas gracias por tu feedback!</h2></div><div class=\"feedback-container-body\"><div class=\"feedback-evaluation-text\"><p class=\"evaluation-text\">Tu opinión es muy importante para nosotros, así podemos entregar un mejor servicio para todos nuestros clientes. Te invitamos a calificarnos también en Google. Esto te tomará menos de 1 minuto.</p></div><div class=\"feedback-link\"><a class=\"evaluation\" target=\"_blank\" href=\"{{externalFeedback.googleAddress}}\" ng-click=\"externalFeedback.closeModal()\"><span>Evalúanos en <b>Google</b></span></a></div><div class=\"feedback-link browsing\"><a class=\"browsing\" ui-sref=\"main\"><span>Seguir navegando</span></a></div></div></div></div>");
$templateCache.put("app/external-feedback/desktop/external-feedback.html","<nav class=\"navbar-default\"><div class=\"navbar-container\"><div class=\"navbar-header-left\"><div class=\"navbar-brand\"><a ui-sref=\"main\"><img src=\"{{externalFeedback.envConstants.LOGO_HEADER_URL}}\" alt=\"{{externalFeedback.envConstants.COMPANY_NAME}} logo\"></a></div></div></div></nav><div class=\"feedback\"><div class=\"feedback-container\"><div class=\"feedback-container-title\"><h2 class=\"feedback-title\">¡{{externalFeedback.order.clientName.split(\' \')[0]}}, muchas gracias por tu feedback!</h2></div><div class=\"feedback-container-body\"><div class=\"feedback-evaluation-text\"><p class=\"evaluation-text\">Tu opinión es muy importante para nosotros, así podemos entregar un mejor servicio para todos nuestros clientes. Te invitamos a calificarnos también en Google. Esto te tomará menos de 1 minuto.</p></div><div class=\"feedback-link\"><a class=\"evaluation\" target=\"_blank\" href=\"{{externalFeedback.googleAddress}}\" ng-click=\"externalFeedback.closeModal()\"><span>Evalúanos en <b>Google</b></span></a></div><div class=\"feedback-link browsing\"><a class=\"browsing\" ui-sref=\"main\"><span>Seguir navegando</span></a></div></div></div></div>");
$templateCache.put("app/customer-session/mobile/login.html","<div class=\"login-form\"><div class=\"login-header-close\"><button class=\"close-button\" ui-sref=\"menu\"><i class=\"icon-x\"></i></button></div><div class=\"login-header\" ng-if=\"customerSession.showAllBrands()\"><h2>Si tienes cuenta en una, tienes cuenta en todas</h2><p>Desde ahora, pide en todas las marcas <b class=\"highlight\">NiuFoods</b> con una misma cuenta</p></div><div class=\"login-header\" ng-if=\"!customerSession.showAllBrands() && customerSession.DEFAULT_DISCOUNT > 0\"><h2 class=\"title-mx\">!Estás a un paso de disfrutar</h2><p class=\"title-mx\">tus pedidos con un {{customerSession.DEFAULT_DISCOUNT}}% de dcto.!</p></div><div class=\"login-body\"><div class=\"login-brands\"><div class=\"brands-img\"><a href=\"{{customerSession.niusushiUrl}}\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a ng-if=\"customerSession.showAllBrands()\" href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"container-form\"><div class=\"box-form\"><form ng-submit=\"customerSession.login(customerSession.loginForm)\"><div class=\"login-group-error\" ng-if=\"!!customerSession.errorModal\"><p class=\"login-error\">{{customerSession.errorModal}}</p></div><input type=\"hidden\" name=\"confirm_password\" ng-model=\"customerSession.loginForm.confirm_password\" ng-init=\"customerSession.loginForm.confirm_password = true\"><div class=\"login-group\"><label class=\"login-label\">Email</label> <input type=\"email\" name=\"email\" placeholder=\"ejemplo@email.com\" ng-model=\"customerSession.loginForm.email\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" required=\"\"></div><div class=\"login-group\"><label class=\"login-label\">Contraseña</label> <input type=\"password\" name=\"password\" placeholder=\"********\" ng-model=\"customerSession.loginForm.password\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" required=\"\"></div><a class=\"forget\" href=\"javascript:void(0)\" ui-sref=\"resetPassword({email: customerSession.loginForm.email})\">¿Olvidaste tu clave?</a><div class=\"login-passwordless\"><a id=\"login-password-click\" href=\"javascript:void(0)\" ui-sref=\"passwordless\">Ingresar con código</a></div><div class=\"button-submit-center\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\">Iniciar sesión</button></div></form><a href=\"javascript:void(0)\" class=\"register-link\" ui-sref=\"signin\">¿No tienes cuenta? Regístrate</a></div></div></div><div class=\"login-footer\"><img src=\"assets/success/niu-foods.png\" alt=\"\"></div></div>");
$templateCache.put("app/customer-session/mobile/new-password.html","<div class=\"new-password\"><div class=\"login-header-close\"><button class=\"close-button\" ui-sref=\"profile\"><i class=\"icon-x\"></i></button></div><div class=\"login-header\" ng-if=\"!(customerSession.isPasswordSaved || customerSession.error)\"><h2>Crear nueva contraseña</h2></div><div class=\"login-body\"><div class=\"container-form\" ng-if=\"!(customerSession.isPasswordSaved || customerSession.error)\"><div class=\"box-form\"><form ng-submit=\"customerSession.updatePassword(customerSession.updatePasswordForm)\"><input type=\"password\" placeholder=\"Nueva clave\" ng-model=\"customerSession.updatePasswordForm.password\" name=\"password\" required=\"\"><div class=\"button-submit-center\"><button type=\"submit\" class=\"btn submit-button\">Enviar</button></div></form></div></div><div class=\"login-email-sent\" ng-if=\"customerSession.isPasswordSaved\"><h2>Excelente</h2><p>Tu contraseña ya ha sido actualizada.</p><p>Explora <a ui-sref=\"menu\" ui-sref-opts=\"{location: \'replace\'}\"><span>la carta</span></a> , o revisa <a ui-sref=\"profile\" ui-sref-opts=\"{location: \'replace\', reload: true}\"><span>tu perfil</span></a>.</p></div><div class=\"login-email-sent\" ng-if=\"customerSession.error\"><h2>Ups</h2><p>{{customerSession.error}}</p><a ng-click=\"customerSession.error = null\" class=\"btn btn-primary-outline btn-block\"><span>Inténtalo nuevamente.</span></a></div></div></div>");
$templateCache.put("app/customer-session/mobile/passwordless.html","<div class=\"login-form\"><div class=\"login-header-close\"><button class=\"close-button\" ui-sref=\"menu\"><i class=\"icon-x\"></i></button></div><div class=\"login-header\" ng-if=\"customerSession.showAllBrands()\"><h2>Si tienes cuenta en una, tienes cuenta en todas</h2><p>Desde ahora, pide en todas las marcas <b class=\"highlight\">NiuFoods</b> con una misma cuenta</p></div><div class=\"login-header\" ng-if=\"!customerSession.showAllBrands() && customerSession.DEFAULT_DISCOUNT > 0\"><h2 class=\"title-mx\">!Estás a un paso de disfrutar</h2><p class=\"title-mx\">tus pedidos con un {{customerSession.DEFAULT_DISCOUNT}}% de dcto.!</p></div><div class=\"login-body\"><div class=\"login-brands\"><div class=\"brands-img\"><a href=\"{{customerSession.niusushiUrl}}\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a ng-if=\"customerSession.showAllBrands()\" href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"container-form\"><div class=\"box-form\"><form ng-submit=\"customerSession.login(customerSession.loginForm)\"><div class=\"login-group-error\" ng-if=\"!customerSession.requiresVerificationCode && !!customerSession.errorModal\"><p class=\"login-error\">{{customerSession.errorModal}}</p></div><div class=\"login-group-code\" ng-if=\"!!customerSession.requiresVerificationCode && !!customerSession.data.email\"><span><i class=\"icon-checkmark\"></i></span><p class=\"login-title-code\">¡Solo un paso más!</p><p class=\"login-text-code\">Valida tu cuenta ingresando el código enviado a {{customerSession.data.email}}.</p></div><input type=\"hidden\" name=\"confirm_password\" ng-model=\"customerSession.loginForm.confirm_password\" ng-init=\"customerSession.loginForm.confirm_password = false\"><div class=\"login-group\" ng-if=\"!customerSession.loginForm.confirm_token\"><label class=\"login-label\">Email</label> <input type=\"email\" name=\"email\" placeholder=\"ejemplo@email.com\" ng-model=\"customerSession.loginForm.email\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" required=\"\"></div><div class=\"login-group\" ng-if=\"customerSession.loginForm.confirm_token\"><label class=\"login-label\">Código</label> <input type=\"text\" name=\"code\" placeholder=\"XXXXXX\" ng-model=\"customerSession.loginForm.password\" ng-change=\"customerSession.loginForm.password = (customerSession.loginForm.password || \'\').toUpperCase()\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" required=\"\"></div><div class=\"button-submit-center\" ng-if=\"!customerSession.loginForm.confirm_token\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\">Iniciar sesión</button></div><div class=\"resend-code\" ng-if=\"customerSession.loginForm.confirm_token\"><span ng-if=\"customerSession.codeTimer > 0\">{{customerSession.codeTimer}}s</span> <a id=\"resend-code-click\" ng-click=\"customerSession.resendCode(customerSession.loginForm.email)\">Reenviar código <span class=\"icon icon-repeat\"></span></a> <a id=\"login-password-click\" class=\"login-password-click\" href=\"javascript:void(0)\" ui-sref=\"login\" ng-if=\"customerSession.resendCodeCount > 0\">Ingresar con contraseña</a></div><div class=\"button-submit-center\" ng-if=\"customerSession.loginForm.confirm_token\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\">Validar código</button></div></form><a href=\"javascript:void(0)\" class=\"register-link\" ui-sref=\"signin\">¿No tienes cuenta? Regístrate</a></div></div></div><div class=\"login-footer\"><img src=\"assets/success/niu-foods.png\" alt=\"\"></div></div>");
$templateCache.put("app/customer-session/mobile/register.html","<div class=\"register\"><div class=\"register-header\" ng-if=\"customerSession.showAllBrands()\"><h2>Si tienes cuenta en una, tienes cuenta en todas</h2><p>Desde ahora, pide en todas las marcas <b class=\"highlight\">NiuFoods</b> con una misma cuenta</p></div><div class=\"register-header\" ng-if=\"!customerSession.showAllBrands() && customerSession.DEFAULT_DISCOUNT > 0\"><h2 class=\"title-mx\">¡Estás a un paso de disfrutar</h2><p class=\"title-mx\">tus pedidos con un {{customerSession.DEFAULT_DISCOUNT}}% de dcto.!</p></div><div class=\"register-body\"><div class=\"register-brands\"><div class=\"brands-img\"><a href=\"{{customerSession.niusushiUrl}}\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a ng-if=\"customerSession.showAllBrands()\" href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"container-form\"><div class=\"box-form\"><form name=\"registrationForm\" ng-submit=\"customerSession.register()\"><div class=\"login-group-error\" ng-if=\"!customerSession.requiresVerificationCode && !!customerSession.errorModal\"><p ng-class=\"{\'login-error\': !customerSession.data}\">{{customerSession.errorModal}}</p></div><div class=\"login-group-code\" ng-if=\"!!customerSession.requiresVerificationCode && !!customerSession.data.email\"><span><i class=\"icon-checkmark\"></i></span><p class=\"login-title-code\">¡Solo un paso más!</p><p class=\"login-text-code\">Valida tu cuenta ingresando el código enviado a {{customerSession.data.email}}.</p></div><input type=\"hidden\" name=\"confirm_password\" ng-model=\"customerSession.registrationForm.confirm_password\" ng-init=\"customerSession.registrationForm.confirm_password = false\"><div class=\"login-group\" ng-if=\"!customerSession.registrationForm.confirm_token\"><label class=\"register-label\">Nombre y apellido</label> <input autocomplete=\"name\" type=\"text\" name=\"name\" placeholder=\"Juan Perez\" ng-model=\"customerSession.registrationForm.name\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" required=\"\"> <label class=\"register-label\">Email</label> <input type=\"email\" name=\"email\" placeholder=\"ejemplo@email.com\" ng-model=\"customerSession.registrationForm.email\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" required=\"\"> <label class=\"register-label\">Teléfono</label><div class=\"container-phone\"><phone-select btn-submit-id=\"submit-button-click\" model=\"customerSession.registrationForm.phone.number\" object=\"customerSession\" form-name=\"registrationForm\" class=\"phone-component\"></phone-select></div><div class=\"button-submit-center\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\" ng-disabled=\"!registrationForm.$valid\">Guardar datos</button></div></div><div class=\"login-group\" ng-if=\"customerSession.registrationForm.confirm_token\"><label class=\"register-label\">Código</label> <input type=\"text\" name=\"code\" placeholder=\"XXXXXX\" ng-model=\"customerSession.registrationForm.password\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" required=\"\"><div class=\"resend-code\"><span>{{customerSession.codeTimer}}s</span> <a id=\"resend-code-click\" ng-click=\"customerSession.resendCode(customerSession.registrationForm.email)\">Reenviar código <span class=\"icon icon-repeat\"></span></a></div><div class=\"button-submit-center\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\">Confirmar Cuenta</button></div></div></form><a href=\"javascript:void(0)\" class=\"login-link\" ui-sref=\"passwordless\">¿Ya tienes cuenta? Inicia sesión</a></div></div><div class=\"register-footer\"><img src=\"assets/success/niu-foods.png\" alt=\"\"></div></div></div>");
$templateCache.put("app/customer-session/mobile/registration.html","<div class=\"register-form\"><div class=\"login-header-close\"><button class=\"close-button\" ui-sref=\"menu\"><i class=\"icon-x\"></i></button></div><div class=\"login-header\" ng-if=\"customerSession.showAllBrands()\"><h2>Si tienes cuenta en una, tienes cuenta en todas</h2><p>Desde ahora, pide en todas las marcas <b class=\"highlight\">NiuFoods</b> con una misma cuenta</p></div><div class=\"login-header\" ng-if=\"!customerSession.showAllBrands() && customerSession.DEFAULT_DISCOUNT > 0\"><h2 class=\"title-mx\">¡Estás a un paso de disfrutar</h2><p class=\"title-mx\">tus pedidos con un {{customerSession.DEFAULT_DISCOUNT}}% de dcto.!</p></div><div class=\"login-body\"><div class=\"login-brands\"><div class=\"brands-img\"><a href=\"{{customerSession.niusushiUrl}}\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a ng-if=\"customerSession.showAllBrands()\" href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"container-form\"><div class=\"box-form\"><form name=\"registrationForm\" ng-submit=\"customerSession.register()\"><div class=\"login-group-error\" ng-if=\"!customerSession.requiresVerificationCode && !!customerSession.errorModal\"><p ng-class=\"{\'login-error\': !customerSession.data}\">{{customerSession.errorModal}}</p></div><div class=\"login-group-code\" ng-if=\"!!customerSession.requiresVerificationCode && !!customerSession.data.email\"><span><i class=\"icon-checkmark\"></i></span><p class=\"login-title-code\">¡Solo un paso más!</p><p class=\"login-text-code\">Valida tu cuenta ingresando el código enviado a {{customerSession.data.email}}.</p></div><input type=\"hidden\" name=\"confirm_password\" ng-model=\"customerSession.registrationForm.confirm_password\" ng-init=\"customerSession.registrationForm.confirm_password = false\"><div class=\"login-group\" ng-if=\"!customerSession.registrationForm.confirm_token\"><label class=\"login-label\">Nombre y apellido</label> <input autocomplete=\"name\" type=\"text\" name=\"name\" placeholder=\"Juan Perez\" ng-model=\"customerSession.registrationForm.name\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" required=\"\"> <label class=\"login-label\">Email</label> <input type=\"email\" name=\"email\" placeholder=\"ejemplo@email.com\" ng-model=\"customerSession.registrationForm.email\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" required=\"\"> <label class=\"login-label\">Teléfono</label><div class=\"container-phone\"><phone-select btn-submit-id=\"submit-button-click\" model=\"customerSession.registrationForm.phone.number\" object=\"customerSession\" form-name=\"registrationForm\" class=\"phone-component\"></phone-select></div><div class=\"button-submit-center\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\" ng-disabled=\"!registrationForm.$valid\">Guardar datos</button></div></div><div class=\"login-group\" ng-if=\"customerSession.registrationForm.confirm_token\"><label class=\"login-label\">Código</label> <input type=\"text\" name=\"code\" placeholder=\"XXXXXX\" ng-model=\"customerSession.registrationForm.password\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" required=\"\"><div class=\"resend-code\"><span>{{customerSession.codeTimer}}s</span> <a id=\"resend-code-click\" ng-click=\"customerSession.resendCode(customerSession.registrationForm.email)\">Reenviar código <span class=\"icon icon-repeat\"></span></a></div><div class=\"button-submit-center\"><button type=\"submit\" id=\"submit-button-click\" class=\"btn submit-button\">Confirmar Cuenta</button></div></div></form><a href=\"javascript:void(0)\" class=\"login-link\" ui-sref=\"passwordless\">¿Ya tienes cuenta? Inicia sesión</a></div></div><div class=\"login-footer\"><img src=\"assets/success/niu-foods.png\" alt=\"\"></div></div></div>");
$templateCache.put("app/customer-session/mobile/reset-password.html","<div class=\"reset-password\"><div class=\"login-header-close\"><button class=\"close-button\" ui-sref=\"main\"><i class=\"icon-x\"></i></button></div><div class=\"login-header\" ng-if=\"!(customerSession.isEmailSent || customerSession.error)\"><h2>Olvidé mi Contraseña</h2></div><div class=\"login-body\"><div class=\"container-form\" ng-if=\"!(customerSession.isEmailSent || customerSession.error)\"><div class=\"box-form\"><form ng-submit=\"customerSession.resetPassword(customerSession.resetForm)\"><input type=\"email\" placeholder=\"ejemplo@email.com\" ng-model=\"customerSession.resetForm.email\" name=\"email\" required=\"\"><div class=\"button-submit-center\"><button type=\"submit\" class=\"btn submit-button\">Enviar</button></div></form></div></div><div class=\"login-email-sent\" ng-if=\"customerSession.isEmailSent\"><h2>Excelente</h2><p>Se te ha enviado un email a <span class=\"highlight\">\'{{customerSession.resetForm.email}}\'</span> con instrucciones para restaurar tu contraseña. Te debiese llegar en los próximos minutos. Por mientras, <a ng-click=\"$close()\" ui-sref-opts=\"{location: \'replace\'}\"><span>revisa qué quieres pedir</span></a>.</p></div><div class=\"login-email-sent\" ng-if=\"customerSession.error\"><h2>Ups</h2><p>{{customerSession.error}}</p><a ng-click=\"customerSession.error = null\" class=\"btn btn-primary-outline btn-block\"><span>Inténtalo nuevamente.</span></a></div></div></div>");
$templateCache.put("app/event/desktop/event.checkout.html","<header-cart></header-cart><div class=\"event-checkout\"><div class=\"container-event-checkout\"><div class=\"event-checkout-body event-checkout-form\"><div class=\"container-heading\"><h2>Detalles del pedido</h2></div><div class=\"container-body\"><div class=\"container-body-title\"><p>Mándanos tus datos y los del evento y te contactaremos para coordinar tu pedido</p></div><form name=\"form\" ng-submit=\"eventCheckout.sendOrder()\"><div class=\"form-element\"><input autocomplete=\"name\" id=\"name\" name=\"name\" type=\"text\" class=\"form-input\" ng-model=\"eventCheckout.customer.name\" placeholder=\"Nombre y Apellido\" required=\"\"> <span id=\"name-error-message\" class=\"form-error-message hide\">Ingresa un nombre</span></div><div class=\"form-element\"><input autocomplete=\"off\" id=\"email\" name=\"email\" type=\"email\" class=\"form-input\" ng-model=\"eventCheckout.customer.email\" placeholder=\"Email\" required=\"\"> <span id=\"email-error-message\" class=\"form-error-message hide\">Ingresa un correo electrónico valido</span></div><div class=\"form-element\"><div class=\"form-elements-group\"><div class=\"form-element-half\"><input autocomplete=\"off\" id=\"address\" name=\"address\" type=\"text\" class=\"form-input\" ng-model=\"eventCheckout.customer.address\" placeholder=\"Dirección\" required=\"\"> <span id=\"address-error-message\" class=\"form-error-message hide\">Ingresa una dirección</span></div><div class=\"form-element-half\"><div class=\"form-element-select\"><select id=\"commune\" name=\"commune\" class=\"event-select\" ng-model=\"eventCheckout.customer.commune\" ng-options=\"commune as commune.name for commune in eventCheckout.communes\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Comuna</option></select></div><span id=\"commune-error-message\" class=\"form-error-message hide\">Selecciona una comuna</span></div></div></div><div class=\"form-element\"><div class=\"form-elements-group\"><phone-select number=\"eventCheckout.phones[0]\" btn-submit-id=\"submit-event-form\" model=\"eventCheckout.phone[0].number\" object=\"eventCheckout\" form-name=\"form\" invalid-phone=\"eventCheckout.invalidPhone\" class=\"form-element-phone\"></phone-select></div></div><div class=\"form-element\"><div class=\"form-elements-group\"><div class=\"form-element-half\"><input type=\"text\" ng-focus=\"eventCheckout.info.birthdateFocus = true\" ng-model=\"eventCheckout.date.day\" min-date=\"eventCheckout.minDate.day\" max-date=\"eventCheckout.maxDate.day\" uib-datepicker-popup=\"dd-MMMM-yyyy\" show-button-bar=\"false\" is-open=\"eventCheckout.info.birthdateFocus\" required=\"\"></div><div class=\"form-element-half\"><input type=\"time\" ng-model=\"eventCheckout.date.time\" placeholder=\"Hora\" required=\"\"></div></div></div><div class=\"form-element\"><textarea autocomplete=\"comment\" name=\"comment\" type=\"text\" placeholder=\"Comentarios extra (opcional)\" ng-model=\"eventCheckout.customerComments\">\n            </textarea> <input type=\"text\" ng-model=\"eventCheckout.hiddenInput\" style=\"display: none;\"></div><div class=\"btn-submit-event-checkout\"><button class=\"btn-next\" id=\"submit-event-form\" type=\"submit\" ng-click=\"eventCheckout.sendOrder()\" ng-disabled=\"!form.$valid || eventCheckout.invalidPhone || eventCheckout.inProgress || eventCheckout.hiddenInput != null\">{{eventCheckout.sendEmailTxt}}</button></div></form></div></div><div class=\"event-checkout-body event-checkout-shopping\"><div class=\"container-heading\"><h2>Mi Pedido</h2></div><div class=\"container-body\"><div class=\"container-body-title\"><h2>{{eventCheckout.eventData.name}}</h2></div></div><div class=\"container-body\"><div class=\"total\"><h2>Total</h2><h2>${{eventCheckout.eventData.finalPrice}}</h2></div></div><div class=\"footer-event-checkout-shopping\"><button ui-sref=\"menu\" class=\"btn btn-modifier-order\">Modificar Pedido</button></div></div></div></div>");
$templateCache.put("app/event/desktop/event.html","<div class=\"modal-event\"><div class=\"modal-box\"><div class=\"modal-body\" stop-event=\"touchend\"><div class=\"product-img\"><div class=\"content\"><img ng-src=\"{{event.eventData.imageUrl}}\"></div><div class=\"modal-close\"><button class=\"close\" ng-click=\"event.cancel()\"><i class=\"icon-x\"></i></button></div></div><div class=\"product-info padding-top\"><div class=\"product-text-container padding-bottom\"><div class=\"text-container\"><div class=\"title-container\"><h4 class=\"product-title event\">{{event.eventData.name}}</h4><p class=\"product-description bites\">{{event.eventData.piecesQty}}</p></div><div class=\"title-container\"><h4 class=\"product-title price\">${{event.eventData.finalPrice}}</h4></div></div><div class=\"text-container\"><div class=\"pull-left\"><p class=\"product-description event\" ng-repeat=\"prod in event.descriptionProducts(\'left\')\">{{prod}}</p></div><div class=\"pull-right\"><p class=\"product-description event\" ng-repeat=\"prod in event.descriptionProducts(\'right\')\">{{prod}}</p></div></div><div class=\"text-container\"><p class=\"product-description\"><span>** Cualquiera de estos pedidos se producen previo pago total del producto.</span><br><span>** El pedido debe confirmarse al menos con 24 hrs de anticipación.</span><br><span ng-if=\"event.additionalItems.length > 0\">** El pedido incluye <span class=\"lower-case\" ng-repeat=\"item in event.additionalItems\">{{event.showAdditionalItem(item)}}</span> acorde al pedido.</span><br ng-if=\"event.additionalItems.length > 0\"><span>** Combinaciones NO sujetas a cambio.</span></p></div></div></div></div><div class=\"modal-footer\"><div class=\"container-btn-primary\"><button class=\"btn btn-primary\" ng-click=\"event.addEventRequest()\">Crear solicitud</button></div></div></div></div>");
$templateCache.put("app/event/desktop/event.success.html","<div class=\"event-success\"><div class=\"container-success container-top\"><div class=\"cont-success\"><div class=\"box-success\"><div class=\"box-img\"><img src=\"assets/success/{{$environment}}/img/super.svg\" alt=\"\"></div></div></div><div class=\"cont-success\"><div class=\"box-success\"><h4 class=\"order-name\"><p class=\"name\">¡{{eventSuccess.customer.name.split(\' \')[0]}}, <span class=\"order\">tu solicitud fue recibida con éxito!</span></p></h4></div></div><div class=\"cont-success\"><div class=\"box-success\"><h4 class=\"about-us\">¡Conoce y disfruta todas las marcas de Niu Foods!</h4></div><div class=\"box-success brands\"><img src=\"assets/success/byniu.png\" alt=\"\"> <a href=\"https://niusushi.cl/\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"cont-success\"><div class=\"box-success\"><div class=\"info-success\"><p>Hemos recibido tu email, nos pondremos en contacto contigo para generar la orden.<br>Cualquier duda o consulta, escríbenos a <a href=\"mailto:niusushi@niusushi.cl\">niusushi@niusushi.cl</a></p></div></div></div><div class=\"cont-success\"><div class=\"box-success continue-browsing\"><a ui-sref=\"main\"><span class=\"browsing\">Seguir navegando</span></a></div></div></div></div>");
$templateCache.put("app/faq/desktop/faq.html","<header-cart></header-cart><div class=\"faq\"><div class=\"container-faq\"><div class=\"box-faq\"><h2 class=\"faq-title\" ng-repeat-start=\"(g, group) in faq.questions\">{{group.name}}</h2><div class=\"panel-group\" id=\"{{group.name}}\" role=\"tablist\" aria-multiselectable=\"true\" ng-repeat-end=\"\"><div class=\"panel-default\" ng-repeat=\"(id, question) in group.questions\"><div class=\"panel-heading\" ng-class=\"{\'active\': question.isExpanded}\" id=\"{{\'question-\'+g+\'-\'+id}}\" role=\"tab\" ng-click=\"question.isExpanded = !question.isExpanded\" data-toggle=\"collapse\" data-parent=\"#{{group.name}}\" aria-expanded=\"{{question.isExpanded}}\" aria-controls=\"{{\'question-\'+g+\'-\'+id}}-content\"><p>{{question.q}}</p><i ng-class=\"question.isExpanded ? \'icon-chevron-up\' : \'icon-chevron-down\'\"></i></div><div id=\"{{\'question-\'+g+\'-\'+id}}-content\" class=\"panel-collapse collapse\" ng-class=\"{\'in\': question.isExpanded}\" role=\"tabpanel\" aria-labelledby=\"{{\'question-\'+g+\'-\'+id}}\"><div class=\"panel-body\"><p>{{question.a}}</p></div></div></div></div></div></div><footer-cart></footer-cart></div>");
$templateCache.put("app/event/mobile/event.checkout.html","<header-cart></header-cart><div class=\"event-checkout\"><div class=\"container-event-checkout\"><div class=\"event-checkout-body event-checkout-form\"><div class=\"container-body\"><div class=\"container-body-title\"><p>Mándanos tus datos y los del evento<br>y te contactaremos para coordinar tu pedido</p></div><form name=\"form\" ng-submit=\"eventCheckout.sendOrder()\"><div class=\"form-element\"><input autocomplete=\"name\" id=\"name\" name=\"name\" type=\"text\" class=\"form-input\" ng-model=\"eventCheckout.customer.name\" placeholder=\"Nombre y Apellido\" required=\"\"> <span id=\"name-error-message\" class=\"form-error-message hide\">Ingresa un nombre</span></div><div class=\"form-element\"><input autocomplete=\"off\" id=\"email\" name=\"email\" type=\"email\" class=\"form-input\" ng-model=\"eventCheckout.customer.email\" placeholder=\"Email\" required=\"\"> <span id=\"email-error-message\" class=\"form-error-message hide\">Ingresa un correo electrónico valido</span></div><div class=\"form-element\"><input autocomplete=\"off\" id=\"address\" name=\"address\" type=\"text\" class=\"form-input\" ng-model=\"eventCheckout.customer.address\" placeholder=\"Dirección\" required=\"\"> <span id=\"address-error-message\" class=\"form-error-message hide\">Ingresa una dirección</span></div><div class=\"form-element\"><div class=\"form-element-select\"><select id=\"commune\" name=\"commune\" class=\"event-select\" ng-model=\"eventCheckout.customer.commune\" ng-options=\"commune as commune.name for commune in eventCheckout.communes\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Comuna</option></select></div><span id=\"commune-error-message\" class=\"form-error-message hide\">Selecciona una comuna</span></div><div class=\"form-element\"><div class=\"form-elements-group\"><phone-select number=\"eventCheckout.phones[0]\" btn-submit-id=\"submit-event-form\" model=\"eventCheckout.phone[0].number\" object=\"eventCheckout\" form-name=\"form\" invalid-phone=\"eventCheckout.invalidPhone\" class=\"form-element-phone\"></phone-select></div></div><div class=\"form-element\"><div class=\"form-elements-group\"><div class=\"form-element-half\"><input type=\"text\" ng-focus=\"eventCheckout.info.birthdateFocus = true\" ng-model=\"eventCheckout.date.day\" min-date=\"eventCheckout.minDate.day\" max-date=\"eventCheckout.maxDate.day\" uib-datepicker-popup=\"dd-MMMM-yyyy\" show-button-bar=\"false\" is-open=\"eventCheckout.info.birthdateFocus\" required=\"\"></div><div class=\"form-element-half\"><input type=\"time\" ng-model=\"eventCheckout.date.time\" placeholder=\"Hora\" required=\"\"></div></div></div><div class=\"form-element\"><textarea autocomplete=\"comment\" name=\"comment\" type=\"text\" placeholder=\"Comentarios extra (opcional)\" ng-model=\"eventCheckout.customerComments\">\n            </textarea> <input type=\"text\" ng-model=\"eventCheckout.hiddenInput\" style=\"display: none;\"></div><div class=\"btn-submit-event-checkout\"><button ui-sref=\"menu\" class=\"btn btn-modifier-order\">Modificar Pedido</button> <button class=\"btn-next\" id=\"submit-event-form\" type=\"submit\" ng-click=\"eventCheckout.sendOrder()\" ng-disabled=\"!form.$valid || eventCheckout.invalidPhone || eventCheckout.inProgress || eventCheckout.hiddenInput != null\">{{eventCheckout.sendEmailTxt}}</button></div></form></div></div></div></div>");
$templateCache.put("app/event/mobile/event.html","<div class=\"modal-event\"><div class=\"modal-box\"><div class=\"modal-body\" stop-event=\"touchend\"><div class=\"product-img\"><div class=\"content\"><img ng-src=\"{{event.eventData.imageUrl}}\"></div><div class=\"modal-close\"><button class=\"close\" ng-click=\"event.cancel()\"><i class=\"icon-x\"></i></button></div></div><div class=\"product-info padding-top\"><div class=\"product-text-container event padding-bottom\"><div class=\"text-container\"><div class=\"title-container event\"><h4 class=\"product-title event\">{{event.eventData.name}}</h4><p class=\"product-description bites\">{{event.eventData.piecesQty}}</p></div><div class=\"title-container\"><h4 class=\"product-title price\">${{event.eventData.finalPrice}}</h4></div></div><div class=\"text-container\"><div class=\"pull-container\"><p class=\"product-description event\" ng-repeat=\"prod in event.eventData.description\">{{prod}}</p></div></div><div class=\"text-container\"><p class=\"product-description\"><span>** Cualquiera de estos pedidos se producen previo pago total del producto.</span><br><span>** El pedido debe confirmarse al menos con 24 hrs de anticipación.</span><br><span ng-if=\"event.additionalItems.length > 0\">** El pedido incluye <span class=\"lower-case\" ng-repeat=\"item in event.additionalItems\">{{event.showAdditionalItem(item)}}</span> acorde al pedido.</span><br ng-if=\"event.additionalItems.length > 0\"><span>** Combinaciones NO sujetas a cambio.</span></p></div></div></div></div><div class=\"modal-footer\"><div class=\"container-btn-primary\"><button class=\"btn btn-primary\" ng-click=\"event.addEventRequest()\">Crear solicitud</button></div></div></div></div>");
$templateCache.put("app/event/mobile/event.success.html","<div class=\"event-success\"><div class=\"container-success container-top\"><div class=\"cont-success\"><div class=\"box-success\"><div class=\"box-img\"><img src=\"assets/success/{{$environment}}/img/super.svg\" alt=\"\"></div></div></div><div class=\"cont-success\"><div class=\"box-success\"><h4 class=\"order-name\"><p class=\"name\">¡{{eventSuccess.customer.name.split(\' \')[0]}}, <span class=\"order\">tu solicitud fue recibida con éxito!</span></p></h4></div></div><div class=\"cont-success\"><div class=\"box-success\"><h4 class=\"about-us\">¡Conoce y disfruta todas las marcas de Niu Foods!</h4></div><div class=\"box-success center\"><img src=\"assets/success/byniu.png\" alt=\"\"></div><div class=\"box-success brands\"><a href=\"https://niusushi.cl/\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"cont-success\"><div class=\"box-success\"><div class=\"info-success\"><p>Cualquier duda o consulta,<br>escríbenos a <a href=\"mailto:niusushi@niusushi.cl\">niusushi@niusushi.cl</a></p></div></div></div><div class=\"cont-success\"><div class=\"box-success continue-browsing\"><a ui-sref=\"main\"><span class=\"browsing\">Seguir navegando</span></a></div></div></div></div>");
$templateCache.put("app/faq/mobile/faq.html","<header-cart></header-cart><div class=\"faq\"><div class=\"container-faq\"><div class=\"box-faq\"><h2 class=\"faq-title\" ng-repeat-start=\"(g, group) in faq.questions\">{{group.name}}</h2><div class=\"panel-group\" id=\"{{group.name}}\" role=\"tablist\" aria-multiselectable=\"true\" ng-repeat-end=\"\"><div class=\"panel-default\" ng-repeat=\"(id, question) in group.questions\"><div class=\"panel-heading\" ng-class=\"{\'active\': question.isExpanded}\" id=\"{{\'question-\'+g+\'-\'+id}}\" role=\"tab\" ng-click=\"question.isExpanded = !question.isExpanded\" data-toggle=\"collapse\" data-parent=\"#{{group.name}}\" aria-expanded=\"{{question.isExpanded}}\" aria-controls=\"{{\'question-\'+g+\'-\'+id}}-content\"><p>{{question.q}}</p><i ng-class=\"question.isExpanded ? \'icon-chevron-up\' : \'icon-chevron-down\'\"></i></div><div id=\"{{\'question-\'+g+\'-\'+id}}-content\" class=\"panel-collapse collapse\" ng-class=\"{\'in\': question.isExpanded}\" role=\"tabpanel\" aria-labelledby=\"{{\'question-\'+g+\'-\'+id}}\"><div class=\"panel-body\"><p>{{question.a}}</p></div></div></div></div></div></div></div>");
$templateCache.put("app/feedback/desktop/feedback.html","<nav class=\"navbar-default\"><div class=\"navbar-container\"><div class=\"navbar-header-left\"><div class=\"navbar-brand\"><img src=\"{{feedback.envConstants.LOGO_HEADER_URL}}\" alt=\"{{feedback.envConstants.COMPANY_NAME}} logo\"></div></div></div></nav><div class=\"feedback-loader-container\"><loader template=\"ellipsis\" size=\"large\" ng-if=\"feedback.isLoadingView\"><loader></loader></loader></div><div class=\"feedback\" ng-if=\"!feedback.isLoadingView\"><div class=\"feedback-container\"><div class=\"feedback-container-title\"><h2 class=\"feedback-title\">Encuesta</h2></div><form name=\"form\" class=\"feedback-form\" ng-submit=\"feedback.sendFeedback()\"><div class=\"card-evaluation\"><div id=\"withinPromisedTime\" class=\"item-evaluation\"><h4 class=\"feedback-question\">1. ¿Recibiste tu pedido en el tiempo prometido?</h4><div class=\"feedback-radio-buttons\"><div class=\"radio-button\"><input id=\"withinPromisedTime-yes\" name=\"withinPromisedTime\" required=\"\" type=\"radio\" value=\"yes\" ng-change=\"feedback.scrollTo(\'receivedAllProducts\')\" ng-model=\"feedback.feedbackForm.withinPromisedTime\"> <label class=\"radio-label\" for=\"withinPromisedTime-yes\"><span>Si</span></label></div><div class=\"radio-button\"><input id=\"withinPromisedTime-no\" name=\"withinPromisedTime\" type=\"radio\" required=\"\" value=\"no\" ng-change=\"feedback.scrollTo(\'receivedAllProducts\')\" ng-model=\"feedback.feedbackForm.withinPromisedTime\"> <label class=\"radio-label\" for=\"withinPromisedTime-no\"><span>No</span></label></div></div></div><div id=\"receivedAllProducts\" class=\"item-evaluation\"><h4 class=\"feedback-question\">2. ¿Recibiste todos los productos correctamente?</h4><div class=\"feedback-radio-buttons\"><div class=\"radio-button\"><input id=\"receivedAllProducts-yes\" name=\"receivedAllProducts\" required=\"\" type=\"radio\" value=\"yes\" ng-change=\"feedback.specialQuestions ? feedback.scrollTo(\'howDidYouMeetUs\') : feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.receivedAllProducts\"> <label class=\"radio-label\" for=\"receivedAllProducts-yes\"><span>Si</span></label></div><div class=\"radio-button\"><input id=\"receivedAllProducts-no\" name=\"receivedAllProducts\" type=\"radio\" required=\"\" value=\"no\" ng-change=\"feedback.specialQuestions ? feedback.scrollTo(\'howDidYouMeetUs\') : feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.receivedAllProducts\"> <label class=\"radio-label\" for=\"receivedAllProducts-no\"><span>No</span></label></div></div></div><div id=\"howDidYouMeetUs\" class=\"item-evaluation\" ng-if=\"feedback.specialQuestions\"><h4 class=\"feedback-question\">3. ¿Cómo nos conociste?</h4><div class=\"feedback-radio-buttons\"><div class=\"radio-button\"><input id=\"howDidYouMeetUs-google\" name=\"howDidYouMeetUs\" required=\"\" type=\"radio\" value=\"google\" ng-change=\"feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.howDidYouMeetUs\"> <label class=\"radio-label\" for=\"howDidYouMeetUs-google\"><span>Google</span></label></div><div class=\"radio-button\"><input id=\"howDidYouMeetUs-social\" name=\"howDidYouMeetUs\" type=\"radio\" required=\"\" value=\"social\" ng-change=\"feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.howDidYouMeetUs\"> <label class=\"radio-label\" for=\"howDidYouMeetUs-social\"><span>Redes sociales</span></label></div><div class=\"radio-button\"><input id=\"howDidYouMeetUs-recommended\" name=\"howDidYouMeetUs\" type=\"radio\" required=\"\" value=\"recommended\" ng-change=\"feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.howDidYouMeetUs\"> <label class=\"radio-label\" for=\"howDidYouMeetUs-recommended\"><span>Me lo recomendó un amigo/a</span></label></div><div class=\"radio-button\"><input id=\"howDidYouMeetUs-flyer\" name=\"howDidYouMeetUs\" type=\"radio\" required=\"\" value=\"flyer\" ng-change=\"feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.howDidYouMeetUs\"> <label class=\"radio-label\" for=\"howDidYouMeetUs-flyer\"><span>Volante en la calle</span></label></div><div class=\"radio-button\"><input id=\"howDidYouMeetUs-other\" name=\"howDidYouMeetUs\" type=\"radio\" required=\"\" value=\"other\" ng-change=\"feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.howDidYouMeetUs\"> <label class=\"radio-label\" for=\"howDidYouMeetUs-other\"><span>Otro</span></label></div></div></div><div id=\"recommendToFriend\" class=\"item-evaluation\"><h4 class=\"feedback-question\">{{ feedback.specialQuestions ? \'4\' : \'3\' }}. ¿Qué tan probable es que nos recomiendes a un amigo?</h4><div class=\"feedback-radio-buttons\"><div class=\"radio-button\" ng-repeat=\"evaluation in feedback.evaluationValues\"><input id=\"recommendToFriend-{{evaluation}}\" type=\"radio\" required=\"\" name=\"recommendToFriend\" ng-change=\"feedback.scrollTo(\'comment\')\" ng-model=\"feedback.feedbackForm.recommendToFriend\" ng-value=\"evaluation\"> <label class=\"radio-label\" for=\"recommendToFriend-{{evaluation}}\"><span>{{evaluation}}</span></label></div></div><div class=\"radio-details\"><p class=\"radio-details-text\">1 = Nada probable</p><p class=\"radio-details-text\">10 = Muy probable</p></div></div><div id=\"comment\" class=\"item-evaluation\"><h4 class=\"feedback-question\">Comentario Opcional</h4><div class=\"feedback-textarea\"><p class=\"textarea-title\">Cuéntanos la razón principal por la cual nos calificas con esta nota</p><textarea name=\"comment\" cols=\"30\" rows=\"10\" placeholder=\"Comentario Opcional\" ng-model=\"feedback.feedbackForm.comment\">\n            </textarea></div></div><div class=\"btn-submit-feedback\"><button class=\"btn-feedback\" type=\"submit\" ng-disabled=\"!form.$valid\" ng-if=\"!feedback.isSending\">Enviar encuesta</button><loader template=\"ellipsis\" ng-if=\"feedback.isSending\"></loader></div></div></form></div></div>");
$templateCache.put("app/feedback/mobile/feedback.html","<nav class=\"navbar navbar-default\"><div class=\"navbar-brand\"><img src=\"{{feedback.envConstants.LOGO_HEADER_URL}}\" alt=\"{{feedback.envConstants.COMPANY_NAME}} logo\"></div></nav><div class=\"feedback-loader-container\"><loader template=\"ellipsis\" size=\"large\" ng-if=\"feedback.isLoadingView\"><loader></loader></loader></div><div class=\"feedback\" ng-if=\"!feedback.isLoadingView\"><div class=\"feedback-container\"><div class=\"feedback-container-title\"><h2 class=\"feedback-title\">Encuesta</h2></div><form name=\"form\" class=\"feedback-form\" ng-submit=\"feedback.sendFeedback()\"><div class=\"card-evaluation\"><div id=\"withinPromisedTime\" class=\"item-evaluation\"><h4 class=\"feedback-question\">1. ¿Recibiste tu pedido en el tiempo prometido?</h4><div class=\"feedback-radio-buttons\"><div class=\"radio-button\"><input id=\"withinPromisedTime-yes\" name=\"withinPromisedTime\" required=\"\" type=\"radio\" value=\"yes\" ng-change=\"feedback.scrollTo(\'receivedAllProducts\')\" ng-model=\"feedback.feedbackForm.withinPromisedTime\"> <label class=\"radio-label\" for=\"withinPromisedTime-yes\"><span>Si</span></label></div><div class=\"radio-button\"><input id=\"withinPromisedTime-no\" name=\"withinPromisedTime\" type=\"radio\" required=\"\" value=\"no\" ng-change=\"feedback.scrollTo(\'receivedAllProducts\')\" ng-model=\"feedback.feedbackForm.withinPromisedTime\"> <label class=\"radio-label\" for=\"withinPromisedTime-no\"><span>No</span></label></div></div></div><div id=\"receivedAllProducts\" class=\"item-evaluation\"><h4 class=\"feedback-question\">2. ¿Recibiste todos los productos correctamente?</h4><div class=\"feedback-radio-buttons\"><div class=\"radio-button\"><input id=\"receivedAllProducts-yes\" name=\"receivedAllProducts\" required=\"\" type=\"radio\" value=\"yes\" ng-change=\"feedback.specialQuestions ? feedback.scrollTo(\'howDidYouMeetUs\') : feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.receivedAllProducts\"> <label class=\"radio-label\" for=\"receivedAllProducts-yes\"><span>Si</span></label></div><div class=\"radio-button\"><input id=\"receivedAllProducts-no\" name=\"receivedAllProducts\" type=\"radio\" required=\"\" value=\"no\" ng-change=\"feedback.specialQuestions ? feedback.scrollTo(\'howDidYouMeetUs\') : feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.receivedAllProducts\"> <label class=\"radio-label\" for=\"receivedAllProducts-no\"><span>No</span></label></div></div></div><div id=\"howDidYouMeetUs\" class=\"item-evaluation\" ng-if=\"feedback.specialQuestions\"><h4 class=\"feedback-question\">3. ¿Cómo nos conociste?</h4><div class=\"feedback-radio-buttons special-questions\"><div class=\"radio-button\"><input id=\"howDidYouMeetUs-google\" name=\"howDidYouMeetUs\" required=\"\" type=\"radio\" value=\"google\" ng-change=\"feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.howDidYouMeetUs\"> <label class=\"radio-label\" for=\"howDidYouMeetUs-google\"><span>Google</span></label></div><div class=\"radio-button\"><input id=\"howDidYouMeetUs-social\" name=\"howDidYouMeetUs\" type=\"radio\" required=\"\" value=\"social\" ng-change=\"feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.howDidYouMeetUs\"> <label class=\"radio-label\" for=\"howDidYouMeetUs-social\"><span>Redes sociales</span></label></div><div class=\"radio-button\"><input id=\"howDidYouMeetUs-recommended\" name=\"howDidYouMeetUs\" type=\"radio\" required=\"\" value=\"recommended\" ng-change=\"feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.howDidYouMeetUs\"> <label class=\"radio-label\" for=\"howDidYouMeetUs-recommended\"><span>Me lo recomendó un amigo/a</span></label></div><div class=\"radio-button\"><input id=\"howDidYouMeetUs-flyer\" name=\"howDidYouMeetUs\" type=\"radio\" required=\"\" value=\"flyer\" ng-change=\"feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.howDidYouMeetUs\"> <label class=\"radio-label\" for=\"howDidYouMeetUs-flyer\"><span>Volante en la calle</span></label></div><div class=\"radio-button\"><input id=\"howDidYouMeetUs-other\" name=\"howDidYouMeetUs\" type=\"radio\" required=\"\" value=\"other\" ng-change=\"feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.howDidYouMeetUs\"> <label class=\"radio-label\" for=\"howDidYouMeetUs-other\"><span>Otro</span></label></div></div></div><div id=\"recommendToFriend\" class=\"item-evaluation\"><h4 class=\"feedback-question\">{{ feedback.specialQuestions ? \'4\' : \'3\' }}. ¿Qué tan probable es que nos recomiendes a un amigo?</h4><div class=\"feedback-radio-buttons\"><div class=\"radio-button\" ng-repeat=\"evaluation in feedback.evaluationValues\"><input id=\"recommendToFriend-{{evaluation}}\" type=\"radio\" required=\"\" name=\"recommendToFriend\" ng-change=\"feedback.scrollTo(\'comment\')\" ng-model=\"feedback.feedbackForm.recommendToFriend\" ng-value=\"evaluation\"> <label class=\"radio-label\" for=\"recommendToFriend-{{evaluation}}\"><span>{{evaluation}}</span></label></div></div><div class=\"radio-details\"><p class=\"radio-details-text\">1 = Nada probable</p><p class=\"radio-details-text\">10 = Muy probable</p></div></div><div id=\"comment\" class=\"item-evaluation\"><h4 class=\"feedback-question\">Comentario Opcional</h4><div class=\"feedback-textarea\"><p class=\"textarea-title\">Cuéntanos la razón principal por la cual nos calificas con esta nota</p><textarea name=\"comment\" cols=\"30\" rows=\"10\" placeholder=\"Comentario Opcional\" ng-model=\"feedback.feedbackForm.comment\">\n            </textarea></div></div><div class=\"btn-submit-feedback\"><button class=\"btn-feedback\" type=\"submit\" ng-disabled=\"!form.$valid\" ng-if=\"!feedback.isSending\">Enviar encuesta</button><loader template=\"ellipsis\" ng-if=\"feedback.isSending\"></loader></div></div></form></div></div>");
$templateCache.put("app/franchises/desktop/franchises-form.html","<header-cart></header-cart><div class=\"franchises\"><div class=\"container-franchises\"><div class=\"franchises-info\"><div class=\"franchise-description\"><p>En <span class=\"highlight\">{{franchises.companyName}}</span> queremos encontrar a los mejores franquiciados para que juntos hagamos crecer aún más esta gran familia.</p><p>Por eso, si te interesa sumarte a un equipo desafiante, exigente y muy unido, que busca siempre la excelencia, te invitamos a ser parte de la cadena de {{franchises.companyFood}} más grande del país</p></div><div class=\"franchises-video\"><iframe width=\"784\" height=\"441\" src=\"https://www.youtube.com/embed/XjK0Um_xuGM\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen=\"\"></iframe></div><div class=\"franchises-benefits\"><h2>Como nuestro franquiciado tendrás los siguientes <span class=\"highlight\">beneficios:</span></h2><ul><li>Selección y búsqueda del lugar adecuado para tu local comercial.</li><li>Asesoría en la construcción y licitación del mismo.</li><li>Asesoría en la obtención de patentes comerciales.</li><li>Selección y capacitación del personal necesario para dar inicio a tu negocio.</li><li>Abastecimientos con los mejores insumos del mercado.</li><li>Comisiones competitivas con agregadores.</li><li>Ventas por sobre la media de mercado.</li><li>Tecnología de punta para la gestión de tu restaurant.</li><li>Nosotros llevamos la administración central para que tengas todo tu foco en la operación.</li></ul><h2>Entonces, ¿quieres que el próximo <span class=\"highlight\">{{franchises.companyName}} sea tuyo?</span></h2><p>Responde nuestro breve formulario y estarás dando el primer paso para llegar a formar parte de la cadena de {{franchises.companyFood}} más grande de Chile.</p></div></div><div class=\"franchises-form\"><form name=\"form\" ng-submit=\"franchises.submitForm()\"><div class=\"form-element\"><div class=\"form-elements-group\"><input placeholder=\"Nombre\" name=\"first_name\" ng-model=\"franchises.form.first_name\" required=\"\"></div><div class=\"form-elements-group\"><input placeholder=\"Apellido\" name=\"last_name\" ng-model=\"franchises.form.last_name\" required=\"\"></div></div><div class=\"form-element\"><div class=\"form-elements-group\"><phone-select btn-submit-id=\"submit-franchises\" model=\"franchises.form.phone.number\" object=\"franchises\" form-name=\"form\" class=\"form-element-phone\"></phone-select></div><div class=\"form-elements-group\"><input placeholder=\"Ciudad\" name=\"city\" ng-model=\"franchises.form.city\" required=\"\"></div></div><div class=\"form-element\"><div class=\"form-elements-group\"><input placeholder=\"Email\" type=\"email\" name=\"email\" ng-model=\"franchises.form.email\" required=\"\"></div><div class=\"form-elements-group\"><input placeholder=\"Confirmar Email\" type=\"email\" name=\"email_validation\" ng-model=\"franchises.form.email_validation\" required=\"\"></div></div><div class=\"form-element\"><textarea type=\"text\" name=\"experience\" placeholder=\"¿Tienes experiencia manejando un restaurant o franquicia? (Max. 240 caracteres)\" maxlength=\"240\" ng-model=\"franchises.form.experience\">\n          </textarea></div><div class=\"form-element\"><div class=\"form-element-select\"><select ng-model=\"franchises.form.money\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">¿Cuenta con el capital suficiente? (Local Full 350 millones + IVA aprox.)</option><option value=\"yes\">Sí</option><option value=\"no\">No</option></select></div></div><div class=\"form-element\"><div class=\"form-element-select\"><select ng-model=\"franchises.form.availability\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">¿Cuenta con disponibilidad de tener dedicación exclusiva para administrar el local en la ciudad donde vive?</option><option value=\"yes\">Sí</option><option value=\"no\">No</option></select></div></div><div class=\"form-element\"><input placeholder=\"¿Estaría dispuesto a tener su franquicia en otra región? (De contestar \'sí\', indique cuál)\" name=\"another_region\" ng-model=\"franchises.form.another_region\" required=\"\"></div><div class=\"form-element\"><textarea type=\"text\" name=\"review\" placeholder=\"Haga una breve reseña de por qué sería un buen franquiciado de {{franchises.companyName}} (Max. 500 caracteres)\" maxlength=\"500\" ng-model=\"franchises.form.review\">\n          </textarea></div><div class=\"btn-submit-franchises\"><button type=\"submit\" id=\"submit-franchises\" class=\"btn-next\" ng-disabled=\"form.$invalid || franchises.isDisabled\">Enviar</button></div></form></div></div><footer-cart></footer-cart></div>");
$templateCache.put("app/franchises/mobile/franchises-form.html","<header-cart></header-cart><div class=\"franchises\"><div class=\"container-franchises\"><div class=\"franchises-info\"><div class=\"franchise-description\"><p>En <span class=\"highlight\">{{franchises.companyName}}</span> queremos encontrar a los mejores franquiciados para que juntos hagamos crecer aún más esta gran familia.</p><p>Por eso, si te interesa sumarte a un equipo desafiante, exigente y muy unido, que busca siempre la excelencia, te invitamos a ser parte de la cadena de {{franchises.companyFood}} más grande del país</p></div><div class=\"franchises-video\"><div class=\"panel-group\" role=\"tablist\" aria-multiselectable=\"true\" ng-repeat-end=\"\"><div class=\"panel-default\"><a class=\"btn btn-franchises-video\" ng-class=\"{\'active\': isExpanded}\" role=\"tab\" ng-click=\"isExpanded = !isExpanded\" data-toggle=\"collapse\" aria-expanded=\"{{isExpanded}}\"><span>Ver video</span></a></div><div class=\"panel-collapse collapse\" ng-class=\"{\'in\': isExpanded}\" role=\"tabpanel\"><div class=\"panel-body\"><iframe width=\"100%\" height=\"441\" src=\"https://www.youtube.com/embed/XjK0Um_xuGM\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen=\"\"></iframe></div></div></div></div><div class=\"franchises-benefits\"><h2>Como nuestro franquiciado tendrás los siguientes <span class=\"highlight\">beneficios:</span></h2><ul><li>Selección y búsqueda del lugar adecuado para tu local comercial.</li><li>Asesoría en la construcción y licitación del mismo.</li><li>Asesoría en la obtención de patentes comerciales.</li><li>Selección y capacitación del personal necesario para dar inicio a tu negocio.</li><li>Abastecimientos con los mejores insumos del mercado.</li><li>Comisiones competitivas con agregadores.</li><li>Ventas por sobre la media de mercado.</li><li>Tecnología de punta para la gestión de tu restaurant.</li><li>Nosotros llevamos la administración central para que tengas todo tu foco en la operación.</li></ul><h2>Entonces, ¿quieres que el próximo <span class=\"highlight\">{{franchises.companyName}} sea tuyo?</span></h2><p>Responde nuestro breve formulario y estarás dando el primer paso para llegar a formar parte de la cadena de {{franchises.companyFood}} más grande de Chile.</p></div></div><div class=\"franchises-form\"><form name=\"form\" ng-submit=\"franchises.submitForm()\"><div class=\"form-element\"><input placeholder=\"Nombre\" name=\"first_name\" ng-model=\"franchises.form.first_name\" required=\"\"></div><div class=\"form-element\"><input placeholder=\"Apellido\" name=\"last_name\" ng-model=\"franchises.form.last_name\" required=\"\"></div><div class=\"form-element\"><phone-select btn-submit-id=\"submit-franchises\" model=\"franchises.form.phone.number\" object=\"franchises\" form-name=\"form\" class=\"form-element-phone\"></phone-select></div><div class=\"form-element\"><input placeholder=\"Ciudad\" name=\"city\" ng-model=\"franchises.form.city\" required=\"\"></div><div class=\"form-element\"><input placeholder=\"Email\" type=\"email\" name=\"email\" ng-model=\"franchises.form.email\" required=\"\"></div><div class=\"form-element\"><input placeholder=\"Confirmar Email\" type=\"email\" name=\"email_validation\" ng-model=\"franchises.form.email_validation\" required=\"\"></div><div class=\"form-element\"><textarea type=\"text\" name=\"experience\" placeholder=\"¿Tienes experiencia manejando un restaurant o franquicia? (Max. 240 caracteres)\" maxlength=\"240\" ng-model=\"franchises.form.experience\">\n          </textarea></div><div class=\"form-element\"><div class=\"form-element-select\"><select ng-model=\"franchises.form.money\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">¿Cuenta con el capital suficiente? (Local Full 350 millones + IVA aprox.)</option><option value=\"yes\">Sí</option><option value=\"no\">No</option></select></div></div><div class=\"form-element\"><div class=\"form-element-select\"><select ng-model=\"franchises.form.availability\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">¿Cuenta con disponibilidad de tener dedicación exclusiva para administrar el local en la ciudad donde vive?</option><option value=\"yes\">Sí</option><option value=\"no\">No</option></select></div></div><div class=\"form-element\"><input placeholder=\"¿Estaría dispuesto a tener su franquicia en otra región? (De contestar \'sí\', indique cuál)\" name=\"another_region\" ng-model=\"franchises.form.another_region\" required=\"\"></div><div class=\"form-element\"><textarea type=\"text\" name=\"review\" placeholder=\"Haga una breve reseña de por qué sería un buen franquiciado de {{franchises.companyName}} (Max. 500 caracteres)\" maxlength=\"500\" ng-model=\"franchises.form.review\">\n          </textarea></div><div class=\"btn-submit-franchises\"><button type=\"submit\" id=\"submit-franchises\" class=\"btn-next\" ng-disabled=\"form.$invalid || franchises.isDisabled\">Enviar</button></div></form></div></div></div>");
$templateCache.put("app/home/desktop/home.html","<notice-bar-cart></notice-bar-cart><header-cart></header-cart><div class=\"container-home\"><div class=\"content-home\"><skeleton-screen class=\"full-width\" ng-show=\"home.isLoadingItems\" template=\"banner-home\"></skeleton-screen><div class=\"banner-home\" ng-show=\"!home.isLoadingItems\"><carousel></carousel></div><skeleton-screen class=\"full-width\" ng-show=\"home.isLoadingItems\" template=\"favorites-home\"></skeleton-screen><div class=\"favorites-home\" ng-if=\"home.products.length > 0\" ng-show=\"!home.isLoadingItems\"><div class=\"favorites-home-title\"><h2>Los favoritos de<br>nuestros clientes</h2></div><div class=\"product-carousel-home-container\"><product-carousel></product-carousel></div></div><skeleton-screen class=\"full-width\" ng-show=\"home.isLoadingItems\" template=\"promotions-home\"></skeleton-screen><div class=\"promotions-home\" ng-if=\"home.banners.length > 0\" ng-show=\"!home.isLoadingItems\"><div class=\"promotions-home-title\"><h2>Promociones</h2></div><div class=\"promotions-home-container\"><div class=\"promotions-home-content\" ng-repeat=\"image in home.banners\"><img ng-src=\"{{image.image}}\" alt=\"{{image.alt}}\" data-index=\"{{image.index}}\" ng-click=\"home.goToUrl(image.redirect)\"></div></div></div><skeleton-screen class=\"full-width\" ng-show=\"home.isLoadingItems\" template=\"menu-home\"></skeleton-screen><div class=\"menu-home\" ng-if=\"home.menuCategories.length > 0\" ng-show=\"!home.isLoadingItems\"><div class=\"menu-home-title\"><h2>Nuestro Menu</h2></div><div class=\"menu-home-container\"><div class=\"menu-home-content\" ng-repeat=\"menuCategory in home.menuCategories\"><img ng-src=\"{{menuCategory.home_image.large}}\" alt=\"{{menuCategory.name}}\"><div class=\"menu-home-btn\"><button class=\"btn btn-home menu\" ui-sref=\"menu.category({categoryName: home.kebabCase(menuCategory.name)})\">{{menuCategory.name}}</button></div></div></div></div><skeleton-screen class=\"full-width\" ng-show=\"home.isLoadingItems\" template=\"more-info-home\"></skeleton-screen><div class=\"more-info-home\" ng-show=\"!home.isLoadingItems\"><div class=\"more-info-locale\"><p>Encuentra tu sucursal de NiuSushi más cercano.</p></div><div class=\"locale-home-container\"><button class=\"btn btn-home\" ui-sref=\"restaurants\">Sucursales</button></div></div></div></div><footer-home></footer-home>");
$templateCache.put("app/kushki/desktop/modal-kushki.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\" ng-disabled=\"kushki.kushki.isDisabled\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><h2>Nueva tarjeta de crédito</h2></div><div class=\"modal-body\"><div class=\"modal-form\"><div class=\"kushki-form\"><form name=\"kushkiForm\" ng-submit=\"kushki.kushki.kushkiSubscribeCard()\"><div class=\"form-element-column\"><label class=\"kushki-label\">Número de tarjeta</label><div class=\"form-element-column input\"><input type=\"text\" name=\"number\" ng-pattern=\"/^[0-9]{1,16}$/\" maxlength=\"16\" placeholder=\"**** **** **** ****\" ng-model=\"kushki.kushki.kushkiForm.number\" required=\"\"></div></div><div class=\"form-element-column\"><label class=\"kushki-label\">Nombre del titular</label><div class=\"form-element-column input\"><input type=\"text\" name=\"name\" ng-pattern=\"/^[a-zA-Z\\s]+$/\" placeholder=\"Juan Perez\" ng-model=\"kushki.kushki.kushkiForm.name\" required=\"\"> <span class=\"kushki-label form-error\" ng-if=\"kushkiForm[\'name\'].$viewValue.length > 0 && kushkiForm[\'name\'].$invalid\">Como se muestra en la tarjeta</span></div></div><div class=\"form-element-column\"><div class=\"form-element-row\"><div class=\"form-element-column\"><label class=\"kushki-label\">Expiración</label><div class=\"form-element-row expiry-date\"><div class=\"form-element-column input expiry-date\"><input id=\"expiryMonth\" name=\"expiryMonth\" type=\"text\" ng-pattern=\"/^[0-9]{2,2}$/\" minlength=\"2\" maxlength=\"2\" placeholder=\"MM\" ng-keyup=\"kushki.kushki.filterExpiryMonth($event)\" ng-model=\"kushki.kushki.kushkiForm.expiryMonth\" required=\"\"></div><span>/</span><div class=\"form-element-column input expiry-date\"><input id=\"expiryYear\" name=\"expiryYear\" type=\"text\" ng-pattern=\"/^[0-9]{2,2}$/\" minlength=\"2\" maxlength=\"2\" placeholder=\"YY\" ng-keyup=\"kushki.kushki.filterExpiryYear($event)\" ng-model=\"kushki.kushki.kushkiForm.expiryYear\" required=\"\"></div></div></div><div class=\"form-element-column\"><label class=\"kushki-label\">Código</label><div class=\"form-element-column input\"><input type=\"password\" name=\"cvv\" ng-pattern=\"/^[0-9]{3,4}$/\" minlength=\"3\" maxlength=\"4\" placeholder=\"CVV\" ng-model=\"kushki.kushki.kushkiForm.cvv\" required=\"\"></div></div></div></div><div class=\"form-element-column\"><label class=\"kushki-label charge\">Realizaremos un cobro de 5 pesos para efectos de validación de tarjeta, los que serán devueltos en un máximo de 48 horas</label></div><div class=\"button-submit-center\"><button type=\"submit\" class=\"btn submit-button\" ng-show=\"!kushki.kushki.inProgress\" ng-disabled=\"!kushkiForm.$valid || kushki.kushki.isDisabled\">Inscribir tarjeta</button><loader template=\"ellipsis\" ng-show=\"kushki.kushki.inProgress\"><loader></loader></loader></div></form></div></div></div><div class=\"modal-footer\"><img src=\"assets/images/kushki/logo-kushki.svg\" alt=\"logo-kushki\"></div>");
$templateCache.put("app/kushki/mobile/modal-kushki.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\" ng-disabled=\"kushki.kushki.isDisabled\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><h2>Nueva tarjeta de crédito</h2></div><div class=\"modal-body\"><div class=\"modal-form\"><div class=\"kushki-form\"><form name=\"kushkiForm\" ng-submit=\"kushki.kushki.kushkiSubscribeCard()\"><div class=\"form-element-column\"><label class=\"kushki-label\">Número de tarjeta</label><div class=\"form-element-column input\"><input type=\"text\" name=\"number\" ng-pattern=\"/^[0-9]{1,16}$/\" maxlength=\"16\" placeholder=\"**** **** **** ****\" ng-model=\"kushki.kushki.kushkiForm.number\" required=\"\"></div></div><div class=\"form-element-column\"><label class=\"kushki-label\">Nombre del titular</label><div class=\"form-element-column input\"><input type=\"text\" name=\"name\" ng-pattern=\"/^[a-zA-Z\\s]+$/\" placeholder=\"Juan Perez\" ng-model=\"kushki.kushki.kushkiForm.name\" required=\"\"> <span class=\"form-error\" ng-if=\"kushkiForm[\'name\'].$viewValue.length > 0 && kushkiForm[\'name\'].$invalid\">Como se muestra en la tarjeta</span></div></div><div class=\"form-element-column\"><div class=\"form-element-row\"><div class=\"form-element-column\"><label class=\"kushki-label\">Expiración</label><div class=\"form-element-row expiry-date\"><div class=\"form-element-column input expiry-date\"><input id=\"expiryMonth\" name=\"expiryMonth\" type=\"text\" ng-pattern=\"/^[0-9]{2,2}$/\" minlength=\"2\" maxlength=\"2\" placeholder=\"MM\" ng-keyup=\"kushki.kushki.filterExpiryMonth($event)\" ng-model=\"kushki.kushki.kushkiForm.expiryMonth\" required=\"\"></div><span>/</span><div class=\"form-element-column input expiry-date\"><input id=\"expiryYear\" name=\"expiryYear\" type=\"text\" ng-pattern=\"/^[0-9]{2,2}$/\" minlength=\"2\" maxlength=\"2\" placeholder=\"YY\" ng-keyup=\"kushki.kushki.filterExpiryYear($event)\" ng-model=\"kushki.kushki.kushkiForm.expiryYear\" required=\"\"></div></div></div><div class=\"form-element-column\"><label class=\"kushki-label\">Código</label><div class=\"form-element-column input\"><input type=\"password\" name=\"cvv\" ng-pattern=\"/^[0-9]{3,4}$/\" minlength=\"3\" maxlength=\"4\" placeholder=\"CVV\" ng-model=\"kushki.kushki.kushkiForm.cvv\" required=\"\"></div></div></div></div><div class=\"form-element-column\"><label class=\"kushki-label charge\">Realizaremos un cobro de 5 pesos para efectos de validación de tarjeta, los que serán devueltos en un máximo de 48 horas</label></div><div class=\"button-submit-center\"><button type=\"submit\" class=\"btn submit-button\" ng-show=\"!kushki.kushki.inProgress\" ng-disabled=\"!kushkiForm.$valid || kushki.kushki.isDisabled\">Inscribir tarjeta</button><loader template=\"ellipsis\" ng-show=\"kushki.kushki.inProgress\"><loader></loader></loader></div></form></div></div></div><div class=\"modal-footer\"><img src=\"assets/images/kushki/logo-kushki.svg\" alt=\"logo-kushki\"></div>");
$templateCache.put("app/home/mobile/home.html","<notice-bar-cart></notice-bar-cart><header-cart></header-cart><div class=\"container-home\"><div class=\"content-home\"><skeleton-screen class=\"full-width\" ng-show=\"home.isLoadingItems\" template=\"banner-home\"></skeleton-screen><div class=\"banner-home\" ng-show=\"!home.isLoadingItems\"><carousel></carousel></div><skeleton-screen class=\"full-width\" ng-show=\"home.isLoadingItems\" template=\"favorites-home\"></skeleton-screen><div class=\"favorites-home\" ng-if=\"home.products.length > 0\" ng-show=\"!home.isLoadingItems\"><div class=\"favorites-home-title\"><h2>Los favoritos de<br>nuestros clientes</h2></div><div class=\"product-carousel-home-container\"><product-carousel></product-carousel></div></div><skeleton-screen class=\"full-width\" ng-show=\"home.isLoadingItems\" template=\"promotions-home\"></skeleton-screen><div class=\"promotions-home\" ng-if=\"home.banners.length > 0\" ng-show=\"!home.isLoadingItems\"><div class=\"promotions-home-title\"><h2>Promociones</h2></div><div class=\"promotions-home-container\"><div class=\"promotions-home-content\" ng-repeat=\"image in home.banners\"><img ng-src=\"{{image.image}}\" alt=\"{{image.alt}}\" data-index=\"{{image.index}}\" ng-click=\"home.goToUrl(image.redirect)\"></div></div></div><skeleton-screen class=\"full-width\" ng-show=\"home.isLoadingItems\" template=\"menu-home\"></skeleton-screen><div class=\"menu-home\" ng-if=\"home.menuCategories.length > 0\" ng-show=\"!home.isLoadingItems\"><div class=\"menu-home-title\"><h2>Nuestro Menu</h2></div><div class=\"menu-home-container\"><div class=\"menu-home-content\" ng-repeat=\"menuCategory in home.menuCategories\"><img ng-src=\"{{menuCategory.home_image.large}}\" alt=\"{{menuCategory.name}}\"><div class=\"menu-home-btn\"><button class=\"btn btn-home menu\" ui-sref=\"menu.category({categoryName: home.kebabCase(menuCategory.name)})\">{{menuCategory.name}}</button></div></div></div></div><skeleton-screen class=\"full-width\" ng-show=\"home.isLoadingItems\" template=\"more-info-home\"></skeleton-screen><div class=\"more-info-home\" ng-show=\"!home.isLoadingItems\"><div class=\"more-info-locale\"><p>Encuentra tu sucursal de NiuSushi más cercano.</p></div><div class=\"locale-home-container\"><button class=\"btn btn-home\" ui-sref=\"restaurants\">Sucursales</button><div class=\"locale-home-image\"><img ng-src=\"{{home.restaurantImage}}\" alt=\"Sucursales\"></div></div></div><footer-home></footer-home></div></div>");
$templateCache.put("app/location/desktop/cart-warning-modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close(false)\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header warning-modal\"><h2><b class=\"highlight\">!Cuidado!</b> algunos productos se eliminarán de tu carrito al cambiar tu ubicación.</h2></div><div class=\"modal-body\"><div class=\"modal-form\"><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-click=\"$close(true)\">Confirmar</button> <button class=\"btn submit-button\" ng-click=\"$close(false)\">Rechazar</button></div></div></div>");
$templateCache.put("app/location/desktop/location.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-box\"><div class=\"modal-body\"><div class=\"modal-form\"><div class=\"modal-select\"><label class=\"location-label\">Elige tu región</label><select required=\"\" ng-model=\"location.location\" ng-options=\"restaurantGroup.name for restaurantGroup in location.restaurantGroups\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Región</option></select></div><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-click=\"location.setRestaurantGroup()\">Confirmar</button></div></div></div></div>");
$templateCache.put("app/location/desktop/login-warning-modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><h2><b class=\"highlight\">!Cuidado!</b> Serás redireccionado a tu última región guardada ({{location.locationPrefs.short_name}}). Si cambias ahora de región podrían modificarse los productos de tu pedido</h2></div><div class=\"modal-body\"><div class=\"modal-form\"><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-click=\"$close(true)\">Confirmar</button> <button class=\"btn submit-button\" ng-click=\"$close(false)\">Rechazar</button></div></div></div>");
$templateCache.put("app/location/desktop/modal-location-cart.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><h2><b class=\"highlight\">!Cuidado!</b> si cambias ahora de región podrían modificarse los productos de tu pedido &#128064;</h2><p><b>¿No encuentras tu local? Quizás estés en otra región o el local ya no existe.</b></p></div><div class=\"modal-body\"><div class=\"modal-form\"><div class=\"modal-select\"><label class=\"location-label\">Región</label><select required=\"\" ng-model=\"location.location\" ng-options=\"restaurantGroup.name for restaurantGroup in location.restaurantGroups\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Región</option></select><label class=\"location-label\">Locales cerrados (abren de 12:00 a 23:30)</label></div><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-click=\"location.setRestaurantGroup()\">Confirmar</button></div></div></div>");
$templateCache.put("app/location/desktop/warning-modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close(false)\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header warning-modal\"><h2><b class=\"highlight\">!Cuidado!</b> algunos productos se eliminarán de tu carrito al cambiar tu ubicación.</h2></div><div class=\"modal-body\"><div class=\"modal-form\"><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-click=\"location.confirmWarningModal()\">Confirmar</button> <button class=\"btn submit-button\" ng-click=\"$close()\">Rechazar</button></div></div></div>");
$templateCache.put("app/main/desktop/main.html","<notice-bar-cart></notice-bar-cart><header-cart></header-cart><div class=\"home-banner\" ng-class=\"{\'home-notice-bar\': noticeBarDesktop}\"><carousel></carousel></div><footer-cart></footer-cart>");
$templateCache.put("app/location/mobile/cart-warning-modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close(false)\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header warning-modal\"><h2><b class=\"highlight\">!Cuidado!</b> algunos productos se eliminarán de tu carrito al cambiar tu ubicación.</h2></div><div class=\"modal-body\"><div class=\"modal-form\"><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-click=\"$close(true)\">Confirmar</button> <button class=\"btn submit-button\" ng-click=\"$close(false)\">Rechazar</button></div></div></div>");
$templateCache.put("app/location/mobile/location.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-box\"><div class=\"modal-body\"><div class=\"modal-form\"><div class=\"modal-select\"><label class=\"location-label\">Elige tu región</label><select required=\"\" ng-model=\"location.location\" ng-options=\"restaurantGroup.name for restaurantGroup in location.restaurantGroups\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Región</option></select></div><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-click=\"location.setRestaurantGroup()\">Confirmar</button></div></div></div></div>");
$templateCache.put("app/location/mobile/login-warning-modal.html","<div class=\"modal-restaurant-group\"><div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><h2><b class=\"highlight\">!Cuidado!</b> Serás redireccionado a tu última región guardada ({{location.locationPrefs.short_name}}). Si cambias ahora de región podrían modificarse los productos de tu pedido</h2></div><div class=\"modal-body\"><div class=\"modal-form\"><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-click=\"$close(true)\">Confirmar</button> <button class=\"btn submit-button\" ng-click=\"$close(false)\">Rechazar</button></div></div></div></div>");
$templateCache.put("app/location/mobile/modal-location-cart.html","<div class=\"modal-header-close\"><button class=\"close-button\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><h2><b class=\"highlight\">!Cuidado!</b> si cambias ahora de región podrían modificarse los productos de tu pedido &#128064;</h2><p><b>¿No encuentras tu local? Quizás estés en otra región o el local ya no existe.</b></p></div><div class=\"modal-body\"><div class=\"modal-form\"><div class=\"modal-select\"><label class=\"location-label\">Región</label><select required=\"\" ng-model=\"location.location\" ng-options=\"restaurantGroup.name for restaurantGroup in location.restaurantGroups\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Región</option></select><label class=\"location-label\">Locales cerrados (abren de 12:00 a 23:30)</label></div><div class=\"button-submit-center\"><button class=\"btn submit-button\" ng-click=\"location.setRestaurantGroup()\">Confirmar</button></div></div></div>");
$templateCache.put("app/main/mobile/main.html","<notice-bar-cart></notice-bar-cart><header-cart></header-cart><div class=\"container container-banner\"><div class=\"home-banner\"><carousel></carousel></div></div><toolbar-cart></toolbar-cart>");
$templateCache.put("app/menu/desktop/menu.html","<notice-bar-cart></notice-bar-cart><header-cart></header-cart><div class=\"menu-background\" ng-controller=\"CartController as cart\"><div class=\"menu-row\"><div class=\"menu-left\"><skeleton-screen ng-show=\"menu.isLoadingCategories\" template=\"menu-categories\"></skeleton-screen><div class=\"menu-group\" id=\"\" role=\"tablist\" aria-multiselectable=\"true\" ng-show=\"!menu.isLoadingCategories\"><div class=\"menu-default\" ng-if=\"menu.search == \'true\'\"><a class=\"menu-heading\" role=\"button\" ng-click=\"menu.expandFilter()\"><div class=\"search-box\"><i class=\"glyphicon glyphicon-search\"></i><p class=\"search\"><span class=\"search\" ng-if=\"menu.customer.name\">{{menu.customer.name.split(\' \')[0]}},</span> {{menu.menuPlaceholderSearch}}</p></div></a></div><div class=\"menu-default\"><a class=\"menu-heading favourites\" role=\"button\" ui-sref=\"myFavorites\"><p class=\"favourites\">Mis favoritos</p><i class=\"glyphicon glyphicon-heart\"></i></a></div><div class=\"menu-default\"><a class=\"menu-heading\" role=\"button\" ui-sref=\"latestOrders\" ng-class=\"{\'active\': (menu.currentState == \'latestOrders\')}\"><p>Repetir Pedidos</p><i class=\"icon-chevron-right\"></i></a></div><div class=\"menu-default\" ng-repeat=\"category in menu.categories\" ng-if=\"category.seleables.length > 0\" ng-class=\"{ favorite: category.isFavorites }\"><a class=\"menu-heading\" role=\"button\" ui-sref=\"menu.category({categoryName: menu.kebabCase(category.name)})\" ng-click=\"menu.expandCategory(category)\" ng-class=\"{\'active\': menu.currentCategoryState(category)}\"><p>{{category.name}}</p><i class=\"icon-chevron-right\"></i></a></div><div class=\"menu-default\" ng-if=\"menu.events\"><a class=\"menu-heading\" role=\"button\" ui-sref=\"events\" ng-class=\"{\'active\': (menu.currentState == \'events\')}\"><p>Eventos y Cumpleaños</p><i class=\"icon-chevron-right\"></i></a></div></div></div><div id=\"menu-right\" class=\"menu-right\"><skeleton-screen ng-show=\"menu.isLoadingCategories\" template=\"menu-card\"></skeleton-screen><div ng-show=\"!menu.isLoadingCategories\" ng-if=\"menu.isEmptyState()\" class=\"container-empty\"><div class=\"icon-container\"><img src=\"assets/images/frown.png\" alt=\"Frown Icon\"></div><p>Aún no tienes {{menu.getEntityLabel()}}.</p><p>{{menu.emptyTextDescription()}}</p></div><div id=\"menu\" class=\"menu-group\" ng-if=\"menu.currentState == \'searchMenu\'\" ng-show=\"!menu.isLoadingCategories\"><ng-include src=\"\'app/menu/desktop/menu_search.html\'\"></ng-include></div><div id=\"menu\" class=\"menu-group\" ng-init=\"categories = menu.getCategories(menu)\" ng-if=\"menu.currentState == \'myFavorites\'\" ng-show=\"!menu.isLoadingCategories\"><ng-include src=\"\'app/menu/desktop/my_favorites.html\'\"></ng-include></div><div id=\"menu\" class=\"menu-group\" ng-init=\"categories = menu.getCategories(menu)\" ng-if=\"menu.currentState != \'searchMenu\' && menu.currentState != \'myFavorites\' && menu.currentState != \'events\'\" ng-show=\"!menu.isLoadingCategories\"><ng-include src=\"\'app/menu/desktop/menu_categories.html\'\"></ng-include></div><div id=\"menu\" class=\"menu-group\" ng-if=\"menu.currentState == \'events\'\" ng-show=\"!menu.isLoadingCategories\"><ng-include src=\"\'app/menu/desktop/menu_events.html\'\"></ng-include></div></div></div><footer-cart></footer-cart></div><div class=\"structured_data\"></div>");
$templateCache.put("app/menu/desktop/menu_categories.html","<div class=\"panel panel-default\" ng-repeat=\"category in categories\" id=\"{{menu.kebabCase((category.promised_time || \'\') + category.name)}}\" ng-if=\"category.seleables.length > 0 && (category.isExpanded || menu.currentState.indexOf(\'menu\') == -1)\"><div class=\"panel-heading\" ng-class=\"{\'active\': category.isExpanded}\" ng-if=\"menu.currentState.indexOf(\'menu\') == -1\" data-toggle=\"collapse\" data-parent=\"#menu\" id=\"{{menu.kebabCase((category.promised_time || \'\') + category.name)}}-heading\" aria-controls=\"{{menu.kebabCase(category.name)}}-content\" ng-click=\"menu.expandCategory(category)\"><div class=\"panel-row-heading\"><div class=\"panel-date\" ng-class=\"{\'expanded\': category.isExpanded}\"><span class=\"date-text\">{{category.promised_time | date:\'EEEE d/M\'}} {{ category.name }}</span><div class=\"scheduled-order-text\" ng-if=\"category.scheduled && !category.promised_time_fulfilled\"><i class=\"icon-pickup-time\"></i> <span>{{category.promised_time_with_format}}</span></div></div><div class=\"expanded-icon\"><i class=\"icon-plus\" ng-if=\"!category.isExpanded\"></i> <i class=\"icon-minus\" ng-if=\"category.isExpanded\"></i></div></div></div><div id=\"{{menu.kebabCase(category.name)}}-content\" class=\"panel-collapse collapse\" ng-class=\"{\'in\': category.isExpanded}\" role=\"tabpanel\" aria-labelledby=\"{{menu.kebabCase((category.promised_time || \'\') + category.name)}}\"><div class=\"panel-body\" ng-if=\"category.isExpanded\"><div class=\"panel-row-body\"><div class=\"panel-col-body\" ng-repeat=\"seleable in category.seleables\"><div class=\"menu-product\"><div class=\"img-product\"><product-badge badge=\"highlight-text\" seleable=\"seleable\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.image.large}}\" alt=\"{{seleable.name}}\" ng-click=\"menu.viewSeleable(seleable, !!category.order_id ? \'latestOrders\' : menu.kebabCase(category.name), false, !category.order_id)\"> <a class=\"favorite\" ng-click=\"menu.toggleLike(seleable.type, seleable.preference, seleable)\"><img ng-if=\"seleable.preference === 1\" src=\"assets/images/favorite-heart.svg\" ng-mouseenter=\"menu.addHeartEmpty($event)\" ng-mouseleave=\"menu.addHeartFull($event)\"> <img ng-if=\"seleable.preference === 0\" src=\"assets/images/favorite-heart-empty.svg\" ng-mouseenter=\"menu.addHeartFull($event)\" ng-mouseleave=\"menu.addHeartEmpty($event)\"></a></div></div><div class=\"body-product\"><div class=\"body-product-details\"><div class=\"body-product-name\"><h5>{{seleable.name}}</h5></div><div class=\"body-product-price\" ng-class=\"{\'one-line\': (!seleable.discount || !menu.cart.discountable()) && (seleable.discount || seleable.normal_price <= seleable.special_price || seleable.special_price <= 0)}\"><p class=\"discount-price\" ng-show=\"(seleable.discount && menu.cart.discountable()) || (!seleable.discount && seleable.normal_price > seleable.special_price && seleable.special_price > 0)\">{{menu.cart.discountPriceIntl(seleable.id, seleable.type)}}</p><p>{{menu.cart.priceIntl(seleable.id, seleable.discount, seleable.type)}}</p></div></div><div class=\"body-add-product\"><a class=\"add-btn\" ng-class=\"{\'aggregated\': menu.cart.get(seleable.id, null, seleable.type)}\" ng-click=\"menu.addToCart(seleable, category, !!category.order_id)\"><img src=\"assets/images/icon-cart.svg\"></a> <small ng-click=\"menu.addToCart(seleable, category, !!category.order_id)\" ng-if=\"!menu.cart.get(seleable.id, null, seleable.type)\"><i class=\"icon-plus\"></i></small> <small ng-click=\"menu.addToCart(seleable, category, !!category.order_id)\" ng-if=\"menu.cart.get(seleable.id, null, seleable.type)\">{{menu.cart.get(seleable.id, null, seleable.type)}}</small></div></div></div></div></div><div class=\"repeat-order\" ng-show=\"!!category.order_id\"><div class=\"body-repeat-order\" ng-click=\"menu.repeatOrder(category)\"><h5>Repetir pedido completo</h5><i class=\"icon-repeat\"></i></div></div></div></div></div>");
$templateCache.put("app/menu/desktop/menu_events.html","<div class=\"panel-default\"><div id=\"eventos-y-cumpleanos-content\" class=\"panel-collapse collapse in\" role=\"tabpanel\" aria-labelledby=\"eventos-y-cumpleanos\"><div class=\"panel-body\"><div class=\"panel-row-body\"><div class=\"panel-col-body events\"><div class=\"container-events\"><div class=\"container-banner\"><div class=\"description-banner\"><p>Elige tu pedido y pídelo al menos con 24 horas de anticipación.</p></div><div class=\"banner-event\"><div class=\"content\"><img src=\"{{menu.bannerEvent}}\" alt=\"Banner event\"></div></div></div><div class=\"container-options\" ng-repeat=\"event in menu.eventData\"><div class=\"product-image\" ng-click=\"menu.viewEvent(event.code)\"><div class=\"content\"><img src=\"{{event.imageUrl}}\" alt=\"{{event.name}}\"></div></div><div class=\"product-detail\" ng-click=\"menu.viewEvent(event.code)\"><strong>{{event.name}}</strong> <span>{{event.piecesQty}}</span><p>$ {{event.finalPrice}}</p><a>Ver pedido</a></div></div><div class=\"container-footer\"><div class=\"container-text\"><p>Si quieres hacer pedidos más grandes, mándanos tus requerimientos y lo cotizamos para ti. Escríbenos a <a href=\"mailto:niusushi@niusushi.cl\">niusushi@niusushi.cl</a>.</p></div></div></div></div></div></div></div></div>");
$templateCache.put("app/menu/desktop/menu_search.html","<div class=\"panel-default\"><div class=\"panel-collapse collapse in\" role=\"tabpanel\"><div class=\"panel-body\"><div class=\"panel-tag-filter\"><div class=\"tag-filter-title\"><h3>¿Qué ingrediente quieres? (o cuál no &#128586;)</h3></div><div class=\"tag-filter-container\"><input id=\"input-tag-filter\" type=\"text\" ng-class=\"{\'has-tags\': menu.hasTags}\" ng-model=\"menu.tagText\" placeholder=\"{{menu.tagPlaceholder}}\" ng-keydown=\"menu.updateTags($event)\" autofocus=\"\"><div class=\"button-search\"><a ng-click=\"menu.cleanTags()\"><span>Limpiar búsqueda</span></a></div></div><div class=\"input-tag-container\"><span class=\"input-tag\" ng-repeat=\"(key, tag) in tags\">{{ tag }} <span class=\"delete-tag\" ng-click=\"menu.deleteTag(key)\">&times;</span></span></div></div><div class=\"panel-row-body\"><div class=\"panel-col-body\" ng-repeat=\"seleable in menu.getCategories(menu)\"><div class=\"menu-product\"><div class=\"img-product\"><product-badge badge=\"highlight-text\" seleable=\"seleable\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.image.large}}\" alt=\"{{seleable.name}}\" ng-click=\"menu.viewSeleable(seleable, \'searchMenu\', false, false)\"> <a class=\"favorite\" ng-click=\"menu.toggleLike(seleable.type, seleable.preference, seleable)\"><img ng-if=\"seleable.preference === 1\" src=\"assets/images/favorite-heart.svg\" ng-mouseenter=\"menu.addHeartEmpty($event)\" ng-mouseleave=\"menu.addHeartFull($event)\"> <img ng-if=\"seleable.preference === 0\" src=\"assets/images/favorite-heart-empty.svg\" ng-mouseenter=\"menu.addHeartFull($event)\" ng-mouseleave=\"menu.addHeartEmpty($event)\"></a></div></div><div class=\"body-product\"><div class=\"body-product-details\"><div class=\"body-product-name\"><h5>{{seleable.name}}</h5></div><div class=\"body-product-price\" ng-class=\"{\'one-line\': (!seleable.discount || !menu.cart.discountable()) && (seleable.discount || seleable.normal_price <= seleable.special_price || seleable.special_price <= 0)}\"><p class=\"discount-price\" ng-show=\"(seleable.discount && menu.cart.discountable()) || (!seleable.discount && seleable.normal_price > seleable.special_price && seleable.special_price > 0)\">{{menu.cart.discountPriceIntl(seleable.id, seleable.type)}}</p><p>{{menu.cart.priceIntl(seleable.id, true, seleable.type)}}</p></div></div><div class=\"body-add-product\"><a class=\"add-btn\" ng-class=\"{\'aggregated\': menu.cart.get(seleable.id, null, seleable.type)}\" ng-click=\"menu.addToCart(seleable, category)\"><img src=\"assets/images/icon-cart.svg\"></a> <small ng-click=\"menu.addToCart(seleable, category)\" ng-if=\"!menu.cart.get(seleable.id, null, seleable.type)\"><i class=\"icon-plus\"></i></small> <small ng-click=\"menu.addToCart(seleable, category)\" ng-if=\"menu.cart.get(seleable.id, null, seleable.type)\">{{menu.cart.get(seleable.id, null, seleable.type)}}</small></div></div></div></div></div></div></div></div>");
$templateCache.put("app/menu/desktop/menu_search.modal.html","<div class=\"modal-body\"><div class=\"modal-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"$close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-search\"><div class=\"modal-title\"><h5>¿Qué ingrediente quieres? (o cuál no &#128586;)</h5></div><div class=\"modal-search-bar\"><div class=\"modal-input-search\"><input type=\"text\" ng-class=\"{\'has-tags\': menu.hasTags}\" ng-model=\"menu.tagText\" placeholder=\"{{menu.tagPlaceholder}}\" ng-keydown=\"menu.updateTags($event)\"><div class=\"modal-input-tag\"><span class=\"input-tag\" ng-repeat=\"(key, tag) in tags\">{{tag}} <span class=\"delete-tag\" ng-click=\"menu.deleteTag(key)\">&times;</span></span></div></div><div class=\"modal-button-search\"><a ng-click=\"menu.cleanTags()\"><span>Limpiar búsqueda</span></a></div></div></div></div>");
$templateCache.put("app/menu/desktop/my_favorites.html","<div class=\"panel-default\" ng-repeat=\"category in categories\"><div id=\"{{menu.kebabCase(category.name)}}-content\" class=\"panel-collapse collapse\" ng-class=\"{\'in\': category.isExpanded}\" role=\"tabpanel\" aria-labelledby=\"{{menu.kebabCase((category.promised_time || \'\') + category.name)}}\"><div class=\"panel-body\" ng-if=\"category.isExpanded\"><div class=\"panel-row-body\"><div class=\"panel-col-body\" ng-repeat=\"seleable in category.seleables\" ng-if=\"$index < 10\"><div class=\"menu-product\"><div class=\"img-product\"><product-badge badge=\"highlight-text\" seleable=\"seleable\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.image.large}}\" alt=\"{{seleable.name}}\" ng-click=\"menu.viewSeleable(seleable, \'myFavorites\', false, false)\"> <a class=\"favorite\" ng-click=\"menu.toggleLike(seleable.type, seleable.preference, seleable)\"><img ng-if=\"seleable.preference === 1\" src=\"assets/images/favorite-heart.svg\" ng-mouseenter=\"menu.addHeartEmpty($event)\" ng-mouseleave=\"menu.addHeartFull($event)\"> <img ng-if=\"seleable.preference === 0\" src=\"assets/images/favorite-heart-empty.svg\" ng-mouseenter=\"menu.addHeartFull($event)\" ng-mouseleave=\"menu.addHeartEmpty($event)\"></a></div></div><div class=\"body-product\"><div class=\"body-product-details\"><div class=\"body-product-name\"><h5>{{seleable.name}}</h5></div><div class=\"body-product-price\" ng-class=\"{\'one-line\': (!seleable.discount || !menu.cart.discountable()) && (seleable.discount || seleable.normal_price <= seleable.special_price || seleable.special_price <= 0)}\"><p class=\"discount-price\" ng-show=\"(seleable.discount && menu.cart.discountable()) || (!seleable.discount && seleable.normal_price > seleable.special_price && seleable.special_price > 0)\">{{menu.cart.discountPriceIntl(seleable.id, seleable.type)}}</p><p>{{menu.cart.priceIntl(seleable.id, true, seleable.type)}}</p></div></div><div class=\"body-add-product\"><a class=\"add-btn\" ng-class=\"{\'aggregated\': menu.cart.get(seleable.id, null, seleable.type)}\" ng-click=\"menu.addToCart(seleable, category)\"><img src=\"assets/images/icon-cart.svg\"></a> <small ng-click=\"menu.addToCart(seleable, category)\" ng-if=\"!menu.cart.get(seleable.id, null, seleable.type)\"><i class=\"icon-plus\"></i></small> <small ng-click=\"menu.addToCart(seleable, category)\" ng-if=\"menu.cart.get(seleable.id, null, seleable.type)\">{{menu.cart.get(seleable.id, null, seleable.type)}}</small></div></div></div></div></div></div></div></div>");
$templateCache.put("app/order/desktop/order.fail.html","<div class=\"order-fail\"><div class=\"container-fail\"><div class=\"cont-fail\"><div class=\"box-fail\"><div class=\"box-img\"><img src=\"assets/success/{{$environment}}/img/super.svg\" alt=\"\"></div></div></div><div class=\"cont-fail\"><div class=\"box-fail\"><h4 class=\"order-name\"><p class=\"name\">¡{{order.customer.name.split(\' \')[0]}}, <span class=\"order\">tu pedido a fallado!</span></p></h4></div></div><div class=\"cont-fail\" ng-if=\"customerSession.showAllBrands()\"><div class=\"box-fail\"><h4 class=\"about-us\">¡Conoce y disfruta todas las marcas de Niu Foods!</h4></div><div class=\"box-fail brands\"><img src=\"assets/success/byniu.png\" alt=\"\"> <a href=\"https://niusushi.cl/\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"cont-fail\"><div class=\"box-fail continue-browsing\"><a ui-sref=\"main\"><span class=\"browsing\">Volver a pedir</span></a></div></div></div></div>");
$templateCache.put("app/order/desktop/order.success.html","<div class=\"order-success\"><div class=\"container-success\"><div class=\"cont-success\"><div class=\"box-success\"><div class=\"box-img\"><img src=\"assets/success/{{$environment}}/img/super.svg\" alt=\"\"></div></div></div><div class=\"cont-success\"><div class=\"box-success\"><h4 class=\"order-name\"><p class=\"name\">¡{{order.customer.name.split(\' \')[0]}}, <span class=\"order\">tu pedido fue recibido con éxito!</span></p></h4><div class=\"mailing\"><p class=\"email\">Te enviamos confirmación a tu email {{order.customer.email}} y <b>{{order.deliveryTimeMessage}}</b> estará <span ng-if=\"order.order.order_type === \'Retiro\'\">listo para retiro en <b>{{order.restaurant.address}}</b>.</span> <span ng-if=\"order.order.order_type === \'Delivery\'\">siendo entregado en tu domicilio.</span><br><br>En caso que tengamos alguna duda te contactaremos, por favor ten tu teléfono a mano.<br><br></p><div class=\"payment\"><h2 class=\"title\">Resumen del pedido:</h2><div class=\"payment-detail\"><p><span class=\"principal\">N° de orden</span> <span class=\"secondary\">: {{order.order.id}}</span></p><p><span class=\"principal\">Total</span> <span class=\"secondary\">: {{order.cart.parseIntl(order.order.total_to_pay)}}</span></p><p><span class=\"principal\">Tipo de pedido</span> <span class=\"secondary\">: {{order.order.order_type}}</span></p><p><span class=\"principal\">Método de pago</span> <span class=\"secondary\">: {{order.paymentType}}</span></p></div></div><div ng-if=\"order.order.webpayment\" class=\"payment\"><h2 class=\"title\">Detalle Webpay:</h2><div class=\"payment-detail\"><p><span class=\"principal\">Transacción</span> <span class=\"secondary\">: {{order.order.webpayment.order_num}}</span></p><p><span class=\"principal\">Monto</span> <span class=\"secondary\">: {{order.cart.parseIntl(order.order.total_to_pay)}}</span></p><p><span class=\"principal\">Fecha</span> <span class=\"secondary\">: {{order.order.date | date:\'dd/MM/yyyy\'}}</span></p><p><span class=\"principal\">Tarjeta</span> <span class=\"secondary\">: xxxx-xxxx-xxxx-{{order.order.webpayment.last4CardDigits}}</span></p></div></div></div><div class=\"restaurant\"><div class=\"restaurant-info\"><img src=\"assets/success/{{$environment}}/img/tienda.png\" alt=\"\"></div><div class=\"restaurant-info\"><p class=\"name\">{{order.restaurant.name}}</p></div><div class=\"restaurant-info\"><img src=\"assets/success/{{$environment}}/img/telefono.png\" alt=\"\"></div><div class=\"restaurant-info\"><a href=\"tel:{{order.restaurant.phones[0]}}\"><p class=\"phones\">Cualquier duda o consulta llámanos al {{order.restaurant.phones[0]}}</p></a></div></div></div></div><div class=\"cont-success\" ng-if=\"customerSession.showAllBrands()\"><div class=\"box-success\"><h4 class=\"about-us\">¡Conoce y disfruta todas las marcas de Niu Foods!</h4></div><div class=\"box-success brands\"><img src=\"assets/success/byniu.png\" alt=\"\"> <a href=\"https://niusushi.cl/\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"cont-success\" ng-show=\"order.hasNoName\"><div class=\"box-success\"><p class=\"nominate\">Ponle nombre a este pedido para reconocerlo más fácilmente a futuro</p><form class=\"form-order\" ng-submit=\"order.setOrderName()\" _lpchecked=\"1\"><input placeholder=\"Nombre del pedido\" type=\"text\" ng-model=\"order.order.name\" class=\"form-nominate\"> <button type=\"submit\" class=\"btn btn-nominate\">Guardar nombre</button></form></div></div><div class=\"cont-success\" ng-show=\"!order.hasNoName\"><div class=\"box-success\"><p class=\"nominate\">Tu pedido ha quedado nombrado exitosamente.</p></div></div><div class=\"cont-success\"><div class=\"box-success continue-browsing\"><a ui-sref=\"main\"><span class=\"browsing\">Seguir navegando</span></a></div></div><div class=\"cont-success\" ng-if=\"order.hasTracking\"><div class=\"box-success continue-browsing\"><a ui-sref=\"tracking({orderId: order.order.id})\"><span class=\"browsing\">Consulta el estado del pedido</span></a></div></div><div class=\"cont-success\"><div class=\"box-success-tip continue-browsing\"><p><br><br>**Recuerda que la propina es voluntaria.</p></div></div></div></div>");
$templateCache.put("app/menu/mobile/latest_orders.html","<div class=\"panel-group\"><div class=\"panel-default\" id=\"{{menu.kebabCase((order.promised_time || \'\') + order.name)}}\" ng-repeat=\"order in menu.latestOrders | limitTo:5\" ng-if=\"order.seleables.length > 0\" ng-show=\"menu.myPastOrdesExpandend\"><div class=\"panel-heading latest-orders\" ng-class=\"{\'active\': order.isExpanded}\" data-toggle=\"collapse\" data-parent=\"#menu-last\" id=\"{{menu.kebabCase(order.name) + order.name}}\" aria-controls=\"{{menu.kebabCase(order.name)}}-content\" ng-click=\"menu.expandCategory(order, true)\"><div class=\"information-text\"><span class=\"date-text\">- {{order.promised_time | date:\'EEEE d/M\'}} {{order.name}}</span><div class=\"scheduled-order-text\" ng-if=\"order.scheduled && !order.promised_time_fulfilled\"><i class=\"icon-pickup-time\"></i> <span>{{order.promised_time_with_format}}</span></div></div><div class=\"icons\"><i class=\"icon icon-chevron-down\" ng-if=\"!category.isExpanded\"></i> <i class=\"icon icon-chevron-up\" ng-if=\"category.isExpanded\"></i></div></div><div id=\"{{menu.kebabCase(order.name)}}-content\" class=\"collapse\" ng-class=\"{\'in\': order.isExpanded}\" role=\"tabpanel\" aria-labelledby=\"{{menu.kebabCase(order.name) + order.name}}\"><div class=\"panel-body\" ng-if=\"order.isExpanded\"><div class=\"panel-row-body\"><div class=\"panel-col-body\" ng-repeat=\"seleable in order.seleables\"><div class=\"menu-product\"><div class=\"img-product\"><product-badge badge=\"highlight-text\" seleable=\"seleable\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.image.large}}\" ng-class=\"{\'full-size\': menu.fullSizeImg}\" alt=\"{{seleable.name}}\" ng-click=\"menu.viewSeleable(seleable, menu.kebabCase(menu.promisedTimeFormat(order.promised_time || \'\') + (order.name || \'\')), false, true)\"> <a class=\"favorite\" ng-click=\"menu.toggleLike(seleable.type, seleable.preference, seleable)\"><img ng-if=\"seleable.preference === 1\" src=\"assets/images/favorite-heart.svg\"> <img ng-if=\"seleable.preference === 0\" src=\"assets/images/favorite-heart-empty.svg\"></a></div></div><div class=\"body-product\"><div class=\"body-product-details\"><div class=\"body-product-name\"><h5>{{seleable.name}}</h5></div><div class=\"body-product-price\" ng-class=\"{\'one-line\': (!seleable.discount || !menu.cart.discountable()) && (seleable.discount || seleable.normal_price <= seleable.special_price || seleable.special_price <= 0)}\"><p class=\"discount-price\" ng-show=\"(seleable.discount && menu.cart.discountable()) || (!seleable.discount && seleable.normal_price > seleable.special_price && seleable.special_price > 0)\">{{menu.cart.discountPriceIntl(seleable.id, seleable.type)}}</p><p>{{menu.cart.priceIntl(seleable.id, true, seleable.type)}}</p></div></div><div class=\"body-add-product\"><a class=\"add-btn\" ng-class=\"{\'aggregated\': menu.cart.get(seleable.id, null, seleable.type)}\" ng-click=\"menu.addToCart(seleable, category, true)\"><img src=\"assets/images/icon-cart.svg\"></a> <small ng-click=\"menu.addToCart(seleable, category, true)\" ng-if=\"!menu.cart.get(seleable.id, null, seleable.type)\"><i class=\"icon-plus\"></i></small> <small ng-click=\"menu.addToCart(seleable, category, true)\" ng-if=\"menu.cart.get(seleable.id, null, seleable.type)\">{{menu.cart.get(seleable.id, null, seleable.type)}}</small></div></div></div></div></div><div class=\"repeat-order\"><div class=\"body-repeat-order\" ng-click=\"menu.repeatOrder(order)\"><h5>Repetir pedido completo</h5><i class=\"icon-repeat\"></i></div></div></div></div></div></div>");
$templateCache.put("app/menu/mobile/menu.html","<notice-bar-cart></notice-bar-cart><header-cart></header-cart><div class=\"container-menu\"><div id=\"panel-acordeon\" class=\"panel-acordeon\"><skeleton-screen ng-show=\"menu.isLoadingCategories\" template=\"menu-categories\" ng-if=\"menu.isMenuBase\"></skeleton-screen><skeleton-screen ng-show=\"menu.isLoadingCategories\" template=\"menu-card\" ng-if=\"menu.isMenuCategory\"></skeleton-screen><div ng-if=\"!menu.isLoadingCategories\"><div ng-if=\"menu.currentState == \'latestOrders\'\"><ng-include src=\"\'app/menu/mobile/latest_orders.html\'\"></ng-include></div><div ng-if=\"menu.currentState == \'myFavorites\'\"><div class=\"panel-group\"><div class=\"panel-default\" id=\"{{menu.kebabCase(category.name)}}\" ng-repeat=\"category in menu.myFavorites\" ng-if=\"category.seleables.length > 0\"><ng-include src=\"\'app/menu/mobile/my_favorites.html\'\"></ng-include></div></div></div><div ng-if=\"menu.currentState == \'menu\' || menu.currentState == \'menu.category\'\"><main class=\"panel-group\"><section id=\"menu-search\" class=\"panel-default\" ng-if=\"menu.search == \'true\'\"><div class=\"panel-heading\" ng-class=\"{\'active\': menu.filterExpanded}\" data-toggle=\"collapse\" data-parent=\"#menu\" id=\"menu-search-heading\" aria-controls=\"menu-search-content\" ng-click=\"menu.expandFilter()\"><i class=\"glyphicon glyphicon-search\"></i> <span ng-if=\"menu.customer.name\">{{menu.customer.name.split(\' \')[0]}},</span> {{menu.menuPlaceholderSearch}} <i class=\"icon icon-chevron-down\" ng-if=\"!menu.filterExpanded\"></i> <i class=\"icon icon-chevron-up\" ng-if=\"menu.filterExpanded\"></i></div><ng-include src=\"\'app/menu/mobile/menu_search.html\'\"></ng-include></section><section class=\"panel-default\" id=\"{{menu.kebabCase(category.name)}}\" ng-repeat=\"category in menu.myFavorites\" ng-if=\"category.seleables.length > 0\"><div class=\"panel-heading\" ng-class=\"{\'active\': category.isExpanded}\" data-toggle=\"collapse\" data-parent=\"#menu\" id=\"{{menu.kebabCase(category.name)}}-heading\" aria-controls=\"{{menu.kebabCase(category.name)}}-content\" ng-click=\"menu.expandCategory(category, true)\">{{ category.name }} <i class=\"glyphicon glyphicon-heart\"></i> <i class=\"icon icon-chevron-down\" ng-if=\"!category.isExpanded\"></i> <i class=\"icon icon-chevron-up\" ng-if=\"category.isExpanded\"></i></div><ng-include src=\"\'app/menu/mobile/my_favorites.html\'\"></ng-include></section><section class=\"panel-default\" id=\"latest-orders\" ng-show=\"menu.latestOrders.length > 0\"><div class=\"panel-heading\" ng-class=\"{\'active\': menu.myPastOrdesExpandend}\" data-toggle=\"collapse\" data-parent=\"#menu\" id=\"latest-orders-heading\" aria-controls=\"latest-orders-content\" ng-click=\"menu.expandCartPastOrders()\"><i class=\"icon-repeat\"></i> Mis pedidos anteriores <i class=\"icon icon-chevron-down\" ng-if=\"!menu.myPastOrdesExpandend\"></i> <i class=\"icon icon-chevron-up\" ng-if=\"menu.myPastOrdesExpandend\"></i></div><ng-include src=\"\'app/menu/mobile/latest_orders.html\'\"></ng-include></section><section class=\"panel-default\" id=\"{{menu.kebabCase(category.name)}}\" ng-repeat=\"category in menu.categories\" ng-if=\"category.seleables.length > 0\"><div class=\"panel-heading\" ng-class=\"{\'active\': category.isExpanded}\" data-toggle=\"collapse\" data-parent=\"#menu\" id=\"{{menu.kebabCase(category.name)}}-heading\" aria-controls=\"{{menu.kebabCase(category.name)}}-content\" ng-click=\"menu.expandCategory(category, true)\">{{ category.name }} <i class=\"icon icon-chevron-down\" ng-if=\"!category.isExpanded\"></i> <i class=\"icon icon-chevron-up\" ng-if=\"category.isExpanded\"></i></div><div id=\"{{menu.kebabCase(category.name)}}-content\" class=\"collapse\" ng-class=\"{\'in\': category.isExpanded}\" role=\"tabpanel\" aria-labelledby=\"{{menu.kebabCase(category.name) + category.name}}\"><div class=\"panel-body\" ng-if=\"category.isExpanded\"><div class=\"panel-row-body\"><div class=\"panel-col-body\" ng-repeat=\"seleable in category.seleables\"><div class=\"menu-product\"><div class=\"img-product\"><product-badge badge=\"highlight-text\" seleable=\"seleable\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.image.large}}\" ng-class=\"{\'full-size\': menu.fullSizeImg}\" alt=\"{{seleable.name}}\" ng-click=\"menu.viewSeleable(seleable, menu.kebabCase(category.name), false, true)\"> <a class=\"favorite\" ng-click=\"menu.toggleLike(seleable.type, seleable.preference, seleable)\"><img ng-if=\"seleable.preference === 1\" src=\"assets/images/favorite-heart.svg\"> <img ng-if=\"seleable.preference === 0\" src=\"assets/images/favorite-heart-empty.svg\"></a></div></div><div class=\"body-product\"><div class=\"body-product-details\"><div class=\"body-product-name\"><h5>{{seleable.name}}</h5></div><div class=\"body-product-price\" ng-class=\"{\'one-line\': (!seleable.discount || !menu.cart.discountable()) && (seleable.discount || seleable.normal_price <= seleable.special_price || seleable.special_price <= 0)}\"><p class=\"discount-price\" ng-show=\"(seleable.discount && menu.cart.discountable()) || (!seleable.discount && seleable.normal_price > seleable.special_price && seleable.special_price > 0)\">{{menu.cart.discountPriceIntl(seleable.id, seleable.type)}}</p><p>{{menu.cart.priceIntl(seleable.id, seleable.discount, seleable.type)}}</p></div></div><div class=\"body-add-product\"><a class=\"add-btn\" ng-class=\"{\'aggregated\': menu.cart.get(seleable.id, null, seleable.type)}\" ng-click=\"menu.addToCart(seleable, category)\"><img src=\"assets/images/icon-cart.svg\"></a> <small ng-click=\"menu.addToCart(seleable, category)\" ng-if=\"!menu.cart.get(seleable.id, null, seleable.type)\"><i class=\"icon-plus\"></i></small> <small ng-click=\"menu.addToCart(seleable, category)\" ng-if=\"menu.cart.get(seleable.id, null, seleable.type)\">{{menu.cart.get(seleable.id, null, seleable.type)}}</small></div></div></div></div></div></div></div></section><section id=\"menu-events\" class=\"panel-default\" ng-if=\"menu.events\"><div class=\"panel-heading\" ng-class=\"{\'active\': menu.myEventsExpandend}\" data-toggle=\"collapse\" data-parent=\"#menu\" id=\"menu-events-heading\" aria-controls=\"menu-events-content\" ng-click=\"menu.expandCartEvents()\">Eventos y Cumpleaños <i class=\"icon icon-chevron-down\" ng-if=\"!menu.myEventsExpandend\"></i> <i class=\"icon icon-chevron-up\" ng-if=\"menu.myEventsExpandend\"></i></div><ng-include src=\"\'app/menu/mobile/menu_events.html\'\"></ng-include></section></main></div></div></div><footer-cart></footer-cart></div>");
$templateCache.put("app/menu/mobile/menu.modal.html","<div class=\"modal-header-close\"><button class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"menu.close()\"><i class=\"icon-x\"></i></button></div><div class=\"modal-header\"><h2 ng-if=\"menu.customer.name\">Bienvenido,&nbsp; <span>{{menu.customer.name}} ;)</span></h2></div><div class=\"modal-body\"><div class=\"modal-menu-list\"><div class=\"modal-menu-group\"><div class=\"modal-menu-default\"><a class=\"menu-heading\" role=\"button\" ng-click=\"menu.close()\" ui-sref=\"menu.category({categoryName: \'mis-favoritos\'})\" ui-sref-opts=\"{reload: true, notify: true}\"><p class=\"favourites\">Mis favoritos</p><i class=\"glyphicon glyphicon-heart\"></i></a></div><div class=\"modal-menu-default\"><a class=\"menu-heading\" role=\"button\" ng-click=\"menu.close()\" ui-sref=\"menu.category({categoryName: \'latestOrders\'})\" ui-sref-opts=\"{reload: true, notify: true}\"><p ng-class=\"{\'current\': menu.currentCartState(menu.kebabCase(\'latestOrders\'))}\">Repetir Pedido</p></a></div><div class=\"modal-menu-default\"><a class=\"menu-heading\" role=\"button\" ng-click=\"menu.close()\" ui-sref=\"menu\" ui-sref-opts=\"{reload: true, notify: true}\"><p ng-class=\"{\'current\': menu.currentCartState(\'menu\')}\">{{menu.menuText}}</p></a></div><div class=\"modal-menu-default\"><a class=\"menu-heading\" role=\"button\" ng-click=\"menu.close()\" ui-sref=\"restaurants\" ui-sref-opts=\"{reload: true, notify: true}\"><p ng-class=\"{\'current\': menu.currentMenuState(\'restaurants\')}\">{{menu.restaurantText}}</p></a></div><div class=\"modal-menu-default\"><a class=\"menu-heading\" role=\"button\" ng-click=\"menu.close()\" ui-sref=\"profile\" ui-sref-opts=\"{reload: true, notify: true}\"><p ng-class=\"{\'current\': menu.currentMenuState(\'profile\')}\">Mi Perfil</p></a></div><div class=\"modal-menu-default\"><a class=\"menu-heading\" role=\"button\" ng-click=\"menu.close()\" ui-sref=\"client-contact\" ui-sref-opts=\"{reload: true, notify: true}\"><p ng-class=\"{\'current\': menu.currentMenuState(\'client-contact\')}\">Contáctanos</p></a></div><div class=\"modal-menu-default\" ng-if=\"menu.faq === \'true\'\"><a class=\"menu-heading\" role=\"button\" ng-click=\"menu.close()\" ui-sref=\"faq\" ui-sref-opts=\"{reload: true, notify: true}\"><p ng-class=\"{\'current\': menu.currentMenuState(\'faq\')}\">Preguntas Frecuentes</p></a></div><div class=\"modal-menu-default\" ng-if=\"menu.hasGenerateReceipt\"><a class=\"menu-heading\" role=\"button\" ng-click=\"menu.close()\" ui-sref=\"ticketReceipts\" ui-sref-opts=\"{reload: true, notify: true}\"><p ng-class=\"{\'current\': menu.currentMenuState(\'ticketReceipts\')}\">Facturación</p></a></div></div><ul class=\"modal-menu-footer\"><li class=\"default\"><a href=\"{{menu.facebook_url}}\" target=\"_blank\" class=\"facebook\" ng-click=\"menu.close()\"><img class=\"footer-facebook\" src=\"assets/images/icon-facebook.svg\"></a></li><li class=\"default\"><a href=\"{{menu.instagram_url}}\" target=\"_blank\" class=\"instagram\" ng-click=\"menu.close()\"><img class=\"footer-instagram\" src=\"assets/images/icon-instagram.svg\"></a></li><li class=\"default\"><a href=\"{{menu.tiktok_url}}\" target=\"_blank\" class=\"tiktok\" ng-click=\"menu.close()\"><img class=\"footer-tiktok\" src=\"assets/images/icon-tiktok.svg\"></a></li></ul></div></div>");
$templateCache.put("app/menu/mobile/menu_events.html","<div class=\"panel-default\"><div id=\"eventos-y-cumpleanos-content\" class=\"panel-collapse collapse\" ng-class=\"{\'in\': menu.myEventsExpandend}\" role=\"tabpanel\" aria-labelledby=\"eventos-y-cumpleanos\"><div class=\"panel-body\" ng-if=\"menu.myEventsExpandend\"><div class=\"panel-row-body\"><div class=\"panel-col-body events\"><div class=\"container-events\"><div class=\"container-banner\"><div class=\"description-banner\"><p>Elige tu pedido y pídelo al menos con 24 horas de anticipación.</p></div><div class=\"banner-event\"><div class=\"content\"><img src=\"{{menu.bannerEvent}}\" alt=\"Banner event\"></div></div></div><div class=\"container-options\" ng-repeat=\"event in menu.eventData\"><div class=\"product-image\" ng-click=\"menu.viewEvent(event.code)\"><div class=\"content\"><img src=\"{{event.imageUrl}}\" alt=\"{{event.name}}\"></div></div><div class=\"product-detail\" ng-click=\"menu.viewEvent(event.code)\"><strong>{{event.name}}</strong> <span>{{event.piecesQty}}</span><p>$ {{event.finalPrice}}</p><a>Ver pedido</a></div></div><div class=\"container-footer\"><div class=\"container-text\"><p>Si quieres hacer pedidos más grandes, mándanos tus requerimientos y lo cotizamos para ti. Escríbenos a <a href=\"mailto:niusushi@niusushi.cl\">niusushi@niusushi.cl</a>.</p></div></div></div></div></div></div></div></div>");
$templateCache.put("app/menu/mobile/menu_search.html","<div class=\"panel-default\" ng-show=\"menu.filterExpanded\"><div class=\"panel-collapse collapse in\" role=\"tabpanel\"><div class=\"panel-body tag-filter\"><div class=\"tag-filter-title\"><h3>¿Qué ingrediente quieres? (o cuál no &#128586;)</h3></div><div class=\"tag-filter-container\"><input id=\"input-tag-filter\" type=\"text\" ng-class=\"{\'has-tags\': menu.hasTags}\" ng-model=\"menu.tagText\" placeholder=\"{{menu.tagPlaceholder}}\" ng-keydown=\"menu.updateTags($event)\" autofocus=\"\"><div class=\"input-tag-container\"><span class=\"input-tag\" ng-repeat=\"(key, tag) in tags\"><span class=\"text-tag\">{{ tag }}</span> <span class=\"delete-tag\" ng-click=\"menu.deleteTag(key)\">&times;</span></span></div></div><div class=\"panel-row-body\"><div class=\"panel-col-body\" ng-repeat=\"seleable in menu.getCategories(menu)\"><div class=\"menu-product\"><div class=\"img-product\"><product-badge badge=\"highlight-text\" seleable=\"seleable\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.image.large}}\" ng-class=\"{\'full-size\': menu.fullSizeImg}\" alt=\"{{seleable.name}}\" ng-click=\"menu.viewSeleable(seleable, \'searchMenu\', false, true)\"> <a class=\"favorite\" ng-click=\"menu.toggleLike(seleable.type, seleable.preference, seleable)\"><img ng-if=\"seleable.preference === 1\" src=\"assets/images/favorite-heart.svg\"> <img ng-if=\"seleable.preference === 0\" src=\"assets/images/favorite-heart-empty.svg\"></a></div></div><div class=\"body-product\"><div class=\"body-product-details\"><div class=\"body-product-name\"><h5>{{seleable.name}}</h5></div><div class=\"body-product-price\" ng-class=\"{\'one-line\': (!seleable.discount || !menu.cart.discountable()) && (seleable.discount || seleable.normal_price <= seleable.special_price || seleable.special_price <= 0)}\"><p class=\"discount-price\" ng-show=\"(seleable.discount && menu.cart.discountable()) || (!seleable.discount && seleable.normal_price > seleable.special_price && seleable.special_price > 0)\">{{menu.cart.discountPriceIntl(seleable.id, seleable.type)}}</p><p>{{menu.cart.priceIntl(seleable.id, true, seleable.type)}}</p></div></div><div class=\"body-add-product\"><a class=\"add-btn\" ng-class=\"{\'aggregated\': menu.cart.get(seleable.id, null, seleable.type)}\" ng-click=\"menu.addToCart(seleable, category)\"><img src=\"assets/images/icon-cart.svg\"></a> <small ng-click=\"menu.addToCart(seleable, category)\" ng-if=\"!menu.cart.get(seleable.id, null, seleable.type)\"><i class=\"icon-plus\"></i></small> <small ng-click=\"menu.addToCart(seleable, category)\" ng-if=\"menu.cart.get(seleable.id, null, seleable.type)\">{{menu.cart.get(seleable.id, null, seleable.type)}}</small></div></div></div></div></div></div></div></div>");
$templateCache.put("app/menu/mobile/my_favorites.html","<div id=\"{{menu.kebabCase(category.name)}}-content\" class=\"collapse\" ng-class=\"{\'in\': category.isExpanded}\" role=\"tabpanel\" aria-labelledby=\"{{menu.kebabCase(category.name) + category.name}}\"><div class=\"panel-body\"><div class=\"panel-row-body\"><div class=\"panel-col-body\" ng-repeat=\"seleable in category.seleables\" ng-if=\"$index < 10\"><div class=\"menu-product\"><div class=\"img-product\"><product-badge badge=\"highlight-text\" seleable=\"seleable\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.image.large}}\" ng-class=\"{\'full-size\': menu.fullSizeImg}\" alt=\"{{seleable.name}}\" ng-click=\"menu.viewSeleable(seleable, menu.kebabCase(category.name), false, true)\"> <a class=\"favorite\" ng-click=\"menu.toggleLike(seleable.type, seleable.preference, seleable)\"><img ng-if=\"seleable.preference === 1\" src=\"assets/images/favorite-heart.svg\"> <img ng-if=\"seleable.preference === 0\" src=\"assets/images/favorite-heart-empty.svg\"></a></div></div><div class=\"body-product\"><div class=\"body-product-details\"><div class=\"body-product-name\"><h5>{{seleable.name}}</h5></div><div class=\"body-product-price\" ng-class=\"{\'one-line\': (!seleable.discount || !menu.cart.discountable()) && (seleable.discount || seleable.normal_price <= seleable.special_price || seleable.special_price <= 0)}\"><p class=\"discount-price\" ng-show=\"(seleable.discount && menu.cart.discountable()) || (!seleable.discount && seleable.normal_price > seleable.special_price && seleable.special_price > 0)\">{{menu.cart.discountPriceIntl(seleable.id, seleable.type)}}</p><p>{{menu.cart.priceIntl(seleable.id, true, seleable.type)}}</p></div></div><div class=\"body-add-product\"><a class=\"add-btn\" ng-class=\"{\'aggregated\': menu.cart.get(seleable.id, null, seleable.type)}\" ng-click=\"menu.addToCart(seleable, category)\"><img src=\"assets/images/icon-cart.svg\"></a> <small ng-click=\"menu.addToCart(seleable, category)\" ng-if=\"!menu.cart.get(seleable.id, null, seleable.type)\"><i class=\"icon-plus\"></i></small> <small ng-click=\"menu.addToCart(seleable, category)\" ng-if=\"menu.cart.get(seleable.id, null, seleable.type)\">{{menu.cart.get(seleable.id, null, seleable.type)}}</small></div></div></div></div></div></div></div>");
$templateCache.put("app/order/mobile/order.fail.html","<div class=\"order-fail\"><div class=\"container-fail\"><div class=\"cont-fail\"><div class=\"box-fail\"><div class=\"box-img\"><img src=\"assets/success/{{$environment}}/img/super.svg\" alt=\"\"></div></div></div><div class=\"cont-fail\"><div class=\"box-fail\"><h4 class=\"order-name\"><p class=\"name\">¡{{order.customer.name.split(\' \')[0]}}, <span class=\"order\">tu pedido a fallado!</span></p></h4></div></div><div class=\"cont-fail\" ng-if=\"customerSession.showAllBrands()\"><div class=\"box-fail\"><h4 class=\"about-us\">¡Conoce y disfruta todas las marcas de Niu Foods!</h4></div><div class=\"box-fail center\"><img src=\"assets/success/byniu.png\" alt=\"\"></div><div class=\"box-fail brands\"><a href=\"https://niusushi.cl/\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"cont-fail\"><div class=\"box-fail continue-browsing\"><a ui-sref=\"main\"><span class=\"browsing\">Volver a pedir</span></a></div></div></div></div>");
$templateCache.put("app/order/mobile/order.success.html","<div class=\"order-success\"><div class=\"container-success\"><div class=\"cont-success\"><div class=\"box-success\"><div class=\"box-img\"><img src=\"assets/success/{{$environment}}/img/super.svg\" alt=\"\"></div></div></div><div class=\"cont-success\"><div class=\"box-success\"><h4 class=\"order-name\"><p class=\"name\">¡{{order.customer.name.split(\' \')[0]}}, <span class=\"order\">tu pedido fue recibido con éxito!</span></p></h4><div class=\"mailing\"><p class=\"email\">Te enviamos confirmación a tu email {{order.customer.email}} y <b>{{order.deliveryTimeMessage}}</b> estará <span ng-if=\"order.order.order_type === \'Retiro\'\">listo para retiro en <b>{{order.restaurant.address}}</b>.</span> <span ng-if=\"order.order.order_type === \'Delivery\'\">siendo entregado en tu domicilio.</span><br><br>En caso que tengamos alguna duda te contactaremos, por favor ten tu teléfono a mano.<br><br></p><div class=\"payment\"><h2 class=\"title\">Resumen del pedido:</h2><div class=\"payment-detail\"><p><span class=\"principal\">N° de orden</span> <span class=\"secondary\">: {{order.order.id}}</span></p><p><span class=\"principal\">Total</span> <span class=\"secondary\">: {{order.cart.parseIntl(order.order.total_to_pay)}}</span></p><p><span class=\"principal\">Tipo de pedido</span> <span class=\"secondary\">: {{order.order.order_type}}</span></p><p><span class=\"principal\">Método de pago</span> <span class=\"secondary\">: {{order.paymentType}}</span></p></div></div><div ng-if=\"order.order.webpayment\" class=\"payment\"><h2 class=\"title\">Detalle Webpay:</h2><div class=\"payment-detail\"><p><span class=\"principal\">Transacción</span> <span class=\"secondary\">: {{order.order.webpayment.order_num}}</span></p><p><span class=\"principal\">Monto</span> <span class=\"secondary\">: {{order.cart.parseIntl(order.order.total_to_pay)}}</span></p><p><span class=\"principal\">Fecha</span> <span class=\"secondary\">: {{order.order.date | date:\'dd/MM/yyyy\'}}</span></p><p><span class=\"principal\">Tarjeta</span> <span class=\"secondary\">: xxxx-xxxx-xxxx-{{order.order.webpayment.last4CardDigits}}</span></p></div></div></div><div class=\"restaurant\"><div class=\"restaurant-icon\"><img src=\"assets/success/{{$environment}}/img/tienda.png\" alt=\"\"></div><div class=\"restaurant-info\"><p class=\"name\">{{order.restaurant.name}}</p><a href=\"tel:{{order.restaurant.phones[0]}}\"><p class=\"phones\">{{order.restaurant.phones[0]}}</p></a></div></div></div></div><div class=\"cont-success\" ng-if=\"customerSession.showAllBrands()\"><div class=\"box-success\"><h4 class=\"about-us\">¡Conoce y disfruta todas las marcas de Niu Foods!</h4></div><div class=\"box-success center\"><img src=\"assets/success/byniu.png\" alt=\"\"></div><div class=\"box-success brands\"><a href=\"https://niusushi.cl/\" target=\"_blank\"><img src=\"assets/success/niu.svg\" alt=\"\"></a> <a href=\"https://guacamole.cl\" target=\"_blank\"><img src=\"assets/success/guacamole.svg\" alt=\"\"></a></div></div><div class=\"cont-success\" ng-show=\"order.hasNoName\"><div class=\"box-success\"><p class=\"nominate\">Ponle nombre a este pedido para reconocerlo más fácilmente a futuro</p><form class=\"form-order\" ng-submit=\"order.setOrderName()\" _lpchecked=\"1\"><input placeholder=\"Nombre del pedido\" type=\"text\" ng-model=\"order.order.name\" class=\"form-nominate\"> <button type=\"submit\" class=\"btn btn-nominate\">Guardar nombre</button></form></div></div><div class=\"cont-success\" ng-show=\"!order.hasNoName\"><div class=\"box-success\"><p class=\"nominate\">Tu pedido ha quedado nombrado exitosamente.</p></div></div><div class=\"cont-success\"><div class=\"box-success continue-browsing\"><a ui-sref=\"main\"><span class=\"browsing\">Seguir navegando</span></a></div></div><div class=\"cont-success\" ng-if=\"order.hasTracking\"><div class=\"box-success continue-browsing\"><a ui-sref=\"tracking({orderId: order.order.id})\"><span class=\"browsing\">Consulta el estado del pedido</span></a></div></div><div class=\"cont-success\"><div class=\"box-success-tip continue-browsing\"><p><br><br>**Recuerda que la propina es voluntaria.</p></div></div></div></div>");
$templateCache.put("app/payment/desktop/process-payment.fail_new.html","<div class=\"order-success\"><div ng-if=\"payment.isAmipass\" class=\"container-success\"><div class=\"cont-success\"><div class=\"box-success\"><div class=\"box-img\"><img src=\"assets/success/{{$environment}}/img/super.svg\" alt=\"\"></div></div></div><div class=\"cont-success\"><div class=\"box-success\"><h4 class=\"order-name\"><p class=\"name\">Tu pago con <strong>{{ payment.paymentMethod }}</strong> ha sido <span class=\"order\">{{ payment.isError ? \'rechazado 😢\' : \'procesado correctamente ❣️\' }}</span></p></h4><div class=\"mailing\"><p class=\"email\"><strong>Detalle:</strong></p><br><p class=\"email\">Monto: {{ payment.amount | currency:\'$\':0 }}</p><p class=\"email\" ng-if=\"payment.isError\">Lo sentimos, la transacción no fue exitosa. Por favor, intenta nuevamente.</p><p class=\"email\" ng-if=\"!payment.isError\">Tu pago fue procesado correctamente.</p></div></div></div><div class=\"cont-success\"><div class=\"box-success continue-browsing\"><a ui-sref=\"checkout\"><span class=\"browsing\">{{ payment.isError ? \"Intentar nuevamente\" : \"Seguir navegando\" }}</span></a></div></div></div><div ng-if=\"!payment.isAmipass\" ng-init=\"data = payment.data\" class=\"container-success\"><div class=\"cont-success\"><div class=\"box-success\"><div class=\"box-img\"><img src=\"assets/success/{{$environment}}/img/super.svg\" alt=\"\"></div></div></div><div class=\"cont-success\"><div class=\"box-success\"><h4 class=\"order-name\"><p class=\"name\">{{data.customer.name}}, tu pedido ha sido <span class=\"order\">rechazado 😢</span></p><br><br></h4><div class=\"mailing\"><p class=\"email\"><strong>Detalle:</strong></p><br><p class=\"email\" ng-if=\"data.formatted_amount\">Monto: {{data.formatted_amount}}</p><p class=\"email\">Motivo: {{data.reason}}</p><p class=\"email\" ng-if=\"!data.isProductError\">Lo sentimos, la transacción no fue exitosa. Por favor, intenta nuevamente.</p><p class=\"email\" ng-if=\"data.isProductError\">Este producto no estará disponible para la fecha seleccionada. Por favor, elige otro producto.</p></div></div></div><div class=\"cont-success\"><div class=\"box-success continue-browsing\"><a ui-sref=\"checkout\"><span class=\"browsing\">{{ data.isProductError ? \"Cambiar producto\" : \"Inténtalo nuevamente\" }}</span></a></div></div></div></div>");
$templateCache.put("app/payment/desktop/process-payment.success_new.html","<div ng-init=\"data = payment.data\" class=\"order-success\"><div class=\"container-success\"><div class=\"cont-success\"><div class=\"box-success\"><div class=\"box-img\"><img src=\"assets/success/{{$environment}}/img/super.svg\" alt=\"\"></div></div></div><div class=\"cont-success\"><div class=\"box-success\"><h4 class=\"order-name\"><p class=\"name\">¡Hola {{data.customer.name}}, <span class=\"order\">Hemos recibido tu pedido! ❣️</span></p></h4><div class=\"mailing\"><p class=\"email\">Ya enviamos los detalles a {{data.customer.email}}. En aprox <b>{{data.order.remaining_minutes}} minutos</b>: tu pedido <span ng-if=\"data.order.order_type === \'Retiro\'\">estará listo en <b>{{data.order.restaurant.address}}</b> para que lo recojas.</span> <span ng-if=\"data.order.order_type === \'Delivery\'\">llegará a <b>{{data.order.delivery.address}}</b>.</span> Si necesitamos más detalles, te llamaremos. ¡Gracias por tu preferencia! Y recuerda, la propina es voluntaria.</p><br><br><br><div><p class=\"email\"><strong>Detalle de pago:</strong></p><br><p class=\"email\">Código de order: {{data.order.id}}<br>Número de transacción: {{data.transaction_info.id}}<br>Monto pagado: {{data.formatted_amount}}<br>Fecha de compra: {{data.transaction_info.date | date:\'dd/MM/yyyy\'}}<br>Tarjeta terminada en: {{data.payment_card.last_four_digits}}<br>Tipo de pago: {{data.transaction_info.payment_type}}<br>Número de cuotas: {{data.transaction_info.quota_number}}</p><p class=\"email\" ng-if=\"data.transaction_info.quota_number >= 1\">Monto de cuota: {{data.transaction_info.quota_amount}}</p></div></div><div class=\"restaurant\"><div class=\"restaurant-info\"><img src=\"assets/success/{{$environment}}/img/tienda.png\" alt=\"\"></div><div class=\"restaurant-info\"><p class=\"name\"><b>{{data.restaurant.name}}</b></p></div><div class=\"restaurant-info\"><img src=\"assets/success/{{$environment}}/img/telefono.png\" alt=\"\"></div><div class=\"restaurant-info\"><a href=\"tel:{{data.restaurant.phones[0]}}\"><p class=\"phones\">¿Tienes dudas? Llámanos al {{data.restaurant.phones[0]}}.</p></a></div></div></div></div><div class=\"cont-success\"><div class=\"box-success continue-browsing\"><a ui-sref=\"main\"><span class=\"browsing\">Seguir navegando</span></a></div></div></div></div>");
$templateCache.put("app/payment-redirect/mobile/payment.redirect.html","<!DOCTYPE html><html lang=\"es\"><head><meta charset=\"UTF-8\"><title>Finalizando pago</title><meta name=\"viewport\" content=\"width=device-width, initial-scale=1\"><style>\n        body {\n            margin: 0;\n            height: 100vh;\n            font-family: system-ui, -apple-system, BlinkMacSystemFont, \'Segoe UI\', sans-serif;\n            background: #f8f8f8;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n\n        .card {\n            background: #fff;\n            width: 100%;\n            max-width: 360px;\n            padding: 32px 24px;\n            border-radius: 12px;\n            text-align: center;\n            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n        }\n\n        .icon {\n            font-size: 56px;\n            margin-bottom: 16px;\n        }\n\n        .icon.success {\n            color: #2e7d32;\n        }\n\n        .icon.error {\n            color: #d32f2f;\n        }\n\n        h1 {\n            font-size: 20px;\n            margin: 0 0 8px;\n            color: #111;\n        }\n\n        p {\n            font-size: 14px;\n            color: #666;\n            margin: 0 0 24px;\n        }\n\n        button {\n            width: 100%;\n            background: #d32f2f;\n            color: #fff;\n            border: none;\n            padding: 14px;\n            font-size: 15px;\n            border-radius: 8px;\n            cursor: pointer;\n        }\n\n        button:active {\n            opacity: 0.9;\n        }\n    </style></head><body><div class=\"card\"><div class=\"icon\" ng-class=\"{ success: redirect.isSuccess, error: redirect.isError }\">{{ redirect.isSuccess ? \'✅\' : \'⚠️\' }}</div><h1>{{ redirect.isSuccess ? \'¡Pago confirmado!\' : \'No pudimos confirmar el pago\' }}</h1><p>{{ redirect.isSuccess ? \'Toca el botón para volver a la app.\' : \'Vuelve a la app para revisar el estado de tu pedido.\' }}</p><button ng-click=\"redirect.openApp()\">Volver a la app</button></div></body></html>");
$templateCache.put("app/payment-redirect/desktop/payment.redirect.html","<!DOCTYPE html><html lang=\"es\"><head><meta charset=\"UTF-8\"><title>Finalizando pago</title><meta name=\"viewport\" content=\"width=device-width, initial-scale=1\"><style>\n        body {\n            margin: 0;\n            height: 100vh;\n            font-family: system-ui, -apple-system, BlinkMacSystemFont, \'Segoe UI\', sans-serif;\n            background: #f8f8f8;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n\n        .card {\n            background: #fff;\n            width: 100%;\n            max-width: 360px;\n            padding: 32px 24px;\n            border-radius: 12px;\n            text-align: center;\n            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n        }\n\n        .icon {\n            font-size: 56px;\n            margin-bottom: 16px;\n        }\n\n        .icon.success {\n            color: #2e7d32;\n        }\n\n        .icon.fail {\n            color: #d32f2f;\n        }\n\n        h1 {\n            font-size: 20px;\n            margin: 0 0 8px;\n            color: #111;\n        }\n\n        p {\n            font-size: 14px;\n            color: #666;\n            margin: 0 0 24px;\n        }\n\n        button {\n            width: 100%;\n            background: #d32f2f;\n            color: #fff;\n            border: none;\n            padding: 14px;\n            font-size: 15px;\n            border-radius: 8px;\n            cursor: pointer;\n        }\n\n        button:active {\n            opacity: 0.9;\n        }\n    </style></head><body ng-controller=\"PaymentRedirectController as redirect\"><div class=\"card\"><div class=\"icon\" ng-class=\"{ success: redirect.isSuccess, fail: redirect.isFail }\">{{ redirect.isSuccess ? \'✅\' : \'⚠️\' }}</div><h1>{{ redirect.isSuccess ? \'¡Pago confirmado!\' : \'No pudimos confirmar el pago\' }}</h1><p>{{ redirect.isSuccess ? \'En unos segundos volverás a la app.\' : \'Vuelve a la app para revisar el estado de tu pedido.\' }}</p><button ng-click=\"redirect.openApp()\">Volver a la app</button></div></body></html>");
$templateCache.put("app/payment/mobile/process-payment.fail_new.html","<div class=\"order-success\"><div ng-if=\"payment.isAmipass\" class=\"container-success\"><div class=\"cont-success\"><div class=\"box-success\"><div class=\"box-img\"><img src=\"assets/success/{{$environment}}/img/super.svg\" alt=\"\"></div></div></div><div class=\"cont-success\"><div class=\"box-success\"><h4 class=\"order-name\"><p class=\"name\">Tu pago con <strong>{{ payment.paymentMethod }}</strong> ha sido <span class=\"order\">rechazado 😢</span></p><br><br></h4><div class=\"mailing\"><p class=\"email\"><strong>Detalle:</strong></p><br><p class=\"email\">Monto: {{ payment.amount | currency:\'$\':0 }}</p><p class=\"email\">Lo sentimos, la transacción no fue exitosa. Por favor, intenta nuevamente.</p></div></div></div><div class=\"cont-success\"><div class=\"box-success continue-browsing\"><a ui-sref=\"checkout\"><span class=\"browsing\">Intentar nuevamente</span></a></div></div></div><div ng-if=\"!payment.isAmipass\" ng-init=\"data = payment.data\" class=\"container-success\"><div class=\"cont-success\"><div class=\"box-success\"><div class=\"box-img\"><img src=\"assets/success/{{$environment}}/img/super.svg\" alt=\"\"></div></div></div><div class=\"cont-success\"><div class=\"box-success\"><h4 class=\"order-name\"><p class=\"name\">{{data.customer.name}}, tu pedido ha sido <span class=\"order\">Rechazado 😢</span></p><br><br></h4><div class=\"mailing\"><p class=\"email\"><strong>Detalle:</strong></p><br><p class=\"email\" ng-if=\"data.formatted_amount\">Monto: {{data.formatted_amount}}</p><p class=\"email\">Motivo: {{data.reason}}</p><p class=\"email\" ng-if=\"!data.isProductError\">Lo sentimos, la transacción no fue exitosa. Por favor, intenta nuevamente.</p><p class=\"email\" ng-if=\"data.isProductError\">Este producto no estará disponible para la fecha seleccionada. Por favor, elige otro producto.</p></div></div></div><div class=\"cont-success\"><div class=\"box-success continue-browsing\"><a ui-sref=\"checkout\"><span class=\"browsing\">{{ data.isProductError ? \"Cambiar producto\" : \"Inténtalo nuevamente\" }}</span></a></div></div></div></div>");
$templateCache.put("app/payment/mobile/process-payment.success_new.html","<div ng-init=\"data = payment.data\" class=\"order-success\"><div class=\"container-success\"><div class=\"cont-success\"><div class=\"box-success\"><div class=\"box-img\"><img src=\"assets/success/{{$environment}}/img/super.svg\" alt=\"\"></div></div></div><div class=\"cont-success\"><div class=\"box-success\"><h4 class=\"order-name\"><p class=\"name\">¡Hola {{data.customer.name}}! <span class=\"order\">Hemos recibido tu pedido! ❣️</span></p></h4><div class=\"mailing\"><p class=\"email\">Ya enviamos los detalles a {{data.customer.email}}. En aprox <b>{{data.order.remaining_minutes}} minutos</b>: tu pedido <span ng-if=\"data.order.order_type === \'Retiro\'\">estará listo en <b>{{data.order.restaurant.address}}</b> para que lo recojas.</span> <span ng-if=\"data.order.order_type === \'Delivery\'\">llegará a {{data.order.delivery.address}}.</span> Si necesitamos más detalles, te llamaremos. ¡Gracias por tu preferencia! Y recuerda, la propina es voluntaria.</p><br><br><br><div><p class=\"email\"><strong>Detalle de pago:</strong></p><br><p class=\"email\">Código de order: {{data.order.id}}<br>Número de transacción: {{data.transaction_info.id}}<br>Monto pagado: {{data.formatted_amount}}<br>Fecha de compra: {{data.transaction_info.date | date:\'dd/MM/yyyy\'}}<br>Tarjeta terminada en: {{data.payment_card.last_four_digits}}<br>Tipo de pago: {{data.transaction_info.payment_type}}<br>Número de cuotas: {{data.transaction_info.quota_number}}</p><p class=\"email\" ng-if=\"data.transaction_info.quota_number > 0\">Monto de cuota: {{data.transaction_info.quota_amount}}</p></div></div><div class=\"restaurant\"><div class=\"restaurant-info\"><img src=\"assets/success/{{$environment}}/img/tienda.png\" alt=\"\"></div><div class=\"restaurant-info\"><p class=\"name\"><b>{{data.order.restaurant.name}}</b></p></div><div class=\"restaurant-info\"><img src=\"assets/success/{{$environment}}/img/telefono.png\" alt=\"\"></div><div class=\"restaurant-info\"><a href=\"tel:{{data.order.restaurant.phones[0]}}\"><p class=\"phones\">¿Tienes dudas? Llámanos al {{data.order.restaurant.phones[0]}}.</p></a></div></div></div></div><div class=\"cont-success\"><div class=\"box-success continue-browsing\"><a ui-sref=\"main\"><span class=\"browsing\">Seguir navegando</span></a></div></div></div></div>");
$templateCache.put("app/profile/desktop/logout.html","<div class=\"container-login user-login\"><div class=\"modal-header\"><div class=\"container-perfil\"><div class=\"name-user\"><p>¡Bienvenido,<br>{{profile.info.name}}!</p></div><a ui-sref=\"profile\"><i class=\"icon-persona\"></i><p>Mi Perfil</p></a> <a ng-click=\"profile.signOut()\" class=\"exit\"><img src=\"assets/images/desktop/cerrar.png\" alt=\"cerrar\"><p>Salir</p></a></div></div></div>");
$templateCache.put("app/profile/desktop/profile.html","<header-cart></header-cart><div class=\"container-profile\"><div class=\"profile\"><div class=\"box-profile\"><div class=\"profile-name\"><p>Tu perfil, <span class=\"highlight\">{{profile.info.name}} ;)</span></p></div><div class=\"profile-form\"><form name=\"form\" ng-submit=\"profile.saveProfile(profile.info)\"><div class=\"form-element\"><label class=\"form-label\">Mi nombre <small>*</small></label> <input name=\"name\" type=\"text\" class=\"form-input\" ng-model=\"profile.info.name\" required=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Mi género</label><div class=\"form-checkbox-inline\"><div class=\"form-checkbox-text\" ng-repeat=\"gender in profile.genders\"><input id=\"gender-{{gender}}\" name=\"gender\" type=\"radio\" ng-model=\"profile.info.gender\" ng-value=\"gender\"> <label for=\"gender-{{gender}}\" class=\"button-select gender\"><div class=\"checkbox-label\"><span>{{gender}}</span></div></label></div></div></div><div class=\"form-element\"><label class=\"form-label\">Mi cumpleaños <small>*</small></label> <input type=\"text\" class=\"form-input\" ng-focus=\"profile.info.birthdateFocus = true\" ng-model=\"profile.info.birthdate\" uib-datepicker-popup=\"dd-MMMM-yyyy\" show-button-bar=\"false\" is-open=\"profile.info.birthdateFocus\"></div><div class=\"form-element\"><label class=\"form-label\">Mi email <small>*</small></label> <input name=\"email\" class=\"form-input\" type=\"email\" ng-model=\"profile.info.email\" disabled=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Mi número <small>*</small></label><div class=\"form-phones\"><phone-select number=\"profile.phones[0]\" btn-submit-id=\"submit-perfil\" model=\"profile.phones[0].prefix\" object=\"profile\" form-name=\"form\" class=\"phone-component\" disabled=\"true\"></phone-select></div></div><div class=\"form-button\"><button class=\"btn btn-submit-perfil\" id=\"submit-perfil\" type=\"submit\" ng-disabled=\"form.$invalid\">Guardar perfil</button></div></form></div></div><div class=\"box-profile\"><div class=\"profile-controls\"><div class=\"add-address\"><a ng-click=\"profile.newAddressModal(false)\">Agregar dirección <span>+</span></a></div><div class=\"login-controls\"><a class=\"highlight\" ui-sref=\"logout\">Cerrar sesión</a></div></div><div class=\"address\"><div class=\"address-checkbox\" ng-repeat=\"address in profile.addresses\"><input id=\"address-{{$index}}\" name=\"address\" type=\"radio\" ng-model=\"profile.selectedAddress\" ng-value=\"address\"> <label for=\"address-{{$index}}\" class=\"button-select address\"><div class=\"checkbox-label address\"><span ng-show=\"address.address\">{{address.street_name}} #{{address.street_number}} <span class=\"specific-number\" ng-if=\"address.specific_number\">, {{address.specific_number}}</span></span> <small>{{address.comune_name}}</small> <a ng-click=\"profile.deactivateAddress(address)\"><i class=\"icon-x\"></i></a></div></label></div></div><div class=\"payment\"><div class=\"payment-info\"><p>Mis medios de pago</p><small ng-if=\"profile.onlinePayment && !profile.tbkUsers.length > 0\">Añade tu tarjeta de crédito con webpay oneclick desde el checkout</small> <small ng-if=\"profile.kushkiPayment && !profile.paymentCards.length > 0\">Añade tu tarjeta de crédito con kushki desde el checkout</small></div><div class=\"payment-checkbox\" ng-repeat=\"tbkUser in profile.tbkUsers\" ng-if=\"profile.onlinePayment && profile.tbkUsers.length > 0\"><input id=\"tbkuser-{{$index}}\" name=\"tbkuser\" type=\"radio\" ng-value=\"tbkuser\"> <label class=\"button-select payment\" for=\"tbkuser-{{$index}}\"><div class=\"checkbox-label payment\"><span>Webpay Oneclick</span> <small>Tarjeta nro</small> <small>XXXX.XXXX.XXXX.{{tbkUser.last_4_card_digits}}</small></div><div class=\"checkbox-label payment-action\"><a id=\"tbkuser-{{$index}}-deactivate-card\" ng-click=\"profile.deactivateCard(tbkUser, $index)\"><i class=\"icon-x payment\"></i></a><div id=\"tbkuser-{{$index}}-loader\" class=\"hidden\"><loader template=\"ring\"><loader></loader></loader></div></div></label></div><div class=\"payment-checkbox\" ng-repeat=\"card in profile.paymentCards\" ng-if=\"profile.kushkiPayment && profile.paymentCards.length > 0\"><input id=\"kushki-{{$index}}\" name=\"kushki\" type=\"radio\" value=\"{{card.token}}\"> <label class=\"button-select payment\" for=\"kushki-{{$index}}\"><div class=\"checkbox-label payment\"><span>Kushki</span> <small>{{profile.cart.cardTypeName(card.payment_brand)}}</small> <small>XXXX.XXXX.XXXX.{{card.card_last_four}}</small> <a ng-click=\"profile.kushki.kushkiDeleteSubscribedCard(card)\"><i class=\"icon-x payment\"></i></a></div></label></div></div><div class=\"coupon\"><div class=\"coupon-info\"><p>Cupones de descuento</p></div><div class=\"coupon-checkbox\" ng-repeat=\"customer_coupon in profile.coupon.coupons\"><input id=\"coupon-customer-{{$index}}\" name=\"coupon-customer\" type=\"radio\" ng-model=\"profile.coupon.currentCustomerCouponId\" ng-value=\"customer_coupon.id\"> <label for=\"coupon-customer-{{$index}}\" class=\"button-select coupon\" ng-click=\"profile.coupon.activateCoupon(customer_coupon.id)\"><div class=\"checkbox-label coupon\"><span>{{customer_coupon.coupon.code}}</span> <small>{{customer_coupon.coupon.caption}}.</small> <small>Válido hasta: {{(customer_coupon.coupon.expiration_date | date:\'dd/MM/yyyy\') || \"-\"}}</small></div></label></div><div class=\"box-coupon\"><input class=\"input-coupon\" name=\"coupon\" maxlength=\"50\" autocomplete=\"off\" placeholder=\"Código de tu cupón de descuento\" required=\"\" type=\"text\" ng-model=\"profile.coupon.code\"> <button class=\"btn btn-coupon\" ng-click=\"profile.coupon.applyCoupon(true)\" ng-disabled=\"!profile.coupon.code\">Aplicar</button></div></div></div></div><footer-cart></footer-cart></div>");
$templateCache.put("app/promos/mobile/promoqr.html","<header-cart></header-cart><div class=\"promoqr-menu\"><img class=\"promoqr-menu-img\" src=\"assets/images/promos/{{$environment}}-promoqr.webp\" ui-sref=\"menu\"></div><footer-cart></footer-cart>");
$templateCache.put("app/receipts/desktop/generate-ticket-receipt.html","<header-cart></header-cart><div class=\"generate-ticket-receipt\"><div class=\"generate-ticket-receipt-container\" ng-show=\"!receipt.checkTicketSuccess\"><div class=\"generate-ticket-receipt-title\"><h2>Facturar Ticket</h2></div><div class=\"generate-ticket-receipt-form\"><form name=\"checkTicketForm\" ng-submit=\"receipt.checkTicket()\"><div class=\"form-element\"><label class=\"form-label\">Restaurant <small>*</small></label><div class=\"form-element-select\"><select required=\"\" name=\"restaurant_identifier\" ng-model=\"receipt.checkTicketForm.restaurant_identifier\" ng-options=\"restaurant.code as restaurant.name for restaurant in receipt.restaurants\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Restaurant</option></select></div></div><div class=\"form-element\"><label class=\"form-label\">Nº Ticket. Facturación válida sólo en el mes de consumo y disponible 5 días hábiles posterior al consumo <small>*</small></label> <input type=\"number\" name=\"fiscal_number\" placeholder=\"Ingresa Nº Ticket\" ng-model=\"receipt.checkTicketForm.fiscal_number\" required=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Fecha <small>*</small></label> <input type=\"date\" name=\"emission_date\" placeholder=\"Fecha\" onfocus=\"this.showPicker()\" ng-model=\"receipt.checkTicketForm.emission_date\" required=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Monto <small>*</small></label> <input type=\"number\" name=\"amount\" step=\"0.01\" placeholder=\"Ingresa monto\" ng-model=\"receipt.checkTicketForm.amount\" required=\"\"></div><div class=\"btn-submit-generate-ticket-receipt\"><button type=\"submit\" class=\"btn-next\" ng-disabled=\"checkTicketForm.$invalid || receipt.inProgress\">Enviar</button></div></form></div></div><div class=\"generate-ticket-receipt-container\" ng-show=\"receipt.checkTicketSuccess\"><div class=\"generate-ticket-receipt-title\"><h2>Datos fiscales</h2></div><div class=\"generate-ticket-receipt-form\"><form name=\"ticketForm\" ng-submit=\"receipt.requestTicket()\"><div class=\"form-element\"><label class=\"form-label\">RFC <small>*</small></label> <input type=\"text\" name=\"bussiness_identification\" placeholder=\"Ingresa RFC\" ng-model=\"receipt.ticketForm.bussiness_identification\" required=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Nombre / Razón Social <small>*</small></label> <input type=\"text\" name=\"bussiness_name\" placeholder=\"Ingresa Nombre / Razón Social\" ng-model=\"receipt.ticketForm.bussiness_name\" required=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Código Postal <small>*</small></label> <input type=\"text\" name=\"postal_code\" placeholder=\"Ingresa Código Postal\" ng-model=\"receipt.ticketForm.postal_code\" required=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Tipo <small>*</small></label><div class=\"form-element-select\"><select required=\"\" ng-change=\"receipt.onChangeTaxRegimeType()\" ng-model=\"receipt.clientType\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Tipo</option><option value=\"fisica\">Física</option><option value=\"moral\">Moral</option></select></div></div><div class=\"form-element\"><label class=\"form-label\">Régimen Fiscal <small>*</small></label><div class=\"form-element-select\"><select required=\"\" ng-model=\"receipt.ticketForm.tax_regime\" ng-options=\"item.code as item.description for item in receipt.filteredTaxRegimes\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Régimen Fiscal</option></select></div></div><div class=\"form-element\"><label class=\"form-label\">Uso CFDI <small>*</small></label><div class=\"form-element-select\"><select required=\"\" ng-model=\"receipt.ticketForm.cfdi_use\" ng-options=\"item.code as item.description for item in receipt.filteredCfdiUses\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona uso CFDI</option></select></div></div><div class=\"form-element\"><label class=\"form-label\">Email</label> <input type=\"email\" name=\"email\" placeholder=\"Ingresa Email\" ng-model=\"receipt.ticketForm.email\"></div><div class=\"form-element\" ng-show=\"receipt.errorMessage\"><div class=\"form-error-message\">{{ receipt.errorMessage }}</div></div><div class=\"btn-submit-generate-ticket-receipt\"><button type=\"submit\" class=\"btn-next\" ng-disabled=\"ticketForm.$invalid || receipt.inProgress\">Enviar</button></div></form></div></div><footer-cart></footer-cart></div>");
$templateCache.put("app/receipts/desktop/search.html","<header-cart></header-cart><div class=\"container\"><div class=\"row m-t-60 m-b-40\"><div class=\"col-md-6 m-t-40\"><h1>Verificación DTE</h1></div></div><form name=\"form\" ng-submit=\"receipt.requestDte()\"><div class=\"row m-b-60\"><div class=\"col-md-6 col-md-offset-3\"><div class=\"form-group\"><label class=\"control-label\">Restaurant <small>*</small></label><div class=\"form-select\"><select class=\"form-control\" required=\"\" ng-model=\"receipt.receiptForm.restaurant_identifier\" ng-options=\"restaurant.code as restaurant.name for restaurant in receipt.restaurants\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Restaurant</option></select></div></div><div class=\"form-group\"><label class=\"control-label\">Nº Boleta <small>*</small></label> <input name=\"fiscal_number\" class=\"form-control\" required=\"\" type=\"number\" ng-model=\"receipt.receiptForm.fiscal_number\"></div><div class=\"form-group\"><label class=\"control-label\">Fecha <small>*</small></label> <input name=\"emission_date\" class=\"form-control\" required=\"\" type=\"date\" ng-model=\"receipt.receiptForm.emission_date\"></div><div class=\"form-group\"><label class=\"control-label\">Monto <small>*</small></label> <input name=\"amount\" required=\"\" class=\"form-control\" type=\"number\" ng-model=\"receipt.receiptForm.amount\"></div><button class=\"btn btn-primary pull-right\" type=\"submit\" ng-disabled=\"!form.$valid\">Confirmar</button></div></div></form></div><footer-cart></footer-cart>");
$templateCache.put("app/receipts/desktop/success.html","<header-cart></header-cart><div class=\"ticket-receipt-success\"><div class=\"ticket-receipt-success-container\"><div class=\"ticket-receipt-success-box\"><h3>¡Gracias {{ receipt.bussinessName }}!</h3><button ng-click=\"receipt.downloadFile(\'pdf\')\"><span class=\"download\">Descargar Factura PDF</span></button> <button ng-click=\"receipt.downloadFile(\'xml\')\"><span class=\"download\">Descargar Factura XML</span></button> <img src=\"assets/images/niufoods-dots.png\" alt=\"niufoods\"></div><div class=\"ticket-receipt-success-box\"><a ui-sref=\"main\"><span class=\"follow\">SEGUIR EXPLORANDO LA WEB</span></a></div></div><footer-cart></footer-cart></div>");
$templateCache.put("app/profile/mobile/profile.html","<header-cart></header-cart><div class=\"container-profile\"><div class=\"profile\"><div class=\"box-profile controls\"><div class=\"profile-controls\"><div class=\"login-controls\"><a class=\"highlight\" ui-sref=\"logout\">Cerrar sesión</a></div></div></div><div class=\"box-profile\"><div class=\"profile-name\"><p>Tu perfil, <span class=\"highlight\">{{profile.info.name}} ;)</span></p></div><div class=\"profile-form\"><form name=\"form\" ng-submit=\"profile.saveProfile(profile.info)\"><div class=\"form-container\"><div class=\"form-element\"><label class=\"form-label\">Mi nombre <small>*</small></label> <input name=\"name\" type=\"text\" class=\"form-input\" ng-model=\"profile.info.name\" required=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Mi género</label><div class=\"form-checkbox-inline\"><div class=\"form-checkbox-text\" ng-repeat=\"gender in profile.genders\"><input id=\"gender-{{gender}}\" name=\"gender\" type=\"radio\" ng-model=\"profile.info.gender\" ng-value=\"gender\"> <label for=\"gender-{{gender}}\" class=\"button-select gender\"><div class=\"checkbox-label\"><span>{{gender}}</span></div></label></div></div></div><div class=\"form-element birthdate\"><label class=\"form-label\">Mi cumpleaños <small>*</small></label> <input type=\"text\" class=\"form-input\" ng-focus=\"profile.info.birthdateFocus = true\" ng-model=\"profile.info.birthdate\" uib-datepicker-popup=\"dd-MMMM-yyyy\" show-button-bar=\"false\" is-open=\"profile.info.birthdateFocus\"></div><div class=\"form-element\"><label class=\"form-label\">Mi email <small>*</small></label> <input name=\"email\" class=\"form-input\" type=\"email\" ng-model=\"profile.info.email\" disabled=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Mi número <small>*</small></label><div class=\"form-phones\"><phone-select number=\"profile.phones[0]\" btn-submit-id=\"submit-perfil\" model=\"profile.phones[0].prefix\" object=\"profile\" form-name=\"form\" class=\"phone-component\" disabled=\"true\"></phone-select></div></div></div><div class=\"form-button\"><button class=\"btn btn-submit-perfil\" type=\"submit\" id=\"submit-perfil\" ng-disabled=\"form.$invalid\">Guardar perfil</button></div></form></div></div><div class=\"box-profile address\"><div class=\"address\"><div class=\"address-container\"><div class=\"address-checkbox\" ng-repeat=\"address in profile.addresses\"><input id=\"address-{{$index}}\" name=\"address\" type=\"radio\" ng-model=\"profile.selectedAddress\" ng-value=\"address\"> <label for=\"address-{{$index}}\" class=\"button-select address\"><div class=\"checkbox-label address\"><span ng-show=\"address.address\">{{address.street_name}} #{{address.street_number}} <span class=\"specific-number\" ng-if=\"address.specific_number\">, {{address.specific_number}}</span></span> <small>{{address.comune_name}}</small> <a ng-click=\"profile.deactivateAddress(address)\"><i class=\"icon-x\"></i></a></div></label></div></div><div class=\"add-address\"><a ng-click=\"profile.newAddressModal(true)\">Agregar dirección +</a></div></div><div class=\"payment\"><div class=\"payment-info\"><p>Mis medios de pago</p><small ng-if=\"profile.onlinePayment && !profile.tbkUsers.length > 0\">Añade tu tarjeta de crédito con webpay oneclick desde el checkout</small> <small ng-if=\"profile.kushkiPayment && !profile.paymentCards.length > 0\">Añade tu tarjeta de crédito con kushki desde el checkout</small></div><div class=\"payment-checkbox\" ng-repeat=\"tbkUser in profile.tbkUsers\" ng-if=\"profile.onlinePayment && profile.tbkUsers.length > 0\"><input id=\"tbkuser-{{$index}}\" name=\"tbkuser\" type=\"radio\" ng-value=\"tbkuser\"> <label class=\"button-select payment\" for=\"tbkuser-{{$index}}\"><div class=\"checkbox-label payment\"><span>Webpay Oneclick</span> <small>Tarjeta nro</small> <small>XXXX.XXXX.XXXX.{{tbkUser.last_4_card_digits}}</small></div><div class=\"checkbox-label payment-action\"><a id=\"tbkuser-{{$index}}-deactivate-card\" ng-click=\"profile.deactivateCard(tbkUser, $index)\"><i class=\"icon-x payment\"></i></a><div id=\"tbkuser-{{$index}}-loader\" class=\"hidden\"><loader template=\"ring\"><loader></loader></loader></div></div></label></div><div class=\"payment-checkbox\" ng-repeat=\"card in profile.paymentCards\" ng-if=\"profile.kushkiPayment && profile.paymentCards.length > 0\"><input id=\"kushki-{{$index}}\" name=\"kushki\" type=\"radio\" value=\"{{card.token}}\"> <label class=\"button-select payment\" for=\"kushki-{{$index}}\"><div class=\"checkbox-label payment\"><span>Kushki</span> <small>{{profile.cart.cardTypeName(card.payment_brand)}}</small> <small>XXXX.XXXX.XXXX.{{card.card_last_four}}</small> <a ng-click=\"profile.kushki.kushkiDeleteSubscribedCard(card)\"><i class=\"icon-x payment\"></i></a></div></label></div></div><div class=\"coupon\"><div class=\"coupon-info\"><p>Cupones de descuento</p></div><div class=\"coupon-checkbox\" ng-repeat=\"customer_coupon in profile.coupon.coupons\"><input id=\"coupon-customer-{{$index}}\" name=\"coupon-customer\" type=\"radio\" ng-model=\"profile.coupon.currentCustomerCouponId\" ng-value=\"customer_coupon.id\"> <label for=\"coupon-customer-{{$index}}\" class=\"button-select coupon\" ng-click=\"profile.coupon.activateCoupon(customer_coupon.id)\"><div class=\"checkbox-label coupon\"><span>{{customer_coupon.coupon.code}}</span> <small>{{customer_coupon.coupon.caption}}.</small> <small>Válido hasta: {{(customer_coupon.coupon.expiration_date | date:\'dd/MM/yyyy\') || \"-\"}}</small></div></label></div><div class=\"box-coupon\"><input class=\"input-coupon\" name=\"coupon\" maxlength=\"50\" autocomplete=\"off\" placeholder=\"Código de tu cupón de descuento\" required=\"\" type=\"text\" ng-model=\"profile.coupon.code\"> <button class=\"btn btn-coupon\" ng-click=\"profile.coupon.applyCoupon(true)\" ng-disabled=\"!profile.coupon.code\">Aplicar</button></div></div></div></div></div>");
$templateCache.put("app/receipts/mobile/generate-ticket-receipt.html","<header-cart></header-cart><div class=\"generate-ticket-receipt\"><div class=\"generate-ticket-receipt-container\" ng-show=\"!receipt.checkTicketSuccess\"><div class=\"generate-ticket-receipt-title\"><h2>Facturar Ticket</h2></div><div class=\"generate-ticket-receipt-form\"><form name=\"checkTicketForm\" ng-submit=\"receipt.checkTicket()\"><div class=\"form-element\"><label class=\"form-label\">Restaurant <small>*</small></label><div class=\"form-element-select\"><select required=\"\" name=\"restaurant_identifier\" ng-model=\"receipt.checkTicketForm.restaurant_identifier\" ng-options=\"restaurant.code as restaurant.name for restaurant in receipt.restaurants\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Restaurant</option></select></div></div><div class=\"form-element\"><label class=\"form-label\">Nº Ticket. Facturación válida sólo en el mes de consumo y disponible 5 días hábiles posterior al consumo <small>*</small></label> <input type=\"number\" name=\"fiscal_number\" placeholder=\"Ingresa Nº Ticket\" ng-model=\"receipt.checkTicketForm.fiscal_number\" required=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Fecha <small>*</small></label> <input type=\"date\" name=\"emission_date\" placeholder=\"Fecha\" onfocus=\"this.showPicker()\" ng-model=\"receipt.checkTicketForm.emission_date\" required=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Monto <small>*</small></label> <input type=\"number\" name=\"amount\" step=\"0.01\" placeholder=\"Ingresa Monto\" ng-model=\"receipt.checkTicketForm.amount\" required=\"\"></div><div class=\"btn-submit-generate-ticket-receipt\"><button type=\"submit\" class=\"btn-next\" ng-disabled=\"checkTicketForm.$invalid || receipt.inProgress\">Enviar</button></div></form></div></div><div class=\"generate-ticket-receipt-container\" ng-show=\"receipt.checkTicketSuccess\"><div class=\"generate-ticket-receipt-title\"><h2>Datos fiscales</h2></div><div class=\"generate-ticket-receipt-form\"><form name=\"ticketForm\" ng-submit=\"receipt.requestTicket()\"><div class=\"form-element\"><label class=\"form-label\">RFC <small>*</small></label> <input type=\"text\" name=\"bussiness_identification\" placeholder=\"Ingresa RFC\" ng-model=\"receipt.ticketForm.bussiness_identification\" required=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Nombre / Razón Social <small>*</small></label> <input type=\"text\" name=\"bussiness_name\" placeholder=\"Ingresa Nombre / Razón Social\" ng-model=\"receipt.ticketForm.bussiness_name\" required=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Código Postal <small>*</small></label> <input type=\"text\" name=\"postal_code\" placeholder=\"Ingresa Código Postal\" ng-model=\"receipt.ticketForm.postal_code\" required=\"\"></div><div class=\"form-element\"><label class=\"form-label\">Tipo <small>*</small></label><div class=\"form-element-select\"><select required=\"\" ng-change=\"receipt.onChangeTaxRegimeType()\" ng-model=\"receipt.clientType\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Tipo</option><option value=\"fisica\">Física</option><option value=\"moral\">Moral</option></select></div></div><div class=\"form-element\"><label class=\"form-label\">Régimen Fiscal <small>*</small></label><div class=\"form-element-select\"><select required=\"\" ng-model=\"receipt.ticketForm.tax_regime\" ng-options=\"item.code as item.description for item in receipt.filteredTaxRegimes\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Régimen Fiscal</option></select></div></div><div class=\"form-element\"><label class=\"form-label\">Uso CFDI <small>*</small></label><div class=\"form-element-select\"><select required=\"\" ng-model=\"receipt.ticketForm.cfdi_use\" ng-options=\"item.code as item.description for item in receipt.filteredCfdiUses\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona uso CFDI</option></select></div></div><div class=\"form-element\"><label class=\"form-label\">Email</label> <input type=\"email\" name=\"email\" placeholder=\"Ingresa Email\" ng-model=\"receipt.ticketForm.email\"></div><div class=\"form-element\" ng-show=\"receipt.errorMessage\"><div class=\"form-error-message\">{{ receipt.errorMessage }}</div></div><div class=\"btn-submit-generate-ticket-receipt\"><button type=\"submit\" class=\"btn-next\" ng-disabled=\"ticketForm.$invalid || receipt.inProgress\">Enviar</button></div></form></div></div></div>");
$templateCache.put("app/receipts/mobile/search.html","<header-cart></header-cart><div class=\"container\"><div class=\"profile-form-container\"><h1 class=\"m-b-40\">Verificación DTE</h1><form name=\"form\" ng-submit=\"receipt.requestDte()\"><div class=\"form-group\"><label class=\"control-label\">Restaurant <small>*</small></label><div class=\"form-select\"><select class=\"form-control\" required=\"\" ng-model=\"receipt.receiptForm.restaurant_identifier\" ng-options=\"restaurant.code as restaurant.name for restaurant in receipt.restaurants\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona Restaurant</option></select></div></div><div class=\"form-group\"><label class=\"control-label\">Nº Boleta <small>*</small></label> <input class=\"form-control\" name=\"fiscal_number\" type=\"number\" ng-model=\"receipt.receiptForm.fiscal_number\" required=\"\"></div><div class=\"form-group\"><label class=\"control-label\">Fecha <small>*</small></label> <input class=\"form-control\" name=\"emission_date\" type=\"date\" ng-model=\"receipt.receiptForm.emission_date\" required=\"\"></div><div class=\"form-group\"><label class=\"control-label\">Monto <small>*</small></label> <input class=\"form-control\" name=\"amount\" type=\"number\" ng-model=\"receipt.receiptForm.amount\" required=\"\"></div><button class=\"btn btn-primary btn-block m-t-20\" type=\"submit\" ng-disabled=\"!form.$valid\">Confirmar</button></form></div></div>");
$templateCache.put("app/receipts/mobile/success.html","<header-cart></header-cart><div class=\"ticket-receipt-success\"><div class=\"ticket-receipt-success-box\"><h3>¡Gracias {{ receipt.bussinessName }}!</h3><button ng-click=\"receipt.downloadFile(\'pdf\')\"><span class=\"download\">Descargar Factura PDF</span></button> <button ng-click=\"receipt.downloadFile(\'xml\')\"><span class=\"download\">Descargar Factura XML</span></button> <img src=\"assets/images/niufoods-dots.png\" alt=\"niufoods\"></div><div class=\"ticket-receipt-success-box\"><a ui-sref=\"main\"><span class=\"follow\">SEGUIR EXPLORANDO LA WEB</span></a></div></div>");
$templateCache.put("app/restaurants/desktop/restaurants.html","<header-cart></header-cart><div class=\"maps-address\"><div class=\"row-maps\"><div id=\"restaurants-list\" class=\"col-restaurants scroll-bar\"><div class=\"title-select-restaurants\"><h1>Seleccione una {{restaurants.localeCommune}}</h1></div><div class=\"container-select-restaurants\"><div class=\"select-restaurants\"><select required=\"\" ng-model=\"restaurantComune\" ng-options=\"comune.name for comune in restaurants.comunes\" ng-change=\"update()\"><option value=\"\" selected=\"\">Todas las {{restaurants.localeCommunes}}</option></select></div></div><div id=\"{{restaurants.kebabCase(restaurant.name)}}\" class=\"restaurants\" ng-class=\"{\'active\': restaurant == restaurants.selected}\" ng-repeat=\"restaurant in restaurants.restaurants\"><a ng-click=\"restaurants.onMarkerClick(\'\', \'\', restaurant)\"><div class=\"restaurant-main\"><div class=\"restaurant-header\"><h3>{{restaurant.name}}</h3><i class=\"icon-chevron-right\"></i></div><div class=\"restaurant-description\"><p>{{restaurant.address}}</p><p ng-if=\"restaurant.phones.length > 0\">{{restaurant.phones[0] | phone}}</p></div></div><div class=\"restaurant-schedules\"><p class=\"schedule-title\">Horarios</p><p class=\"schedule-line\" ng-repeat=\"schedule in restaurant.schedules_list_with_format\" ng-class=\"{\'today-highlight\': schedule.today}\"><span class=\"schedule-badge\">{{schedule.label}}: {{schedule.hours}}</span></p></div></a></div></div><div class=\"col-maps\"><ui-gmap-google-map class=\"map\" center=\"restaurants.selected.lonlat\" draggable=\"true\" options=\"restaurants.mapOptions\" pan=\"true\" zoom=\"restaurants.mapOptions.zoom\"><ui-gmap-markers click=\"restaurants.onMarkerClick\" coords=\"\'lonlat\'\" icon=\"\'icon\'\" models=\"restaurants.restaurants\"></ui-gmap-markers><ui-gmap-polygons models=\"restaurants.polygons\" idkey=\"\'id\'\" path=\"\'path\'\" stroke=\"{color: $polygon_border_color, weight: 0, opacity: 0}\" visible=\"true\" static=\"true\" geodesic=\"true\" fill=\"{color: $polygon_fill_color, opacity: 0.3}\" fit=\"false\" editable=\"false\" draggable=\"false\"></ui-gmap-polygons></ui-gmap-google-map></div></div><footer-cart></footer-cart></div>");
$templateCache.put("app/restaurant-menu/mobile/bar-menu.html","<header-cart></header-cart><div class=\"beers-menu\"><img class=\"beers-menu-img\" src=\"{{envConstants.RESTAURANT_MENU_MOBILE}}\"></div><footer-cart></footer-cart>");
$templateCache.put("app/restaurant-menu/mobile/bar-menu2.html","<header-cart></header-cart><div class=\"beers-menu\"><img class=\"beers-menu-img\" src=\"{{envConstants.BAR_MENU_MOBILE}}\"></div><footer-cart></footer-cart>");
$templateCache.put("app/restaurant-menu/mobile/beers-menu.html","<header-cart></header-cart><div class=\"beers-menu\"><img class=\"beers-menu-img\" src=\"{{envConstants.BEERS_MENU_MOBILE}}\"></div><footer-cart></footer-cart>");
$templateCache.put("app/restaurant-menu/mobile/kids-menu.html","<header-cart></header-cart><div class=\"beers-menu\"><img class=\"beers-menu-img\" src=\"{{envConstants.KIDS_MENU_MOBILE}}\"></div><footer-cart></footer-cart>");
$templateCache.put("app/restaurant-menu/mobile/restaurant-menu.html","<header-cart></header-cart><div class=\"beers-menu\"><img class=\"beers-menu-img\" ng-if=\"restaurantMenu.imageUrl\" ng-src=\"{{restaurantMenu.imageUrl}}\"></div><footer-cart></footer-cart>");
$templateCache.put("app/restaurant-menu/desktop/bar-menu.html","<header-cart></header-cart><div class=\"beers-menu scroll-bar\"><img class=\"beers-menu-img\" src=\"{{envConstants.RESTAURANT_MENU_DESKTOP}}\"> <img class=\"beers-menu-img\" src=\"{{envConstants.RESTAURANT_MENU_DESKTOP_2}}\"></div><footer-cart></footer-cart>");
$templateCache.put("app/restaurant-menu/desktop/bar-menu2.html","<header-cart></header-cart><div class=\"beers-menu scroll-bar\"><img class=\"beers-menu-img\" src=\"{{envConstants.BAR_MENU_DESKTOP}}\"></div><footer-cart></footer-cart>");
$templateCache.put("app/restaurant-menu/desktop/beers-menu.html","<header-cart></header-cart><div class=\"beers-menu scroll-bar\"><img class=\"beers-menu-img\" src=\"{{envConstants.BEERS_MENU_DESKTOP}}\"></div><footer-cart></footer-cart>");
$templateCache.put("app/restaurant-menu/desktop/kids-menu.html","<header-cart></header-cart><div class=\"beers-menu scroll-bar\"><img class=\"beers-menu-img\" src=\"{{envConstants.KIDS_MENU_DESKTOP}}\"></div><footer-cart></footer-cart>");
$templateCache.put("app/restaurant-menu/desktop/restaurant-menu.html","<header-cart></header-cart><div class=\"beers-menu scroll-bar\"><img class=\"beers-menu-img\" ng-if=\"restaurantMenu.imageUrl\" ng-src=\"{{restaurantMenu.imageUrl}}\"></div><footer-cart></footer-cart>");
$templateCache.put("app/restaurants/mobile/restaurants.html","<header-cart></header-cart><div class=\"maps-address\"><div class=\"maps-box\"><div class=\"title-select-restaurants\"><h1>Seleccione una {{restaurants.localeCommune}}</h1></div><div class=\"container-select-restaurants\"><div class=\"select-restaurants\"><select required=\"\" ng-model=\"restaurantComune\" ng-options=\"comune.name for comune in restaurants.comunes\" ng-change=\"update()\"><option value=\"\" selected=\"\">Todas las {{restaurants.localeCommunes}}</option></select></div></div><div class=\"restaurants\" ng-class=\"{\'active\': restaurant == restaurants.selected}\" ng-repeat=\"restaurant in restaurants.restaurants\"><div class=\"restaurant-main\"><div class=\"restaurant-description\"><h3>{{restaurant.name}}</h3><p>{{restaurant.address}}</p></div><div class=\"restaurant-item-controls\"><a href=\"{{restaurants.googleMapsUrl(restaurant)}}\"><i class=\"glyphicon glyphicon-map-marker\"></i></a> <a ng-href=\"tel:{{restaurant.phones[0]}}\"><i class=\"glyphicon glyphicon-earphone\"></i></a></div></div><div class=\"restaurant-schedules\"><p class=\"schedule-title\">Horarios</p><p class=\"schedule-line\" ng-repeat=\"schedule in restaurant.schedules_list_with_format\" ng-class=\"{\'today-highlight\': schedule.today}\"><span class=\"schedule-badge\">{{schedule.label}}: {{schedule.hours}}</span></p></div></div></div></div>");
$templateCache.put("app/tos/desktop/tos-cl.html","<div class=\"tos\"><h1>POLÍTICA DE PRIVACIDAD</h1><p>{{tos.companyName}} respeta la privacidad de cada individuo y valora la confidencialidad de sus clientes. Esta Política de Privacidad (en adelante, la \"Política de Privacidad\") establece las prácticas de {{tos.companyName}} con respecto a la recopilación, uso, y divulgación de información que usted nos proporcione por medio del sitio web {{tos.companyUrl}} (en adelante, el \"Sitio Web\"). Por favor lea toda la Política de Privacidad antes de utilizar este Sitio Web o de proporcionar información a través del mismo. Al utilizar este Sitio Web, y siempre que usted remita información por medio del mismo a {{tos.companyName}}, usted acepta tácitamente los términos de esta Política de Privacidad.</p><h3>Recopilación de Datos Personales</h3><p>{{tos.companyName}} respeta su derecho a la protección de sus datos personales, los cuales están amparados por las Leyes Chilenas. {{tos.companyName}} solamente recopilará datos identificables personales sin los cuales se tornaría imposible brindar los servicios de {{tos.companyName}}, tales como su nombre, dirección, teléfono, celular, email y fecha de nacimiento, cuando usted los proporcione de forma voluntaria a {{tos.companyName}}. El Usuario que proporciona de la manera descrita sus datos personales, lo hace en forma expresa, libre y consentida y autoriza automáticamente a que {{tos.companyName}} utilice esta información, conforme a lo que describe esta Política de Privacidad.</p><p>La información y/o datos que voluntariamente nos facilite a través del Sitio Web, podrán ser incorporados a la base de datos con la finalidad de realizar la gestión y el mantenimiento de nuestras relaciones con Ud., es decir, poder enviarle información sobre nuestros productos, promociones, descuentos, publicidad, etc. De ninguna manera {{tos.companyName}} le solicitará para su base de datos, información personal que revele su origen racial y étnico, opiniones políticas, convicciones religiosas, filosóficas o morales, afiliación sindical e información referente a su salud o a su vida sexual (\"Datos Sensibles\").</p><p>La base de datos será guardada y almacenada y se encuentra debidamente registrada conforme la ley aplicable. Esta información no será transferida a terceros sin su consentimiento previo. {{tos.companyName}} mantiene los datos de información personal identificable, proporcionada voluntariamente en una base de datos electrónica. A pesar de que {{tos.companyName}} hace todos los esfuerzos razonables por proteger la información recopilada por medio del Sitio Web, por favor tome en cuenta que siempre existe un riesgo implícito al suministrar datos por medio del Internet. {{tos.companyName}} no puede garantizar que nuestro Sitio Web sea 100% seguro contra la manipulación ilegal o la piratería. Cualquier información transmitida por medio de Internet puede estar en peligro; sin embargo, una vez que {{tos.companyName}} recibe esta información y se añade a nuestra base de datos, recibe la misma protección que {{tos.companyName}} extiende a su propia información confidencial. Se adoptarán las medidas técnicas y organizativas necesarias para garantizar la seguridad y confidencialidad de sus datos personales.</p><h3>Actualización de su Información</h3><p>Si desea conocer los datos de su persona que constan en la base de datos, actualizarlos o rectificar errores, o ejercer el derecho de retiro o bloqueo total o parcial de su nombre de nuestra base de datos, por favor comuníquese por correo a Las Tranqueras 370, Comuna de Las Condes, Santiago de Chile, o por correo electrónico a {{tos.companyEmail}}, con el asunto: DATOS PERSONALES.</p><h3>Derecho de revocar su consentimiento para el tratamiento de datos</h3><p>Los usuarios pueden revocar en cualquier momento el consentimiento que nos ha entregado para el tratamiento de sus datos personales con el propósito que se deje de hacer uso de los mismos. Para ello, es necesario que presente su petición por escrito en la sección “Contáctanos” de nuestro Sitio Web o mediante correo electrónico destinado “{{tos.companyEmail}}”. Su solicitud deberá indicar \'Nombre completo\' (nombre o nombres y apellido o apellidos), \'copia simple de su cédula nacional de identidad\' o, en medios electrónicos, versión digitalizada de la misma (escaneo), indicación del correo electrónico o dirección física que designe para notificaciones y algún número telefónico de contacto. En un plazo máximo de 3 días hábiles contados a partir de la fecha de recepción de su solicitud de revocación le daremos contestación sobre la procedencia de la misma, por medio de correo electrónico dirigido a su persona, enviado a la dirección de correo electrónico que haya indicado en la propia solicitud. La revocación no tiene efectos retroactivos. Solo opera a contar de la fecha de notificación a {{tos.companyName}}.</p><h3>Actualización de la Política de Privacidad</h3><p>Cualquier cambio a la Política de Privacidad del Sitio Web será anunciado en esta página.</p><p>Todos los derechos reservados.</p><h2>TÉRMINOS Y CONDICIONES PARA EL USO DE ESTE SITIO WEB</h2><h3>Condiciones generales</h3><p>Comercial Javerim LTDA con domicilio en Chesterton 8677, comuna de Las Condes, Santiago, (en adelante, {{tos.companyName}}) se complace en ofrecerle este sitio web: {{tos.companyUrl}} (en adelante, el \"Sitio Web\"), su contenido y sus servicios. Por favor lea cuidadosamente estos términos y condiciones (en adelante los \"Términos y Condiciones\") relacionados con el uso de nuestro Sitio Web. Al usar nuestro Sitio Web, Usted acepta estos Términos y Condiciones, sin limitación ni condición alguna. Si no está de acuerdo con estos Términos y Condiciones, por favor no utilice nuestro Sitio Web. Cualquier persona física y/o jurídica puede navegar gratuitamente en el Sitio Web, y no es necesario ser Usuario para ello.</p><p>{{tos.companyName}} se reserva el derecho de revisar estos Términos y Condiciones o cualquier parte de ellos en cualquier momento sin previo aviso, actualizando esta publicación. Usted deberá visitar periódicamente esta página para revisar los presentes Términos y Condiciones que se aplican al uso que usted haga de nuestro Sitio Web.</p><p>{{tos.companyName}} se reserva el derecho de interrumpir, suspender o modificar en cualquier momento los servicios ofrecidos en el Sitio Web, ya sea en forma permanente o transitoria. No se requerirá la conformidad de los Usuarios, ni será necesario aviso previo alguno a dichos efectos. Asimismo, no garantiza el acceso o uso permanente al Sitio Web, ya que éste podría interrumpirse por cuestiones técnicas totalmente ajenas a {{tos.companyName}}. No obstante, si la suspensión o interrupción mencionada no obedeciere a razones de fuerza mayor o caso fortuito, {{tos.companyName}} se compromete a cumplir con las prestaciones que estuvieren pendientes al momento de la suspensión y/o interrupción.</p><p>{{tos.companyName}} no garantiza que el Sitio Web se encuentre libre de virus, gusanos o cualquier otro elemento que pueda llegar a dañar o alterar el normal funcionamiento de una computadora. Es su responsabilidad y obligación exclusiva contar con las herramientas adecuadas para detectar, desinfectar y/o prevenir cualquier tipo de elementos y/o posibles daños de esta naturaleza.</p><p>{{tos.companyName}} no se responsabiliza por cualquier daño y/o perjuicio que pueda producirse en los equipos informáticos de los Usuarios o de terceros como consecuencia de la navegación en el Sitio Web.</p><p>En virtud de la naturaleza de los productos ofrecidos en este Sitio Web, se recomienda conservar los productos enviados por {{tos.companyName}} en refrigeración, y consumir en el mismo día de adquisición de los mismos.</p><h3>Registro de Usuarios:</h3><p>Para realizar compras en el Sitio Web, es necesario registrarse como Usuario del mismo. Se deberá completar el Formulario en forma completa y correcta, incluyendo todos los datos personales que se requieran. El registro ocurre al momento de hacer su primer pedido, luego puede acceder al servicio ingresando su nombre de usuario y contraseña. Los datos personales suministrados, serán tratados por {{tos.companyName}} de manera totalmente confidencial. Sugerimos consultar nuestra \"Política de Privacidad\" publicada en el Sitio Web, previo a su registro como Usuario.</p><h3>Demoras y disponibilidad de los productos ofrecidos.</h3><p>La disponibilidad de todos los productos y/o servicios y/o promociones en el Sitio Web, está sujeta al stock diario de productos y/o servicios y/o promociones de {{tos.companyName}}. Todos los precios suministrados en el SitioWeb incluyen el Impuesto al Valor Agregado. Toda compra se encuentra sujeta a dicha disponibilidad, con lo cual se confirmará la disponibilidad con el número de pedido confirmado.</p><p>La información sobre productos y precios publicados en la página está sujeta a cambios y pueden ser modificados y/o actualizados a exclusiva discreción de {{tos.companyName}}.</p><h3>Información de los productos y del servicio. Validez de las promociones.</h3><p>La información sobre los productos, servicios y promociones que provee {{tos.companyName}} es suministrada en forma gratuita al Usuario en forma cierta, clara, detallada y veraz a través de el Sitio Web. En el caso de que se realicen ofertas y/o promociones de productos, éstas tendrán validez para los pedidos realizados desde el comienzo de aquellas, hasta la finalización de la oferta. Los términos y condiciones de las ofertas y/o promociones serán comunicados en el Sitio Web, y estarán siempre sujetas a la disponibilidad y stock de la materia prima con la cual se elaboran nuestros productos.</p><h3>Delivery. Alcance y tiempo de entrega. Consulta sobre el estado del envío.</h3><p>Las entregas de los productos de {{tos.companyName}} se realizarán en la dirección que el Usuario indique a tal efecto. La validez de la dirección indicada es de exclusiva responsabilidad de los Usuarios. Al realizar un pedido online, el Usuario recibirá en su correo electrónico una confirmación del mismo junto a un número de pedido, y tiempo aproximado de entrega. El tiempo de entrega depende del tiempo de elaboración del pedido, del tiempo de envío y del horario en que se efectuó el pedido. Dicho de tiempo de espera es aproximado. {{tos.companyName}} efectúa todo lo que se encuentra a su alcance para cumplir con el plazo de entrega de los pedidos.</p><h3>Gastos de envío</h3><p>Le recordamos consultar los precios de costos de envío, los cuales serán incluidos de manera explicita en el carro de compras para pedidos con despacho a domicilio. {{tos.companyName}} se reserva el derecho de cambiar estos precios sin previo aviso.</p><h3>Horarios de Atención al Público</h3><p>Se podrán realizar pedidos a través de la página web entre las 12:00 y las 23:30 horas en días hábiles en que los locales de {{tos.companyName}} estén operando.</p><h3>Facturación</h3><p>Junto con la entrega del pedido, se le entregará la boleta correspondiente con la información clara y precisa del pedido.</p><h3>Cancelación del pedido</h3><p>Sin perjuicio de lo establecido en los presentes Términos y Condiciones, el Usuario podrá cancelar su pedido telefónicamente. Sugerimos contactarse en cuanto antes para la cancelación del mismo, ya que {{tos.companyName}} trabaja con productos frescos, que requieren la elaboración en el momento del pedido.</p><h3>Registro de reclamos. Atención personalizada.</h3><p>{{tos.companyName}} habilita un registro de reclamos donde quedarán asentadas las presentaciones de los usuarios. Los reclamos podrán efectuarse a través de {{tos.companyUrl}}/contacto (completando todos los campos requeridos). Los reclamos efectuados serán respondidos por {{tos.companyName}} telefónicamente o vía correo electrónico. Dentro de los 10 días hábiles siguientes. {{tos.companyName}} se compromete además a atender su reclamo y efectuar las averiguaciones pertinentes del mismo. Dándole la seriedad que a todo reclamo corresponde.</p><h3>Prohibiciones</h3><p>Se les prohíbe terminantemente a los Usuarios y/o quienes naveguen en el Sitio Web a: a) Consignar datos falsos en el Formulario y/o al momento de realizar un pedido, y/o en cualquier otro momento que le sea requerida cualquier tipo de información o datos personales; y b) Usar programas, software o aparatos automáticos o manuales para monitorear o copiar la información o cualquier contenido del Sitio Web sin previo consentimiento de {{tos.companyName}}.</p><h3>Derechos reservados. Propiedad Intelectual</h3><p>Todos los derechos del presente Sitio Webestán reservados. El contenido del presente Sitio Web, incluyendo aunque no limitado al texto, logos, gráficos y todo el diseño en general, es de propiedad o uso exclusivo de su titular registrado y se encuentra protegido por la legislación nacional e internacional vigente sobre propiedad intelectual.</p><h3>Enlaces a Sitios de Terceros</h3><p>Como una cortesía, hemos proporcionado enlaces a ciertos sitios web de terceros. Al proporcionar estos enlaces, {{tos.companyName}} no está endosando, adoptando, o accediendo al contenido de estos sitios enlazados o a los productos y servicios de estos terceros ajenos a {{tos.companyName}}. {{tos.companyName}} no revisa o controla de manera alguna el contenido de estos sitios de terceros y ese contenido no forma parte de nuestro Sitio Web. {{tos.companyName}} niega expresamente cualquier responsabilidad por el contenido de cualquier sitio de terceros enlazado a nuestro Sitio Web o los productos y servicios de estos terceros. {{tos.companyName}} no se responsabiliza, ni responderá de manera alguna por los daños y perjuicios, ya sean actuales o eventuales, materiales o morales, directos o indirectos, que sufrieren los usuarios y que se derivaran de la información contenida en tales sitios de terceros o de la relación que los usuarios pudieren entablar con tales terceros. {{tos.companyName}} no garantiza el contenido o exactitud de los materiales de los sitios de terceros, o los productos y servicios de terceros. {{tos.companyName}} le ruega que verifique la seguridad y autenticidad de los sitios de terceros a los que acceda a través de un enlace en nuestro Sitio.</p><h3>Ley Aplicable y Jurisdicción</h3><p>Estos Términos y Condiciones se rigen por y serán interpretados de acuerdo a las leyes Chilenas. Tendrán jurisdicción sobre cualquier acción relacionada con estos Términos y Condiciones únicamente los Tribunales Ordinarios de Justicia asiento en la ciudad de Santiago de Chile.</p><h3>Validez por Separado</h3><p>Si cualquiera de las cláusulas incluidas en estos Términos y Condiciones se considerase inválida o inaplicable por cualquier corte o jurisdicción competente, las otras cláusulas incluidas en estos Términos y Condiciones de Uso permanecerán vigentes y resultarán aplicables. Cualquier cláusula incluida en estos Términos y Condiciones que sea considerada inválida o inaplicable parcialmente o hasta cierto punto únicamente, permanecerá vigente y resultará aplicable hasta el grado en el que haya sido declarada inválida o inaplicable. {{tos.companyName}} podrá reemplazar dicha cláusula inválida o inaplicable incluida en estos Términos y Condiciones con otra cláusula válida y aplicable que alcance, hasta el grado posible, los propósitos económicos, comerciales y otros propósitos de dicha cláusula inválida o inaplicable.</p><h3>Acuerdo Completo</h3><p>Estos Términos y Condiciones representan el acuerdo en su totalidad entre usted y {{tos.companyName}} referente a la utilización del Sitio Web y temas relacionados al mismo y no serán modificados excepto por {{tos.companyName}}, mediante su publicación en el Sitio Web. {{tos.companyName}} se reserva el derecho de modificar los términos y condiciones de uso de este Sitio Web y tales cambios tendrán vigencia desde su publicación en el Sitio Web. Usted estará obligado a revisar periódicamente los Términos y Condiciones publicados para verificar cualquier modificación que pudieren haber sufrido, y la sola utilización del Sitio Web implicará la aceptación total e incondicional de estos Términos y Condiciones, sin necesidad de manifestación alguna de su parte.</p><h3>Actualización de Términos y Condiciones.</h3><p>Cualquier cambio a la Política de Privacidad del Sitio Web será anunciado en esta página.</p></div>");
$templateCache.put("app/tos/desktop/tos-mx.html","<div class=\"tos\"><h1>POLÍTICA DE PRIVACIDAD</h1><p>{{tos.companyName}} respeta la privacidad de cada individuo y valora la confidencialidad de sus clientes. Esta Política de Privacidad (en adelante, la \"Política de Privacidad\") establece las prácticas de {{tos.companyName}} con respecto a la recopilación, uso, y divulgación de información que usted nos proporcione por medio del sitio web {{tos.companyUrl}} (en adelante, el \"Sitio Web\"). Por favor lea toda la Política de Privacidad antes de utilizar este Sitio Web o de proporcionar información a través del mismo. Al utilizar este Sitio Web, y siempre que usted remita información por medio del mismo a {{tos.companyName}}, usted acepta tácitamente los términos de esta Política de Privacidad.</p><h3>Recopilación de Datos Personales</h3><p>{{tos.companyName}} respeta su derecho a la protección de sus datos personales, los cuales están amparados por las Leyes Chilenas. {{tos.companyName}} solamente recopilará datos identificables personales sin los cuales se tornaría imposible brindar los servicios de {{tos.companyName}}, tales como su nombre, dirección, teléfono, celular, email y fecha de nacimiento, cuando usted los proporcione de forma voluntaria a {{tos.companyName}}. El Usuario que proporciona de la manera descrita sus datos personales, lo hace en forma expresa, libre y consentida y autoriza automáticamente a que {{tos.companyName}} utilice esta información, conforme a lo que describe esta Política de Privacidad.</p><p>La información y/o datos que voluntariamente nos facilite a través del Sitio Web, podrán ser incorporados a la base de datos con la finalidad de realizar la gestión y el mantenimiento de nuestras relaciones con Ud., es decir, poder enviarle información sobre nuestros productos, promociones, descuentos, publicidad, etc. De ninguna manera {{tos.companyName}} le solicitará para su base de datos, información personal que revele su origen racial y étnico, opiniones políticas, convicciones religiosas, filosóficas o morales, afiliación sindical e información referente a su salud o a su vida sexual (\"Datos Sensibles\").</p><p>La base de datos será guardada y almacenada y se encuentra debidamente registrada conforme la ley aplicable. Esta información no será transferida a terceros sin su consentimiento previo. {{tos.companyName}} mantiene los datos de información personal identificable, proporcionada voluntariamente en una base de datos electrónica. A pesar de que {{tos.companyName}} hace todos los esfuerzos razonables por proteger la información recopilada por medio del Sitio Web, por favor tome en cuenta que siempre existe un riesgo implícito al suministrar datos por medio del Internet. {{tos.companyName}} no puede garantizar que nuestro Sitio Web sea 100% seguro contra la manipulación ilegal o la piratería. Cualquier información transmitida por medio de Internet puede estar en peligro; sin embargo, una vez que {{tos.companyName}} recibe esta información y se añade a nuestra base de datos, recibe la misma protección que {{tos.companyName}} extiende a su propia información confidencial. Se adoptarán las medidas técnicas y organizativas necesarias para garantizar la seguridad y confidencialidad de sus datos personales.</p><h3>Actualización de su Información</h3><p>Si desea conocer los datos de su persona que constan en la base de datos, actualizarlos o rectificar errores, o ejercer el derecho de retiro o bloqueo total o parcial de su nombre de nuestra base de datos, por favor comuníquese por correo a Chesterton 8677, Comuna de Las Condes, Santiago de Chile, o por correo electrónico a {{tos.companyEmail}}, con el asunto: DATOS PERSONALES.</p><h3>Actualización de la Política de Privacidad</h3><p>Cualquier cambio a la Política de Privacidad del Sitio Web será anunciado en esta página.</p><p>Todos los derechos reservados.</p></div>");
$templateCache.put("app/tos/desktop/tos.html","<header-cart></header-cart><div class=\"container-contenido\" ng-class=\"{\'container\': deviceType == \'desktop\'}\"><ng-include src=\"tos.templateUrl()\"></ng-include><footer-cart></footer-cart></div>");
$templateCache.put("app/tos/mobile/tos-cl.html","<div class=\"tos\"><h1>POLÍTICA DE PRIVACIDAD</h1><p>{{tos.companyName}} respeta la privacidad de cada individuo y valora la confidencialidad de sus clientes. Esta Política de Privacidad (en adelante, la \"Política de Privacidad\") establece las prácticas de {{tos.companyName}} con respecto a la recopilación, uso, y divulgación de información que usted nos proporcione por medio del sitio web {{tos.companyUrl}} (en adelante, el \"Sitio Web\"). Por favor lea toda la Política de Privacidad antes de utilizar este Sitio Web o de proporcionar información a través del mismo. Al utilizar este Sitio Web, y siempre que usted remita información por medio del mismo a {{tos.companyName}}, usted acepta tácitamente los términos de esta Política de Privacidad.</p><h3>Recopilación de Datos Personales</h3><p>{{tos.companyName}} respeta su derecho a la protección de sus datos personales, los cuales están amparados por las Leyes Chilenas. {{tos.companyName}} solamente recopilará datos identificables personales sin los cuales se tornaría imposible brindar los servicios de {{tos.companyName}}, tales como su nombre, dirección, teléfono, celular, email y fecha de nacimiento, cuando usted los proporcione de forma voluntaria a {{tos.companyName}}. El Usuario que proporciona de la manera descrita sus datos personales, lo hace en forma expresa, libre y consentida y autoriza automáticamente a que {{tos.companyName}} utilice esta información, conforme a lo que describe esta Política de Privacidad.</p><p>La información y/o datos que voluntariamente nos facilite a través del Sitio Web, podrán ser incorporados a la base de datos con la finalidad de realizar la gestión y el mantenimiento de nuestras relaciones con Ud., es decir, poder enviarle información sobre nuestros productos, promociones, descuentos, publicidad, etc. De ninguna manera {{tos.companyName}} le solicitará para su base de datos, información personal que revele su origen racial y étnico, opiniones políticas, convicciones religiosas, filosóficas o morales, afiliación sindical e información referente a su salud o a su vida sexual (\"Datos Sensibles\").</p><p>La base de datos será guardada y almacenada y se encuentra debidamente registrada conforme la ley aplicable. Esta información no será transferida a terceros sin su consentimiento previo. {{tos.companyName}} mantiene los datos de información personal identificable, proporcionada voluntariamente en una base de datos electrónica. A pesar de que {{tos.companyName}} hace todos los esfuerzos razonables por proteger la información recopilada por medio del Sitio Web, por favor tome en cuenta que siempre existe un riesgo implícito al suministrar datos por medio del Internet. {{tos.companyName}} no puede garantizar que nuestro Sitio Web sea 100% seguro contra la manipulación ilegal o la piratería. Cualquier información transmitida por medio de Internet puede estar en peligro; sin embargo, una vez que {{tos.companyName}} recibe esta información y se añade a nuestra base de datos, recibe la misma protección que {{tos.companyName}} extiende a su propia información confidencial. Se adoptarán las medidas técnicas y organizativas necesarias para garantizar la seguridad y confidencialidad de sus datos personales.</p><h3>Actualización de su Información</h3><p>Si desea conocer los datos de su persona que constan en la base de datos, actualizarlos o rectificar errores, o ejercer el derecho de retiro o bloqueo total o parcial de su nombre de nuestra base de datos, por favor comuníquese por correo a Las Tranqueras 370, Comuna de Las Condes, Santiago de Chile, o por correo electrónico a {{tos.companyEmail}}, con el asunto: DATOS PERSONALES.</p><h3>Derecho de revocar su consentimiento para el tratamiento de datos</h3><p>Los usuarios pueden revocar en cualquier momento el consentimiento que nos ha entregado para el tratamiento de sus datos personales con el propósito que se deje de hacer uso de los mismos. Para ello, es necesario que presente su petición por escrito en la sección “Contáctanos” de nuestro Sitio Web o mediante correo electrónico destinado “{{tos.companyEmail}}”. Su solicitud deberá indicar \'Nombre completo\' (nombre o nombres y apellido o apellidos), \'copia simple de su cédula nacional de identidad\' o, en medios electrónicos, versión digitalizada de la misma (escaneo), indicación del correo electrónico o dirección física que designe para notificaciones y algún número telefónico de contacto. En un plazo máximo de 3 días hábiles contados a partir de la fecha de recepción de su solicitud de revocación le daremos contestación sobre la procedencia de la misma, por medio de correo electrónico dirigido a su persona, enviado a la dirección de correo electrónico que haya indicado en la propia solicitud. La revocación no tiene efectos retroactivos. Solo opera a contar de la fecha de notificación a {{tos.companyName}}.</p><h3>Actualización de la Política de Privacidad</h3><p>Cualquier cambio a la Política de Privacidad del Sitio Web será anunciado en esta página.</p><p>Todos los derechos reservados.</p><h2>TÉRMINOS Y CONDICIONES PARA EL USO DE ESTE SITIO WEB</h2><h3>Condiciones generales</h3><p>Comercial Javerim LTDA con domicilio en Chesterton 8677, comuna de Las Condes, Santiago, (en adelante, {{tos.companyName}}) se complace en ofrecerle este sitio web: {{tos.companyUrl}} (en adelante, el \"Sitio Web\"), su contenido y sus servicios. Por favor lea cuidadosamente estos términos y condiciones (en adelante los \"Términos y Condiciones\") relacionados con el uso de nuestro Sitio Web. Al usar nuestro Sitio Web, Usted acepta estos Términos y Condiciones, sin limitación ni condición alguna. Si no está de acuerdo con estos Términos y Condiciones, por favor no utilice nuestro Sitio Web. Cualquier persona física y/o jurídica puede navegar gratuitamente en el Sitio Web, y no es necesario ser Usuario para ello.</p><p>{{tos.companyName}} se reserva el derecho de revisar estos Términos y Condiciones o cualquier parte de ellos en cualquier momento sin previo aviso, actualizando esta publicación. Usted deberá visitar periódicamente esta página para revisar los presentes Términos y Condiciones que se aplican al uso que usted haga de nuestro Sitio Web.</p><p>{{tos.companyName}} se reserva el derecho de interrumpir, suspender o modificar en cualquier momento los servicios ofrecidos en el Sitio Web, ya sea en forma permanente o transitoria. No se requerirá la conformidad de los Usuarios, ni será necesario aviso previo alguno a dichos efectos. Asimismo, no garantiza el acceso o uso permanente al Sitio Web, ya que éste podría interrumpirse por cuestiones técnicas totalmente ajenas a {{tos.companyName}}. No obstante, si la suspensión o interrupción mencionada no obedeciere a razones de fuerza mayor o caso fortuito, {{tos.companyName}} se compromete a cumplir con las prestaciones que estuvieren pendientes al momento de la suspensión y/o interrupción.</p><p>{{tos.companyName}} no garantiza que el Sitio Web se encuentre libre de virus, gusanos o cualquier otro elemento que pueda llegar a dañar o alterar el normal funcionamiento de una computadora. Es su responsabilidad y obligación exclusiva contar con las herramientas adecuadas para detectar, desinfectar y/o prevenir cualquier tipo de elementos y/o posibles daños de esta naturaleza.</p><p>{{tos.companyName}} no se responsabiliza por cualquier daño y/o perjuicio que pueda producirse en los equipos informáticos de los Usuarios o de terceros como consecuencia de la navegación en el Sitio Web.</p><p>En virtud de la naturaleza de los productos ofrecidos en este Sitio Web, se recomienda conservar los productos enviados por {{tos.companyName}} en refrigeración, y consumir en el mismo día de adquisición de los mismos.</p><h3>Registro de Usuarios:</h3><p>Para realizar compras en el Sitio Web, es necesario registrarse como Usuario del mismo. Se deberá completar el Formulario en forma completa y correcta, incluyendo todos los datos personales que se requieran. El registro ocurre al momento de hacer su primer pedido, luego puede acceder al servicio ingresando su nombre de usuario y contraseña. Los datos personales suministrados, serán tratados por {{tos.companyName}} de manera totalmente confidencial. Sugerimos consultar nuestra \"Política de Privacidad\" publicada en el Sitio Web, previo a su registro como Usuario.</p><h3>Demoras y disponibilidad de los productos ofrecidos.</h3><p>La disponibilidad de todos los productos y/o servicios y/o promociones en el Sitio Web, está sujeta al stock diario de productos y/o servicios y/o promociones de {{tos.companyName}}. Todos los precios suministrados en el SitioWeb incluyen el Impuesto al Valor Agregado. Toda compra se encuentra sujeta a dicha disponibilidad, con lo cual se confirmará la disponibilidad con el número de pedido confirmado.</p><p>La información sobre productos y precios publicados en la página está sujeta a cambios y pueden ser modificados y/o actualizados a exclusiva discreción de {{tos.companyName}}.</p><h3>Información de los productos y del servicio. Validez de las promociones.</h3><p>La información sobre los productos, servicios y promociones que provee {{tos.companyName}} es suministrada en forma gratuita al Usuario en forma cierta, clara, detallada y veraz a través de el Sitio Web. En el caso de que se realicen ofertas y/o promociones de productos, éstas tendrán validez para los pedidos realizados desde el comienzo de aquellas, hasta la finalización de la oferta. Los términos y condiciones de las ofertas y/o promociones serán comunicados en el Sitio Web, y estarán siempre sujetas a la disponibilidad y stock de la materia prima con la cual se elaboran nuestros productos.</p><h3>Delivery. Alcance y tiempo de entrega. Consulta sobre el estado del envío.</h3><p>Las entregas de los productos de {{tos.companyName}} se realizarán en la dirección que el Usuario indique a tal efecto. La validez de la dirección indicada es de exclusiva responsabilidad de los Usuarios. Al realizar un pedido online, el Usuario recibirá en su correo electrónico una confirmación del mismo junto a un número de pedido, y tiempo aproximado de entrega. El tiempo de entrega depende del tiempo de elaboración del pedido, del tiempo de envío y del horario en que se efectuó el pedido. Dicho de tiempo de espera es aproximado. {{tos.companyName}} efectúa todo lo que se encuentra a su alcance para cumplir con el plazo de entrega de los pedidos.</p><h3>Gastos de envío</h3><p>Le recordamos consultar los precios de costos de envío, los cuales serán incluidos de manera explicita en el carro de compras para pedidos con despacho a domicilio. {{tos.companyName}} se reserva el derecho de cambiar estos precios sin previo aviso.</p><h3>Horarios de Atención al Público</h3><p>Se podrán realizar pedidos a través de la página web entre las 12:00 y las 23:30 horas en días hábiles en que los locales de {{tos.companyName}} estén operando.</p><h3>Facturación</h3><p>Junto con la entrega del pedido, se le entregará la boleta correspondiente con la información clara y precisa del pedido.</p><h3>Cancelación del pedido</h3><p>Sin perjuicio de lo establecido en los presentes Términos y Condiciones, el Usuario podrá cancelar su pedido telefónicamente. Sugerimos contactarse en cuanto antes para la cancelación del mismo, ya que {{tos.companyName}} trabaja con productos frescos, que requieren la elaboración en el momento del pedido.</p><h3>Registro de reclamos. Atención personalizada.</h3><p>{{tos.companyName}} habilita un registro de reclamos donde quedarán asentadas las presentaciones de los usuarios. Los reclamos podrán efectuarse a través de {{tos.companyUrl}}/contacto (completando todos los campos requeridos). Los reclamos efectuados serán respondidos por {{tos.companyName}} telefónicamente o vía correo electrónico. Dentro de los 10 días hábiles siguientes. {{tos.companyName}} se compromete además a atender su reclamo y efectuar las averiguaciones pertinentes del mismo. Dándole la seriedad que a todo reclamo corresponde.</p><h3>Prohibiciones</h3><p>Se les prohíbe terminantemente a los Usuarios y/o quienes naveguen en el Sitio Web a: a) Consignar datos falsos en el Formulario y/o al momento de realizar un pedido, y/o en cualquier otro momento que le sea requerida cualquier tipo de información o datos personales; y b) Usar programas, software o aparatos automáticos o manuales para monitorear o copiar la información o cualquier contenido del Sitio Web sin previo consentimiento de {{tos.companyName}}.</p><h3>Derechos reservados. Propiedad Intelectual</h3><p>Todos los derechos del presente Sitio Webestán reservados. El contenido del presente Sitio Web, incluyendo aunque no limitado al texto, logos, gráficos y todo el diseño en general, es de propiedad o uso exclusivo de su titular registrado y se encuentra protegido por la legislación nacional e internacional vigente sobre propiedad intelectual.</p><h3>Enlaces a Sitios de Terceros</h3><p>Como una cortesía, hemos proporcionado enlaces a ciertos sitios web de terceros. Al proporcionar estos enlaces, {{tos.companyName}} no está endosando, adoptando, o accediendo al contenido de estos sitios enlazados o a los productos y servicios de estos terceros ajenos a {{tos.companyName}}. {{tos.companyName}} no revisa o controla de manera alguna el contenido de estos sitios de terceros y ese contenido no forma parte de nuestro Sitio Web. {{tos.companyName}} niega expresamente cualquier responsabilidad por el contenido de cualquier sitio de terceros enlazado a nuestro Sitio Web o los productos y servicios de estos terceros. {{tos.companyName}} no se responsabiliza, ni responderá de manera alguna por los daños y perjuicios, ya sean actuales o eventuales, materiales o morales, directos o indirectos, que sufrieren los usuarios y que se derivaran de la información contenida en tales sitios de terceros o de la relación que los usuarios pudieren entablar con tales terceros. {{tos.companyName}} no garantiza el contenido o exactitud de los materiales de los sitios de terceros, o los productos y servicios de terceros. {{tos.companyName}} le ruega que verifique la seguridad y autenticidad de los sitios de terceros a los que acceda a través de un enlace en nuestro Sitio.</p><h3>Ley Aplicable y Jurisdicción</h3><p>Estos Términos y Condiciones se rigen por y serán interpretados de acuerdo a las leyes Chilenas. Tendrán jurisdicción sobre cualquier acción relacionada con estos Términos y Condiciones únicamente los Tribunales Ordinarios de Justicia asiento en la ciudad de Santiago de Chile.</p><h3>Validez por Separado</h3><p>Si cualquiera de las cláusulas incluidas en estos Términos y Condiciones se considerase inválida o inaplicable por cualquier corte o jurisdicción competente, las otras cláusulas incluidas en estos Términos y Condiciones de Uso permanecerán vigentes y resultarán aplicables. Cualquier cláusula incluida en estos Términos y Condiciones que sea considerada inválida o inaplicable parcialmente o hasta cierto punto únicamente, permanecerá vigente y resultará aplicable hasta el grado en el que haya sido declarada inválida o inaplicable. {{tos.companyName}} podrá reemplazar dicha cláusula inválida o inaplicable incluida en estos Términos y Condiciones con otra cláusula válida y aplicable que alcance, hasta el grado posible, los propósitos económicos, comerciales y otros propósitos de dicha cláusula inválida o inaplicable.</p><h3>Acuerdo Completo</h3><p>Estos Términos y Condiciones representan el acuerdo en su totalidad entre usted y {{tos.companyName}} referente a la utilización del Sitio Web y temas relacionados al mismo y no serán modificados excepto por {{tos.companyName}}, mediante su publicación en el Sitio Web. {{tos.companyName}} se reserva el derecho de modificar los términos y condiciones de uso de este Sitio Web y tales cambios tendrán vigencia desde su publicación en el Sitio Web. Usted estará obligado a revisar periódicamente los Términos y Condiciones publicados para verificar cualquier modificación que pudieren haber sufrido, y la sola utilización del Sitio Web implicará la aceptación total e incondicional de estos Términos y Condiciones, sin necesidad de manifestación alguna de su parte.</p><h3>Actualización de Términos y Condiciones.</h3><p>Cualquier cambio a la Política de Privacidad del Sitio Web será anunciado en esta página.</p></div>");
$templateCache.put("app/tos/mobile/tos-mx.html","<div class=\"tos\"><h1>POLÍTICA DE PRIVACIDAD</h1><p>{{tos.companyName}} respeta la privacidad de cada individuo y valora la confidencialidad de sus clientes. Esta Política de Privacidad (en adelante, la \"Política de Privacidad\") establece las prácticas de {{tos.companyName}} con respecto a la recopilación, uso, y divulgación de información que usted nos proporcione por medio del sitio web {{tos.companyUrl}} (en adelante, el \"Sitio Web\"). Por favor lea toda la Política de Privacidad antes de utilizar este Sitio Web o de proporcionar información a través del mismo. Al utilizar este Sitio Web, y siempre que usted remita información por medio del mismo a {{tos.companyName}}, usted acepta tácitamente los términos de esta Política de Privacidad.</p><h3>Recopilación de Datos Personales</h3><p>{{tos.companyName}} respeta su derecho a la protección de sus datos personales, los cuales están amparados por las Leyes Chilenas. {{tos.companyName}} solamente recopilará datos identificables personales sin los cuales se tornaría imposible brindar los servicios de {{tos.companyName}}, tales como su nombre, dirección, teléfono, celular, email y fecha de nacimiento, cuando usted los proporcione de forma voluntaria a {{tos.companyName}}. El Usuario que proporciona de la manera descrita sus datos personales, lo hace en forma expresa, libre y consentida y autoriza automáticamente a que {{tos.companyName}} utilice esta información, conforme a lo que describe esta Política de Privacidad.</p><p>La información y/o datos que voluntariamente nos facilite a través del Sitio Web, podrán ser incorporados a la base de datos con la finalidad de realizar la gestión y el mantenimiento de nuestras relaciones con Ud., es decir, poder enviarle información sobre nuestros productos, promociones, descuentos, publicidad, etc. De ninguna manera {{tos.companyName}} le solicitará para su base de datos, información personal que revele su origen racial y étnico, opiniones políticas, convicciones religiosas, filosóficas o morales, afiliación sindical e información referente a su salud o a su vida sexual (\"Datos Sensibles\").</p><p>La base de datos será guardada y almacenada y se encuentra debidamente registrada conforme la ley aplicable. Esta información no será transferida a terceros sin su consentimiento previo. {{tos.companyName}} mantiene los datos de información personal identificable, proporcionada voluntariamente en una base de datos electrónica. A pesar de que {{tos.companyName}} hace todos los esfuerzos razonables por proteger la información recopilada por medio del Sitio Web, por favor tome en cuenta que siempre existe un riesgo implícito al suministrar datos por medio del Internet. {{tos.companyName}} no puede garantizar que nuestro Sitio Web sea 100% seguro contra la manipulación ilegal o la piratería. Cualquier información transmitida por medio de Internet puede estar en peligro; sin embargo, una vez que {{tos.companyName}} recibe esta información y se añade a nuestra base de datos, recibe la misma protección que {{tos.companyName}} extiende a su propia información confidencial. Se adoptarán las medidas técnicas y organizativas necesarias para garantizar la seguridad y confidencialidad de sus datos personales.</p><h3>Actualización de su Información</h3><p>Si desea conocer los datos de su persona que constan en la base de datos, actualizarlos o rectificar errores, o ejercer el derecho de retiro o bloqueo total o parcial de su nombre de nuestra base de datos, por favor comuníquese por correo a Chesterton 8677, Comuna de Las Condes, Santiago de Chile, o por correo electrónico a {{tos.companyEmail}}, con el asunto: DATOS PERSONALES.</p><h3>Actualización de la Política de Privacidad</h3><p>Cualquier cambio a la Política de Privacidad del Sitio Web será anunciado en esta página.</p><p>Todos los derechos reservados.</p></div>");
$templateCache.put("app/tos/mobile/tos.html","<header-cart></header-cart><div class=\"container-contenido\"><ng-include src=\"tos.templateUrl()\"></ng-include></div>");
$templateCache.put("app/seleable/desktop/extras_modifier_groups.html","<div class=\"product-group\"><div class=\"selection-header\"><div class=\"title-container\"><p class=\"selection-title\">{{modifier_group.name}} <span class=\"description\" ng-if=\"modifier_group.description\">{{modifier_group.description}}</span></p></div></div><ng-include src=\"\'app/seleable/desktop/modifier_groups.html\'\"></ng-include></div>");
$templateCache.put("app/seleable/desktop/modifiable_product.html","<div class=\"modal-body scroll-bar\" ng-class=\"{\'submiteable\': seleable.submiteable}\" stop-event=\"touchend\"><div class=\"product-img\"><product-badge badge=\"highlight-text\" seleable=\"seleable.product\" modal=\"true\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.currentImage.large}}\"></div><div class=\"modal-close\"><button class=\"close\" ng-click=\"seleable.cancel()\"><i class=\"icon-x\"></i></button></div><div class=\"fav\"><div class=\"like-btn\"><a ng-if=\"seleable.customer\" class=\"favorite\" ng-click=\"seleable.toggleLike()\"><img ng-if=\"seleable.pref > 0\" src=\"assets/images/favorite-heart.svg\" ng-mouseenter=\"seleable.addHeartEmpty($event)\" ng-mouseleave=\"seleable.addHeartFull($event)\"> <img ng-if=\"seleable.pref <= 0\" src=\"assets/images/favorite-heart-empty.svg\" ng-mouseenter=\"seleable.addHeartFull($event)\" ng-mouseleave=\"seleable.addHeartEmpty($event)\"></a></div></div></div><div class=\"product-info\"><div class=\"product-text-container\"><div class=\"text-container\"><div class=\"title-container\"><h4 class=\"product-title\">{{seleable.product.name}}</h4><div class=\"slides\" ng-if=\"(seleable.product).servings > 1 && seleable.hasServingsSeleable\"><img src=\"assets/images/{{$environment}}/slides.svg\"><p>{{(seleable.product).servings}}</p></div></div><div class=\"title-container\"><h4 class=\"product-title discount-price\" ng-show=\"(seleable.product.discount && seleable.cart.discountable()) || (!seleable.product.discount && seleable.product.normal_price > seleable.product.special_price && seleable.product.special_price > 0)\">{{seleable.cart.discountPriceIntl(seleable.product.id, seleable.product.type, seleable.additionalPrice)}}</h4><h4 class=\"product-title price\">{{seleable.cart.priceIntl(seleable.product.id, true, seleable.product.type, seleable.additionalPrice)}}</h4></div></div><div class=\"text-container\"><p id=\"product-description-{{seleable.product.id}}\" class=\"product-description\">{{seleable.html.addInnerHTML(\'product-description-\' + seleable.product.id, seleable.product.description)}}</p></div></div><div class=\"product-groups-container\"><div class=\"product-group\"><div class=\"selection-header\"><div class=\"title-container\"><p class=\"selection-title\">Incluye:</p></div></div></div><div ng-repeat=\"modifier_group in seleable.product.modifier_groups | orderBy:\'position\'\"><div class=\"product-group\" ng-if=\"!modifier_group.extra_price || modifier_group.extra_price == 0\"><div class=\"selection-header\" ng-if=\"modifier_group.max_permitted_per_option != 0\"><div class=\"title-container\"><p class=\"selection-title\">{{modifier_group.name}} <span class=\"description\" ng-if=\"modifier_group.description\">{{modifier_group.description}}</span></p></div></div><ng-include src=\"\'app/seleable/desktop/modifier_groups.html\'\"></ng-include></div><div ng-if=\"modifier_group.extra_price > 0\"><ng-include src=\"\'app/seleable/desktop/extras_modifier_groups.html\'\"></ng-include></div></div></div></div></div><div class=\"modal-footer\" ng-class=\"{\'submiteable\': seleable.submiteable}\"><div class=\"container-btn-primary\"><div class=\"product-notice\" ng-hide=\"seleable.submiteable\"><div class=\"highlight\"><span>*</span> deberás elegir una opción</div></div><button class=\"btn btn-primary\" ng-click=\"seleable.addToCart(seleable.productQuantity)\" ng-disabled=\"!seleable.submiteable\" ng-switch=\"seleable.showTotalOnButton\"><span ng-switch-when=\"true\">Agregar {{seleable.calculateTotals(seleable.product, true, seleable.productQuantity)}}</span> <span ng-switch-default=\"\">Agregar al carro</span></button></div></div>");
$templateCache.put("app/seleable/desktop/modifier_groups.html","<div class=\"variant-option\" ng-repeat=\"modifier_group_category in modifier_group.modifier_group_categories\"><p class=\"selection-title-text\" ng-if=\"modifier_group_category.name\">{{modifier_group_category.name}} <span ng-if=\"modifier_group_category.description\">: {{modifier_group_category.description}}</span></p><div class=\"explanation-container\" ng-if=\"modifier_group.extra_price > 0\"><p class=\"selection-explanation\">Valor adicional <span class=\"extra-price\">{{seleable.cart.parseIntl(modifier_group.extra_price)}}</span></p></div><div class=\"modifier-group\" ng-repeat=\"modifier_group_variant in modifier_group_category.modifier_group_variants\"><div class=\"modifier-item\" ng-if=\"modifier_group.min_selection == 1 && modifier_group.max_selection == 1 && modifier_group.max_permitted_per_option == 1\"><input id=\"radio-product-{{modifier_group_variant.id}}-{{modifier_group_variant.variant.id}}\" name=\"radio_{{modifier_group.id}}\" type=\"radio\" ng-click=\"seleable.modifyRadioVariant(modifier_group.id, modifier_group_variant.variant.id)\" ng-checked=\"seleable.selectedProductVariants[modifier_group.id].variants[modifier_group_variant.variant.id].quantity == 1\"> <label class=\"buttonselect\" for=\"radio-product-{{modifier_group_variant.id}}-{{modifier_group_variant.variant.id}}\" ng-click=\"seleable.modifyRadioVariant(modifier_group.id, modifier_group_variant.variant.id)\"><div class=\"container-info\"><span class=\"variant-name\">{{modifier_group_variant.variant.name}}</span></div><div class=\"container-price\"><span class=\"variant-extra-price-discount\" ng-if=\"seleable.hasExtraPriceDiscount && modifier_group_variant.extra_price > 0\">+ {{seleable.cart.extraPriceIntl(modifier_group_variant.extra_price, false)}}</span> <span class=\"variant-extra-price\" ng-if=\"modifier_group_variant.extra_price > 0\">+ {{seleable.cart.extraPriceIntl(modifier_group_variant.extra_price, true)}}</span></div></label></div><div class=\"modifier-item\" ng-class=\"seleable.selectedProductVariants[modifier_group.id].variants[modifier_group_variant.variant.id].quantity >= seleable.selectedProductVariants[modifier_group.id].max_permitted_per_option || seleable.selectedProductVariants[modifier_group.id].amountChecked >= seleable.selectedProductVariants[modifier_group.id].max_selection ? \'disabled\' : \'\'\" ng-if=\"modifier_group.min_selection != 1 || modifier_group.max_selection != 1 || modifier_group.max_permitted_per_option != 1\"><div class=\"item-box-quantity\" ng-if=\"modifier_group.max_permitted_per_option != 0\"><button class=\"btn-quantity\" ng-click=\"seleable.modifyVariant(modifier_group.id, modifier_group_variant.variant.id, \'substract\')\" ng-disabled=\"seleable.selectedProductVariants[modifier_group.id].variants[modifier_group_variant.variant.id].quantity === 0\"><i class=\"icon-minus\"></i></button> <input class=\"input-quantity\" type=\"text\" id=\"inputSumador\" ng-value=\"seleable.selectedProductVariants[modifier_group.id].variants[modifier_group_variant.variant.id].quantity\" name=\"quantity\" disabled=\"\"> <button class=\"btn-quantity\" ng-click=\"seleable.modifyVariant(modifier_group.id, modifier_group_variant.variant.id, \'add\')\" ng-disabled=\"seleable.selectedProductVariants[modifier_group.id].variants[modifier_group_variant.variant.id].quantity === modifier_group.max_selection\"><i class=\"icon-plus\"></i></button></div><label class=\"buttonselect\"><div class=\"container-info\"><span class=\"variant-name\">{{modifier_group_variant.variant.name}}</span></div><div class=\"container-price\"><span class=\"variant-extra-price-discount\" ng-if=\"seleable.hasExtraPriceDiscount && modifier_group_variant.extra_price > 0\">+ {{seleable.cart.extraPriceIntl(modifier_group_variant.extra_price, false)}}</span> <span class=\"variant-extra-price\" ng-if=\"modifier_group_variant.extra_price > 0\">+ {{seleable.cart.extraPriceIntl(modifier_group_variant.extra_price, true)}}</span></div></label></div></div></div>");
$templateCache.put("app/seleable/desktop/product.html","<div class=\"modal-body\" stop-event=\"touchend\"><div class=\"product-img\"><product-badge badge=\"highlight-text\" seleable=\"seleable.product\" modal=\"true\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.currentImage.large}}\"></div><div class=\"modal-close\"><button class=\"close\" ng-click=\"seleable.cancel()\"><i class=\"icon-x\"></i></button></div><div class=\"fav\"><div class=\"like-btn\"><a ng-if=\"seleable.customer\" class=\"favorite\" ng-click=\"seleable.toggleLike()\"><img ng-if=\"seleable.pref > 0\" src=\"assets/images/favorite-heart.svg\" ng-mouseenter=\"seleable.addHeartEmpty($event)\" ng-mouseleave=\"seleable.addHeartFull($event)\"> <img ng-if=\"seleable.pref <= 0\" src=\"assets/images/favorite-heart-empty.svg\" ng-mouseenter=\"seleable.addHeartFull($event)\" ng-mouseleave=\"seleable.addHeartEmpty($event)\"></a></div></div></div><div class=\"product-info padding-top\"><div class=\"product-text-container\"><div class=\"text-container\"><div class=\"title-container\"><h4 class=\"product-title\">{{seleable.product.name}}</h4><div class=\"slides\" ng-if=\"(seleable.product).servings > 1 && seleable.hasServingsSeleable\"><img src=\"assets/images/{{$environment}}/slides.svg\"><p>{{(seleable.product).servings}}</p></div></div><div class=\"title-container\"><h4 class=\"product-title discount-price\" ng-show=\"(seleable.product.discount && seleable.cart.discountable()) || (!seleable.product.discount && seleable.product.normal_price > seleable.product.special_price && seleable.product.special_price > 0)\">{{seleable.cart.discountPriceIntl(seleable.product.id, seleable.product.type, seleable.additionalPrice)}}</h4><h4 class=\"product-title price\">{{seleable.cart.priceIntl(seleable.product.id, true, seleable.product.type, seleable.additionalPrice)}}</h4></div></div><div class=\"text-container\"><p class=\"product-description\">{{seleable.product.description}}</p></div></div></div></div><div class=\"modal-footer\"><div class=\"container-btn-primary\"><button class=\"btn btn-primary\" ng-click=\"seleable.addToCart(seleable.productQuantity)\" ng-switch=\"seleable.showTotalOnButton\"><span ng-switch-when=\"true\">Agregar {{seleable.calculateTotals(seleable.product, true, seleable.productQuantity)}}</span> <span ng-switch-default=\"\">Agregar al carro</span></button></div></div>");
$templateCache.put("app/seleable/desktop/promotion.html","<div class=\"modal-body scroll-bar\" ng-class=\"{\'submiteable\': seleable.submiteable}\" stop-event=\"touchend\"><div class=\"product-img\"><product-badge badge=\"highlight-text\" seleable=\"seleable.promotion\" modal=\"true\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.currentImage.large}}\"></div><div class=\"modal-close\"><button class=\"close\" ng-click=\"seleable.cancel()\"><i class=\"icon-x\"></i></button></div><div class=\"fav\"><div class=\"like-btn\"><a ng-if=\"seleable.customer\" class=\"favorite\" ng-click=\"seleable.toggleLike()\"><img ng-if=\"seleable.pref > 0\" src=\"assets/images/favorite-heart.svg\" ng-mouseenter=\"seleable.addHeartEmpty($event)\" ng-mouseleave=\"seleable.addHeartFull($event)\"> <img ng-if=\"seleable.pref <= 0\" src=\"assets/images/favorite-heart-empty.svg\" ng-mouseenter=\"seleable.addHeartFull($event)\" ng-mouseleave=\"seleable.addHeartEmpty($event)\"></a></div></div></div><div class=\"product-info\"><div class=\"product-text-container\"><div class=\"text-container\"><div class=\"title-container\"><h4 class=\"product-title\">{{seleable.promotion.name}}</h4></div><div class=\"title-container\"><h4 class=\"product-title discount-price\" ng-show=\"(seleable.promotion.discount && seleable.cart.discountable()) || (!seleable.promotion.discount && seleable.promotion.normal_price > seleable.promotion.special_price && seleable.promotion.special_price > 0)\">{{seleable.cart.discountPriceIntl(seleable.promotion.id, seleable.promotion.type, seleable.additionalPrice)}}</h4><h4 class=\"product-title price\">{{seleable.cart.priceIntl(seleable.promotion.id, true, seleable.promotion.type, seleable.additionalPrice)}}</h4></div></div><div class=\"text-container description\"><p class=\"product-description\">{{seleable.promotion.description}}</p><p class=\"product-description items-limit\">Incluye:</p></div></div><div class=\"product-groups-container\"><div class=\"product-group\" ng-repeat=\"promotion_product_group in seleable.promotion.promotion_product_groups\"><p class=\"product-group-title\" ng-if=\"promotion_product_group.items_limit > 0\">{{promotion_product_group.name}}: <span ng-if=\"promotion_product_group.description\">{{promotion_product_group.description}}</span> <span ng-if=\"promotion_product_group.items_limit > 0\">(Máx {{promotion_product_group.free_items_quantity}})</span></p><p class=\"product-group-description extra-price\" ng-if=\"promotion_product_group.extra_price_per_item > 0\">Valor adicional: {{seleable.cart.parseIntl(promotion_product_group.extra_price_per_item)}}</p><div class=\"variant-option\"><div class=\"modifier-group\" ng-repeat=\"product in promotion_product_group.products\" ng-disabled=\"seleable.shouldDisableElem(promotion_product_group, product)\" ng-switch=\"promotion_product_group.items_limit == 0 || promotion_product_group.items_limit == 1 && promotion_product_group.free_items_quantity == 1 && promotion_product_group.extra_price_per_item == 0\"><div class=\"modifier-item\" ng-switch-when=\"true\"><input id=\"radio-product-{{promotion_product_group.id}}-{{product.id}}\" name=\"radio_{{promotion_product_group.id}}\" type=\"radio\" ng-click=\"seleable.shouldDisableGroup(promotion_product_group, product)\" ng-checked=\"seleable.selectedPromotionProducts[promotion_product_group.id][product.id].selected == true\" ng-if=\"promotion_product_group.items_limit == 1\"> <label class=\"buttonselect items-limit\" for=\"radio-product-{{promotion_product_group.id}}-{{product.id}}\"><div class=\"container-info\"><span class=\"variant-name\">{{product.name}}</span></div><div class=\"container-price\"><span class=\"variant-extra-price\" ng-if=\"product.price > 0\">+ {{seleable.cart.parseIntl(product.price)}}</span></div></label></div><div class=\"modifier-item\" ng-switch-default=\"\"><input id=\"radio-product-{{promotion_product_group.id}}-{{product.id}}\" type=\"checkbox\" ng-model=\"seleable.selectedPromotionProducts[promotion_product_group.id][product.id].selected\" ng-change=\"seleable.shouldDisableGroup(promotion_product_group, product)\" ng-disabled=\"seleable.shouldDisableElem(promotion_product_group, product)\"> <label class=\"buttonselect\" for=\"radio-product-{{promotion_product_group.id}}-{{product.id}}\"><div class=\"container-info\"><span class=\"variant-name\">{{product.name}}</span></div><div class=\"container-price\"><span class=\"variant-extra-price\" ng-if=\"product.price > 0\">+ {{seleable.cart.parseIntl(product.price)}}</span></div></label></div></div></div></div></div></div></div><div class=\"modal-footer\" ng-class=\"{\'submiteable\': seleable.submiteable}\"><div class=\"container-btn-primary\"><div class=\"product-notice\" ng-hide=\"seleable.submiteable\"><div class=\"highlight\"><span>*</span> deberás elegir una opción</div></div><button class=\"btn btn-primary\" ng-click=\"seleable.addToCart(seleable.productQuantity)\" ng-disabled=\"!seleable.submiteable\" ng-switch=\"seleable.showTotalOnButton\"><span ng-switch-when=\"true\">Agregar {{seleable.calculateTotals(seleable.promotion, true, seleable.productQuantity)}}</span> <span ng-switch-default=\"\">Agregar al carro</span></button></div></div>");
$templateCache.put("app/seleable/desktop/seleable.html","<div class=\"modal-seleable\" ng-if=\"seleable.promotion\"><ng-include class=\"modal-box\" src=\"\'app/seleable/desktop/promotion.html\'\"></ng-include></div><div class=\"modal-seleable\" ng-if=\"seleable.product && seleable.product.modifier_groups.length == 0\"><ng-include class=\"modal-box\" src=\"\'app/seleable/desktop/product.html\'\"></ng-include></div><div class=\"modal-seleable\" ng-if=\"seleable.product && seleable.product.modifier_groups.length > 0\"><ng-include class=\"modal-box\" src=\"\'app/seleable/desktop/modifiable_product.html\'\"></ng-include></div>");
$templateCache.put("app/seleable/mobile/extras_modifier_groups.html","<div class=\"product-group\"><div class=\"selection-header\"><div class=\"title-container\"><p class=\"selection-title\">{{modifier_group.name}} <span class=\"description\" ng-if=\"modifier_group.description\">{{modifier_group.description}}</span></p></div></div><ng-include src=\"\'app/seleable/mobile/modifier_groups.html\'\"></ng-include></div>");
$templateCache.put("app/seleable/mobile/modifiable_product.html","<div class=\"modal-body scroll-bar\" ng-class=\"{\'submiteable\': seleable.submiteable}\" stop-event=\"touchend\"><div class=\"product-img\"><product-badge badge=\"highlight-text\" seleable=\"seleable.product\" modal=\"true\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.currentImage.large}}\"></div><div class=\"modal-close\"><button class=\"close\" ng-click=\"seleable.cancel()\"><i class=\"icon-x\"></i></button></div><div class=\"fav\"><div class=\"like-btn\"><a ng-if=\"seleable.customer\" class=\"favorite\" ng-click=\"seleable.toggleLike()\"><img ng-if=\"seleable.pref > 0\" src=\"assets/images/favorite-heart.svg\"> <img ng-if=\"seleable.pref <= 0\" src=\"assets/images/favorite-heart-empty.svg\"></a></div></div></div><div class=\"product-info\"><div class=\"product-text-container\"><div class=\"text-container\"><div class=\"title-container\"><h4 class=\"product-title\">{{seleable.product.name}}</h4><div class=\"slides\" ng-if=\"(seleable.product).servings > 1 && seleable.hasServingsSeleable\"><img src=\"assets/images/{{$environment}}/slides.svg\"><p>{{(seleable.product).servings}}</p></div></div></div><div class=\"text-container\"><h4 class=\"product-title discount-price\" ng-show=\"(seleable.product.discount && seleable.cart.discountable()) || (!seleable.product.discount && seleable.product.normal_price > seleable.product.special_price && seleable.product.special_price > 0)\">{{seleable.cart.discountPriceIntl(seleable.product.id, seleable.product.type, seleable.additionalPrice)}}</h4><h4 class=\"product-title price\">{{seleable.cart.priceIntl(seleable.product.id, true, seleable.product.type, seleable.additionalPrice)}}</h4></div><div class=\"text-container\"><p id=\"product-description-{{seleable.product.id}}\" class=\"product-description\">{{seleable.html.addInnerHTML(\'product-description-\' + seleable.product.id, seleable.product.description)}}</p></div></div><div class=\"product-groups-container\"><div class=\"product-group\"><div class=\"selection-header\"><div class=\"title-container\"><p class=\"selection-title\">Incluye:</p></div></div></div><div ng-repeat=\"modifier_group in seleable.product.modifier_groups | orderBy:\'position\'\"><div class=\"product-group\" ng-if=\"!modifier_group.extra_price || modifier_group.extra_price == 0\"><div class=\"selection-header\" ng-if=\"modifier_group.max_permitted_per_option != 0\"><div class=\"title-container\"><p class=\"selection-title\">{{modifier_group.name}} <span class=\"description\" ng-if=\"modifier_group.description\">{{modifier_group.description}}</span></p></div></div><ng-include src=\"\'app/seleable/mobile/modifier_groups.html\'\"></ng-include></div><div ng-if=\"modifier_group.extra_price > 0\"><ng-include src=\"\'app/seleable/mobile/extras_modifier_groups.html\'\"></ng-include></div></div></div></div></div><div class=\"modal-footer\" ng-class=\"{\'submiteable\': seleable.submiteable}\"><div class=\"container-btn-primary\"><div class=\"product-notice\" ng-hide=\"seleable.submiteable\"><div class=\"highlight\"><span>*</span> deberás elegir una opción</div></div><button class=\"btn btn-primary\" ng-click=\"seleable.addToCart(seleable.productQuantity)\" ng-disabled=\"!seleable.submiteable\" ng-switch=\"seleable.showTotalOnButton\"><span ng-switch-when=\"true\">Agregar {{seleable.calculateTotals(seleable.product, true, seleable.productQuantity)}}</span> <span ng-switch-default=\"\">Agregar al carro</span></button></div></div>");
$templateCache.put("app/seleable/mobile/modifier_groups.html","<div class=\"variant-option\" ng-repeat=\"modifier_group_category in modifier_group.modifier_group_categories\"><p class=\"selection-title-text\" ng-if=\"modifier_group_category.name\">{{modifier_group_category.name}} <span ng-if=\"modifier_group_category.description\">: {{modifier_group_category.description}}</span></p><div class=\"explanation-container\" ng-if=\"modifier_group.extra_price > 0\"><p class=\"selection-explanation\">Valor adicional <span class=\"extra-price\">{{seleable.cart.parseIntl(modifier_group.extra_price)}}</span></p></div><div class=\"modifier-group\" ng-repeat=\"modifier_group_variant in modifier_group_category.modifier_group_variants\"><div class=\"modifier-item\" ng-if=\"modifier_group.min_selection == 1 && modifier_group.max_selection == 1 && modifier_group.max_permitted_per_option == 1\"><input id=\"radio-product-{{modifier_group_variant.id}}-{{modifier_group_variant.variant.id}}\" name=\"radio_{{modifier_group.id}}\" type=\"radio\" ng-click=\"seleable.modifyRadioVariant(modifier_group.id, modifier_group_variant.variant.id)\" ng-checked=\"seleable.selectedProductVariants[modifier_group.id].variants[modifier_group_variant.variant.id].quantity == 1\"> <label class=\"buttonselect\" for=\"radio-product-{{modifier_group_variant.id}}-{{modifier_group_variant.variant.id}}\" ng-click=\"seleable.modifyRadioVariant(modifier_group.id, modifier_group_variant.variant.id)\"><div class=\"container-info\"><span class=\"variant-name\">{{modifier_group_variant.variant.name}}</span></div><div class=\"container-price\"><span class=\"variant-extra-price-discount\" ng-if=\"seleable.hasExtraPriceDiscount && modifier_group_variant.extra_price > 0\">+ {{seleable.cart.extraPriceIntl(modifier_group_variant.extra_price, false)}}</span> <span class=\"variant-extra-price\" ng-if=\"modifier_group_variant.extra_price > 0\">+ {{seleable.cart.extraPriceIntl(modifier_group_variant.extra_price, true)}}</span></div></label></div><div class=\"modifier-item\" ng-class=\"seleable.selectedProductVariants[modifier_group.id].variants[modifier_group_variant.variant.id].quantity >= seleable.selectedProductVariants[modifier_group.id].max_permitted_per_option || seleable.selectedProductVariants[modifier_group.id].amountChecked >= seleable.selectedProductVariants[modifier_group.id].max_selection ? \'disabled\' : \'\'\" ng-if=\"modifier_group.min_selection != 1 || modifier_group.max_selection != 1 || modifier_group.max_permitted_per_option != 1\"><div class=\"item-box-quantity\" ng-if=\"modifier_group.max_permitted_per_option != 0\"><button class=\"btn-quantity\" ng-click=\"seleable.modifyVariant(modifier_group.id, modifier_group_variant.variant.id, \'substract\')\" ng-disabled=\"seleable.selectedProductVariants[modifier_group.id].variants[modifier_group_variant.variant.id].quantity === 0\"><i class=\"icon-minus\"></i></button> <input class=\"input-quantity\" type=\"text\" id=\"inputSumador\" ng-value=\"seleable.selectedProductVariants[modifier_group.id].variants[modifier_group_variant.variant.id].quantity\" name=\"quantity\" disabled=\"\"> <button class=\"btn-quantity\" ng-click=\"seleable.modifyVariant(modifier_group.id, modifier_group_variant.variant.id, \'add\')\" ng-disabled=\"seleable.selectedProductVariants[modifier_group.id].variants[modifier_group_variant.variant.id].quantity === modifier_group.max_selection\"><i class=\"icon-plus\"></i></button></div><label class=\"buttonselect\"><div class=\"container-info\"><span class=\"variant-name\">{{modifier_group_variant.variant.name}}</span></div><div class=\"container-price\"><span class=\"variant-extra-price-discount\" ng-if=\"seleable.hasExtraPriceDiscount && modifier_group_variant.extra_price > 0\">+ {{seleable.cart.extraPriceIntl(modifier_group_variant.extra_price, false)}}</span> <span class=\"variant-extra-price\" ng-if=\"modifier_group_variant.extra_price > 0\">+ {{seleable.cart.extraPriceIntl(modifier_group_variant.extra_price, true)}}</span></div></label></div></div></div>");
$templateCache.put("app/seleable/mobile/product.html","<div class=\"modal-body scroll-bar\" stop-event=\"touchend\"><div class=\"product-img\"><product-badge badge=\"highlight-text\" seleable=\"seleable.product\" modal=\"true\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.currentImage.large}}\"></div><div class=\"modal-close\"><button class=\"close\" ng-click=\"seleable.cancel()\"><i class=\"icon-x\"></i></button></div><div class=\"fav\"><div class=\"like-btn\"><a ng-if=\"seleable.customer\" class=\"favorite\" ng-click=\"seleable.toggleLike()\"><img ng-if=\"seleable.pref > 0\" src=\"assets/images/favorite-heart.svg\"> <img ng-if=\"seleable.pref <= 0\" src=\"assets/images/favorite-heart-empty.svg\"></a></div></div></div><div class=\"product-info padding-top\"><div class=\"product-text-container\"><div class=\"text-container\"><div class=\"title-container\"><h4 class=\"product-title\">{{seleable.product.name}}</h4></div><div class=\"slides\" ng-if=\"(seleable.product).servings > 1 && seleable.hasServingsSeleable\"><img src=\"assets/images/{{$environment}}/slides.svg\"><p>{{(seleable.product).servings}}</p></div></div><div class=\"text-container\"><h4 class=\"product-title discount-price\" ng-show=\"(seleable.product.discount && seleable.cart.discountable()) || (!seleable.product.discount && seleable.product.normal_price > seleable.product.special_price && seleable.product.special_price > 0)\">{{seleable.cart.discountPriceIntl(seleable.product.id, seleable.product.type, seleable.additionalPrice)}}</h4><h4 class=\"product-title price\">{{seleable.cart.priceIntl(seleable.product.id, true, seleable.product.type, seleable.additionalPrice)}}</h4></div><div class=\"text-container\"><p class=\"product-description\">{{seleable.product.description}}</p></div></div></div></div><div class=\"modal-footer\"><div class=\"container-btn-primary\"><button class=\"btn btn-primary\" ng-click=\"seleable.addToCart(seleable.productQuantity)\" ng-switch=\"seleable.showTotalOnButton\"><span ng-switch-when=\"true\">Agregar {{seleable.calculateTotals(seleable.product, true, seleable.productQuantity)}}</span> <span ng-switch-default=\"\">Agregar al carro</span></button></div></div>");
$templateCache.put("app/seleable/mobile/promotion.html","<div class=\"modal-body scroll-bar\" ng-class=\"{\'submiteable\': seleable.submiteable}\" stop-event=\"touchend\"><div class=\"product-img\"><product-badge badge=\"highlight-text\" seleable=\"seleable.promotion\" modal=\"true\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.currentImage.large}}\"></div><div class=\"modal-close\"><button class=\"close\" ng-click=\"seleable.cancel()\"><i class=\"icon-x\"></i></button></div><div class=\"fav\"><div class=\"like-btn\"><a ng-if=\"seleable.customer\" class=\"favorite\" ng-click=\"seleable.toggleLike()\"><img ng-if=\"seleable.pref > 0\" src=\"assets/images/favorite-heart.svg\"> <img ng-if=\"seleable.pref <= 0\" src=\"assets/images/favorite-heart-empty.svg\"></a></div></div></div><div class=\"product-info\"><div class=\"product-text-container\"><div class=\"text-container\"><div class=\"title-container\"><h4 class=\"product-title promotion\">{{seleable.promotion.name}}</h4></div></div><div class=\"text-container\"><h4 class=\"product-title discount-price\" ng-show=\"(seleable.promotion.discount && seleable.cart.discountable()) || (!seleable.promotion.discount && seleable.promotion.normal_price > seleable.promotion.special_price && seleable.promotion.special_price > 0)\">{{seleable.cart.discountPriceIntl(seleable.promotion.id, seleable.promotion.type, seleable.additionalPrice)}}</h4><h4 class=\"product-title price-promotion\">{{seleable.cart.priceIntl(seleable.promotion.id, true, seleable.promotion.type, seleable.additionalPrice)}}</h4></div><div class=\"text-container description\"><p class=\"product-description\">{{seleable.promotion.description}}</p><p class=\"product-description items-limit\">Incluye:</p></div></div><div class=\"product-groups-container\"><div class=\"product-group\" ng-repeat=\"promotion_product_group in seleable.promotion.promotion_product_groups\"><p class=\"product-group-title\" ng-if=\"promotion_product_group.items_limit > 0\">{{promotion_product_group.name}}: <span ng-if=\"promotion_product_group.description\">{{promotion_product_group.description}}</span> <span ng-if=\"promotion_product_group.items_limit > 0\">(Máx {{promotion_product_group.free_items_quantity}})</span></p><p class=\"product-group-description extra-price\" ng-if=\"promotion_product_group.extra_price_per_item > 0\">Valor adicional: {{seleable.cart.parseIntl(promotion_product_group.extra_price_per_item)}}</p><div class=\"variant-option promotion\"><div class=\"modifier-group promotion\" ng-repeat=\"product in promotion_product_group.products\" ng-disabled=\"seleable.shouldDisableElem(promotion_product_group, product)\" ng-switch=\"promotion_product_group.items_limit == 0 || promotion_product_group.items_limit == 1 && promotion_product_group.free_items_quantity == 1 && promotion_product_group.extra_price_per_item == 0\"><div class=\"modifier-item\" ng-switch-when=\"true\"><input id=\"radio-product-{{promotion_product_group.id}}-{{product.id}}\" name=\"radio_{{promotion_product_group.id}}\" type=\"radio\" ng-click=\"seleable.shouldDisableGroup(promotion_product_group, product)\" ng-checked=\"seleable.selectedPromotionProducts[promotion_product_group.id][product.id].selected == true\" ng-if=\"promotion_product_group.items_limit == 1\"> <label class=\"buttonselect items-limit\" for=\"radio-product-{{promotion_product_group.id}}-{{product.id}}\"><div class=\"container-info\"><span class=\"variant-name\">{{product.name}}</span></div><div class=\"container-price\"><span class=\"variant-extra-price\" ng-if=\"product.price > 0\">+ {{seleable.cart.parseIntl(product.price)}}</span></div></label></div><div class=\"modifier-item\" ng-switch-default=\"\"><input id=\"radio-product-{{promotion_product_group.id}}-{{product.id}}\" type=\"checkbox\" ng-model=\"seleable.selectedPromotionProducts[promotion_product_group.id][product.id].selected\" ng-change=\"seleable.shouldDisableGroup(promotion_product_group, product)\" ng-disabled=\"seleable.shouldDisableElem(promotion_product_group, product)\"> <label class=\"buttonselect\" for=\"radio-product-{{promotion_product_group.id}}-{{product.id}}\"><div class=\"container-info\"><span class=\"variant-name\">{{product.name}}</span></div><div class=\"container-price\"><span class=\"variant-extra-price\" ng-if=\"product.price > 0\">+ {{seleable.cart.parseIntl(product.price)}}</span></div></label></div></div></div></div></div></div></div><div class=\"modal-footer\" ng-class=\"{\'submiteable\': seleable.submiteable}\"><div class=\"container-btn-primary\"><div class=\"product-notice\" ng-hide=\"seleable.submiteable\"><div class=\"highlight\"><span>*</span> deberás elegir una opción</div></div><button class=\"btn btn-primary\" ng-click=\"seleable.addToCart(seleable.productQuantity)\" ng-disabled=\"!seleable.submiteable\" ng-switch=\"seleable.showTotalOnButton\"><span ng-switch-when=\"true\">Agregar {{seleable.calculateTotals(seleable.promotion, true, seleable.productQuantity)}}</span> <span ng-switch-default=\"\">Agregar al carro</span></button></div></div>");
$templateCache.put("app/seleable/mobile/seleable.html","<div class=\"modal-seleable\" ng-if=\"seleable.promotion\"><ng-include class=\"modal-box\" src=\"\'app/seleable/mobile/promotion.html\'\"></ng-include></div><div class=\"modal-seleable\" ng-if=\"seleable.product && seleable.product.modifier_groups.length == 0\"><ng-include class=\"modal-box\" src=\"\'app/seleable/mobile/product.html\'\"></ng-include></div><div class=\"modal-seleable\" ng-if=\"seleable.product && seleable.product.modifier_groups.length > 0\"><ng-include class=\"modal-box\" src=\"\'app/seleable/mobile/modifiable_product.html\'\"></ng-include></div>");
$templateCache.put("app/tracking/desktop/tracking.html","<header-cart></header-cart><div class=\"tracking-container\"><div class=\"tracking-title-container\"><div class=\"tracking-body-container\"><skeleton-screen class=\"full-width\" ng-show=\"tracking.isLoadingItems\" template=\"tracking-status\"></skeleton-screen><div class=\"tracking-status-container\" ng-show=\"!tracking.isLoadingItems\"><div class=\"info-status-container\"><div class=\"info-status\"><div class=\"tracking-customer\"><h1 ng-show=\"!!tracking.customerName\">{{tracking.customerName}}</h1><h1 ng-show=\"!!tracking.customerLastName\">{{tracking.customerLastName}}</h1></div><div class=\"pos-number-container\" ng-show=\"tracking.order.pos_number\"><p>este es el estado</p><p>de tu orden <span>n° {{tracking.order.pos_number}}</span></p></div></div><div class=\"order-type-status\"><h1>{{tracking.orderTypeName}}</h1></div></div><div class=\"tracking-hr\"><hr ng-if=\"!tracking.finishedStatus(tracking.currentStatus)\"></div><div class=\"order-status-success\" ng-if=\"tracking.finishedStatus(tracking.currentStatus)\"><div class=\"order-success-text\"><h1>Entregado</h1></div><div class=\"order-success-icon\"><i class=\"{{tracking.iconCooking}}\"></i></div></div><div class=\"order-status\" ng-if=\"!tracking.finishedStatus(tracking.currentStatus)\"><div class=\"order-status-container\" ng-repeat=\"status in tracking.ordersStatus\" ng-if=\"status.status !== \'delivered\'\" ng-class=\"{\'width-auto\': status.status == \'ready_on_the_way\'}\"><div class=\"status-container\"><div class=\"tracking-img-container\"><i class=\"{{status.statusIcon}}\" ng-class=\"{\'current-status\': tracking.trackingStatusActive($index)}\"></i></div><h1>{{status.name}}</h1></div><div class=\"separation-status\" ng-if=\"status.status !== \'ready_on_the_way\'\"><hr ng-class=\"{\'current-status\': tracking.trackingStepActive($index)}\"></div></div></div></div><div class=\"tracking-description-container\"><skeleton-screen class=\"full-width full-height\" ng-show=\"tracking.isLoadingItems\" template=\"tracking-products\"></skeleton-screen><div class=\"order-description-container\" ng-show=\"!tracking.isLoadingItems\"><div class=\"order-description-title\"><h1 class=\"title\">esta es tu orden</h1></div><div class=\"order-description-body\"><div class=\"order-items-container\"><div class=\"items-info-container\" ng-if=\"tracking.orderItems.length > 0\" ng-repeat=\"item in tracking.orderItems | limitTo:2\"><div class=\"items-info\" ng-if=\"item.item_type == \'product\'\"><div class=\"item-img\"><div class=\"content\"><img ng-src=\"{{item.product.image.medium}}\" alt=\"{{item.product.name}}\"></div></div><div class=\"item-name-price\"><p>{{item.product.name}}</p><p class=\"price\">{{tracking.cart.parseIntl(item.product.normal_price)}}</p></div></div><div class=\"items-info\" ng-if=\"item.item_type == \'promotion\'\"><div class=\"item-img\"><div class=\"content\"><img ng-src=\"{{item.promotion.image.medium}}\" alt=\"{{item.promotion.name}}\"></div></div><div class=\"item-name-price\"><p>{{item.promotion.name}}</p><p class=\"price\">{{tracking.cart.seleablePriceIntl(item.promotion, item.total_extra_price)}}</p></div></div></div><div class=\"items-info-container\" ng-if=\"tracking.orderItems.length > 2\"><div class=\"items-count\"><h1>+ {{tracking.orderItems.length - 2}}</h1></div><div class=\"items-count-text\" ng-if=\"tracking.orderItems.length == 3\"><p>producto</p></div><div class=\"items-count-text\" ng-if=\"tracking.orderItems.length > 3\"><p>productos</p></div></div></div><div class=\"payment-detail-container\"><div class=\"payment-method\"><div class=\"order-payment\"><p class=\"label\">Medio de pago:</p><p>{{tracking.paymentMethod}}</p></div><div class=\"order-type\" ng-show=\"!!tracking.orderTypeName\"><p class=\"label\">Metodo de envio:</p><p>{{tracking.orderTypeName}}</p></div></div><div class=\"payment-detail\"><div class=\"money-payment-detail\"><p>Subtotal</p><p class=\"amount\">{{tracking.cart.parseIntl(tracking.subtotalAmount)}}</p></div><div class=\"money-payment-detail\" ng-if=\"tracking.discountAmount > 0\"><p>Descuento</p><p class=\"amount\">-{{tracking.cart.parseIntl(tracking.discountAmount)}}</p></div><div class=\"money-payment-detail\" ng-show=\"tracking.couponAmount > 0\"><p>Cupón</p><p class=\"amount\">-{{tracking.cart.parseIntl(tracking.couponAmount)}}</p></div><div class=\"money-payment-detail\" ng-show=\"tracking.deliveryAmount > 0\"><p>Delivery</p><p class=\"amount\">{{tracking.cart.parseIntl(tracking.deliveryAmount)}}</p></div><div class=\"money-payment-detail\" ng-show=\"tracking.tipAmount > 0\"><p>Propina</p><p class=\"amount\">{{tracking.cart.parseIntl(tracking.tipAmount)}}</p></div><div class=\"money-payment-detail\"><p>Total</p><p class=\"amount\">{{tracking.cart.parseIntl(tracking.totalAmount)}}</p></div></div></div></div></div><skeleton-screen class=\"full-width full-height\" ng-show=\"tracking.isLoadingItems\" template=\"tracking-address\"></skeleton-screen><div class=\"address-description-container\" ng-show=\"!tracking.isLoadingItems\"><div class=\"address-description-title\"><h1 class=\"title\">tu orden será enviada a</h1></div><div class=\"address-description\"><div class=\"address-description-body\"><div class=\"address-container\"><div class=\"tracking-info-container\"><div class=\"tracking-address\"><i class=\"icon-location-pin\" ng-show=\"tracking.address\"></i><p ng-show=\"tracking.address\">{{tracking.address}}</p></div><div class=\"tracking-promised-time\"><i class=\"icon-promised-time\"></i><div><p class=\"promised-time\" ng-show=\"!!tracking.currentTime\">Hora Estimada: {{tracking.promisedTime}} hrs.</p></div></div><div class=\"tracking-assigned-restaurant\"><i class=\"icon-restaurant\" ng-show=\"tracking.restaurant.name\"></i><p ng-show=\"tracking.restaurant.name\">Local {{tracking.restaurant.name}}</p></div></div><div class=\"address-description-footer\"><div class=\"restaurant-phones-number\" ng-if=\"!!tracking.restaurant.phones[0]\"><i class=\"icon-phone\"></i><p>{{tracking.restaurant.phones[0]}}</p></div></div></div><div class=\"gmap-container\"><ui-gmap-google-map ng-if=\"!tracking.trackingUrl\" center=\"tracking.mapLonLat\" options=\"{draggable: true, scrollwheel: false, streetViewControl: false, mapTypeControl: false}\" pan=\"true\" zoom=\"15\"><ui-gmap-marker coords=\"tracking.mapLonLat\" idkey=\"1\" options=\"{draggable: true, icon: tracking.icon}\"></ui-gmap-marker></ui-gmap-google-map><iframe ng-if=\"tracking.trackingUrl\" ng-src=\"{{tracking.trackingUrl | trustedUrl}}\" width=\"100%\" height=\"100%\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></div><div class=\"order-nominate-container\" ng-show=\"tracking.hasNoName\"><div class=\"box-success\"><p class=\"nominate\">Ponle nombre a este pedido para reconocerlo más fácilmente a futuro</p><form class=\"form-order\" ng-submit=\"tracking.setOrderName()\" _lpchecked=\"1\"><input type=\"text\" class=\"form-nominate\" placeholder=\"Nombre del pedido\" ng-model=\"tracking.order.name\"> <button type=\"submit\" class=\"btn btn-nominate\">Guardar nombre</button></form></div></div><div class=\"order-nominate-success\" ng-show=\"!tracking.hasNoName\"><div class=\"box-success\"><p class=\"nominate\">Tu pedido ha quedado nombrado como {{tracking.order.name}}</p></div></div></div></div></div></div></div></div>");
$templateCache.put("app/tracking/mobile/tracking.html","<header-cart></header-cart><div class=\"tracking-container\"><skeleton-screen class=\"full-width\" ng-show=\"tracking.isLoadingItems\" template=\"tracking-map\"></skeleton-screen><div class=\"tracking-map-container\" ng-show=\"!tracking.isLoadingItems\"><div class=\"order-status-success\" ng-if=\"tracking.finishedStatus(tracking.currentStatus)\"><div class=\"order-success-icon\"><i class=\"{{tracking.iconCooking}}\"></i></div><div class=\"order-success-text\"><h1>Entregado</h1></div></div><div class=\"tracking-url-container\" ng-if=\"!tracking.finishedStatus(tracking.currentStatus)\"><div class=\"gmap-container\"><ui-gmap-google-map ng-if=\"!tracking.trackingUrl\" center=\"tracking.mapLonLat\" options=\"{draggable: true, scrollwheel: false, streetViewControl: false, mapTypeControl: false}\" pan=\"true\" zoom=\"15\"><ui-gmap-marker coords=\"tracking.mapLonLat\" idkey=\"1\" options=\"{draggable: true, icon: tracking.icon}\"></ui-gmap-marker></ui-gmap-google-map></div><iframe ng-if=\"tracking.trackingUrl\" ng-src=\"{{tracking.trackingUrl | trustedUrl}}\" width=\"100%\" height=\"400\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div><div class=\"tracking-map-separation\"><hr></div></div><skeleton-screen class=\"full-width\" ng-show=\"tracking.isLoadingItems\" template=\"tracking-description\"></skeleton-screen><div class=\"info-order-status-container\" ng-show=\"!tracking.isLoadingItems\"><div class=\"info-status-container\"><div class=\"info-status\"><div class=\"tracking-customer\"><h1 ng-show=\"!!tracking.customerName\">{{tracking.customerName}}</h1><h1 ng-show=\"!!tracking.customerLastName\">{{tracking.customerLastName}}</h1></div><div class=\"pos-number-container\" ng-show=\"tracking.order.pos_number\"><p>este es el estado</p><p>de tu orden <span>n° {{tracking.order.pos_number}}</span></p></div></div><div class=\"order-type-status\" ng-show=\"!!tracking.orderTypeName\"><h1>{{tracking.orderTypeName}}</h1></div></div></div><div class=\"tracking-body-container\"><skeleton-screen class=\"full-width\" ng-show=\"tracking.isLoadingItems\" template=\"tracking-status\"></skeleton-screen><div class=\"tracking-status-container\" ng-show=\"!tracking.isLoadingItems\"><div class=\"order-status\"><div class=\"order-status-container\"><div class=\"status-container\" ng-repeat=\"status in tracking.ordersStatus\" ng-if=\"status.status !== \'delivered\'\" ng-class=\"{\'width-auto\': status.status == \'ready_on_the_way\'}\"><div class=\"tracking-img-container\"><i class=\"{{status.statusIcon}}\" ng-class=\"{\'current-status\': tracking.trackingStatusActive($index)}\"></i><div class=\"tracking-step\" ng-class=\"{\'unseen\': $index == (tracking.ordersStatus.length - 1), \'active\': tracking.trackingStepActive($index)}\"></div></div></div></div><div class=\"order-status-container\"><div class=\"status-container width-auto\" ng-repeat=\"status in tracking.ordersStatus\" ng-if=\"status.status !== \'delivered\'\"><h1>{{status.name}}</h1></div></div></div></div><div class=\"tracking-description-container\"><skeleton-screen class=\"full-width\" ng-show=\"tracking.isLoadingItems\" template=\"tracking-products\"></skeleton-screen><div class=\"order-description-container\" ng-show=\"!tracking.isLoadingItems\"><div class=\"order-description-body-container\"><div class=\"order-description-title\"><h1>esta es tu orden</h1></div><div class=\"order-description-body\"><div class=\"order-items-container\"><div class=\"items-info-container\" ng-if=\"tracking.orderItems.length > 0\" ng-repeat=\"item in tracking.orderItems\"><div class=\"items-info\" ng-if=\"item.item_type == \'product\'\"><div class=\"item-img\"><div class=\"content\"><img ng-src=\"{{item.product.image.medium}}\" alt=\"{{item.product.name}}\"></div></div><div class=\"item-description\"><div class=\"item-name\"><p>{{item.product.name}}</p></div><div class=\"item-option\" ng-repeat=\"option in tracking.showOptions(item)\"><p class=\"option\">-</p><p class=\"option\">{{option}}</p></div><div class=\"item-price\"><p class=\"price\">{{tracking.cart.parseIntl(item.product.normal_price)}}</p></div></div></div><div class=\"items-info\" ng-if=\"item.item_type == \'promotion\'\"><div class=\"item-img\"><div class=\"content\"><img ng-src=\"{{item.promotion.image.medium}}\" alt=\"{{item.promotion.name}}\"></div></div><div class=\"item-description\"><div class=\"item-name\"><p><span>{{item.quantity}} x</span> {{item.promotion.name}}</p></div><div class=\"item-option\" ng-repeat=\"option in tracking.showOptions(item)\"><p class=\"option\">-</p><p class=\"option\">{{option}}</p></div></div></div></div></div><div class=\"payment-method-container\"><div class=\"order-payment\"><p class=\"label\">Medio de pago:</p><p>{{tracking.paymentMethod}}</p></div><div class=\"order-type\" ng-show=\"!!tracking.orderTypeName\"><p class=\"label\">Metodo de envio:</p><p>{{tracking.orderTypeName}}</p></div></div><div class=\"payment-detail-container\"><div class=\"payment-detail\"><div class=\"money-payment-detail\"><p>Subtotal</p><p class=\"money-payment\">{{tracking.cart.parseIntl(tracking.subtotalAmount)}}</p></div><div class=\"money-payment-detail\" ng-if=\"tracking.discountAmount > 0\"><p>Descuento</p><p class=\"money-payment\">-{{tracking.cart.parseIntl(tracking.discountAmount)}}</p></div><div class=\"money-payment-detail\" ng-show=\"tracking.couponAmount > 0\"><p>Cupón</p><p class=\"money-payment\">-{{tracking.cart.parseIntl(tracking.couponAmount)}}</p></div><div class=\"money-payment-detail\" ng-show=\"tracking.deliveryAmount > 0\"><p>Costo de envío</p><p class=\"money-payment\">{{tracking.cart.parseIntl(tracking.deliveryAmount)}}</p></div><div class=\"money-payment-detail\" ng-show=\"tracking.tipAmount > 0\"><p>Propina</p><p class=\"money-payment\">{{tracking.cart.parseIntl(tracking.tipAmount)}}</p></div></div><div class=\"payment-detail\"><div class=\"money-payment-detail\"><p>Total</p><p class=\"money-payment\">{{tracking.cart.parseIntl(tracking.totalAmount)}}</p></div></div></div></div></div></div><skeleton-screen class=\"full-width\" ng-show=\"tracking.isLoadingItems\" template=\"tracking-address\"></skeleton-screen><div class=\"address-description-container\" ng-show=\"!tracking.isLoadingItems\"><div class=\"address-description\"><div class=\"address-description-title-container\"><h1>tu orden será enviada a</h1></div><div class=\"address-description-body-container\"><div class=\"address-description-body\"><div class=\"address-container\"><div class=\"tracking-promised-time\"><i class=\"icon-promised-time\"></i><p ng-show=\"!!tracking.promisedTime\">Hora Estimada: {{tracking.promisedTime}} hrs.</p></div><div class=\"tracking-address\"><i class=\"icon-location-pin\" ng-show=\"tracking.address\"></i><p ng-show=\"tracking.address\">{{tracking.address}}</p></div><div class=\"tracking-assigned-restaurant\"><i class=\"icon-restaurant\" ng-show=\"tracking.restaurant.name\"></i><p ng-show=\"tracking.restaurant.name\">Local {{tracking.restaurant.name}}</p></div></div></div><div class=\"address-description-footer\"><div class=\"restaurant-phones-number\" ng-if=\"!!tracking.restaurant.phones[0]\"><a ng-href=\"tel:{{tracking.restaurant.phones[0]}}\"><i class=\"icon-earphone\"></i><p>{{tracking.restaurant.phones[0]}}</p></a></div></div><div class=\"order-nominate-container\" ng-show=\"tracking.hasNoName\"><div class=\"box-success\"><p class=\"nominate\">Ponle nombre a este pedido para reconocerlo más fácilmente a futuro</p><form class=\"form-order\" ng-submit=\"tracking.setOrderName()\" _lpchecked=\"1\"><input type=\"text\" class=\"form-nominate\" placeholder=\"Nombre del pedido\" ng-model=\"tracking.order.name\"> <button type=\"submit\" class=\"btn btn-nominate\">Guardar nombre</button></form></div></div><div class=\"order-nominate-success\" ng-show=\"!tracking.hasNoName\"><div class=\"box-success\"><p class=\"nominate\">Tu pedido ha quedado nombrado como {{tracking.order.name}}</p></div></div></div></div></div><skeleton-screen class=\"full-width\" ng-show=\"tracking.isLoadingItems\" template=\"tracking-need-help\"></skeleton-screen><div class=\"need-help-container\" ng-show=\"!tracking.isLoadingItems\"><p>¿Tuviste algún problema con tu pedido?</p><a ui-sref=\"client-contact\" ui-sref-opts=\"{reload: true, notify: true}\"><span>Ir a ayuda</span></a></div></div></div></div>");
$templateCache.put("app/components/carousel/desktop/carousel.html","<div class=\"carousel\" ng-controller=\"CarouselController as vm\"><div class=\"image-container\"><img id=\"image{{image.index}}\" ng-repeat=\"image in vm.images\" class=\"carousel-image {{image.active_class}}\" ng-src=\"{{image.image}}\" alt=\"{{image.alt}}\" data-index=\"{{image.index}}\" ng-click=\"vm.goToUrl(image.redirect)\"></div><div class=\"dot-container\" ng-if=\"vm.totalImages > 1\"><button ng-repeat=\"dot in vm.images\" data-index=\"{{dot.index}}\" class=\"{{dot.active_class}}\" ng-click=\"vm.dot($event)\"></button></div><button id=\"prev\" ng-click=\"vm.prev()\" ng-if=\"vm.totalImages > 1\"><i class=\"icon-chevron-left\"></i></button> <button id=\"next\" ng-click=\"vm.next()\" ng-if=\"vm.totalImages > 1\"><i class=\"icon-chevron-right\"></i></button></div>");
$templateCache.put("app/components/carousel/mobile/carousel.html","<div class=\"carousel\" ng-controller=\"CarouselController as vm\"><div class=\"image-container\"><img id=\"image{{image.index}}\" ng-repeat=\"image in vm.images\" class=\"carousel-image {{image.active_class}}\" ng-src=\"{{image.image}}\" alt=\"{{image.alt}}\" data-index=\"{{image.index}}\" ng-click=\"vm.goToUrl(image.redirect)\"></div><button ng-click=\"vm.prev()\" ng-if=\"vm.totalImages > 1\" ng-class=\"vm.newHome && vm.currentState === \'home\' ? \'prev-home\' : \'prev\'\"><i class=\"icon-chevron-left\"></i></button> <button ng-click=\"vm.next()\" ng-if=\"vm.totalImages > 1\" ng-class=\"vm.newHome && vm.currentState === \'home\' ? \'next-home\' : \'next\'\"><i class=\"icon-chevron-right\"></i></button></div>");
$templateCache.put("app/components/footer-cart/desktop/footer-cart.html","<div id=\"footer\" class=\"footer\" ng-class=\"{\'fixed\': footerCart.fixedFooter()}\"><div class=\"footer-default\"><ul class=\"footer-left\"><li class=\"social-networks\" ng-if=\"!!envConstants.FACEBOOK_URL\"><a href=\"{{envConstants.FACEBOOK_URL}}\" target=\"_blank\" class=\"facebook\"><img class=\"footer-facebook\" src=\"assets/images/icon-facebook.svg\"></a></li><li class=\"social-networks\" ng-if=\"!!envConstants.INSTAGRAM_URL\"><a href=\"{{envConstants.INSTAGRAM_URL}}\" target=\"_blank\" class=\"instagram\"><img class=\"footer-instagram\" src=\"assets/images/icon-instagram.svg\"></a></li><li class=\"social-networks\" ng-if=\"!!envConstants.TIKTOK_URL\"><a href=\"{{envConstants.TIKTOK_URL}}\" target=\"_blank\" class=\"tiktok\"><img class=\"footer-tiktok\" src=\"assets/images/icon-tiktok.svg\"></a></li></ul><div class=\"footer-center\"><div class=\"footer-schedule\"><p>Horario de Atención: {{envConstants.MAIN_RESTAURANT_SCH_1}}</p></div><div class=\"footer-copyright\"><p>@ COPYRIGHT 2022 {{envConstants.COMPANY_NAME}}</p><a ui-sref=\"tos\">{{footerCart.localeTos}}</a> <a ui-sref=\"faq\" ng-if=\"envConstants.FAQ === \'true\'\">Preguntas Frecuentes</a> <a ui-sref=\"ticketReceipts\" ng-if=\"footerCart.hasGenerateReceipt\">FACTURACIÓN</a></div></div><div class=\"footer-right\"><div class=\"logo-box\"><img src=\"{{envConstants.LOGO_FOOTER_URL}}\" alt=\"{{envConstants.COMPANY_NAME}} logo\"></div></div></div></div>");
$templateCache.put("app/components/footer-cart/mobile/footer-cart.html","<div id=\"footer\" class=\"footer\" ng-class=\"{\'fixed\': footerCart.fixedFooter()}\"><div class=\"footer-top\"><div class=\"footer-top-left\"><div class=\"logo-box\"><img src=\"{{envConstants.LOGO_FOOTER_URL}}\" alt=\"{{envConstants.COMPANY_NAME}} logo\"></div></div><div class=\"footer-top-right\"><a ui-sref=\"franchises\" ng-if=\"envConstants.FRANCHISES === \'true\'\">Franquicias</a> <a ui-sref=\"faq\" ng-if=\"envConstants.FAQ === \'true\'\">Preguntas Frecuentes</a></div></div><hr><div class=\"footer-middle\"><div class=\"footer-middle-schedule\"><p>{{envConstants.MAIN_RESTAURANT_SCH_1}}</p></div></div><div class=\"footer-bottom\"><div class=\"footer-bottom-left\"><p>@ COPYRIGHT 2022 {{envConstants.COMPANY_NAME}}</p></div><div class=\"footer-bottom-right\"><a ui-sref=\"tos\">{{footerCart.localeTos}}</a></div></div></div>");
$templateCache.put("app/components/footer-home/desktop/footer-home.html","<div id=\"footer\" class=\"footer-home-container\" ng-class=\"{\'fixed\': footerHome.fixedFooter()}\"><div class=\"footer-home-default\"><div class=\"footer-home-left\"><div class=\"footer-home-social-title\"><p>Siguenos en nuestras redes sociales</p></div><ul class=\"footer-home-social-networks\"><li class=\"social-networks\" ng-if=\"!!envConstants.FACEBOOK_URL\"><a href=\"{{envConstants.FACEBOOK_URL}}\" target=\"_blank\" class=\"facebook\"><img class=\"footer-home-facebook\" src=\"assets/images/icon-facebook.svg\"></a></li><li class=\"social-networks\" ng-if=\"!!envConstants.INSTAGRAM_URL\"><a href=\"{{envConstants.INSTAGRAM_URL}}\" target=\"_blank\" class=\"instagram\"><img class=\"footer-home-instagram\" src=\"assets/images/icon-instagram.svg\"></a></li><li class=\"social-networks\" ng-if=\"!!envConstants.TIKTOK_URL\"><a href=\"{{envConstants.TIKTOK_URL}}\" target=\"_blank\" class=\"tiktok\"><img class=\"footer-home-tiktok\" src=\"assets/images/icon-tiktok.svg\"></a></li></ul></div><div class=\"footer-home-center\"><div class=\"footer-home-schedule\"><p>Horario de atención: {{envConstants.MAIN_RESTAURANT_SCH_1}}</p></div><div class=\"footer-home-copyright\"><p>@ COPYRIGHT 2022 {{envConstants.COMPANY_NAME}}</p><a ui-sref=\"tos\">{{footerHome.localeTos}}</a> <a ui-sref=\"faq\" ng-if=\"envConstants.FAQ === \'true\'\">Preguntas Frecuentes</a> <a ui-sref=\"ticketReceipts\" ng-if=\"footerHome.hasGenerateReceipt\">FACTURACIÓN</a></div></div><div class=\"footer-home-right\"><div class=\"logo-box\"><img src=\"{{envConstants.LOGO_FOOTER_URL}}\" alt=\"{{envConstants.COMPANY_NAME}} logo\"></div></div></div></div>");
$templateCache.put("app/components/footer-home/mobile/footer-home.html","<div id=\"footer\" class=\"footer-home-container\"><div class=\"footer-home-top\"><div class=\"footer-home-top-left\"><div class=\"footer-home-top-left-content\"><div class=\"footer-home-top-left-title\"><p>Siguenos en nuestras redes sociales</p></div><ul class=\"footer-home-social-media\"><li class=\"default\"><a href=\"{{footerHome.instagramUrl}}\" target=\"_blank\" class=\"instagram\"><img class=\"footer-instagram\" src=\"assets/images/icon-instagram.svg\"></a></li><li class=\"default\"><a href=\"{{footerHome.facebookUrl}}\" target=\"_blank\" class=\"facebook\"><img class=\"footer-facebook\" src=\"assets/images/icon-facebook.svg\"></a></li><li class=\"default\"><a href=\"{{footerHome.tiktokUrl}}\" target=\"_blank\" class=\"tiktok\"><img class=\"footer-tiktok\" src=\"assets/images/icon-tiktok.svg\"></a></li></ul></div></div><div class=\"footer-home-top-right\"><div class=\"logo-box\"><img src=\"{{footerHome.logoFooter}}\" alt=\"{{footerHome.companyName}} logo\"></div></div></div><div class=\"footer-home-middle\"><div class=\"footer-home-middle-schedule\"><p class=\"bold\">Horario de atención:</p><p>{{footerHome.restaurantSchedule}}</p></div></div><hr><div class=\"footer-home-bottom\"><div class=\"footer-home-bottom-left\"><p>@ COPYRIGHT 2022 {{footerHome.companyName}}</p></div><div class=\"footer-home-bottom-right\"><a ui-sref=\"tos\">{{footerHome.localeTos}}</a> <a ui-sref=\"ticketReceipts\" ng-if=\"footerHome.hasGenerateReceipt\">FACTURACIÓN</a></div></div></div>");
$templateCache.put("app/components/go-to/mobile/go-to.html","<a class=\"{{vm.parentClass}}\" ui-sref=\"{{vm.redirectTo}}\"><i class=\"{{vm.arrowClass}}\"></i><p>{{vm.textGoTo}}</p></a>");
$templateCache.put("app/components/header-checkout/desktop/header-checkout.html","<nav id=\"navbar\" class=\"header-checkout\" ng-controller=\"HeaderCheckoutController as vm\"><div class=\"header-checkout-container\"><div class=\"header-checkout-left\"><a class=\"header-checkout-back\" ui-sref=\"{{vm.redirectTo}}\"><i class=\"icon-back\"></i> <span>Volver</span></a></div><div class=\"header-checkout-center\"><h1>Checkout - Detalles del pedido</h1></div><div class=\"header-checkout-right\"><a class=\"header-checkout-brand\" ui-sref=\"{{vm.redirectTo}}\"><img src=\"{{envConstants.LOGO_HEADER_URL}}\" alt=\"{{envConstants.COMPANY_NAME}} logo\"></a></div></div></nav>");
$templateCache.put("app/components/header-checkout/mobile/header-checkout.html","<nav id=\"navbar\" class=\"header-checkout\" ng-controller=\"HeaderCheckoutController as vm\"><div class=\"header-checkout-container\"><div class=\"header-checkout-left\"><a class=\"header-checkout-back\" ui-sref=\"{{vm.redirectTo}}\"><i class=\"icon-back\"></i></a></div><div class=\"header-checkout-center\"><h1>Checkout - {{vm.how}}</h1></div><div class=\"header-checkout-right\"></div></div></nav>");
$templateCache.put("app/components/header-cart/desktop/header-cart.html","<nav id=\"navbar\" class=\"navbar navbar-default navbar-fixed-top\" ng-class=\"{\'new-home\': vm.newHome && vm.currentState.includes(\'home\')}\" ng-controller=\"HeaderController as vm\"><div class=\"navbar-container\"><div class=\"navbar-header-left\"><a class=\"navbar-brand\" ui-sref=\"{{vm.redirectTo}}\"><img src=\"{{envConstants.LOGO_HEADER_URL}}\" alt=\"{{envConstants.COMPANY_NAME}} logo\"></a></div><ul class=\"navbar-header-right\"><li class=\"default menu\" ng-if=\"vm.newHome\" ui-sref-active=\"active\"><a class=\"current\" ui-sref=\"menu\" ui-sref-opts=\"{reload: true, notify: true}\"><span>Pide aquí</span></a></li><div class=\"navbar-address-bar\" ng-if=\"vm.primaryAddress\"><span class=\"address-text\">Envío a: {{vm.primaryAddress.street_name}} {{vm.primaryAddress.street_number}}</span> <span class=\"address-change\" ng-click=\"vm.openAddressMethodModal($event)\">Cambiar</span></div><li class=\"default menu\" ng-if=\"!vm.newHome\" ui-sref-active=\"active\"><a ng-class=\"{\'current\': vm.includeStr(vm.currentState, [\'menu\', \'myFavorites\', \'latestOrders\', \'events\'])}\" ui-sref=\"menu\" ui-sref-opts=\"{reload: true, notify: true}\"><span>{{vm.menuText}}</span></a></li><li class=\"restaurants\" ui-sref-active=\"active\"><a ui-sref=\"restaurants\" ng-class=\"{\'current\': vm.includeStr(vm.currentState, [\'restaurants\'])}\"><span>{{vm.restaurantText}}</span></a></li><li class=\"default icon location\" ng-if=\"envConstants.ALLOW_PRICE_LISTS === \'true\'\"><a ng-click=\"vm.openModalLocation()\" ng-class=\"{\'selected\': vm.restaurantGroup.short_name}\"><i class=\"icon-map-pin\"></i> <span>{{vm.restaurantGroup.short_name}}</span></a></li><li class=\"default icon cart\"><a ui-sref=\"checkout\" class=\"navbar-cart\" ng-class=\"{\'current\': vm.includeStr(vm.currentState, [\'checkout\'])}\"><img class=\"nav-img\" src=\"assets/images/icon-cart.svg\"> <small ng-show=\"vm.count > 0\">{{vm.count}}</small></a></li><li class=\"default icon profile dropdown\" ng-if=\"vm.customer\" uib-dropdown=\"\"><a class=\"dropdown-toggle\" ng-class=\"{\'current\': vm.includeStr(vm.currentState, [\'profile\', \'client-contact\', \'client-contact-success\'])}\" id=\"simple-dropdown\" uib-dropdown-toggle=\"\"><img class=\"nav-img\" src=\"assets/images/icon-profile.svg\"></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li class=\"title-dropdown\"><p>Bienvenido,&nbsp; <span>{{vm.customer.name}} ;</span></p></li><li class=\"profile-dropdown\"><a ui-sref=\"profile\"><img class=\"nav-img\" src=\"assets/images/icon-profile.svg\"> <span>Mi perfil</span></a></li><li class=\"contact-dropdown\"><a ui-sref=\"client-contact\"><span>Contáctanos</span></a></li><li class=\"logout-dropdown\"><a ui-sref=\"logout\"><span>Cerrar Sesión</span></a></li></ul></li><li class=\"default icon profile\" ng-if=\"!vm.customer\"><a ng-class=\"{\'current\': vm.includeStr(vm.currentState, [\'profile\', \'client-contact\', \'client-contact-success\'])}\" ui-sref=\"{{vm.stateName}}\"><img class=\"nav-img\" src=\"assets/images/icon-profile.svg\"></a></li></ul></div></nav>");
$templateCache.put("app/components/header-cart/mobile/header-cart.html","<nav id=\"navbar\" class=\"navbar navbar-default\" ng-controller=\"HeaderController as vm\"><div class=\"navbar-main\"><a ui-sref=\"{{backState}}\" ng-if=\"backState && vm.currentState !== \'home\'\"><i class=\"icon-chevron-left\"></i></a> <a id=\"navbar-brand\" class=\"navbar-brand\" ui-sref=\"{{vm.redirectTo}}\"><img src=\"{{envConstants.LOGO_HEADER_URL}}\" alt=\"{{envConstants.COMPANY_NAME}} logo\"></a><div id=\"navbar-category\" class=\"navbar-category\" ng-if=\"vm.stateIncludes() && vm.currentState !== \'home\'\"><a ng-repeat=\"category in vm.categories\" href=\"{{category.id}}\">{{category.name}}</a></div><div class=\"navbar-spacer\"></div><div class=\"navbar-cart\"><a class=\"navbar-location-button\" ng-if=\"envConstants.ALLOW_PRICE_LISTS === \'true\'\" ng-click=\"vm.openModalLocation()\" ng-class=\"{\'selected\': vm.restaurantGroup.short_name}\"><i class=\"icon-map-pin\"></i> <span>{{vm.restaurantGroup.short_name || \'Comuna\'}}</span></a><div class=\"navbar-cart-button\" ng-if=\"vm.newHome && vm.currentState === \'home\'\"><button class=\"btn btn-navbar-menu\" ui-sref=\"menu\" ui-sref-opts=\"{reload: true, notify: true}\">Pide aquí</button></div><a class=\"navbar-cart\" ui-sref=\"checkout\" ng-if=\"vm.currentState !== \'home\'\"><img class=\"nav-img\" src=\"assets/images/icon-cart.svg\"> <small ng-show=\"vm.count > 0\">{{vm.count}}</small></a> <a ng-click=\"vm.viewMenu()\"><img class=\"nav-img\" src=\"assets/images/icon-hamburger.svg\"></a></div></div><div class=\"navbar-address-bar\" ng-if=\"vm.primaryAddress\"><span class=\"address-text\">Envío a: {{vm.primaryAddress.street_name}} {{vm.primaryAddress.street_number}}</span> <span class=\"address-change\" ng-click=\"vm.openAddressMethodModal($event)\">Cambiar</span></div></nav>");
$templateCache.put("app/components/loader/desktop/ellipsis.html","<div id=\"loading-ellipsis\" class=\"lds-ellipsis-container lds-ellipsis-container-{{vm.size}}\"><div class=\"lds-ellipsis lds-ellipsis-{{vm.size}}\"><div></div><div></div><div></div><div></div></div></div>");
$templateCache.put("app/components/loader/desktop/ring.html","<div><span class=\"loader\"></span></div>");
$templateCache.put("app/components/loader/mobile/ellipsis.html","<div id=\"loading-ellipsis\" class=\"lds-ellipsis-container lds-ellipsis-container-{{vm.size}}\"><div class=\"lds-ellipsis lds-ellipsis-{{vm.size}}\"><div></div><div></div><div></div><div></div></div></div>");
$templateCache.put("app/components/loader/mobile/ring.html","<div><span class=\"loader\"></span></div>");
$templateCache.put("app/components/location-method/desktop/location-method.modal.html","<div class=\"location-method-modal location-method-modal--box\"><button class=\"modal-close\" ng-click=\"vm.close()\">×</button><h2>¿Cómo quieres pedir hoy?</h2><div class=\"method-toggle\"><div class=\"method-indicator\" ng-class=\"{ pickup: vm.method === \'pickup\' }\"></div><button class=\"method-button\" ng-click=\"vm.selectMethod(\'delivery\')\" ng-class=\"{ active: vm.method === \'delivery\' }\">DESPACHO</button> <button class=\"method-button\" ng-click=\"vm.selectMethod(\'pickup\')\" ng-class=\"{ active: vm.method === \'pickup\' }\">RETIRO</button></div><div class=\"address-box\" ng-if=\"vm.method === \'delivery\' && vm.address\"><label>Selecciona una dirección</label><div class=\"address-value\" ng-click=\"vm.toggleAddressList()\" ng-class=\"{ open: vm.isAddressOpen }\"><i class=\"icon-map-pin\"></i> {{ vm.address.street_name }} {{ vm.address.street_number }}, {{ vm.address.comune_name }} <i class=\"caret\"></i></div><div class=\"address-dropdown\" ng-if=\"vm.isAddressOpen\"><div class=\"address-option\" ng-repeat=\"address in vm.addresses\" ng-click=\"vm.selectAddress(address)\"><i class=\"icon-map-pin\"></i> {{ address.street_name }} {{ address.street_number }}, {{ address.comune_name }}</div></div></div><div class=\"pickup-restaurants\" ng-if=\"vm.method === \'pickup\'\"><div class=\"restaurant-card\" ng-repeat=\"restaurant in vm.restaurants\" ng-click=\"vm.selectRestaurant(restaurant)\" ng-class=\"{ selected: vm.selectedRestaurant && vm.selectedRestaurant.id === restaurant.id, disabled: !restaurant.is_open}\"><div class=\"restaurant-header\"><h3>{{ $index + 1 }}. {{ restaurant.name }}</h3><a class=\"directions\" ng-href=\"{{ vm.googleMapsUrl(restaurant) }}\" target=\"_blank\" rel=\"noopener\" ng-click=\"$event.stopPropagation()\">Ubicación</a></div><p class=\"restaurant-address\">{{ restaurant.address }}</p><p class=\"restaurant-distance\" ng-if=\"restaurant.distance_from_customer\"><i class=\"glyphicon glyphicon-map-marker\"></i> {{ restaurant.distance_from_customer }}</p><p class=\"restaurant-time\"><i class=\"icon-promised-time\"></i> Retiro: {{ restaurant.current_pickup_time }} min aprox</p></div></div><div class=\"add-address-cta\" ng-if=\"vm.method === \'delivery\'\" ng-click=\"vm.openAddAddressModal(); $event.stopPropagation()\">Agregar dirección</div><button class=\"confirm-button\" ng-click=\"vm.confirm()\" ng-disabled=\"vm.method === \'delivery\' && !vm.selectedAddress\">CONFIRMAR</button></div>");
$templateCache.put("app/components/location-method/mobile/location-method.modal.html","<div class=\"location-method-modal location-method-modal--box\"><button class=\"modal-close\" ng-click=\"vm.close()\">×</button><h2>¿Cómo quieres pedir hoy?</h2><div class=\"method-toggle\"><div class=\"method-indicator\" ng-class=\"{ pickup: vm.method === \'pickup\' }\"></div><button class=\"method-button\" ng-click=\"vm.selectMethod(\'delivery\')\" ng-class=\"{ active: vm.method === \'delivery\' }\">DESPACHO</button> <button class=\"method-button\" ng-click=\"vm.selectMethod(\'pickup\')\" ng-class=\"{ active: vm.method === \'pickup\' }\">RETIRO</button></div><div class=\"address-box\" ng-if=\"vm.method === \'delivery\' && vm.address\"><label>Selecciona una dirección</label><div class=\"address-value\" ng-click=\"vm.toggleAddressList()\" ng-class=\"{ open: vm.isAddressOpen }\"><i class=\"icon-map-pin\"></i> {{ vm.address.street_name }} {{ vm.address.street_number }}, {{ vm.address.comune_name }} <i class=\"caret\"></i></div><div class=\"address-dropdown\" ng-if=\"vm.isAddressOpen\"><div class=\"address-option\" ng-repeat=\"address in vm.addresses\" ng-click=\"vm.selectAddress(address)\"><i class=\"icon-map-pin\"></i> {{ address.street_name }} {{ address.street_number }}, {{ address.comune_name }}</div></div></div><div class=\"pickup-restaurants\" ng-if=\"vm.method === \'pickup\'\"><div class=\"restaurant-card\" ng-repeat=\"restaurant in vm.restaurants\" ng-click=\"vm.selectRestaurant(restaurant)\" ng-class=\"{ selected: vm.selectedRestaurant && vm.selectedRestaurant.id === restaurant.id, disabled: !restaurant.is_open }\"><div class=\"restaurant-header\"><h3>{{ $index + 1 }}. {{ restaurant.name }}</h3><a class=\"directions\" ng-href=\"{{ vm.googleMapsUrl(restaurant) }}\" target=\"_blank\" rel=\"noopener\" ng-click=\"$event.stopPropagation()\">Ubicación</a></div><p class=\"restaurant-address\">{{ restaurant.address }}</p><p class=\"restaurant-distance\" ng-if=\"restaurant.distance_from_customer\"><i class=\"glyphicon glyphicon-map-marker\"></i> {{ restaurant.distance_from_customer }}</p><p class=\"restaurant-time\"><i class=\"icon-promised-time\"></i> Retiro: {{ restaurant.current_pickup_time }} min aprox</p></div></div><div class=\"add-address-cta\" ng-if=\"vm.method === \'delivery\'\" ng-click=\"vm.openAddAddressModal(); $event.stopPropagation()\">Agregar dirección</div><button class=\"confirm-button\" ng-click=\"vm.confirm()\" ng-disabled=\"vm.method === \'delivery\' && !vm.selectedAddress\">CONFIRMAR</button></div>");
$templateCache.put("app/components/notice-bar-cart/desktop/notice-bar-cart.html","<div class=\"notice-bar\" ng-if=\"noticeBarDesktop\"><div class=\"notice-bar-container\"><div class=\"notice-bar-title\" ng-class=\"{\'pointer\': !!noticeBarLink}\" ng-if=\"!!noticeBarTitle\" ng-click=\"goToLink()\"><span>{{noticeBarTitle}}</span></div><div class=\"notice-bar-body\" ng-class=\"{\'pointer\': !!noticeBarLink}\" ng-if=\"!!noticeBarBody\" ng-click=\"goToLink()\"><span>{{noticeBarBody}}</span></div></div></div>");
$templateCache.put("app/components/notice-bar-cart/mobile/notice-bar-cart.html","<div id=\"notice-bar\" class=\"notice-bar\" ng-if=\"noticeBarMobile\"><div class=\"notice-bar-container\"><div class=\"notice-bar-img\" ng-if=\"noticeBarLogo\"><img ng-src=\"{{niuLogoApp}}\" alt=\"niu-logo-app\"></div><div class=\"notice-bar-text\"><div class=\"notice-bar-title\" ng-if=\"!!noticeBarTitle\" ng-click=\"goToLink()\"><span>{{noticeBarTitle}}</span></div><div class=\"notice-bar-body\" ng-if=\"!!noticeBarBody\" ng-click=\"goToLink()\"><span>{{noticeBarBody}}</span></div></div><div class=\"notice-bar-icon\" ng-if=\"noticeBarIcon\"><a href=\"{{downloadAppUrl()}}\" target=\"_blank\"><i class=\"icon-download\"></i></a></div><div class=\"notice-bar-close\"><button ng-click=\"noticeBarClose()\"><i class=\"icon-x\"></i></button></div></div></div>");
$templateCache.put("app/components/product-badge/desktop/highlight-text.html","<div ng-class=\"!!modal ? \'product-modal-contanier\' : \'product-container\'\"><div class=\"product-component highlight-text\" ng-class=\"{\'modal-component\': !!modal}\" ng-show=\"badgeText\"><p>{{badgeText}}</p></div></div>");
$templateCache.put("app/components/product-badge/mobile/highlight-text.html","<div ng-class=\"!!modal ? \'product-modal-contanier\' : \'product-container\'\"><div class=\"product-component highlight-text\" ng-class=\"{\'modal-component\': !!modal}\" ng-show=\"badgeText\"><p>{{badgeText}}</p></div></div>");
$templateCache.put("app/components/phone/desktop/phone-select.html","<input type=\"tel\" id=\"phone\" name=\"phones-0\" class=\"phone-select\" ng-model=\"vm.value\" required=\"\"> <span id=\"phone-error-message\" class=\"form-error-message hide\">Formato incorrecto, ej: {{vm.selectedCountryPlaceholder}}</span>");
$templateCache.put("app/components/phone/mobile/phone-select.html","<input type=\"tel\" id=\"phone\" name=\"phones-0\" class=\"phone-select\" ng-model=\"vm.value\" required=\"\"> <span id=\"phone-error-message\" class=\"form-error-message hide\">Formato incorrecto, ej: {{vm.selectedCountryPlaceholder}}</span>");
$templateCache.put("app/components/product-carousel/desktop/product-carousel.html","<div class=\"product-carousel-container\" ng-controller=\"ProductCarouselController as vm\"><div class=\"product-carousel-btn\" ng-if=\"!!vm.products\"><button id=\"product-carousel-prev\" ng-click=\"vm.prev()\"><i class=\"icon-chevron-left\"></i></button></div><div id=\"product-carousel-content\" class=\"product-carousel-content\"><div class=\"product-carousel\" ng-repeat=\"seleable in vm.products\"><div class=\"img-product-carousel\" ng-click=\"vm.viewSeleable(seleable)\"><product-badge badge=\"highlight-text\" seleable=\"seleable\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.image.large}}\" alt=\"{{seleable.name}}\"></div></div><div class=\"body-product-carousel\"><div class=\"body-product-carousel-details\"><div class=\"body-product-carousel-name\"><h5>{{seleable.name}}</h5></div><div class=\"body-product-carousel-price\" ng-class=\"{\'one-line\': (!seleable.discount || !vm.cart.discountable()) && (seleable.discount || seleable.normal_price <= seleable.special_price || seleable.special_price <= 0)}\"><p class=\"discount-price\" ng-show=\"(seleable.discount && vm.cart.discountable()) || (!seleable.discount && seleable.normal_price > seleable.special_price && seleable.special_price > 0)\">{{vm.cart.discountPriceIntl(seleable.id, seleable.type)}}</p><p>{{vm.cart.priceIntl(seleable.id, seleable.discount, seleable.type)}}</p></div></div><div class=\"body-add-product-carousel\"><a class=\"add-btn\" ng-class=\"{\'aggregated\': vm.cart.get(seleable.id, null, seleable.type)}\" ng-click=\"vm.addToCart(seleable)\"><img src=\"assets/images/icon-cart.svg\"></a> <small ng-click=\"vm.addToCart(seleable)\" ng-if=\"!vm.cart.get(seleable.id, null, seleable.type)\"><i class=\"icon-plus\"></i></small> <small ng-if=\"vm.cart.get(seleable.id, null, seleable.type)\" ng-click=\"vm.addToCart(seleable)\" ng-class=\"{\'aggregated\': vm.cart.get(seleable.id, null, seleable.type)}\">{{vm.cart.get(seleable.id, null, seleable.type)}}</small></div></div></div></div><div class=\"product-carousel-btn\" ng-if=\"!!vm.products\"><button id=\"product-carousel-next\" ng-click=\"vm.next()\"><i class=\"icon-chevron-right\"></i></button></div></div>");
$templateCache.put("app/components/product-carousel/mobile/product-carousel.html","<div class=\"product-carousel-container\" ng-controller=\"ProductCarouselController as vm\"><div class=\"product-carousel\" ng-repeat=\"seleable in vm.products\"><div class=\"img-product-carousel\" ng-click=\"vm.viewSeleable(seleable)\"><product-badge badge=\"highlight-text\" seleable=\"seleable\"></product-badge><div class=\"content\"><img ng-src=\"{{seleable.image.large}}\" alt=\"{{seleable.name}}\"></div></div><div class=\"body-product-carousel\"><div class=\"body-product-carousel-details\"><div class=\"body-product-carousel-name\"><h5>{{seleable.name}}</h5></div><div class=\"body-product-carousel-price\" ng-class=\"{\'one-line\': (!seleable.discount || !vm.cart.discountable()) && (seleable.discount || seleable.normal_price <= seleable.special_price || seleable.special_price <= 0)}\"><p class=\"discount-price\" ng-show=\"(seleable.discount && vm.cart.discountable()) || (!seleable.discount && seleable.normal_price > seleable.special_price && seleable.special_price > 0)\">{{vm.cart.discountPriceIntl(seleable.id, seleable.type)}}</p><p>{{vm.cart.priceIntl(seleable.id, seleable.discount, seleable.type)}}</p></div></div><div class=\"body-add-product-carousel\"><a class=\"add-btn\" ng-class=\"{\'aggregated\': vm.cart.get(seleable.id, null, seleable.type)}\" ng-click=\"vm.addToCart(seleable)\"><img src=\"assets/images/icon-cart.svg\"></a> <small ng-click=\"vm.addToCart(seleable)\" ng-if=\"!vm.cart.get(seleable.id, null, seleable.type)\"><i class=\"icon-plus\"></i></small> <small ng-if=\"vm.cart.get(seleable.id, null, seleable.type)\" ng-click=\"vm.addToCart(seleable)\" ng-class=\"{\'aggregated\': vm.cart.get(seleable.id, null, seleable.type)}\">{{vm.cart.get(seleable.id, null, seleable.type)}}</small></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/desktop/banner-home.html","<div class=\"skeleton-desktop-container\"><div class=\"skeleton-banner-home\"><div class=\"skeleton-banner-container\"><div class=\"skeleton-banner skeleton\"><button class=\"prev-home\"><i class=\"icon-chevron-left skeleton-icon-chevron\"></i></button> <button class=\"next-home\"><i class=\"icon-chevron-right skeleton-icon-chevron\"></i></button></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/desktop/checkout-delivery-details.html","<div class=\"skeleton-desktop-container\"><div class=\"skeleton-checkout-delivery-details-container\"><div class=\"skeleton-checkout-how skeleton\"></div><div class=\"skeleton-checkout-selected-location\"><div class=\"skeleton-checkout-selected-location-title\"><div class=\"selected-location-title skeleton\"></div><div class=\"selected-location-pickup-time skeleton\"></div></div><div class=\"skeleton-checkout-selected-location-body skeleton\"></div><div class=\"skeleton-checkout-selected-location-maps skeleton\"></div></div><div class=\"skeleton-checkout-payment-type\"><div class=\"checkout-payment-type-title skeleton\"></div><div class=\"separator-line skeleton\"></div><div class=\"checkout-payment-type-body\"><div class=\"checkout-payment-type\"><div class=\"checkout-payment-type-icon skeleton\"></div><div class=\"checkout-payment-type-info skeleton\"></div></div><div class=\"checkout-payment-type-btn skeleton\"></div></div></div><div class=\"skeleton-checkout-coupon skeleton\"></div></div></div>");
$templateCache.put("app/components/skeleton-screen/desktop/checkout-items-details.html","<div class=\"skeleton-desktop-container\"><div class=\"skeleton-checkout-items-details-container\"><div class=\"skeleton-checkout-items-title\"><div class=\"checkout-items-title-text skeleton\"></div></div><div class=\"separator-line skeleton\"></div><div class=\"skeleton-checkout-items-body\"><div class=\"skeleton-checkout-price-details\"><div class=\"skeleton-checkout-price\" ng-repeat=\"i in [1, 2, 3, 4]\"><div class=\"checkout-price-text skeleton\"></div><div class=\"checkout-price-details skeleton\"></div></div></div><div class=\"skeleton-checkout-additional-products\"><div class=\"separator-line skeleton\"></div><div class=\"checkout-additional-products-title\"><div class=\"checkout-additional-products-text skeleton\"></div><div class=\"checkout-additional-products-total skeleton\"></div></div><div class=\"separator-line skeleton\"></div><div class=\"checkout-additional-products-body\"><div class=\"checkout-unitary-product-title skeleton\"></div><div class=\"checkout-unitary-product\" ng-repeat=\"i in [1, 2]\"><div class=\"checkout-unitary-product-text skeleton\"></div><div class=\"checkout-unitary-product-checkbox skeleton\"></div></div></div><div class=\"checkout-additional-products-info skeleton\"></div></div><div class=\"skeleton-checkout-items-details\"><div class=\"separator-line skeleton\"></div><div class=\"checkout-items-details-title\"><div class=\"checkout-items-details-title-text skeleton\"></div><div class=\"checkout-items-details-title-icon skeleton\"></div></div><div class=\"separator-line skeleton\"></div><div class=\"checkout-items-details-body\" ng-repeat=\"i in [1, 2, 3, 4]\"><div class=\"checkout-items-quantity skeleton\"></div><div class=\"checkout-items-info skeleton\"></div></div></div></div><div class=\"separator-line skeleton\"></div><div class=\"skeleton-checkout-items-footer\"><div class=\"checkout-items-footer-btn skeleton\"></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/desktop/favorites-home.html","<div class=\"skeleton-desktop-container\"><div class=\"skeleton-favorites-home\"><div class=\"skeleton-favorites-container\"><div class=\"skeleton-favorites-title\"><p class=\"first skeleton\"></p><p class=\"second skeleton\"></p></div><div class=\"skeleton-favorites-cards-container\"><div class=\"skeleton-favorites-btn\"><button class=\"skeleton-favorites-prev skeleton\"><i class=\"icon-chevron-left skeleton-icon-chevron\"></i></button></div><div class=\"skeleton-favorites-cards\"><div class=\"skeleton-favorites-card skeleton\"></div><div class=\"skeleton-favorites-card skeleton\"></div><div class=\"skeleton-favorites-card skeleton\"></div><div class=\"skeleton-favorites-card skeleton\"></div><div class=\"skeleton-favorites-card skeleton\"></div><div class=\"skeleton-favorites-card skeleton\"></div></div><div class=\"skeleton-favorites-btn\"><button class=\"skeleton-favorites-next skeleton\"><i class=\"icon-chevron-right skeleton-icon-chevron\"></i></button></div></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/desktop/menu-card.html","<div class=\"skeleton-desktop-container\"><div class=\"skeleton-menu\"><div class=\"skeleton-menu-card\" ng-repeat=\"i in vm.getNumber(1, 8, 1)\"><div class=\"img skeleton\"></div><div class=\"body\"><div class=\"left\"><div class=\"name\"><p class=\"skeleton\"></p><p class=\"skeleton\"></p></div><div class=\"price skeleton\"></div></div><div class=\"right\"><div class=\"circle skeleton\"></div></div></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/desktop/menu-categories.html","<div class=\"skeleton-desktop-container\"><div class=\"skeleton-menu-categories\"><div class=\"category skeleton\" ng-repeat=\"i in vm.getNumber(1, 12, 1)\"></div></div></div>");
$templateCache.put("app/components/skeleton-screen/desktop/menu-home.html","<div class=\"skeleton-desktop-container\"><div class=\"skeleton-menu-home\"><div class=\"skeleton-menu-container\"><div class=\"skeleton-menu-title\"><p class=\"skeleton\"></p></div><div class=\"skeleton-menu-content\"><div class=\"skeleton-menu skeleton\"><button class=\"skeleton-button\"></button></div><div class=\"skeleton-menu skeleton\"><button class=\"skeleton-button\"></button></div><div class=\"skeleton-menu skeleton\"><button class=\"skeleton-button\"></button></div><div class=\"skeleton-menu skeleton\"><button class=\"skeleton-button\"></button></div></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/desktop/more-info-home.html","<div class=\"skeleton-desktop-container\"><div class=\"skeleton-more-info-home\"><div class=\"skeleton-more-info-container\"><div class=\"skeleton-more-info-title\"><p class=\"skeleton\"></p></div><div class=\"skeleton-more-info-content\"><button class=\"skeleton\"></button></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/desktop/promotions-home.html","<div class=\"skeleton-desktop-container\"><div class=\"skeleton-promotions-home\"><div class=\"skeleton-promotions-title\"><p class=\"skeleton\"></p></div><div class=\"skeleton-promotions-container\"><div class=\"skeleton-promotions skeleton\"></div><div class=\"skeleton-promotions skeleton\"></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/desktop/tracking-address.html","<div class=\"skeleton-desktop-container full-height radius-20 skeleton\"><div class=\"skeleton-address-description-container\"><div class=\"skeleton-address-description-title skeleton\"><h1 class=\"skeleton-text\"></h1></div><div class=\"skeleton-address-description\"><div class=\"skeleton-address-description-body\"><div class=\"skeleton-address-container\"><div class=\"skeleton-tracking-info-container\"><div class=\"skeleton-tracking-address\"><i class=\"skeleton\"></i><p class=\"skeleton\"></p></div><div class=\"skeleton-tracking-address\"><i class=\"skeleton\"></i><p class=\"skeleton\"></p></div><div class=\"skeleton-tracking-address\"><i class=\"skeleton\"></i><p class=\"skeleton\"></p></div></div><div class=\"skeleton-address-description-footer\"><div class=\"skeleton-restaurant-phones-number skeleton\"><i class=\"skeleton-text\"></i><p class=\"skeleton-text\"></p></div></div></div><div class=\"skeleton-gmap-container skeleton\"></div></div><div class=\"skeleton-order-nominate-container\"><div class=\"skeleton-box-success\"><p class=\"skeleton\"></p><p class=\"second-line skeleton\"></p><div class=\"skeleton-form-order\"><div class=\"skeleton-form-nominate skeleton-border\"><p class=\"skeleton\"></p></div><div class=\"skeleton-btn-nominate skeleton\"><p class=\"skeleton-text\"></p></div></div></div></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/desktop/tracking-products.html","<div class=\"skeleton-desktop-container full-height radius-20 skeleton\"><div class=\"skeleton-order-description-container\"><div class=\"skeleton-order-description-title skeleton\"><h1 class=\"skeleton-text\"></h1></div><div class=\"skeleton-order-description-body\"><div class=\"skeleton-order-items-container\"><div class=\"skeleton-items-info-container\" ng-repeat=\"i in vm.getNumber(1, 3, 1)\"><div class=\"skeleton-items-info\"><div class=\"skeleton-item-img skeleton\"></div><div class=\"skeleton-item-name-price\"><p class=\"skeleton\"></p><p ng-if=\"i !== 3\" class=\"price skeleton\"></p></div></div></div></div><div class=\"skeleton-tracking-hr\"><hr class=\"skeleton\"></div><div class=\"skeleton-payment-detail-container\"><div class=\"skeleton-payment-method\"><div class=\"skeleton-order-payment\"><p class=\"skeleton\"></p><p class=\"skeleton\"></p></div><div class=\"skeleton-order-payment\"><p class=\"skeleton\"></p><p class=\"skeleton\"></p></div></div><div class=\"skeleton-payment-detail\"><div class=\"skeleton-money-payment-detail\"><p class=\"skeleton\"></p><p class=\"skeleton\"></p></div><div class=\"skeleton-money-payment-detail\"><p class=\"skeleton\"></p><p class=\"skeleton\"></p></div><div class=\"skeleton-money-payment-detail\"><p class=\"skeleton\"></p><p class=\"skeleton\"></p></div></div></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/desktop/tracking-status.html","<div class=\"skeleton-desktop-container radius-20 skeleton\"><div class=\"skeleton-tracking-status-container\"><div class=\"skeleton-info-status-container\"><div class=\"skeleton-info-status skeleton\"><div class=\"skeleton-tracking-customer\"><h1 class=\"name skeleton-text\"></h1><h1 class=\"skeleton-text\"></h1></div><div class=\"skeleton-pos-number-container\"><p class=\"skeleton-text\"></p><p class=\"pos-number skeleton-text\"></p></div></div><div class=\"skeleton-order-type-status\"><h1 class=\"skeleton\"></h1></div></div><div class=\"skeleton-tracking-hr\"><hr class=\"skeleton\"></div><div class=\"skeleton-order-status\"><div class=\"skeleton-order-status-container\"><div ng-repeat=\"i in vm.getNumber(1, 3, 1)\" class=\"skeleton-status-container\" ng-class=\"{\'width-auto\': i == 3}\"><div class=\"skeleton-tracking-status\"><div class=\"skeleton-tracking-img-container skeleton\"></div><h1 class=\"skeleton\"></h1></div><div ng-if=\"i !== 3\" class=\"skeleton-separation-status\"><hr class=\"skeleton\"></div></div></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/banner-home.html","<div class=\"skeleton-mobile-container\"><div class=\"skeleton-banner-home\"><div class=\"skeleton-banner-container\"><div class=\"skeleton-banner skeleton\"><button class=\"prev-home\"><i class=\"icon-chevron-left skeleton-icon-chevron\"></i></button> <button class=\"next-home\"><i class=\"icon-chevron-right skeleton-icon-chevron\"></i></button></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/checkout-delivery-details.html","<div class=\"skeleton-mobile-container\"><div class=\"skeleton-checkout-delivery-details-container\"><div class=\"skeleton-checkout-how skeleton\"></div><div class=\"skeleton-checkout-selected-location\"><div class=\"skeleton-checkout-selected-location-title\"><div class=\"selected-location-title skeleton\"></div><div class=\"selected-location-pickup-time skeleton\"></div></div><div class=\"skeleton-checkout-selected-location-body skeleton\"></div><div class=\"skeleton-checkout-selected-location-maps skeleton\"></div></div><div class=\"skeleton-checkout-payment-type\"><div class=\"checkout-payment-type-title skeleton\"></div><div class=\"separator-line skeleton\"></div><div class=\"checkout-payment-type-body\"><div class=\"checkout-payment-type\"><div class=\"checkout-payment-type-icon skeleton\"></div><div class=\"checkout-payment-type-info skeleton\"></div></div><div class=\"checkout-payment-type-btn skeleton\"></div></div></div><div class=\"skeleton-checkout-coupon skeleton\"></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/checkout-items-details.html","<div class=\"skeleton-mobile-container\"><div class=\"skeleton-checkout-items-details-container\"><div class=\"skeleton-checkout-items-title\"><div class=\"checkout-items-title-text skeleton\"></div></div><div class=\"separator-line skeleton\"></div><div class=\"skeleton-checkout-items-body\"><div class=\"skeleton-checkout-price-details\"><div class=\"skeleton-checkout-price\" ng-repeat=\"i in [1, 2, 3, 4]\"><div class=\"checkout-price-text skeleton\"></div><div class=\"checkout-price-details skeleton\"></div></div></div><div class=\"skeleton-checkout-additional-products\"><div class=\"separator-line skeleton\"></div><div class=\"checkout-additional-products-title\"><div class=\"checkout-additional-products-text skeleton\"></div><div class=\"checkout-additional-products-total skeleton\"></div></div><div class=\"separator-line skeleton\"></div><div class=\"checkout-additional-products-body\"><div class=\"checkout-unitary-product-title skeleton\"></div><div class=\"checkout-unitary-product\" ng-repeat=\"i in [1, 2]\"><div class=\"checkout-unitary-product-text skeleton\"></div><div class=\"checkout-unitary-product-checkbox skeleton\"></div></div></div><div class=\"checkout-additional-products-info skeleton\"></div></div><div class=\"skeleton-checkout-items-details\"><div class=\"separator-line skeleton\"></div><div class=\"checkout-items-details-title\"><div class=\"checkout-items-details-title-text skeleton\"></div><div class=\"checkout-items-details-title-icon skeleton\"></div></div><div class=\"separator-line skeleton\"></div><div class=\"checkout-items-details-body\" ng-repeat=\"i in [1, 2, 3, 4]\"><div class=\"checkout-items-quantity skeleton\"></div><div class=\"checkout-items-info skeleton\"></div></div></div></div><div class=\"separator-line skeleton\"></div><div class=\"skeleton-checkout-items-footer\"><div class=\"checkout-items-footer-btn skeleton\"></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/favorites-home.html","<div class=\"skeleton-mobile-container\"><div class=\"skeleton-favorites-home\"><div class=\"skeleton-favorites-container\"><div class=\"skeleton-favorites-title\"><p class=\"first skeleton\"></p><p class=\"second skeleton\"></p></div><div class=\"skeleton-favorites-cards\"><div class=\"skeleton-favorites-card skeleton\"></div><div class=\"skeleton-favorites-card skeleton\"></div><div class=\"skeleton-favorites-card skeleton\"></div><div class=\"skeleton-favorites-card skeleton\"></div></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/menu-card.html","<div class=\"skeleton-mobile-container\"><div class=\"skeleton-menu-card\"><div class=\"category\"><div class=\"name skeleton\"></div><div class=\"icon skeleton\"></div></div><div class=\"cards\"><div class=\"card\" ng-repeat=\"i in vm.getNumber(1, 4, 1)\"><div class=\"img skeleton\"></div><div class=\"body\"><div class=\"left\"><div class=\"name\"><p class=\"skeleton\"></p><p class=\"skeleton\"></p></div><div class=\"price skeleton\"></div></div><div class=\"right\"><div class=\"circle skeleton\"></div></div></div></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/menu-categories.html","<div class=\"skeleton-mobile-container\"><div class=\"skeleton-menu-categories\"><div class=\"category\" ng-repeat=\"i in vm.getNumber(1, 9, 1)\"><div class=\"name skeleton\"></div><div class=\"icon skeleton\"></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/menu-home.html","<div class=\"skeleton-mobile-container\"><div class=\"skeleton-menu-home\"><div class=\"skeleton-menu-container\"><div class=\"skeleton-menu-title\"><p class=\"skeleton\"></p></div><div class=\"skeleton-menu-content\"><div class=\"skeleton-menu skeleton\"><button class=\"skeleton-button\"></button></div><div class=\"skeleton-menu skeleton\"><button class=\"skeleton-button\"></button></div><div class=\"skeleton-menu skeleton\"><button class=\"skeleton-button\"></button></div><div class=\"skeleton-menu skeleton\"><button class=\"skeleton-button\"></button></div></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/more-info-home.html","<div class=\"skeleton-mobile-container\"><div class=\"skeleton-more-info-home\"><div class=\"skeleton-more-info-container\"><div class=\"skeleton-more-info-title\"><p class=\"skeleton\"></p></div><div class=\"skeleton-more-info-content\"><button class=\"skeleton\"></button><div class=\"skeleton-restaurant skeleton\"></div></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/promotions-home.html","<div class=\"skeleton-mobile-container\"><div class=\"skeleton-promotions-home\"><div class=\"skeleton-promotions-title\"><p class=\"skeleton\"></p></div><div class=\"skeleton-promotions-container\"><div class=\"skeleton-promotions skeleton\"></div><div class=\"skeleton-promotions skeleton\"></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/tracking-address.html","<div class=\"skeleton-mobile-container full-height radius-20 skeleton\"><div class=\"skeleton-address-description-container\"><div class=\"skeleton-address-description-title skeleton\"><h1 class=\"skeleton-text\"></h1></div><div class=\"skeleton-address-description\"><div class=\"skeleton-address-description-body\"><div class=\"skeleton-address-container\"><div class=\"skeleton-tracking-address\"><i class=\"skeleton\"></i><p class=\"skeleton\"></p></div><div class=\"skeleton-tracking-address\"><i class=\"skeleton\"></i><p class=\"skeleton\"></p></div><div class=\"skeleton-tracking-address\"><i class=\"skeleton\"></i><p class=\"skeleton\"></p></div></div></div><div class=\"skeleton-address-description-footer\"><div class=\"skeleton-restaurant-phones-number skeleton\"><i class=\"skeleton-text\"></i><p class=\"skeleton-text\"></p></div></div><div class=\"skeleton-tracking-hr\"><hr class=\"skeleton\"></div><div class=\"skeleton-order-nominate-container\"><div class=\"skeleton-box-success\"><p class=\"skeleton\"></p><p class=\"second-line skeleton\"></p><div class=\"skeleton-form-order\"><div class=\"skeleton-form-nominate skeleton-border\"><p class=\"skeleton\"></p></div><div class=\"skeleton-btn-nominate skeleton\"><p class=\"skeleton-text\"></p></div></div></div></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/tracking-description.html","<div class=\"skeleton-mobile-container\"><div class=\"skeleton-info-order-status-container\"><div class=\"skeleton-info-status-container\"><div class=\"skeleton-info-status radius-20 skeleton\"><div class=\"skeleton-tracking-customer\"><h1 class=\"name skeleton-text\"></h1><h1 class=\"skeleton-text\"></h1></div><div class=\"skeleton-pos-number-container\"><p class=\"pos-number skeleton-text\"></p><p class=\"skeleton-text\"></p></div></div><div class=\"skeleton-order-type-status\"><h1 class=\"skeleton\"></h1></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/tracking-map.html","<div class=\"skeleton-mobile-container\"><div class=\"skeleton-tracking-map-container\"><div class=\"skeleton-tracking-url-container skeleton\"></div><div class=\"skeleton-tracking-map-separation\"><div class=\"skeleton-tracking-hr skeleton-border\"></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/tracking-need-help.html","<div class=\"skeleton-mobile-container\"><div class=\"skeleton-need-help-container\"><p class=\"skeleton\"></p><span class=\"skeleton\"></span></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/tracking-products.html","<div class=\"skeleton-mobile-container full-height radius-20 skeleton\"><div class=\"skeleton-order-description-container\"><div class=\"skeleton-order-description-title skeleton\"><h1 class=\"skeleton-text\"></h1></div><div class=\"skeleton-order-description-body\"><div class=\"skeleton-order-items-container\"><div class=\"skeleton-items-info-container\" ng-repeat=\"i in vm.getNumber(1, 3, 1)\"><div class=\"skeleton-items-info\"><div class=\"skeleton-item-img skeleton\"></div><div class=\"skeleton-item-description\"><div class=\"skeleton-item-name-price\"><p class=\"skeleton\"></p><p class=\"price skeleton\"></p></div></div></div></div></div><div class=\"skeleton-tracking-hr\"><hr class=\"skeleton\"></div><div class=\"skeleton-payment-method-container\"><div class=\"skeleton-order-payment-method\"><p class=\"skeleton\"></p><p class=\"method skeleton\"></p></div><div class=\"skeleton-order-payment-method\"><p class=\"skeleton\"></p><p class=\"method skeleton\"></p></div></div><div class=\"skeleton-tracking-hr\"><hr class=\"skeleton\"></div><div class=\"skeleton-payment-detail-container\"><div class=\"skeleton-money-payment-detail\"><p class=\"skeleton\"></p><p class=\"skeleton\"></p></div><div class=\"skeleton-money-payment-detail\"><p class=\"skeleton\"></p><p class=\"skeleton\"></p></div><div class=\"skeleton-money-payment-detail\"><p class=\"skeleton\"></p><p class=\"skeleton\"></p></div></div></div></div></div>");
$templateCache.put("app/components/skeleton-screen/mobile/tracking-status.html","<div class=\"skeleton-mobile-container\"><div class=\"skeleton-tracking-status-container\"><div class=\"skeleton-order-status\"><div class=\"skeleton-order-status-container\"><div ng-repeat=\"i in vm.getNumber(1, 3, 1)\" class=\"skeleton-status-container\" ng-class=\"{\'width-auto\': i == 3}\"><div class=\"skeleton-tracking-img-container\"><div class=\"skeleton-tracking-img skeleton\"></div><div ng-if=\"i !== 3\" class=\"skeleton-tracking-step skeleton-border\"></div></div></div></div><div class=\"skeleton-order-status-container\"><div class=\"skeleton-status-container width-auto\" ng-repeat=\"i in vm.getNumber(1, 3, 1)\"><h1 class=\"skeleton\"></h1></div></div></div></div></div>");
$templateCache.put("app/components/toolbar-cart/mobile/toolbar-cart.html","<div id=\"toolbar\" class=\"toolbar\" ng-controller=\"ToolbarController as vm\"><div class=\"toolbar-default\"><div class=\"toolbar-icon\" ui-sref-active=\"active-menu\"><a ui-sref=\"menu.category({categoryName: \'mis-favoritos\'})\" ui-sref-opts=\"{reload: true, notify: true}\" ng-if=\"vm.isLoggedIn\"><img class=\"nav-img\" src=\"assets/images/icon-favorite.svg\"> <span>Mis favoritos</span></a> <a ui-sref=\"menu.category({categoryName: \'combinaciones-niu\'})\" ui-sref-opts=\"{reload: true, notify: true}\" ng-if=\"!vm.isLoggedIn\"><img class=\"nav-img\" src=\"assets/images/icon-menu.svg\"> <span>{{vm.menuText}}</span></a></div></div><div class=\"toolbar-default\"><div class=\"toolbar-icon\" ui-sref-active=\"active-menu\"><a ng-click=\"vm.latestOrders()\"><i class=\"icon-repeat\"></i> <span>Repetir Pedido</span></a></div></div></div>");}]);